
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4KsXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d721b44212ec2a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $8BZ1O = parcelRequire("8BZ1O");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");

var $Heqyv = parcelRequire("Heqyv");
const $4d721b44212ec2a2$var$JiraBusinessBoardApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7c3W1.ViewPreferencesProvider), {
        view: "board",
        preferences: (0, $ji3xf.BOARD_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Heqyv.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    })));
var $4d721b44212ec2a2$export$2e2bcd8739ae039 = $4d721b44212ec2a2$var$JiraBusinessBoardApp;

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");
var $fDLFb = parcelRequire("fDLFb");
var $eZbpk = parcelRequire("eZbpk");
var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $kJlBc = parcelRequire("kJlBc");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3m77k")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("3m77k", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dX4bq');
        const value = parcelRequire('gutLJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dX4bq").then(()=>parcelRequire('gutLJ'));
}

});



parcelRegister("ji3xf", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", () => $3ed190d907cd42b1$export$5d3f940b56d7af28);
$parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", () => $3ed190d907cd42b1$export$8019dfa5a44f6d46);
$parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", () => $3ed190d907cd42b1$export$3ef984a9f784490f);
$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3ed190d907cd42b1$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3ed190d907cd42b1$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3ed190d907cd42b1$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3ed190d907cd42b1$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3ed190d907cd42b1$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3ed190d907cd42b1$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3ed190d907cd42b1$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3ed190d907cd42b1$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3ed190d907cd42b1$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3ed190d907cd42b1$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$2e2923d9c9daba20);

var $jGcn0 = parcelRequire("jGcn0");

var $khRV9 = parcelRequire("khRV9");
const $3ed190d907cd42b1$export$5d3f940b56d7af28 = (0, $khRV9.createSimplePreference)('activeWorkflow');
const $3ed190d907cd42b1$export$8019dfa5a44f6d46 = (0, $khRV9.createSimplePreference)('collapsedColumns');
const $3ed190d907cd42b1$export$3ef984a9f784490f = (0, $khRV9.createSimplePreference)('columnOrder');
const $3ed190d907cd42b1$export$2df4c3d44dcb1e5b = (0, $khRV9.createSimplePreference)('createType');
const $3ed190d907cd42b1$export$638c3932e4cbdede = (0, $khRV9.createSimplePreference)('expandedIssues');
const $3ed190d907cd42b1$export$e3ddfc509464e305 = (0, $khRV9.createSimplePreference)('fields');
const $3ed190d907cd42b1$export$ffcb5603c64e12d0 = (0, $khRV9.createSimplePreference)('fieldsDetail');
const $3ed190d907cd42b1$export$f50d5db589fb1475 = (0, $khRV9.createSimpleUrlPreference)((0, $jGcn0.FILTER_PARAM));
const $3ed190d907cd42b1$export$ac8a4771da7f03af = (0, $khRV9.createSimpleUrlPreference)('groupBy');
const $3ed190d907cd42b1$export$4aace169721c2927 = (0, $khRV9.createSimpleUrlPreference)('hideDone');
const $3ed190d907cd42b1$export$983f0d3325e2938 = (0, $khRV9.createSimpleUrlPreference)('hideSoftwareRelease');
const $3ed190d907cd42b1$export$f43988a3762bf711 = (0, $khRV9.createSimpleUrlPreference)('rangeMode');
const $3ed190d907cd42b1$export$373eea1341dcff74 = {
    ...(0, $khRV9.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3ed190d907cd42b1$export$4ec60be96e9eadc0 = [
    $3ed190d907cd42b1$export$5d3f940b56d7af28,
    $3ed190d907cd42b1$export$8019dfa5a44f6d46,
    $3ed190d907cd42b1$export$3ef984a9f784490f,
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$638c3932e4cbdede,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af
];
const $3ed190d907cd42b1$export$43fc1ec27b2f1801 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$ffcb5603c64e12d0,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$373eea1341dcff74
];
const $3ed190d907cd42b1$export$14e2a519a8c2881a = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$983f0d3325e2938
];
const $3ed190d907cd42b1$export$8443f3f4fd94276 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$f43988a3762bf711
];
const $3ed190d907cd42b1$export$2e2923d9c9daba20 = [
    $3ed190d907cd42b1$export$f50d5db589fb1475
];

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("khRV9", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $462fa2c618ea906f$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $462fa2c618ea906f$export$78f3983105936d30);

var $3QMTK = parcelRequire("3QMTK");
const $462fa2c618ea906f$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
    });
const $462fa2c618ea906f$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("7c3W1", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $6117ab20ad9a3ccd$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $6117ab20ad9a3ccd$export$ee494de6c0ff45d7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $6YT9E = parcelRequire("6YT9E");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $6117ab20ad9a3ccd$var$ViewPreferencesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6117ab20ad9a3ccd$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $kJlBc.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $hzcvF.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $eUqFw.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            const queryValue = queryParameter && queryParameter.deserialize(query);
            if (queryValue) value = queryValue;
            else if (persistChanges) // if the view is persisting changes, restore the preferences from local storage
            value = preference.deserialize((0, $6YT9E.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $eUqFw.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $6YT9E.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6117ab20ad9a3ccd$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $6117ab20ad9a3ccd$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $eUqFw.useContext)($6117ab20ad9a3ccd$var$ViewPreferencesContext);
    const setValue = (0, $eUqFw.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("6YT9E", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $e32968ac8498b8dc$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $e32968ac8498b8dc$export$5fa261395d19a143);

var $aZaPn = parcelRequire("aZaPn");
const $e32968ac8498b8dc$var$store = (0, $aZaPn.createLocalStorageProvider)('jwm-view-preferences');
const $e32968ac8498b8dc$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $e32968ac8498b8dc$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $e32968ac8498b8dc$var$store.set(key, value);
};
const $e32968ac8498b8dc$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $e32968ac8498b8dc$var$store.get(key);
};

});


parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("Heqyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52e256f1a55722d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $7e8pf = parcelRequire("7e8pf");

var $fyk0U = parcelRequire("fyk0U");

var $fAoR8 = parcelRequire("fAoR8");
var $3555e = parcelRequire("3555e");

var $hJYsP = parcelRequire("hJYsP");

var $cWd72 = parcelRequire("cWd72");

var $4G5xU = parcelRequire("4G5xU");

var $fvzkg = parcelRequire("fvzkg");

var $d3C6e = parcelRequire("d3C6e");

var $c7wtc = parcelRequire("c7wtc");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $ib4WI = parcelRequire("ib4WI");

var $bFk6h = parcelRequire("bFk6h");

var $dtXTv = parcelRequire("dtXTv");

var $iLiDV = parcelRequire("iLiDV");

var $3jaqr = parcelRequire("3jaqr");

var $gWYTK = parcelRequire("gWYTK");

var $bJNjm = parcelRequire("bJNjm");

var $bZapc = parcelRequire("bZapc");

var $gKXju = parcelRequire("gKXju");

var $ay4XV = parcelRequire("ay4XV");

var $cgK6s = parcelRequire("cgK6s");

var $iq40z = parcelRequire("iq40z");

var $hppqk = parcelRequire("hppqk");

var $lqN6D = parcelRequire("lqN6D");

var $3ImR7 = parcelRequire("3ImR7");

var $dszCn = parcelRequire("dszCn");
var $9FDwo = parcelRequire("9FDwo");

var $lQ65S = parcelRequire("lQ65S");
const $e52e256f1a55722d$var$analyticsSourceName = 'board';
const $e52e256f1a55722d$var$analyticsSourceNameOld = 'jwmBoard';
const $e52e256f1a55722d$var$WrapWithUserTraitsProvider = ({ children: children })=>(0, $eI5EY.fg)('card_covers_editor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyk0U.UserTraitsProvider), null, children) : children;
const $e52e256f1a55722d$var$FireScreenAnalyticsWithIssueLinksAttributes = ()=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            withIssueLinks: Boolean(selectedFields[0, $lO4Or.ISSUE_LINKS_TYPE])
        }
    });
};
const $e52e256f1a55722d$var$BoardWithWorkflowsData = ()=>{
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    const workflowsProviderWorkflows = (0, $eUqFw.useMemo)(()=>workflows.map((0, $lQ65S.transformWorkflow)), [
        workflows
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7wtc.WorkflowsProvider), {
        workflows: workflowsProviderWorkflows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $3ImR7.CREATE_ISSUE_MUTATION),
        query: (0, $3ImR7.ISSUE_REFETCH_QUERY),
        ignoreFiltersContext: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "jwmBoard",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $e52e256f1a55722d$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvzkg.DeserialisedFiltersProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cgK6s.WorkflowActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtXTv.IssueStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJNjm.ColumnDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWYTK.CardDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gKXju.GroupsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFk6h.BoardDataProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ay4XV.IssueTransitionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLiDV.ConfettiColumnsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$WrapWithUserTraitsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9FDwo.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dszCn.default), null)))))))))), (0, $1ybV0.ff)('jwm.linked_issue_viewed_screen_analytics_ewjrp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$FireScreenAnalyticsWithIssueLinksAttributes, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)))));
};
const $e52e256f1a55722d$export$38c311e2746e0f8b = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const pageHeading = formatMessage((0, $hppqk.default).boardHeading);
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iq40z.WorkflowStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$BoardWithWorkflowsData, null))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lqN6D.BoardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7wtc.WorkflowsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $3ImR7.CREATE_ISSUE_MUTATION),
        query: (0, $3ImR7.ISSUE_REFETCH_QUERY),
        ignoreFiltersContext: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "jwmBoard",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $e52e256f1a55722d$var$analyticsSourceNameOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvzkg.DeserialisedFiltersProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$WrapWithUserTraitsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9FDwo.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3jaqr.ConfettiColumnsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dszCn.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)))))))));
});
const $e52e256f1a55722d$var$BoardViewRootWithSmartCard = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    if (hasConfluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAoR8.ConfluenceModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$export$38c311e2746e0f8b, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$export$38c311e2746e0f8b, null);
};
const $e52e256f1a55722d$var$Board = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e52e256f1a55722d$var$BoardViewRootWithSmartCard, null));
var $e52e256f1a55722d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e52e256f1a55722d$var$Board);

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $5pr8w = parcelRequire("5pr8w");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5pr8w)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("inzmU", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $2fFJv.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("5pr8w", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3f0456472e399d24$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3f0456472e399d24$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3f0456472e399d24$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3f0456472e399d24$var$getValidCacheKeyFn(options);
        this._cacheMap = $3f0456472e399d24$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3f0456472e399d24$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3f0456472e399d24$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3f0456472e399d24$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3f0456472e399d24$var$resolvedPromise) $3f0456472e399d24$var$resolvedPromise = Promise.resolve();
    $3f0456472e399d24$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3f0456472e399d24$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3f0456472e399d24$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3f0456472e399d24$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3f0456472e399d24$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3f0456472e399d24$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3f0456472e399d24$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3f0456472e399d24$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3f0456472e399d24$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3f0456472e399d24$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3f0456472e399d24$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3f0456472e399d24$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3f0456472e399d24$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3f0456472e399d24$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3f0456472e399d24$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3f0456472e399d24$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3f0456472e399d24$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3f0456472e399d24$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3f0456472e399d24$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3f0456472e399d24$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $5ECju.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $5ECju.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $5ECju.default).of({
                data: {}
            });
            return new (0, $5ECju.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fVaJL = parcelRequire("fVaJL");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fVaJL.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});

parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");

var $1ybV0 = parcelRequire("1ybV0");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ContentWrapper), {
        isSidebarOpen: isSidebarOpen,
        sidebarWidth: sidebarWidth
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, jira/react/no-classname-attribute
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $a61MH.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $ggKAj.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            (0, $1ybV0.ff)('jwm-sidebar-resizer-limit_4m1km') ? $b41642a7c0ef06fe$var$sidebarStyles : $b41642a7c0ef06fe$var$oldSidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarOld), {
        sidebarWidth: sidebarWidth
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$oldSidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card'
});
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $41WOo = parcelRequire("41WOo");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) resetSidebarQueryParams();
        else setQueryParams({
            [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined,
            [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
        });
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
        else {
            // clear "selectedComment=X" query param when IssueApp Sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
            });
            // clear "selectedIssue=X" query param when Comments sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_COMMENT_PARAM] && queryParams[0, $jGcn0.SELECTED_COMMENT_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined
            });
        }
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarOld", () => $8c2051301c5af547$export$3c45ed53a787e357);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $8c2051301c5af547$var$SIDEBAR_Z_INDEX = 10;
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$3c45ed53a787e357 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_99zgm9": (0, $9t7rW.default)(`${__cmplp.sidebarWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbge8f _1o9zidpf _11q7vuon _2rko15h0 _kqswh2mm _18s8hhfb _16qszotn _1pbyzo7u",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
$parcel$export(module.exports, "ContentWrapper", () => $c8a88c0524c1629a$export$6ce170286acaa8d3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT = (0, $c9TLT.gridSize) * 3;
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT = (0, $c9TLT.gridSize);
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});
const $c8a88c0524c1629a$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarOpen: isSidebarOpen, sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_k62x1i": (0, $9t7rW.default)(__cmplp.sidebarWidth + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _1e0c1txw _2lx21bp4 _ca0qidpf _19bvidpf",
            __cmplp.isSidebarOpen ? "_1bsb1izx" : "_1bsb1osq",
            __cmplp.isSidebarOpen ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.isSidebarOpen ? "_n3td1ejb" : "_n3tdidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fyk0U", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $8dca86bbd49a57d4$export$d5a27009aa54a078);
$parcel$export(module.exports, "UserTraitsProvider", () => $8dca86bbd49a57d4$export$23c27d2553d62584);
$parcel$export(module.exports, "UserTraitsStore", () => $8dca86bbd49a57d4$export$6e688ed53ae076d5);
$parcel$export(module.exports, "useUserTraits", () => $8dca86bbd49a57d4$export$49363c8b904e0dc7);
$parcel$export(module.exports, "useUserTraitsActions", () => $8dca86bbd49a57d4$export$4f249a943026a90b);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lRmyA = parcelRequire("lRmyA");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
const $8dca86bbd49a57d4$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $8dca86bbd49a57d4$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $8dca86bbd49a57d4$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $lRmyA.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $8dca86bbd49a57d4$var$actions = {
    setUserTraits: $8dca86bbd49a57d4$var$setUserTraits,
    fetchUserTraits: $8dca86bbd49a57d4$var$fetchUserTraits,
    addUserTrait: $8dca86bbd49a57d4$var$addUserTrait
};
const $8dca86bbd49a57d4$var$initialState = {
    attributes: null
};
const $8dca86bbd49a57d4$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $lRmyA.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $8dca86bbd49a57d4$export$23c27d2553d62584 = (0, $heB5U.createContainer)();
const $8dca86bbd49a57d4$export$6e688ed53ae076d5 = (0, $a61MH.createStore)({
    initialState: $8dca86bbd49a57d4$var$initialState,
    actions: $8dca86bbd49a57d4$var$actions,
    containedBy: $8dca86bbd49a57d4$export$23c27d2553d62584,
    name: 'UserTraits'
});
const $8dca86bbd49a57d4$export$49363c8b904e0dc7 = (0, $ggKAj.createHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);
const $8dca86bbd49a57d4$export$4f249a943026a90b = (0, $ggKAj.createActionsHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);

});

parcelRegister("fAoR8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $c504526f38fce139$export$465701d340b2a0fb);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $fQ8Gt = parcelRequire("fQ8Gt");

var $38C70 = parcelRequire("38C70");

var $Mkrqy = parcelRequire("Mkrqy");

var $5bEwi = parcelRequire("5bEwi");
const $c504526f38fce139$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $Mkrqy.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $Mkrqy.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $eUqFw.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ8Gt.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bEwi.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38C70.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("fQ8Gt", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $37beefa91041e6e4$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $37beefa91041e6e4$export$750ed67ce7764287);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $37beefa91041e6e4$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $37beefa91041e6e4$export$750ed67ce7764287 = ()=>{
    const context = (0, $eUqFw.useContext)($37beefa91041e6e4$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("38C70", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a2043a17368e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ce5a2043a17368e7$var$LazyCreatePage = (0, $7rh0R.lazy)(()=>(parcelRequire("8AwfJ")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce5a2043a17368e7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce5a2043a17368e7$var$LazyCreatePage, props));

});
parcelRegister("8AwfJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iWR0i')
        ]);
        const value = parcelRequire('4gJwS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iWR0i")
    ]).then(()=>parcelRequire('4gJwS'));
}

});


parcelRegister("Mkrqy", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $7c28d3b4703778fb$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $7c28d3b4703778fb$export$3cac20211c8788d8);

var $eUqFw = parcelRequire("eUqFw");

var $eDn3S = parcelRequire("eDn3S");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $7c28d3b4703778fb$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $eUqFw.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $eUqFw.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $eUqFw.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $7c28d3b4703778fb$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $eUqFw.useState)({
        confluencePageUrl: null,
        viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const showConfluencePage = (0, $eUqFw.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $eUqFw.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});
parcelRegister("eDn3S", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $244f576f48d8bb4b$export$816ef638e478449a);
var $244f576f48d8bb4b$export$816ef638e478449a;
(function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
})($244f576f48d8bb4b$export$816ef638e478449a || ($244f576f48d8bb4b$export$816ef638e478449a = {}));

});


parcelRegister("5bEwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c1b8e81f1ff3d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal = (0, $7rh0R.lazy)(()=>(parcelRequire("8Qj3m")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6c1b8e81f1ff3d7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal, props));

});
parcelRegister("8Qj3m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('bfFl5')
        ]);
        const value = parcelRequire('eCTVv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("bfFl5")
    ]).then(()=>parcelRequire('eCTVv'));
}

});



parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});


parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


parcelRegister("cWd72", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $c6421b4581e45226$export$31eaf35dc72d0fa0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gEmpR = parcelRequire("gEmpR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6421b4581e45226$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $c6421b4581e45226$var$TRACKING_TIMEOUT = 1000;
const $c6421b4581e45226$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return $c6421b4581e45226$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $c6421b4581e45226$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("gEmpR", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $0655e80332547c29$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $0655e80332547c29$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $0655e80332547c29$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $0655e80332547c29$export$d2121b02f0b65782);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $9zYls = parcelRequire("9zYls");

var $i2apV = parcelRequire("i2apV");

var $2RZxj = parcelRequire("2RZxj");

const $0655e80332547c29$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $0655e80332547c29$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $0655e80332547c29$var$isProjectPermissionError = (error)=>error.message.indexOf($0655e80332547c29$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($0655e80332547c29$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $0655e80332547c29$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $kJlBc.useRouter)();
    const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $2RZxj.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $2RZxj.JWMQueryByRouteMap)[0, $i2apV.DEFAULT];
    return (0, $eUqFw.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $0655e80332547c29$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $iZuDo.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $eUqFw.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $0655e80332547c29$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $eUqFw.useState)(false);
    const fetchAttempts = (0, $eUqFw.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: queryVariables,
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($0655e80332547c29$var$isProjectPermissionError(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $eUqFw.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $guiFP.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $0655e80332547c29$export$77937175321fab39 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$fbd286e14113bfc = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $eUqFw.useContext)($0655e80332547c29$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $eUqFw.useContext)($0655e80332547c29$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("i2apV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $3bfdf44128ce0634$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $3bfdf44128ce0634$export$7faaf3222dfd10db);
const $3bfdf44128ce0634$export$e6952b12ade67489 = 'default';
const $3bfdf44128ce0634$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("2RZxj", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $36ea36a72d22859a$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $36ea36a72d22859a$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $36ea36a72d22859a$export$7188da46161cbb8f);

var $41WOo = parcelRequire("41WOo");

var $exb0h = parcelRequire("exb0h");

var $lO4Or = parcelRequire("lO4Or");

var $i2apV = parcelRequire("i2apV");

var $fEf9a = parcelRequire("fEf9a");
const $36ea36a72d22859a$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $36ea36a72d22859a$var$emptyArray = [];
const $36ea36a72d22859a$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks') // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || node.type === (0, $lO4Or.SELECT_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        else // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value })=>{
            fieldOptions.push({
                value: value,
                label: value
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        issueTypes: [],
        __typename: node.__typename
    };
};
const $36ea36a72d22859a$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $36ea36a72d22859a$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $36ea36a72d22859a$export$b07b0d8dc0894ecf;
};
const $36ea36a72d22859a$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$36ea36a72d22859a$export$bffa388e20165996(node, issueType))
        }));
    return $36ea36a72d22859a$var$emptyArray;
};
const $36ea36a72d22859a$export$7188da46161cbb8f = {
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM]: {
        view: 'Form',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT]: {
        view: 'FormSubmit',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR]: {
        view: 'Calendar',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED]: {
        view: 'CalendarEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST]: {
        view: 'List',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST_EMBED]: {
        view: 'ListEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE]: {
        view: 'Timeline',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED]: {
        view: 'TimelineEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD]: {
        view: 'Board',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD_EMBED]: {
        view: 'BoardEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $i2apV.DEFAULT)]: {
        view: 'Common',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("fEf9a", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $546f0d2a9095de4c$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $546f0d2a9095de4c$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $546f0d2a9095de4c$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $546f0d2a9095de4c$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $546f0d2a9095de4c$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $546f0d2a9095de4c$export$79304c172f5555ae);

var $9ypom = parcelRequire("9ypom");
const $546f0d2a9095de4c$export$ec2562ca5badac3b = (0, $9ypom.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $546f0d2a9095de4c$export$ba5f98a8d6136727 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$cba408dff1091b60 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$363435cea078aa93 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$1641a42cf2cdb09a = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$7903c43b0ec55315 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$79304c172f5555ae = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;

});




parcelRegister("fvzkg", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $df8b3ad8c9e75684$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $df8b3ad8c9e75684$export$eaa578dc219a620a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $9TEHc = parcelRequire("9TEHc");

var $jhNgz = parcelRequire("jhNgz");

var $hLW3I = parcelRequire("hLW3I");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $coMWQ = parcelRequire("coMWQ");
const $df8b3ad8c9e75684$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $df8b3ad8c9e75684$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($df8b3ad8c9e75684$var$DEFAULT_VALUE);
const $df8b3ad8c9e75684$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const value = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8b3ad8c9e75684$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7 = ()=>(0, $eUqFw.useContext)($df8b3ad8c9e75684$var$DeserialisedFiltersContext);
/**
 * There are known limitations with deserialising JQL that the backend supports but the UI filter
 * dialog does not. This is mainly seen from links on the Summary page that contain filters like relative
 * dates (i.e. `statusCategoryChangedDate >= -1w`) and `statusCategory`. For these types of filters
 * we don't want to send errors to our analytics service as they create too much noise
 * and make it harder to identify errors we care about.
 *
 * Software projects do not have a Summary page so we are using `allowedFilterTypes` as a way of
 * approximating what type of project we are, this allows us to then prevent/allow sending
 * errors to the analytics service.
 *
 * @see https://jbusiness.atlassian.net/browse/FLINGO-370
 */ const $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics = ({ allowedFieldTypes: allowedFieldTypes, error: error })=>{
    const isSoftwareProject = (0, $9TEHc.SOFTWARE_FIELD_TYPES).some(Set.prototype.has, allowedFieldTypes);
    const shouldSuppressErrors = !isSoftwareProject;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldSuppressErrors) return;
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'deserializeJQL',
                packageName: 'jiraBusinessFilters',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to deserialize filters'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        shouldSuppressErrors
    ]);
};
const $df8b3ad8c9e75684$var$EMPTY_FILTER = {};
const $df8b3ad8c9e75684$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $jhNgz.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $eUqFw.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $eUqFw.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $df8b3ad8c9e75684$var$EMPTY_FILTER) setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        (0, $coMWQ.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters
    ]);
    $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics({
        allowedFieldTypes: allowedFieldTypes,
        error: error
    });
    (0, $gZpkQ.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    (0, $eUqFw.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(isLoadingFieldConfig || isDeserialisingFilters);
    }, [
        isDeserialisingFilters,
        isLoadingFieldConfig,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter
    };
};

});
parcelRegister("jhNgz", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $d017338cf4a59425$export$9f6dc7e3584916fa);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $ejYlo = parcelRequire("ejYlo");

var $bPRqC = parcelRequire("bPRqC");

var $aWjLM = parcelRequire("aWjLM");
const $d017338cf4a59425$var$emptySet = new Set();
const $d017338cf4a59425$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $bPRqC.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $d017338cf4a59425$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $eUqFw.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $aWjLM.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $eUqFw.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $eUqFw.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d017338cf4a59425$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $d017338cf4a59425$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $eUqFw.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $lO4Or.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $lO4Or.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("ejYlo", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $a250a9d5a7d089ab$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

var $4Zgod = parcelRequire("4Zgod");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");


var $bRzz9 = parcelRequire("bRzz9");
const $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
// TODO: remove shouldFetchSprints and keep shouldFetchSoftwareFields after clean up  jsw_list_view_-_all_the_fields
const $a250a9d5a7d089ab$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: (0, $1ybV0.ff)('jwm-increase-initial-issue-type-field-options_ztvy8') ? $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS : $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE))),
                    shouldFetchSoftwareFields: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, $lO4Or.FIX_VERSIONS_TYPE))),
                    shouldFetchParentField: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $lO4Or.GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')),
                    goalsJqlTerm: goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? goalsJqlTerm : '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE)) ? `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $bRzz9.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            return (0, $5IIOI.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $bRzz9.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $a250a9d5a7d089ab$var$memoizedFetchInitialData = (0, $5iWql.default)($a250a9d5a7d089ab$var$fetchInitialDataInternal);
const $a250a9d5a7d089ab$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, $4Zgod.EMPTY_TEAMS));
const $a250a9d5a7d089ab$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $bRzz9.useGoalsJqlTerm)(filterFields);
    let fetchTeamsService = $a250a9d5a7d089ab$var$fetchTeamsServiceFnc;
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fetchTeamsService = (0, $4Zgod.useFetchTeams)();
    const fetchInitialData = (0, $eUqFw.useCallback)(async ()=>{
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
            $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsService({
                first: $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS
            })
        ]).then((values)=>{
            let result = (0, $kIODn.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
        return $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsService,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $kIODn.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $8d92abf0af87bfd8$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $kIODn.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            fetchFixVersions: fetchFixVersions,
            fetchParents: fetchParents,
            fetchTeams: fetchTeams
        } : {},
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("kIODn", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $661a0fc6907b6ea1$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $661a0fc6907b6ea1$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $661a0fc6907b6ea1$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $661a0fc6907b6ea1$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $661a0fc6907b6ea1$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $661a0fc6907b6ea1$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $661a0fc6907b6ea1$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $661a0fc6907b6ea1$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $661a0fc6907b6ea1$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $661a0fc6907b6ea1$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $661a0fc6907b6ea1$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $661a0fc6907b6ea1$export$8e327b5f9ebc175d);
/* eslint-disable complexity */ 
var $lyOYo = parcelRequire("lyOYo");

var $lO4Or = parcelRequire("lO4Or");
const $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $661a0fc6907b6ea1$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $661a0fc6907b6ea1$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $661a0fc6907b6ea1$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $661a0fc6907b6ea1$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $661a0fc6907b6ea1$var$getFirstIssueTypeId(node),
            avatar: $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $661a0fc6907b6ea1$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $661a0fc6907b6ea1$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(transformedCategories, ({ value: value })=>value);
};
const $661a0fc6907b6ea1$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $661a0fc6907b6ea1$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $661a0fc6907b6ea1$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $661a0fc6907b6ea1$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar
        };
    });
const $661a0fc6907b6ea1$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $661a0fc6907b6ea1$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $661a0fc6907b6ea1$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $661a0fc6907b6ea1$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $661a0fc6907b6ea1$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $661a0fc6907b6ea1$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $661a0fc6907b6ea1$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $661a0fc6907b6ea1$var$isUser = (fieldValue)=>true;
const $661a0fc6907b6ea1$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $661a0fc6907b6ea1$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $661a0fc6907b6ea1$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$661a0fc6907b6ea1$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($661a0fc6907b6ea1$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($661a0fc6907b6ea1$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($661a0fc6907b6ea1$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($661a0fc6907b6ea1$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $lO4Or.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $661a0fc6907b6ea1$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($661a0fc6907b6ea1$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($661a0fc6907b6ea1$var$isSprint(fieldValue)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $661a0fc6907b6ea1$var$isUser(fieldValue)) {
                    const usersData = $661a0fc6907b6ea1$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($661a0fc6907b6ea1$var$isGoal(fieldValue)) transformedData[0, $lO4Or.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("4Zgod", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TEAMS", () => $f012c42657d68d46$export$37430da53242c305);
$parcel$export(module.exports, "useFetchTeams", () => $f012c42657d68d46$export$da1ab223b3f1410c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $jD3pk = parcelRequire("jD3pk");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

// use ari functions from @atlassian/ari whenever it is ready for import
const $f012c42657d68d46$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $f012c42657d68d46$export$37430da53242c305 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS = 20;
const $f012c42657d68d46$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query, first: first = $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $1a073e75df73c791$export$cbe5a6af25588495),
                    variables: {
                        orgId: $f012c42657d68d46$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            const options = (0, $kIODn.transformTeams)(response.data.team.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $f012c42657d68d46$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};

});
const $1a073e75df73c791$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;


parcelRegister("gF4D9", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $12ce55db15189323$export$b18eef22aaa99c21);

var $5iWql = parcelRequire("5iWql");

var $6gPph = parcelRequire("6gPph");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

const $12ce55db15189323$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $12ce55db15189323$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? (0, $a02b4224be9155fa$export$2bd792833522f1f1) : (0, $a02b4224be9155fa$export$e8b5e80812d4a604),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $6gPph.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $12ce55db15189323$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $12ce55db15189323$export$b18eef22aaa99c21 = (0, $5iWql.default)($12ce55db15189323$export$7a89edfb546e2344);

});
parcelRegister("6gPph", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $cba33ea5171f294f$export$83dcbdfe8cbc1e17);
const $cba33ea5171f294f$export$f215947b3d76a6b7 = 'QueryError';
class $cba33ea5171f294f$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("5IIOI", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $3cf74c17db7589d0$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $3cf74c17db7589d0$export$8f60413c08081990);

var $lyOYo = parcelRequire("lyOYo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $3cf74c17db7589d0$var$transformHydratedValuesOld = (data)=>{
    const transformedHydratedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    Object.keys(data).forEach((key)=>{
        if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
            case 'issuetype':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformIssueTypes)(data[key])
                };
                return;
            case 'priority':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformPriorities)(data[key])
                };
                return;
            case 'status':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformStatuses)(data[key])
                };
                return;
            case 'labels':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            case 'component':
                transformedHydratedData.components = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            default:
                if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                    totalCount: 0,
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...(0, $kIODn.transformUsers)(data[key]),
                        ...transformedHydratedData.users?.options ?? []
                    ], ({ value: value })=>value)
                };
                else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformSprints)(data[key])
                };
        }
    });
    return transformedHydratedData;
};
const $3cf74c17db7589d0$export$56282b201a60959e = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $kIODn.transformValuesData)(data);
    return $3cf74c17db7589d0$var$transformHydratedValuesOld(data);
};
const $3cf74c17db7589d0$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $lO4Or.CATEGORY_TYPE)]: initialData[0, $lO4Or.CATEGORY_TYPE],
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: initialData[0, $lO4Or.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.SPRINT_TYPE].options,
                ...initialData[0, $lO4Or.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || [],
                ...initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.PARENT_FIELD_TYPE]?.options || [],
                ...initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.GOALS_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.GOALS_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        }
    });

});

const $8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $8d92abf0af87bfd8$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("bRzz9", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $26047d310e78058e$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $26047d310e78058e$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $26047d310e78058e$export$674eff5ec8403101);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $26047d310e78058e$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $kIODn.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $26047d310e78058e$var$transformInitialDataOld = (data)=>{
    const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
    const transformedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
        totalCount: components.totalCount,
        options: (0, $kIODn.transformDefaultField)(components)
    };
    if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
        totalCount: issuetype.totalCount,
        options: (0, $kIODn.transformIssueTypes)(issuetype)
    };
    if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
        totalCount: priority.totalCount,
        options: (0, $kIODn.transformPriorities)(priority)
    };
    if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
        totalCount: labels.totalCount,
        options: (0, $kIODn.transformDefaultField)(labels)
    };
    if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
        totalCount: status.totalCount,
        options: (0, $kIODn.transformStatuses)(status)
    };
    if (users?.edges != null && Array.isArray(users.edges)) {
        const usersData = (0, $kIODn.transformUsers)(users);
        const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, $kIODn.transformUsers)(recentlyUsedUsers) : null;
        transformedData.users = {
            totalCount: users.totalCount,
            options: // combine `recentlyUsedUsers` and `users` options to improve relevancy of the users field
            recentlyUsedUsersData != null ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...recentlyUsedUsersData,
                ...usersData
            ], ({ value: value })=>value) : usersData
        };
    }
    const categories = $26047d310e78058e$var$transformInitialCategories(data);
    if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
    if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
        options: (0, $kIODn.transformSprints)(sprints),
        totalCount: sprints.totalCount
    };
    return transformedData;
};
const $26047d310e78058e$export$93219b8691fe49a0 = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        const transformedData = (0, $kIODn.transformValuesData)(data.jira.jqlBuilder);
        const categories = $26047d310e78058e$var$transformInitialCategories(data);
        if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
        return transformedData;
    }
    return $26047d310e78058e$var$transformInitialDataOld(data);
};
const $26047d310e78058e$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $guiFP.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $26047d310e78058e$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $eUqFw.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $lO4Or.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("bPRqC", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $527c6b4310270d47$export$70da50df1be2dbe1);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $jGcn0 = parcelRequire("jGcn0");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $ihkPC = parcelRequire("ihkPC");

var $fP7qq = parcelRequire("fP7qq");

var $e20I1 = parcelRequire("e20I1");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");

var $a75Ge = parcelRequire("a75Ge");

var $7G14t = parcelRequire("7G14t");

var $ijEQD = parcelRequire("ijEQD");
const $527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS = 10;
const $527c6b4310270d47$var$useFilterMapper = true;
const $527c6b4310270d47$var$EMPTY_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_USER_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY = [];
const $527c6b4310270d47$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $527c6b4310270d47$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $527c6b4310270d47$export$74cea4b24a6bc9fa = $527c6b4310270d47$export$1fe8227c57fa0d68();
const $527c6b4310270d47$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $eUqFw.useState)(0);
    return (0, $eUqFw.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $527c6b4310270d47$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userResolver] = (0, $eUqFw.useState)(new (0, $e20I1.UserResolver)());
    const forceUpdate = $527c6b4310270d47$var$useForceUpdate();
    // this is used to check whether the hook is still mounted by the time we call fireErrorAnalytics
    // see JET-2324
    const mounted = (0, $eUqFw.useRef)(true);
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $eUqFw.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $a75Ge.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const hydratedUsers = (0, $eUqFw.useRef)(null);
    const fetchInitialUsers = (0, $eUqFw.useCallback)(async ()=>{
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $2OdyW.default)(url);
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $eUqFw.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $2OdyW.default)(url);
            const labels = response.values;
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $527c6b4310270d47$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $2OdyW.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $ihkPC.getErrorType)(err),
                        online: window.navigator.onLine,
                        mounted: mounted.current
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $527c6b4310270d47$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $fP7qq.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $527c6b4310270d47$var$useFilterMapper,
                mounted: mounted.current
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)((query = '')=>(0, $2OdyW.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $eUqFw.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey !== projectKey || $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.data === $527c6b4310270d47$var$EMPTY_USER_ARRAY)) {
            if ($527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $eUqFw.useMemo)(()=>({
            priority: (0, $ijEQD.transformPriority)(priorityFieldConfig),
            issuetype: (0, $ijEQD.transformIssueType)(issueTypeData),
            status: (0, $ijEQD.transformStatuses)(statuses),
            users: (0, $ijEQD.transformUsers)(initialUsers),
            labels: (0, $ijEQD.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $lO4Or.CATEGORY_TYPE)]: initialCategories,
            [(0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $eUqFw.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $ijEQD.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $ijEQD.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $ijEQD.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingStatuses || fetching
    };
};

});
parcelRegister("35jYz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $81e81ebd14cd3d82$export$42e875bfb69ded2);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $gEmpR = parcelRequire("gEmpR");
const $81e81ebd14cd3d82$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $81e81ebd14cd3d82$var$actions = {
    merge: $81e81ebd14cd3d82$var$merge
};
const $81e81ebd14cd3d82$export$cbf0f7fe9ca42a65 = (0, $a61MH.createStore)({
    initialState: {},
    actions: $81e81ebd14cd3d82$var$actions,
    name: 'issueTypeFieldConfig'
});
const $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $81e81ebd14cd3d82$export$47647eb426e85a25 = (0, $ggKAj.createHook)($81e81ebd14cd3d82$export$cbf0f7fe9ca42a65, {
    selector: $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector
});
const $81e81ebd14cd3d82$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $81e81ebd14cd3d82$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $eUqFw.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("ihkPC", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $348eddd0ac284a22$export$e19f9f08a6d79fd2);

var $7byHA = parcelRequire("7byHA");
const $348eddd0ac284a22$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $348eddd0ac284a22$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $348eddd0ac284a22$export$d46a05f8561f868a = 'OTHER';
const $348eddd0ac284a22$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $348eddd0ac284a22$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $348eddd0ac284a22$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $348eddd0ac284a22$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($348eddd0ac284a22$var$isApolloClientNetworkError(error)) return $348eddd0ac284a22$export$7453182ebe5973d4;
    const entry = Object.entries($348eddd0ac284a22$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $348eddd0ac284a22$export$d46a05f8561f868a;
};

});

parcelRegister("fP7qq", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3);
$parcel$export(module.exports, "mapComponentsToOptions", () => (parcelRequire("a9hW2")).mapComponentsToOptions);

var $53ciZ = parcelRequire("53ciZ");

var $ihkPC = parcelRequire("ihkPC");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $a9hW2 = parcelRequire("a9hW2");
const $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, mounted: mounted, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $a9hW2.mapComponentsToFilterOptions) : (0, $a9hW2.mapComponentsToOptions);
    const query = (0, $1ybV0.ff)('jira.list.field-support-part1') ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue,
        ...queryParameters
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $ihkPC.getErrorType)(error),
                online: window.navigator.onLine,
                mounted: mounted
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("a9hW2", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $c0b17925cb48a958$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $c0b17925cb48a958$export$b4ef58d3e943e4d5);
const $c0b17925cb48a958$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $c0b17925cb48a958$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("e20I1", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $2f3c56b3440530f6$export$723df28d03868f02);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
class $2f3c56b3440530f6$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $2OdyW.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("a75Ge", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $342d49f1f4fd71f7$export$11ff6a520db76faf);

var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $kQAZu = parcelRequire("kQAZu");

var $gUUjF = parcelRequire("gUUjF");
const $342d49f1f4fd71f7$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $342d49f1f4fd71f7$var$MAX_RETRIES = 3;
const $342d49f1f4fd71f7$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $342d49f1f4fd71f7$var$actions = {
    set: $342d49f1f4fd71f7$var$set
};
const $342d49f1f4fd71f7$var$ProjectStatusesStore = (0, $a61MH.createStore)({
    initialState: {},
    actions: $342d49f1f4fd71f7$var$actions,
    name: 'projectStatuses'
});
const $342d49f1f4fd71f7$var$getProjectStatusesSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $342d49f1f4fd71f7$export$482f388228eef22c = (0, $ggKAj.createHook)($342d49f1f4fd71f7$var$ProjectStatusesStore, {
    selector: $342d49f1f4fd71f7$var$getProjectStatusesSelector
});
const $342d49f1f4fd71f7$var$emptyArray = [];
const $342d49f1f4fd71f7$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $342d49f1f4fd71f7$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
            const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
            (acc, next)=>acc.concat(next.statuses), []);
            const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(allStatuses, 'id');
            return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(dedupedResults, [
                'name'
            ]);
        }).then((uniqueStatuses)=>{
            statusActions.set(projectKey, uniqueStatuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($342d49f1f4fd71f7$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
            if (retriesCount < $342d49f1f4fd71f7$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $342d49f1f4fd71f7$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("7G14t", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f05aa0c8a487bc66$export$f05af123f98299b0);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lKPnc = parcelRequire("lKPnc");

var $fOoev = parcelRequire("fOoev");
const $f05aa0c8a487bc66$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f05aa0c8a487bc66$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($f05aa0c8a487bc66$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchDataAbortable = (0, $NFHn0.useAbortable)((0, $lKPnc.fetchGroupItemValues));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $fOoev.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("lKPnc", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $8489c6f37b087f09$export$7e6e0c3f4468ce45);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

const $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $8489c6f37b087f09$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $622211c2999f2f37$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $622211c2999f2f37$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("fOoev", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $2b76e62e743cb9ff$export$93219b8691fe49a0);

var $ivaRx = parcelRequire("ivaRx");
const $2b76e62e743cb9ff$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $ivaRx.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("ivaRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2394f0a911447$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd2394f0a911447$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("ijEQD", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $c6e67604bea772f5$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $c6e67604bea772f5$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $c6e67604bea772f5$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $c6e67604bea772f5$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $c6e67604bea772f5$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $c6e67604bea772f5$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $c6e67604bea772f5$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $h1vWF = parcelRequire("h1vWF");
const $c6e67604bea772f5$export$1b9f55a39456e911 = (0, $5iWql.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$96520244689f81c1 = (0, $5iWql.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$20a57a5ec025f2d = (0, $5iWql.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$c072126708d93f04 = (0, $5iWql.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$cdfcc40760c1a4f8 = (0, $5iWql.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $c6e67604bea772f5$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
        case 0, $lO4Or.DATE_CF_TYPE:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $c6e67604bea772f5$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $c6e67604bea772f5$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return $c6e67604bea772f5$var$getSelectCustomFieldValues(field);
        case 0, $lO4Or.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $c6e67604bea772f5$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $c6e67604bea772f5$var$isCustomField = (type)=>(0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $c6e67604bea772f5$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$c6e67604bea772f5$export$fb8c90bfc4beaa59(response)));
const $c6e67604bea772f5$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $h1vWF.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $c6e67604bea772f5$var$getType({
            type: type
        });
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $h1vWF.default).filterPlaceholder),
            options: $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $c6e67604bea772f5$var$isCustomField(type),
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $lO4Or.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $h1vWF.default).typeLabel);
        if ($c6e67604bea772f5$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $c6e67604bea772f5$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $h1vWF.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $h1vWF.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("1run3", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $0804b64445570a47$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $0804b64445570a47$export$7d34c8548269835d);
const $0804b64445570a47$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $0804b64445570a47$export$7d34c8548269835d = (field)=>field.type === $0804b64445570a47$export$ed12481c953b8653.DateFilter;

});

parcelRegister("dG4cR", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $36a0671262b022c0$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $36a0671262b022c0$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $36a0671262b022c0$export$9b72011e2eb8d7d0);
const $36a0671262b022c0$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $36a0671262b022c0$export$6e40821019289c70 = 'optimistic-filter-id';
const $36a0671262b022c0$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$9ebaf9fe814731d3 = null;
const $36a0671262b022c0$export$9b72011e2eb8d7d0 = 'text';

});

parcelRegister("h1vWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a86e8a54f0713c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2a86e8a54f0713c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("aWjLM", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $f0c719cf639dcc71$export$c041141a7ef797c1);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $e20I1 = parcelRequire("e20I1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ejYlo = parcelRequire("ejYlo");

var $hLW3I = parcelRequire("hLW3I");

var $jWIW7 = parcelRequire("jWIW7");

var $7goEv = parcelRequire("7goEv");
const $f0c719cf639dcc71$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$var$EMPTY_FILTER_DATA = {
    initialUsers: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialLabels: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialComponents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialPriorities: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialStatuses: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialCategories: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialSprints: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialFixVersions: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialParents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialGoals: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialTeams: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA
};
const $f0c719cf639dcc71$var$initialState = {
    data: undefined,
    loadingData: true
};
const $f0c719cf639dcc71$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $f0c719cf639dcc71$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $f0c719cf639dcc71$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $f0c719cf639dcc71$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectFieldData = (0, $jWIW7.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $eUqFw.useReducer)($f0c719cf639dcc71$var$reducer, $f0c719cf639dcc71$var$initialState);
    const userResolver = (0, $eUqFw.useRef)(new (0, $e20I1.UserResolver)());
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $eUqFw.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $lO4Or.CATEGORY_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $lO4Or.SPRINT_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                        initialFixVersions: initialData?.[0, $lO4Or.FIX_VERSIONS_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialParents: initialData?.[0, $lO4Or.PARENT_FIELD_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialTeams: initialData?.[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                    } : {},
                    initialGoals: initialData?.[0, $lO4Or.GOALS_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $eUqFw.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $f0c719cf639dcc71$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $f0c719cf639dcc71$var$emptyFieldValue,
            status: data?.initialStatuses ?? $f0c719cf639dcc71$var$emptyFieldValue,
            users: data?.initialUsers ?? $f0c719cf639dcc71$var$emptyFieldValue,
            labels: data?.initialLabels ?? $f0c719cf639dcc71$var$emptyFieldValue,
            components: data?.initialComponents ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.CATEGORY_TYPE)]: data?.initialCategories ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.SPRINT_TYPE)]: data?.initialSprints ?? $f0c719cf639dcc71$var$emptyFieldValue,
            project: projectFieldData,
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                [(0, $lO4Or.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.PARENT_FIELD_TYPE)]: data?.initialParents ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $f0c719cf639dcc71$var$emptyFieldValue
            } : {},
            [(0, $lO4Or.GOALS_CF_TYPE)]: data?.initialGoals ?? $f0c719cf639dcc71$var$emptyFieldValue
        };
        return (0, $7goEv.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("hLW3I", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $b966faf4b3b8c8a2$export$b2d30fa5478b571a);

var $eUqFw = parcelRequire("eUqFw");

var $kMmsu = parcelRequire("kMmsu");
const $b966faf4b3b8c8a2$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $kMmsu.useFieldsResource)();
    const data = (0, $eUqFw.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});

parcelRegister("7goEv", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $9Jtgc = parcelRequire("9Jtgc");
const $1ffbd75d284f79d7$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $1ffbd75d284f79d7$var$getType = (type)=>{
    switch(type){
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
        case 0, $lO4Or.PARENT_FIELD_TYPE:
        case 0, $lO4Or.TEAMS_PLATFORM_CF_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
        case 0, $lO4Or.SPRINT_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.PROJECT_TYPE:
            return (0, $1run3.FieldType).ProjectFilter;
        case 0, $lO4Or.GOALS_CF_TYPE:
            return (0, $1run3.FieldType).GoalsSelectFilter;
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $1ffbd75d284f79d7$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $1ffbd75d284f79d7$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$isCustomField = (type)=>{
    switch(type){
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$1ffbd75d284f79d7$export$fb8c90bfc4beaa59(response)));
const $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $9Jtgc.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter,
        fromLabel: formatMessage((0, $9Jtgc.default).startDateLabel),
        toLabel: formatMessage((0, $9Jtgc.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    // eslint-disable-next-line complexity
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $1ffbd75d284f79d7$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $1ffbd75d284f79d7$var$getType(fieldType),
            placeholder: formatMessage((0, $9Jtgc.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $1ffbd75d284f79d7$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $lO4Or.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($1ffbd75d284f79d7$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $1ffbd75d284f79d7$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.FIX_VERSIONS_TYPE) && fetchFixVersions && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.PARENT_FIELD_TYPE) && fetchParents && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noParentLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("9Jtgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082940a52668b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $510082940a52668b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});




parcelRegister("gZpkQ", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $0e65969a09396197$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $0e65969a09396197$export$a14bc8305f71e469);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $8Qd0L = parcelRequire("8Qd0L");

var $9GlEj = parcelRequire("9GlEj");
const $0e65969a09396197$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $7c3W1.useViewPreference)((0, $ji3xf.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $eUqFw.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $0e65969a09396197$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $0e65969a09396197$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("9GlEj", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $20c7583d02c9250e$export$3dae1bb95b659fd4);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $kMmsu = parcelRequire("kMmsu");
const $20c7583d02c9250e$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $20c7583d02c9250e$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $20c7583d02c9250e$var$quickFilterToJQLMapOld;
    return {
        ...$20c7583d02c9250e$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $20c7583d02c9250e$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $20c7583d02c9250e$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $20c7583d02c9250e$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$20c7583d02c9250e$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $20c7583d02c9250e$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    return (0, $eUqFw.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $20c7583d02c9250e$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $20c7583d02c9250e$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const [filters, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const jql = $20c7583d02c9250e$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (jql == null) setFilters(undefined);
            else setFilters(jql);
        } else setFilters(undefined);
    }, [
        quickFilterToJQLMap,
        setFilters
    ]);
    const quickFilters = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$9692fc1a2fd983f5(filters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        filters,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $20c7583d02c9250e$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("lEWmB", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $2972841342234906$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $8aCHU = parcelRequire("8aCHU");
const $2972841342234906$export$973ca22476b0e05f = ()=>{
    const [jql, saveFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const serialiseJql = (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? (0, $8aCHU.serialiseJql) : (0, $8aCHU.serialiseJqlOld);
    const setFilter = (0, $eUqFw.useCallback)((filters)=>{
        const serialisedJql = serialiseJql(filters);
        saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveFilters,
        serialiseJql
    ]);
    return {
        setFilter: setFilter,
        jql: jql
    };
};

});
parcelRegister("8aCHU", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $0e700551905b00b3$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "serialiseJqlOld", () => $0e700551905b00b3$export$5bd6a523f48a18cd);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $0e700551905b00b3$export$9ee6085825c9cbfa);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $6wqPF = parcelRequire("6wqPF");

var $6x1NF = parcelRequire("6x1NF");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $dG4cR = parcelRequire("dG4cR");
const $0e700551905b00b3$var$START_DATE_JQL = 'Start date[Date]';
const $0e700551905b00b3$var$EMPTY = 'EMPTY';
const $0e700551905b00b3$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $0e700551905b00b3$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $0e700551905b00b3$var$START_DATE_JQL;
    return fieldName;
};
const $0e700551905b00b3$var$getFieldNameForJql = (fieldName)=>$0e700551905b00b3$var$getQuotedFieldName($0e700551905b00b3$var$getFieldNameForJqlRaw(fieldName));
const $0e700551905b00b3$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $0e700551905b00b3$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $0e700551905b00b3$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $0e700551905b00b3$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $0e700551905b00b3$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $ehDeP.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(toFieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_LT)), (0, $ehDeP.default).valueOperand(toDate)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_GT_EQUALS)), (0, $ehDeP.default).valueOperand(options.value.from)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $ehDeP.default).valueOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $ehDeP.default).byText.valueOperand(`"${$0e700551905b00b3$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), operands[0]), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_IN)), (0, $ehDeP.default).listOperand(operands)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $ehDeP.default).jast(jqlQuery);
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $0e700551905b00b3$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $0e700551905b00b3$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $dG4cR.EMPTY_FILTER_VALUE) ? $0e700551905b00b3$var$EMPTY : `'${$0e700551905b00b3$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $0e700551905b00b3$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $0e700551905b00b3$var$getFieldIdFromJql(fieldId);
};
const $0e700551905b00b3$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($0e700551905b00b3$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';

parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});




parcelRegister("coMWQ", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $67199c690c914c16$export$214464255b766962);

var $hir2i = parcelRequire("hir2i");

var $27QuD = parcelRequire("27QuD");

var $9FEvp = parcelRequire("9FEvp");

var $6x1NF = parcelRequire("6x1NF");

var $6RWCB = parcelRequire("6RWCB");
var $bXcc5 = parcelRequire("bXcc5");
var $k85ht = parcelRequire("k85ht");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");
const $67199c690c914c16$var$START_DATE_JQL = 'Start date[Date]';
const $67199c690c914c16$var$EMPTY = 'EMPTY';
// remove any extra space first
// then replace any escaped apostrophe,
// lastly replace any quotation marks in the beginning and end of word but not the apostrophes in the middle of the word
const $67199c690c914c16$var$cleanString = (value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? value.trim() : value.trim().replace(/\\'/g, "'").replace(/^'|'$/g, '');
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $67199c690c914c16$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.CATEGORY_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $67199c690c914c16$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $67199c690c914c16$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $67199c690c914c16$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') {
        const cleanIds = list.map((value)=>$67199c690c914c16$var$cleanString(value));
        const ids = cleanIds.filter((value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') || value !== $67199c690c914c16$var$EMPTY);
        return resolver(ids).then((options)=>{
            // keep empty option in the response
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && list.find((value)=>value === $67199c690c914c16$var$EMPTY)) return [
                ...options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            return options;
        });
    }
    const allowUnknownOption = $67199c690c914c16$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        const cleanValue = $67199c690c914c16$var$cleanString(value);
        if (field && !(0, $1run3.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $67199c690c914c16$var$EMPTY;
                return option.value === cleanValue;
            });
            if (!optionInField && allowUnknownOption) return {
                value: cleanValue,
                label: cleanValue
            };
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && value === $67199c690c914c16$var$EMPTY) return {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: ''
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $67199c690c914c16$export$5299115fe71e8b39 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super();
        this.getOption = (fieldName, items)=>$67199c690c914c16$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
        this.visitCompoundClause = (compoundClause)=>{
            const clauseMap = Promise.resolve({});
            const operator = compoundClause.operator.value;
            if (operator === (0, $e5bc650799ce4838$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        };
        this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) {
                let date = (0, $6x1NF.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $k85ht.OPERATOR_LT)) date = (0, $6x1NF.default)((0, $9FEvp.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $k85ht.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        };
        this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $807962b43ef03b56$export$f6049126fd97001f)) return (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? [
                {
                    isEmptyOption: true,
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ] : this.getOption(fieldName, [
                $67199c690c914c16$var$EMPTY
            ]);
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        };
        this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $67199c690c914c16$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $k85ht.OPERATOR_GT_EQUALS) || operator.value === (0, $k85ht.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $k85ht.OPERATOR_EQUALS) || operator.value === (0, $k85ht.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $67199c690c914c16$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $67199c690c914c16$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});
parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});



parcelRegister("d3C6e", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $167db4325906604f$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $167db4325906604f$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $167db4325906604f$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $167db4325906604f$export$2ecca9d8a7f031af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $cWiVr = parcelRequire("cWiVr");

var $kjzom = parcelRequire("kjzom");

var $frfm9 = parcelRequire("frfm9");
class $167db4325906604f$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $167db4325906604f$var$IssueCreateContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $167db4325906604f$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $167db4325906604f$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $167db4325906604f$export$a975cd9627cdf4b6 = ({ mutation: mutation, query: query, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $eUqFw.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $eUqFw.useReducer)($167db4325906604f$var$reducer, $167db4325906604f$var$initialState);
    const createIssueController = (0, $kjzom.useCreateIssue)(mutation, query);
    const highlightIssue = (0, $eUqFw.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $eUqFw.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $eUqFw.useCallback)((createParams)=>{
        const job = new $167db4325906604f$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $lskA1.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $lskA1.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext
    ]);
    (0, $frfm9.useCreateParamHandler)();
    const saveSummary = (0, $eUqFw.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($167db4325906604f$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $167db4325906604f$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $eUqFw.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $eUqFw.useRef)(true);
    const submit = (0, $eUqFw.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $eUqFw.useCallback)(()=>{
        onBlur?.();
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $167db4325906604f$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $167db4325906604f$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $eUqFw.useCallback)((issueId)=>$167db4325906604f$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("lskA1", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $7b4071d915fd0829$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $7b4071d915fd0829$export$e2047b3433d9f565);
const $7b4071d915fd0829$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $7b4071d915fd0829$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $7b4071d915fd0829$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};

});

parcelRegister("kjzom", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $b3543cf4b0365df5$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $c7wtc = parcelRequire("c7wtc");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iNULk = parcelRequire("iNULk");

var $fop6E = parcelRequire("fop6E");

var $5ujax = parcelRequire("5ujax");

var $auegK = parcelRequire("auegK");

var $fOAem = parcelRequire("fOAem");

var $9Y2JR = parcelRequire("9Y2JR");
const $b3543cf4b0365df5$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    return (0, $eUqFw.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $b3543cf4b0365df5$export$8af2d18142c8506c = (mutation, query)=>{
    const createIssue = (0, $iNULk.useCreateIssue)(mutation);
    const refetchIssue = (0, $fop6E.useRefetchIssue)(query);
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await createIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await refetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $9Y2JR.default).errorFlagTitleNonFinal),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescriptionNonFinal)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        createIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        refetchIssue
    ]);
};

});
parcelRegister("c7wtc", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $0662fc67a6d31ad1$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $0662fc67a6d31ad1$export$437f9bd807b88beb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $6LdZl = parcelRequire("6LdZl");

var $8xqyO = parcelRequire("8xqyO");
const $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID = (0, $eo17r.toFlagId)('fetch-board-error-flag');
const $0662fc67a6d31ad1$var$WorkflowsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $0662fc67a6d31ad1$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6LdZl.useFetchWorkflows)();
    (0, $eUqFw.useEffect)(()=>{
        if ((!(0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || enabled) && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            id: $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $8xqyO.default).workflowsErrorTitle,
            description: (0, $8xqyO.default).workflowsErrorDescription
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0662fc67a6d31ad1$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $0662fc67a6d31ad1$export$437f9bd807b88beb = ()=>(0, $eUqFw.useContext)($0662fc67a6d31ad1$var$WorkflowsContext);

});
parcelRegister("6LdZl", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $999083320983ea8a$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $5Hc99 = parcelRequire("5Hc99");
const $999083320983ea8a$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $5Hc99.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $eUqFw.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5Hc99", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $d1ebb9e47bb48695$export$d54deb6c2b9695b7);

var $9ypom = parcelRequire("9ypom");
const $d1ebb9e47bb48695$export$d54deb6c2b9695b7 = (0, $9ypom.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("8xqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2d03bd6919e7a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2d03bd6919e7a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("iNULk", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $7f9682590ce5c99c$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");
var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $4xHig = parcelRequire("4xHig");


var $iWGMH = parcelRequire("iWGMH");
const $7f9682590ce5c99c$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $7f9682590ce5c99c$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $7f9682590ce5c99c$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $7f9682590ce5c99c$export$8af2d18142c8506c = (mutation)=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$sprintFieldPredicate);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [createIssue] = (0, $iZuDo.useMutation)(mutation);
    return (0, $eUqFw.useCallback)(async (createParams, extraPayload)=>{
        try {
            const input = (0, $iWGMH.buildInput)(createParams.input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            let isParentFieldVisible = false;
            let isDevSummaryFieldVisible = false;
            if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                isDevSummaryFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                isParentFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$bf9df74e065af482));
                fieldIdsSet.delete((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                fieldIdsSet.delete((0, $908924b2d198da78$export$bf9df74e065af482));
            }
            const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
            fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    withCoverMedia: withCoverMedia,
                    withExtendedIssue: (0, $1ybV0.ff)('jwm.board-awesome-enhancements'),
                    withChildrenCount: false,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                    withIssueLinks: withIssueLinks,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, $kkYfO.MutationError)(firstMutationError);
                }
                throw new (0, $dlVOn.GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueId: result.itemIdentifiers.issueId,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(error instanceof (0, $7byHA.ValidationError))) (0, $guiFP.default)({
                meta: {
                    id: 'JWMCreateIssueInline',
                    packageName: 'jiraBusinessIssueCreate',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        categoryField,
        createIssue,
        locale,
        sprintField,
        startDateField,
        storyPointEstimateField,
        storyPointsField,
        isLinkingEnabled
    ]);
};

});
parcelRegister("e4qlg", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $ce9b32995a7706e8$export$f7ac7f1f12b4c794);

var $lO4Or = parcelRequire("lO4Or");

var $gEmpR = parcelRequire("gEmpR");
const $ce9b32995a7706e8$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("4S5hf", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $8ce2e5c1390595df$export$4b0b80fa50e6b4be);

var $gEmpR = parcelRequire("gEmpR");
const $8ce2e5c1390595df$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $908924b2d198da78$export$41b6c9f5441c22c5 = 'rankBefore';
const $908924b2d198da78$export$d564e563c2ee8c4f = 'rankAfter';
const $908924b2d198da78$export$20b3b4741b8cfb64 = 'devSummaryField';
const $908924b2d198da78$export$bf9df74e065af482 = 'parentField';

parcelRegister("iWGMH", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $6cba527c033852df$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");

var $8K9kM = parcelRequire("8K9kM");

const $6cba527c033852df$export$f4db126e014728a3 = (input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    text: input.summary
                }
            ],
            singleSelectUserPickerFields: [],
            datePickerFields: [],
            numberFields: []
        },
        rank: {}
    };
    if (input.category && categoryField?.id) result.fields.singleLineTextFields.push({
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) result.fields.singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.startDate && startDateField?.id) result.fields.datePickerFields.push({
        fieldId: startDateField?.id,
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.dueDate) result.fields.datePickerFields.push({
        fieldId: (0, $lO4Or.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.priority) result.fields.priority = {
        priorityId: input.priority.priorityId
    };
    if (input.parentIssueId) result.fields.parentField = {
        issueId: input.parentIssueId
    };
    if (input.rankBefore) result.rank.before = {
        id: (0, $908924b2d198da78$export$41b6c9f5441c22c5),
        issueId: input.rankBefore.issueId
    };
    if (input.rankAfter) result.rank.after = {
        id: (0, $908924b2d198da78$export$d564e563c2ee8c4f),
        issueId: input.rankAfter.issueId
    };
    if (extraPayload.transitionId) result.transitionId = extraPayload.transitionId;
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) result.fields.numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) result.fields.numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    if (input.sprint && sprintField?.id) result.fields.sprintsField = {
        fieldId: sprintField.id,
        sprints: [
            {
                sprintId: input.sprint.id
            }
        ]
    };
    return result;
};

});


parcelRegister("fop6E", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssue", () => $afeef06c89f9a563$export$8bf876d423f9293d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $lGxgz = parcelRequire("lGxgz");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");
function $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $afeef06c89f9a563$export$8bf876d423f9293d = (query)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const refetchIssue = $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query);
    return (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withExtendedIssue: (0, $1ybV0.ff)('jwm.board-awesome-enhancements'),
            withChildrenCount: false,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withIssueLinks: withIssueLinks,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
};

});
parcelRegister("i3K0B", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $6bd61e247d9e0007$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $6bd61e247d9e0007$export$a39eddd73bba62c1);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_NEW = (0, $jGcn0.DEFAULT_PAGE_SIZE);
const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_OLD = 100;
const $6bd61e247d9e0007$var$IS_EMPTY = 'IS EMPTY';
const $6bd61e247d9e0007$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $6bd61e247d9e0007$var$getFieldNameForJql = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};
const $6bd61e247d9e0007$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = (0, $1ybV0.ff)('jwm.fix-list-view-jql-query-errors_5jp7y') ? sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC' : true;
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${$6bd61e247d9e0007$var$getFieldNameForJql(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $6bd61e247d9e0007$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue, parentIssues: parentIssues } = input;
    const defaultChildrenPerPage = (0, $1ybV0.ff)('jwm.remove-list-view-bulk-query') ? $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_NEW : $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_OLD;
    const isBulkQuery = Array.isArray(parentIssues) && parentIssues.length;
    const singleQueryJql = {
        jql: $6bd61e247d9e0007$export$d43e55153d6948c0(input, parentIssue)
    };
    const bulkQueryJql = isBulkQuery ? parentIssues.reduce((acc, currParentIssue)=>{
        acc[`jql${currParentIssue.issueId}`] = $6bd61e247d9e0007$export$d43e55153d6948c0(input, currParentIssue);
        return acc;
    }, {}) : {};
    const shouldUseChildrenPerPage = isBulkQuery ? true : parentIssue;
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    return {
        ...singleQueryJql,
        ...bulkQueryJql,
        first: shouldUseChildrenPerPage ? defaultChildrenPerPage : (0, $jGcn0.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        withParentRank: (0, $1ybV0.ff)('jwm.list_sort_parent_rank_first'),
        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
    };
};

});
const $2a7b21c0842403e6$export$9355e489ad16f98e = 'TASK';
const $2a7b21c0842403e6$export$3cb4a99a332e4186 = 'EPIC';


parcelRegister("lGxgz", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6fc881cfc8a36877$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6fc881cfc8a36877$export$d566b5d8a729afa0);

var $eUqFw = parcelRequire("eUqFw");


var $eZbpk = parcelRequire("eZbpk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iaCjO = parcelRequire("iaCjO");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $96etS = parcelRequire("96etS");

var $jQFcD = parcelRequire("jQFcD");
const $6fc881cfc8a36877$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $96etS.useSimpleSearchJQL)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $eUqFw.useMemo)(()=>(0, $jQFcD.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $eUqFw.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6fc881cfc8a36877$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6fc881cfc8a36877$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const [sortingBy] = (0, $iaCjO.useSorting)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.filters.handle-invalid-jql')) return (0, $jQFcD.getJqlErrors)(jql);
        return [];
    }, [
        jql
    ]);
    const sorting = (0, $eUqFw.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $lO4Or.FIX_VERSIONS_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return {
            ...sortingBy,
            sortBy: $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("iaCjO", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $35b6a42c26975572$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $35b6a42c26975572$export$f161a6f9d84a6fea);

var $eUqFw = parcelRequire("eUqFw");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $2i84A = parcelRequire("2i84A");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $a75Ge = parcelRequire("a75Ge");

var $a6BBe = parcelRequire("a6BBe");

var $iP9h2 = parcelRequire("iP9h2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE = {};
const $35b6a42c26975572$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    return [
        sorting || $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $35b6a42c26975572$var$emptyArray = [];
const $35b6a42c26975572$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $35b6a42c26975572$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $1ybV0.ff)('jwm.list.filters.sort-by-project-statuses') ? (0, $a75Ge.useProjectStatuses)() : (0, $2i84A.useGlobalStatuses)();
    const priorities = priorityFieldConfig?.options || $35b6a42c26975572$var$emptyArray;
    const sortFunction = (0, $eUqFw.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $a6BBe.STATUS_SORT_ORDER)) return (0, $a6BBe.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>{
            const sortedStatus = (0, $eI5EY.fg)('list_view_status_sorting') ? [
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }) : [
                ...statuses
            ];
            return sortedStatus.reduce((acc, next, index)=>{
                acc[(0, $eI5EY.fg)('list_view_status_sorting') ? next.name : next.id] = index;
                return acc;
            }, {});
        };
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $iP9h2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $iP9h2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("2i84A", function(module, exports) {

$parcel$export(module.exports, "useGlobalStatuses", () => $6dcdae727178c9b6$export$96ca88c93202037);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gUUjF = parcelRequire("gUUjF");
const $6dcdae727178c9b6$var$PACKAGE_LOCATION = 'jira-business.common.services.global-statuses';
const $6dcdae727178c9b6$var$MAX_RETRIES = 3;
const $6dcdae727178c9b6$var$set = (statuses)=>({ setState: setState })=>setState({
            statuses: statuses
        });
const $6dcdae727178c9b6$var$actions = {
    set: $6dcdae727178c9b6$var$set
};
const $6dcdae727178c9b6$var$GlobalStatusesStore = (0, $a61MH.createStore)({
    initialState: {
        statuses: []
    },
    actions: $6dcdae727178c9b6$var$actions,
    name: 'globalStatuses'
});
const $6dcdae727178c9b6$export$d8357dfc5f272b90 = (0, $ggKAj.createHook)($6dcdae727178c9b6$var$GlobalStatusesStore);
const $6dcdae727178c9b6$var$emptyArray = [];
const $6dcdae727178c9b6$export$96ca88c93202037 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const [state, statusActions] = $6dcdae727178c9b6$export$d8357dfc5f272b90();
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (Array.isArray(state.statuses) && state.statuses.length > 0) return {
        statuses: state.statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch('/rest/api/3/status').then((response)=>response.json()).then((statuses)=>{
            statusActions.set(statuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($6dcdae727178c9b6$var$PACKAGE_LOCATION, `Failed to retrieve global statuses - Retry #${retriesCount}`);
            if (retriesCount < $6dcdae727178c9b6$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $6dcdae727178c9b6$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("a6BBe", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $4f70cf7d8b2e6b0e$export$de9c103e53e690d1);
const $4f70cf7d8b2e6b0e$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("iP9h2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $61a5cf2a87fc48eb$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $61a5cf2a87fc48eb$export$b3fdfcb601c683c3);

var $bDIST = parcelRequire("bDIST");

var $jGcn0 = parcelRequire("jGcn0");

var $6imc4 = parcelRequire("6imc4");

var $iJbbQ = parcelRequire("iJbbQ");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $90Dtq = parcelRequire("90Dtq");
const $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $61a5cf2a87fc48eb$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $61a5cf2a87fc48eb$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(nodes, getters, orders.map($61a5cf2a87fc48eb$var$toAcceptedOrder));
const $61a5cf2a87fc48eb$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $3uSNh.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
};
/* eslint-enable complexity */ const $61a5cf2a87fc48eb$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $3uSNh.safeGetValue)(fields, 'priority', 'priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $61a5cf2a87fc48eb$var$resolveStatusOrder = (fields, statuses)=>{
    const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
    const statusName = (0, $3uSNh.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[(0, $eI5EY.fg)('list_view_status_sorting') ? statusName : statusId];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $61a5cf2a87fc48eb$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $61a5cf2a87fc48eb$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $3uSNh.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
/* eslint-disable complexity */ const $61a5cf2a87fc48eb$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $6imc4.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $6imc4.isSortingSupported)(fieldType) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            const field = (0, $3uSNh.getFieldValue)(fields, sortingField);
            if ((0, $iJbbQ.isNewTransformedFieldPredicated)(field)) return (0, $6imc4.getSorting)(fieldType, field) || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
            return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $lO4Or.LABELS_TYPE:
            case 0, $lO4Or.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $lO4Or.PRIORITY_TYPE:
                return $61a5cf2a87fc48eb$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $lO4Or.STATUS_TYPE:
                return $61a5cf2a87fc48eb$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $lO4Or.ISSUE_TYPE:
                return $61a5cf2a87fc48eb$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $lO4Or.ASSIGNEE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $lO4Or.USER_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $61a5cf2a87fc48eb$var$resolveIssueKeyOrder(fields);
            case 0, $lO4Or.CREATED:
            case 0, $lO4Or.UPDATED:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $lO4Or.DATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DATETIME_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $jGcn0.RANK_ALIAS_FIELD_ID:
                if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                    // We want to check for l-1 if the new jql parent is on
                    if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first') && (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                } else if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first')) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $lO4Or.SUMMARY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $lO4Or.TEXT_CF_TYPE:
                return $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $lO4Or.SELECT_CF_TYPE:
            case 0, $lO4Or.CATEGORY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.URL_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.NUMBER_CF_TYPE:
            case 0, $lO4Or.STORY_POINTS_TYPE:
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.COMPONENTS_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $lO4Or.SPRINT_TYPE:
                {
                    const sprintValue = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE].toString()) return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $3uSNh.safeGetValue)(fields, (0, $jGcn0.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $61a5cf2a87fc48eb$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});

parcelRegister("6imc4", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $5172533d88399045$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $5172533d88399045$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $5172533d88399045$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $5172533d88399045$export$56c924491e5617ad);

var $5iWql = parcelRequire("5iWql");

var $hPNnE = parcelRequire("hPNnE");

var $6Kxnm = parcelRequire("6Kxnm");

var $4dn6Q = parcelRequire("4dn6Q");

var $fgDTb = parcelRequire("fgDTb");

var $4kOft = parcelRequire("4kOft");

var $dnGVZ = parcelRequire("dnGVZ");

var $5GKSf = parcelRequire("5GKSf");

var $4ACib = parcelRequire("4ACib");

var $8DMfR = parcelRequire("8DMfR");

var $77PMd = parcelRequire("77PMd");

var $fGEjz = parcelRequire("fGEjz");
const $5172533d88399045$var$createSortingHandlers = (0, $5iWql.default)(()=>({
        ...(0, $4kOft.parentSortingHandler),
        ...(0, $fGEjz.versionSortingHandler),
        ...(0, $4ACib.resolutionSortingHandler),
        ...(0, $fgDTb.groupSortingHandler),
        ...(0, $5GKSf.radioSelectSortingHandler),
        ...(0, $hPNnE.cascadingSelectSortingHandler),
        ...(0, $dnGVZ.projectSortingHandler)
    }));
const $5172533d88399045$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $5172533d88399045$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $5172533d88399045$export$190ed2ad153b150b = (fieldType)=>true;
const $5172533d88399045$export$56c924491e5617ad = (0, $5iWql.default)(()=>({
        ...(0, $6Kxnm.devSummaryDisabledSorting),
        ...(0, $77PMd.teamDisabledSorting),
        ...(0, $8DMfR.statusCategoryDisabledSorting),
        ...(0, $4dn6Q.goalsDisabledSorting)
    }));

});
parcelRegister("hPNnE", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $9006c1312190fa14$export$7b0bfc6838ff3257);

var $lO4Or = parcelRequire("lO4Or");

var $yTRlI = parcelRequire("yTRlI");
const $9006c1312190fa14$var$getCascadingSelectSorting = (field)=>(0, $yTRlI.getCascadingSelectStringValue)(field.value);
const $9006c1312190fa14$export$7b0bfc6838ff3257 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $9006c1312190fa14$var$getCascadingSelectSorting
};

});
parcelRegister("yTRlI", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $501644a5d0f27e91$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $501644a5d0f27e91$export$f39c163ada81742a);

var $lO4Or = parcelRequire("lO4Or");
const $501644a5d0f27e91$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $501644a5d0f27e91$var$getCascadingSelectValue = (field)=>$501644a5d0f27e91$export$f110a74eb752aa7e(field.value);
const $501644a5d0f27e91$export$f39c163ada81742a = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectValue
};

});


parcelRegister("6Kxnm", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $13cd49fb2f12cee8$export$8cf683615a3ccf77);

var $lO4Or = parcelRequire("lO4Or");
const $13cd49fb2f12cee8$export$8cf683615a3ccf77 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("4dn6Q", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $e609dcddc34139db$export$60ff70c996f5c362);

var $lO4Or = parcelRequire("lO4Or");
const $e609dcddc34139db$export$60ff70c996f5c362 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: false
};

});

parcelRegister("fgDTb", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $2965094b1aff09d1$export$a577fd60fa30451d);

var $lO4Or = parcelRequire("lO4Or");
const $2965094b1aff09d1$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $2965094b1aff09d1$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $2965094b1aff09d1$export$a577fd60fa30451d = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getSingleGroupSorting,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getMultipleGroupSorting
};

});

parcelRegister("4kOft", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $b1645a5228930c15$export$20dbdacc158507c9);

var $lO4Or = parcelRequire("lO4Or");
const $b1645a5228930c15$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $b1645a5228930c15$export$20dbdacc158507c9 = {
    [(0, $lO4Or.PARENT_TYPE)]: $b1645a5228930c15$var$getParentSorting
};

});

parcelRegister("dnGVZ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $b535da34585ea13f$export$18c888fa7805bbf9);

var $lO4Or = parcelRequire("lO4Or");
const $b535da34585ea13f$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $b535da34585ea13f$export$18c888fa7805bbf9 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $b535da34585ea13f$var$getProjectSorting
};

});

parcelRegister("5GKSf", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $090676a3e9c576f9$export$d622730346571a2b);

var $lO4Or = parcelRequire("lO4Or");
const $090676a3e9c576f9$var$getRadioSelectSorting = (field)=>field.value ? field.value.label : '';
const $090676a3e9c576f9$export$d622730346571a2b = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $090676a3e9c576f9$var$getRadioSelectSorting
};

});

parcelRegister("4ACib", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $2a63ab07413670f0$export$596a643f093db9a7);

var $lO4Or = parcelRequire("lO4Or");
const $2a63ab07413670f0$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $2a63ab07413670f0$export$596a643f093db9a7 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $2a63ab07413670f0$var$getResolutionSorting
};

});

parcelRegister("8DMfR", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $14c4f6b294c727dd$export$117cb43589655b27);

var $lO4Or = parcelRequire("lO4Or");
const $14c4f6b294c727dd$export$117cb43589655b27 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("77PMd", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $4318536e894fadd9$export$1626c947db580b0f);

var $lO4Or = parcelRequire("lO4Or");
const $4318536e894fadd9$export$1626c947db580b0f = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("fGEjz", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $478431d0e41552b9$export$f2894a637a250eaa);

var $lO4Or = parcelRequire("lO4Or");
const $478431d0e41552b9$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $478431d0e41552b9$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $478431d0e41552b9$export$f2894a637a250eaa = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $478431d0e41552b9$var$getSingleVersionSorting,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting
};

});


parcelRegister("iJbbQ", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $1f6d8e2cada4a475$export$b018c2b58ea7e0de);

var $edHli = parcelRequire("edHli");
const $1f6d8e2cada4a475$export$b018c2b58ea7e0de = (field)=>field != null;

});
parcelRegister("edHli", function(module, exports) {

$parcel$export(module.exports, "isJiraBusinessFields", () => $58b3a50c72d1bd9f$export$257745f9c8865601);
const $58b3a50c72d1bd9f$export$257745f9c8865601 = (_)=>true;

});


parcelRegister("3uSNh", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $0a411223ee962893$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $0a411223ee962893$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $0a411223ee962893$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $0a411223ee962893$export$c1cc7bc9b4953394);

var $illlw = parcelRequire("illlw");
const $0a411223ee962893$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $0a411223ee962893$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, attributeName, defaultValue);
};
const $0a411223ee962893$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return $0a411223ee962893$export$c1cc7bc9b4953394(field, defaultValue);
};
const $0a411223ee962893$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, 'value', defaultValue);

});

parcelRegister("90Dtq", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $668a01cc7ea88012$export$992090b26f7c7f11);

var $1ybV0 = parcelRequire("1ybV0");
const $668a01cc7ea88012$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first')) {
        // sorting based on rank considers the parent rank first, then sorts based on item rank
        // concatenating (parentRank + rank) would do that for us!
        const parentRank = parentIssue?.rank ?? '';
        return parentRank.concat(rank);
    }
    return rank;
};

});



parcelRegister("96etS", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $70f3d6a365372dbd$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $70f3d6a365372dbd$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $70f3d6a365372dbd$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $70f3d6a365372dbd$export$42b8d8a5ec5bc873);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $kJlBc = parcelRequire("kJlBc");

var $dG4cR = parcelRequire("dG4cR");
const $70f3d6a365372dbd$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $70f3d6a365372dbd$var$issueKeyRegex = new RegExp(`^${(0, $6GXx9.ISSUEKEY_REGEX)}$`);
const $70f3d6a365372dbd$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $70f3d6a365372dbd$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $kJlBc.useQueryParam)((0, $dG4cR.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $eUqFw.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $70f3d6a365372dbd$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $70f3d6a365372dbd$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    return (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $70f3d6a365372dbd$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $70f3d6a365372dbd$var$sanitize(text);
    if ($70f3d6a365372dbd$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$70f3d6a365372dbd$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $70f3d6a365372dbd$export$119186efd4186c93 = (text)=>{
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $70f3d6a365372dbd$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $eUqFw.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $70f3d6a365372dbd$export$2e2bcd8739ae039 = $70f3d6a365372dbd$export$b549f44e7ca96280;

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("jQFcD", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $fea50252d29e77ce$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $fea50252d29e77ce$export$cc387523b0acb16d);

var $bXcc5 = parcelRequire("bXcc5");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");
const $fea50252d29e77ce$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $lmIUR.print)(jast, (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? {
        operatorCase: 'upper',
        printWidth: null
    } : undefined);
};
const $fea50252d29e77ce$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});



parcelRegister("5ujax", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $52d6130341d650ac$export$146976a1cbd99cd0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $52d6130341d650ac$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $lO4Or.ISSUE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return true;
            case 0, $lO4Or.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $lO4Or.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $lO4Or.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $lO4Or.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("auegK", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $3e371496a660187a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $3e371496a660187a$export$8254d39962ec7361);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $ctR9z = parcelRequire("ctR9z");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");


var $fD1Hq = parcelRequire("fD1Hq");

var $l1Cux = parcelRequire("l1Cux");
class $3e371496a660187a$export$a8430ed4188f35a9 extends Error {
}
const $3e371496a660187a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $eUqFw.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $3e371496a660187a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const getField = $3e371496a660187a$export$8d1d8a0d2a7917ac();
    // rank field is handled separately as it's not returned by the available fields API
    const { data: rankField } = (0, $fD1Hq.useRankField)();
    return (0, $eUqFw.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $3e371496a660187a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $l1Cux.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankField: rankField,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $33ffe55cb7bcdadc$export$145eb8935a34e85e),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        rankField,
        subscribe
    ]);
};

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') && {
                    callbackPayload: undefined
                },
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("l1Cux", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $3b44adbb66991c12$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable complexity */ 
var $6x1NF = parcelRequire("6x1NF");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $3b44adbb66991c12$var$assigneeFieldPredicate = (field)=>field.type === (0, $lO4Or.ASSIGNEE_TYPE);
const $3b44adbb66991c12$var$categoryFieldPredicate = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $3b44adbb66991c12$var$dueDateFieldPredicate = (field)=>field.type === (0, $lO4Or.DUE_DATE_TYPE);
const $3b44adbb66991c12$var$priorityFieldPredicate = (field)=>field.type === (0, $lO4Or.PRIORITY_TYPE);
const $3b44adbb66991c12$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $3b44adbb66991c12$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $3b44adbb66991c12$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $3b44adbb66991c12$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $6x1NF.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $lO4Or.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $3b44adbb66991c12$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $6x1NF.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $3b44adbb66991c12$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $lO4Or.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $3b44adbb66991c12$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $lO4Or.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $3b44adbb66991c12$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $3b44adbb66991c12$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankField && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankField.id] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("fOAem", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $96a3689a6bc73ef9$export$dfe953d11a91d407);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $jb0p7 = parcelRequire("jb0p7");
const $96a3689a6bc73ef9$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return (0, $eUqFw.useCallback)((issueKey)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage((0, $jb0p7.default).createSuccessFlagTitle, {
                issueKey: issueKey
            }),
            actions: [
                {
                    content: (0, $jb0p7.default).viewIssueLinkText,
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $hIxFu.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("hIxFu", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $b3eda05a90faeae0$export$642c6f14f6d4bbd5);
const $b3eda05a90faeae0$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("jb0p7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d4475055050609$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $82d4475055050609$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("9Y2JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43750acdd7824c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd43750acdd7824c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("frfm9", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $6b54e991d48bd90a$export$294bf5b0ba86140);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $kJlBc = parcelRequire("kJlBc");

var $auegK = parcelRequire("auegK");
const $6b54e991d48bd90a$export$294bf5b0ba86140 = ()=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const project = (0, $kQAZu.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("ib4WI", function(module, exports) {

$parcel$export(module.exports, "COLLAPSED_COLUMN_FIXED_WIDTH", () => $f265285bd2aea130$export$836c3f1e10326a68);
$parcel$export(module.exports, "COLUMN_FIXED_WIDTH", () => $f265285bd2aea130$export$fb45fce6dbb30982);
$parcel$export(module.exports, "COLUMN_HEADER_HEIGHT", () => $f265285bd2aea130$export$ad065eea37c8234b);
$parcel$export(module.exports, "GAP_BETWEEN_CARDS", () => $f265285bd2aea130$export$ef81b8582dd6e67d);
$parcel$export(module.exports, "GAP_BETWEEN_COLUMNS", () => $f265285bd2aea130$export$e4e941da6bdb3c31);
$parcel$export(module.exports, "CARD_DND_TYPE", () => $f265285bd2aea130$export$b05303cbde3e8c8c);
$parcel$export(module.exports, "COLUMN_DND_TYPE", () => $f265285bd2aea130$export$57d0ef745f304b91);
$parcel$export(module.exports, "getMissingFields", () => $f265285bd2aea130$export$34c8d98e36ee1fa9);
$parcel$export(module.exports, "getSupportedExtendedFilterTypes", () => $f265285bd2aea130$export$404aeafdb4c2feb9);
$parcel$export(module.exports, "BASE_FIELDS", () => $f265285bd2aea130$export$527474bbf19f45e4);
$parcel$export(module.exports, "BOARD_VIEW_COLUMNS_OFFSET", () => $f265285bd2aea130$export$8a3034ed3e68c427);
$parcel$export(module.exports, "MAX_ISSUE_TYPES_COUNT", () => $f265285bd2aea130$export$1778b00a1b1bdb85);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $f265285bd2aea130$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $f265285bd2aea130$export$4a2289be55388ee6);
$parcel$export(module.exports, "TRANSITION_ISSUE_EXPERIENCE", () => $f265285bd2aea130$export$9ae30868cdbc85ce);
$parcel$export(module.exports, "RANK_ISSUE_EXPERIENCE", () => $f265285bd2aea130$export$1cc6cf3582688fdd);
$parcel$export(module.exports, "UPDATE_ISSUE_GROUPED_BY_FIELD_EXPERIENCE", () => $f265285bd2aea130$export$28e35976b99ae521);
$parcel$export(module.exports, "CARD_ACTION_MOVE_TO_TOP_EXPERIENCE", () => $f265285bd2aea130$export$d04899b6f9d7af24);
$parcel$export(module.exports, "CARD_ACTION_MOVE_TO_BOTTOM_EXPERIENCE", () => $f265285bd2aea130$export$8bc834de834eeed8);
$parcel$export(module.exports, "CARD_ACTION_DELETE_EXPERIENCE", () => $f265285bd2aea130$export$647c9f579a340457);
$parcel$export(module.exports, "LOAD_EXTENDED_BOARD_DATA_EXPERIENCE", () => $f265285bd2aea130$export$a105429a905474b9);
$parcel$export(module.exports, "LOAD_SUBTASKS_EXPERIENCE", () => $f265285bd2aea130$export$96ecda7ef7336f1b);
$parcel$export(module.exports, "COLUMN_ACTION_RENAME_EXPERIENCE", () => $f265285bd2aea130$export$a2dd7e77ac9433fa);
$parcel$export(module.exports, "COLUMN_ACTION_ADD_EXPERIENCE", () => $f265285bd2aea130$export$ac8265dd2cdaac92);
$parcel$export(module.exports, "COLUMN_ACTION_DELETE_EXPERIENCE", () => $f265285bd2aea130$export$4813f2d5e485cf28);
$parcel$export(module.exports, "InvalidMove", () => $f265285bd2aea130$export$aa9c2b5ef6f32ae2);
$parcel$export(module.exports, "NULL_GROUP_KEY", () => $f265285bd2aea130$export$947ad1d92ba954ec);
$parcel$export(module.exports, "OTHER", () => $f265285bd2aea130$export$d46a05f8561f868a);
$parcel$export(module.exports, "BOARD_FIELD_TEXT", () => $f265285bd2aea130$export$69cbdb5b06ddf32d);
$parcel$export(module.exports, "BOARD_FIELD_FLOAT", () => $f265285bd2aea130$export$183b99b9ca85ddaa);
$parcel$export(module.exports, "BOARD_FIELD_USER", () => $f265285bd2aea130$export$f3e4cc1059d02f6f);
$parcel$export(module.exports, "BOARD_FIELD_MULTI_USER", () => $f265285bd2aea130$export$2c7d7c1c0024ef92);
$parcel$export(module.exports, "BOARD_FIELD_CATEGORY", () => $f265285bd2aea130$export$65fb8d4fddcb3db6);
$parcel$export(module.exports, "BOARD_FIELD_COMPONENTS", () => $f265285bd2aea130$export$c48edb33483d0062);
$parcel$export(module.exports, "BOARD_FIELD_DATE", () => $f265285bd2aea130$export$638505006ae9ba93);
$parcel$export(module.exports, "BOARD_FIELD_DATE_TIME", () => $f265285bd2aea130$export$465f5a7204a3dffc);
$parcel$export(module.exports, "BOARD_FIELD_LABEL", () => $f265285bd2aea130$export$4709bd5a74152ae7);
$parcel$export(module.exports, "BOARD_FIELD_SELECT", () => $f265285bd2aea130$export$96d1ec764b4e2f60);
$parcel$export(module.exports, "BOARD_FIELD_PARENT", () => $f265285bd2aea130$export$d2edf947f6b61359);
$parcel$export(module.exports, "BOARD_FIELD_STORY_POINTS", () => $f265285bd2aea130$export$d2eed83c3ed9ab1d);
$parcel$export(module.exports, "BOARD_FIELD_TIME_ORIGINAL_ESTIMATE", () => $f265285bd2aea130$export$66de7ee82b097a84);
$parcel$export(module.exports, "BOARD_FIELD_CONFLUENCE_PAGES_COUNT", () => $f265285bd2aea130$export$5f51001602e4f639);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_LINKS_COUNT", () => $f265285bd2aea130$export$9b9930ab0e532c29);
$parcel$export(module.exports, "BOARD_FIELD_STATUS", () => $f265285bd2aea130$export$ad56e5948f48da2c);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_TYPE", () => $f265285bd2aea130$export$928ca8ef7db2c7ce);
$parcel$export(module.exports, "BOARD_FIELD_PRIORITY", () => $f265285bd2aea130$export$eb7c8ce7565d664);
$parcel$export(module.exports, "ASSIGNEE_ID", () => $f265285bd2aea130$export$9059d5c1244fee75);
$parcel$export(module.exports, "CATEGORY_ID", () => $f265285bd2aea130$export$f7c25c2b1222ecd7);
$parcel$export(module.exports, "COMPONENT_ID", () => $f265285bd2aea130$export$723ee4d7411b97b4);
$parcel$export(module.exports, "DUE_DATE_ID", () => $f265285bd2aea130$export$876c8bd8ab9d799b);
$parcel$export(module.exports, "ISSUE_KEY_ID", () => $f265285bd2aea130$export$461d491d7fb1ef7c);
$parcel$export(module.exports, "ISSUE_TYPE_ID", () => $f265285bd2aea130$export$1612a59f1be6d6f3);
$parcel$export(module.exports, "LABEL_ID", () => $f265285bd2aea130$export$4db2521ab6aa047);
$parcel$export(module.exports, "PARENT_ID", () => $f265285bd2aea130$export$3af4d9a28905196d);
$parcel$export(module.exports, "PRIORITY_ID", () => $f265285bd2aea130$export$45ce44d95b47db60);
$parcel$export(module.exports, "RANK_ID", () => $f265285bd2aea130$export$21420526762ffb8);
$parcel$export(module.exports, "STATUS_ID", () => $f265285bd2aea130$export$fac746c9db478fd8);
$parcel$export(module.exports, "SUMMARY_ID", () => $f265285bd2aea130$export$8cadcb0dac4af55);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_DURATION", () => $f265285bd2aea130$export$58bbde0bd11b3269);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_MAX_LENGTH", () => $f265285bd2aea130$export$c9056a07d77f30a8);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $f265285bd2aea130$export$42310dd57a41067 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    collapsedStickyHeaders: 2
};
const $f265285bd2aea130$var$EMPTY_ARRAY = [];
const $f265285bd2aea130$export$8528e478b6bed7a7 = 5;
const $f265285bd2aea130$export$2229f82295383c35 = 6;
const $f265285bd2aea130$export$836c3f1e10326a68 = 40;
const $f265285bd2aea130$export$fb45fce6dbb30982 = 270;
const $f265285bd2aea130$export$ad065eea37c8234b = 48;
const $f265285bd2aea130$export$48eb2e1fcac39867 = 6;
const $f265285bd2aea130$export$ef81b8582dd6e67d = 4;
const $f265285bd2aea130$export$e4e941da6bdb3c31 = 12;
const $f265285bd2aea130$export$68cfa75d03564799 = 90;
const $f265285bd2aea130$export$b05303cbde3e8c8c = 'CARD';
const $f265285bd2aea130$export$57d0ef745f304b91 = 'COLUMN';
const $f265285bd2aea130$export$34c8d98e36ee1fa9 = (hasConfluence)=>[
        ...hasConfluence ? [
            {
                id: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
                name: 'Confluence pages',
                type: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)
            }
        ] : $f265285bd2aea130$var$EMPTY_ARRAY
    ];
const $f265285bd2aea130$export$404aeafdb4c2feb9 = ()=>[
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.REPORTER_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE)
    ];
const $f265285bd2aea130$export$527474bbf19f45e4 = [
    'key',
    'type',
    'dueDate',
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUBTASKS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE)
];
const $f265285bd2aea130$export$8a3034ed3e68c427 = {
    'jwm-board-embed': 208,
    'jwm-board': 315
};
const $f265285bd2aea130$export$1778b00a1b1bdb85 = 25;
const $f265285bd2aea130$export$9ebaf9fe814731d3 = null;
const $f265285bd2aea130$export$4a2289be55388ee6 = {
    experience: 'viewBoard',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$ed625f60643a6c30 = {
    experience: 'createIssue',
    experienceId: 'createIssue',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$9ae30868cdbc85ce = {
    experience: 'transitionIssue',
    experienceId: 'transitionIssue',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$1cc6cf3582688fdd = {
    experience: 'rankIssue',
    experienceId: 'rankIssue',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$28e35976b99ae521 = {
    experience: 'updateIssueGroupedByField',
    experienceId: 'updateIssueGroupedByField',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$d04899b6f9d7af24 = {
    experience: 'cardActionMoveToTop',
    experienceId: 'cardActionMoveToTop',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$8bc834de834eeed8 = {
    experience: 'cardActionMoveToBottom',
    experienceId: 'cardActionMoveToBottom',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$647c9f579a340457 = {
    experience: 'cardActionDelete',
    experienceId: 'cardActionDelete',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$a105429a905474b9 = {
    experience: 'loadExtendedBoardData',
    experienceId: 'loadExtendedBoardData',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$96ecda7ef7336f1b = {
    experience: 'loadSubtasks',
    experienceId: 'loadSubtasks',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$a2dd7e77ac9433fa = {
    experience: 'columnActionRename',
    experienceId: 'columnActionRename',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$ac8265dd2cdaac92 = {
    experience: 'columnActionAdd',
    experienceId: 'columnActionAdd',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f265285bd2aea130$export$4813f2d5e485cf28 = {
    experience: 'columnActionDelete',
    experienceId: 'columnActionDelete',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
class $f265285bd2aea130$export$aa9c2b5ef6f32ae2 extends Error {
}
const $f265285bd2aea130$export$947ad1d92ba954ec = 'null_pivot';
const $f265285bd2aea130$export$d46a05f8561f868a = 'other';
const $f265285bd2aea130$export$69cbdb5b06ddf32d = 'BOARD_FIELD_TEXT';
const $f265285bd2aea130$export$183b99b9ca85ddaa = 'BOARD_FIELD_FLOAT';
const $f265285bd2aea130$export$f3e4cc1059d02f6f = 'BOARD_FIELD_USER';
const $f265285bd2aea130$export$2c7d7c1c0024ef92 = 'BOARD_FIELD_MULTI_USER';
const $f265285bd2aea130$export$65fb8d4fddcb3db6 = 'BOARD_FIELD_CATEGORY';
const $f265285bd2aea130$export$c48edb33483d0062 = 'BOARD_FIELD_COMPONENTS';
const $f265285bd2aea130$export$638505006ae9ba93 = 'BOARD_FIELD_DATE';
const $f265285bd2aea130$export$465f5a7204a3dffc = 'BOARD_FIELD_DATE_TIME';
const $f265285bd2aea130$export$4709bd5a74152ae7 = 'BOARD_FIELD_LABEL';
const $f265285bd2aea130$export$96d1ec764b4e2f60 = 'BOARD_FIELD_SELECT';
const $f265285bd2aea130$export$d2edf947f6b61359 = 'BOARD_FIELD_PARENT';
const $f265285bd2aea130$export$d2eed83c3ed9ab1d = 'BOARD_FIELD_STORY_POINTS';
const $f265285bd2aea130$export$66de7ee82b097a84 = 'BOARD_FIELD_TIME_ORIGINAL_ESTIMATE';
const $f265285bd2aea130$export$5f51001602e4f639 = 'BOARD_FIELD_CONFLUENCE_PAGES_COUNT';
const $f265285bd2aea130$export$9b9930ab0e532c29 = 'BOARD_FIELD_ISSUE_LINKS_COUNT';
const $f265285bd2aea130$export$ad56e5948f48da2c = 'BOARD_FIELD_STATUS';
const $f265285bd2aea130$export$928ca8ef7db2c7ce = 'BOARD_FIELD_ISSUE_TYPE';
const $f265285bd2aea130$export$eb7c8ce7565d664 = 'BOARD_FIELD_PRIORITY';
const $f265285bd2aea130$export$9059d5c1244fee75 = (0, $lO4Or.ASSIGNEE_TYPE);
const $f265285bd2aea130$export$f7c25c2b1222ecd7 = 'category';
const $f265285bd2aea130$export$723ee4d7411b97b4 = (0, $lO4Or.COMPONENTS_TYPE);
const $f265285bd2aea130$export$876c8bd8ab9d799b = (0, $lO4Or.DUE_DATE_TYPE);
const $f265285bd2aea130$export$461d491d7fb1ef7c = (0, $lO4Or.ISSUE_KEY_TYPE);
const $f265285bd2aea130$export$1612a59f1be6d6f3 = (0, $lO4Or.ISSUE_TYPE);
const $f265285bd2aea130$export$4db2521ab6aa047 = (0, $lO4Or.LABELS_TYPE);
const $f265285bd2aea130$export$3af4d9a28905196d = (0, $lO4Or.PARENT_TYPE);
const $f265285bd2aea130$export$45ce44d95b47db60 = (0, $lO4Or.PRIORITY_TYPE);
const $f265285bd2aea130$export$21420526762ffb8 = 'rank';
const $f265285bd2aea130$export$fac746c9db478fd8 = (0, $lO4Or.STATUS_TYPE);
const $f265285bd2aea130$export$8cadcb0dac4af55 = (0, $lO4Or.SUMMARY_TYPE);
const $f265285bd2aea130$export$58bbde0bd11b3269 = 900;
const $f265285bd2aea130$export$c9056a07d77f30a8 = 65534;

});

parcelRegister("bFk6h", function(module, exports) {

$parcel$export(module.exports, "BoardDataProvider", () => $7c4b861c11ae769d$export$56f1728b5dbbcb33);
$parcel$export(module.exports, "useBoardData", () => $7c4b861c11ae769d$export$35c54b081e81928);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $499dl = parcelRequire("499dl");

var $kQAZu = parcelRequire("kQAZu");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $cOkcY = parcelRequire("cOkcY");

var $ib4WI = parcelRequire("ib4WI");

var $1rVdL = parcelRequire("1rVdL");

var $dtXTv = parcelRequire("dtXTv");

var $d1mZL = parcelRequire("d1mZL");

var $aeiY7 = parcelRequire("aeiY7");

var $lgmYa = parcelRequire("lgmYa");

var $5FsEp = parcelRequire("5FsEp");

var $iq40z = parcelRequire("iq40z");

var $7x9tw = parcelRequire("7x9tw");
const $7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID = 'FETCH_BOARD_DATA_FAILED';
const $7c4b861c11ae769d$var$getActiveWorkflow = (workflows, activeWorkflowId)=>{
    const activeWorkflow = workflows.find((workflow)=>workflow.workflowId === activeWorkflowId) ?? workflows[0];
    return activeWorkflow;
};
const $7c4b861c11ae769d$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $7c4b861c11ae769d$export$56f1728b5dbbcb33 = ({ children: children })=>{
    const { data: data, loading: isWorkflowLoading, error: error } = (0, $cOkcY.useWorkflowIssues)();
    const project = (0, $kQAZu.useProject)();
    const { workflowIssuesLastChangedTime: workflowIssuesLastChangedTime } = (0, $iq40z.useWorkflowStoreState)();
    const { setFetchResponse: setFetchResponse } = (0, $iq40z.useWorkflowStoreActions)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [activeWorkflowId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.ACTIVE_WORKFLOW_PREFERENCE));
    const { setIssues: setIssues, reset: resetIssueStore } = (0, $dtXTv.useIssueStoreActions)();
    const refetchIssuesWithThrow = (0, $5FsEp.useRefetchIssuesWithThrow)();
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const [initialized, setInitialized] = (0, $eUqFw.useState)(false);
    const fetchedFields = (0, $eUqFw.useRef)([]);
    const filterIssues = (0, $1rVdL.useFilter)();
    const { isLoading: isLoadingFilters } = (0, $1rVdL.useFilterStatus)();
    const allIssues = (0, $d1mZL.useIssues)();
    const filteredIssues = (0, $eUqFw.useMemo)(()=>{
        const withoutSubtasks = Array.from(allIssues.values()).filter((issue)=>issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.hierarchyLevel >= 0);
        const issues = filterIssues(withoutSubtasks);
        return (0, $aeiY7.sortIssuesBy)('rank', issues);
    }, [
        allIssues,
        filterIssues
    ]);
    const reset = (0, $eUqFw.useCallback)(()=>{
        resetIssueStore();
        setInitialized(false);
        fetchedFields.current = [];
    }, [
        resetIssueStore
    ]);
    const showErrorFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            id: $7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID,
            type: 'error',
            title: (0, $7x9tw.default).boardInitErrorTitle,
            description: (0, $7x9tw.default).boardInitErrorMessage
        });
    }, [
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!initialized) {
            if (data) {
                setInitialized(true);
                const activeWorkflowData = $7c4b861c11ae769d$var$getActiveWorkflow(data.workflows, activeWorkflowId);
                if (!activeWorkflowData) return;
                const mappedIssues = (0, $aeiY7.mapWorkflowIssuesToBoardIssues)(activeWorkflowData);
                setIssues(mappedIssues);
                setFetchResponse({
                    activeWorkflow: activeWorkflowData,
                    workflows: data.workflows,
                    workflowIssuesLastChangedTime: data.lastChangedTime || undefined
                });
            } else if (error) {
                setInitialized(true);
                showErrorFlag();
            }
        }
    }, [
        activeWorkflowId,
        data,
        error,
        initialized,
        setFetchResponse,
        setIssues,
        showErrorFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if there are additional fields required to be fetched, refetch the issues
        if (initialized && !isLoadingFilters && fieldIds.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(fieldIds, fetchedFields.current).length > 0) {
            fetchedFields.current = fieldIds;
            refetchIssuesWithThrow(Array.from(allIssues.keys())).catch(showErrorFlag);
        }
    }, [
        fieldIds,
        initialized,
        isLoadingFilters,
        allIssues,
        refetchIssuesWithThrow,
        showErrorFlag
    ]);
    const refetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $499dl.fetchWorkflowIssues)(project.key, workflowIssuesLastChangedTime);
            const activeWorkflowData = $7c4b861c11ae769d$var$getActiveWorkflow(response.workflows, activeWorkflowId);
            if (!activeWorkflowData) return;
            await refetchIssuesWithThrow(activeWorkflowData.issues.map((issue)=>issue.id));
            setFetchResponse({
                activeWorkflow: activeWorkflowData,
                workflows: response.workflows,
                workflowIssuesLastChangedTime: response.lastChangedTime || undefined
            });
            dismissFlag($7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (refetchError) {
            if (refetchError instanceof (0, $499dl.Unchanged)) {
                dismissFlag($7c4b861c11ae769d$var$FETCH_FAILED_FLAG_ID);
                return;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'refetchBoardData',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to refetch workflow issues data'
                },
                error: refetchError,
                sendToPrivacyUnsafeSplunk: true
            });
            showErrorFlag();
        }
    }, [
        project.key,
        workflowIssuesLastChangedTime,
        activeWorkflowId,
        refetchIssuesWithThrow,
        setFetchResponse,
        dismissFlag,
        showErrorFlag
    ]);
    // only mark as loading when the page initialises but not when applying filters thereafter
    const [loading, setLoading] = (0, $eUqFw.useState)(isWorkflowLoading || isLoadingFilters);
    (0, $eUqFw.useEffect)(()=>{
        if (loading && !isWorkflowLoading && !isLoadingFilters) setLoading(false);
    }, [
        loading,
        isWorkflowLoading,
        isLoadingFilters
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            filteredIssues: filteredIssues,
            refetch: refetch,
            reset: reset,
            loading: loading,
            error: error
        }), [
        filteredIssues,
        refetch,
        reset,
        error,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c4b861c11ae769d$var$Context.Provider, {
        value: value
    }, children);
};
const $7c4b861c11ae769d$export$35c54b081e81928 = ()=>{
    const context = (0, $eUqFw.useContext)($7c4b861c11ae769d$var$Context);
    if (!context) throw new Error('useInitializeBoard must be used within a BoardDataProvider');
    return context;
};

});
parcelRegister("1rVdL", function(module, exports) {

$parcel$export(module.exports, "useFilterFieldIds", () => $4f8aeeea5d5879e1$export$db2c52178fd751e7);
$parcel$export(module.exports, "useFilterStatus", () => $4f8aeeea5d5879e1$export$66de9151ffa1198a);
$parcel$export(module.exports, "useFilter", () => $4f8aeeea5d5879e1$export$3274cf84b703fff);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $e4qlg = parcelRequire("e4qlg");

var $fvzkg = parcelRequire("fvzkg");
var $lEWmB = parcelRequire("lEWmB");
var $9GlEj = parcelRequire("9GlEj");
var $96etS = parcelRequire("96etS");

var $d3C6e = parcelRequire("d3C6e");

var $kMmsu = parcelRequire("kMmsu");

var $gd0Sp = parcelRequire("gd0Sp");

var $ib4WI = parcelRequire("ib4WI");

var $fUxR1 = parcelRequire("fUxR1");
const $4f8aeeea5d5879e1$var$filterByExtendedFields = (issue, expandedFilters)=>expandedFilters.every((filter)=>{
        const issueField = issue.fields[filter.fieldKey];
        if (issueField == null) return filter.hasEmptyFilter;
        switch(issueField.type){
            case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                return (0, $fUxR1.filterByCategory)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_COMPONENTS:
                return (0, $fUxR1.filterByComponents)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_ISSUE_TYPE:
                return (0, $fUxR1.filterByIssueType)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_LABEL:
                return (0, $fUxR1.filterByLabels)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_PRIORITY:
                return (0, $fUxR1.filterByPriority)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_SELECT:
                return (0, $fUxR1.filterBySelect)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_STATUS:
                return (0, $fUxR1.filterByStatus)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_USER:
                return (0, $fUxR1.filterByUser)(filter, issueField);
            case 0, $ib4WI.BOARD_FIELD_MULTI_USER:
                return (0, $fUxR1.filterByMultiUser)(filter, issueField);
            default:
                return false;
        }
    });
const $4f8aeeea5d5879e1$var$filterIssues = (filters, issues, fields)=>{
    const expandedFilters = (0, $fUxR1.getExpandedFilters)(filters, fields);
    return issues.filter((issue)=>(0, $d3C6e.isOptimisticIssue)(issue.id) || $4f8aeeea5d5879e1$var$filterByExtendedFields(issue, expandedFilters));
};
const $4f8aeeea5d5879e1$var$quickFilterIssues = (quickFilters, issues, atlassianAccountId)=>{
    let results = issues;
    if (quickFilters.ASSIGNED_TO_ME && atlassianAccountId != null) results = (0, $fUxR1.isAssignedToMe)(results, atlassianAccountId);
    if (quickFilters.DUE_THIS_WEEK) results = (0, $fUxR1.isDueThisWeek)(results);
    return results;
};
const $4f8aeeea5d5879e1$var$EMPTY_FIELD_IDS = [];
const $4f8aeeea5d5879e1$export$db2c52178fd751e7 = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { filters: filters } = (0, $fvzkg.useDeserialisedFilters)();
    return (0, $eUqFw.useMemo)(()=>filters != null && fields != null ? Object.keys(filters).map((fieldKeyFromFilter)=>(0, $fUxR1.jqlTermToFieldId)(fieldKeyFromFilter, fields, categoryField)).filter(Boolean) : $4f8aeeea5d5879e1$var$EMPTY_FIELD_IDS, [
        categoryField,
        fields,
        filters
    ]);
};
const $4f8aeeea5d5879e1$export$66de9151ffa1198a = ()=>{
    const { loading: fieldsLoading } = (0, $kMmsu.useFieldsResource)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const { isLoading: isDeserializingFilters } = (0, $fvzkg.useDeserialisedFilters)();
    const isFiltering = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(jql) || quickFilters.ASSIGNED_TO_ME || quickFilters.DUE_THIS_WEEK || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(simpleSearch);
    return {
        isLoading: isFiltering && (Boolean(isDeserializingFilters) || fieldsLoading),
        isFiltering: isFiltering
    };
};
const $4f8aeeea5d5879e1$var$useMemoizedFiltersDependencies = (simpleSearch, filters, quickFilters)=>{
    const ref = (0, $eUqFw.useRef)({
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ref.current, {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    })) ref.current = {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    };
    return ref.current;
};
const $4f8aeeea5d5879e1$export$3274cf84b703fff = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const { filters: filters } = (0, $fvzkg.useDeserialisedFilters)();
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    // these dependencies are memoized with deep equality comparison because they are not stable
    const filtersDependencies = $4f8aeeea5d5879e1$var$useMemoizedFiltersDependencies(simpleSearch, filters, quickFilters);
    const filter = (0, $eUqFw.useCallback)((issues)=>{
        // we always want to filter issues with text search
        const results = (0, $fUxR1.filterIssuesByText)(issues, filtersDependencies.simpleSearch);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filtersDependencies.filters)) return $4f8aeeea5d5879e1$var$filterIssues(filtersDependencies.filters, results, fields);
        return $4f8aeeea5d5879e1$var$quickFilterIssues(filtersDependencies.quickFilters, results, atlassianAccountId);
    }, [
        filtersDependencies,
        fields,
        atlassianAccountId
    ]);
    return filter;
};

});
parcelRegister("fUxR1", function(module, exports) {

$parcel$export(module.exports, "isAssignedToMe", () => $7c8f1d8205fe2b16$export$e87389f48a5305be);
$parcel$export(module.exports, "isDueThisWeek", () => $7c8f1d8205fe2b16$export$ff3ea4cb53c4a28);
$parcel$export(module.exports, "filterIssuesByText", () => $7c8f1d8205fe2b16$export$c0fbf20bc94589ef);
$parcel$export(module.exports, "jqlTermToFieldId", () => $7c8f1d8205fe2b16$export$f8fe768269c955c0);
$parcel$export(module.exports, "getExpandedFilters", () => $7c8f1d8205fe2b16$export$eb6a39f031848a63);
$parcel$export(module.exports, "filterByCategory", () => $7c8f1d8205fe2b16$export$6d1731a321e8bdf4);
$parcel$export(module.exports, "filterByComponents", () => $7c8f1d8205fe2b16$export$3f1c0440e368606f);
$parcel$export(module.exports, "filterByIssueType", () => $7c8f1d8205fe2b16$export$f836023a765b3b9f);
$parcel$export(module.exports, "filterByLabels", () => $7c8f1d8205fe2b16$export$d226d89b96788bab);
$parcel$export(module.exports, "filterByPriority", () => $7c8f1d8205fe2b16$export$710b0eb282166a50);
$parcel$export(module.exports, "filterBySelect", () => $7c8f1d8205fe2b16$export$d8a8627f7157d954);
$parcel$export(module.exports, "filterByStatus", () => $7c8f1d8205fe2b16$export$1caf81d27b0e4d0e);
$parcel$export(module.exports, "filterByUser", () => $7c8f1d8205fe2b16$export$20a671e3b06cc1b5);
$parcel$export(module.exports, "filterByMultiUser", () => $7c8f1d8205fe2b16$export$862615c6ba36b321);

var $illlw = parcelRequire("illlw");

var $ellIm = parcelRequire("ellIm");

var $d3C6e = parcelRequire("d3C6e");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");
const $7c8f1d8205fe2b16$export$e87389f48a5305be = (issues, atlassianAccountId)=>issues.filter(({ id: id, fields: fields })=>(0, $d3C6e.isOptimisticIssue)(id) || fields[0, $ib4WI.ASSIGNEE_ID]?.user.accountId === atlassianAccountId);
const $7c8f1d8205fe2b16$export$ff3ea4cb53c4a28 = (issues)=>issues.filter((issue)=>{
        if ((0, $d3C6e.isOptimisticIssue)(issue.id)) return true;
        if (!issue.fields[0, $ib4WI.DUE_DATE_ID]) return false;
        const dueDate = new Date(issue.fields[0, $ib4WI.DUE_DATE_ID].value);
        const today = new Date();
        return (0, $ellIm.default)(dueDate, today);
    });
const $7c8f1d8205fe2b16$export$c0fbf20bc94589ef = (issues, searchText)=>{
    if (searchText != null && searchText.trim() !== '') {
        const trimmedSearchTextInLowerCase = searchText.trim().toLowerCase();
        return issues.filter(({ id: id, fields: fields })=>(0, $d3C6e.isOptimisticIssue)(id) || fields[0, $ib4WI.SUMMARY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $ib4WI.ASSIGNEE_ID]?.user.name?.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $ib4WI.ISSUE_KEY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase));
    }
    return issues;
};
const $7c8f1d8205fe2b16$export$f8fe768269c955c0 = (jqlTerm, fields, categoryField)=>{
    const field = fields.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $lO4Or.CATEGORY_TYPE)) return categoryField?.id ?? null;
    if (field?.type === (0, $lO4Or.COMPONENTS_TYPE)) return 0, $lO4Or.COMPONENTS_TYPE;
    if (field?.type === (0, $lO4Or.ISSUE_TYPE)) return 0, $lO4Or.ISSUE_TYPE;
    return jqlTerm;
};
const $7c8f1d8205fe2b16$var$jqlTermToIssueFieldKey = (jqlTerm, fields)=>{
    const field = fields?.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $lO4Or.CATEGORY_TYPE)) return 0, $ib4WI.CATEGORY_ID;
    if (field?.type === (0, $lO4Or.COMPONENTS_TYPE)) return 0, $ib4WI.COMPONENT_ID;
    return field?.type ?? jqlTerm;
};
const $7c8f1d8205fe2b16$var$getFilterValues = (filterValueForExtendedField, valueProperty)=>new Set(filterValueForExtendedField.map((filterValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValue, valueProperty, null)));
const $7c8f1d8205fe2b16$var$isSelectOption = (filterValue)=>Array.isArray(filterValue) && filterValue.length > 0 && 'value' in filterValue[0];
const $7c8f1d8205fe2b16$var$FILTER_VALUE_PROPERTY = {
    type: 'id',
    issuetype: 'id',
    priority: 'label',
    status: 'label'
};
const $7c8f1d8205fe2b16$export$eb6a39f031848a63 = (filters, fields)=>Object.entries(filters).map(([jqlTerm, filterValue])=>{
        const filterValues = $7c8f1d8205fe2b16$var$isSelectOption(filterValue) ? $7c8f1d8205fe2b16$var$getFilterValues(filterValue, $7c8f1d8205fe2b16$var$FILTER_VALUE_PROPERTY[jqlTerm] ?? 'value') : new Set();
        return {
            jqlTerm: jqlTerm,
            fieldKey: $7c8f1d8205fe2b16$var$jqlTermToIssueFieldKey(jqlTerm, fields),
            filterValues: filterValues,
            hasEmptyFilter: filterValues.has((0, $ib4WI.EMPTY_FILTER_VALUE))
        };
    });
const $7c8f1d8205fe2b16$export$6d1731a321e8bdf4 = (filter, field)=>{
    const category = field.category?.name;
    return filter.filterValues.has(category ?? '') || filter.hasEmptyFilter && !category;
};
const $7c8f1d8205fe2b16$export$3f1c0440e368606f = (filter, field)=>{
    const components = field.value;
    return Array.isArray(components) && (components.some((component)=>filter.filterValues.has(component)) || filter.hasEmptyFilter && !components.length);
};
const $7c8f1d8205fe2b16$export$f836023a765b3b9f = (filter, field)=>{
    const issueTypeId = field.issueType.id;
    return filter.filterValues.has(issueTypeId);
};
const $7c8f1d8205fe2b16$export$d226d89b96788bab = (filter, field)=>{
    const labels = field.value;
    return Array.isArray(labels) && (labels.some((label)=>filter.filterValues.has(label)) || filter.hasEmptyFilter && !labels.length);
};
const $7c8f1d8205fe2b16$export$710b0eb282166a50 = (filter, field)=>{
    const priorityName = field.priority.name;
    return filter.filterValues.has(priorityName);
};
const $7c8f1d8205fe2b16$export$d8a8627f7157d954 = (filter, field)=>{
    const selectedValues = field.value;
    return Array.isArray(selectedValues) && (selectedValues.some((selectedValue)=>filter.filterValues.has(selectedValue)) || filter.hasEmptyFilter && !selectedValues.length);
};
const $7c8f1d8205fe2b16$export$1caf81d27b0e4d0e = (filter, field)=>{
    const statusName = field.status.name;
    return filter.filterValues.has(statusName);
};
const $7c8f1d8205fe2b16$export$20a671e3b06cc1b5 = (filter, field)=>{
    const user = field.user.accountId;
    return filter.filterValues.has(user);
};
const $7c8f1d8205fe2b16$export$862615c6ba36b321 = (filter, field)=>{
    const users = field.users.map((user)=>user.accountId);
    return Array.isArray(users) && (users.some((user)=>filter.filterValues.has(user)) || filter.hasEmptyFilter && !users.length);
};

});


parcelRegister("dtXTv", function(module, exports) {

$parcel$export(module.exports, "IssueStoreContainer", () => $aa874c967cb6aed7$export$2f0bbf62c1aadb30);
$parcel$export(module.exports, "Store", () => $aa874c967cb6aed7$export$390f32400eaf98c9);
$parcel$export(module.exports, "useIssueStoreActions", () => $aa874c967cb6aed7$export$20586bb841d52702);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lskA1 = parcelRequire("lskA1");

var $ib4WI = parcelRequire("ib4WI");
const $aa874c967cb6aed7$var$initialState = {
    issues: new Map()
};
const $aa874c967cb6aed7$export$2f0bbf62c1aadb30 = (0, $heB5U.createContainer)();
const $aa874c967cb6aed7$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    containedBy: $aa874c967cb6aed7$export$2f0bbf62c1aadb30,
    initialState: $aa874c967cb6aed7$var$initialState,
    actions: {
        setIssues: (issues)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issues.forEach((issue)=>{
                    issueMap.set(issue.id, issue);
                });
                setState({
                    issues: issueMap
                });
            },
        updateIssueFields: ({ issueId: issueId, fields: fields, rank: rank })=>({ setState: setState, getState: getState })=>{
                const fieldUpdates = {
                    ...fields
                };
                const issueMap = new Map(getState().issues);
                const issue = issueMap.get(issueId);
                if (issue == null) return;
                if (rank != null) {
                    const relativeIssue = issueMap.get(rank.relativeIssueId);
                    if (relativeIssue != null) {
                        const relativeIssueRank = relativeIssue.fields[0, $ib4WI.RANK_ID].value;
                        fieldUpdates[0, $ib4WI.RANK_ID] = {
                            fieldId: (0, $ib4WI.RANK_ID),
                            type: (0, $ib4WI.BOARD_FIELD_TEXT),
                            value: rank.position === 'before' ? (0, $lskA1.getPreviousRank)(relativeIssueRank) : (0, $lskA1.getNextRank)(relativeIssueRank)
                        };
                    }
                }
                if (Object.keys(fieldUpdates).length === 0) return;
                Object.entries(fieldUpdates).forEach(([fieldId, field])=>{
                    if (field == null) {
                        delete issue.fields[fieldId];
                        return;
                    }
                    issue.fields[fieldId] = field;
                });
                issueMap.set(issueId, issue);
                setState({
                    issues: issueMap
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState($aa874c967cb6aed7$var$initialState);
            },
        removeIssues: (issueIds)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issueIds.forEach((issueId)=>{
                    issueMap.delete(issueId);
                });
                setState({
                    issues: issueMap
                });
            }
    }
});
const $aa874c967cb6aed7$export$5c02e8fb28d6ca6c = (0, $ggKAj.createStateHook)($aa874c967cb6aed7$export$390f32400eaf98c9);
const $aa874c967cb6aed7$export$20586bb841d52702 = (0, $ggKAj.createActionsHook)($aa874c967cb6aed7$export$390f32400eaf98c9);

});

parcelRegister("d1mZL", function(module, exports) {

$parcel$export(module.exports, "useIssueAssignees", () => $8b3b45f3a2264ad5$export$d3a21f46315fa5b8);
$parcel$export(module.exports, "useSubtasksByParentId", () => $8b3b45f3a2264ad5$export$48744da495950c6b);
$parcel$export(module.exports, "useIssues", () => $8b3b45f3a2264ad5$export$fdf0b908e72b6bef);

var $bj4JM = parcelRequire("bj4JM");
var $ggKAj = parcelRequire("ggKAj");

var $ib4WI = parcelRequire("ib4WI");

var $dtXTv = parcelRequire("dtXTv");
const $8b3b45f3a2264ad5$var$getAssigneesInIssues = (0, $bj4JM.createSelector)((state)=>state.issues, (issues)=>{
    const userMap = new Map();
    issues.forEach((issue)=>{
        if (issue.fields.assignee) {
            const user = issue.fields.assignee.user;
            userMap.set(user.accountId, user);
        }
    });
    return userMap;
});
const $8b3b45f3a2264ad5$export$d3a21f46315fa5b8 = (0, $ggKAj.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getAssigneesInIssues
});
const $8b3b45f3a2264ad5$var$getSubtasksByParentId = (0, $bj4JM.createSelector)((state)=>state.issues, (_, props)=>props.parentId, (issues, parentId)=>Array.from(issues.values()).filter((issue)=>issue.fields[0, $ib4WI.PARENT_ID] && String(parentId) === issue.fields[0, $ib4WI.PARENT_ID].value));
const $8b3b45f3a2264ad5$export$48744da495950c6b = (0, $ggKAj.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getSubtasksByParentId
});
const $8b3b45f3a2264ad5$var$getIssues = (0, $bj4JM.createSelector)((state)=>state.issues, (issues)=>issues);
const $8b3b45f3a2264ad5$export$fdf0b908e72b6bef = (0, $ggKAj.createStateHook)((0, $dtXTv.Store), {
    selector: $8b3b45f3a2264ad5$var$getIssues
});

});

parcelRegister("aeiY7", function(module, exports) {

$parcel$export(module.exports, "sortIssuesBy", () => $66bbee1348362b4c$export$6c4fd61382a93216);
$parcel$export(module.exports, "mapWorkflowIssuesToBoardIssues", () => $66bbee1348362b4c$export$fd35f0368f6a9a66);

var $8Qd0L = parcelRequire("8Qd0L");

var $ib4WI = parcelRequire("ib4WI");
const $66bbee1348362b4c$export$6c4fd61382a93216 = (fieldId, issues)=>{
    switch(fieldId){
        case 0, $ib4WI.RANK_ID:
            return issues.sort((a, b)=>{
                const aRank = a.fields[0, $ib4WI.RANK_ID]?.value || '';
                const bRank = b.fields[0, $ib4WI.RANK_ID]?.value || '';
                if (aRank < bRank) return -1;
                if (aRank > bRank) return 1;
                return 0;
            });
        default:
            return issues;
    }
};
const $66bbee1348362b4c$export$fd35f0368f6a9a66 = (workflow)=>{
    const statusMap = new Map(workflow.columns.map((column)=>[
            column.statusId,
            column
        ]));
    const issueTypesMap = new Map(workflow.issueTypes.map((issueType)=>[
            issueType.id,
            issueType
        ]));
    return workflow.issues.map((issue)=>{
        const status = statusMap.get(issue.statusId);
        const issueType = issueTypesMap.get(issue.issueTypeId);
        if (!status) throw new Error(`Status with id ${issue.statusId} not found`);
        if (!issueType) throw new Error(`Issue type with id ${issue.issueTypeId} not found`);
        const fields = {
            [(0, $ib4WI.RANK_ID)]: {
                fieldId: (0, $ib4WI.RANK_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.rank
            },
            [(0, $ib4WI.SUMMARY_ID)]: {
                fieldId: (0, $ib4WI.SUMMARY_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.summary
            },
            [(0, $ib4WI.ISSUE_KEY_ID)]: {
                fieldId: (0, $ib4WI.ISSUE_KEY_ID),
                type: (0, $ib4WI.BOARD_FIELD_TEXT),
                value: issue.key
            },
            [(0, $ib4WI.ISSUE_TYPE_ID)]: {
                fieldId: (0, $ib4WI.ISSUE_TYPE_ID),
                type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
                id: issueType.id,
                issueType: issueType
            },
            [(0, $ib4WI.STATUS_ID)]: {
                fieldId: (0, $ib4WI.STATUS_ID),
                type: (0, $ib4WI.BOARD_FIELD_STATUS),
                value: String(status.statusId),
                status: {
                    id: String(status.statusId),
                    name: status.name,
                    statusCategoryId: (0, $8Qd0L.StatusCategoryIds)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    status.statusCategory]
                }
            }
        };
        if (issue.assigneeKey && issue.assigneeName) {
            const assignee = workflow.people[issue.assigneeKey];
            fields[0, $ib4WI.ASSIGNEE_ID] = {
                fieldId: (0, $ib4WI.ASSIGNEE_ID),
                type: (0, $ib4WI.BOARD_FIELD_USER),
                value: assignee.key,
                user: {
                    accountId: assignee.key,
                    name: assignee.displayName,
                    avatarURL: assignee.avatarUrl
                }
            };
        }
        if (issue.priorityId && issue.priorityIconUrl && issue.priorityName) fields[0, $ib4WI.PRIORITY_ID] = {
            fieldId: (0, $ib4WI.PRIORITY_ID),
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            value: issue.priorityId,
            priority: {
                iconUrl: issue.priorityIconUrl,
                id: issue.priorityId,
                name: issue.priorityName
            }
        };
        if (issue.dueDate) fields[0, $ib4WI.DUE_DATE_ID] = {
            fieldId: (0, $ib4WI.DUE_DATE_ID),
            type: (0, $ib4WI.BOARD_FIELD_DATE),
            value: issue.dueDate
        };
        return {
            id: issue.id,
            coverMedia: null,
            fields: fields,
            subtaskMetadata: issue.subtaskMetadata
        };
    });
};

});

parcelRegister("lgmYa", function(module, exports) {

$parcel$export(module.exports, "useFieldIds", () => $d6c8b23ffeae272a$export$a8f1976671d75184);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $1rVdL = parcelRequire("1rVdL");

var $bZapc = parcelRequire("bZapc");
const $d6c8b23ffeae272a$var$SYSTEM_FIELDS = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.ISSUE_KEY_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $jGcn0.RANK_ALIAS_FIELD_ID),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
];
const $d6c8b23ffeae272a$export$a8f1976671d75184 = ()=>{
    // use the raw grouping view preference instead of the group-by
    // helpers because it contains the category field id (oh god why)
    const [groupByFieldId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const filteredFieldIds = (0, $1rVdL.useFilterFieldIds)();
    return (0, $eUqFw.useMemo)(()=>{
        const fieldIds = new Set($d6c8b23ffeae272a$var$SYSTEM_FIELDS);
        if (groupByFieldId) fieldIds.add(groupByFieldId);
        for (const fieldId of filteredFieldIds)fieldIds.add(fieldId);
        for (const fieldId of Object.keys(selectedFields))fieldIds.add(fieldId);
        // The formatting of the timeoriginalestimate relies on the timetrackingsettings field within timetracking: FUN 1015
        if (fieldIds.has((0, $lO4Or.TIME_ESTIMATE_TYPE))) fieldIds.add((0, $lO4Or.TIME_TRACKING_TYPE));
        return Array.from(fieldIds);
    }, [
        filteredFieldIds,
        groupByFieldId,
        selectedFields
    ]);
};

});
parcelRegister("bZapc", function(module, exports) {

$parcel$export(module.exports, "useFieldsPreference", () => $bf795410a1a30a08$export$46ce869a6df40a8b);
$parcel$export(module.exports, "useSelectedFields", () => $bf795410a1a30a08$export$eb999826034c8235);
$parcel$export(module.exports, "useCardFieldsOld", () => $bf795410a1a30a08$export$7e71bea34214ee32);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");
const $bf795410a1a30a08$export$1671dbe17e3a0329 = new Set([
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    'key',
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUBTASKS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $jGcn0.CARD_COVERS_TYPE)
]);
const $bf795410a1a30a08$var$INITIAL_CARD_FIELDS_IDS_OLD = new Set([
    ...$bf795410a1a30a08$export$1671dbe17e3a0329,
    (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)
]);
const $bf795410a1a30a08$export$46ce869a6df40a8b = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const [fieldPreferences, setFieldPreferences] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const fieldIds = (0, $eUqFw.useMemo)(()=>{
        const defaultValue = (0, $1ybV0.ff)('jwm.board-awesome-enhancements') ? $bf795410a1a30a08$export$1671dbe17e3a0329 : $bf795410a1a30a08$var$INITIAL_CARD_FIELDS_IDS_OLD;
        if (fieldPreferences == null || !Array.isArray(fieldPreferences)) return defaultValue;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return new Set(fieldPreferences);
    }, [
        fieldPreferences
    ]);
    const setFieldIds = (0, $eUqFw.useCallback)((value)=>setFieldPreferences(Array.from(value)), [
        setFieldPreferences
    ]);
    return [
        fieldIds,
        setFieldIds
    ];
};
const $bf795410a1a30a08$export$eb999826034c8235 = ()=>{
    const [fieldIds] = $bf795410a1a30a08$export$46ce869a6df40a8b();
    return (0, $eUqFw.useMemo)(()=>{
        const selectedFields = {};
        fieldIds.forEach((fieldId)=>{
            selectedFields[fieldId] = true;
        });
        return selectedFields;
    }, [
        fieldIds
    ]);
};
const $bf795410a1a30a08$export$7e71bea34214ee32 = (issueTypeId)=>{
    const selectedFields = $bf795410a1a30a08$export$eb999826034c8235();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    return (0, $eUqFw.useMemo)(()=>{
        const matchedTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType?.id === issueTypeId) || {
            fields: []
        };
        // "key" and "subtasks" are compulsory fields in the cards but not in project settings
        const fieldIdsFromSettings = [
            'key',
            (0, $lO4Or.SUBTASKS_TYPE),
            ...matchedTypeWithFields?.fields.map((field)=>field.id)
        ];
        Object.keys(selectedFields).forEach((fieldId)=>{
            if (fieldIdsFromSettings.includes(fieldId)) selectedFields[fieldId] = true;
            else selectedFields[fieldId] = false;
        });
        return selectedFields;
    }, [
        selectedFields,
        issueTypeId,
        typesWithFields
    ]);
};

});


parcelRegister("5FsEp", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssues", () => $eac02ab7fa0ac8a0$export$8b0ce7bde93e400a);
$parcel$export(module.exports, "useRefetchIssuesWithThrow", () => $eac02ab7fa0ac8a0$export$207597c4678856ab);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $3MOum = parcelRequire("3MOum");

var $dtXTv = parcelRequire("dtXTv");
const $eac02ab7fa0ac8a0$export$8b0ce7bde93e400a = ()=>{
    const refetchIssuesWithThrow = $eac02ab7fa0ac8a0$export$207597c4678856ab();
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        try {
            return await refetchIssuesWithThrow(issueIds);
        } catch (error) {
            // do nothing
            return [];
        }
    }, [
        refetchIssuesWithThrow
    ]);
};
const $eac02ab7fa0ac8a0$export$207597c4678856ab = ()=>{
    const fetchIssueDetails = (0, $3MOum.useFetchIssueDetails)();
    const { setIssues: setIssues, removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        const issues = await fetchIssueDetails(issueIds);
        setIssues(issues);
        const fetchedIssueIds = issues.map((issue)=>issue.id);
        const removedIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issueIds, fetchedIssueIds);
        if (removedIssueIds.length > 0) removeIssues(removedIssueIds);
        return issues;
    }, [
        fetchIssueDetails,
        setIssues,
        removeIssues
    ]);
};

});
parcelRegister("3MOum", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueDetails", () => $af3cdd1dc206d65a$export$2e8364353306e0d3);

var $eUqFw = parcelRequire("eUqFw");

var $aYAw7 = parcelRequire("aYAw7");

var $4G5xU = parcelRequire("4G5xU");

var $ib4WI = parcelRequire("ib4WI");

var $c7RGv = parcelRequire("c7RGv");

var $1j5vW = parcelRequire("1j5vW");

var $lgmYa = parcelRequire("lgmYa");
const $af3cdd1dc206d65a$var$CHUNK_SIZE = 100;
const $af3cdd1dc206d65a$export$2e8364353306e0d3 = ()=>{
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const fetchIssues = (0, $c7RGv.useFetchBoardIssues)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    return (0, $eUqFw.useCallback)(async (issueIds)=>{
        if (!fieldIds.length) return [];
        startExperience();
        try {
            const chunks = (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(issueIds, $af3cdd1dc206d65a$var$CHUNK_SIZE);
            const results = await Promise.all(chunks.map((chunkIssueIds)=>fetchIssues({
                    jql: `id in (${chunkIssueIds.join(',')})`,
                    fieldIds: fieldIds
                })));
            markExperienceSuccess();
            return results.reduce((acc, result)=>acc.concat(transformToIssues(result)), []);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            markExperienceFailed('Failed to load issue details', error);
            throw error;
        }
    }, [
        fetchIssues,
        fieldIds,
        markExperienceFailed,
        markExperienceSuccess,
        startExperience,
        transformToIssues
    ]);
};

});
parcelRegister("c7RGv", function(module, exports) {

$parcel$export(module.exports, "useFetchBoardIssues", () => $324309ca8ae6b1f1$export$26780ba8d679f5d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $053h2 = parcelRequire("053h2");

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $iwwE5 = parcelRequire("iwwE5");
const $324309ca8ae6b1f1$var$ITEMS_PER_PAGE = 100;
const $324309ca8ae6b1f1$export$26780ba8d679f5d = ()=>{
    const client = (0, $iZuDo.useApolloClient)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    return (0, $eUqFw.useCallback)(async ({ jql: jql, fieldIds: fieldIdsInput })=>{
        const fieldIds = new Set(fieldIdsInput);
        const withChildrenCount = fieldIds.has((0, $lO4Or.SUBTASKS_TYPE));
        fieldIds.delete((0, $lO4Or.SUBTASKS_TYPE));
        const withConfluenceLinks = hasConfluence && fieldIds.has((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
        fieldIds.delete((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
        const withIssueLinks = (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation') && fieldIds.has((0, $lO4Or.ISSUE_LINKS_TYPE));
        fieldIds.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIds.has((0, $jGcn0.CARD_COVERS_TYPE));
        fieldIds.delete((0, $jGcn0.CARD_COVERS_TYPE));
        const variables = {
            fieldIds: Array.from(fieldIds),
            first: $324309ca8ae6b1f1$var$ITEMS_PER_PAGE,
            jql: jql,
            withConfluenceLinks: withConfluenceLinks,
            withCoverMedia: withCoverMedia,
            cloudId: cloudId,
            withIssueLinks: withIssueLinks,
            withChildrenCount: withChildrenCount,
            withExtendedIssue: true
        };
        const response = await client.query({
            query: (0, $iwwE5.JIS2_JWMBoardItemsQuery),
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
            variables: variables
        });
        if (!response) throw new Error('No issue response');
        if (response.errors) {
            const apolloError = new (0, $jlBDe.ApolloError)({
                graphQLErrors: response.errors
            });
            if ((0, $053h2.shouldHandleTheError)(apolloError)) throw apolloError;
        }
        const responseData = response.data.jira?.jwmViewItems;
        if (responseData?.__typename === 'JiraWorkManagementViewItemConnection' && responseData.edges != null) return responseData.edges.map((edge)=>edge?.node).filter((node)=>node != null);
        throw new Error('Invalid issue response');
    }, [
        client,
        cloudId,
        hasConfluence
    ]);
};

});
parcelRegister("053h2", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $26bb3a81152c05d0$export$47770c8b6d645cdb);

var $1ybV0 = parcelRequire("1ybV0");
const $26bb3a81152c05d0$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE'
];
const $26bb3a81152c05d0$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        if ((0, $1ybV0.ff)('jwm.timeline.ignore-field-unavailable-errors')) {
            const isWhitelisted = $26bb3a81152c05d0$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
            return !isWhitelisted;
        }
        return graphQLError?.extensions?.errorType !== 'EXPERIENCE_UNAVAILABLE';
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};

});

parcelRegister("iwwE5", function(module, exports) {

$parcel$export(module.exports, "JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT", () => $fc4bffa3fcd81f30$export$9ed9a1cb8188c743);
$parcel$export(module.exports, "JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT", () => $fc4bffa3fcd81f30$export$cb794cef9d65b633);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT", () => $fc4bffa3fcd81f30$export$832c0260442bf18d);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_FRAGMENT", () => $fc4bffa3fcd81f30$export$8a4c8763de723c1b);
$parcel$export(module.exports, "JIS2_JWMBoardItemsQuery", () => $fc4bffa3fcd81f30$export$aeea67f0727d06fb);

var $9ypom = parcelRequire("9ypom");
const $fc4bffa3fcd81f30$export$9ed9a1cb8188c743 = (0, $9ypom.default)`
fragment JIS2_JWMBoardConfluenceLinksFragment on JiraWorkManagementViewItem {
  legacyConfluenceLinks (getFirstOnly: true) {
    linkedConfluencePages {
      pageCount
    }
  }
}
`;
const $fc4bffa3fcd81f30$export$cb794cef9d65b633 = (0, $9ypom.default)`
fragment JIS2_JWMBoardIssueLinksFragment on JiraWorkManagementViewItem {
  issueLinks(first: 10) {
    edges {
      node {
        issue {
          issueId
        }
      }
    }
  }
}
`;
const $fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT = (0, $9ypom.default)`
fragment JIS2_JWMBoardAccountFragment on AtlassianAccountUser {
  accountId
  name
  picture
}
`;
const $fc4bffa3fcd81f30$var$JIS2_JWMBOARD_USER_FRAGMENT = (0, $9ypom.default)`
fragment JIS2_JWMBoardUserFragment on JiraUserConnection {
  edges {
    node {
      ...JIS2_JWMBoardAccountFragment
    }
  }
}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
`;
const $fc4bffa3fcd81f30$export$832c0260442bf18d = (0, $9ypom.default)`
fragment JIS2_JWMBoardItemCoverMediaFragment on JiraWorkManagementViewItem {
  coverMedia {
    ... on JiraWorkManagementColorBackground {
      entityId
      colorValue
    }
    ... on JiraWorkManagementGradientBackground {
      entityId
      gradientValue
    }
    ... on JiraWorkManagementAttachmentBackground {
        entityId
        attachment {
            attachmentId
            mediaReadToken(durationInSeconds: 900, maxTokenLength: 65534)
            fileName
            mediaApiFileId
            __typename
            # Helpful for determining the source of the attachment, such as Unsplash so that we can attribute the source
            ... on JiraPlatformAttachment {
                sourceType: attachmentProperty(key: "sourceType")
                sourceIdentifier: attachmentProperty(key: "sourceIdentifier")
            }
        }
    }
  }
}`;
const $fc4bffa3fcd81f30$export$8a4c8763de723c1b = (0, $9ypom.default)`
fragment JIS2_JWMBoardItemFragment on JiraWorkManagementViewItem {
  id
  issueId
  fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) {
    __typename
    fieldId
    name
    ... on JiraSingleLineTextField {
      text
      type @include(if: $withExtendedIssue)
    }
    ... on JiraLabelsField {
      selectedLabelsConnection {
        edges {
          node {
            name,
          }
        }
      }
    }
    ... on JiraSingleSelectUserPickerField {
      user {
        ... JIS2_JWMBoardAccountFragment
      }
    }
    ... on JiraDatePickerField {
      date
    }
    ... on JiraDateTimePickerField {
      dateTime
    }
    ... on JiraComponentsField {
      selectedComponentsConnection {
        edges {
          node {
            name
          }
        }
      }
    }
    ... on JiraOriginalTimeEstimateField {
      originalEstimate {
        timeInSeconds
      }
    }
    ... on JiraSingleSelectField {
      type
      fieldOption {
        optionId
        value
        color {
          colorKey
        }
      }
    }
    ... on JiraMultipleSelectField {
      selectedOptions {
        edges {
          node {
            value
          }
        }
      }
    }
    ... on JiraNumberField {
      number
    }
    ... on JiraMultipleSelectUserPickerField {
      selectedUsersConnection {
        ...JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraPeopleField {
      selectedUsersConnection {
        ... JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraEpicLinkField @skip(if: $withExtendedIssue) {
      epic {
        issueId
        key
        name
        color
      }
    }
    ... on JiraTimeTrackingField {
      originalEstimate {
        timeInSeconds
      }
      timeTrackingSettings {
        defaultUnit
        defaultFormat
        workingHoursPerDay
        workingDaysPerWeek
      }
    }
    ... on JiraStatusField {
      status {
        name
        statusId
        statusCategory {
          statusCategoryId
        }
      }
    }
    ... on JiraIssueTypeField {
      issueType {
        issueTypeId
        name
        avatar {
          medium
        }
        hierarchy @include(if: $withExtendedIssue) {
          level
        }
      }
    }
    ... on JiraPriorityField {
      priority {
        iconUrl
        name
        priorityId
      }
    }
    ... on JiraParentIssueField @include(if: $withExtendedIssue) {
      parentIssue {
        issueId
      }
    }
  },
  childrenTotal: childSummary(includeDone:true) @include(if: $withChildrenCount) {
    totalCount,
  }
  childrenNotDone: childSummary(includeDone:false) @include(if: $withChildrenCount) {
    totalCount,
  }
}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
${$fc4bffa3fcd81f30$var$JIS2_JWMBOARD_USER_FRAGMENT}
`;
const $fc4bffa3fcd81f30$export$aeea67f0727d06fb = (0, $9ypom.default)`
query JIS2JWMBoardItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!, $withExtendedIssue: Boolean!) {
  jira {
    jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first, after: $after) @connection (key: "boardJIS", filter:["jql"]) {
      __typename
      ... on QueryError {
          message
          extensions {
              statusCode
              errorType
          }
      }
      ... on JiraWorkManagementViewItemConnection {
        edges {
          node {
            ...JIS2_JWMBoardItemFragment
            ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
          }
        }
      }
    }
  }
}
${$fc4bffa3fcd81f30$export$8a4c8763de723c1b}
${$fc4bffa3fcd81f30$export$9ed9a1cb8188c743}
${$fc4bffa3fcd81f30$export$832c0260442bf18d}
${$fc4bffa3fcd81f30$export$cb794cef9d65b633}
`;

});


parcelRegister("1j5vW", function(module, exports) {

$parcel$export(module.exports, "transformCoverMedia", () => $93c688f39458612f$export$2c47b714cdbd1e2a);
$parcel$export(module.exports, "useTransformIssues", () => $93c688f39458612f$export$3746553fffc661a3);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $h9cCP = parcelRequire("h9cCP");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $7v0hO = parcelRequire("7v0hO");

var $ib4WI = parcelRequire("ib4WI");

var $cThpl = parcelRequire("cThpl");
const $93c688f39458612f$var$transformers = {
    [(0, $lO4Or.TEXT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.TEXT_GQL_FIELD) || field.text == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TEXT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.text
        };
    },
    [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.COMPONENTS_GQL_FIELD)) return null;
        const value = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_COMPONENTS),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.LABEL_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.LABEL_GQL_FIELD) || field.selectedLabelsConnection == null) return null;
        const value = field.selectedLabelsConnection.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_LABEL),
            fieldId: field.fieldId,
            value: value
        };
    },
    [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (field, timeTrackingConfig, intl)=>{
        if (field.__typename !== (0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD) || field.originalEstimate?.timeInSeconds == null) return null;
        if (!timeTrackingConfig || !intl) // if timeTrackingConfig is not available, return the original estimate in seconds
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.originalEstimate.timeInSeconds
        };
        const { workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultFormat: timeFormat, defaultUnit: defaultUnit } = timeTrackingConfig;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: (0, $7v0hO.timeTrackingFormatter)(field.originalEstimate.timeInSeconds, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                timeFormat: timeFormat.toLowerCase() ?? (0, $h9cCP.PRETTY),
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_PICKER_GQL_FIELD) || field.date == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.date
        };
    },
    [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) || field.fieldOption?.value == null) return null;
        if (field.__typename === (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) && field.type === (0, $lO4Or.CATEGORY_TYPE) && field.fieldOption?.value != null) return {
            fieldId: field.fieldId,
            name: field.name,
            type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
            value: field.fieldOption.optionId,
            category: {
                name: field.fieldOption.value,
                color: field.fieldOption.color?.colorKey ?? null
            }
        };
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: [
                field.fieldOption.value
            ]
        };
    },
    [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_TIME_GQL_FIELD) || field.dateTime == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE_TIME),
            fieldId: field.fieldId,
            name: field.name,
            value: field.dateTime
        };
    },
    [(0, $lO4Or.NUMBER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.NUMBER_GQL_FIELD) || field.number == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_FLOAT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.number
        };
    },
    [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.USER_PICKER_GQL_FIELD) || field.user == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            value: field.user.accountId,
            user: {
                accountId: field.user.accountId,
                name: field.user.name,
                avatarURL: field.user.picture
            }
        };
    },
    [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_SELECT_GQL_FIELD)) return null;
        const value = field.selectedOptions?.edges?.map((edge)=>edge?.node).map((node)=>node?.value).filter(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        (optionValue)=>optionValue != null);
        if (value == null || value.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PEOPLE_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.PARENT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PARENT_GQL_FIELD) || field.parentIssue == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PARENT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.parentIssue.issueId
        };
    },
    [(0, $lO4Or.STATUS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.STATUS_GQL_FIELD) || field.status.name == null || field.status.statusCategory?.statusCategoryId == null || field.status.statusId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_STATUS),
            fieldId: field.fieldId,
            name: field.name,
            value: field.status.statusId,
            status: {
                id: field.status.statusId,
                name: field.status.name,
                statusCategoryId: Number(field.status.statusCategory.statusCategoryId)
            }
        };
    },
    [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || field.issueType?.issueTypeId == null || field.issueType.name == null || field.issueType.hierarchy?.level == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
            fieldId: field.fieldId,
            name: field.name,
            id: field.issueType.issueTypeId,
            issueType: {
                id: field.issueType.issueTypeId,
                name: field.issueType.name,
                iconUrl: field.issueType.avatar?.medium ?? '',
                hierarchyLevel: field.issueType.hierarchy.level
            }
        };
    },
    [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PRIORITY_GQL_FIELD) || field.priority?.iconUrl == null || field.priority?.name == null || field.priority?.priorityId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            fieldId: field.fieldId,
            name: field.name,
            value: field.priority.priorityId,
            priority: {
                iconUrl: field.priority.iconUrl,
                id: field.priority.priorityId,
                name: field.priority.name
            }
        };
    }
};
const $93c688f39458612f$var$transformField = (field, timeTrackingConfig, intl)=>{
    if (field == null) return null;
    if (field.__typename in $93c688f39458612f$var$transformers) return $93c688f39458612f$var$transformers[field.__typename](field, timeTrackingConfig, intl);
    return null;
};
const $93c688f39458612f$var$extractTimeTrackingConfig = (issueDetail)=>{
    const timetracking = issueDetail.fieldsByIdOrAlias?.find((field)=>field?.__typename === (0, $lO4Or.TIME_TRACKING_GQL_FIELD));
    if (timetracking && 'timeTrackingSettings' in timetracking && timetracking.timeTrackingSettings?.workingHoursPerDay != null && timetracking.timeTrackingSettings?.workingDaysPerWeek != null && timetracking.timeTrackingSettings?.defaultUnit != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return timetracking.timeTrackingSettings;
    return null;
};
const $93c688f39458612f$export$2c47b714cdbd1e2a = (coverMedia)=>{
    if (!coverMedia) return null;
    if (coverMedia.__typename === 'JiraWorkManagementColorBackground') {
        if (coverMedia.colorValue == null) return null;
        return {
            type: 'color',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.colorValue
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementGradientBackground') {
        if (coverMedia.gradientValue == null) return null;
        return {
            type: 'gradient',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.gradientValue
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementAttachmentBackground') {
        const { fileName: fileName, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken } = coverMedia.attachment ?? {};
        if (fileName == null || mediaApiFileId == null || mediaReadToken == null) return null;
        let unsplashId = null;
        const unsplashAttachment = coverMedia.attachment?.__typename === 'JiraPlatformAttachment' ? coverMedia.attachment : null;
        if (unsplashAttachment?.sourceType === 'UNSPLASH' && unsplashAttachment?.sourceIdentifier != null) unsplashId = unsplashAttachment.sourceIdentifier;
        return {
            type: 'image',
            fileName: fileName,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            unsplashId: unsplashId
        };
    }
    return null;
};
const $93c688f39458612f$export$3746553fffc661a3 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useCallback)((issueDetails)=>{
        const transformedIssues = [];
        issueDetails.forEach((issueDetail)=>{
            if (!issueDetail.fieldsByIdOrAlias) return;
            const newIssue = {
                id: issueDetail.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                fields: {},
                coverMedia: $93c688f39458612f$export$2c47b714cdbd1e2a(issueDetail.coverMedia),
                subtaskMetadata: (0, $cThpl.getSubtaskMetadata)(issueDetail.childrenTotal?.totalCount, issueDetail.childrenNotDone?.totalCount)
            };
            const timeTrackingConfig = $93c688f39458612f$var$extractTimeTrackingConfig(issueDetail);
            issueDetail.fieldsByIdOrAlias?.forEach((field)=>{
                const transformedField = $93c688f39458612f$var$transformField(field, timeTrackingConfig, {
                    formatMessage: formatMessage
                });
                if (transformedField == null) return;
                switch(transformedField.type){
                    case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                        newIssue.fields[0, $ib4WI.CATEGORY_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_LABEL:
                        newIssue.fields[0, $ib4WI.LABEL_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_PARENT:
                        newIssue.fields[0, $ib4WI.PARENT_ID] = transformedField;
                        break;
                    case 0, $ib4WI.BOARD_FIELD_TEXT:
                        if (field && field.__typename === (0, $lO4Or.TEXT_GQL_FIELD) && field.type === (0, $lO4Or.RANK_CF_TYPE)) {
                            newIssue.fields[0, $ib4WI.RANK_ID] = transformedField;
                            break;
                        }
                        newIssue.fields[transformedField.fieldId] = transformedField;
                        break;
                    default:
                        newIssue.fields[transformedField.fieldId] = transformedField;
                }
            });
            if (issueDetail.legacyConfluenceLinks?.linkedConfluencePages?.pageCount != null) newIssue.fields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE] = {
                type: (0, $ib4WI.BOARD_FIELD_CONFLUENCE_PAGES_COUNT),
                fieldId: 'remoteIssueLinks',
                value: issueDetail.legacyConfluenceLinks.linkedConfluencePages.pageCount
            };
            if ((0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation')) {
                if (issueDetail.issueLinks?.edges) newIssue.fields[0, $lO4Or.ISSUE_LINKS_TYPE] = {
                    type: (0, $ib4WI.BOARD_FIELD_ISSUE_LINKS_COUNT),
                    fieldId: (0, $lO4Or.ISSUE_LINKS_TYPE),
                    value: issueDetail.issueLinks.edges.filter(Boolean).length ?? 0
                };
            }
            transformedIssues.push(newIssue);
        });
        return transformedIssues;
    }, [
        formatMessage
    ]);
};

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units)=>{
    const timeForZero = `0${units[3].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units)=>{
    const timeForZero = `0${units[7].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (unit?.isSingular) {
            if (currentTimeValue === 1) return {
                secondsRemaining: timeObj.secondsRemaining % unit.seconds,
                time: `${timeObj.time} ${currentTimeValue}${unit.suffix}`
            };
            return timeObj;
        }
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitWeek),
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitDay),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitHour),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitMinute),
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[1].seconds : 0, units[1].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekSingular)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekPlural)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDaySingular)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDayPlural)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourPlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinuteSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinutePlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR) * workingHoursPerDay) return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[3].seconds : 0, units[3].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR)) return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[4].seconds : 0, units[4].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[5].seconds : 0, units[5].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeekPlural: {
        "id": "time-tracking-formatter.time-unit-long-week-plural",
        "defaultMessage": "weeks"
    },
    timeUnitLongDayPlural: {
        "id": "time-tracking-formatter.time-unit-long-day-plural",
        "defaultMessage": "days"
    },
    timeUnitLongHourPlural: {
        "id": "time-tracking-formatter.time-unit-long-hour-plural",
        "defaultMessage": "hours"
    },
    timeUnitLongMinutePlural: {
        "id": "time-tracking-formatter.time-unit-long-minute-plural",
        "defaultMessage": "minutes"
    },
    timeUnitLongWeekSingular: {
        "id": "time-tracking-formatter.time-unit-long-week-singular",
        "defaultMessage": "week"
    },
    timeUnitLongDaySingular: {
        "id": "time-tracking-formatter.time-unit-long-day-singular",
        "defaultMessage": "day"
    },
    timeUnitLongHourSingular: {
        "id": "time-tracking-formatter.time-unit-long-hour-singular",
        "defaultMessage": "hour"
    },
    timeUnitLongMinuteSingular: {
        "id": "time-tracking-formatter.time-unit-long-minute-singular",
        "defaultMessage": "minute"
    }
});

});


parcelRegister("cThpl", function(module, exports) {

$parcel$export(module.exports, "getSubtaskMetadata", () => $6fbed3cf6493d53d$export$9af279b6109e0217);
const $6fbed3cf6493d53d$export$9af279b6109e0217 = (totalCount, totalNotDoneCount)=>{
    if (totalCount == null || totalNotDoneCount == null) return {
        total: 0,
        done: 0
    };
    return {
        total: totalCount,
        done: totalCount - totalNotDoneCount
    };
};

});




parcelRegister("iq40z", function(module, exports) {

$parcel$export(module.exports, "WorkflowStoreContainer", () => $6deadcee45e6e201$export$704db246c3ac6062);
$parcel$export(module.exports, "useWorkflowStoreState", () => $6deadcee45e6e201$export$28d1a95bd5ffa117);
$parcel$export(module.exports, "useWorkflowStoreActions", () => $6deadcee45e6e201$export$d932477502b964cb);
$parcel$export(module.exports, "useInitialTransition", () => $6deadcee45e6e201$export$1c96719c98024183);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");
const $6deadcee45e6e201$var$initialState = {
    columns: [],
    issueTypes: [],
    transitions: [],
    workflows: [],
    workflowId: null,
    workflowName: null
};
const $6deadcee45e6e201$var$removeColumn = (statusId)=>({ setState: setState, getState: getState })=>{
        const { columns: columns, workflows: workflows } = getState();
        const newColumns = columns.filter((c)=>c.statusId !== statusId);
        setState({
            columns: [
                ...newColumns
            ],
            workflows: workflows.map((wf)=>{
                const newWfColumns = wf.columns.filter((c)=>c.statusId !== statusId);
                return {
                    ...wf,
                    columns: [
                        ...newWfColumns
                    ]
                };
            })
        });
    };
const $6deadcee45e6e201$var$setColumns = (columns)=>({ setState: setState, getState: getState })=>{
        const { workflowId: workflowId, workflows: workflows } = getState();
        setState({
            columns: columns,
            workflows: workflows.map((workflow)=>workflow.workflowId === workflowId ? {
                    ...workflow,
                    columns: columns
                } : workflow)
        });
    };
const $6deadcee45e6e201$var$setFetchResponse = ({ workflows: workflows, activeWorkflow: activeWorkflow, workflowIssuesLastChangedTime: workflowIssuesLastChangedTime })=>async ({ setState: setState })=>{
        setState({
            columns: activeWorkflow.columns,
            issueTypes: activeWorkflow.issueTypes,
            transitions: activeWorkflow.transitions,
            workflows: workflows,
            workflowId: activeWorkflow.workflowId,
            workflowIssuesLastChangedTime: workflowIssuesLastChangedTime,
            workflowName: activeWorkflow.workflowName
        });
    };
const $6deadcee45e6e201$var$actions = {
    removeColumn: $6deadcee45e6e201$var$removeColumn,
    setColumns: $6deadcee45e6e201$var$setColumns,
    setFetchResponse: $6deadcee45e6e201$var$setFetchResponse
};
const $6deadcee45e6e201$export$704db246c3ac6062 = (0, $heB5U.createContainer)();
const $6deadcee45e6e201$var$WorkflowStore = (0, $a61MH.createStore)({
    initialState: $6deadcee45e6e201$var$initialState,
    actions: $6deadcee45e6e201$var$actions,
    name: 'WorkflowStore',
    containedBy: $6deadcee45e6e201$export$704db246c3ac6062
});
const $6deadcee45e6e201$var$getInitialTransition = (0, $bj4JM.createSelector)((state)=>state.transitions, (transitions)=>transitions.find((transition)=>transition.isInitial));
const $6deadcee45e6e201$export$28d1a95bd5ffa117 = (0, $ggKAj.createStateHook)($6deadcee45e6e201$var$WorkflowStore);
const $6deadcee45e6e201$export$d932477502b964cb = (0, $ggKAj.createActionsHook)($6deadcee45e6e201$var$WorkflowStore);
const $6deadcee45e6e201$export$1c96719c98024183 = (0, $ggKAj.createStateHook)($6deadcee45e6e201$var$WorkflowStore, {
    selector: $6deadcee45e6e201$var$getInitialTransition
});

});

parcelRegister("7x9tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebadd2525659871f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ebadd2525659871f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardInitErrorTitle: {
        "id": "work-management-board.controllers.board-data.board-init-error-title",
        "defaultMessage": "Failed to load the board"
    },
    boardInitErrorMessage: {
        "id": "work-management-board.controllers.board-data.board-init-error-message",
        "defaultMessage": "We couldn't load your board, try refreshing the page or try again later."
    }
});

});


parcelRegister("iLiDV", function(module, exports) {

$parcel$export(module.exports, "ConfettiColumnsProvider", () => $bdd596b34dcec0e4$export$a2ded958dc3b3a);
$parcel$export(module.exports, "useConfettiColumns", () => $bdd596b34dcec0e4$export$d2d8be1cdd91d59f);
$parcel$export(module.exports, "useAddConfettiColumn", () => $bdd596b34dcec0e4$export$5f36accfd50e20fd);
$parcel$export(module.exports, "matchConfettiColumn", () => $bdd596b34dcec0e4$export$44c2e17e7d7d4d24);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lnmSR = parcelRequire("lnmSR");
const $bdd596b34dcec0e4$var$COLUMN_CONFETTI_NAMES = [
    "\uD83C\uDF8A",
    "\uD83C\uDF89",
    "\uD83C\uDF86",
    "\uD83C\uDF87",
    "\u2728"
];
const $bdd596b34dcec0e4$var$actions = {
    addConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.add(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        },
    removeConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.delete(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        }
};
const $bdd596b34dcec0e4$export$a2ded958dc3b3a = (0, $heB5U.createContainer)();
const $bdd596b34dcec0e4$var$store = (0, $a61MH.createStore)({
    name: 'JWMConfettiColumnsStore',
    containedBy: $bdd596b34dcec0e4$export$a2ded958dc3b3a,
    initialState: {
        confettiColumns: new Set()
    },
    actions: $bdd596b34dcec0e4$var$actions
});
const $bdd596b34dcec0e4$var$useConfettiColumnsStore = (0, $ggKAj.createHook)($bdd596b34dcec0e4$var$store);
const $bdd596b34dcec0e4$var$useConfettiColumnsActions = (0, $ggKAj.createActionsHook)($bdd596b34dcec0e4$var$store);
const $bdd596b34dcec0e4$export$d2d8be1cdd91d59f = ()=>{
    const [{ confettiColumns: confettiColumns }, { removeConfettiColumn: removeConfettiColumn }] = $bdd596b34dcec0e4$var$useConfettiColumnsStore();
    return {
        confettiColumns: confettiColumns,
        removeConfettiColumn: removeConfettiColumn
    };
};
const $bdd596b34dcec0e4$export$5f36accfd50e20fd = ()=>{
    const collapsedColumnIds = (0, $lnmSR.useCollapsedColumnIds)();
    const { addConfettiColumn: addConfettiColumn } = $bdd596b34dcec0e4$var$useConfettiColumnsActions();
    const addConfettiColumnWithCheck = (columnId)=>{
        if (!collapsedColumnIds.includes(columnId)) addConfettiColumn(columnId);
    };
    return addConfettiColumnWithCheck;
};
const $bdd596b34dcec0e4$export$44c2e17e7d7d4d24 = (str)=>$bdd596b34dcec0e4$var$COLUMN_CONFETTI_NAMES.some((emoji)=>str.includes(emoji));

});
parcelRegister("lnmSR", function(module, exports) {

$parcel$export(module.exports, "useCollapsedColumnIds", () => $b1fee01dd111e5cd$export$fdfb8ac54a686d2f);
$parcel$export(module.exports, "useExpandCollapse", () => $b1fee01dd111e5cd$export$9b6687336a4cef1c);
$parcel$export(module.exports, "useExpandCollapseAllColumns", () => $b1fee01dd111e5cd$export$bc447e7b85c60666);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $iXHUp = parcelRequire("iXHUp");

var $gKXju = parcelRequire("gKXju");
const $b1fee01dd111e5cd$var$emptyColumnKeys = {
    [(0, $jGcn0.GROUP_BY_STATUS)]: [],
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: [],
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: [],
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: []
};
const $b1fee01dd111e5cd$export$fdfb8ac54a686d2f = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const collapsedColumns = (0, $eUqFw.useMemo)(()=>{
        if (collapsedColumnsByGroupBy && typeof collapsedColumnsByGroupBy === 'object') {
            const collapsedKeys = collapsedColumnsByGroupBy[groupBy];
            if (Array.isArray(collapsedKeys)) return collapsedKeys;
        }
        return [];
    }, [
        collapsedColumnsByGroupBy,
        groupBy
    ]);
    return collapsedColumns;
};
const $b1fee01dd111e5cd$export$9b6687336a4cef1c = (groupId)=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy, updateCollapsedColumns] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const collapsedColumns = $b1fee01dd111e5cd$export$fdfb8ac54a686d2f();
    const isCollapsed = (0, $eUqFw.useMemo)(()=>collapsedColumns.includes(groupId), [
        collapsedColumns,
        groupId
    ]);
    const toggleCollapse = (0, $eUqFw.useCallback)(()=>{
        let newCollapsedKeys = [];
        if (isCollapsed) // Remove ID to expand column
        newCollapsedKeys = collapsedColumns.filter((collapsedColumnKey)=>groupId !== collapsedColumnKey);
        else // Add ID to collapse column
        newCollapsedKeys = [
            ...collapsedColumns,
            groupId
        ];
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: newCollapsedKeys
        });
    }, [
        collapsedColumns,
        collapsedColumnsByGroupBy,
        groupBy,
        groupId,
        isCollapsed,
        updateCollapsedColumns
    ]);
    return {
        isCollapsed: isCollapsed,
        toggleCollapse: toggleCollapse
    };
};
const $b1fee01dd111e5cd$export$bc447e7b85c60666 = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [collapsedColumnsByGroupBy, updateCollapsedColumns] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const groupColumns = (0, $gKXju.useGroups)();
    const collapseAllColumns = (0, $eUqFw.useCallback)(()=>{
        const columnKeys = groupColumns.map((column)=>column.id ?? '');
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: columnKeys
        });
    }, [
        groupBy,
        groupColumns,
        collapsedColumnsByGroupBy,
        updateCollapsedColumns
    ]);
    const expandAllColumns = (0, $eUqFw.useCallback)(()=>{
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $b1fee01dd111e5cd$var$emptyColumnKeys,
            [groupBy]: []
        });
    }, [
        collapsedColumnsByGroupBy,
        groupBy,
        updateCollapsedColumns
    ]);
    return {
        collapseAllColumns: collapseAllColumns,
        expandAllColumns: expandAllColumns
    };
};

});
parcelRegister("iXHUp", function(module, exports) {

$parcel$export(module.exports, "useGroupBy", () => $31d26bc9b6a9f109$export$c4ec754551fa3ff4);
$parcel$export(module.exports, "useGroupByField", () => $31d26bc9b6a9f109$export$1897bb3806cdf8b6);
$parcel$export(module.exports, "useGroupByOptions", () => $31d26bc9b6a9f109$export$b3c181458faa8480);
$parcel$export(module.exports, "useGroupByFieldOld", () => $31d26bc9b6a9f109$export$81c26e7276b9ddf3);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");
const $31d26bc9b6a9f109$var$DEFAULT_GROUP_BY = (0, $jGcn0.GROUP_BY_STATUS);
const $31d26bc9b6a9f109$var$getGroupByValue = (groupByPreference)=>{
    if (groupByPreference === (0, $jGcn0.GROUP_BY_STATUS)) return 0, $jGcn0.GROUP_BY_STATUS;
    if (groupByPreference === (0, $jGcn0.GROUP_BY_ASSIGNEE)) return 0, $jGcn0.GROUP_BY_ASSIGNEE;
    if (groupByPreference === (0, $jGcn0.GROUP_BY_PRIORITY)) return 0, $jGcn0.GROUP_BY_PRIORITY;
    if (groupByPreference?.includes('customfield')) return 0, $jGcn0.GROUP_BY_CATEGORY;
    return $31d26bc9b6a9f109$var$DEFAULT_GROUP_BY;
};
const $31d26bc9b6a9f109$export$c4ec754551fa3ff4 = ()=>{
    const [groupByPreference, setGroupByPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    const setGroupBy = (0, $eUqFw.useCallback)((value)=>{
        // Set the default type value to undefined so we don't show query param for the default value
        if (value === (0, $jGcn0.GROUP_BY_STATUS)) setGroupByPreference(undefined);
        else setGroupByPreference(value);
    }, [
        setGroupByPreference
    ]);
    return [
        $31d26bc9b6a9f109$var$getGroupByValue(groupByPreference),
        setGroupBy
    ];
};
const $31d26bc9b6a9f109$export$1897bb3806cdf8b6 = ()=>{
    const [groupByPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    return $31d26bc9b6a9f109$var$getGroupByValue(groupByPreference);
};
const $31d26bc9b6a9f109$export$b3c181458faa8480 = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    return (0, $eUqFw.useMemo)(()=>{
        const options = new Set([
            (0, $jGcn0.GROUP_BY_STATUS)
        ]);
        // if we don't have the issue types data yet, return all options
        if (!typesWithFields.length) {
            options.add((0, $jGcn0.GROUP_BY_ASSIGNEE));
            options.add((0, $jGcn0.GROUP_BY_PRIORITY));
            options.add((0, $jGcn0.GROUP_BY_CATEGORY));
            return options;
        }
        typesWithFields.forEach((type)=>{
            // do not consider subtasks type
            if (type.issueType.hierarchyLevel < 0) return;
            type.fields.forEach((field)=>{
                if (field.type === (0, $jGcn0.GROUP_BY_ASSIGNEE) || field.type === (0, $jGcn0.GROUP_BY_PRIORITY)) options.add(field.type);
                else if (field.type === (0, $lO4Or.CATEGORY_TYPE)) options.add((0, $jGcn0.GROUP_BY_CATEGORY));
            });
        });
        return options;
    }, [
        typesWithFields
    ]);
};
const $31d26bc9b6a9f109$export$81c26e7276b9ddf3 = ()=>{
    const [groupBy] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    return groupBy;
};

});

parcelRegister("gKXju", function(module, exports) {

$parcel$export(module.exports, "GroupsProvider", () => $91ff6e8e07e8b83f$export$c4c2327ef89cf163);
$parcel$export(module.exports, "useGroups", () => $91ff6e8e07e8b83f$export$55065ab2491a4a0c);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $iXHUp = parcelRequire("iXHUp");

var $9QB5c = parcelRequire("9QB5c");
const $91ff6e8e07e8b83f$var$GroupsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $91ff6e8e07e8b83f$var$AssigneeGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useAssigneeGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$CategoryGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useCategoryGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$PriorityGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.usePriorityGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$var$StatusGroupsSetter = ({ onGroupsChange: onGroupsChange })=>{
    const groups = (0, $9QB5c.useStatusGroups)();
    (0, $eUqFw.useEffect)(()=>{
        onGroupsChange(groups);
    }, [
        groups,
        onGroupsChange
    ]);
    return null;
};
const $91ff6e8e07e8b83f$export$c4c2327ef89cf163 = ({ children: children })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [groups, setGroups] = (0, $eUqFw.useState)([]);
    let GroupSetter;
    switch(groupBy){
        case 0, $jGcn0.GROUP_BY_ASSIGNEE:
            GroupSetter = $91ff6e8e07e8b83f$var$AssigneeGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_CATEGORY:
            GroupSetter = $91ff6e8e07e8b83f$var$CategoryGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_PRIORITY:
            GroupSetter = $91ff6e8e07e8b83f$var$PriorityGroupsSetter;
            break;
        case 0, $jGcn0.GROUP_BY_STATUS:
            GroupSetter = $91ff6e8e07e8b83f$var$StatusGroupsSetter;
            break;
        default:
            {
                const exhaustiveCheck = groupBy;
                throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91ff6e8e07e8b83f$var$GroupsContext.Provider, {
        value: groups
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupSetter, {
        onGroupsChange: setGroups
    }));
};
const $91ff6e8e07e8b83f$export$55065ab2491a4a0c = ()=>{
    const context = (0, $eUqFw.useContext)($91ff6e8e07e8b83f$var$GroupsContext);
    if (!context) throw new Error('useGroups must be used within a GroupsProvider');
    return context;
};

});
parcelRegister("9QB5c", function(module, exports) {

$parcel$export(module.exports, "useAssigneeGroups", () => $9c82db01a350fd0e$export$ecac68cd9ce8682c);
$parcel$export(module.exports, "useCategoryGroups", () => $9c82db01a350fd0e$export$2b65473e959d1be7);
$parcel$export(module.exports, "usePriorityGroups", () => $9c82db01a350fd0e$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useStatusGroups", () => $9c82db01a350fd0e$export$de3bb934718a3348);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $d1mZL = parcelRequire("d1mZL");

var $2XClh = parcelRequire("2XClh");

var $iq40z = parcelRequire("iq40z");
const $9c82db01a350fd0e$var$getPriorityOptions = (fields)=>{
    const priorityField = fields.find((field)=>field.type === (0, $lO4Or.PRIORITY_TYPE));
    return priorityField?.fieldConfig?.options ?? [];
};
const $9c82db01a350fd0e$var$getCategoryOptions = (fields)=>{
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE));
    return categoryField?.fieldConfig?.selectOptions ?? [];
};
const $9c82db01a350fd0e$export$ecac68cd9ce8682c = ()=>{
    const users = (0, $d1mZL.useIssueAssignees)();
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = [
            {
                id: (0, $ib4WI.NULL_GROUP_KEY),
                imageUrl: null,
                name: '',
                type: (0, $jGcn0.GROUP_BY_ASSIGNEE)
            }
        ];
        users?.forEach(({ accountId: accountId, name: name, avatarURL: avatarURL })=>{
            groups.push({
                id: accountId,
                imageUrl: avatarURL,
                name: name,
                type: (0, $jGcn0.GROUP_BY_ASSIGNEE)
            });
        });
        return sortGroups(groups);
    }, [
        sortGroups,
        users
    ]);
};
const $9c82db01a350fd0e$export$2b65473e959d1be7 = ()=>{
    const { data: { fields: fields } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = [
            {
                color: null,
                id: (0, $ib4WI.NULL_GROUP_KEY),
                name: '',
                type: (0, $jGcn0.GROUP_BY_CATEGORY)
            }
        ];
        const categoryOptions = $9c82db01a350fd0e$var$getCategoryOptions(fields);
        categoryOptions.forEach(({ label: label, color: color, optionId: optionId })=>{
            if (optionId) groups.push({
                color: color ?? null,
                id: String(optionId),
                name: label,
                type: (0, $jGcn0.GROUP_BY_CATEGORY)
            });
        });
        return sortGroups(groups);
    }, [
        fields,
        sortGroups
    ]);
};
const $9c82db01a350fd0e$export$9ad7fd5c13dc6dbb = ()=>{
    const { data: { fields: fields } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        const priorityOptions = $9c82db01a350fd0e$var$getPriorityOptions(fields);
        const groups = priorityOptions.map(({ name: name, priorityId: priorityId, iconUrl: iconUrl })=>({
                id: priorityId,
                imageUrl: iconUrl,
                name: name,
                type: (0, $jGcn0.GROUP_BY_PRIORITY)
            }));
        return sortGroups(groups);
    }, [
        fields,
        sortGroups
    ]);
};
const $9c82db01a350fd0e$export$de3bb934718a3348 = ()=>{
    const { columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    return (0, $eUqFw.useMemo)(()=>{
        const groups = columns.map(({ name: name, statusId: statusId, statusCategory: statusCategory })=>({
                id: String(statusId),
                name: name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                statusCategoryId: (0, $8Qd0L.StatusCategoryIds)[statusCategory],
                type: (0, $jGcn0.GROUP_BY_STATUS)
            }));
        return groups;
    }, [
        columns
    ]);
};

});
parcelRegister("2XClh", function(module, exports) {

$parcel$export(module.exports, "useGroupsOrder", () => $d6c7bc83d6e84e98$export$b952fbf263ab4b98);
$parcel$export(module.exports, "useSortGroups", () => $d6c7bc83d6e84e98$export$41ac6817d8a83a93);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $ib4WI = parcelRequire("ib4WI");

var $iXHUp = parcelRequire("iXHUp");
const $d6c7bc83d6e84e98$export$b952fbf263ab4b98 = ()=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [orderedGroupsByGroupBy, setGroupsOrderPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLUMNS_ORDER_PREFERENCE));
    const setGroupOrder = (0, $eUqFw.useCallback)((newGroupsOrderKeys)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setGroupsOrderPreference({
            ...orderedGroupsByGroupBy,
            [groupBy]: newGroupsOrderKeys
        });
    }, [
        groupBy,
        orderedGroupsByGroupBy,
        setGroupsOrderPreference
    ]);
    const orderedGroupIds = (0, $eUqFw.useMemo)(()=>orderedGroupsByGroupBy?.[groupBy] ?? null, [
        orderedGroupsByGroupBy,
        groupBy
    ]);
    return [
        orderedGroupIds,
        setGroupOrder
    ];
};
const $d6c7bc83d6e84e98$export$41ac6817d8a83a93 = ()=>{
    const [orderedGroupsKeys] = $d6c7bc83d6e84e98$export$b952fbf263ab4b98();
    const groupBy = (0, $iXHUp.useGroupByField)();
    return (0, $eUqFw.useCallback)((groups)=>{
        const indexInOrder = (groupId, order)=>{
            const index = order.indexOf(groupId);
            return index >= 0 ? index : groups.length;
        };
        if (orderedGroupsKeys == null) {
            if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY)) // Priority groups are already sorted based on the order in the field configuration
            return groups;
            return groups.sort((groupA, groupB)=>{
                if (groupA.id === (0, $ib4WI.NULL_GROUP_KEY)) return -1;
                if (groupB.id === (0, $ib4WI.NULL_GROUP_KEY)) return 1;
                // Sort fields alphabetically
                return groupA.name.localeCompare(groupB.name);
            });
        }
        return groups.sort((groupA, groupB)=>indexInOrder(groupA.id, orderedGroupsKeys) - indexInOrder(groupB.id, orderedGroupsKeys));
    }, [
        groupBy,
        orderedGroupsKeys
    ]);
};

});





parcelRegister("3jaqr", function(module, exports) {

$parcel$export(module.exports, "ConfettiColumnsContainer", () => $95c1b46c082f1516$export$31deec5431468626);
$parcel$export(module.exports, "useConfettiColumns", () => $95c1b46c082f1516$export$d2d8be1cdd91d59f);
$parcel$export(module.exports, "useConfettiColumnActions", () => $95c1b46c082f1516$export$1d500deaab0137a8);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $95c1b46c082f1516$var$actions = {
    addConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.add(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        },
    removeConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.delete(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        }
};
const $95c1b46c082f1516$export$31deec5431468626 = (0, $heB5U.createContainer)();
const $95c1b46c082f1516$var$store = (0, $a61MH.createStore)({
    containedBy: $95c1b46c082f1516$export$31deec5431468626,
    initialState: {
        confettiColumns: new Set()
    },
    actions: $95c1b46c082f1516$var$actions,
    name: 'JWMConfettiColumnsStore'
});
const $95c1b46c082f1516$export$d2d8be1cdd91d59f = (0, $ggKAj.createHook)($95c1b46c082f1516$var$store);
const $95c1b46c082f1516$export$1d500deaab0137a8 = (0, $ggKAj.createActionsHook)($95c1b46c082f1516$var$store);

});

parcelRegister("gWYTK", function(module, exports) {

$parcel$export(module.exports, "CardDragDropProvider", () => $c2ce2edab203bb3e$export$b1ccb12106075e69);
$parcel$export(module.exports, "useStartCardDrag", () => $c2ce2edab203bb3e$export$c489958ad236599c);
$parcel$export(module.exports, "useCancelConfirmCardDrop", () => $c2ce2edab203bb3e$export$124d43f574a408ec);
$parcel$export(module.exports, "useUpdateDropTarget", () => $c2ce2edab203bb3e$export$fd80b4a210addcaa);
$parcel$export(module.exports, "useResetDropTarget", () => $c2ce2edab203bb3e$export$886c7f1b5e5013b3);
$parcel$export(module.exports, "useHighlightedIssue", () => $c2ce2edab203bb3e$export$daf5b1f2d290b352);
$parcel$export(module.exports, "useCardDragDrop", () => $c2ce2edab203bb3e$export$51dcb5ebefb8c3d7);
$parcel$export(module.exports, "useCanDropCard", () => $c2ce2edab203bb3e$export$6075fd3ad3110a90);
$parcel$export(module.exports, "useInferredDropTargetTransition", () => $c2ce2edab203bb3e$export$79dfb0dde692631b);
$parcel$export(module.exports, "useUpdateSessionId", () => $c2ce2edab203bb3e$export$c6e81f4ae8465e96);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $ay4XV = parcelRequire("ay4XV");

var $d4s3F = parcelRequire("d4s3F");
const $c2ce2edab203bb3e$var$emptyDropTarget = {
    groupId: null,
    transition: null
};
const $c2ce2edab203bb3e$var$reducer = (state, action)=>{
    switch(action.type){
        case 'startDrag':
            return {
                ...state,
                ...action.value
            };
        case 'cancelDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
                updateSessionId: null
            };
        case 'confirmDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
                updateSessionId: null,
                highlightedIssueId: state.draggedIssue?.id ?? null
            };
        case 'updateDropTarget':
            return {
                ...state,
                dropTarget: {
                    ...state.dropTarget,
                    ...action.value
                }
            };
        case 'resetDropTarget':
            return {
                ...state,
                dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget
            };
        case 'resetHighlightedIssue':
            return {
                ...state,
                highlightedIssueId: null
            };
        default:
            return state;
    }
};
const $c2ce2edab203bb3e$var$initialState = {
    draggedIssue: null,
    sourceGroup: null,
    dropTarget: $c2ce2edab203bb3e$var$emptyDropTarget,
    updateSessionId: null,
    highlightedIssueId: null
};
const $c2ce2edab203bb3e$var$CardDragDropContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $c2ce2edab203bb3e$export$b1ccb12106075e69 = ({ children: children })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($c2ce2edab203bb3e$var$reducer, $c2ce2edab203bb3e$var$initialState);
    const value = (0, $eUqFw.useMemo)(()=>({
            ...state,
            dispatch: dispatch
        }), [
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c2ce2edab203bb3e$var$CardDragDropContext.Provider, {
        value: value
    }, children);
};
const $c2ce2edab203bb3e$var$useCardDragDropContext = ()=>{
    const context = (0, $eUqFw.useContext)($c2ce2edab203bb3e$var$CardDragDropContext);
    if (!context) throw new Error('useCardDragDropContext must be used within a CardDragDropProvider');
    return context;
};
const $c2ce2edab203bb3e$export$c489958ad236599c = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { fetch: fetchIssueTransitions } = (0, $ay4XV.useIssueTransitions)();
    const { fireStartCardDragAnalytics: fireStartCardDragAnalytics } = (0, $d4s3F.useCardDragDropAnalytics)();
    return (0, $eUqFw.useCallback)((issue, group)=>{
        const updateSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        dispatch({
            type: 'startDrag',
            value: {
                draggedIssue: issue,
                sourceGroup: group,
                updateSessionId: updateSessionId
            }
        });
        fireStartCardDragAnalytics(updateSessionId);
        if (group.type === (0, $jGcn0.GROUP_BY_STATUS)) fetchIssueTransitions(issue);
    }, [
        dispatch,
        fetchIssueTransitions,
        fireStartCardDragAnalytics
    ]);
};
const $c2ce2edab203bb3e$export$124d43f574a408ec = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const cancelCardDrop = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'cancelDrop'
        }), [
        dispatch
    ]);
    const confirmCardDrop = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'confirmDrop'
        }), [
        dispatch
    ]);
    return {
        cancelCardDrop: cancelCardDrop,
        confirmCardDrop: confirmCardDrop
    };
};
const $c2ce2edab203bb3e$export$fd80b4a210addcaa = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return (0, $eUqFw.useCallback)((newDropTarget)=>dispatch({
            type: 'updateDropTarget',
            value: newDropTarget
        }), [
        dispatch
    ]);
};
const $c2ce2edab203bb3e$export$886c7f1b5e5013b3 = ()=>{
    const { dispatch: dispatch } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'resetDropTarget'
        }), [
        dispatch
    ]);
};
const $c2ce2edab203bb3e$export$daf5b1f2d290b352 = ()=>{
    const { dispatch: dispatch, highlightedIssueId: highlightedIssueId } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const resetHighlightedIssue = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'resetHighlightedIssue'
        }), [
        dispatch
    ]);
    return {
        highlightedIssueId: highlightedIssueId,
        resetHighlightedIssue: resetHighlightedIssue
    };
};
const $c2ce2edab203bb3e$export$51dcb5ebefb8c3d7 = ()=>$c2ce2edab203bb3e$var$useCardDragDropContext();
const $c2ce2edab203bb3e$var$GROUP_TYPE_TO_FIELD_TYPE = {
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: (0, $lO4Or.ASSIGNEE_TYPE),
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: (0, $lO4Or.CATEGORY_TYPE),
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: (0, $lO4Or.PRIORITY_TYPE)
};
const $c2ce2edab203bb3e$export$6075fd3ad3110a90 = (group)=>{
    const project = (0, $kQAZu.useProject)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)();
    const { sourceGroup: sourceGroup, draggedIssue: draggedIssue, dropTarget: dropTarget } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { transitions: transitions, loading: loading, hasError: hasError } = (0, $ay4XV.useIssueTransitions)();
    const canRank = project.permissions.scheduleIssues;
    const isSameGroup = sourceGroup?.id === group.id;
    const areTransitionsUnavailable = loading || hasError;
    if (!draggedIssue) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    if (group.type !== (0, $jGcn0.GROUP_BY_STATUS)) {
        let canDropInGroup = 'unknown';
        if (!isSameGroup) {
            // check if the field is available for the dragged issue's issue type
            const fieldType = $c2ce2edab203bb3e$var$GROUP_TYPE_TO_FIELD_TYPE[group.type];
            const issueType = typesWithFields.find((type)=>type.issueType.id === draggedIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.id);
            const hasField = issueType?.fields.some((field)=>field.type === fieldType);
            canDropInGroup = hasField ? 'yes' : 'no';
        }
        return {
            canDropInGroup: canDropInGroup,
            canDropAgainstCard: canRank && canDropInGroup !== 'no' ? 'yes' : 'no'
        };
    }
    if (isSameGroup && areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: canRank ? 'yes' : 'no'
    };
    if (areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    const transitionsToGroup = transitions.filter((transition)=>String(transition.toStatusId) === group.id);
    let canDropInGroup = 'no';
    let canDropAgainstCard = canRank ? 'yes' : 'no';
    if (isSameGroup) {
        const selfTransitions = transitionsToGroup.filter((t)=>!t.isGlobal);
        canDropInGroup = selfTransitions.length > 0 ? 'choice-available' : 'unknown';
        if (dropTarget.transition != null) canDropInGroup = 'yes';
    } else if (transitionsToGroup.length === 0) canDropAgainstCard = 'no';
    else if (transitionsToGroup.length === 1) canDropInGroup = 'yes';
    else if (transitionsToGroup.length > 1) {
        canDropInGroup = dropTarget.transition == null ? 'choice-required' : 'yes';
        canDropAgainstCard = canRank && canDropInGroup === 'yes' ? 'yes' : 'no';
    }
    return {
        canDropInGroup: canDropInGroup,
        canDropAgainstCard: canDropAgainstCard
    };
};
const $c2ce2edab203bb3e$export$79dfb0dde692631b = (group)=>{
    const { sourceGroup: sourceGroup } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const destinationGroupId = group.id;
    if (sourceGroup?.type !== (0, $jGcn0.GROUP_BY_STATUS) || sourceGroup.id === destinationGroupId || transitions.length === 0) return null;
    const transitionsToDestinationGroup = transitions.filter((transition)=>String(transition.toStatusId) === destinationGroupId);
    return transitionsToDestinationGroup.length === 1 ? transitionsToDestinationGroup[0] : null;
};
const $c2ce2edab203bb3e$export$c6e81f4ae8465e96 = ()=>{
    const { updateSessionId: updateSessionId } = $c2ce2edab203bb3e$var$useCardDragDropContext();
    return updateSessionId;
};

});
parcelRegister("ay4XV", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionsProvider", () => $9e2e3a7403c9b4ae$export$504c5361b0788bb);
$parcel$export(module.exports, "useIssueTransitions", () => $9e2e3a7403c9b4ae$export$4868b6fb356ee1e7);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $7EhAs = parcelRequire("7EhAs");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $99zuh = parcelRequire("99zuh");

var $iq40z = parcelRequire("iq40z");

var $grmpM = parcelRequire("grmpM");
const $9e2e3a7403c9b4ae$var$IssueTransitionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $9e2e3a7403c9b4ae$var$initialState = {
    hasError: false,
    loading: false,
    transitions: []
};
const $9e2e3a7403c9b4ae$var$reducer = (state, action)=>{
    switch(action.type){
        case 'fetch':
            return {
                ...state,
                hasError: false,
                loading: true,
                transitions: []
            };
        case 'success':
            return {
                ...state,
                hasError: false,
                loading: false,
                transitions: action.value
            };
        case 'error':
            return {
                ...state,
                hasError: true,
                loading: false,
                transitions: []
            };
        default:
            return state;
    }
};
const $9e2e3a7403c9b4ae$export$504c5361b0788bb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { transitions: workflowTransitions } = (0, $iq40z.useWorkflowStoreState)();
    const [{ loading: loading, hasError: hasError, transitions: transitions }, dispatch] = (0, $eUqFw.useReducer)($9e2e3a7403c9b4ae$var$reducer, $9e2e3a7403c9b4ae$var$initialState);
    const abortableFetchIssueTransitions = (0, $NFHn0.useAbortable)((0, $99zuh.fetchIssueTransitions));
    const fetch = (0, $eUqFw.useCallback)(async (issue)=>{
        // check if any of the relevant workflow transitions are conditional
        const fromStatusId = Number(issue.fields[0, $ib4WI.STATUS_ID].status.id);
        const eligibleTransitions = workflowTransitions.filter((transition)=>transition.fromStatusId === fromStatusId || transition.isGlobal);
        // if none of the eligible transitions are conditional, then we do not need to fetch
        // the transitions from the server
        if (eligibleTransitions.every((transition)=>!transition.isConditional)) {
            dispatch({
                type: 'success',
                value: eligibleTransitions
            });
            return;
        }
        try {
            dispatch({
                type: 'fetch'
            });
            const response = await abortableFetchIssueTransitions(issue.id);
            dispatch({
                type: 'success',
                value: response
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
            if (error instanceof (0, $7EhAs.default) && error.statusCode === 404) {
                showFlag({
                    description: formatMessage((0, $grmpM.default).notFoundErrorMessage),
                    title: formatMessage((0, $grmpM.default).notFoundErrorTitle),
                    type: 'error'
                });
                return;
            }
            showFlag({
                description: formatMessage((0, $grmpM.default).errorMessage),
                title: formatMessage((0, $grmpM.default).errorTitle),
                type: 'error'
            });
        }
    }, [
        abortableFetchIssueTransitions,
        formatMessage,
        showFlag,
        workflowTransitions
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            fetch: fetch,
            hasError: hasError,
            loading: loading,
            transitions: transitions
        }), [
        fetch,
        hasError,
        loading,
        transitions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e2e3a7403c9b4ae$var$IssueTransitionsContext.Provider, {
        value: value
    }, children);
};
const $9e2e3a7403c9b4ae$export$4868b6fb356ee1e7 = ()=>{
    const context = (0, $eUqFw.useContext)($9e2e3a7403c9b4ae$var$IssueTransitionsContext);
    if (!context) throw new Error('useIssueTransitions must be used within a IssueTransitionsProvider');
    return context;
};

});
parcelRegister("99zuh", function(module, exports) {

$parcel$export(module.exports, "fetchIssueTransitions", () => $1d427dc2c26eea30$export$abb47d81cfdbea9e);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");
const $1d427dc2c26eea30$export$abb47d81cfdbea9e = async (signal, issueId)=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`/rest/api/3/issue/${issueId}/transitions`, {
            signal: signal
        });
        return response.transitions.map((transition)=>({
                transitionId: Number(transition.id),
                name: transition.name,
                isConditional: transition.isConditional,
                isGlobal: transition.isGlobal,
                isInitial: transition.isInitial,
                hasScreen: transition.hasScreen,
                toStatusId: Number(transition.to.id)
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'fetchIssueTransitions',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});

parcelRegister("grmpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d49a2a6b3a2014$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4d49a2a6b3a2014$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-transitions.error-title",
        "defaultMessage": "We couldn't load transitions"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-transitions.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    notFoundErrorTitle: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title",
        "defaultMessage": "Issue not found"
    },
    notFoundErrorMessage: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message",
        "defaultMessage": "Looks like this issue has been removed. Refresh the page, then try again."
    }
});

});


parcelRegister("d4s3F", function(module, exports) {

$parcel$export(module.exports, "useCardDragDropAnalytics", () => $8a4ff52153cb8c04$export$bf7082aa7f5f928b);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $3bukT = parcelRequire("3bukT");

var $8Qd0L = parcelRequire("8Qd0L");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");
const $8a4ff52153cb8c04$export$bf7082aa7f5f928b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const project = (0, $kQAZu.useProject)();
    const fireStartCardDragAnalytics = (0, $eUqFw.useCallback)((sessionId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'item'
        });
        const analyticsAttributes = {
            isDragEditing: true,
            updateSessionId: sessionId
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issue', analyticsAttributes);
    }, [
        createAnalyticsEvent
    ]);
    const fireCardDropAnalytics = (0, $eUqFw.useCallback)(({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, updateSessionId: updateSessionId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'update',
            actionSubject: 'issue'
        });
        const analyticsAttributes = $8a4ff52153cb8c04$var$getAnalyticsAttributes({
            issue: issue,
            sourceGroup: sourceGroup,
            destinationGroup: destinationGroup,
            rank: rank,
            transition: transition,
            project: project,
            updateSessionId: updateSessionId
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issue update', 'ended', analyticsAttributes);
    }, [
        createAnalyticsEvent,
        project
    ]);
    return {
        fireStartCardDragAnalytics: fireStartCardDragAnalytics,
        fireCardDropAnalytics: fireCardDropAnalytics
    };
};
const $8a4ff52153cb8c04$var$getAnalyticsAttributes = ({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, project: project, updateSessionId: updateSessionId })=>{
    const sourceGroupId = sourceGroup.id;
    const destinationGroupId = destinationGroup.id;
    const sourceGroupType = sourceGroup.type;
    const destinationGroupType = destinationGroup.type;
    const issueTypeName = issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.name;
    const attributes = {
        assigneeId: issue.fields[0, $ib4WI.ASSIGNEE_ID]?.user?.accountId ?? '',
        fieldType: destinationGroupType,
        fieldKey: destinationGroupType,
        oldValId: sourceGroupId !== (0, $ib4WI.NULL_GROUP_KEY) ? sourceGroupId : '',
        newValId: destinationGroupId !== (0, $ib4WI.NULL_GROUP_KEY) ? destinationGroupId : '',
        isClassic: !project.isSimplified,
        isDragEditing: true,
        isInlineEditing: false,
        hasRankChanged: rank != null,
        isProjectAdmin: project.permissions.administerProject,
        issueId: issue.id,
        issueType: (0, $3bukT.standardIssueTypes)[issueTypeName] ? issueTypeName : (0, $ib4WI.OTHER),
        projectId: project.id,
        updateSessionId: updateSessionId
    };
    if (sourceGroupType === (0, $jGcn0.GROUP_BY_STATUS) && destinationGroupType === (0, $jGcn0.GROUP_BY_STATUS)) {
        attributes.oldStatusCategoryId = sourceGroup.statusCategoryId;
        attributes.newStatusCategoryId = destinationGroup.statusCategoryId;
        attributes.oldStatusCategoryName = (0, $8Qd0L.statusCategoryForId)(sourceGroup.statusCategoryId);
        attributes.newStatusCategoryName = (0, $8Qd0L.statusCategoryForId)(destinationGroup.statusCategoryId);
    }
    if (transition != null) attributes.transitionId = transition.transitionId;
    return attributes;
};

});
parcelRegister("3bukT", function(module, exports) {

$parcel$export(module.exports, "CUSTOM", () => $cc2fecf6996f211b$export$952581bc40160893);
$parcel$export(module.exports, "standardIssueTypes", () => $cc2fecf6996f211b$export$c5b8a33017b6146a);
$parcel$export(module.exports, "translatedTaskNames", () => $cc2fecf6996f211b$export$ae53d86e513cd6);
const $cc2fecf6996f211b$var$EPIC = 'Epic';
const $cc2fecf6996f211b$var$STORY = 'Story';
const $cc2fecf6996f211b$var$BUG = 'Bug';
const $cc2fecf6996f211b$var$TASK = 'Task';
const $cc2fecf6996f211b$export$952581bc40160893 = 'Custom';
const $cc2fecf6996f211b$export$c5b8a33017b6146a = {
    [$cc2fecf6996f211b$var$EPIC]: true,
    [$cc2fecf6996f211b$var$STORY]: true,
    [$cc2fecf6996f211b$var$BUG]: true,
    [$cc2fecf6996f211b$var$TASK]: true
};
const $cc2fecf6996f211b$export$ae53d86e513cd6 = [
    'Task',
    'Aufgabe',
    'Tarea',
    "T\xe2che",
    "\u30BF\u30B9\u30AF",
    "\uC791\uC5C5",
    'Tarefa',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdakol",
    "\xdclesanne",
    "Teht\xe4v\xe4",
    'Feladat',
    'Verk',
    'Taak',
    'Opgave',
    'Oppgave',
    'Zadanie',
    'Activitate',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdaloha",
    'Uppgift',
    "G\xf6rev",
    "Nhi\u1EC7m v\u1EE5",
    "\u4EFB\u52A1",
    "\u4EFB\u52D9",
    "Attivit\xe0"
];

});



parcelRegister("bJNjm", function(module, exports) {

$parcel$export(module.exports, "ColumnDragDropProvider", () => $53c6eb107c910683$export$f18179b46c61fc8e);
$parcel$export(module.exports, "useColumnDragDrop", () => $53c6eb107c910683$export$c7a612ace05118e9);

var $eUqFw = parcelRequire("eUqFw");
const $53c6eb107c910683$var$ColumnDragDropContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $53c6eb107c910683$export$f18179b46c61fc8e = ({ children: children })=>{
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        draggedColumnId: null,
        dragPreviewState: {
            type: 'idle'
        }
    });
    const value = (0, $eUqFw.useMemo)(()=>({
            ...dragState,
            setDragState: setDragState
        }), [
        dragState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53c6eb107c910683$var$ColumnDragDropContext.Provider, {
        value: value
    }, children);
};
const $53c6eb107c910683$var$useColumnDragDropContext = ()=>{
    const context = (0, $eUqFw.useContext)($53c6eb107c910683$var$ColumnDragDropContext);
    if (!context) throw new Error('useColumnDragDropContext must be used within a ColumnDragDropProvider');
    return context;
};
const $53c6eb107c910683$export$c7a612ace05118e9 = (columnId)=>{
    const { draggedColumnId: draggedColumnId, dragPreviewState: dragPreviewState, setDragState: setDragState } = $53c6eb107c910683$var$useColumnDragDropContext();
    const startColumnDrag = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    ...prevDragState.dragPreviewState,
                    draggedColumnId: columnId
                }
            })), [
        columnId,
        setDragState
    ]);
    const resetDraggedColumn = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: null
            })), [
        setDragState
    ]);
    const renderDragPreview = (0, $eUqFw.useCallback)((container)=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: columnId,
                dragPreviewState: {
                    container: container,
                    type: 'preview'
                }
            })), [
        columnId,
        setDragState
    ]);
    const cleanupDragPreview = (0, $eUqFw.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    type: 'idle'
                }
            })), [
        setDragState
    ]);
    const isDragging = draggedColumnId === columnId;
    return {
        cleanupDragPreview: cleanupDragPreview,
        dragPreviewState: dragPreviewState,
        isDragging: isDragging,
        renderDragPreview: renderDragPreview,
        resetDraggedColumn: resetDraggedColumn,
        startColumnDrag: startColumnDrag
    };
};

});

parcelRegister("cgK6s", function(module, exports) {

$parcel$export(module.exports, "WorkflowActionsProvider", () => $6153ddf7f13eaaea$export$52383769590f1f7d);
$parcel$export(module.exports, "useIsWorkflowOperationInProgress", () => $6153ddf7f13eaaea$export$d8535539ef06db21);
$parcel$export(module.exports, "useWorkflowOperationStatusId", () => $6153ddf7f13eaaea$export$fcd0c43b34e1ab49);
$parcel$export(module.exports, "useStopWorkflowOperationInProgress", () => $6153ddf7f13eaaea$export$7d25f9f7a4197a33);
$parcel$export(module.exports, "useStartDeleteOperation", () => $6153ddf7f13eaaea$export$f125869614239ac);
$parcel$export(module.exports, "useStartAddOperation", () => $6153ddf7f13eaaea$export$a9547f77ff1cbe18);
$parcel$export(module.exports, "useStartRenameOperation", () => $6153ddf7f13eaaea$export$1763316459ec74d5);

var $eUqFw = parcelRequire("eUqFw");
const $6153ddf7f13eaaea$export$98ff4de2f070152d = {
    DELETING: 'deleting-status',
    ADDING: 'adding-status',
    RENAMING: 'renaming-status'
};
const $6153ddf7f13eaaea$var$WorkflowActionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6153ddf7f13eaaea$export$52383769590f1f7d = ({ children: children })=>{
    const [operationInProgress, setOperationInProgress] = (0, $eUqFw.useState)(null);
    const [statusId, setStatusId] = (0, $eUqFw.useState)(null);
    const value = (0, $eUqFw.useMemo)(()=>({
            statusId: statusId,
            operationInProgress: operationInProgress,
            setStatusId: setStatusId,
            setOperationInProgress: setOperationInProgress
        }), [
        statusId,
        operationInProgress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6153ddf7f13eaaea$var$WorkflowActionsContext.Provider, {
        value: value
    }, children);
};
const $6153ddf7f13eaaea$export$1f652ba9a3f9f48e = ()=>{
    const context = (0, $eUqFw.useContext)($6153ddf7f13eaaea$var$WorkflowActionsContext);
    if (!context) throw new Error('WorkflowActionsContext must be used within a WorkflowActionsProvider');
    return context;
};
const $6153ddf7f13eaaea$export$d8535539ef06db21 = ()=>{
    const context = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return context.operationInProgress != null;
};
const $6153ddf7f13eaaea$export$fcd0c43b34e1ab49 = ()=>{
    const context = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return context.statusId;
};
const $6153ddf7f13eaaea$export$7d25f9f7a4197a33 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)(()=>{
        setOperationInProgress(null);
        setStatusId(null);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $6153ddf7f13eaaea$export$f125869614239ac = ()=>{
    const { setOperationInProgress: setOperationInProgress } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)(()=>{
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.DELETING);
    }, [
        setOperationInProgress
    ]);
};
const $6153ddf7f13eaaea$export$a9547f77ff1cbe18 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.ADDING);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $6153ddf7f13eaaea$export$1763316459ec74d5 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $6153ddf7f13eaaea$export$1f652ba9a3f9f48e();
    return (0, $eUqFw.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($6153ddf7f13eaaea$export$98ff4de2f070152d.RENAMING);
    }, [
        setStatusId,
        setOperationInProgress
    ]);
};

});

parcelRegister("hppqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $182e7881eaae261e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $182e7881eaae261e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardHeading: {
        "id": "work-management-board.board-heading",
        "defaultMessage": "Board"
    }
});

});

parcelRegister("lqN6D", function(module, exports) {

$parcel$export(module.exports, "BoardStoreContainer", () => $bea3ff4760cfa8fd$export$b70209b0a9305722);
$parcel$export(module.exports, "useTransitionsByStatus", () => $bea3ff4760cfa8fd$export$71032cfff862eac6);
$parcel$export(module.exports, "useTransitionById", () => $bea3ff4760cfa8fd$export$7896497476db10bc);
$parcel$export(module.exports, "useHasMultipleTransitionsBetweenStatuses", () => $bea3ff4760cfa8fd$export$7ff9a7933e7d0448);
$parcel$export(module.exports, "useColumnByStatusId", () => $bea3ff4760cfa8fd$export$3970c7d63a0ff6c4);
$parcel$export(module.exports, "useGetIssueById", () => $bea3ff4760cfa8fd$export$f887e7f00d1a8941);
$parcel$export(module.exports, "useInitialTransition", () => $bea3ff4760cfa8fd$export$1c96719c98024183);
$parcel$export(module.exports, "useBoardStore", () => $bea3ff4760cfa8fd$export$18a7b27690614aac);
$parcel$export(module.exports, "useBoardStoreState", () => $bea3ff4760cfa8fd$export$a338eaa0da7be8ca);
$parcel$export(module.exports, "useBoardStoreActions", () => $bea3ff4760cfa8fd$export$faf6816ead15930);
$parcel$export(module.exports, "useHasMultipleWorkflows", () => $bea3ff4760cfa8fd$export$4b341ff69f53286b);
$parcel$export(module.exports, "useActiveWorkflowDetails", () => $bea3ff4760cfa8fd$export$63280ebfa63bed9b);
$parcel$export(module.exports, "useWorkflowDetailsWithoutSubtasksOnlyWorkflows", () => $bea3ff4760cfa8fd$export$154415725d43d3f6);
$parcel$export(module.exports, "useAreAnyColumnsUpdating", () => $bea3ff4760cfa8fd$export$4813f9119bbdf4ee);
$parcel$export(module.exports, "useIsGroupByFieldAllowed", () => $bea3ff4760cfa8fd$export$d6ba560b0cc08a8b);

var $3aUuh = parcelRequire("3aUuh");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $jroYY = parcelRequire("jroYY");

var $a0PqO = parcelRequire("a0PqO");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bea3ff4760cfa8fd$var$emptyObj = {};
const $bea3ff4760cfa8fd$var$emptyArray = [];
const $bea3ff4760cfa8fd$var$emptyTransitions = [];
const $bea3ff4760cfa8fd$var$emptyIssues = [];
const $bea3ff4760cfa8fd$var$emptyWorkflows = [];
const $bea3ff4760cfa8fd$var$emptyWorkflowsDetails = [];
const $bea3ff4760cfa8fd$var$emptyFieldIds = [];
const $bea3ff4760cfa8fd$var$initialState = {
    workflowName: null,
    workflowId: null,
    issues: $bea3ff4760cfa8fd$var$emptyIssues,
    people: $bea3ff4760cfa8fd$var$emptyObj,
    transitions: $bea3ff4760cfa8fd$var$emptyTransitions,
    columns: $bea3ff4760cfa8fd$var$emptyArray,
    loading: true,
    error: null,
    cardDragState: {
        issue: null,
        hoverIntent: false,
        transitionId: null,
        columnId: null
    },
    taskQueue: null,
    workflows: $bea3ff4760cfa8fd$var$emptyWorkflows,
    workflowsDetails: $bea3ff4760cfa8fd$var$emptyWorkflowsDetails,
    columnToDelete: null,
    columnToDeleteHover: null,
    isDeleteColumnInProgress: false,
    subtaskParentMap: {}
};
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$setIssueTypes = (issueTypes)=>({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        setState({
            issueTypes: (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issueTypes, 'id')
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$setIssueFields = (issueFields)=>({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const categoryFieldId = issueFields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.id;
        // For now, we only need category field id to load extended fields but other fields are also stored for
        // forwards compatibility.
        if (categoryFieldId == null) setState({
            issueFields: (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issueFields, 'id')
        });
        else setState({
            issueFields: (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issueFields, 'id'),
            categoryFieldId: categoryFieldId
        });
    };
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $bea3ff4760cfa8fd$var$pushToJobQueue = (job)=>({ setState: setState, getState: getState })=>{
        const { taskQueue: taskQueue } = getState();
        if (taskQueue === null) {
            setState({
                loading: true
            });
            const jobPromise = job();
            const newPromise = Promise.allSettled([
                jobPromise
            ]).then(()=>{
                setState({
                    taskQueue: null,
                    loading: false
                });
                return jobPromise;
            });
            setState({
                taskQueue: newPromise
            });
            return newPromise;
        }
        const aggregatedPromise = Promise.allSettled([
            taskQueue
        ]).then(()=>{
            setState({
                loading: true
            });
            const jobPromise = job();
            return Promise.allSettled([
                jobPromise
            ]).then(()=>{
                setState({
                    taskQueue: null,
                    loading: false
                });
                return jobPromise;
            });
        });
        setState({
            taskQueue: aggregatedPromise
        });
        return aggregatedPromise;
    };
const $bea3ff4760cfa8fd$var$addColumn = (column)=>({ setState: setState, getState: getState })=>{
        const { columns: columns, workflows: workflows } = getState();
        setState({
            columns: [
                ...columns,
                column
            ],
            workflows: workflows.map((wf)=>({
                    ...wf,
                    columns: [
                        ...wf.columns,
                        column
                    ]
                }))
        });
    };
const $bea3ff4760cfa8fd$var$setColumns = (columns)=>({ setState: setState, getState: getState })=>{
        const { workflowId: workflowId, workflows: workflows } = getState();
        setState({
            columns: columns,
            workflows: workflows.map((workflow)=>workflow.workflowId === workflowId ? {
                    ...workflow,
                    columns: columns
                } : workflow)
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$setIssues = (issues)=>({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        setState({
            issues: issues
        });
    };
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $bea3ff4760cfa8fd$var$setColumnToDelete = (columnToDelete)=>({ setState: setState })=>{
        setState({
            columnToDelete: columnToDelete
        });
    };
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $bea3ff4760cfa8fd$var$setColumnToDeleteHover = (columnToDeleteHover)=>({ setState: setState })=>{
        setState({
            columnToDeleteHover: columnToDeleteHover
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$moveIssues = (issueIDs, sourceColumnId, targetColumnId, relativeIssueId, shouldRankAfter, optimisticUpdates)=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const state = getState();
        const { issues: issues } = state;
        const issueById = (0, $jroYY.getIssueById)(state);
        let destinationIndex = relativeIssueId === null ? 0 : issues.findIndex((i)=>i.id === relativeIssueId);
        if (shouldRankAfter && sourceColumnId !== targetColumnId) destinationIndex += 1;
        const updatedIssues = [
            ...issues
        ];
        [
            ...issueIDs
        ].reverse().forEach((issueId)=>{
            const issue = issueById(issueId);
            const issueIndex = updatedIssues.findIndex((i)=>i.id === issue?.id);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            let updatedIssue = {
                ...issue,
                statusId: targetColumnId
            };
            if (optimisticUpdates != null) {
                if (Array.isArray(optimisticUpdates)) {
                    // Extended field updates
                    updatedIssue = {
                        ...issue
                    };
                    const issueDetails = state.issuesWithFields?.[issueId];
                    if (issueDetails != null) {
                        // Issue details are transformed generic type, optimistic update generic type
                        const { issuesWithFields: currentIssuesWithFields } = getState();
                        setState({
                            issuesWithFields: {
                                ...currentIssuesWithFields,
                                [String(issueId)]: (0, $a0PqO.updateExtendedFields)(issueDetails, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                optimisticUpdates)
                            }
                        });
                    }
                } else // Issue field updates
                updatedIssue = {
                    ...issue,
                    ...optimisticUpdates
                };
            }
            updatedIssues.splice(issueIndex, 1);
            const newIndex = issueIndex < destinationIndex && sourceColumnId !== targetColumnId ? destinationIndex - 1 : destinationIndex;
            updatedIssues.splice(newIndex, 0, updatedIssue);
        });
        setState({
            issues: updatedIssues
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$addIssue = (issue, extendedFields, rankBeforeIssueId)=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issues: issues } = getState();
        let updatedIssues;
        if (rankBeforeIssueId != null) {
            const issueIndex = issues.findIndex((i)=>i.id === rankBeforeIssueId);
            updatedIssues = [
                ...issues
            ];
            updatedIssues.splice(issueIndex, 0, issue);
        } else updatedIssues = [
            ...issues,
            issue
        ];
        if (extendedFields == null) setState({
            issues: updatedIssues
        });
        else {
            const { issuesWithFields: currentIssuesWithFields } = getState();
            const issueId = issue.id;
            setState({
                issues: updatedIssues,
                issuesWithFields: {
                    ...currentIssuesWithFields,
                    [String(issueId)]: extendedFields
                }
            });
        }
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$removeIssue = (issueId)=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issues: issues } = getState();
        setState({
            issues: [
                ...issues.filter((i)=>i.id !== issueId)
            ]
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$setCardDragState = (cardDragState)=>({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        setState({
            cardDragState: cardDragState
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$updateIssue = (issueId, updates, extendedFields)=>({ getState: getState, setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issues: issues, issuesWithFields: currentIssuesWithFields, subtaskParentMap: subtaskParentMap } = getState();
        const existingIssue = issues.find((issue)=>issue.id === issueId);
        if (!existingIssue) return;
        const updatedIssues = issues.map((issue)=>issue.id === issueId ? {
                ...issue,
                ...updates
            } : issue);
        if (updates.subtasks != null) updates.subtasks.forEach((subtaskIssue)=>{
            subtaskParentMap[subtaskIssue.id] = issueId;
        });
        const newState = {
            issues: updatedIssues,
            subtaskParentMap: subtaskParentMap
        };
        if (extendedFields) {
            const updatedIssueId = String(updates.id ?? issueId);
            const hasUpdatedIssueId = updates.id && existingIssue.id !== updates.id;
            const updatedIssuesWithFields = {
                ...currentIssuesWithFields,
                [String(updatedIssueId)]: extendedFields
            };
            /*
			 * If the issue ID has changed, remove the old issue ID from the issuesWithFields map.
			 * This ensures that the issue IDs referenced in the map match the issue IDs in the issues array.
			 */ if (hasUpdatedIssueId) delete updatedIssuesWithFields[issueId];
            newState.issuesWithFields = updatedIssuesWithFields;
        }
        setState(newState);
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$clearStoredFieldIds = ()=>({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        setState({
            issueDetailFields: $bea3ff4760cfa8fd$var$emptyFieldIds
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$updateIssuesWithFields = (updatedIssuesWithFields, fields)=>({ getState: getState, setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issuesWithFields: currentIssuesWithFields, issues: issues } = getState();
        setState({
            issuesWithFields: {
                ...currentIssuesWithFields,
                ...updatedIssuesWithFields
            },
            issueDetailFields: fields,
            // Clear needsExtendedFieldsUpdate flag from all issues
            issues: issues.map(({ needsExtendedFieldsUpdate: needsExtendedFieldsUpdate, ...issue })=>issue)
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$removeIssueWithFields = (issueId)=>({ getState: getState, setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issuesWithFields: issuesWithFields } = getState();
        if (issuesWithFields != null) {
            delete issuesWithFields[issueId];
            Object.keys(issuesWithFields).forEach((id)=>{
                const issueDetails = issuesWithFields[Number(id)];
                if (issueDetails?.fieldsByAlias?.parent?.parent?.id === String(issueId)) delete issuesWithFields[Number(id)];
            });
        }
        setState({
            issuesWithFields: issuesWithFields
        });
    };
/** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ const $bea3ff4760cfa8fd$var$updateConfluenceLinksCount = (issueId, count)=>({ getState: getState, setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) throw new Error('Project BAE is enabled');
        const { issuesWithFields: currentIssuesWithFields } = getState();
        const currentIssueDetails = currentIssuesWithFields?.[issueId];
        if (currentIssueDetails?.fieldsByAlias?.confluenceLinksCount?.value == null) return;
        const updatedIssueDetails = {
            ...currentIssueDetails,
            fieldsByAlias: {
                ...currentIssueDetails.fieldsByAlias,
                confluenceLinksCount: {
                    ...currentIssueDetails.fieldsByAlias.confluenceLinksCount,
                    value: count
                }
            }
        };
        setState({
            issuesWithFields: {
                ...currentIssuesWithFields,
                [issueId]: updatedIssueDetails
            }
        });
    };
const $bea3ff4760cfa8fd$var$setWorkflowsDetails = (workflowsDetails)=>({ setState: setState })=>{
        setState({
            workflowsDetails: workflowsDetails
        });
    };
/**
 * Used to modify a specific column based on statusId with partial data of Column
 */ const $bea3ff4760cfa8fd$var$modifyColumn = (statusId, columnData)=>({ getState: getState, setState: setState })=>{
        const { columns: columns, workflows: workflows } = getState();
        const modifyChosenColumns = (columnsToModify)=>{
            const selectedColumnIndex = columnsToModify.findIndex((c)=>c.statusId === statusId);
            if (selectedColumnIndex === -1) return columnsToModify;
            const updatedColumns = [
                ...columnsToModify
            ];
            const [sourceColumn] = updatedColumns.splice(selectedColumnIndex, 1);
            updatedColumns.splice(selectedColumnIndex, 0, {
                ...sourceColumn,
                ...columnData
            });
            return updatedColumns;
        };
        const updatedColumns = modifyChosenColumns(columns);
        const updatedWorkflows = workflows.map((wf)=>{
            const wfUpdatedColumns = modifyChosenColumns(wf.columns);
            return {
                ...wf,
                columns: wfUpdatedColumns
            };
        });
        setState({
            columns: updatedColumns,
            workflows: updatedWorkflows
        });
    };
const $bea3ff4760cfa8fd$var$deleteColumn = (columnToDelete, toStatus, columnData)=>({ setState: setState, getState: getState })=>{
        const { columns: columns, workflows: workflows } = getState();
        const toColumnData = columnData;
        if (columnToDelete.isDone) toColumnData.statusCategory = columnToDelete.statusCategory;
        const getUpdatedColumns = (columnsToUpdate)=>{
            const updatedColumns = [
                ...columnsToUpdate
            ];
            const columnToDeleteIndex = columnsToUpdate.findIndex((c)=>c.statusId === columnToDelete.statusId);
            updatedColumns.splice(columnToDeleteIndex, 1);
            return updatedColumns;
        };
        const updatedColumns = getUpdatedColumns(columns);
        const toColumnIndex = updatedColumns.findIndex((c)=>c.name === toStatus.name);
        const [toColumn] = updatedColumns.splice(toColumnIndex, 1);
        updatedColumns.splice(toColumnIndex, 0, {
            ...toColumn,
            ...toColumnData
        });
        const updatedWorkflows = workflows.map((wf)=>({
                ...wf,
                columns: getUpdatedColumns(wf.columns)
            }));
        setState({
            columns: updatedColumns,
            workflows: updatedWorkflows,
            columnToDelete: null,
            isDeleteColumnInProgress: true
        });
    };
const $bea3ff4760cfa8fd$var$setColumnsAndWorkflows = (columns, workflows)=>({ setState: setState })=>{
        setState({
            columns: columns,
            workflows: workflows,
            isDeleteColumnInProgress: false
        });
    };
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $bea3ff4760cfa8fd$var$setDeleteColumnInProgress = (isDeleteColumnInProgress)=>({ setState: setState })=>{
        setState({
            isDeleteColumnInProgress: isDeleteColumnInProgress
        });
    };
const $bea3ff4760cfa8fd$var$setFetchResponse = ({ workflows: workflows, activeWorkflow: activeWorkflow, workflowIssuesLastChangedTime: workflowIssuesLastChangedTime })=>async ({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) setState({
            columns: activeWorkflow.columns,
            transitions: activeWorkflow.transitions,
            workflowId: activeWorkflow.workflowId,
            workflowName: activeWorkflow.workflowName,
            workflows: workflows,
            workflowIssuesLastChangedTime: workflowIssuesLastChangedTime,
            loading: false
        });
        else setState({
            ...activeWorkflow,
            workflows: workflows,
            workflowIssuesLastChangedTime: workflowIssuesLastChangedTime,
            loading: false
        });
    };
const $bea3ff4760cfa8fd$var$setWorkflowData = (workflow)=>async ({ setState: setState })=>{
        if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) setState({
            columns: workflow.columns,
            transitions: workflow.transitions,
            workflowId: workflow.workflowId,
            workflowName: workflow.workflowName
        });
        else setState({
            ...workflow
        });
    };
const $bea3ff4760cfa8fd$var$actions = {
    addColumn: $bea3ff4760cfa8fd$var$addColumn,
    setColumns: $bea3ff4760cfa8fd$var$setColumns,
    setIssues: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setIssues,
    moveIssues: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$moveIssues,
    setCardDragState: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setCardDragState,
    addIssue: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$addIssue,
    removeIssue: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$removeIssue,
    updateIssue: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$updateIssue,
    modifyColumn: $bea3ff4760cfa8fd$var$modifyColumn,
    pushToJobQueue: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$pushToJobQueue,
    setWorkflowsDetails: $bea3ff4760cfa8fd$var$setWorkflowsDetails,
    setColumnToDelete: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setColumnToDelete,
    setColumnToDeleteHover: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setColumnToDeleteHover,
    deleteColumn: $bea3ff4760cfa8fd$var$deleteColumn,
    setColumnsAndWorkflows: $bea3ff4760cfa8fd$var$setColumnsAndWorkflows,
    setDeleteColumnInProgress: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setDeleteColumnInProgress,
    updateIssuesWithFields: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$updateIssuesWithFields,
    updateConfluenceLinksCount: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$updateConfluenceLinksCount,
    removeIssueWithFields: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$removeIssueWithFields,
    clearStoredFieldIds: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$clearStoredFieldIds,
    setIssueTypes: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setIssueTypes,
    setIssueFields: /** @deprecated Do not use in new board implementation (jwm.board-awesome-enhancements) */ $bea3ff4760cfa8fd$var$setIssueFields,
    setFetchResponse: $bea3ff4760cfa8fd$var$setFetchResponse,
    setWorkflowData: $bea3ff4760cfa8fd$var$setWorkflowData
};
const $bea3ff4760cfa8fd$export$b70209b0a9305722 = (0, $heB5U.createContainer)();
const $bea3ff4760cfa8fd$export$a960aa7525634ac0 = (0, $a61MH.createStore)({
    initialState: $bea3ff4760cfa8fd$var$initialState,
    actions: $bea3ff4760cfa8fd$var$actions,
    name: 'BoardStore',
    containedBy: $bea3ff4760cfa8fd$export$b70209b0a9305722
});
const $bea3ff4760cfa8fd$export$71032cfff862eac6 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getTransitionsByStatus)
});
const $bea3ff4760cfa8fd$export$7896497476db10bc = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getTransitionById)
});
const $bea3ff4760cfa8fd$export$7ff9a7933e7d0448 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.hasMultipleTransitions)
});
const $bea3ff4760cfa8fd$export$3970c7d63a0ff6c4 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getColumnByStatusId)
});
const $bea3ff4760cfa8fd$export$f887e7f00d1a8941 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getIssueById)
});
const $bea3ff4760cfa8fd$export$1c96719c98024183 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getInitialTransition)
});
const $bea3ff4760cfa8fd$export$18a7b27690614aac = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0);
const $bea3ff4760cfa8fd$export$a338eaa0da7be8ca = (0, $ggKAj.createStateHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0);
const $bea3ff4760cfa8fd$export$faf6816ead15930 = (0, $ggKAj.createActionsHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0);
const $bea3ff4760cfa8fd$export$4b341ff69f53286b = (0, $ggKAj.createStateHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.hasMultipleWorkflows)
});
const $bea3ff4760cfa8fd$export$63280ebfa63bed9b = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getActiveWorkflowDetails)
});
const $bea3ff4760cfa8fd$export$154415725d43d3f6 = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.getWorkflowDetailsWithoutSubtasksOnlyWorklows)
});
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const $bea3ff4760cfa8fd$var$areAnyColumnsUpdating = (0, $bj4JM.createSelector)((state)=>state.columns, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
(columns)=>columns.some((column)=>column?.loading));
const $bea3ff4760cfa8fd$export$4813f9119bbdf4ee = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: $bea3ff4760cfa8fd$var$areAnyColumnsUpdating
});
const $bea3ff4760cfa8fd$export$d6ba560b0cc08a8b = (0, $ggKAj.createHook)($bea3ff4760cfa8fd$export$a960aa7525634ac0, {
    selector: (0, $jroYY.isGroupByFieldAllowed)
});

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("jroYY", function(module, exports) {

$parcel$export(module.exports, "getTransitionsByStatus", () => $fd34e3562176a31a$export$ff691f590e65d740);
$parcel$export(module.exports, "getTransitionById", () => $fd34e3562176a31a$export$737c6134d3ab6356);
$parcel$export(module.exports, "getColumnByStatusId", () => $fd34e3562176a31a$export$c0868dfc0085fdc9);
$parcel$export(module.exports, "getInitialTransition", () => $fd34e3562176a31a$export$f21c70c692350783);
$parcel$export(module.exports, "getIssueById", () => $fd34e3562176a31a$export$75010363f38d9dc8);
$parcel$export(module.exports, "hasMultipleTransitions", () => $fd34e3562176a31a$export$e642abf2d8cab89c);
$parcel$export(module.exports, "getActiveWorkflowDetails", () => $fd34e3562176a31a$export$89327d34e5b328e7);
$parcel$export(module.exports, "hasMultipleWorkflows", () => $fd34e3562176a31a$export$42fbc14eed97311e);
$parcel$export(module.exports, "getWorkflowDetailsWithoutSubtasksOnlyWorklows", () => $fd34e3562176a31a$export$61b4f4690a594672);
$parcel$export(module.exports, "isGroupByFieldAllowed", () => $fd34e3562176a31a$export$260e91a6f957a1cd);

var $fcWBJ = parcelRequire("fcWBJ");

var $bj4JM = parcelRequire("bj4JM");

var $a0PqO = parcelRequire("a0PqO");
const $fd34e3562176a31a$export$ff691f590e65d740 = (0, $bj4JM.createSelector)((state)=>state.transitions, (__, props)=>props.fromStatusId, (__, props)=>props.toStatusId, (transitions, fromStatusId, toStatusId)=>transitions.filter((transition)=>{
        if (transition.isInitial) return false;
        if (fromStatusId !== toStatusId && transition.isGlobal && toStatusId === transition.toStatusId) return true;
        return toStatusId === Number(transition.toStatusId) && fromStatusId === Number(transition.fromStatusId);
    }));
const $fd34e3562176a31a$export$737c6134d3ab6356 = (0, $bj4JM.createSelector)((state)=>state.transitions, (__, props)=>props.transitionId, (transitions, transitionId)=>transitions.find((transition)=>transition.transitionId === transitionId));
const $fd34e3562176a31a$export$c0868dfc0085fdc9 = (0, $bj4JM.createSelector)((state)=>state.columns, (__, props)=>props.statusId, (columns, statusId)=>columns.find((column)=>column.statusId === statusId));
const $fd34e3562176a31a$export$f21c70c692350783 = (0, $bj4JM.createSelector)((state)=>state.transitions, (transitions)=>transitions.find((transition)=>transition.isInitial));
const $fd34e3562176a31a$export$75010363f38d9dc8 = (state)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const idIssueMap = state.issues.reduce((issuesMap, issue)=>Object.assign(issuesMap, {
            [issue.id]: issue
        }), {});
    return (id)=>idIssueMap[id];
};
const $fd34e3562176a31a$export$e642abf2d8cab89c = (0, $bj4JM.createSelector)((state)=>state.transitions, (transitions)=>{
    // Always show dropzones for self transitions since dragging in the same column will rank without the transitions
    if (transitions.some((transition)=>transition.fromStatusId === transition.toStatusId)) return true;
    // Group transitions by target status filtering out initial ones since they can't be executed implicitly
    const transitionsGroupedByToStatus = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(transitions.filter((transition)=>!transition.isInitial), (transition)=>transition.toStatusId);
    return Object.keys(transitionsGroupedByToStatus).map((toStatusId)=>transitionsGroupedByToStatus[toStatusId]).some((transitionsByTargetStatus)=>transitionsByTargetStatus.length > 1 && (transitionsByTargetStatus.some((transition)=>transition.isGlobal) || new Set(transitionsByTargetStatus.map((transition)=>transition.fromStatusId)).size < transitionsByTargetStatus.length));
});
const $fd34e3562176a31a$export$89327d34e5b328e7 = (0, $bj4JM.createSelector)((state)=>state.workflowsDetails, (state)=>state.workflowId, (workflowsDetails, workflowId)=>{
    if (workflowId == null) return undefined;
    return workflowsDetails.find((workflowsDetail)=>workflowsDetail.workflowId === workflowId) ?? workflowsDetails[0];
});
const $fd34e3562176a31a$export$42fbc14eed97311e = (0, $bj4JM.createSelector)((state)=>state.workflowsDetails, (workflowsDetails)=>workflowsDetails?.length > 1);
const $fd34e3562176a31a$export$61b4f4690a594672 = (0, $bj4JM.createSelector)((state)=>state.workflowsDetails, (workflowsDetails)=>workflowsDetails.filter((workflowDetails)=>{
        if (workflowDetails.issueTypes == null || workflowDetails.issueTypes.length === 0) return false;
        return workflowDetails.issueTypes.some((issueType)=>issueType.hierarchyLevel >= 0);
    }));
const $fd34e3562176a31a$export$260e91a6f957a1cd = (0, $bj4JM.createSelector)((state)=>state.issueFields, (state)=>state.issueTypes, (_, props)=>props.fieldType, (_, props)=>props.fieldKey, (issueFields, issueTypesMap, fieldType, fieldKey)=>{
    if (fieldType != null) return (0, $a0PqO.isGroupByFieldAllowedByType)(fieldType, issueFields, issueTypesMap);
    if (fieldKey != null) return (0, $a0PqO.isGroupByFieldAllowedByKey)(fieldKey, issueFields, issueTypesMap);
    return true;
});

});
parcelRegister("a0PqO", function(module, exports) {

$parcel$export(module.exports, "isGroupByFieldAllowedByType", () => $da1e6a648ee6e46a$export$ed1e1ff96f8e0283);
$parcel$export(module.exports, "isGroupByFieldAllowedByKey", () => $da1e6a648ee6e46a$export$2dd4525a0745202e);
$parcel$export(module.exports, "updateExtendedFields", () => $da1e6a648ee6e46a$export$fd1b32f70ba344b4);

var $3aUuh = parcelRequire("3aUuh");

var $ib4WI = parcelRequire("ib4WI");
const $da1e6a648ee6e46a$export$ed1e1ff96f8e0283 = (fieldType, issueFields, issueTypesMap)=>{
    // Allow grouping if we don't know about the fields
    if (issueFields == null || issueTypesMap == null) return true;
    return Object.values(issueFields).some((field)=>field.type === fieldType && field.issueTypes != null && field.issueTypes.some((issueTypeId)=>issueTypesMap[issueTypeId]?.subtask === false));
};
const $da1e6a648ee6e46a$export$2dd4525a0745202e = (fieldKey, issueFields, issueTypesMap)=>{
    // Allow grouping if we don't know about the fields
    if (issueFields == null || issueTypesMap == null) return true;
    return issueFields[fieldKey] != null && issueFields[fieldKey].issueTypes?.some((issueTypeId)=>issueTypesMap?.[issueTypeId]?.subtask === false);
};
const $da1e6a648ee6e46a$export$fd1b32f70ba344b4 = (existingDetails, updates)=>{
    const updatesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(updates, 'fieldId');
    const toReturn = {
        fields: [],
        fieldsByAlias: {
            ...existingDetails.fieldsByAlias
        }
    };
    const updatedFieldIds = new Set([
        ...updates.map((update)=>update.fieldId),
        ...existingDetails.fields.map((field)=>field.fieldId)
    ]);
    existingDetails.fields.forEach((field)=>{
        updatedFieldIds.delete(field.fieldId);
        const fieldUpdates = updatesMap[field.fieldId];
        const shouldRemoveField = fieldUpdates != null && 'value' in fieldUpdates && fieldUpdates.value == null;
        if (shouldRemoveField) return;
        if (fieldUpdates != null) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const updatedField = {
                ...field,
                ...fieldUpdates
            };
            toReturn.fields.push(updatedField);
            if (updatedField.type === (0, $ib4WI.BOARD_FIELD_CATEGORY)) toReturn.fieldsByAlias.category = updatedField;
        } else toReturn.fields.push(field);
    });
    updatedFieldIds.forEach((fieldId)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const updatedField = updatesMap[fieldId];
        if (updatedField != null) {
            toReturn.fields.push(updatedField);
            if (updatedField.type === (0, $ib4WI.BOARD_FIELD_CATEGORY)) toReturn.fieldsByAlias.category = updatedField;
        }
    });
    return toReturn;
};

});



parcelRegister("3ImR7", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $60c5c521b68798fd$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $60c5c521b68798fd$export$834c81726d4c51eb);

var $9ypom = parcelRequire("9ypom");

var $7Pw84 = parcelRequire("7Pw84");

var $iwwE5 = parcelRequire("iwwE5");
const $60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT = (0, $9ypom.default)`
fragment CreatedBoardItemFragment on JiraWorkManagementViewItem {
    ...JIS2_JWMBoardItemFragment
    ...JIS2_JWMBoardConfluenceLinksFragment
}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
`;
const $60c5c521b68798fd$export$f5c1cac020b22be4 = (0, $9ypom.default)`
mutation JWMBoardInlineCreateIssue($input: JiraCreateIssueInput!, $fieldIds: [String]!, $withCoverMedia: Boolean!, $withExtendedIssue: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedBoardItemFragment
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
        }
        ...CreateIssueFragment
    }
}
${$60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT}
${(0, $7Pw84.CREATE_ISSUE_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;
const $60c5c521b68798fd$export$834c81726d4c51eb = (0, $9ypom.default)`
query JWMBoardInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $withCoverMedia: Boolean!, $withExtendedIssue: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedBoardItemFragment
                        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
                        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
                    }
                }
            }
        }
    }
}
${$60c5c521b68798fd$var$CREATED_ITEM_FRAGMENT}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});
parcelRegister("7Pw84", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $33f8e9ac12479c3a$export$47232071d0e9dfb);

var $9ypom = parcelRequire("9ypom");
const $33f8e9ac12479c3a$export$47232071d0e9dfb = (0, $9ypom.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});


parcelRegister("dszCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a576ee981fa6eef$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $l3fLv = parcelRequire("l3fLv");

var $6MNdO = parcelRequire("6MNdO");

var $9FDwo = parcelRequire("9FDwo");
const $0a576ee981fa6eef$var$JWMBoardComponent = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jwm.board-awesome-enhancements'), (0, $l3fLv.default), (0, $6MNdO.default));
var $0a576ee981fa6eef$export$2e2bcd8739ae039 = $0a576ee981fa6eef$var$JWMBoardComponent;

});
parcelRegister("l3fLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4275242491df62$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6ki0E = parcelRequire("6ki0E");

var $iBFrS = parcelRequire("iBFrS");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $jGcn0 = parcelRequire("jGcn0");

var $3JiQx = parcelRequire("3JiQx");

var $kQAZu = parcelRequire("kQAZu");

var $gCyQH = parcelRequire("gCyQH");

var $4G5xU = parcelRequire("4G5xU");

var $41WOo = parcelRequire("41WOo");

var $kiBzn = parcelRequire("kiBzn");
var $96etS = parcelRequire("96etS");

var $jvtK3 = parcelRequire("jvtK3");
var $h02O8 = parcelRequire("h02O8");
var $7SlEV = parcelRequire("7SlEV");

var $kHnEs = parcelRequire("kHnEs");
var $9u6Jh = parcelRequire("9u6Jh");
var $fibAs = parcelRequire("fibAs");

var $5I9Im = parcelRequire("5I9Im");

var $8BjUT = parcelRequire("8BjUT");

var $bcWyL = parcelRequire("bcWyL");
var $6HWvN = parcelRequire("6HWvN");

var $eeJbA = parcelRequire("eeJbA");

var $eRpjy = parcelRequire("eRpjy");

var $90G8g = parcelRequire("90G8g");


var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $3hjaO = parcelRequire("3hjaO");
var $fkLhx = parcelRequire("fkLhx");

var $hzcvF = parcelRequire("hzcvF");


var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $84CBi = parcelRequire("84CBi");

var $ib4WI = parcelRequire("ib4WI");

var $bFk6h = parcelRequire("bFk6h");

var $1rVdL = parcelRequire("1rVdL");

var $3sztN = parcelRequire("3sztN");

var $2b5eO = parcelRequire("2b5eO");

var $iXHUp = parcelRequire("iXHUp");

var $cY0Xy = parcelRequire("cY0Xy");

var $c52lf = parcelRequire("c52lf");

var $sFqil = parcelRequire("sFqil");

var $93B7g = parcelRequire("93B7g");

var $1trHT = parcelRequire("1trHT");

var $2TjqC = parcelRequire("2TjqC");
const $1b4275242491df62$var$isRealTimePayloadIssueEvent = (payload)=>'issueId' in payload && payload.issueId != null;
const $1b4275242491df62$var$REALTIME_APP_ID = 'jira-business-board-view';
const $1b4275242491df62$var$BoardContent = ({ isFullHeight: isFullHeight })=>{
    const project = (0, $kQAZu.useProject)();
    const groups = (0, $c52lf.useIssueGroups)();
    const groupBy = (0, $iXHUp.useGroupByField)();
    const boardContentRef = (0, $eUqFw.useRef)(null);
    const [boardWrapper, setBoardWrapper] = (0, $eUqFw.useState)(null);
    const isColumnCreateEnabled = project.isSimplified && (!groupBy || groupBy === (0, $jGcn0.GROUP_BY_STATUS));
    const totalChildren = isColumnCreateEnabled ? groups.length + 1 : groups.length;
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: totalChildren,
        horizontal: true,
        getScrollElement: ()=>boardWrapper,
        estimateSize: ()=>(0, $ib4WI.COLUMN_FIXED_WIDTH),
        gap: (0, $ib4WI.GAP_BETWEEN_COLUMNS),
        overscan: 0
    });
    const { shouldRenderExperiment: automationDiscoveryEnabled } = (0, $41WOo.isAutomationDiscoveryOnBoardColumnsExperimentEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fkLhx.useJwmAutomationDiscoveryOnBoardColumnsExperiment)(true) : {
        shouldRenderExperiment: false
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!boardWrapper) return;
        return (0, $iBFrS.autoScrollForElements)({
            element: boardWrapper
        });
    }, [
        boardWrapper
    ]);
    const ColumnContent = virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$VirtualItemWrapper, {
            key: virtualItem.key,
            start: virtualItem.start,
            "data-index": virtualItem.index,
            ref: virtualizer.measureElement
        }, virtualItem.index === groups.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $93B7g.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c52lf.IssueGroupProvider), {
            key: virtualItem.key,
            group: groups[virtualItem.index]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sFqil.default), {
            columnIndex: virtualItem.index,
            isFullHeight: isFullHeight,
            columnsNumber: groups.length
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardWrapper, {
        ref: setBoardWrapper,
        "data-testid": "work-management-board.ui.board.board-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContentWrapper, {
        ref: boardContentRef,
        totalSize: virtualizer.getTotalSize()
    }, automationDiscoveryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hjaO.AutomationDiscoveryProvider), {
        columns: groups.map((group)=>({
                id: Number(group.id),
                statusCategoryId: 'statusCategoryId' in group ? Number(group.statusCategoryId) : undefined
            }))
    }, ColumnContent) : ColumnContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2TjqC.default), {
        boardContentElement: boardContentRef.current,
        scrollElement: boardWrapper
    })));
};
const $1b4275242491df62$var$Board = ()=>{
    const { featureView: featureView } = (0, $2b5eO.useJWMBoardFeatures)();
    const { isFiltering: isFiltering } = (0, $1rVdL.useFilterStatus)();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    const { filteredIssues: filteredIssues, loading: loading, error: error, refetch: refetch } = (0, $bFk6h.useBoardData)();
    const { handleUpdatedIssue: handleUpdatedIssue, handleDeletedIssue: handleDeletedIssue } = (0, $cY0Xy.useHandleIssueEvents)();
    const [, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $4TJj0.useCollabStore)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    const [{ openInSidebar: openInSidebar }] = (0, $fibAs.useIssueAppSwitcher)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const viewMode = (0, $1ybV0.ff)('refactor-bento-view-mode-logic') ? (0, $hJ992.useViewMode)() : null;
    const isViewModeSideBar = (0, $1ybV0.ff)('refactor-bento-view-mode-logic') ? viewMode === (0, $935e771f19f8ea28$export$705305d6da432040) : openInSidebar;
    (0, $3sztN.useDropHandler)(loading);
    const boardHasNoIssues = filteredIssues.length === 0;
    const isBoardEmptyAfterFilter = boardHasNoIssues && (isFiltering || isSearching) && !loading;
    const isBoardEmpty = boardHasNoIssues && !isFiltering && !loading;
    const onIssueModalClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // when issueKey param is removed from URL we need to clear node selection
        if (selectedIssueKey == null && prevSelectedIssueKey != null) {
            const issue = filteredIssues.find((item)=>item.fields[0, $ib4WI.ISSUE_KEY_ID].value === prevSelectedIssueKey);
            if (issue) {
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: `${issue.id}`
                });
                sendClearNodeSelection({
                    nodeId: nodeId
                });
            }
        }
    }, [
        filteredIssues,
        prevSelectedIssueKey,
        projectId,
        selectedIssueKey,
        sendClearNodeSelection,
        sendNodeSelected
    ]);
    const onPageVisibilityChange = (0, $eUqFw.useCallback)(({ isVisible: isVisible })=>{
        if (isVisible) refetch();
    }, [
        refetch
    ]);
    const onRealtimeEventOld = (0, $eUqFw.useCallback)(async (event)=>{
        if ($1b4275242491df62$var$isRealTimePayloadIssueEvent(event.payload)) {
            const { issueId: issueId } = event.payload;
            const isDeleted = event.type === (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99);
            if (isDeleted) handleDeletedIssue(issueId);
            else handleUpdatedIssue(issueId);
        }
    }, [
        handleDeletedIssue,
        handleUpdatedIssue
    ]);
    const onRealtimeEvent = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $h02O8.isIssueEvent)(event)) {
            const issueId = Number(event.payload.issueId);
            if (event.type === (0, $7SlEV.ISSUE_DELETED_EVENT)) handleDeletedIssue(issueId);
            else handleUpdatedIssue(issueId);
        }
    }, [
        handleDeletedIssue,
        handleUpdatedIssue
    ]);
    const onBentoChange = (0, $eUqFw.useCallback)((event)=>handleUpdatedIssue(Number(event.issueId)), [
        handleUpdatedIssue
    ]);
    const onBentoDelete = (0, $eUqFw.useCallback)(({ issueId: issueId })=>handleDeletedIssue(Number(issueId)), [
        handleDeletedIssue
    ]);
    // Memoised to prevent flicker on JIRT updates
    const issueModal = (0, $eUqFw.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onIssueModalClose,
            analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e),
            onChange: onBentoChange,
            onDeleteSuccess: onBentoDelete
        }), [
        selectedIssueKey,
        onIssueModalClose,
        onBentoChange,
        onBentoDelete
    ]);
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCyQH.ErrorPage), {
        error: error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "board-container-initial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1b4275242491df62$var$loadingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c52lf.IssuesByGroupProvider), {
        filteredIssues: filteredIssues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContainer, {
        "data-testid": "work-management-board.ui.board.board-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView
    }), isBoardEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1trHT.EmptyBoardComponent), null)) : null, isBoardEmptyAfterFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiBzn.ThemedFilterEmptyState), null)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4275242491df62$var$BoardContent, {
        isFullHeight: (0, $1ybV0.ff)('jwm.board-full-height-columns') && !boardHasNoIssues
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null))), isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onIssueModalClose,
        onChange: onBentoChange,
        onIssueDeleteSuccess: onBentoDelete,
        analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e)
    }) : issueModal, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcWyL.PerformanceAnalytics), {
        view: featureView,
        loading: loading,
        itemsCount: filteredIssues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeJbA.SignupInviteModal), null), (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null), (0, $1ybV0.ff)('jwm.board.migrate-jirt-to-gqls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvtK3.GqlsRealtime), {
        appId: $1b4275242491df62$var$REALTIME_APP_ID,
        entityId: projectId,
        onReceive: onRealtimeEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JiQx.BusinessRealtime), {
        appId: $1b4275242491df62$var$REALTIME_APP_ID,
        onReceive: onRealtimeEventOld
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BjUT.PageVisibility), {
        onChange: onPageVisibilityChange
    })));
};
var $1b4275242491df62$export$2e2bcd8739ae039 = $1b4275242491df62$var$Board;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b4275242491df62$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1o9zidpf _1n261q9c _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1reo1wug _16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1ul9idpf _kqswh2mm _syaz1fxt _1yt41r6r _18s81mhk",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$BoardContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $9t7rW.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1n261q9c _kqswh2mm _4t3i1osq _c71l1osq _1ul91ns9 _uiztglyw _1bsb1651 _m6k4brmi",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$loadingWrapperStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-around'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b4275242491df62$var$VirtualItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_19kxfes": (0, $9t7rW.default)(`translateX(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _kqswstnw _154iidpf _1ltvidpf _t9ec1yxo",
            __cmplp.className
        ])
    });
});
const $1b4275242491df62$var$EmptyStateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i1x1l _1bsb1osq _1pbykb7n _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6ki0E", function(module, exports) {

$parcel$export(module.exports, "useVirtualizer", () => $49b294a7a914c493$export$dd6d526d88b5a137);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7UQje = parcelRequire("7UQje");
const $49b294a7a914c493$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;
function $49b294a7a914c493$var$useVirtualizerBase(options) {
    const rerender = $eUqFw.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $lEfVV.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $eUqFw.useState(()=>new (0, $7UQje.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $eUqFw.useEffect(()=>{
        return instance._didMount();
    }, []);
    $49b294a7a914c493$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $49b294a7a914c493$export$dd6d526d88b5a137(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        observeElementRect: $7UQje.observeElementRect,
        observeElementOffset: $7UQje.observeElementOffset,
        scrollToFn: (0, $7UQje.elementScroll),
        ...options
    });
}
function $49b294a7a914c493$export$645722dcac657cb9(options) {
    return $49b294a7a914c493$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $7UQje.observeWindowRect),
        observeElementOffset: (0, $7UQje.observeWindowOffset),
        scrollToFn: (0, $7UQje.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("7UQje", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $5c3656db8b73d7d9$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $5c3656db8b73d7d9$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $5c3656db8b73d7d9$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $5c3656db8b73d7d9$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $5c3656db8b73d7d9$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $5c3656db8b73d7d9$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $5c3656db8b73d7d9$export$89be5a243e59c4b2);

var $a9AhN = parcelRequire("a9AhN");
const $5c3656db8b73d7d9$export$76974b428a49f15b = (index)=>index;
const $5c3656db8b73d7d9$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $5c3656db8b73d7d9$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $5c3656db8b73d7d9$var$addEventListenerOptions = {
    passive: true
};
const $5c3656db8b73d7d9$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $5c3656db8b73d7d9$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $5c3656db8b73d7d9$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $5c3656db8b73d7d9$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $5c3656db8b73d7d9$var$supportsScrollend ? ()=>void 0 : (0, $a9AhN.debounce)(()=>{
        cb(offset, false);
    }, 150);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollLeft" : "scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $5c3656db8b73d7d9$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $5c3656db8b73d7d9$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $5c3656db8b73d7d9$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $5c3656db8b73d7d9$var$supportsScrollend ? ()=>void 0 : (0, $a9AhN.debounce)(()=>{
        cb(offset, false);
    }, 150);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $5c3656db8b73d7d9$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $5c3656db8b73d7d9$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $5c3656db8b73d7d9$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $5c3656db8b73d7d9$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $5c3656db8b73d7d9$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $5c3656db8b73d7d9$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $5c3656db8b73d7d9$export$76974b428a49f15b,
                rangeExtractor: $5c3656db8b73d7d9$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $5c3656db8b73d7d9$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                ...opts2
            };
        };
        this.notify = (force, sync)=>{
            var _a, _b;
            const { startIndex: startIndex, endIndex: endIndex } = this.range ?? {
                startIndex: void 0,
                endIndex: void 0
            };
            const range = this.calculateRange();
            if (force || startIndex !== (range == null ? void 0 : range.startIndex) || endIndex !== (range == null ? void 0 : range.endIndex)) (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.notify(false, false);
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.scrollOffset < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    const prevIsScrolling = this.isScrolling;
                    this.isScrolling = isScrolling;
                    this.notify(prevIsScrolling !== isScrolling, isScrolling);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getMeasurementOptions = (0, $a9AhN.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $a9AhN.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $a9AhN.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $5c3656db8b73d7d9$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $a9AhN.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(true, false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $a9AhN.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $a9AhN.notUndefined)(measurements[$5c3656db8b73d7d9$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $a9AhN.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $a9AhN.notUndefined)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $a9AhN.approxEqual)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            var _a, _b;
            this.itemSizeCache = /* @__PURE__ */ new Map();
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.notify(false, false);
    }
}
const $5c3656db8b73d7d9$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $5c3656db8b73d7d9$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $5c3656db8b73d7d9$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("a9AhN", function(module, exports) {

$parcel$export(module.exports, "memo", () => $7646e44d16e81122$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $7646e44d16e81122$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $7646e44d16e81122$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $7646e44d16e81122$export$61fc7d43ac8f84b0);
function $7646e44d16e81122$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $7646e44d16e81122$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $7646e44d16e81122$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $7646e44d16e81122$export$61fc7d43ac8f84b0 = (fn, ms)=>{
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("iBFrS", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $2bdf60adda54f012$export$4b66ee8317094cdb);

var $eo9PV = parcelRequire("eo9PV");

var $5dz2w = parcelRequire("5dz2w");
const $2bdf60adda54f012$var$api = (0, $5dz2w.makeApi)({
    monitor: (0, $eo9PV.monitorForElements)
});
const $2bdf60adda54f012$export$4b66ee8317094cdb = $2bdf60adda54f012$var$api.autoScroll;
const $2bdf60adda54f012$export$c9168f41de61f525 = $2bdf60adda54f012$var$api.autoScrollWindow;

});
parcelRegister("5dz2w", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $247b873d90531327$export$b8fa21320a811083);
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $2bJOS = parcelRequire("2bJOS");

var $b8ruP = parcelRequire("b8ruP");

var $b2gaW = parcelRequire("b2gaW");
function $247b873d90531327$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $jFl9L.combine)((0, $b8ruP.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $b2gaW.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $2bJOS.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("3f2za", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("jFl9L")).combine);

var $jFl9L = parcelRequire("jFl9L");

});

parcelRegister("2bJOS", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $8b7edb6fc42851b3$export$5cff7ac265db316a);
parcelRequire("5K1lL");
var $cHW1B = parcelRequire("cHW1B");

var $lOu8O = parcelRequire("lOu8O");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $8b7edb6fc42851b3$var$schedulers = new Map();
function $8b7edb6fc42851b3$export$5cff7ac265db316a(monitor) {
    const scheduler = $8b7edb6fc42851b3$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $8b7edb6fc42851b3$var$makeScheduler(monitor);
    $8b7edb6fc42851b3$var$schedulers.set(monitor, created);
    return created;
}
function $8b7edb6fc42851b3$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $lOu8O.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $lOu8O.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("5K1lL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cHW1B")).getElementFromPointWithoutHoneypot);

var $cHW1B = parcelRequire("cHW1B");

});

parcelRegister("lOu8O", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $b8e95e7998ef0be7$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $b8e95e7998ef0be7$export$13ae770ed39b71ea);
const $b8e95e7998ef0be7$var$ledger = new Map();
const $b8e95e7998ef0be7$var$requested = new Set();
function $b8e95e7998ef0be7$export$8c764c3f2fc3d2d2(element) {
    $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element);
    const entry = $b8e95e7998ef0be7$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8e95e7998ef0be7$var$ledger.set(element, fresh);
    return fresh;
}
function $b8e95e7998ef0be7$export$1cb7cbb266b6f6fa(element) {
    $b8e95e7998ef0be7$var$requested.add(element);
}
function $b8e95e7998ef0be7$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8e95e7998ef0be7$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8e95e7998ef0be7$var$ledger.forEach((_, element)=>{
        if (!$b8e95e7998ef0be7$var$requested.has(element)) $b8e95e7998ef0be7$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8e95e7998ef0be7$var$requested.clear();
}
function $b8e95e7998ef0be7$export$13ae770ed39b71ea() {
    $b8e95e7998ef0be7$var$ledger.clear();
}

});


parcelRegister("b8ruP", function(module, exports) {

$parcel$export(module.exports, "selector", () => $4f53e0cf4f3db8df$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $4f53e0cf4f3db8df$export$4ec12fb57dfebd53);
const $4f53e0cf4f3db8df$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $4f53e0cf4f3db8df$export$aea217a45095ce11 = `[${$4f53e0cf4f3db8df$export$4b152ab55cad4fd6}="true"]`;
function $4f53e0cf4f3db8df$export$4ec12fb57dfebd53(element) {
    element.setAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($4f53e0cf4f3db8df$export$4b152ab55cad4fd6);
}

});

parcelRegister("b2gaW", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $1d3eba3ce2467b62$export$233199807749476d);

var $igc9Q = parcelRequire("igc9Q");

var $lOu8O = parcelRequire("lOu8O");

var $b8ruP = parcelRequire("b8ruP");

var $lbLMz = parcelRequire("lbLMz");
function $1d3eba3ce2467b62$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $1d3eba3ce2467b62$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $b8ruP.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $1d3eba3ce2467b62$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $lOu8O.markAndGetEngagement)(element);
    const config = (0, $igc9Q.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $lbLMz.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $1d3eba3ce2467b62$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $lOu8O.markAndGetEngagement)(element);
        const config = (0, $igc9Q.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $lbLMz.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $1d3eba3ce2467b62$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $1d3eba3ce2467b62$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$1d3eba3ce2467b62$var$isScrollingAvailable(remainder)) return;
    $1d3eba3ce2467b62$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("igc9Q", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $66fbafc1c093817a$export$e96028ec7ff9d079);
const $66fbafc1c093817a$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 300,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $66fbafc1c093817a$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $66fbafc1c093817a$export$e96028ec7ff9d079(provided) {
    return {
        ...$66fbafc1c093817a$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $66fbafc1c093817a$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("lbLMz", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $6e8faf33c307118e$export$6cfa6dfe6898b98f);

var $e6EBw = parcelRequire("e6EBw");

var $9knKV = parcelRequire("9knKV");

var $ik6Wv = parcelRequire("ik6Wv");

var $jqf1q = parcelRequire("jqf1q");

var $B7xXV = parcelRequire("B7xXV");

var $kMdkl = parcelRequire("kMdkl");
function $6e8faf33c307118e$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $6e8faf33c307118e$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $6e8faf33c307118e$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $9knKV.edges).reduce((map, edge)=>{
        const hitbox = (0, $ik6Wv.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $9knKV.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $B7xXV.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $kMdkl.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $e6EBw.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $jqf1q.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("e6EBw", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $3e6125aba6075bda$export$ccd6d9407403fcad);
const $3e6125aba6075bda$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("9knKV", function(module, exports) {

$parcel$export(module.exports, "edges", () => $0502d94573f152b7$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $0502d94573f152b7$export$7fc144124ccf8292);
const $0502d94573f152b7$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $0502d94573f152b7$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("ik6Wv", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $3dbe4989a882188b$export$b9a449c20abb0e9);

var $br1pC = parcelRequire("br1pC");

var $cKmqq = parcelRequire("cKmqq");
function $3dbe4989a882188b$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $br1pC.axisLookup)[axis];
        const side = (0, $cKmqq.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $3dbe4989a882188b$export$b9a449c20abb0e9 = {
    top: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $3dbe4989a882188b$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("br1pC", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $673eff0f7ee04f30$export$42e42cdab35a2b96);
const $673eff0f7ee04f30$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $673eff0f7ee04f30$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $673eff0f7ee04f30$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $673eff0f7ee04f30$var$vertical,
        crossAxis: $673eff0f7ee04f30$var$horizontal
    },
    horizontal: {
        mainAxis: $673eff0f7ee04f30$var$horizontal,
        crossAxis: $673eff0f7ee04f30$var$vertical
    }
};

});

parcelRegister("cKmqq", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $d8562d1d605931b4$export$a45c0cd714a4dbaa);
const $d8562d1d605931b4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("jqf1q", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $bdfe01e15b6de5db$export$470a2ff46db8cee8);

var $br1pC = parcelRequire("br1pC");

var $gbi1O = parcelRequire("gbi1O");

var $cKmqq = parcelRequire("cKmqq");
// We want a consistent scroll speed across devices, regardless of framerate
function $bdfe01e15b6de5db$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $bdfe01e15b6de5db$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $br1pC.axisLookup)[axis];
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $gbi1O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $bdfe01e15b6de5db$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $bdfe01e15b6de5db$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $bdfe01e15b6de5db$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $gbi1O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $cKmqq.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("gbi1O", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $694f9e529fce8a4a$export$1a29de000a332d74);
function $694f9e529fce8a4a$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("B7xXV", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $838c24923fe49251$export$7120fdbd90bd1292);
function $838c24923fe49251$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("kMdkl", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $76ef8eaf125506fe$export$cda7a9d4399bf2e3);
function $76ef8eaf125506fe$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("i0nxo", function(module, exports) {

$parcel$export(module.exports, "getPresenceNodeId", () => $0ed5d5739c577dad$export$b31325f2ad6cf0b5);
const $0ed5d5739c577dad$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;

});

parcelRegister("4TJj0", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $8f55868fdda87f4e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3BgyA = parcelRequire("3BgyA");

const $8f55868fdda87f4e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $8f55868fdda87f4e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $daf44b44f86c0150$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $8f55868fdda87f4e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $8f55868fdda87f4e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $8f55868fdda87f4e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $8f55868fdda87f4e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $8f55868fdda87f4e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $3BgyA.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $8f55868fdda87f4e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $8f55868fdda87f4e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $8f55868fdda87f4e$var$actions = {
    setProvider: $8f55868fdda87f4e$var$setProvider,
    participantsLeft: $8f55868fdda87f4e$var$participantsLeft,
    participantsJoined: $8f55868fdda87f4e$var$participantsJoined,
    updateUserInParticipants: $8f55868fdda87f4e$var$updateUserInParticipants,
    sendNodeSelected: $8f55868fdda87f4e$var$sendNodeSelected,
    sendClearNodeSelection: $8f55868fdda87f4e$var$sendClearNodeSelection,
    setNodeSelection: $8f55868fdda87f4e$var$setNodeSelection,
    clearNodeSelection: $8f55868fdda87f4e$var$clearNodeSelection,
    stopDragAnimation: $8f55868fdda87f4e$var$stopDragAnimation
};
const $8f55868fdda87f4e$var$Store = (0, $a61MH.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $8f55868fdda87f4e$var$actions,
    name: 'JWMCollabStore'
});
const $8f55868fdda87f4e$export$4159ae80cfa2156 = (0, $ggKAj.createHook)($8f55868fdda87f4e$var$Store);

});
parcelRegister("3BgyA", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $9bfc0522bb35e6c9$export$137ec5185b12f5a2);

var $PdmhA = parcelRequire("PdmhA");
const $9bfc0522bb35e6c9$var$colors = [
    (0, $PdmhA).R300,
    (0, $PdmhA).R400,
    (0, $PdmhA).R500,
    (0, $PdmhA).Y300,
    (0, $PdmhA).Y400,
    (0, $PdmhA).Y500,
    (0, $PdmhA).G300,
    (0, $PdmhA).G400,
    (0, $PdmhA).G500,
    (0, $PdmhA).T300,
    (0, $PdmhA).T400,
    (0, $PdmhA).T500,
    (0, $PdmhA).B300,
    (0, $PdmhA).B400,
    (0, $PdmhA).B500,
    (0, $PdmhA).P300,
    (0, $PdmhA).P400,
    (0, $PdmhA).P500,
    (0, $PdmhA).N200,
    (0, $PdmhA).N500,
    (0, $PdmhA).N800
];
const $9bfc0522bb35e6c9$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $9bfc0522bb35e6c9$var$colors.length;
    return {
        index: index,
        color: $9bfc0522bb35e6c9$var$colors[index]
    };
};

});

const $daf44b44f86c0150$export$3debf01bbfa135e5 = 80;


parcelRegister("3JiQx", function(module, exports) {

$parcel$export(module.exports, "BusinessRealtime", () => $b046e6744d314566$export$3a36519ab0aab897);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fEYK5 = parcelRequire("fEYK5");

var $giZl9 = parcelRequire("giZl9");
var $kUiXU = parcelRequire("kUiXU");

var $dWLk9 = parcelRequire("dWLk9");

var $ePgRW = parcelRequire("ePgRW");
const $b046e6744d314566$var$DEFAULT_EVENTS_TO_SUBSCRIBE_TO = [
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60)
];
const $b046e6744d314566$export$3a36519ab0aab897 = ({ appId: appId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = $b046e6744d314566$var$DEFAULT_EVENTS_TO_SUBSCRIBE_TO })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const realtimeIds = (0, $ePgRW.useRealtimeContext)();
    const realtimeChannels = (0, $eUqFw.useMemo)(()=>realtimeIds.map((pid)=>(0, $giZl9.buildChannelString)(cloudId, pid)), [
        cloudId,
        realtimeIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUiXU.default), {
        appId: appId,
        channels: realtimeChannels,
        events: eventsToSubscribeTo,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: (event)=>{
            if (!(0, $fEYK5.isPageVisible)()) return;
            onReceive(event);
        },
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });
};

});
parcelRegister("giZl9", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $5615d21da29bd94b$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $5615d21da29bd94b$export$354e43de513ff5);

var $6rW04 = parcelRequire("6rW04");

const $5615d21da29bd94b$export$f795b2d9ba365882 = ()=>(0, $6rW04.default)('ajs-fabric-realtime-url') || (0, $b0799f8f855a2fe4$export$92ffb25149c24a33);
const $5615d21da29bd94b$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});
const $b0799f8f855a2fe4$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $b0799f8f855a2fe4$export$13ac40d1a5475532 = 'JIRA';


parcelRegister("kUiXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $762b47cb6f205076$export$2e2bcd8739ae039);

var $6heO3 = parcelRequire("6heO3");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");


var $giZl9 = parcelRequire("giZl9");
var $762b47cb6f205076$export$2e2bcd8739ae039 = (0, $6heO3.default);

});
parcelRegister("6heO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb89aa8c6039d680$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fLHAD = parcelRequire("fLHAD");

var $2W6nG = parcelRequire("2W6nG");
class $eb89aa8c6039d680$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W6nG.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLHAD.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args);
        this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        };
    }
}

});
parcelRegister("fLHAD", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $42b77c4aa56216fa$export$e680ceb7b9fcc184);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $efKIh = parcelRequire("efKIh");

var $6yVT4 = parcelRequire("6yVT4");
// eslint-disable-next-line jira/react/no-class-components
class $42b77c4aa56216fa$var$RealtimeClientView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $42b77c4aa56216fa$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $42b77c4aa56216fa$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($42b77c4aa56216fa$var$withAnalytics, (0, $6yVT4.withPubSubClient), (0, $efKIh.asClientOnly))($42b77c4aa56216fa$var$RealtimeClientView);
var $42b77c4aa56216fa$export$2e2bcd8739ae039 = $42b77c4aa56216fa$export$e680ceb7b9fcc184;

});
parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("efKIh", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $4874a35f2e3af873$export$95cd02374de3431);

var $eUqFw = parcelRequire("eUqFw");
function $4874a35f2e3af873$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $4874a35f2e3af873$export$2e2bcd8739ae039 = $4874a35f2e3af873$export$95cd02374de3431;

});

parcelRegister("6yVT4", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $4857e418d88b13dd$export$32d968d4900ae3cd);

var $eUqFw = parcelRequire("eUqFw");

var $e97Bh = parcelRequire("e97Bh");
function $4857e418d88b13dd$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $4857e418d88b13dd$export$2e2bcd8739ae039 = $4857e418d88b13dd$export$32d968d4900ae3cd;

});
parcelRegister("e97Bh", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4f1fb1ba24fc84ec$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");
const $4f1fb1ba24fc84ec$var$defaultContext = {
    client: null
};
const { Provider: $4f1fb1ba24fc84ec$export$2881499e37b75b9a, Consumer: $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)($4f1fb1ba24fc84ec$var$defaultContext);

});



parcelRegister("2W6nG", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $ba1d3670c80098a4$export$64d242981d970821);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $g8JvH = parcelRequire("g8JvH");

var $3FyZ4 = parcelRequire("3FyZ4");


var $e97Bh = parcelRequire("e97Bh");

var $eBLah = parcelRequire("eBLah");

var $eDbRL = parcelRequire("eDbRL");

const $ba1d3670c80098a4$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("gewAB")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $b0799f8f855a2fe4$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $ba1d3670c80098a4$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $ba1d3670c80098a4$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $ba1d3670c80098a4$var$RealtimeProviderView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            host: (0, $b0799f8f855a2fe4$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((analyticsClient)=>$ba1d3670c80098a4$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$ba1d3670c80098a4$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $ba1d3670c80098a4$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $ba1d3670c80098a4$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $ba1d3670c80098a4$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($ba1d3670c80098a4$var$withAnalytics, (0, $eBLah.withHost), (0, $eDbRL.withRuntimeProvider))($ba1d3670c80098a4$var$RealtimeProviderView);
var $ba1d3670c80098a4$export$2e2bcd8739ae039 = $ba1d3670c80098a4$export$64d242981d970821;

});
parcelRegister("eBLah", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $bd78fcaaefe05a83$export$b2d89aaea1461cd9);

var $eUqFw = parcelRequire("eUqFw");

var $giZl9 = parcelRequire("giZl9");
function $bd78fcaaefe05a83$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            host: (0, $giZl9.getDefaultPubSubHost)()
        });
}
var $bd78fcaaefe05a83$export$2e2bcd8739ae039 = $bd78fcaaefe05a83$export$b2d89aaea1461cd9;

});

parcelRegister("eDbRL", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $e49daff82a9a2253$export$4b38d0b01368c3f4);

var $eUqFw = parcelRequire("eUqFw");
function $e49daff82a9a2253$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $e49daff82a9a2253$export$2e2bcd8739ae039 = $e49daff82a9a2253$export$4b38d0b01368c3f4;

});

parcelRegister("gewAB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('acEmi');
        const value = parcelRequire('3S62s');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("acEmi").then(()=>parcelRequire('3S62s'));
}

});



const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';



parcelRegister("kiBzn", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $a505eae840e121fb$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");
parcelRequire("hgbp4");
var $e9Rfo = parcelRequire("e9Rfo");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $dG4cR = parcelRequire("dG4cR");

var $9rrf5 = parcelRequire("9rrf5");
const $a505eae840e121fb$export$e911425bb76dd69e = ({ reason: reason })=>{
    // @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
    const { updateQueryParam: updateQueryParam } = (0, $kJlBc.useRouterActions)();
    const [, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        // persist that the user has cleared filters in view preferences
        // but do not push the change to the URL as we're already pushing a history state
        // to clear both filters and simple search below
        setFilters(undefined, 'none');
        updateQueryParam({
            filter: undefined,
            quickFilters: undefined,
            [(0, $dG4cR.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'push');
    }, [
        updateQueryParam,
        setFilters
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $9rrf5.default).invalidStateHeading) : formatMessage((0, $9rrf5.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a505eae840e121fb$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e9Rfo))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $9rrf5.default).clearFiltersButton)));
};
const $a505eae840e121fb$var$wrapperStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a505eae840e121fb$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $a505eae840e121fb$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e9Rfo")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $i647H = parcelRequire("i647H");

var $e9Rfo = parcelRequire("e9Rfo");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e9Rfo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($i647H))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("i647H", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("e9Rfo", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("9rrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8fd0b56fda09200$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8fd0b56fda09200$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("jvtK3", function(module, exports) {

$parcel$export(module.exports, "GqlsRealtime", () => $98ac3be71dbce786$export$ad092969d774a1ab);

var $eUqFw = parcelRequire("eUqFw");

var $ePgRW = parcelRequire("ePgRW");

var $4G5xU = parcelRequire("4G5xU");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $7SlEV = parcelRequire("7SlEV");

var $39J28 = parcelRequire("39J28");

var $jG3N9 = parcelRequire("jG3N9");

var $55JiT = parcelRequire("55JiT");

var $bqvPy = parcelRequire("bqvPy");
const $98ac3be71dbce786$export$ad092969d774a1ab = /*#__PURE__*/ (0, $eUqFw.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, $7SlEV.DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const siteId = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const realtimeIds = (0, $ePgRW.useRealtimeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const createSubsExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const realtimeEventExperienceStart = (0, $4G5xU.useExperienceStart)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceFail = (0, $4G5xU.useExperienceFail)((0, $7SlEV.REALTIME_EVENT_EXPERIENCE));
    createSubsExperienceStart();
    // We need to be careful not to re-trigger the subscriptions useMemo, as this
    // causes new subscribe messages to be sent over the WS, which we only want to
    // happen when something directly related to the subscription changes
    // So we are using Refs to prevent the handleReceive function from changing too much
    const extraEventDataRef = (0, $eUqFw.useRef)({
        appId: appId,
        entityId: entityId
    });
    extraEventDataRef.current.appId = appId;
    extraEventDataRef.current.entityId = entityId;
    const onReceiveRef = (0, $eUqFw.useRef)(onReceive);
    onReceiveRef.current = onReceive;
    const handleReceive = (0, $eUqFw.useCallback)((event)=>{
        realtimeEventExperienceStart();
        try {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                ...extraEventDataRef.current,
                realtimeEvent: event.type
            });
            onReceiveRef.current(event);
            realtimeEventExperienceSuccess({
                realtimeEvent: event.type
            });
        } catch (error) {
            realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            error, {
                realtimeEvent: event.type
            });
        }
    }, [
        createAnalyticsEvent,
        realtimeEventExperienceStart,
        realtimeEventExperienceSuccess,
        realtimeEventExperienceFail
    ]);
    const handleReactError = (0, $eUqFw.useCallback)((_location, error, event)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
        createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
    }, [
        createAnalyticsEvent,
        createSubsExperienceFail
    ]);
    const handleSubscriptionError = (0, $eUqFw.useCallback)((errorMessage, operationName)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
            errorMessage: errorMessage,
            operationName: operationName,
            ...extraEventDataRef.current
        });
    }, [
        createAnalyticsEvent
    ]);
    const subscriptions = (0, $eUqFw.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqvPy.UpdateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39J28.CreateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG3N9.DeleteIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55JiT.FieldMutationSubscription), {
                siteId: siteId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }))), [
        cloudId,
        siteId,
        realtimeIds,
        eventsToSubscribeTo,
        handleReceive,
        handleSubscriptionError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const realtimeEvents = {
            issueCreated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_CREATED_EVENT)),
            issueUpdated: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_UPDATED_EVENT)),
            issueDeleted: eventsToSubscribeTo.includes((0, $7SlEV.ISSUE_DELETED_EVENT)),
            fieldMutation: eventsToSubscribeTo.includes((0, $7SlEV.FIELD_MUTATION_EVENT))
        };
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
            ...extraEventDataRef.current,
            ...realtimeEvents,
            subscriptions: realtimeIds.length * eventsToSubscribeTo.length
        });
        createSubsExperienceSuccess();
    }, [
        subscriptions,
        createAnalyticsEvent,
        realtimeIds,
        eventsToSubscribeTo,
        createSubsExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
        const extraEventData = extraEventDataRef.current;
        return ()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "gqlsRealtime",
        packageName: "jiraBusinessGqlsRealtime",
        extraEventData: extraEventDataRef.current,
        onError: handleReactError
    }, subscriptions);
});

});
parcelRegister("7SlEV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $dbd458bd7de773e3$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $dbd458bd7de773e3$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $dbd458bd7de773e3$export$b22142e61b3fdbee);
$parcel$export(module.exports, "FIELD_MUTATION_EVENT", () => $dbd458bd7de773e3$export$eddbca92a5bee91f);
$parcel$export(module.exports, "ISSUE_EVENTS", () => $dbd458bd7de773e3$export$f01b4f4e297998a0);
$parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", () => $dbd458bd7de773e3$export$edc58098c8ddf4cb);
$parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", () => $dbd458bd7de773e3$export$75b82bac1ec985d9);
$parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", () => $dbd458bd7de773e3$export$245947dc0e8c134b);
const $dbd458bd7de773e3$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $dbd458bd7de773e3$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $dbd458bd7de773e3$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $dbd458bd7de773e3$export$eddbca92a5bee91f = 'avi:jira:field:updated';
const $dbd458bd7de773e3$export$f01b4f4e297998a0 = [
    $dbd458bd7de773e3$export$b22a14d5dac59664,
    $dbd458bd7de773e3$export$25fa37e5059c5a99,
    $dbd458bd7de773e3$export$b22142e61b3fdbee
];
const $dbd458bd7de773e3$export$edc58098c8ddf4cb = $dbd458bd7de773e3$export$f01b4f4e297998a0;
const $dbd458bd7de773e3$export$b8b9d90f9e5bd72b = 'jiraBusinessGqlsRealtime';
const $dbd458bd7de773e3$export$75b82bac1ec985d9 = {
    experience: 'createSubscriptions',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $dbd458bd7de773e3$export$245947dc0e8c134b = {
    experience: 'realtimeEvent',
    packageName: $dbd458bd7de773e3$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};

});

parcelRegister("39J28", function(module, exports) {

$parcel$export(module.exports, "CreateIssueSubscription", () => $4eeb3c77e3051e63$export$7876efe7a86fd4f1);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $4eeb3c77e3051e63$var$operationName = 'JwmIssueCreatedSubscription';
const $4eeb3c77e3051e63$export$7876efe7a86fd4f1 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $f6f4d62eefeaafa1$export$89cddb5ca4c806e4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $4eeb3c77e3051e63$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $4eeb3c77e3051e63$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueCreatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_CREATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
parcelRegister("fEePJ", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $a854284f214cc1d7$export$d3d523392640272);

var $eUqFw = parcelRequire("eUqFw");

var $fEYK5 = parcelRequire("fEYK5");

var $guiFP = parcelRequire("guiFP");

var $keguF = parcelRequire("keguF");


var $eliQU = parcelRequire("eliQU");

var $dIOaC = parcelRequire("dIOaC");

var $lE8MM = parcelRequire("lE8MM");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a854284f214cc1d7$var$noop = ()=>{};
const $a854284f214cc1d7$var$subscribe = (payload, sink)=>{
    const client = (0, $dIOaC.getClient)();
    if (!client) return;
    const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
    const { next: next, error: error, complete: complete = $a854284f214cc1d7$var$noop } = sink;
    let requestId;
    return client.subscribe({
        query: query,
        variables: variables,
        operationName: operationName,
        extensions: {
            ...extensions ?? {}
        }
    }, {
        next: (value)=>{
            // @ts-expect-error agg prop is missing on generic "extensions" type
            const aggRequestId = value?.extensions?.agg?.request_id;
            if (aggRequestId) requestId = aggRequestId;
            // @ts-expect-error incompatible types between two libraries
            next(value);
        },
        complete: complete,
        error: (sinkError)=>{
            const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
            const attributes = {
                operationName: operationName,
                requestId: requestId,
                userLocation: (0, $keguF.getUserLocation)()
            };
            error?.(errorInfo, attributes);
            (0, $guiFP.default)({
                meta: {
                    id: 'subscription',
                    packageName: 'jiraGraphqlSubscription',
                    teamName: 'uip-graphql'
                },
                error: errorInfo,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $a854284f214cc1d7$export$d3d523392640272 = (payload, sink)=>{
    (0, $eUqFw.useEffect)(()=>{
        let unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
        let timeout;
        const onVisibilityChange = ()=>{
            if ((0, $fEYK5.isPageVisible)()) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                } else unsubscribe = $a854284f214cc1d7$var$subscribe(payload, sink);
            } else if (!timeout) timeout = setTimeout(()=>{
                unsubscribe?.();
                unsubscribe = undefined;
                timeout = undefined;
            }, (0, $12457a63a9fa501a$export$1ad8434180c5936c));
        };
        if (!(0, $eliQU.isSSR)()) window.addEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
        return ()=>{
            window.removeEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChange);
            unsubscribe?.();
        };
    }, [
        payload,
        sink
    ]);
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m


parcelRegister("h02O8", function(module, exports) {

$parcel$export(module.exports, "isIssueEvent", () => $8984b81df6dead57$export$734ba008b9d9e61c);
$parcel$export(module.exports, "getResponseError", () => $8984b81df6dead57$export$135f2bf83a3d73b1);

var $7SlEV = parcelRequire("7SlEV");
const $8984b81df6dead57$export$734ba008b9d9e61c = (event)=>(0, $7SlEV.ISSUE_EVENTS).includes(event.type);
const $8984b81df6dead57$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;

});

const $f6f4d62eefeaafa1$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;


parcelRegister("jG3N9", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueSubscription", () => $ff6bd8b7c30a306f$export$cba4fc39801f6792);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $huI7r = parcelRequire("huI7r");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $ff6bd8b7c30a306f$var$operationName = 'JwmIssueDeletedSubscription';
const $ff6bd8b7c30a306f$export$cba4fc39801f6792 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $91d960b142a4aa36$export$9c299c317f46fdc4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $ff6bd8b7c30a306f$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $ff6bd8b7c30a306f$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueDeletedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_DELETED_EVENT),
                    payload: {
                        ...payload,
                        issueId: (0, $huI7r.getAriConfig)(payload.resource).resourceId
                    }
                });
            }
        }
    });
    return null;
});

});
const $91d960b142a4aa36$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) {
        resource
      }
    }
  }
`;


parcelRegister("55JiT", function(module, exports) {

$parcel$export(module.exports, "FieldMutationSubscription", () => $0c96b6eb3ca20eae$export$d82ea923ea48fa52);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $0c96b6eb3ca20eae$var$operationName = 'JwmFieldMutationSubscription';
const $0c96b6eb3ca20eae$export$d82ea923ea48fa52 = /*#__PURE__*/ (0, $eUqFw.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $993d2190e4ed31a0$export$2e75a8174f7cddb8),
        operationName: $0c96b6eb3ca20eae$var$operationName,
        variables: {
            siteId: siteId
        }
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $0c96b6eb3ca20eae$var$operationName);
            else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                type: (0, $7SlEV.FIELD_MUTATION_EVENT),
                payload: {}
            });
        }
    });
    return null;
});

});
const $993d2190e4ed31a0$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;


parcelRegister("bqvPy", function(module, exports) {

$parcel$export(module.exports, "UpdateIssueSubscription", () => $d3e4df2394577653$export$51fac6481c0b4595);

var $eUqFw = parcelRequire("eUqFw");

var $fEePJ = parcelRequire("fEePJ");

var $7SlEV = parcelRequire("7SlEV");

var $h02O8 = parcelRequire("h02O8");

const $d3e4df2394577653$var$operationName = 'JwmIssueUpdatedSubscription';
const $d3e4df2394577653$export$51fac6481c0b4595 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $fEePJ.useSubscribe)({
        query: (0, $4aae5f340c4dce10$export$54c41e3133084b81),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $d3e4df2394577653$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $h02O8.getResponseError)(value);
            if (error) onError(error, $d3e4df2394577653$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueUpdatedByProject;
                if (payload) onReceive({
                    type: (0, $7SlEV.ISSUE_UPDATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
const $4aae5f340c4dce10$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;



parcelRegister("kHnEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cc12293a50ce22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");


var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $jK1pm = parcelRequire("jK1pm");

var $fibAs = parcelRequire("fibAs");

const $f3cc12293a50ce22$export$843a6e93936e3b60 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dQVrX")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $f3cc12293a50ce22$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $0100842672acae20$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [, { switchToModal: switchToModal, switchToSidebar: switchToSidebar }] = (0, $fibAs.useIssueAppSwitcher)();
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('refactor-bento-view-mode-logic')) {
            setDetailViewAsModal();
            setSidebarContent(null);
        } else switchToModal();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        switchToModal,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('refactor-bento-view-mode-logic')) {
            setSidebarContent(null);
            setDetailViewAsSidebar();
        } else switchToSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        switchToSidebar,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $eUqFw.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3cc12293a50ce22$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $f3cc12293a50ce22$export$2e2bcd8739ae039 = $f3cc12293a50ce22$var$ModalIssueAppWrapper;

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $8Bhia = parcelRequire("8Bhia");

var $lDYuK = parcelRequire("lDYuK");

var $idwtd = parcelRequire("idwtd");

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04)) : (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_MODAL));
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $935e771f19f8ea28$export$98c0ebc22792f04) : (0, $idwtd.DETAIL_VIEW_MODAL)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040)) : (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_SIDEBAR));
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $935e771f19f8ea28$export$705305d6da432040) : (0, $idwtd.DETAIL_VIEW_SIDEBAR)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $fhgeS.getViewModeFromLocalStorage)() : (0, $lDYuK.getBoardDetailViewMode)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("8Bhia", function(module, exports) {

$parcel$export(module.exports, "isAllPerfFeatureFlagsEnabled", () => $706d7ea06981f598$export$a9f38f9f0d6f10af);
$parcel$export(module.exports, "isChildIssuePanelConfigurationEnabled", () => $706d7ea06981f598$export$b5be9eaa7fce369);
$parcel$export(module.exports, "isIssueViewCommentRender", () => $706d7ea06981f598$export$9e18785497c1673b);
$parcel$export(module.exports, "isIssueViewCommentFetch", () => $706d7ea06981f598$export$35c0c8db33387f4d);
$parcel$export(module.exports, "isEcosystemLeftPanel", () => $706d7ea06981f598$export$6e4f76cd76a804da);
$parcel$export(module.exports, "isQuickActionExperimentFF", () => $706d7ea06981f598$export$7f7b600c4eafe68f);
$parcel$export(module.exports, "isDataClassificationEnabled", () => $706d7ea06981f598$export$c8aa8a13c42858dd);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerLinkedIssueEnabled", () => $706d7ea06981f598$export$3041d162b6562717);
$parcel$export(module.exports, "isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled", () => $706d7ea06981f598$export$7af43b56ceb4b148);
$parcel$export(module.exports, "isIssueViewActivityFeedUIFixesEnabled", () => $706d7ea06981f598$export$11c3bd37c4149e8a);
$parcel$export(module.exports, "isRelayCascadingSelectFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$91d9e9331bcb489f);
$parcel$export(module.exports, "isIssueViewMigratedStreamEnabled", () => $706d7ea06981f598$export$4bef98bf98ff2cb);
$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $706d7ea06981f598$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $706d7ea06981f598$export$183bff9fcee964a2);
$parcel$export(module.exports, "isIssueViewAdminGlobalOptInAiEnabled", () => $706d7ea06981f598$export$a42a9ff4a537eac1);
$parcel$export(module.exports, "isJiraIntelligentIssueBreakdownEnabled", () => $706d7ea06981f598$export$bb7bcfe9ba7992e5);
$parcel$export(module.exports, "isJiraSmartSummaryPlatformEnabled", () => $706d7ea06981f598$export$be02cc41570f884f);
$parcel$export(module.exports, "isJiraAIWorkBreakdownOnboardingEnabled", () => $706d7ea06981f598$export$25f1a380ac523ab1);
$parcel$export(module.exports, "isIssueTypeSelectHierarchyFixEnabled", () => $706d7ea06981f598$export$b9ecdb2af6d8a25);
$parcel$export(module.exports, "isShardAndRegionToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$a1b2fc5741a7de01);
$parcel$export(module.exports, "isFeatureFlagsToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$b1c6c927b1de3746);
$parcel$export(module.exports, "isJiraAiWorkBreakdownDisclaimerUpdateEnabled", () => $706d7ea06981f598$export$3694fdeb5d384181);
$parcel$export(module.exports, "isA11yForIssueKeyStrikethroughEnabled", () => $706d7ea06981f598$export$4166161ebaa7c45b);
$parcel$export(module.exports, "isIssueViewRemoveConnectOperationsFromCriticalFetchEnabled", () => $706d7ea06981f598$export$c3e066f7be7868e8);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $706d7ea06981f598$export$a3e5d5dfe1ed90ed);
$parcel$export(module.exports, "isTeamsCustomFieldTypeEnabled", () => $706d7ea06981f598$export$d7d142f5ac020394);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $706d7ea06981f598$export$cdd5c612352d7bf0);
$parcel$export(module.exports, "getInviteFromAssignModalCohort", () => $706d7ea06981f598$export$5b9220081498abd7);
$parcel$export(module.exports, "isInviteFromAssignModalFeEnabled", () => $706d7ea06981f598$export$89f18660d3a3bb78);
$parcel$export(module.exports, "isFedRampCheckEnabled", () => $706d7ea06981f598$export$dd98acc8d28f3c1e);
$parcel$export(module.exports, "isStoryPointAnalyticsEnabled", () => $706d7ea06981f598$export$f0ece2538dd9e423);
$parcel$export(module.exports, "isTrelloCardIntegrationPatch", () => $706d7ea06981f598$export$ca7c31f03d6e8f02);
$parcel$export(module.exports, "isNewEditorAiFeedbackCollectorEnabled", () => $706d7ea06981f598$export$2ed16947150cc8c);
$parcel$export(module.exports, "isIssueCommentsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$dcc4742bc52ec465);
$parcel$export(module.exports, "isIssueWorklogsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$fa2b2d3091ee4acb);
$parcel$export(module.exports, "isIssueConfluenceLinksHardLimitsFlagEnabled", () => $706d7ea06981f598$export$8138f2ec6e2b730c);
$parcel$export(module.exports, "isNotifyAdminModalHardLimitsEnabled", () => $706d7ea06981f598$export$b014ef5adbdaef11);
$parcel$export(module.exports, "isSmartSummariesNewDisclaimerEnabled", () => $706d7ea06981f598$export$d6f2a732166d94ed);
$parcel$export(module.exports, "issueDetailsHardLimitsMilestone1Enabled", () => $706d7ea06981f598$export$d0ed2d8440fb5bbc);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueRemoteLinkEnabled", () => $706d7ea06981f598$export$41470180bace44ba);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueAttachmentsEnabled", () => $706d7ea06981f598$export$9a5cf06e051f6deb);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueWeblinksEnabled", () => $706d7ea06981f598$export$e3bcb7ed6340e909);
$parcel$export(module.exports, "isChangeboardingForParentEnabled", () => $706d7ea06981f598$export$a0e01c32249a7097);
$parcel$export(module.exports, "isOptimisticWeblinksFixEnabled", () => $706d7ea06981f598$export$dbaa92a1f690c8fe);
$parcel$export(module.exports, "getPerformanceTrackingConfiguration", () => $706d7ea06981f598$export$78dd97cfaffb6fb1);
$parcel$export(module.exports, "getValidTransactionsTrackingConfiguration", () => $706d7ea06981f598$export$a801da94b6dd586b);
$parcel$export(module.exports, "isEditorUFOEnabled", () => $706d7ea06981f598$export$fd99e03c299972d3);
$parcel$export(module.exports, "getTTRSeverityTrackingConfiguration", () => $706d7ea06981f598$export$6fb6e5d98b15585b);
$parcel$export(module.exports, "getUnsupportedContentLevelsTrackingConfiguration", () => $706d7ea06981f598$export$eccecfefbd48225b);
$parcel$export(module.exports, "isSpecBasedValidatorEnabled", () => $706d7ea06981f598$export$ef24e9eecc594777);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$67305b99ef59566c);
$parcel$export(module.exports, "isCreateLinkedIssueTriggerPointEnabled", () => $706d7ea06981f598$export$fa44fb942e45b85d);
$parcel$export(module.exports, "isModernGlobalSubtaskIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$9ba0da55e7f403e1);
$parcel$export(module.exports, "isModernGICEnabledForSubtask", () => $706d7ea06981f598$export$dbaf42ba39b66293);
$parcel$export(module.exports, "isProformaHarmonisationFFEnabled", () => $706d7ea06981f598$export$5dc774c58824d858);
$parcel$export(module.exports, "isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled", () => $706d7ea06981f598$export$73957227bab0d3f7);
$parcel$export(module.exports, "isDisableEpicLinkAndParentLinkFieldsEnabled", () => $706d7ea06981f598$export$dd5401dbc8bdbdfb);
$parcel$export(module.exports, "isRequestIsDoneWhenRequestingParentCandidatesEnabled", () => $706d7ea06981f598$export$c197f8974183a4f0);
$parcel$export(module.exports, "isRemoveParentLinkFromIssueViewEnabled", () => $706d7ea06981f598$export$6e06c78fd874f07f);
$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $706d7ea06981f598$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isIncrementPlanningM1Enabled", () => $706d7ea06981f598$export$33e603f2e83329f5);
$parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", () => $706d7ea06981f598$export$a73c9c09ec24e5e9);
$parcel$export(module.exports, "isPlaceHolderTemplateE2EEnabled", () => $706d7ea06981f598$export$4df93ecfbfdca877);
$parcel$export(module.exports, "isIssueViewEndUserRequestTrialEnabled", () => $706d7ea06981f598$export$bfc00b5a0f36c863);
$parcel$export(module.exports, "isCompalIssueActionsEnabled", () => $706d7ea06981f598$export$641196cc6a6481ea);
$parcel$export(module.exports, "isCompalIssueActionsFollowUpImprovementsEnabled", () => $706d7ea06981f598$export$7c0bd221ecbf9b57);
$parcel$export(module.exports, "isCompalIssueActionsVeryHighPriorityEnabled", () => $706d7ea06981f598$export$d5d401f0a31e62ea);
$parcel$export(module.exports, "isSelectableFieldEditViewIntegrationEnabled", () => $706d7ea06981f598$export$e253ac70cea0d36b);
$parcel$export(module.exports, "isHistoryActivityFeedAttachmentUpdatesEnabled", () => $706d7ea06981f598$export$ca654183a67f7c1d);
$parcel$export(module.exports, "isRemoveIssueAttachmentPanelViewedEventEnabled", () => $706d7ea06981f598$export$ecfec49bad872d16);
$parcel$export(module.exports, "isFetchingRequiredFieldOnRenderEnabled", () => $706d7ea06981f598$export$fe59b559919ee088);
$parcel$export(module.exports, "isJiraSmartSummaryOnboardingEnabled", () => $706d7ea06981f598$export$5194de77e8750c41);
$parcel$export(module.exports, "isJiraSmartSummaryAIMateEndpointEnabled", () => $706d7ea06981f598$export$3cfaae79d46ba7ee);
$parcel$export(module.exports, "isDefinitionCheckConfluenceAccessEnabled", () => $706d7ea06981f598$export$edfcfe610bd14d1);
$parcel$export(module.exports, "IsAIWorkBreakdownNewUiEnabled", () => $706d7ea06981f598$export$34d90e61db572fb4);
$parcel$export(module.exports, "isStatusInGicEnabled", () => $706d7ea06981f598$export$30cd538422d6ae26);
$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $706d7ea06981f598$export$7e4aef4ae0b914e2);
$parcel$export(module.exports, "isAltTextOnImagesEnabled", () => $706d7ea06981f598$export$9591540fa082da5a);
$parcel$export(module.exports, "useM4LayoutDataInBentoConsistencyCheckValue", () => $706d7ea06981f598$export$df603fd34aea93ca);
$parcel$export(module.exports, "ISSUE_DETAILS_SORTING_PINNED_FIELDS", () => $706d7ea06981f598$export$e6ec1a9a62cbf071);
$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $706d7ea06981f598$export$cce5c39a2a1dacf1);
$parcel$export(module.exports, "getEnableFlexibleBlockCardInIssueEditor", () => $706d7ea06981f598$export$408491224a0c915b);
$parcel$export(module.exports, "isTeamFieldInSubtasksEnabled", () => $706d7ea06981f598$export$150e448c819201a7);
$parcel$export(module.exports, "isOfferingCatalogueFeaturesEnabled", () => $706d7ea06981f598$export$369fa0ed6b2504fb);
$parcel$export(module.exports, "isRendererTtiTrackingEnabled", () => $706d7ea06981f598$export$b236d4b6aec7c4c3);
$parcel$export(module.exports, "isPriorityFieldTooltipEnabled", () => $706d7ea06981f598$export$a792a3f88a852f06);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $706d7ea06981f598$export$575e1bf822db15b5);
$parcel$export(module.exports, "isCannedResponseFFEnabled", () => $706d7ea06981f598$export$9f71233b08c04922);
$parcel$export(module.exports, "isSignatureCrFFEnabled", () => $706d7ea06981f598$export$8521761ebcf26351);
$parcel$export(module.exports, "isRespondersFieldAvailableInAllProjectsEnabled", () => $706d7ea06981f598$export$6f0be57bd65ee8bc);
$parcel$export(module.exports, "isEcClientEnabled", () => $706d7ea06981f598$export$e3bafd4acea73c60);
$parcel$export(module.exports, "isOverrideCreationDateEnabled", () => $706d7ea06981f598$export$dda3a2d16a2e0a31);
$parcel$export(module.exports, "isDeleteissueViewMetricsEnabled", () => $706d7ea06981f598$export$fad47591ae56c23f);
$parcel$export(module.exports, "is4xxRequestsIgnoreEnabled", () => $706d7ea06981f598$export$6d1f8ae8cf9bbc71);
$parcel$export(module.exports, "isMiddleClickFixEnabled", () => $706d7ea06981f598$export$7dbe34739b0d70b8);
$parcel$export(module.exports, "isLogForMissingProjectTypeEnabled", () => $706d7ea06981f598$export$3fa1b10a7b484874);
$parcel$export(module.exports, "isGiraAGGIsArchivedEnabled", () => $706d7ea06981f598$export$6604067817758030);
$parcel$export(module.exports, "isArchivedIssuesPageLinkEnabled", () => $706d7ea06981f598$export$c108c03095e0e655);
$parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", () => $706d7ea06981f598$export$ee410f0ba32dc900);
$parcel$export(module.exports, "isCustomMessageForLinkingWithoutPermissionsEnabled", () => $706d7ea06981f598$export$3068bf83bd6f9396);
$parcel$export(module.exports, "isSearchByEmailInMultiselectUserPickerEnabled", () => $706d7ea06981f598$export$da019fa3d31e5c7e);
$parcel$export(module.exports, "isRelayReleaseVersionFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$48d407f97269c8fa);
$parcel$export(module.exports, "isAsyncFieldOptionsTechDebtEnabled", () => $706d7ea06981f598$export$8a90e3b075447800);
$parcel$export(module.exports, "isJsmFixIncompatibleRequestTypeInconsistenciesEnabled", () => $706d7ea06981f598$export$733566d04cfe61b1);
$parcel$export(module.exports, "PlaceHolderTemplateFlags", () => $706d7ea06981f598$export$bf10032e4a734a65);
$parcel$export(module.exports, "getPlaceHolderTemplateVariant", () => $706d7ea06981f598$export$fb512d5beec30a90);
$parcel$export(module.exports, "isConfluencePageDummyLinkExperiment", () => $706d7ea06981f598$export$6e7dfb06c9e45ae7);
$parcel$export(module.exports, "isConfluencePageDummyLinkEnabled", () => $706d7ea06981f598$export$ef28379ba310de6e);
$parcel$export(module.exports, "isStopLoadingFieldConfigTwiceEnabled", () => $706d7ea06981f598$export$98dcb5ffd7beaf00);
$parcel$export(module.exports, "isNonCriticalGiraQueryExperienceTrackingEnabled", () => $706d7ea06981f598$export$8ea052ed520b62bc);
$parcel$export(module.exports, "isFilterIssueChangedEvents", () => $706d7ea06981f598$export$d616286874a25f83);
$parcel$export(module.exports, "isJiraForgeExtensionChangesForAegisEnabled", () => $706d7ea06981f598$export$496e94e3da873a49);
$parcel$export(module.exports, "isDisableUnneededForgeMetricsEnabled", () => $706d7ea06981f598$export$cd0e0ab900757d23);
$parcel$export(module.exports, "isAnotherExtensionContextForForgeBackgroundScriptsEnabled", () => $706d7ea06981f598$export$ea998c148f057985);
$parcel$export(module.exports, "isForgeExtensionMetricsFixEnabled", () => $706d7ea06981f598$export$3b4e3c7791b3909);
$parcel$export(module.exports, "isCompassComponentsEnabled", () => $706d7ea06981f598$export$33008660eb5353ef);
$parcel$export(module.exports, "isConferenceCallFieldHidden", () => $706d7ea06981f598$export$176e4d6701700463);
$parcel$export(module.exports, "isIssueLinkLimitEnabled", () => $706d7ea06981f598$export$c567845e4f18ee11);
$parcel$export(module.exports, "isCreateConfluencePagesEnabled", () => $706d7ea06981f598$export$2b839c758c080224);
$parcel$export(module.exports, "isOptimiseEditorOnchangeCallsEnabled", () => $706d7ea06981f598$export$7411486b04537f62);
$parcel$export(module.exports, "isMentionsAnalyticsEnabled", () => $706d7ea06981f598$export$281da19089438270);
$parcel$export(module.exports, "isNewLinkPickerEnabled", () => $706d7ea06981f598$export$ae2025957f2940e4);
$parcel$export(module.exports, "isTraceIdForRelayErrorsEnabled", () => $706d7ea06981f598$export$d83d25e87b40c475);
$parcel$export(module.exports, "getJiraIssuesDatasourceEnabled", () => $706d7ea06981f598$export$1c607d9b866655e1);
$parcel$export(module.exports, "shouldUseNewEditorCardProvider", () => $706d7ea06981f598$export$8c74256e92f57afb);
$parcel$export(module.exports, "isMentionsIndicatorEnabled", () => $706d7ea06981f598$export$5cb6179ec1a74a5a);
$parcel$export(module.exports, "isDevOpsAppRecommenderEnabled", () => $706d7ea06981f598$export$882e8ff421f7744c);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemBackgroundScriptsFromTTIEnabled", () => $706d7ea06981f598$export$c3737cff1b9064df);
$parcel$export(module.exports, "isIssueDescriptionReadingAidEnabled", () => $706d7ea06981f598$export$f16a46bb33ebb09c);
$parcel$export(module.exports, "isIssueDescriptionAcronymsHighlightEnabled", () => $706d7ea06981f598$export$7071b16bdeedd7e0);
$parcel$export(module.exports, "isIssueViewUnlinkGlancesFieldFromUi", () => $706d7ea06981f598$export$709da340f602ae6e);
$parcel$export(module.exports, "isIssueViewRemoveGlancesFieldFromQuery", () => $706d7ea06981f598$export$8db987307934d214);
$parcel$export(module.exports, "isIssueViewImplementDeadGlancesFieldQuery", () => $706d7ea06981f598$export$694fa8b8c523f4cc);
$parcel$export(module.exports, "isAggMigrationAttachmentsEnabled", () => $706d7ea06981f598$export$5a53bba8e442c4f9);
$parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", () => $706d7ea06981f598$export$6f64fb042a8db7d9);
$parcel$export(module.exports, "isDynamicEditButtonLabelEnabled", () => $706d7ea06981f598$export$27d85e4af83ec7f9);
$parcel$export(module.exports, "isNinColumnResizingEnabled", () => $706d7ea06981f598$export$1f76c12fbdafb975);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewCrossJoinEnabled", () => $706d7ea06981f598$export$667dd70f296d7a79);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueLinkedPageCrossJoinEnabled", () => $706d7ea06981f598$export$8d9e5c2fc560d7fb);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewDeferSpaceSelectionEnabled", () => $706d7ea06981f598$export$712b6916406c5e2a);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $706d7ea06981f598$export$60184d6d974595a9);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemActivityPanelsFromTTIEnabled", () => $706d7ea06981f598$export$b7098c14b9be61bc);
$parcel$export(module.exports, "isGoalsFieldEnabledInIssueView", () => $706d7ea06981f598$export$602a082cd6009b66);
$parcel$export(module.exports, "isTokensAndStyledComponentsMigrationEnabled", () => $706d7ea06981f598$export$590b056868f89976);
$parcel$export(module.exports, "isIssueArchivalFeatureEnabled", () => $706d7ea06981f598$export$f67982569b9aab31);
$parcel$export(module.exports, "isIssueDateFieldSavedOnChange", () => $706d7ea06981f598$export$694f7148d449e12);
$parcel$export(module.exports, "isSentimentFieldEnabled", () => $706d7ea06981f598$export$cd66b30e1a3ad3b0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $706d7ea06981f598$export$e92cc7310d059d3e);
$parcel$export(module.exports, "isIssueViewClassificationLevelEditabilityEnabled", () => $706d7ea06981f598$export$ab71258032925094);
$parcel$export(module.exports, "isDeleteLinkedIssueSLOEnabled", () => $706d7ea06981f598$export$2923d3b89bbda235);
$parcel$export(module.exports, "isFixForJracloud82128Enabled", () => $706d7ea06981f598$export$ff32b5a0029469f1);
$parcel$export(module.exports, "isCompalParentStatusCategoryIdEnabled", () => $706d7ea06981f598$export$8d6eb687c2a90c8c);
$parcel$export(module.exports, "isJSMRestrictInternalCommentVisibilityEnabled", () => $706d7ea06981f598$export$5dbdd9e44df66fdb);
$parcel$export(module.exports, "isIssueViewFitAndFinishM2Enabled", () => $706d7ea06981f598$export$61a4e4e1a79114de);
$parcel$export(module.exports, "aggUseIsEditableInViewFlag", () => $706d7ea06981f598$export$9e983b29015333eb);
$parcel$export(module.exports, "isLinkedPagesBugFixEnabled", () => $706d7ea06981f598$export$35cba8f6a1edcd6a);
$parcel$export(module.exports, "isUIMCascadingSelectFieldEnablead", () => $706d7ea06981f598$export$418f24ad76008d74);
$parcel$export(module.exports, "sprintFieldLongTextFixFlag", () => $706d7ea06981f598$export$24744533e9559f1e);
$parcel$export(module.exports, "selectableFieldEditViewReplaceSelectWithFooter", () => $706d7ea06981f598$export$614b1f6ee38ef8fe);
$parcel$export(module.exports, "isAIUpsellPremiumTrailEnabled", () => $706d7ea06981f598$export$63beab816c3f18b1);
$parcel$export(module.exports, "isEmbeddedConfluenceCreateContentCrossFlowEnabled", () => $706d7ea06981f598$export$8fa51a766c2ece72);
$parcel$export(module.exports, "isRendererDefaultSmartLinksValueEnabled", () => $706d7ea06981f598$export$36797146406f89b2);
$parcel$export(module.exports, "isHoverCardAISummariesEnabled", () => $706d7ea06981f598$export$68300000ff0840c3);
$parcel$export(module.exports, "isAffectsVersionsFieldSupportForIVEnabled", () => $706d7ea06981f598$export$71ed36e51616c829);
$parcel$export(module.exports, "isIssueViewNudgeExperimentEnabled", () => $706d7ea06981f598$export$d9ce3c80c1cc862d);
$parcel$export(module.exports, "isApprovalsGlancePanelToCollapsibleContextGroupEnabled", () => $706d7ea06981f598$export$9e54bab54faf7459);
$parcel$export(module.exports, "isConfluenceIntegrationsAdminControlsEnabled", () => $706d7ea06981f598$export$268b11901e56613a);
$parcel$export(module.exports, "isCascadingSelectSupportForUIMEnabled", () => $706d7ea06981f598$export$4399c72174f6c25d);
$parcel$export(module.exports, "isWhiteboardStandaloneEnabled", () => $706d7ea06981f598$export$18b62f1e8801aa0f);
$parcel$export(module.exports, "isFitAndFinishFullPageMilestone2", () => $706d7ea06981f598$export$56ceecd3414268e0);
$parcel$export(module.exports, "isCrossJoinContentPreviewEnabled", () => $706d7ea06981f598$export$ce9fb45735ec88ee);
$parcel$export(module.exports, "isHandleIssueCommentsEmptyEnabled", () => $706d7ea06981f598$export$bbd89fe4e4d7eff9);
$parcel$export(module.exports, "isHideLinkedIssueKeyForNonAuthorisesEnabled", () => $706d7ea06981f598$export$31792eb3d1db9c94);
$parcel$export(module.exports, "removeAllMentionsOfNewIssueView", () => $706d7ea06981f598$export$4eddc5d109dcba69);
$parcel$export(module.exports, "isReactReduxV8Upgrade", () => $706d7ea06981f598$export$fc502a08f3da8431);
$parcel$export(module.exports, "isAvoidProjectRedirectFromIssueViewEnabled", () => $706d7ea06981f598$export$27b1ada3a4e1a808);
$parcel$export(module.exports, "isCMDBAttributeIdRemoved", () => $706d7ea06981f598$export$98975042f993a7b1);
$parcel$export(module.exports, "isExtraPaddingOnIssueActionButtonsEnabled", () => $706d7ea06981f598$export$7248d3c792741fe6);
$parcel$export(module.exports, "isBentoViewModeRefactor", () => $706d7ea06981f598$export$6f11e578fe0086aa);
$parcel$export(module.exports, "is3pIssueWatchNudgeEnabled", () => $706d7ea06981f598$export$6ff28b2229a27899);
$parcel$export(module.exports, "isLinkedMentionedRestrictedPageOnClickEnabled", () => $706d7ea06981f598$export$aff6e532ec3ced01);
$parcel$export(module.exports, "isAddCommentScreenAnalyticsEnabled", () => $706d7ea06981f598$export$d365d0b31e3df46e);
$parcel$export(module.exports, "isJPDPanelEnabled", () => $706d7ea06981f598$export$c3c0abcc7a24c315);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $caTc0 = parcelRequire("caTc0");
const $706d7ea06981f598$export$a9f38f9f0d6f10af = ()=>(0, $1ybV0.ff)('ken-100-add-all-featureflags-to-issue-view-performance-events_kmez7');
const $706d7ea06981f598$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $706d7ea06981f598$export$9e18785497c1673b = ()=>(0, $1ybV0.ff)('issue-comment-render_tt9jk');
const $706d7ea06981f598$export$35c0c8db33387f4d = ()=>(0, $1ybV0.ff)('issue-comment-fetch_9eeal');
const $706d7ea06981f598$export$6e4f76cd76a804da = ()=>(0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr');
const $706d7ea06981f598$export$7f7b600c4eafe68f = ()=>(0, $1ybV0.ff)('issue_view_quick_actions_revamp_l8mbx');
const $706d7ea06981f598$export$c8aa8a13c42858dd = ()=>(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw', false);
const $706d7ea06981f598$export$3041d162b6562717 = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$7af43b56ceb4b148 = ()=>(0, $1ybV0.ff)('issue.details.issue-fetch-epic-prefetched-agg-query-logging', false);
const $706d7ea06981f598$export$11c3bd37c4149e8a = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-ui-fixes', false);
const $706d7ea06981f598$export$91d9e9331bcb489f = ()=>(0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
const $706d7ea06981f598$export$4bef98bf98ff2cb = ()=>(0, $1ybV0.ff)('issue.details.migration-migrated-stream', false);
const $706d7ea06981f598$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $706d7ea06981f598$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)('issue.details.jira-issue-view-editor-ai_sozy', false);
const $706d7ea06981f598$export$a42a9ff4a537eac1 = ()=>(0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai', false);
const $706d7ea06981f598$export$bb7bcfe9ba7992e5 = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl', false);
const $706d7ea06981f598$export$be02cc41570f884f = ()=>(0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9', false);
const $706d7ea06981f598$export$25f1a380ac523ab1 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding', false);
const $706d7ea06981f598$export$b9ecdb2af6d8a25 = ()=>(0, $1ybV0.ff)('issue.details.issue-type-select-hierarchy-fix', false);
const $706d7ea06981f598$export$a1b2fc5741a7de01 = ()=>(0, $1ybV0.ff)('issue.details.shard-and-region-to-slo-analytics', false);
const $706d7ea06981f598$export$b1c6c927b1de3746 = ()=>(0, $1ybV0.ff)('issue.details.feature-flags-to-slo-analytics', false);
const $706d7ea06981f598$export$3694fdeb5d384181 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update', false);
const $706d7ea06981f598$export$4166161ebaa7c45b = ()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
const $706d7ea06981f598$export$c3e066f7be7868e8 = ()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
const $706d7ea06981f598$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $706d7ea06981f598$export$d7d142f5ac020394 = ()=>(0, $1ybV0.ff)('jira.teams.enable-new-custom-field-types', false);
const $706d7ea06981f598$export$cdd5c612352d7bf0 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.VARIATION)
    ]) === (0, $1Iui1.VARIATION);
const $706d7ea06981f598$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $706d7ea06981f598$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);
const $706d7ea06981f598$export$dd98acc8d28f3c1e = ()=>(0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation', false);
const $706d7ea06981f598$export$f0ece2538dd9e423 = ()=>(0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6');
const $706d7ea06981f598$export$ca7c31f03d6e8f02 = ()=>(0, $1ybV0.ff)('trello.card.integration.patch', false);
const $706d7ea06981f598$export$2ed16947150cc8c = ()=>(0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk');
const $706d7ea06981f598$export$dcc4742bc52ec465 = ()=>(0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53', false);
const $706d7ea06981f598$export$fa2b2d3091ee4acb = ()=>(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h', false);
const $706d7ea06981f598$export$8138f2ec6e2b730c = ()=>(0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku', false);
const $706d7ea06981f598$export$b014ef5adbdaef11 = ()=>(0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn', false);
const $706d7ea06981f598$export$d6f2a732166d94ed = ()=>(0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u', false);
const $706d7ea06981f598$export$d0ed2d8440fb5bbc = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.milestone-1');
const $706d7ea06981f598$export$41470180bace44ba = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link');
const $706d7ea06981f598$export$9a5cf06e051f6deb = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit');
const $706d7ea06981f598$export$e3bcb7ed6340e909 = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit');
const $706d7ea06981f598$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $706d7ea06981f598$export$dbaa92a1f690c8fe = ()=>(0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error');
const $706d7ea06981f598$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $706d7ea06981f598$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $706d7ea06981f598$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $706d7ea06981f598$export$6fb6e5d98b15585b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.ttr-severity-tracking', {});
const $706d7ea06981f598$export$eccecfefbd48225b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.unsupported-content-levels-tracking', {});
const $706d7ea06981f598$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $706d7ea06981f598$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $706d7ea06981f598$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $706d7ea06981f598$export$dbaf42ba39b66293 = ()=>$706d7ea06981f598$export$67305b99ef59566c() && $706d7ea06981f598$export$9ba0da55e7f403e1();
const $706d7ea06981f598$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false);
const $706d7ea06981f598$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $706d7ea06981f598$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $706d7ea06981f598$export$c197f8974183a4f0 = ()=>(0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
const $706d7ea06981f598$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $706d7ea06981f598$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $706d7ea06981f598$export$33e603f2e83329f5 = ()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', false);
const $706d7ea06981f598$export$a73c9c09ec24e5e9 = ()=>(0, $1ybV0.ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
const $706d7ea06981f598$export$4df93ecfbfdca877 = ()=>(0, $1ybV0.ff)('jira.issue-view.placeholder-template-e2e-iteration', false);
const $706d7ea06981f598$export$bfc00b5a0f36c863 = ()=>(0, $1ybV0.ff)('issue-view-placeholder-end-user-request-modal_myc7n', false);
const $706d7ea06981f598$export$641196cc6a6481ea = ()=>(0, $1ybV0.ff)('compal-issue-actions', false);
const $706d7ea06981f598$export$7c0bd221ecbf9b57 = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu', false);
const $706d7ea06981f598$export$d5d401f0a31e62ea = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r', false);
const $706d7ea06981f598$export$e253ac70cea0d36b = ()=>(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);
const $706d7ea06981f598$export$ca654183a67f7c1d = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-syntax-value-updates', false);
const $706d7ea06981f598$export$ecfec49bad872d16 = ()=>(0, $1ybV0.ff)('remove-issueattachmentpanel-viewed-event_w282l');
const $706d7ea06981f598$export$fe59b559919ee088 = ()=>(0, $1ybV0.ff)('issue-view-fetch-the-required-field-on-rendering_lgknh', false);
const $706d7ea06981f598$export$5194de77e8750c41 = ()=>(0, $1ybV0.ff)('jira-issue-view-smart-summary-onboarding_jmzm7', false);
const $706d7ea06981f598$export$3cfaae79d46ba7ee = ()=>(0, $1ybV0.ff)('issue.details-smart-summary-with-ai-mate_qqug7.', false);
const $706d7ea06981f598$export$edfcfe610bd14d1 = ()=>(0, $1ybV0.ff)('issue-view-disable-definition-feature-if-the-user-doesnt-have-confluence-access_inh6g', false);
const $706d7ea06981f598$export$34d90e61db572fb4 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn', false);
const $706d7ea06981f598$export$30cd538422d6ae26 = ()=>(0, $1ybV0.ff)('issue.details.gic.add_status_field', false);
const $706d7ea06981f598$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);
const $706d7ea06981f598$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $706d7ea06981f598$export$df603fd34aea93ca = ()=>(0, $1ybV0.getFeatureFlagValue)('project.config.pce.use-m4-issue-layout-data-in-bento.with-consistency-check', 'OLD');
const $706d7ea06981f598$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $706d7ea06981f598$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false);
const $706d7ea06981f598$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $706d7ea06981f598$export$150e448c819201a7 = ()=>(0, $1ybV0.ff)('jira.frontend.ptc.team-field-in-subtasks', false);
const $706d7ea06981f598$export$369fa0ed6b2504fb = ()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
const $706d7ea06981f598$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);
const $706d7ea06981f598$export$a792a3f88a852f06 = ()=>(0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
const $706d7ea06981f598$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $706d7ea06981f598$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);
const $706d7ea06981f598$export$8521761ebcf26351 = ()=>(0, $1ybV0.ff)('jsm-agent-signature-cr-enabled', false);
const $706d7ea06981f598$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $706d7ea06981f598$export$e3bafd4acea73c60 = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '');
    return experiences.length > 0;
};
const $706d7ea06981f598$export$dda3a2d16a2e0a31 = ()=>(0, $1ybV0.ff)('override-date-for-attachment-timestamp-in-film-strip_ymajc');
const $706d7ea06981f598$export$fad47591ae56c23f = ()=>(0, $1ybV0.ff)('metric-for-issue-delete-inside-issue-view_baxre');
const $706d7ea06981f598$export$6d1f8ae8cf9bbc71 = ()=>(0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7', false);
const $706d7ea06981f598$export$7dbe34739b0d70b8 = ()=>(0, $1ybV0.ff)('ken-524-fix-middle-click-issue-for-linked-issues_x1hgl', false);
const $706d7ea06981f598$export$3fa1b10a7b484874 = ()=>(0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv', false);
const $706d7ea06981f598$export$6604067817758030 = ()=>{
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-migration-isarchived', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $706d7ea06981f598$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $706d7ea06981f598$export$ee410f0ba32dc900 = ()=>(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences', false);
const $706d7ea06981f598$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $706d7ea06981f598$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $706d7ea06981f598$export$48d407f97269c8fa = ()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration', false);
const $706d7ea06981f598$export$8a90e3b075447800 = ()=>(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt', false);
const $706d7ea06981f598$export$733566d04cfe61b1 = ()=>(0, $1ybV0.ff)('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
const $706d7ea06981f598$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $706d7ea06981f598$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $706d7ea06981f598$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($706d7ea06981f598$export$fb512d5beec30a90($706d7ea06981f598$export$bf10032e4a734a65.CROSS_FLOW));
const $706d7ea06981f598$export$ef28379ba310de6e = (experiment)=>$706d7ea06981f598$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $706d7ea06981f598$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
const $706d7ea06981f598$export$8ea052ed520b62bc = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $706d7ea06981f598$export$d616286874a25f83 = ()=>(0, $1ybV0.ff)('filter-issue-changed-connect-app-events-to-non-dialogs');
const $706d7ea06981f598$export$496e94e3da873a49 = ()=>(0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
const $706d7ea06981f598$export$cd0e0ab900757d23 = ()=>(0, $1ybV0.ff)('remove-invalid-forge-metrics_n3ddj');
const $706d7ea06981f598$export$ea998c148f057985 = ()=>(0, $1ybV0.ff)('change-the-way-we-get-project-context-for-forge-background-scripts_smqab');
const $706d7ea06981f598$export$3b4e3c7791b3909 = ()=>(0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx');
const $706d7ea06981f598$export$33008660eb5353ef = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
const $706d7ea06981f598$export$176e4d6701700463 = ()=>(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5', false);
const $706d7ea06981f598$export$c567845e4f18ee11 = ()=>(0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag');
const $706d7ea06981f598$export$2b839c758c080224 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
const $706d7ea06981f598$export$7411486b04537f62 = ()=>(0, $1ybV0.ff)('issue-details-optimise-editor-onchange-calls_bb4fq', false);
const $706d7ea06981f598$export$281da19089438270 = ()=>(0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji');
const $706d7ea06981f598$export$ae2025957f2940e4 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-picker_tgrho', false);
const $706d7ea06981f598$export$d83d25e87b40c475 = ()=>(0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
const $706d7ea06981f598$export$1c607d9b866655e1 = ()=>(0, $1ybV0.ff)('platform.linking-platform.datasource-jira_issues', false);
const $706d7ea06981f598$export$8c74256e92f57afb = ()=>(0, $1ybV0.ff)('platform.linking-platform.use-new-editor-card-provider', false);
const $706d7ea06981f598$export$5cb6179ec1a74a5a = ()=>(0, $caTc0.isInMentionsIndicatorExperimentCohort)();
const $706d7ea06981f598$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $706d7ea06981f598$export$c3737cff1b9064df = ()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
const $706d7ea06981f598$export$f16a46bb33ebb09c = ()=>(0, $1ybV0.ff)('feature.reading-aid-in-issue-description', false);
const $706d7ea06981f598$export$7071b16bdeedd7e0 = ()=>(0, $1ybV0.ff)('jira-reading-aid-acronyms-highlight_3hr5i');
const $706d7ea06981f598$export$709da340f602ae6e = ()=>(0, $1ybV0.ff)('issue-view-unlink-glancefield-from-ui_8a5yg');
const $706d7ea06981f598$export$8db987307934d214 = ()=>(0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g');
const $706d7ea06981f598$export$694fa8b8c523f4cc = ()=>(0, $1ybV0.ff)('implement-dead-glancesfield-query_f71sc');
const $706d7ea06981f598$export$5a53bba8e442c4f9 = ()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
const $706d7ea06981f598$export$6f64fb042a8db7d9 = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$27d85e4af83ec7f9 = ()=>(0, $1ybV0.ff)('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f', false);
const $706d7ea06981f598$export$1f76c12fbdafb975 = ()=>(0, $1ybV0.ff)('nin-resizable-columns_8z4eo');
const $706d7ea06981f598$export$667dd70f296d7a79 = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join', false);
const $706d7ea06981f598$export$8d9e5c2fc560d7fb = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$712b6916406c5e2a = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_co-use', false);
const $706d7ea06981f598$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false);
const $706d7ea06981f598$export$b7098c14b9be61bc = ()=>(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj');
const $706d7ea06981f598$export$602a082cd6009b66 = ()=>(0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view', false);
const $706d7ea06981f598$export$590b056868f89976 = ()=>(0, $1ybV0.ff)('im-tokens-and-styled-components-migration_qpsld', false);
const $706d7ea06981f598$export$f67982569b9aab31 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);
const $706d7ea06981f598$export$694f7148d449e12 = ()=>(0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur');
const $706d7ea06981f598$export$cd66b30e1a3ad3b0 = ()=>(0, $1ybV0.ff)('jsm-sentiment-analysis_1dage', false);
const $706d7ea06981f598$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);
const $706d7ea06981f598$export$ab71258032925094 = ()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal', false);
const $706d7ea06981f598$export$2923d3b89bbda235 = ()=>(0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8', false);
const $706d7ea06981f598$export$ff32b5a0029469f1 = ()=>(0, $1ybV0.ff)('fix-for-jracloud-82128_379yp', false);
const $706d7ea06981f598$export$8d6eb687c2a90c8c = ()=>(0, $1ybV0.ff)('compal-issue-actions-parent-statuscategoryid_s2esc', false);
const $706d7ea06981f598$export$5dbdd9e44df66fdb = ()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility', false);
const $706d7ea06981f598$export$61a4e4e1a79114de = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$9e983b29015333eb = ()=>(0, $1ybV0.ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
const $706d7ea06981f598$export$35cba8f6a1edcd6a = ()=>(0, $1ybV0.ff)('linked-pages-embedded-bug-fix', false);
const $706d7ea06981f598$export$418f24ad76008d74 = ()=>(0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda', false);
const $706d7ea06981f598$export$24744533e9559f1e = ()=>(0, $1ybV0.ff)('sprint-field-long-text-bug_fo95j', false);
const $706d7ea06981f598$export$614b1f6ee38ef8fe = ()=>(0, $1ybV0.ff)('selectable-field-edit-view-replace-select-with-footer_301u0', false);
const $706d7ea06981f598$export$63beab816c3f18b1 = ()=>(0, $1ybV0.ff)('jsw-premium-edition-eval-admin-ai-upsell_djht5', false);
const $706d7ea06981f598$export$8fa51a766c2ece72 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
const $706d7ea06981f598$export$36797146406f89b2 = ()=>(0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value', false);
const $706d7ea06981f598$export$68300000ff0840c3 = ()=>(0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries', false);
const $706d7ea06981f598$export$71ed36e51616c829 = ()=>(0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj', false);
const $706d7ea06981f598$export$d9ce3c80c1cc862d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$9e54bab54faf7459 = ()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
const $706d7ea06981f598$export$268b11901e56613a = ()=>(0, $1ybV0.ff)('confluence-admin-product-controls', false);
const $706d7ea06981f598$export$4399c72174f6c25d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$18b62f1e8801aa0f = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$56ceecd3414268e0 = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$ce9fb45735ec88ee = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$bbd89fe4e4d7eff9 = ()=>(0, $1ybV0.ff)('catch-issue-comments-empty-response-errors_o2gkc', false);
const $706d7ea06981f598$export$31792eb3d1db9c94 = ()=>(0, $1ybV0.ff)('hide-issue-key-when-linked-issue-has-no-access_8nb8t');
const $706d7ea06981f598$export$4eddc5d109dcba69 = ()=>(0, $1ybV0.ff)('remove-all-mentions-of-new-issue-view_unq0c', false);
const $706d7ea06981f598$export$fc502a08f3da8431 = ()=>(0, $1ybV0.ff)('jff.magma.react-redux-upgrade_53sr4', false);
const $706d7ea06981f598$export$27b1ada3a4e1a808 = ()=>(0, $1ybV0.ff)('jsw.perf.navigation.avoid-redirect-from-issue-view_iv5hd', false);
const $706d7ea06981f598$export$98975042f993a7b1 = ()=>(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false);
const $706d7ea06981f598$export$7248d3c792741fe6 = ()=>(0, $1ybV0.ff)('fix-narrow-button-spacing-on-issue-actions_icmq8', false);
const $706d7ea06981f598$export$6f11e578fe0086aa = ()=>(0, $1ybV0.ff)('refactor-bento-view-mode-logic', false);
const $706d7ea06981f598$export$6ff28b2229a27899 = ()=>(0, $1ybV0.ff)('third_party_app_nudge_on_issues_watch', false) && (0, $79xbN.expValEquals)('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
const $706d7ea06981f598$export$aff6e532ec3ced01 = ()=>(0, $1ybV0.ff)('linked_mentioned_pages_handle_restricted_page_on_click', false);
const $706d7ea06981f598$export$d365d0b31e3df46e = ()=>(0, $1ybV0.ff)('jira.onboarding.kuro-5895', false);
const $706d7ea06981f598$export$c3c0abcc7a24c315 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-in-issue-view', false); // </alaktionova>

});
const $3401608855dcf8dc$export$fb6fa89d43ed06f7 = 'variant-contextual';
const $3401608855dcf8dc$export$c52ae1847ec8c2c = 'variant-contextual-not-enrolled';

parcelRegister("caTc0", function(module, exports) {

$parcel$export(module.exports, "isInMentionsIndicatorExperimentCohort", () => $09e2035ec940dd58$export$4d1c47e616b7a5fb);

var $79xbN = parcelRequire("79xbN");
function $09e2035ec940dd58$export$4d1c47e616b7a5fb() {
    return (0, $79xbN.expValEquals)('mentions_in_board_and_backlog_ver_2', 'cohort', 'test');
}

});


parcelRegister("lDYuK", function(module, exports) {

$parcel$export(module.exports, "setBoardDetailViewMode", () => $1ed8663d5b2b533f$export$5aec23d4b2954b61);
$parcel$export(module.exports, "getBoardDetailViewMode", () => $1ed8663d5b2b533f$export$30296c2892a21468);
$parcel$export(module.exports, "getSwimlaneModeSetting", () => $1ed8663d5b2b533f$export$1708c8217a67f3f9);

var $aZaPn = parcelRequire("aZaPn");

var $idwtd = parcelRequire("idwtd");
const $1ed8663d5b2b533f$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('software');
const $1ed8663d5b2b533f$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $1ed8663d5b2b533f$export$5aec23d4b2954b61 = (detailViewMode)=>$1ed8663d5b2b533f$var$localStorage.set((0, $idwtd.BOARD_DETAIL_VIEW_MODE), detailViewMode);
const $1ed8663d5b2b533f$export$30296c2892a21468 = ()=>$1ed8663d5b2b533f$var$localStorage.get((0, $idwtd.BOARD_DETAIL_VIEW_MODE)) || (0, $idwtd.DETAIL_VIEW_DEFAULT);
const $1ed8663d5b2b533f$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $1ed8663d5b2b533f$var$localStorage.get(`${$1ed8663d5b2b533f$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};

});
parcelRegister("idwtd", function(module, exports) {

$parcel$export(module.exports, "DETAIL_VIEW_SIDEBAR", () => $9ab19831f05a709e$export$dfb67e34e4333816);
$parcel$export(module.exports, "DETAIL_VIEW_MODAL", () => $9ab19831f05a709e$export$1d6094128a3bfe4a);
$parcel$export(module.exports, "DETAIL_VIEW_DEFAULT", () => $9ab19831f05a709e$export$ad4637adae7d3e97);
$parcel$export(module.exports, "BOARD_DETAIL_VIEW_MODE", () => $9ab19831f05a709e$export$201bf1eb7c447afa);
$parcel$export(module.exports, "swimlaneModeToStrategies", () => $9ab19831f05a709e$export$6b0228c67b1e82cf);
const $9ab19831f05a709e$export$dfb67e34e4333816 = 'SIDEBAR';
const $9ab19831f05a709e$export$1d6094128a3bfe4a = 'MODAL';
const $9ab19831f05a709e$export$ad4637adae7d3e97 = 'DEFAULT';
const $9ab19831f05a709e$export$201bf1eb7c447afa = 'board-detail-view-mode';
const $9ab19831f05a709e$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};

});


parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $aZaPn = parcelRequire("aZaPn");

var $lDYuK = parcelRequire("lDYuK");

var $idwtd = parcelRequire("idwtd");

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>{
    const viewModeValue = (0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY));
    if (viewModeValue) return viewModeValue;
    const boardViewModeValue = (0, $lDYuK.getBoardDetailViewMode)();
    // if there is no viewModeValue but there is a boardViewModeValue then set that value in localStorage
    // and remove the old board local storage value
    if (boardViewModeValue) {
        const boardLocalStorage = (0, $aZaPn.createLocalStorageProvider)('software');
        (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), boardViewModeValue);
        boardLocalStorage.remove((0, $idwtd.BOARD_DETAIL_VIEW_MODE));
        return boardViewModeValue;
    }
    return 0, $935e771f19f8ea28$export$2d037fdba4f67558;
// note: during 'refactor-bento-view-mode-logic' ff cleanup (https://jbusiness.atlassian.net/browse/CAL-12), remove the above logic including getBoardDetailViewMode and uncomment
// return localStorage.get(VIEW_MODE_STORAGE_KEY) || VIEW_MODE_DEFAULT;
};

});




parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("fibAs", function(module, exports) {

$parcel$export(module.exports, "useIssueAppSwitcher", () => $3152a3e67378e7d5$export$6a966e207795837d);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $aZaPn = parcelRequire("aZaPn");

var $hSCS8 = parcelRequire("hSCS8");

const $3152a3e67378e7d5$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira_business_issue_view');
const $3152a3e67378e7d5$export$86880b4b2e1a2384 = 'jwm.issue-app-mode';
const $3152a3e67378e7d5$var$actions = {
    switchToSidebar: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                openInSidebar: true
            });
            $3152a3e67378e7d5$var$localStorage.set($3152a3e67378e7d5$export$86880b4b2e1a2384, (0, $935e771f19f8ea28$export$705305d6da432040));
        },
    switchToModal: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                openInSidebar: false
            });
            $3152a3e67378e7d5$var$localStorage.set($3152a3e67378e7d5$export$86880b4b2e1a2384, (0, $935e771f19f8ea28$export$98c0ebc22792f04));
        },
    initState: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const storageValue = $3152a3e67378e7d5$var$localStorage.get($3152a3e67378e7d5$export$86880b4b2e1a2384);
            const nextOpenInSidebar = typeof storageValue !== 'undefined' ? storageValue === (0, $935e771f19f8ea28$export$705305d6da432040) : false;
            if (state.openInSidebar !== nextOpenInSidebar) setState({
                ...state,
                openInSidebar: nextOpenInSidebar
            });
        }
};
const $3152a3e67378e7d5$var$Store = (0, $a61MH.createStore)({
    initialState: {
        openInSidebar: false
    },
    actions: $3152a3e67378e7d5$var$actions,
    name: 'JWMIssueAppSwitcherStore'
});
const $3152a3e67378e7d5$var$useHook = (0, $ggKAj.createHook)($3152a3e67378e7d5$var$Store);
const $3152a3e67378e7d5$export$6a966e207795837d = ()=>{
    const [{ openInSidebar: openInSidebar }, hookActions] = $3152a3e67378e7d5$var$useHook();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        hookActions.initState();
    }, [
        hookActions
    ]);
    const switchToModal = (0, $eUqFw.useCallback)(()=>{
        setSidebarContent(null);
        hookActions.switchToModal();
    }, [
        setSidebarContent,
        hookActions
    ]);
    return [
        {
            openInSidebar: openInSidebar
        },
        {
            switchToSidebar: hookActions.switchToSidebar,
            switchToModal: switchToModal
        }
    ];
};

});

parcelRegister("dQVrX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('aTMMU')
        ]);
        const value = parcelRequire('kjWxV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("aTMMU")
    ]).then(()=>parcelRequire('kjWxV'));
}

});


parcelRegister("9u6Jh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $134113658c67db96$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hSCS8 = parcelRequire("hSCS8");

var $1ybV0 = parcelRequire("1ybV0");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $bw53Y = parcelRequire("bw53Y");

var $4LhhW = parcelRequire("4LhhW");
const $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $134113658c67db96$var$callWhenIdle = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $134113658c67db96$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $4LhhW.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($134113658c67db96$var$CSSAntiCorruptionLayer, {
                key: $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bw53Y.SidebarIssueApp), {
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (!(0, $1ybV0.ff)('jwm.fix-issue-view-sidebar-close-on-unscheduled_click_ysro6.') || (0, $1ybV0.ff)('jwm.fix-issue-view-sidebar-close-on-unscheduled_click_ysro6.') && content?.key === $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $134113658c67db96$var$callWhenIdle(()=>{
            (0, $bw53Y.IssueApp).preload();
        });
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $134113658c67db96$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bw53Y", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $1d0bd87d82d1f36e$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $1d0bd87d82d1f36e$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c4qEZ = parcelRequire("c4qEZ");

var $jK1pm = parcelRequire("jK1pm");

var $fibAs = parcelRequire("fibAs");

const $1d0bd87d82d1f36e$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("f4xMV")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $1d0bd87d82d1f36e$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { switchToModal: switchToModal, switchToSidebar: switchToSidebar }] = (0, $fibAs.useIssueAppSwitcher)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('refactor-bento-view-mode-logic')) {
            setDetailViewAsModal();
            setSidebarContent(null);
        } else switchToModal();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        switchToModal,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('refactor-bento-view-mode-logic')) {
            setDetailViewAsSidebar();
            setSidebarContent(null);
        } else switchToSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        switchToSidebar,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $eUqFw.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0bd87d82d1f36e$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040),
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("f4xMV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('kMAKK')
        ]);
        const value = parcelRequire('9zAkH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("kMAKK")
    ]).then(()=>parcelRequire('9zAkH'));
}

});


parcelRegister("4LhhW", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $94858a1aa5f6a192$export$70b20cd72362e39d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");


var $53ucm = parcelRequire("53ucm");
const $94858a1aa5f6a192$var$MARGIN = 24;
const $94858a1aa5f6a192$export$70b20cd72362e39d = ()=>{
    const [{ content: content, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (content !== null) {
            document.documentElement?.style.setProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $94858a1aa5f6a192$var$MARGIN);
        } else document.documentElement?.style.removeProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $29bf8722faf6f5bf$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("5I9Im", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $1fd41398a8791bc6$export$1e95fb877713bf5e);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $hYeSy = parcelRequire("hYeSy");

var $1SYbt = parcelRequire("1SYbt");
const $1fd41398a8791bc6$var$IssueDataLoader = /*#__PURE__*/ (0, $eUqFw.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SYbt.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $1fd41398a8791bc6$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $hYeSy.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    (0, $eUqFw.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $eUqFw.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fd41398a8791bc6$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("hYeSy", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $1367707b89dd09e1$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $1367707b89dd09e1$export$fee97ccc4dadacbb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $1367707b89dd09e1$var$MAX_DELAY = 300;
const $1367707b89dd09e1$var$MIN_DELAY = 0;
const $1367707b89dd09e1$export$a87749ac92873cf7 = ()=>100;
const $1367707b89dd09e1$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $1367707b89dd09e1$var$MAX_DELAY : $1367707b89dd09e1$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $1367707b89dd09e1$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $1367707b89dd09e1$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $1367707b89dd09e1$var$PrefetchIssueViewStore = (0, $a61MH.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $1367707b89dd09e1$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $1367707b89dd09e1$export$519e056a921d9691 = (0, $ggKAj.createStateHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);
const $1367707b89dd09e1$export$fee97ccc4dadacbb = (0, $ggKAj.createActionsHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);

});

parcelRegister("1SYbt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $b758d168c0275aa2$export$15a49d6c068f7356);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $72NCz = parcelRequire("72NCz");
const $b758d168c0275aa2$var$entryPointParams = {};
const $b758d168c0275aa2$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $72NCz.asyncIssueViewCriticalDataLoaderEntrypoint), $b758d168c0275aa2$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("72NCz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $80aa607d47f3d3ce$export$6254258f84be452a);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $80aa607d47f3d3ce$export$6254258f84be452a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("B8xwO")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("B8xwO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apZDm');
        const value = parcelRequire('2rxqz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apZDm").then(()=>parcelRequire('2rxqz'));
}

});




parcelRegister("8BjUT", function(module, exports) {

$parcel$export(module.exports, "PageVisibility", () => $1a593bdd97c4fabd$export$ddb3b5bf3df25efc);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $fEYK5 = parcelRequire("fEYK5");
const $1a593bdd97c4fabd$export$e39301eefbc90236 = 500;
const $1a593bdd97c4fabd$export$ddb3b5bf3df25efc = ({ onChange: onChange })=>{
    // debouncing the page visibility change to prevent when people switching tabs too fast
    // useDebouncedCallback will always call the latest parameter for every re-render
    // so even though `onChange` may change each re-render, only the last one will be called when debounce finishes
    const [onVisibilityChangeDebounced] = (0, $cNGJr.default)(()=>{
        onChange({
            isVisible: (0, $fEYK5.isPageVisible)()
        });
    }, $1a593bdd97c4fabd$export$e39301eefbc90236);
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChangeDebounced);
        return ()=>{
            window.removeEventListener((0, $fEYK5.supportedVisiblityEvent), onVisibilityChangeDebounced);
        };
    }, [
        onVisibilityChangeDebounced
    ]);
    return null;
};

});

parcelRegister("bcWyL", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $44db5e6179f04fcc$export$ec3c3b39c046a620);

var $eUqFw = parcelRequire("eUqFw");


var $axxSm = parcelRequire("axxSm");

var $84CBi = parcelRequire("84CBi");

var $bDGTl = parcelRequire("bDGTl");

var $6HWvN = parcelRequire("6HWvN");
const $44db5e6179f04fcc$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $eUqFw.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "performance-analytics-loading"
    });
    const scrollElement = false ? null : document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDGTl.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("axxSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed3b6e522e859da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

const $ed3b6e522e859da6$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $083bae7fff0f430d$export$9d3e6d8a99023567));
const $ed3b6e522e859da6$export$46962be62755f053 = /*#__PURE__*/ (0, $eUqFw.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $083bae7fff0f430d$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const samplingCount = (0, $eUqFw.useRef)(0);
    const frames = (0, $eUqFw.useRef)(0);
    const rafId = (0, $eUqFw.useRef)(null);
    const start = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $083bae7fff0f430d$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $ed3b6e522e859da6$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $ed3b6e522e859da6$export$2e2bcd8739ae039 = $ed3b6e522e859da6$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $083bae7fff0f430d$export$71d024136796e395 = 100;
const $083bae7fff0f430d$export$299249b1dad3b14a = 20;
const $083bae7fff0f430d$export$9d3e6d8a99023567 = 60;


parcelRegister("bDGTl", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $f0bbcfda9127146c$export$70b569bf2edd0b7f);

var $eUqFw = parcelRequire("eUqFw");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f0bbcfda9127146c$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const container = document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("eeJbA", function(module, exports) {

$parcel$export(module.exports, "SignupInviteModal", () => $737bdeb96733c8da$export$eb44438138f66a46);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $737bdeb96733c8da$var$LazySignupInviteModal = (0, $7rh0R.lazy)(()=>(parcelRequire("iCXaZ")).then(({ SignupInviteModal: SignupInviteModal })=>SignupInviteModal), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/signup-invite-modal/src/ui/main.tsx"
});
const $737bdeb96733c8da$export$eb44438138f66a46 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-business.signup-invite-modal.modal",
        packageName: "jira-business.signup-invite-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "signup-invite-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($737bdeb96733c8da$var$LazySignupInviteModal, null))));

});
parcelRegister("iCXaZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('bND13')
        ]);
        const value = parcelRequire('gdLes');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("bND13")
    ]).then(()=>parcelRequire('gdLes'));
}

});


parcelRegister("eRpjy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $beaa0dc8e8f2a3dd$export$d54524c142a057f);

var $eUqFw = parcelRequire("eUqFw");

var $iJHZm = parcelRequire("iJHZm");
const $beaa0dc8e8f2a3dd$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ let id = window.requestAnimationFrame(()=>{
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null);
};

});

parcelRegister("3hjaO", function(module, exports) {

$parcel$export(module.exports, "useAutomationDiscoveryContext", () => $0ff47e1d994a8e3c$export$e03a59f2165ecdeb);
$parcel$export(module.exports, "AutomationDiscoveryProvider", () => $0ff47e1d994a8e3c$export$50ef14fc084a10f2);

var $eUqFw = parcelRequire("eUqFw");

var $aZqyz = parcelRequire("aZqyz");

var $I358h = parcelRequire("I358h");
const $0ff47e1d994a8e3c$export$184e10e8443c7fca = (columns)=>{
    const [isAutomationDiscoveryModalOpen, setIsAutomationDiscoveryModalOpen] = (0, $eUqFw.useState)(false);
    const [statusName, setStatusName] = (0, $eUqFw.useState)('');
    const { targetColumnId: targetColumnId, shouldShowSpotlight: shouldShowSpotlight, dismissSpotlight: dismissSpotlight, setSpotlightTargetHasRendered: setSpotlightTargetHasRendered, spotlightTargetHasRendered: spotlightTargetHasRendered, isTargetColumn: isTargetColumn } = (0, $aZqyz.useAutomationDiscoverySpotlight)(columns);
    const onSetAutomationModalOpen = (isOpen, status)=>{
        setIsAutomationDiscoveryModalOpen(isOpen);
        if (status) setStatusName(status);
    };
    const { automationRulesCount: automationRulesCount } = (0, $I358h.useAutomationRulesBadge)();
    return {
        isAutomationDiscoveryModalOpen: isAutomationDiscoveryModalOpen,
        setIsAutomationDiscoveryModalOpen: onSetAutomationModalOpen,
        shouldShowSpotlight: shouldShowSpotlight,
        targetColumnId: targetColumnId,
        dismissSpotlight: dismissSpotlight,
        statusName: statusName,
        setSpotlightTargetHasRendered: setSpotlightTargetHasRendered,
        spotlightTargetHasRendered: spotlightTargetHasRendered,
        isTargetColumn: isTargetColumn,
        automationRulesCount: automationRulesCount
    };
};
const $0ff47e1d994a8e3c$export$2e7ade101c091da0 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAutomationDiscoveryModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsAutomationDiscoveryModalOpen: (_isOpen)=>{},
    shouldShowSpotlight: (_columnId)=>false,
    targetColumnId: '',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dismissSpotlight: ()=>{},
    statusName: '',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSpotlightTargetHasRendered: ()=>{},
    spotlightTargetHasRendered: false,
    isTargetColumn: (_columnId)=>false,
    automationRulesCount: 0
});
const $0ff47e1d994a8e3c$export$e03a59f2165ecdeb = ()=>(0, $eUqFw.useContext)($0ff47e1d994a8e3c$export$2e7ade101c091da0);
const $0ff47e1d994a8e3c$export$50ef14fc084a10f2 = ({ children: children, columns: columns })=>{
    const { isAutomationDiscoveryModalOpen: isAutomationDiscoveryModalOpen, setIsAutomationDiscoveryModalOpen: setIsAutomationDiscoveryModalOpen, shouldShowSpotlight: shouldShowSpotlight, targetColumnId: targetColumnId, dismissSpotlight: dismissSpotlight, statusName: statusName, setSpotlightTargetHasRendered: setSpotlightTargetHasRendered, spotlightTargetHasRendered: spotlightTargetHasRendered, isTargetColumn: isTargetColumn, automationRulesCount: automationRulesCount } = $0ff47e1d994a8e3c$export$184e10e8443c7fca(columns);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ff47e1d994a8e3c$export$2e7ade101c091da0.Provider, {
        value: {
            isAutomationDiscoveryModalOpen: isAutomationDiscoveryModalOpen,
            setIsAutomationDiscoveryModalOpen: setIsAutomationDiscoveryModalOpen,
            shouldShowSpotlight: shouldShowSpotlight,
            targetColumnId: targetColumnId,
            isTargetColumn: isTargetColumn,
            setSpotlightTargetHasRendered: setSpotlightTargetHasRendered,
            spotlightTargetHasRendered: spotlightTargetHasRendered,
            dismissSpotlight: dismissSpotlight,
            statusName: statusName,
            automationRulesCount: automationRulesCount
        }
    }, children);
};

});
parcelRegister("aZqyz", function(module, exports) {

$parcel$export(module.exports, "useAutomationDiscoverySpotlight", () => $e3a1817608a7144f$export$4c5139e4f72fb284);

var $eUqFw = parcelRequire("eUqFw");

var $hzyEL = parcelRequire("hzyEL");
var $bufCq = parcelRequire("bufCq");

var $jBAQz = parcelRequire("jBAQz");

var $gUUjF = parcelRequire("gUUjF");

var $5cLMB = parcelRequire("5cLMB");
const $e3a1817608a7144f$export$27d659ae537a5de6 = 'jira.automation.discovery.on.board.columns';
const $e3a1817608a7144f$export$4c5139e4f72fb284 = (columns)=>{
    const [spotlightDismissed, setSpotlightDismissed] = (0, $eUqFw.useState)(true);
    const [hasSeenFlag, setHasSeenFlag] = (0, $eUqFw.useState)(false);
    const [spotlightTargetHasRendered, setSpotlightTargetHasRendered] = (0, $eUqFw.useState)(false);
    const { overlapsWithQuickstart: overlapsWithQuickstart } = (0, $bufCq.useOverlapsQuickstart)();
    const { overlapsWithImportFlag: overlapsWithImportFlag } = (0, $hzyEL.useOverlapsImportFlag)();
    const [quickstartStatus] = (0, $5cLMB.useQuickstartUiStatus)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!overlapsWithImportFlag && quickstartStatus !== (0, $5cLMB.QUICKSTART_UI_STATUS).NOT_LOADED && !overlapsWithQuickstart) setSpotlightDismissed(false);
    }, [
        overlapsWithImportFlag,
        overlapsWithQuickstart,
        quickstartStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchFlagFn = async ()=>(0, $jBAQz.getFlags)({
                [`${$e3a1817608a7144f$export$27d659ae537a5de6}`]: {}
            }).then((response)=>{
                if (response[`${$e3a1817608a7144f$export$27d659ae537a5de6}`]?.status) setHasSeenFlag(true);
            }).catch(()=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('automation-discovery', 'Failed to fetch have-i-seen-it flags.');
            });
        fetchFlagFn();
    }, []);
    const targetColumnId = columns.find((column)=>column.statusCategory === 'indeterminate' || column.statusCategoryId === 4)?.id ?? '';
    const isTargetColumn = (columnId)=>{
        if (Number(columnId) === 0 || Number(targetColumnId) === 0) return false;
        return Number(columnId) === Number(targetColumnId);
    };
    const shouldShowSpotlight = (columnId)=>spotlightTargetHasRendered && !hasSeenFlag && !spotlightDismissed && isTargetColumn(columnId);
    const dismissSpotlight = ()=>{
        (0, $jBAQz.setFlag)(`${$e3a1817608a7144f$export$27d659ae537a5de6}`);
        setSpotlightDismissed(true);
    };
    const setSpotlightTargetHasRenderedState = ()=>{
        if (!spotlightTargetHasRendered) setSpotlightTargetHasRendered(true);
    };
    return {
        targetColumnId: targetColumnId,
        isTargetColumn: isTargetColumn,
        shouldShowSpotlight: shouldShowSpotlight,
        dismissSpotlight: dismissSpotlight,
        setSpotlightTargetHasRendered: setSpotlightTargetHasRenderedState,
        spotlightTargetHasRendered: spotlightTargetHasRendered
    };
};

});
parcelRegister("hzyEL", function(module, exports) {

$parcel$export(module.exports, "useOverlapsImportFlag", () => $921cbfc96a763453$export$115ce958a1baf0a9);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $8L88Y = parcelRequire("8L88Y");
const $921cbfc96a763453$export$115ce958a1baf0a9 = ()=>{
    const { hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const overlapsWithInprogressFlag = hasFlag?.((0, $8L88Y.IMPORT_PARTIAL_SUCCESS_FLAG_ID));
    const overlapsWithPartialSuccessFlag = hasFlag?.((0, $8L88Y.IMPORT_IN_PROGRESS_FLAG_ID));
    const overlapsWithSuccessFlag = hasFlag?.((0, $8L88Y.IMPORT_SUCCESS_FLAG_ID));
    return (0, $eUqFw.useMemo)(()=>({
            overlapsWithImportFlag: overlapsWithInprogressFlag || overlapsWithPartialSuccessFlag || overlapsWithSuccessFlag
        }), [
        overlapsWithInprogressFlag,
        overlapsWithPartialSuccessFlag,
        overlapsWithSuccessFlag
    ]);
};

});
parcelRegister("8L88Y", function(module, exports) {

$parcel$export(module.exports, "IMPORT_IN_PROGRESS_FLAG_ID", () => $01029c1c9121a7c6$export$3ee01c364a42b386);
$parcel$export(module.exports, "IMPORT_SUCCESS_FLAG_ID", () => $01029c1c9121a7c6$export$b4a552f4abf9b350);
$parcel$export(module.exports, "IMPORT_PARTIAL_SUCCESS_FLAG_ID", () => $01029c1c9121a7c6$export$62eac7116dbcab91);
$parcel$export(module.exports, "IMPORT_ADVANCED_ERRORS_FLAG_ID", () => $01029c1c9121a7c6$export$18a16c13a76c4a32);
$parcel$export(module.exports, "BASE_POLLING_INTERVAL_MS", () => $01029c1c9121a7c6$export$aa34325aa01d2f38);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $01029c1c9121a7c6$export$2cea7f14750b8c19);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $01029c1c9121a7c6$export$2c16bd1d8b68b11f);
const $01029c1c9121a7c6$export$3ee01c364a42b386 = 'import-in-progress-flag';
const $01029c1c9121a7c6$export$b4a552f4abf9b350 = 'import-success-flag';
const $01029c1c9121a7c6$export$62eac7116dbcab91 = 'import-partial-success-flag';
const $01029c1c9121a7c6$export$18a16c13a76c4a32 = 'import-advanced-errors-error-flag';
const $01029c1c9121a7c6$export$aa34325aa01d2f38 = 5000;
const $01029c1c9121a7c6$export$2cea7f14750b8c19 = 'jira-business.project-create-import-progress';
const $01029c1c9121a7c6$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';

});


parcelRegister("bufCq", function(module, exports) {

$parcel$export(module.exports, "useOverlapsQuickstart", () => $41e997aec6d2c257$export$11b9ed0d0aa1a75e);

var $eUqFw = parcelRequire("eUqFw");

var $5cLMB = parcelRequire("5cLMB");

var $hzcvF = parcelRequire("hzcvF");
const $41e997aec6d2c257$export$11b9ed0d0aa1a75e = ()=>{
    const [quickstartStatus] = (0, $5cLMB.useQuickstartUiStatus)();
    const prevQuickstartStatus = (0, $hzcvF.usePreviousWithInitial)(quickstartStatus);
    return (0, $eUqFw.useMemo)(()=>({
            overlapsWithQuickstart: quickstartStatus === (0, $5cLMB.QUICKSTART_UI_STATUS).NOT_LOADED || quickstartStatus === (0, $5cLMB.QUICKSTART_UI_STATUS).OPEN || prevQuickstartStatus === 'OPEN'
        }), [
        prevQuickstartStatus,
        quickstartStatus
    ]);
};

});

parcelRegister("jBAQz", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $1749c1c9732fa517$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $1749c1c9732fa517$export$5e165df1e30a1331);

var $czx3b = parcelRequire("czx3b");

var $hwbh0 = parcelRequire("hwbh0");

var $e91YZ = parcelRequire("e91YZ");

var $1Cw1V = parcelRequire("1Cw1V");

var $gYp0l = parcelRequire("gYp0l");
const $1749c1c9732fa517$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $1749c1c9732fa517$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $1749c1c9732fa517$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gYp0l.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gYp0l.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1Cw1V.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gYp0l.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $1749c1c9732fa517$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $1749c1c9732fa517$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gYp0l.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $1749c1c9732fa517$export$5e165df1e30a1331 = async (flagKey, ttl = $1749c1c9732fa517$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gYp0l.default) {
        const value = (0, $gYp0l.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gYp0l.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1Cw1V.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});

parcelRegister("hwbh0", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $7hlYT = parcelRequire("7hlYT");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $cc0e2b7b9a1e48d7$var$zipObject(props, values) {
    return $7hlYT(props || [], values || [], $jDLwO);
}
module.exports = $cc0e2b7b9a1e48d7$var$zipObject;

});
parcelRegister("7hlYT", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $54cb2be8ad88e749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $54cb2be8ad88e749$var$baseZipObject;

});


parcelRegister("1Cw1V", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $27a69f89da9f41d0$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $27a69f89da9f41d0$export$d5815430bcc75df0);

var $czx3b = parcelRequire("czx3b");

var $7EhAs = parcelRequire("7EhAs");
const $27a69f89da9f41d0$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $27a69f89da9f41d0$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $27a69f89da9f41d0$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $27a69f89da9f41d0$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$27a69f89da9f41d0$var$convertToDates(response));
};

});

parcelRegister("gYp0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $16304c7221461599$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $16304c7221461599$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $89bO2.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $16304c7221461599$export$2e2bcd8739ae039 = $16304c7221461599$var$createStorage();

});



parcelRegister("I358h", function(module, exports) {

$parcel$export(module.exports, "useAutomationRulesBadge", () => $f979c2d594866625$export$d8edeaa55999a1ab);

var $eUqFw = parcelRequire("eUqFw");

var $7gbY6 = parcelRequire("7gbY6");
const $f979c2d594866625$export$d8edeaa55999a1ab = ()=>{
    const { fetch: fetch, error: error, loading: loading, data: data } = (0, $7gbY6.useAutomationRulesService)();
    const automationRulesCount = (0, $eUqFw.useMemo)(()=>{
        if (!data?.total) return 0;
        return data.total;
    }, [
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        fetch: fetch,
        error: error,
        loading: loading,
        automationRulesCount: error ? 0 : automationRulesCount
    };
};

});
parcelRegister("7gbY6", function(module, exports) {

$parcel$export(module.exports, "useAutomationRulesService", () => $b3043969021770b8$export$bfdb385524e08afb);

var $eUqFw = parcelRequire("eUqFw");

var $eym7N = parcelRequire("eym7N");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
var $JRB5w = parcelRequire("JRB5w");

var $aeIT6 = parcelRequire("aeIT6");

var $gd0Sp = parcelRequire("gd0Sp");
const $b3043969021770b8$export$bfdb385524e08afb = ()=>{
    const { environment: environment, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: project } = (0, $aeIT6.useProject)();
    const projectId = String(project?.id);
    const fetchRules = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const automationStack = await (0, $eym7N.getAutomationStack)(environment, cloudId);
            return (0, $2OdyW.default)(`/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rules`, {
                method: 'POST',
                body: JSON.stringify({
                    limit: 10,
                    offset: 0,
                    sortKey: 'NAME',
                    sortOrder: 'ASC'
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(0, $JRB5w.isClientFetchError)(error) && !(0, $JRB5w.isHttpClientErrorResponse)(error)) (0, $guiFP.default)({
                meta: {
                    id: 'fetchIssueTypes',
                    packageName: 'jiraMoonExperimentAutomationDiscoveryOnBoardColumns',
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: false
            });
            throw error;
        }
    }, [
        cloudId,
        environment,
        projectId
    ]);
    const { fetch: fetch, error: error, loading: loading, data: data } = (0, $eEzyV.useService)(fetchRules);
    return {
        fetch: fetch,
        error: error,
        loading: loading,
        data: data
    };
};

});
parcelRegister("eym7N", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $4cd6b2217d481809$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $4cd6b2217d481809$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $4cd6b2217d481809$export$8e479e490e1e69bc);

var $aZaPn = parcelRequire("aZaPn");

var $1ybV0 = parcelRequire("1ybV0");
const $4cd6b2217d481809$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('automation-menu');
const $4cd6b2217d481809$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $4cd6b2217d481809$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $1ybV0.ff)('automation.platform.pre-prod.instance')) {
            const stack = await $4cd6b2217d481809$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $4cd6b2217d481809$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $4cd6b2217d481809$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $4cd6b2217d481809$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $4cd6b2217d481809$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $4cd6b2217d481809$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $4cd6b2217d481809$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});




parcelRegister("fkLhx", function(module, exports) {

$parcel$export(module.exports, "useJwmAutomationDiscoveryOnBoardColumnsExperiment", () => $72d1c504548de1e4$export$fe13ec816a90938c);

var $eUqFw = parcelRequire("eUqFw");

var $e91YZ = parcelRequire("e91YZ");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $c7H0g = parcelRequire("c7H0g");
var $j3FUN = parcelRequire("j3FUN");
var $gd0Sp = parcelRequire("gd0Sp");
const $72d1c504548de1e4$export$fe13ec816a90938c = (shouldFireExposure = false)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const event = createAnalyticsEvent({});
    event.context.push({
        source: 'unknown',
        tags: [
            'measurement'
        ]
    });
    const eligible = (0, $eUqFw.useRef)(false);
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    const [expConfig, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    // User must be a valid user
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, isAnonymous: isAnonymous } = (0, $gd0Sp.useTenantContext)();
    const isValidUser = atlassianAccountId && cloudId && !isAnonymous;
    // User must have an Implicit Jwm License
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const { software: softwareEdition } = (0, $ab6rA.useAppEditions)();
    // User must be a site or project admin.
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const projectContext = (0, $bNe1g.useProjectContext)();
    const checkEligibility = (0, $eUqFw.useMemo)(()=>{
        const editions = [
            (0, $6WXNs.FREE_EDITION),
            (0, $6WXNs.STANDARD_EDITION),
            (0, $6WXNs.PREMIUM_EDITION)
        ];
        const hasImplicitJwmLicense = !licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_CORE] || licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && editions.some((edition)=>edition === softwareEdition);
        const isAutomationAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
        if (isValidUser && hasImplicitJwmLicense && isAutomationAdmin) {
            eligible.current = true;
            return cohort === 'variation';
        }
        return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFireExposure
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldFireExposure && eligible.current) {
            (0, $jMP2a.fireTrackAnalytics)(event, 'feature exposed', {
                flagKey: 'jwm_moon_automation_discovery_v2',
                value: cohort
            });
            fireExposure();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        shouldRenderExperiment: checkEligibility
    };
};

});

parcelRegister("3sztN", function(module, exports) {

$parcel$export(module.exports, "useDropHandler", () => $4fe8e8e343be2ce6$export$c0f5f9f6a076ec6b);

var $eUqFw = parcelRequire("eUqFw");

var $fSMvP = parcelRequire("fSMvP");

var $4ziMO = parcelRequire("4ziMO");

var $eo9PV = parcelRequire("eo9PV");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $blcyP = parcelRequire("blcyP");

var $gKXju = parcelRequire("gKXju");

var $ay4XV = parcelRequire("ay4XV");

var $aKK8W = parcelRequire("aKK8W");

var $gWYTK = parcelRequire("gWYTK");

var $gMJE7 = parcelRequire("gMJE7");
const $4fe8e8e343be2ce6$export$c0f5f9f6a076ec6b = (initialPageLoading)=>{
    const onGroupMove = (0, $blcyP.useGroupMoveHandler)();
    const moveIssue = (0, $aKK8W.useMoveIssue)();
    const groups = (0, $gKXju.useGroups)();
    const { cancelCardDrop: cancelCardDrop, confirmCardDrop: confirmCardDrop } = (0, $gWYTK.useCancelConfirmCardDrop)();
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const { draggedIssue: draggedIssue, dropTarget: dropTarget } = (0, $gWYTK.useCardDragDrop)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>(0, $eo9PV.monitorForElements)({
            canMonitor: ()=>!initialPageLoading,
            onDrop: ({ location: location, source: source })=>{
                const sourceData = source.data;
                if (location.current.dropTargets[0]?.data == null) {
                    if ((0, $gMJE7.isCard)(sourceData)) {
                        cancelCardDrop();
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                    return;
                }
                const destinationData = location.current.dropTargets[0].data;
                // Dropping a card.
                if ((0, $gMJE7.isCard)(sourceData) && draggedIssue != null) {
                    // Dropping a card next to another card.
                    if ((0, $gMJE7.isCard)(destinationData)) {
                        const closestEdgeOfTarget = (0, $fSMvP.extractClosestEdge)(destinationData);
                        const sourceIndex = sourceData.cardIndex;
                        const destinationIndex = destinationData.cardIndex;
                        const sourceColumnId = sourceData.columnId;
                        const destinationColumnId = destinationData.columnId;
                        // Return early if unable to determine the closest edge of the target.
                        if (closestEdgeOfTarget == null) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the card is dropped in the same place.
                        if (sourceData.issueId === destinationData.issueId) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the drop location would not result in a change in rank.
                        // e.g. dropping a card near the bottom of the previous card or near the top of the next card.
                        if (sourceColumnId === destinationColumnId && (0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) {
                            cancelCardDrop();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        moveIssue({
                            issue: draggedIssue,
                            sourceColumnId: sourceColumnId,
                            destinationColumnId: destinationColumnId,
                            rank: {
                                position: closestEdgeOfTarget === 'top' ? 'before' : 'after',
                                relativeIssueId: destinationData.issueId
                            },
                            transition: dropTarget.transition
                        });
                        confirmCardDrop();
                    } else if ((0, $gMJE7.isColumn)(destinationData) || (0, $gMJE7.isTransitionZone)(destinationData)) {
                        const transition = (0, $gMJE7.isColumn)(destinationData) ? dropTarget.transition : transitions.find((t)=>t.transitionId === destinationData.transitionId);
                        moveIssue({
                            issue: draggedIssue,
                            sourceColumnId: sourceData.columnId,
                            destinationColumnId: String(destinationData.columnId),
                            transition: transition
                        });
                        confirmCardDrop();
                    } else {
                        cancelCardDrop();
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                }
                // Dropping a column.
                if ((0, $gMJE7.isColumn)(sourceData) && (0, $gMJE7.isColumn)(destinationData)) {
                    const sourceIndex = sourceData.index;
                    const destinationIndex = destinationData.index;
                    if (sourceIndex === destinationIndex) return;
                    const closestEdgeOfTarget = (0, $fSMvP.extractClosestEdge)(destinationData);
                    // Return early if the drop location would not change the order of the columns.
                    // e.g. dropping a column near the right edge of the previous column or near the left edge of the next column.
                    if ((0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) return;
                    const updatedGroups = (0, $4ziMO.reorderWithEdge)({
                        list: groups,
                        startIndex: sourceIndex,
                        indexOfTarget: destinationIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: 'horizontal'
                    });
                    const updatedGroupIds = updatedGroups.map((group)=>group.id);
                    onGroupMove(updatedGroupIds);
                }
            }
        }), [
        cancelCardDrop,
        confirmCardDrop,
        createAnalyticsEvent,
        draggedIssue,
        dropTarget.transition,
        groups,
        initialPageLoading,
        moveIssue,
        onGroupMove,
        transitions
    ]);
};

});
parcelRegister("fSMvP", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $2724dbed1c43baeb$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $2724dbed1c43baeb$export$945a571f3b658bf);
const $2724dbed1c43baeb$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $2724dbed1c43baeb$var$uniqueKey = Symbol('closestEdge');
function $2724dbed1c43baeb$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $2724dbed1c43baeb$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$2724dbed1c43baeb$var$uniqueKey]: addClosestEdge
    };
}
function $2724dbed1c43baeb$export$945a571f3b658bf(userData) {
    return userData[$2724dbed1c43baeb$var$uniqueKey] ?? null;
}

});

parcelRegister("4ziMO", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $c0c67ffc21923aca$export$d0bc664d2812b3ba);
parcelRequire("gPx3x");
var $j2oqV = parcelRequire("j2oqV");

var $4c90u = parcelRequire("4c90u");
function $c0c67ffc21923aca$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $j2oqV.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $4c90u.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("gPx3x", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("j2oqV")).reorder);

var $j2oqV = parcelRequire("j2oqV");

});
parcelRegister("j2oqV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $6e81661ae370c059$export$fc77a6137e3f91c);
/**
 * Reorder a provided `list`
 * Returns a new array and does not modify the original array
 */ function $6e81661ae370c059$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) return list;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("4c90u", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $aa4edc6717644668$export$846f792f51b92b6e);
function $aa4edc6717644668$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("blcyP", function(module, exports) {

$parcel$export(module.exports, "useGroupMoveHandler", () => $31cafa26926512c1$export$fb43401b85e3d132);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $20OC3 = parcelRequire("20OC3");

var $iXHUp = parcelRequire("iXHUp");

var $2XClh = parcelRequire("2XClh");

var $iq40z = parcelRequire("iq40z");

var $gsogj = parcelRequire("gsogj");
const $31cafa26926512c1$export$3daa7ae3a08bb9e3 = (0, $eo17r.toFlagId)('move-column-error-flag');
const $31cafa26926512c1$export$fb43401b85e3d132 = ()=>{
    const { workflowName: workflowName, columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    const { setColumns: setColumns } = (0, $iq40z.useWorkflowStoreActions)();
    const groupBy = (0, $iXHUp.useGroupByField)();
    const [, setGroupOrder] = (0, $2XClh.useGroupsOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    return (0, $eUqFw.useCallback)(async (updatedGroupIds)=>{
        if (workflowName != null) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'column dragged', 'board');
            if (groupBy === (0, $jGcn0.GROUP_BY_STATUS)) {
                const updatedColumns = [];
                updatedGroupIds.forEach((groupId)=>{
                    const column = columns.find((col)=>String(col.statusId) === groupId);
                    if (column) updatedColumns.push(column);
                });
                setColumns(updatedColumns);
                try {
                    await (0, $20OC3.persistStatusGroups)(projectId, workflowName, updatedGroupIds);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setColumns(columns);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'jwmBoardControllerOnColumnMove',
                            packageName: 'jiraWorkManagementBoard',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to set column order in JWM board'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        id: $31cafa26926512c1$export$3daa7ae3a08bb9e3,
                        type: 'error',
                        title: (0, $gsogj.default).columnMoveErrorTitle,
                        description: (0, $gsogj.default).columnMoveErrorMessage
                    });
                }
            } else setGroupOrder(updatedGroupIds);
        }
    }, [
        workflowName,
        createAnalyticsEvent,
        groupBy,
        setColumns,
        columns,
        projectId,
        showFlag,
        setGroupOrder
    ]);
};

});
parcelRegister("20OC3", function(module, exports) {

$parcel$export(module.exports, "setColumnsOld", () => $8a9e513fdd8e2bc7$export$b73909d28c463584);
$parcel$export(module.exports, "persistStatusGroups", () => $8a9e513fdd8e2bc7$export$e3fa907cd4677f60);

var $lHbJt = parcelRequire("lHbJt");
const $8a9e513fdd8e2bc7$export$b73909d28c463584 = async (projectId, selectedWorkflow, updatedColumns)=>{
    const request = {
        columnRequest: {
            workflowName: selectedWorkflow,
            columns: updatedColumns.map((c)=>({
                    name: c.name,
                    statusCategory: c.statusCategory,
                    statusId: c.statusId,
                    canCreateIssues: c.canCreateIssues,
                    hasFilteredIssues: c.hasFilteredIssues
                }))
        },
        projectId: projectId
    };
    await (0, $lHbJt.setBoardColumnOrder)(request);
};
const $8a9e513fdd8e2bc7$export$e3fa907cd4677f60 = async (projectId, selectedWorkflow, updatedGroupIds)=>{
    const request = {
        columnRequest: {
            workflowName: selectedWorkflow,
            columns: updatedGroupIds.map((statusId)=>({
                    statusId: statusId
                }))
        },
        projectId: projectId
    };
    await (0, $lHbJt.setBoardColumnOrder)(request);
};

});
parcelRegister("lHbJt", function(module, exports) {

$parcel$export(module.exports, "setBoardColumnOrder", () => $62dd4a32972bce00$export$8e48c3971c45541d);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $62dd4a32972bce00$export$8e48c3971c45541d = async ({ projectId: projectId, columnRequest: columnRequest })=>{
    const url = `/rest/board-api/1/project/${projectId}/columnOrder`;
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(columnRequest)
        });
        return Promise.resolve(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jwmBoardSetColumnOrder',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed set board column order'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("gsogj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3200b6d7abd85587$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3200b6d7abd85587$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnMoveErrorTitle: {
        "id": "work-management-board.controllers.column-move-handler.column-move-error-title",
        "defaultMessage": "Failed to move column"
    },
    columnMoveErrorMessage: {
        "id": "work-management-board.controllers.column-move-handler.column-move-error-message",
        "defaultMessage": "We couldn't move this column, try refreshing the page or try again later."
    }
});

});


parcelRegister("aKK8W", function(module, exports) {

$parcel$export(module.exports, "useMoveIssue", () => $7c208b7e8aea750a$export$47e46c713d0f867d);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $iLiDV = parcelRequire("iLiDV");

var $gWYTK = parcelRequire("gWYTK");

var $d4s3F = parcelRequire("d4s3F");

var $gKXju = parcelRequire("gKXju");

var $6kWQc = parcelRequire("6kWQc");
const $7c208b7e8aea750a$var$isIssueNewlyMarkedAsDone = (sourceGroup, destinationGroup)=>{
    if (sourceGroup.type !== (0, $jGcn0.GROUP_BY_STATUS)) return false;
    return sourceGroup.statusCategoryId !== (0, $8Qd0L.StatusCategoryIds).done && destinationGroup.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
};
const $7c208b7e8aea750a$export$47e46c713d0f867d = ()=>{
    const groups = (0, $gKXju.useGroups)();
    const addConfettiColumn = (0, $iLiDV.useAddConfettiColumn)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const updateIssue = (0, $6kWQc.useUpdateIssue)();
    const { fireCardDropAnalytics: fireCardDropAnalytics } = (0, $d4s3F.useCardDragDropAnalytics)();
    const updateSessionId = (0, $gWYTK.useUpdateSessionId)();
    return (0, $eUqFw.useCallback)(async ({ issue: issue, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rank: rank, transition: transition })=>{
        let showConfetti = false;
        const sourceGroup = groups.find((group)=>group.id === sourceColumnId);
        const destinationGroup = groups.find((group)=>group.id === destinationColumnId);
        if (sourceGroup == null || destinationGroup == null) throw new Error('Source or destination group not found');
        const destinationGroupType = destinationGroup.type;
        const fieldUpdates = {};
        if (sourceColumnId !== destinationColumnId) {
            switch(destinationGroupType){
                case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                    fieldUpdates[0, $ib4WI.ASSIGNEE_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_USER),
                        value: destinationGroup.id,
                        user: {
                            accountId: destinationGroup.id,
                            avatarURL: destinationGroup.imageUrl,
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_CATEGORY:
                    if (categoryField) fieldUpdates[0, $ib4WI.CATEGORY_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        name: categoryField.name,
                        fieldId: categoryField.id,
                        type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
                        value: destinationGroup.id,
                        category: {
                            color: destinationGroup.color,
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_PRIORITY:
                    fieldUpdates[0, $ib4WI.PRIORITY_ID] = destinationGroup.id === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : {
                        fieldId: (0, $lO4Or.PRIORITY_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
                        value: destinationGroup.id,
                        priority: {
                            id: destinationGroup.id,
                            iconUrl: destinationGroup.imageUrl ?? '',
                            name: destinationGroup.name
                        }
                    };
                    break;
                case 0, $jGcn0.GROUP_BY_STATUS:
                    showConfetti = $7c208b7e8aea750a$var$isIssueNewlyMarkedAsDone(sourceGroup, destinationGroup);
                    fieldUpdates[0, $ib4WI.STATUS_ID] = {
                        fieldId: (0, $lO4Or.STATUS_TYPE),
                        type: (0, $ib4WI.BOARD_FIELD_STATUS),
                        value: destinationGroup.id,
                        status: {
                            id: destinationGroup.id,
                            statusCategoryId: destinationGroup.statusCategoryId,
                            name: destinationGroup.name
                        }
                    };
                    break;
                default:
                    {
                        const exhaustiveCheck = destinationGroupType;
                        throw new Error(`Unexpected destination group type: ${exhaustiveCheck}`);
                    }
            }
            // Check if the issue is already moving to a column that should show confetti
            showConfetti = showConfetti || (0, $iLiDV.matchConfettiColumn)(destinationGroup.name);
        }
        try {
            await updateIssue({
                issue: issue,
                fields: fieldUpdates,
                transition: transition,
                rank: rank
            });
            if (showConfetti) addConfettiColumn(destinationColumnId);
            if (updateSessionId == null) throw new Error('updateSessionId is required for card drop analytics');
            fireCardDropAnalytics({
                issue: issue,
                sourceGroup: sourceGroup,
                destinationGroup: destinationGroup,
                rank: rank,
                transition: transition,
                updateSessionId: updateSessionId
            });
        } catch (error) {
        // errors handled in updateIssue controller
        }
    }, [
        addConfettiColumn,
        categoryField,
        fireCardDropAnalytics,
        groups,
        updateIssue,
        updateSessionId
    ]);
};

});
parcelRegister("6kWQc", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssue", () => $60b14c9fcb9777c6$export$5ad547ae8fa63f55);

var $eUqFw = parcelRequire("eUqFw");

var $e4qlg = parcelRequire("e4qlg");

var $k8Qyf = parcelRequire("k8Qyf");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $cZTdZ = parcelRequire("cZTdZ");

var $5bODR = parcelRequire("5bODR");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $lgmYa = parcelRequire("lgmYa");

var $5FsEp = parcelRequire("5FsEp");

var $7vHge = parcelRequire("7vHge");

var $aW8xg = parcelRequire("aW8xg");
const $60b14c9fcb9777c6$export$5ad547ae8fa63f55 = ()=>{
    const fieldIds = (0, $lgmYa.useFieldIds)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { updateIssueFields: updateIssueFields, setIssues: setIssues } = (0, $dtXTv.useIssueStoreActions)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const updateIssueFieldsService = (0, $5bODR.useUpdateIssueFields)();
    const transitionAndRankIssueService = (0, $cZTdZ.useTransitionAndRankIssueService)();
    const openTransitionScreenModal = (0, $7vHge.useTransitionScreenModal)();
    return (0, $eUqFw.useCallback)(async ({ issue: issue, fields: fields, rank: rank, transition: transition })=>{
        // optimistically update the issue fields
        updateIssueFields({
            issueId: issue.id,
            fields: fields,
            rank: rank
        });
        let hasTriedFieldsUpdate = false;
        let hasTriedStatusTransition = false;
        let hasTriedRanking = false;
        try {
            // perform field updates first as they are performed through REST
            // and cannot return the full issue data
            if (fields != null) {
                const fieldsForUpdate = [];
                if ((0, $ib4WI.ASSIGNEE_ID) in fields) fieldsForUpdate.push({
                    fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
                    value: fields[0, $ib4WI.ASSIGNEE_ID]
                });
                if ((0, $ib4WI.PRIORITY_ID) in fields) fieldsForUpdate.push({
                    fieldId: (0, $lO4Or.PRIORITY_TYPE),
                    value: fields[0, $ib4WI.PRIORITY_ID]
                });
                if ((0, $ib4WI.CATEGORY_ID) in fields && categoryField?.id != null) fieldsForUpdate.push({
                    fieldId: categoryField.id,
                    value: fields[0, $ib4WI.CATEGORY_ID]
                });
                if (fieldsForUpdate.length > 0) {
                    hasTriedFieldsUpdate = true;
                    await updateIssueFieldsService(issue.id, fieldsForUpdate);
                }
            }
            if (transition != null || rank != null) {
                hasTriedStatusTransition = transition != null;
                hasTriedRanking = rank != null;
                if (transition?.hasScreen) {
                    // if the transition has a screen, the transition is done through the modal
                    await openTransitionScreenModal(issue, transition.transitionId);
                    // only the ranking needs to be updated after the transition
                    if (rank == null) refetchIssues([
                        issue.id
                    ]);
                    else {
                        const response = await transitionAndRankIssueService({
                            fieldIds: fieldIds,
                            issueId: issue.id,
                            rank: rank
                        });
                        setIssues(transformToIssues([
                            response
                        ]));
                    }
                } else {
                    const response = await transitionAndRankIssueService({
                        fieldIds: fieldIds,
                        issueId: issue.id,
                        rank: rank,
                        transitionId: transition?.transitionId
                    });
                    setIssues(transformToIssues([
                        response
                    ]));
                }
            }
        } catch (error) {
            // if anything failed, refetch issues
            refetchIssues([
                issue.id
            ]);
            // if the user cancelled the transition modal, do not show an error flag
            if (error instanceof (0, $7vHge.TransitionModalCanceled)) throw error;
            if (error instanceof (0, $cZTdZ.TransitionValidationError)) showFlag({
                type: 'warning',
                title: (0, $aW8xg.default).transitionValidationErrorTitle,
                description: error.message
            });
            else if (hasTriedStatusTransition) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToTransitionErrorTitle,
                description: (0, $aW8xg.default).failedToTransitionErrorDescription
            });
            else if (hasTriedFieldsUpdate) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToUpdateFieldsErrorTitle,
                description: (0, $aW8xg.default).failedToUpdateFieldsErrorDescription
            });
            else if (hasTriedRanking) showFlag({
                type: 'error',
                title: (0, $aW8xg.default).failedToRankErrorTitle,
                description: (0, $aW8xg.default).failedToRankErrorDescription
            });
            throw error;
        }
    }, [
        updateIssueFields,
        categoryField?.id,
        updateIssueFieldsService,
        transitionAndRankIssueService,
        fieldIds,
        setIssues,
        transformToIssues,
        openTransitionScreenModal,
        refetchIssues,
        showFlag
    ]);
};

});
parcelRegister("cZTdZ", function(module, exports) {

$parcel$export(module.exports, "TransitionValidationError", () => $60f6ec24021a2f56$export$eab080807dcecbbf);
$parcel$export(module.exports, "useTransitionAndRankIssueService", () => $60f6ec24021a2f56$export$13974bef1886fce4);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $kkYfO = parcelRequire("kkYfO");
var $053h2 = parcelRequire("053h2");

var $4G5xU = parcelRequire("4G5xU");

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $a9E08 = parcelRequire("a9E08");
const $60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE = {
    experience: 'transitionAndRankIssue',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
class $60f6ec24021a2f56$export$eab080807dcecbbf extends Error {
}
const $60f6ec24021a2f56$export$13974bef1886fce4 = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const startTransitionAndRankIssueExperience = (0, $4G5xU.useExperienceStart)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const markTransitionAndRankIssueSuccess = (0, $4G5xU.useExperienceSuccess)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const markTransitionAndRankIssueFailed = (0, $4G5xU.useExperienceFail)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const abortTransitionAndRankIssueExperience = (0, $4G5xU.useExperienceAbort)($60f6ec24021a2f56$var$TRANSITION_AND_RANK_EXPERIENCE);
    const [transitionAndRankMutation] = (0, $iZuDo.useMutation)((0, $a9E08.TRANSITION_AND_RANK_ISSUE_MUTATION));
    return (0, $eUqFw.useCallback)(async ({ fieldIds: fieldIdsInput, issueId: issueId, rank: rank, transitionId: transitionId })=>{
        startTransitionAndRankIssueExperience();
        try {
            const fieldIds = new Set(fieldIdsInput);
            const withChildrenCount = fieldIds.has((0, $lO4Or.SUBTASKS_TYPE));
            fieldIds.delete((0, $lO4Or.SUBTASKS_TYPE));
            const withConfluenceLinks = hasConfluence && fieldIds.has((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
            fieldIds.delete((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIds.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIds.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const withIssueLinks = fieldIds.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
            fieldIds.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            let rankInput;
            if (rank?.position === 'before') rankInput = {
                beforeIssueId: rank.relativeIssueId
            };
            else if (rank?.position === 'after') rankInput = {
                afterIssueId: rank.relativeIssueId
            };
            const { data: data, errors: errors } = await transitionAndRankMutation({
                variables: {
                    fieldIds: Array.from(fieldIds),
                    input: {
                        issueIds: [
                            issueId
                        ],
                        rank: rankInput,
                        transitionId: transitionId
                    },
                    withConfluenceLinks: withConfluenceLinks,
                    withCoverMedia: withCoverMedia,
                    withIssueLinks: withIssueLinks,
                    withExtendedIssue: true,
                    withChildrenCount: withChildrenCount
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationError = data?.transitionAndRankJwmItems?.errors?.[0];
            if (mutationError != null) {
                if (mutationError.message != null && mutationError.extensions?.statusCode === 400 && mutationError.extensions.errorType === 'TRANSITION_ERROR') throw new $60f6ec24021a2f56$export$eab080807dcecbbf(mutationError.message);
                throw new (0, $kkYfO.MutationError)(mutationError);
            }
            if (errors) {
                const apolloError = new (0, $jlBDe.ApolloError)({
                    graphQLErrors: errors
                });
                if ((0, $053h2.shouldHandleTheError)(apolloError)) throw apolloError;
            }
            if (!data) throw new Error('No transition and rank response');
            const responseData = data.transitionAndRankJwmItems;
            const issue = data.transitionAndRankJwmItems?.items?.[0]?.fieldsByIdOrAlias != null ? responseData?.items?.[0] : null;
            if (issue == null) throw new Error('Invalid transition and rank response');
            markTransitionAndRankIssueSuccess();
            return issue;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof $60f6ec24021a2f56$export$eab080807dcecbbf) abortTransitionAndRankIssueExperience('Transition validation error');
            else markTransitionAndRankIssueFailed('Failed to transition and rank issue', error);
            throw error;
        }
    }, [
        startTransitionAndRankIssueExperience,
        hasConfluence,
        isLinkingEnabled,
        transitionAndRankMutation,
        markTransitionAndRankIssueSuccess,
        abortTransitionAndRankIssueExperience,
        markTransitionAndRankIssueFailed
    ]);
};

});
parcelRegister("a9E08", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_AND_RANK_ISSUE_MUTATION", () => $db840fa3b3261479$export$f0fa92a42f51bf9b);

var $9ypom = parcelRequire("9ypom");

var $iwwE5 = parcelRequire("iwwE5");
const $db840fa3b3261479$export$f0fa92a42f51bf9b = (0, $9ypom.default)`
mutation JWMBoardTransitionAndRankIssue($input: JWMTransitionAndRankItemInput!, $fieldIds: [String]!, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withExtendedIssue: Boolean!, $withChildrenCount: Boolean!) {
    transitionAndRankJwmItems(input: $input, fieldIdsToReturn: $fieldIds) {
      items {
        ...JIS2_JWMBoardItemFragment
        ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
      }
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $iwwE5.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});


parcelRegister("5bODR", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueFields", () => $f0af32663b0b5785$export$f6fa7ea1cda1a715);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $lRmyA = parcelRequire("lRmyA");

var $ib4WI = parcelRequire("ib4WI");
const $f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE = {
    experience: 'updateIssueFields',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $f0af32663b0b5785$export$f6fa7ea1cda1a715 = ()=>{
    const startUpdateIssueFieldsExperience = (0, $4G5xU.useExperienceStart)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    const markUpdateIssueFieldsSuccess = (0, $4G5xU.useExperienceSuccess)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    const markUpdateIssueFieldsFailed = (0, $4G5xU.useExperienceFail)($f0af32663b0b5785$var$UPDATE_ISSUE_FIELDS_EXPERIENCE);
    return (0, $eUqFw.useCallback)(async (issueId, fields)=>{
        const fieldsPayload = {};
        fields.forEach((field)=>{
            const fieldId = field.fieldId;
            const fieldValue = field.value;
            if (fieldValue == null) {
                fieldsPayload[field.fieldId] = null;
                return;
            }
            const { type: type } = fieldValue;
            switch(type){
                case 0, $ib4WI.BOARD_FIELD_PRIORITY:
                    fieldsPayload[fieldId] = {
                        id: fieldValue.priority.id
                    };
                    break;
                case 0, $ib4WI.BOARD_FIELD_CATEGORY:
                    fieldsPayload[fieldId] = {
                        value: fieldValue.category.name
                    };
                    break;
                case 0, $ib4WI.BOARD_FIELD_USER:
                    fieldsPayload[fieldId] = {
                        accountId: fieldValue.user.accountId
                    };
                    break;
                default:
                    {
                        const exhaustiveCheck = type;
                        throw new Error(`Unexpected field type value: ${exhaustiveCheck}`);
                    }
            }
        });
        startUpdateIssueFieldsExperience();
        try {
            await (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueId}/`, {
                body: JSON.stringify({
                    fields: fieldsPayload
                })
            });
            markUpdateIssueFieldsSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            markUpdateIssueFieldsFailed('Failed to update issue fields', error);
            throw error;
        }
    }, [
        markUpdateIssueFieldsFailed,
        markUpdateIssueFieldsSuccess,
        startUpdateIssueFieldsExperience
    ]);
};

});

parcelRegister("7vHge", function(module, exports) {

$parcel$export(module.exports, "TransitionModalCanceled", () => $50acfe2cbc90d8f6$export$193fd3145c53120d);
$parcel$export(module.exports, "useTransitionScreenModal", () => $50acfe2cbc90d8f6$export$216691fd9138d702);

var $eUqFw = parcelRequire("eUqFw");

var $2Shq0 = parcelRequire("2Shq0");

var $1a3la = parcelRequire("1a3la");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");
const $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY = 'issue-transition-board-card-transition';
class $50acfe2cbc90d8f6$export$193fd3145c53120d extends Error {
}
const $50acfe2cbc90d8f6$export$216691fd9138d702 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    return (0, $eUqFw.useCallback)((issue, transitionId)=>new Promise((resolve, reject)=>{
            const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
            const ariIssueId = (0, $2Shq0.JiraIssueAri).create({
                issueId: String(issue.id),
                siteId: cloudId
            }).toString();
            const onDialogSuccess = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition success', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                resolve(undefined);
            };
            const onDialogError = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition failed', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new Error('Issue transition failed'));
            };
            const onDialogCancel = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition cancel', {
                    triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new $50acfe2cbc90d8f6$export$193fd3145c53120d('Issue transition canceled'));
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: String(transitionId)
                },
                triggerPointKey: $50acfe2cbc90d8f6$var$TRIGGER_POINT_KEY,
                onDialogSuccess: onDialogSuccess,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError
            });
        }), [
        cloudId,
        createAnalyticsEvent,
        openIssueTransitionModal
    ]);
};

});
parcelRegister("2Shq0", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $f33aa2105af1c8a3$export$1da6808e89ee03e);

var $dD8N7 = parcelRequire("dD8N7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue/manifest.ts
var $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dD8N7.JiraIssueAriResourceOwner),
    resourceType: (0, $dD8N7.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $f33aa2105af1c8a3$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dD8N7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $5b32aaefd8525674$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $5b32aaefd8525674$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $5b32aaefd8525674$export$665a39f1b4e29e0a = "jira", $5b32aaefd8525674$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);

var $eUqFw = parcelRequire("eUqFw");

var $6XOSh = parcelRequire("6XOSh");

var $b3pJg = parcelRequire("b3pJg");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        isEnabled,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...actions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $a61MH.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $heB5U.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $ggKAj.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $ggKAj.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';


parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $lNfG4 = parcelRequire("lNfG4");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $lNfG4.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");
var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $duQ8C = parcelRequire("duQ8C");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    if ((0, $1ybV0.ff)('modernised-its-end-to-end-ufo-experience_m5e7f')) (0, $3gb01.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('issue-transition.transition-modal-subsequent');
    else (0, $duQ8C.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $dda1b5d926efd158$export$2f3b26e8acf79182);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $dda1b5d926efd158$export$2f3b26e8acf79182 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $lNfG4 = parcelRequire("lNfG4");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $lNfG4.metrics).interaction({
    key: 'issue-transition-modal'
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $lNfG4.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $lNfG4.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $dfBCt.isFedRamp)()) return true;
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});





parcelRegister("aW8xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19b0fcd13621f65$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d19b0fcd13621f65$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    transitionValidationErrorTitle: {
        "id": "work-management-board.controllers.update-issue.transition-validation-error-title",
        "defaultMessage": "Transition failed"
    },
    failedToTransitionErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-title",
        "defaultMessage": "We couldn't change the status of the item"
    },
    failedToTransitionErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToRankErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-title",
        "defaultMessage": "We couldn't move the item"
    },
    failedToRankErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToUpdateFieldsErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-title",
        "defaultMessage": "We couldn't update the item"
    },
    failedToUpdateFieldsErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("gMJE7", function(module, exports) {

$parcel$export(module.exports, "isCard", () => $c8cfed47b1de5a2c$export$8aa6e45444373ba8);
$parcel$export(module.exports, "isColumn", () => $c8cfed47b1de5a2c$export$891484e65a02ec71);
$parcel$export(module.exports, "isTransitionZone", () => $c8cfed47b1de5a2c$export$3efcc0a6b0c287c2);
$parcel$export(module.exports, "isClosestEdgeAdjacentToSource", () => $c8cfed47b1de5a2c$export$775b69cd23194e37);


var $ib4WI = parcelRequire("ib4WI");
function $c8cfed47b1de5a2c$export$8aa6e45444373ba8(data) {
    return data.type === (0, $ib4WI.CARD_DND_TYPE);
}
function $c8cfed47b1de5a2c$export$891484e65a02ec71(data) {
    return data.type === (0, $ib4WI.COLUMN_DND_TYPE);
}
function $c8cfed47b1de5a2c$export$3efcc0a6b0c287c2(data) {
    return data.type === (0, $df03f3fe1f111432$export$2927f4d423091b16);
}
const $c8cfed47b1de5a2c$export$775b69cd23194e37 = (sourceIndex, destinationIndex, closestEdge)=>{
    if (closestEdge == null) return false;
    const adjacentEdges = {
        top: sourceIndex + 1,
        bottom: sourceIndex - 1,
        left: sourceIndex + 1,
        right: sourceIndex - 1
    };
    return destinationIndex === adjacentEdges[closestEdge];
};

});
const $df03f3fe1f111432$export$b05303cbde3e8c8c = 'CARD';
const $df03f3fe1f111432$export$57d0ef745f304b91 = 'COLUMN';
const $df03f3fe1f111432$export$2927f4d423091b16 = 'TRANSITION_ZONE';



parcelRegister("2b5eO", function(module, exports) {

$parcel$export(module.exports, "useJWMBoardFeatures", () => $f39a893ab3cf4c9e$export$2e6493f557c370c4);
$parcel$export(module.exports, "default", () => $f39a893ab3cf4c9e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f39a893ab3cf4c9e$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'jwm-board',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default'
};
const $f39a893ab3cf4c9e$var$JWMBoardFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($f39a893ab3cf4c9e$var$defaultFeaturesContext);
const $f39a893ab3cf4c9e$export$2e6493f557c370c4 = ()=>(0, $eUqFw.useContext)($f39a893ab3cf4c9e$var$JWMBoardFeaturesContext);
var $f39a893ab3cf4c9e$export$2e2bcd8739ae039 = $f39a893ab3cf4c9e$var$JWMBoardFeaturesContext;

});

parcelRegister("cY0Xy", function(module, exports) {

$parcel$export(module.exports, "useHandleIssueEvents", () => $c6c56e79d7475f18$export$6339e8336d465669);

var $eUqFw = parcelRequire("eUqFw");

var $d3C6e = parcelRequire("d3C6e");

var $ib4WI = parcelRequire("ib4WI");

var $dtXTv = parcelRequire("dtXTv");

var $d1mZL = parcelRequire("d1mZL");

var $5FsEp = parcelRequire("5FsEp");
const $c6c56e79d7475f18$export$6339e8336d465669 = ()=>{
    const issues = (0, $d1mZL.useIssues)();
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const { removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    const handleUpdatedIssue = (0, $eUqFw.useCallback)(async (issueId)=>{
        // Return early when we receive realtime events for an issue that was
        // recently created via the issue create component in the current window.
        // This avoid race conditions.
        if (getIsHighlighted(issueId)) return;
        const [updatedIssue] = await refetchIssues([
            issueId
        ]);
        if (updatedIssue) {
            const parentIssueId = updatedIssue.fields[0, $ib4WI.PARENT_ID]?.value;
            if (parentIssueId) refetchIssues([
                Number(parentIssueId)
            ]);
        }
    }, [
        getIsHighlighted,
        refetchIssues
    ]);
    const handleDeletedIssue = (0, $eUqFw.useCallback)((issueId)=>{
        const deletedIssue = issues.get(issueId);
        if (deletedIssue == null) return;
        const parentIssue = issues.get(Number(deletedIssue.fields[0, $ib4WI.PARENT_ID]?.value));
        if (parentIssue) refetchIssues([
            parentIssue.id
        ]);
        removeIssues([
            issueId
        ]);
    }, [
        issues,
        refetchIssues,
        removeIssues
    ]);
    return {
        handleUpdatedIssue: handleUpdatedIssue,
        handleDeletedIssue: handleDeletedIssue
    };
};

});

parcelRegister("c52lf", function(module, exports) {

$parcel$export(module.exports, "IssuesByGroupProvider", () => $82f310c299227d34$export$15e029fbfaee4283);
$parcel$export(module.exports, "useIssueGroups", () => $82f310c299227d34$export$2a761b53b8f42b98);
$parcel$export(module.exports, "IssueGroupProvider", () => $82f310c299227d34$export$dc797f621868b0d5);
$parcel$export(module.exports, "useIssueGroup", () => $82f310c299227d34$export$7169da554b06d9e9);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ib4WI = parcelRequire("ib4WI");

var $iXHUp = parcelRequire("iXHUp");

var $gKXju = parcelRequire("gKXju");

var $2XClh = parcelRequire("2XClh");
const $82f310c299227d34$var$EMPTY_ISSUES = [];
const $82f310c299227d34$var$RootContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $82f310c299227d34$export$15e029fbfaee4283 = ({ filteredIssues: filteredIssues, children: children })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const issuesByGroup = (0, $eUqFw.useMemo)(()=>{
        const map = new Map();
        // iterate over the filtered issues and add them to the correct group
        filteredIssues.forEach((issue)=>{
            const groupId = issue.fields[groupBy]?.value ?? (0, $ib4WI.NULL_GROUP_KEY);
            let groupIssues = map.get(groupId);
            if (!groupIssues) {
                groupIssues = [];
                map.set(groupId, groupIssues);
            }
            groupIssues.push(issue);
        });
        return map;
    }, [
        filteredIssues,
        groupBy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82f310c299227d34$var$RootContext.Provider, {
        value: issuesByGroup
    }, children);
};
const $82f310c299227d34$var$useIssuesByGroup = ()=>{
    const issuesByGroup = (0, $eUqFw.useContext)($82f310c299227d34$var$RootContext);
    if (!issuesByGroup) throw new Error('useIssuesByGroup must be used within a IssuesByGroupProvider');
    return issuesByGroup;
};
const $82f310c299227d34$export$2a761b53b8f42b98 = ()=>{
    // merge the groups from the group context with the groups from the issues by group
    // to make sure we do not hide any groups
    const groupBy = (0, $iXHUp.useGroupByField)();
    const groups = (0, $gKXju.useGroups)();
    const issuesByGroup = $82f310c299227d34$var$useIssuesByGroup();
    const sortGroups = (0, $2XClh.useSortGroups)();
    return (0, $eUqFw.useMemo)(()=>{
        // if grouped by status or assignee, skip this
        if (groupBy === (0, $jGcn0.GROUP_BY_STATUS) || groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE)) return groups;
        // if all the groups found in issuesByGroup are already in the groups array
        // we can just return the groups array
        const missingGroups = [
            ...issuesByGroup.keys()
        ].filter((groupId)=>!groups.some((group)=>group.id === groupId));
        if (missingGroups.length === 0) return groups;
        return sortGroups([
            ...missingGroups.map((groupId)=>{
                const firstIssue = issuesByGroup.get(groupId)?.[0];
                if (!firstIssue) throw new Error('No issues found for group');
                switch(groupBy){
                    case 0, $jGcn0.GROUP_BY_PRIORITY:
                        return {
                            id: groupId,
                            imageUrl: firstIssue.fields[groupBy]?.priority?.iconUrl ?? null,
                            name: firstIssue.fields[groupBy]?.priority.name ?? '',
                            type: groupBy
                        };
                    case 0, $jGcn0.GROUP_BY_CATEGORY:
                        return {
                            id: groupId,
                            color: firstIssue.fields[groupBy]?.category?.color ?? null,
                            name: firstIssue.fields[groupBy]?.category.name ?? '',
                            type: groupBy
                        };
                    default:
                        {
                            const exhaustiveCheck = groupBy;
                            throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
                        }
                }
            }),
            ...groups
        ]);
    }, [
        sortGroups,
        groupBy,
        groups,
        issuesByGroup
    ]);
};
const $82f310c299227d34$var$ChildContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $82f310c299227d34$export$dc797f621868b0d5 = ({ group: group, children: children })=>{
    const issuesByGroup = $82f310c299227d34$var$useIssuesByGroup();
    const issues = issuesByGroup.get(group.id) ?? $82f310c299227d34$var$EMPTY_ISSUES;
    const value = (0, $eUqFw.useMemo)(()=>({
            issues: issues,
            group: group
        }), [
        issues,
        group
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82f310c299227d34$var$ChildContext.Provider, {
        value: value
    }, children);
};
const $82f310c299227d34$export$7169da554b06d9e9 = ()=>{
    const issueGroup = (0, $eUqFw.useContext)($82f310c299227d34$var$ChildContext);
    if (!issueGroup) throw new Error('useIssueGroup must be used within a IssueGroupProvider');
    return issueGroup;
};

});

parcelRegister("sFqil", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef8d2be9c4d9c7b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lEfVV = parcelRequire("lEfVV");

var $6ki0E = parcelRequire("6ki0E");

var $iBFrS = parcelRequire("iBFrS");

var $lQboI = parcelRequire("lQboI");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $96etS = parcelRequire("96etS");

var $ef5z4 = parcelRequire("ef5z4");

var $c7wtc = parcelRequire("c7wtc");

var $zcJ0y = parcelRequire("zcJ0y");

var $eI5EY = parcelRequire("eI5EY");

var $hFK9U = parcelRequire("hFK9U");

var $hb3Di = parcelRequire("hb3Di");

var $a4Bvw = parcelRequire("a4Bvw");

var $ib4WI = parcelRequire("ib4WI");

var $jlfkT = parcelRequire("jlfkT");

var $2sU4b = parcelRequire("2sU4b");

var $lnmSR = parcelRequire("lnmSR");

var $iXHUp = parcelRequire("iXHUp");

var $c52lf = parcelRequire("c52lf");

var $cgK6s = parcelRequire("cgK6s");

var $eMXBu = parcelRequire("eMXBu");

var $1kaEx = parcelRequire("1kaEx");

var $jduWG = parcelRequire("jduWG");

var $gQQ5C = parcelRequire("gQQ5C");

var $9sGu9 = parcelRequire("9sGu9");
const $bef8d2be9c4d9c7b$var$isSafariBrowser = (0, $zcJ0y.isSafari)();
const $bef8d2be9c4d9c7b$var$renderCardDropIndicator = (cardsCount, cardDragMeta, virtualizer)=>{
    if (!cardDragMeta) return null;
    const virtualItem = virtualizer.getVirtualItems().find((item)=>item.index === cardDragMeta.cardIndex);
    if (!virtualItem) return null;
    const isAtVeryTop = cardDragMeta.cardIndex === 0 && cardDragMeta.closestEdge === 'top';
    const isAtVeryBottom = cardDragMeta.cardIndex === cardsCount - 1 && cardDragMeta.closestEdge === 'bottom';
    let start = cardDragMeta.closestEdge === 'top' ? virtualItem.start - 3 : virtualItem.end + 1;
    if (isAtVeryTop) // makes sure the drop indicator is not clipped
    start = 3;
    else if (isAtVeryBottom) // makes sure the drop indicator doesn't cause a scrollbar
    start -= 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$export$5a1a2d64cf6af79f, {
        start: start
    });
};
const $bef8d2be9c4d9c7b$var$BoardColumn = ({ columnsNumber: columnsNumber, columnIndex: columnIndex, isFullHeight: isFullHeight })=>{
    const project = (0, $kQAZu.useProject)();
    const { issues: issues, group: group } = (0, $c52lf.useIssueGroup)();
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const checkCanCreateIssueInStatus = (0, $ef5z4.useCanCreateIssueInStatus)();
    const [siblingCreateIssueId, setSiblingCreateIssueId] = (0, $eUqFw.useState)(null);
    const workflows = (0, $c7wtc.useWorkflows)();
    const [activeWorkflowId] = (0, $jlfkT.useActiveWorkflow)();
    const [cardContainer, setCardContainer] = (0, $eUqFw.useState)(null);
    const columnDropTargetRef = (0, $eUqFw.useRef)(null);
    const columnHandleRef = (0, $eUqFw.useRef)(null);
    const [cardDragMeta, setCardDragMeta] = (0, $eUqFw.useState)(null);
    const { isCollapsed: isCollapsed } = (0, $lnmSR.useExpandCollapse)(group.id);
    const groupBy = (0, $iXHUp.useGroupByField)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    const isEnrolledTailoredOnboardingExperiment = (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)();
    const { canDropInGroup: canDropInGroup, closestEdge: closestEdge, dragPreviewState: dragPreviewState, isCardOverColumn: isCardOverColumn, isDraggingColumn: isDraggingColumn } = (0, $2sU4b.useDraggableColumn)({
        columnDropTargetRef: columnDropTargetRef,
        columnHandleRef: columnHandleRef,
        group: group,
        index: columnIndex
    });
    const shouldShowInvalidDropTargetMessage = !isCollapsed && canDropInGroup === 'no';
    const virtualizer = (0, $6ki0E.useVirtualizer)({
        count: isCollapsed ? 0 : issues.length,
        getScrollElement: ()=>cardContainer,
        estimateSize: ()=>300,
        overscan: 2,
        gap: 4,
        getItemKey: (0, $eUqFw.useCallback)((index)=>issues[index].id, [
            issues
        ])
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!cardContainer) return;
        return (0, $iBFrS.autoScrollForElements)({
            canScroll: ({ source: source })=>source.data.type === (0, $ib4WI.CARD_DND_TYPE),
            element: cardContainer,
            getAllowedAxis: ()=>'vertical'
        });
    }, [
        cardContainer
    ]);
    const scrollToLastElement = (0, $eUqFw.useCallback)(()=>{
        const issueCount = issues.length;
        if (issueCount === 0) return;
        virtualizer.scrollToIndex(issueCount, {
            align: 'start'
        });
    }, [
        issues.length,
        virtualizer
    ]);
    const textHighlight = (0, $eUqFw.useMemo)(()=>simpleSearch != null ? [
            simpleSearch
        ] : undefined, [
        simpleSearch
    ]);
    const canCreateIssues = (0, $eUqFw.useMemo)(()=>{
        if (isCollapsed) return false;
        if (!project.permissions.createIssues) return false;
        if (isGroupedByStatus && !checkCanCreateIssueInStatus(group.id, workflows?.find((workflow)=>workflow.workflowId === activeWorkflowId))) return false;
        return true;
    }, [
        activeWorkflowId,
        checkCanCreateIssueInStatus,
        group.id,
        isCollapsed,
        isGroupedByStatus,
        project.permissions.createIssues,
        workflows
    ]);
    const isDropDisabled = canDropInGroup === 'no' || isCollapsed && canDropInGroup === 'choice-required';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bef8d2be9c4d9c7b$var$columnDropTargetStyles,
        ref: columnDropTargetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$Column, {
        isCardOverColumn: isCardOverColumn,
        isCollapsed: isCollapsed,
        isDragging: isDraggingColumn,
        isDropDisabled: isDropDisabled,
        isFullHeight: isFullHeight && !isCollapsed,
        isShowingInvalidDropTargetMessage: shouldShowInvalidDropTargetMessage,
        "data-testid": "work-management-board.ui.board.column"
    }, (0, $eI5EY.fg)('jwm_tailored_onboarding_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: isEnrolledTailoredOnboardingExperiment && isGroupedByStatus && (columnsNumber > 1 ? columnIndex === 1 : columnIndex === 0),
        Wrapper: (0, $a4Bvw.TailorBoardColumnsAsync)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        dragHandleRef: columnHandleRef,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: false,
        isDropDisabled: isDropDisabled,
        issueCount: issues.length
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        dragHandleRef: columnHandleRef,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: false,
        isDropDisabled: isDropDisabled,
        issueCount: issues.length
    }), !isCollapsed && issues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$ScrollContainer, {
        isDragging: isDraggingColumn,
        isFullHeight: isFullHeight,
        isScrollbarForced: (0, $zcJ0y.isFirefox)(),
        ref: setCardContainer,
        "data-testid": "work-management-board.ui.board.column.scroll-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$VirtualCardsContainer, {
        height: virtualizer.getTotalSize()
    }, virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$VirtualCardWrapper, {
            key: virtualItem.key,
            "data-index": virtualItem.index,
            start: virtualItem.start,
            ref: virtualizer.measureElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMXBu.default), {
            key: virtualItem.key,
            draggableIndex: virtualItem.index,
            canCreateIssues: canCreateIssues,
            group: group,
            issue: issues[virtualItem.index],
            highlight: textHighlight,
            isSiblingCreateFormOpen: siblingCreateIssueId === issues[virtualItem.index].id,
            toggleSiblingCreateForm: setSiblingCreateIssueId,
            onCardDragChange: setCardDragMeta
        }))), $bef8d2be9c4d9c7b$var$renderCardDropIndicator(issues.length, cardDragMeta, virtualizer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE)
    }))), shouldShowInvalidDropTargetMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQQ5C.default), null), !isCollapsed && [
        'choice-available',
        'choice-required'
    ].includes(canDropInGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9sGu9.default), {
        group: group
    }), canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jduWG.default), {
        group: group,
        scrollToLastElement: scrollToLastElement
    }), isWorkflowOperationInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bef8d2be9c4d9c7b$var$overlayStyles,
        testId: "work-management-board.ui.board.column.overlay"
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$var$ColumnDropIndicatorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQboI.DropIndicator), {
        edge: closestEdge,
        gap: `${(0, $ib4WI.GAP_BETWEEN_COLUMNS)}px`
    })))), dragPreviewState.type === 'preview' && isDraggingColumn ? /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef8d2be9c4d9c7b$export$18a854943bcb82fa, {
        isCollapsed: isCollapsed,
        isTilted: !$bef8d2be9c4d9c7b$var$isSafariBrowser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kaEx.default), {
        key: group.name,
        group: group,
        isCardOverColumn: isCardOverColumn,
        isDragPreview: true,
        isDropDisabled: false,
        issueCount: issues.length
    })), dragPreviewState.container) : null);
};
var $bef8d2be9c4d9c7b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bef8d2be9c4d9c7b$var$BoardColumn);
const $bef8d2be9c4d9c7b$var$columnDropTargetStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $bef8d2be9c4d9c7b$export$18a854943bcb82fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhri9 _2rkopd34 _1bsb1ogy",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.isCollapsed && "_1bsb1ylp",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$ColumnDropIndicatorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_z1i3tvsq _4t3i1kxc _kqswstnw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$Column = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShowingInvalidDropTargetMessage: isShowingInvalidDropTargetMessage, isCardOverColumn: isCardOverColumn, isCollapsed: isCollapsed, isDropDisabled: isDropDisabled, isDragging: isDragging, isFullHeight: isFullHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhri9 _v5641czr _2rkopd34 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _c71l1osq _1bsb1ogy _kqswh2mm _12ji3acm _1cwgidpf _1qu2nqa1 _12y31bk5",
            __cmplp.isShowingInvalidDropTargetMessage && "_1tkep3fh",
            __cmplp.isCardOverColumn && "_bfhki1yw _12ji1yqz",
            __cmplp.isCollapsed && "_1bsb1ylp _c71lnklw",
            __cmplp.isDropDisabled && "_bfhk1gly _12ji1bqt",
            __cmplp.isDragging && "_tzy42wxo",
            __cmplp.isFullHeight && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollbarForced: isScrollbarForced, isDragging: isDragging, isFullHeight: isFullHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tke1ylp _1reo15vq _ca0qt94y _n3tdt94y _u5f31b66 _19bvv47k _18u0mgjw _otyr1b66",
            __cmplp.isScrollbarForced ? "_18m915zi" : "_18m91wug",
            __cmplp.isDragging && "_19bv1b66 _18u0idpf _1reo15vq _18m915vq",
            __cmplp.isFullHeight && "_16jlidpf _i0dl184x",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$overlayStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    background: "var(--ds-background-disabled, rgba(235, 236, 240, 0.7))",
    zIndex: 'blanket'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bef8d2be9c4d9c7b$var$VirtualCardsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$var$VirtualCardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $9t7rW.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _t9ec1dpj",
            __cmplp.className
        ])
    });
});
const $bef8d2be9c4d9c7b$export$5a1a2d64cf6af79f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $9t7rW.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _kqswstnw _1pbycs5v _lcxvglyw _11q71yqz _4t3iyh40 _1ltv1y44 _1xi2idpf _t9ec1dpj _1kt9b3bt _1mp4ftgi _kfgtftgi _qnecyjp0 _1aukj39m _13y0usvi _1cs8stnw _14h8neh2 _rfx31ssb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lQboI", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $d90e1b559aa188c7$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $d90e1b559aa188c7$export$2e2bcd8739ae039);
/**
 * Spacing tokens don't make a lot of sense for this specific use case,
 * so disabling the linting rule.
 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $fvYC3 = parcelRequire("fvYC3");
const $d90e1b559aa188c7$var$terminalSize = 8;
const $d90e1b559aa188c7$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // Blocking pointer events to prevent the line from triggering drag events
    // Dragging over the line should count as dragging over the element behind it
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $fvYC3.line).backgroundColor,
    // Terminal
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        content: '""',
        width: $d90e1b559aa188c7$var$terminalSize,
        height: $d90e1b559aa188c7$var$terminalSize,
        boxSizing: 'border-box',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: `${(0, $fvYC3.line).thickness}px solid ${(0, $fvYC3.line).backgroundColor}`,
        borderRadius: '50%'
    }
});
/**
 * By default, the edge of the terminal will be aligned to the edge of the line.
 *
 * Offsetting the terminal by half its size aligns the middle of the terminal
 * with the edge of the line.
 *
 * We must offset by half the line width in the opposite direction so that the
 * middle of the terminal aligns with the middle of the line.
 *
 * That is,
 *
 * offset = - (terminalSize / 2) + (line.thickness / 2)
 *
 * which simplifies to the following value.
 */ const $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine = ((0, $fvYC3.line).thickness - $d90e1b559aa188c7$var$terminalSize) / 2;
/**
 * We inset the line by half the terminal size,
 * so that the terminal only half sticks out past the item.
 */ const $d90e1b559aa188c7$var$lineOffset = $d90e1b559aa188c7$var$terminalSize / 2;
const $d90e1b559aa188c7$var$orientationStyles = {
    horizontal: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: $d90e1b559aa188c7$var$lineOffset,
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Horizontal indicators have the terminal on the left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: -$d90e1b559aa188c7$var$terminalSize
        }
    }),
    vertical: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: $d90e1b559aa188c7$var$lineOffset,
        bottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // Vertical indicators have the terminal at the top
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: -$d90e1b559aa188c7$var$terminalSize
        }
    })
};
const $d90e1b559aa188c7$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $d90e1b559aa188c7$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        top: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        right: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            right: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        bottom: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            bottom: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        left: 'var(--local-line-offset)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            left: $d90e1b559aa188c7$var$offsetToAlignTerminalWithLine
        }
    })
};
function $d90e1b559aa188c7$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $fvYC3.line).thickness}px))`;
    const orientation = $d90e1b559aa188c7$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $d90e1b559aa188c7$var$lineStyles,
            $d90e1b559aa188c7$var$orientationStyles[orientation],
            $d90e1b559aa188c7$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$d90e1b559aa188c7$export$2e2bcd8739ae039 = $d90e1b559aa188c7$export$62ed72bc21f6b8a6;

});
parcelRegister("fvYC3", function(module, exports) {

$parcel$export(module.exports, "line", () => $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("ef5z4", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $24564dd80699b178$export$efe8838d1712139f);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $c7wtc = parcelRequire("c7wtc");
const $24564dd80699b178$export$efe8838d1712139f = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    const project = (0, $kQAZu.useProject)();
    return (0, $eUqFw.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("hb3Di", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $a40d8b671c4ac5be$export$56d544c4f479b7fb);

var $eUqFw = parcelRequire("eUqFw");
const $a40d8b671c4ac5be$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("a4Bvw", function(module, exports) {

$parcel$export(module.exports, "TailorBoardColumnsAsync", () => $967d7731ab3d49a9$export$e4d6b2cdb1678ee0);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $105cx = parcelRequire("105cx");

var $ii7Kh = parcelRequire("ii7Kh");
const $967d7731ab3d49a9$var$runtimeProps = {};
const $967d7731ab3d49a9$var$entryPointParams = {};
const $967d7731ab3d49a9$export$e4d6b2cdb1678ee0 = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ii7Kh.tailorBoardColumnsNudgeEntryPoint), $967d7731ab3d49a9$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $967d7731ab3d49a9$var$runtimeProps
    }));
};

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("ii7Kh", function(module, exports) {

$parcel$export(module.exports, "tailorBoardColumnsNudgeEntryPoint", () => $9c37f234eaa9d26c$export$13278346f7fe314b);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $9c37f234eaa9d26c$export$13278346f7fe314b = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("3Kffa")), {
        moduleId: "d4273c47"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3Kffa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('glcPs');
        const value = parcelRequire('KJQB0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("glcPs").then(()=>parcelRequire('KJQB0'));
}

});



parcelRegister("jlfkT", function(module, exports) {

$parcel$export(module.exports, "useActiveWorkflow", () => $b679edd3fbf5788d$export$51debb5f83907415);

var $eUqFw = parcelRequire("eUqFw");

var $lEWmB = parcelRequire("lEWmB");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $bFk6h = parcelRequire("bFk6h");
const $b679edd3fbf5788d$export$51debb5f83907415 = ()=>{
    const [activeWorkflowId, setActiveWorkflowId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.ACTIVE_WORKFLOW_PREFERENCE));
    const { reset: reset } = (0, $bFk6h.useBoardData)();
    const { setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const setActiveWorkflow = (0, $eUqFw.useCallback)((newWorkflowId)=>{
        setActiveWorkflowId(newWorkflowId);
        // Reset filters and board data when switching to a different workflow
        setFilter({});
        reset();
    }, [
        setActiveWorkflowId,
        setFilter,
        reset
    ]);
    return [
        activeWorkflowId,
        setActiveWorkflow
    ];
};

});

parcelRegister("2sU4b", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $07b00af135b13bd2$export$a2d73877a5476992);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("gvAZT");
var $aoSnO = parcelRequire("aoSnO");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $ib4WI = parcelRequire("ib4WI");

var $gWYTK = parcelRequire("gWYTK");

var $bJNjm = parcelRequire("bJNjm");

var $gMJE7 = parcelRequire("gMJE7");
const $07b00af135b13bd2$export$a2d73877a5476992 = ({ columnDropTargetRef: columnDropTargetRef, columnHandleRef: columnHandleRef, group: group, index: index })=>{
    const { cleanupDragPreview: cleanupDragPreview, dragPreviewState: dragPreviewState, isDragging: isDraggingColumn, renderDragPreview: renderDragPreview, resetDraggedColumn: resetDraggedColumn, startColumnDrag: startColumnDrag } = (0, $bJNjm.useColumnDragDrop)(group.id);
    const [closestEdge, setClosestEdge] = (0, $eUqFw.useState)(null);
    const [isCardOverColumn, setIsCardOverColumn] = (0, $eUqFw.useState)(false);
    const updateDropTarget = (0, $gWYTK.useUpdateDropTarget)();
    const resetDropTarget = (0, $gWYTK.useResetDropTarget)();
    const { canDropInGroup: canDropInGroup } = (0, $gWYTK.useCanDropCard)(group);
    const inferredDropTargetTransition = (0, $gWYTK.useInferredDropTargetTransition)(group);
    (0, $eUqFw.useEffect)(()=>{
        const handleDrag = ({ source: { data: data }, self: self })=>{
            const destinationData = self.data;
            if (!(0, $gMJE7.isColumn)(destinationData)) return;
            if ((0, $gMJE7.isColumn)(data) && data.columnId !== group.id) {
                const extractedClosestEdge = (0, $fSMvP.extractClosestEdge)(self.data);
                setClosestEdge((0, $gMJE7.isClosestEdgeAdjacentToSource)(data.index, destinationData.index, extractedClosestEdge) ? null : extractedClosestEdge);
                return;
            }
            if ((0, $gMJE7.isCard)(data) && ((0, $gMJE7.isColumn)(destinationData) || (0, $gMJE7.isCard)(destinationData))) {
                setIsCardOverColumn(true);
                if (inferredDropTargetTransition != null) updateDropTarget({
                    transition: inferredDropTargetTransition
                });
            }
        };
        return (0, $jFl9L.combine)(columnHandleRef.current != null ? (0, $eo9PV.draggable)({
            element: columnHandleRef.current,
            getInitialData: ()=>({
                    type: (0, $ib4WI.COLUMN_DND_TYPE),
                    columnId: group.id,
                    index: index
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset: (0, $aoSnO.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        renderDragPreview(container);
                        return ()=>{
                            cleanupDragPreview();
                        };
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: startColumnDrag,
            onDrop: resetDraggedColumn
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), columnDropTargetRef.current != null ? (0, $eo9PV.dropTargetForElements)({
            element: columnDropTargetRef.current,
            canDrop: ({ source: source })=>(0, $gMJE7.isColumn)(source.data) || (0, $gMJE7.isCard)(source.data) && canDropInGroup === 'yes',
            getIsSticky: ({ source: source })=>(0, $gMJE7.isColumn)(source.data),
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $ib4WI.COLUMN_DND_TYPE),
                    columnId: group.id,
                    index: index
                };
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ({ source: { data: data } })=>{
                if ((0, $gMJE7.isCard)(data)) {
                    resetDropTarget();
                    setIsCardOverColumn(false);
                    return;
                }
                setClosestEdge(null);
            },
            onDrop: ({ source: { data: data } })=>{
                if ((0, $gMJE7.isCard)(data)) {
                    setIsCardOverColumn(false);
                    return;
                }
                if ((0, $gMJE7.isColumn)(data)) setClosestEdge(null);
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    }, [
        canDropInGroup,
        columnDropTargetRef,
        columnHandleRef,
        group,
        index,
        inferredDropTargetTransition,
        resetDropTarget,
        updateDropTarget,
        startColumnDrag,
        renderDragPreview,
        cleanupDragPreview,
        resetDraggedColumn
    ]);
    return {
        canDropInGroup: canDropInGroup,
        closestEdge: closestEdge,
        dragPreviewState: dragPreviewState,
        isCardOverColumn: isCardOverColumn,
        isDraggingColumn: isDraggingColumn
    };
};

});
parcelRegister("gvAZT", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("aoSnO")).preserveOffsetOnSource);

var $aoSnO = parcelRequire("aoSnO");

});
parcelRegister("aoSnO", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $f1fd8ffcb433d2d1$export$8830e7ac6eee750e);
function $f1fd8ffcb433d2d1$export$8830e7ac6eee750e({ element: element, input: input }) {
    return ({ container: container })=>{
        const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("bweg7", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("jfbwa")).setCustomNativeDragPreview);

var $jfbwa = parcelRequire("jfbwa");

});
parcelRegister("jfbwa", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $ec46b73243fa3ce1$export$52d889c66db0f96e);

var $9wCS5 = parcelRequire("9wCS5");

var $Fx8Dp = parcelRequire("Fx8Dp");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $ec46b73243fa3ce1$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $ec46b73243fa3ce1$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $ec46b73243fa3ce1$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    const previewOffset = getOffset({
        container: container
    });
    /**
	 * **Problem**
	 * On `Safari@17.1` if a drag preview element has some opacity,
	 * Safari will include elements behind the drag preview element
	 * in the drag preview.
	 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
	 *
	 * **Fix**
	 * We push the drag preview so it is _almost_ completely offscreen so that
	 * there won't be any elements behind the drag preview element.
	 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
	 *
	 * Using `-0.0001` so that any potential "see through" on the drag preview element
	 * is effectively invisible 👻
	 *
	 * **Unsuccessful alternatives**
	 * Setting a background color (eg "white") on the `container`
	 * → Wrecks the opacity of the drag preview element
	 *
	 * Adding a parent element of the `container` with a background color (eg "white")
	 * → Wrecks the opacity of the drag preview element
	 */ if ((0, $Fx8Dp.isSafari)()) /**
		 *  For some frameworks (eg `react@18+` with `ReactDOM.createRoot().render()`) the rendering
		 *  inside the `container` does not occur until after a microtask.
		 *
		 *  Notes:
		 *    - This will run before the browser takes it's picture of the element
		 *    - This will run before the animation frame that removes `container`.
		 **/ queueMicrotask(()=>{
        const rect = container.getBoundingClientRect();
        // We cannot apply this fix if nothing has been rendered into the `container`
        if (rect.width === 0) return;
        container.style.left = `-${rect.width - 0.0001}px`;
    });
    nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $9wCS5.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;




parcelRegister("eMXBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0da123ed4df02977$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $jG2Eu = parcelRequire("jG2Eu");
parcelRequire("aZGbv");
var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $j8Htg = parcelRequire("j8Htg");
var $fyk0U = parcelRequire("fyk0U");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $d3C6e = parcelRequire("d3C6e");

var $hYeSy = parcelRequire("hYeSy");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $kgzZq = parcelRequire("kgzZq");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $gAOAU = parcelRequire("gAOAU");

var $gWYTK = parcelRequire("gWYTK");

var $74CPP = parcelRequire("74CPP");

var $2b5eO = parcelRequire("2b5eO");

var $bZapc = parcelRequire("bZapc");

var $f7G96 = parcelRequire("f7G96");

var $a8jG7 = parcelRequire("a8jG7");

var $cnz22 = parcelRequire("cnz22");

var $10ATT = parcelRequire("10ATT");

var $5Glvh = parcelRequire("5Glvh");

var $b5A1R = parcelRequire("b5A1R");

var $3wfag = parcelRequire("3wfag");
const $0da123ed4df02977$var$isSafariBrowser = (0, $zcJ0y.isSafari)();
const $0da123ed4df02977$var$useDropHighlight = (issueId)=>{
    const { highlightedIssueId: highlightedIssueId, resetHighlightedIssue: resetHighlightedIssue } = (0, $gWYTK.useHighlightedIssue)();
    const isDropHighlighted = highlightedIssueId === issueId;
    (0, $eUqFw.useEffect)(()=>{
        if (isDropHighlighted) {
            /*
       * We need to reset the highlighted issue after a short delay to ensure the card has enough time to move
       * to the correct position after a successful drop.
       */ const timeoutId = setTimeout(()=>{
                resetHighlightedIssue();
            }, 100);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    }, [
        isDropHighlighted,
        resetHighlightedIssue
    ]);
    return isDropHighlighted;
};
const $0da123ed4df02977$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $eUqFw.memo)(({ canCreateIssues: canCreateIssues, group: group, draggableIndex: draggableIndex, highlight: highlight, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm, selections: selections, onCardDragChange: onCardDragChange })=>{
    const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
    const { issueViewInteraction: issueViewInteraction } = (0, $2b5eO.useJWMBoardFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const shouldUseEmbedIssueClick = issueViewInteraction === 'openNewTab';
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const isHighlighted = getIsHighlighted(issue.id);
    const { footerContent: footerContent, footerPlaceholder: footerPlaceholder } = (0, $b5A1R.useCardFooter)(issue);
    const isDropHighlighted = $0da123ed4df02977$var$useDropHighlight(issue.id);
    const cloudId = (0, $dWLk9.useCloudId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const isCardCoversChangeboardingEnabled = (0, $eI5EY.fg)('jwm_card_covers_changeboarding');
    const { fetchUserTraits: fetchUserTraits } = (0, $fyk0U.useUserTraitsActions)();
    const ref = (0, $eUqFw.useRef)(null);
    const { draggedIssue: draggedIssue } = (0, $gWYTK.useCardDragDrop)();
    const { dragState: dragState } = (0, $74CPP.useDraggableCard)({
        ref: ref,
        issue: issue,
        cardIndex: draggableIndex,
        group: group,
        onCardDragChange: onCardDragChange
    });
    const isDragging = draggedIssue?.id === issue.id;
    const onEmbedIssueOpen = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: String(issue.id)
        });
    }, [
        createAnalyticsEvent,
        issue
    ]);
    const onIssueClick = (0, $f7G96.useViewIssue)();
    const clickHandler = (0, $eUqFw.useCallback)((e)=>{
        onIssueClick(issue, e.ctrlKey || e.metaKey);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardIssue');
    }, [
        onIssueClick,
        issue,
        createAnalyticsEvent
    ]);
    const issueKeyClickHandler = (0, $eUqFw.useCallback)(()=>{
        onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue
    ]);
    let prefetchIssue = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)());
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) prefetchIssue(issueKey);
        if (isCardCoversChangeboardingEnabled) fetchUserTraits(cloudId, accountId);
    }, [
        accountId,
        cloudId,
        fetchUserTraits,
        isCardCoversChangeboardingEnabled,
        issueKey,
        prefetchIssue
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' && event.target === event.currentTarget) shouldUseEmbedIssueClick ? onEmbedIssueOpen() : onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue,
        onEmbedIssueOpen,
        shouldUseEmbedIssueClick
    ]);
    const cardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardSummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgzZq.CardSummary), {
        text: issue.fields[0, $ib4WI.SUMMARY_ID].value,
        shouldMenuRender: true,
        highlight: highlight
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10ATT.CardContent), {
        highlight: highlight,
        issue: issue,
        onIssueKeyClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : issueKeyClickHandler
    }));
    const cardContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContentContainer, {
        onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler,
        onKeyDown: handleKeyDown,
        onMouseEnter: onMouseEnter,
        "data-testid": "work-management-board.ui.board.column.card.container"
    }, cardContent, footerPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wfag.default), {
        group: group,
        isTopMost: draggableIndex === 0,
        isSiblingCreateFormOpen: isSiblingCreateFormOpen,
        issue: issue,
        toggleSiblingCreateForm: toggleSiblingCreateForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContainer, {
        ref: ref,
        isDragging: isDragging,
        "data-testid": "work-management-board.ui.board.column.card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAOAU.CardCoverEditingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardContentContainer, {
        onKeyDown: handleKeyDown,
        onMouseEnter: onMouseEnter,
        onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$CardCoverWrapper, {
        coverMedia: issue.coverMedia
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$RelativeMainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$var$HighlightContainer, {
        isDraggingAllowed: !(0, $d3C6e.isOptimisticIssue)(issue.id),
        isHighlighted: isHighlighted || isDropHighlighted
    }, selections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnz22.CardBadge), {
        selections: selections,
        position: draggableIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3)
    }, cardContainer) : cardContainer), footerContent, !(0, $d3C6e.isOptimisticIssue)(issue.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8jG7.default), {
        issue: issue
    })))), dragState.type === 'preview' ? /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$export$6bb2a69551ff8f5b, {
        isTilted: !$0da123ed4df02977$var$isSafariBrowser
    }, cardContent), dragState.container) : null);
});
const $0da123ed4df02977$var$CardCoverWrapper = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const showCardCovers = selectedFields[0, $jGcn0.CARD_COVERS_TYPE];
    return showCardCovers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Glvh.CardCover), {
        coverMedia: coverMedia
    });
});
const $0da123ed4df02977$var$CardWithSelection = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const nodeId = (0, $i0nxo.getPresenceNodeId)({
        projectId: projectId,
        viewId: 'board',
        nodeId: `${props.issue.id}`
    });
    const [{ nodeSelection: nodeSelection }] = (0, $4TJj0.useCollabStore)();
    const selections = nodeSelection[nodeId];
    // card could have multiple selections from different users
    const cardSelections = Array.isArray(selections) && selections.length ? selections : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0da123ed4df02977$export$60332b2344f7fe41, {
        ...props,
        selections: cardSelections
    });
});
var $0da123ed4df02977$export$2e2bcd8739ae039 = $0da123ed4df02977$var$CardWithSelection;
const $0da123ed4df02977$var$MAX_CARD_WIDTH = 270;
const $0da123ed4df02977$var$ACTION_MENU_BUTTON_SIZE = 32;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0da123ed4df02977$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1ogy _uiztglyw _vchhusvi _kqswh2mm _2rko1sit _16qs1os1 _bfhkhp5a _syaz1fxt _v5641hrg _irr3xwku _dwwu1txw _1mkw1txw",
            __cmplp.isDragging ? "_tzy42wxo" : "_tzy4kb7n",
            __cmplp.isDragging ? "_d0al5szm" : "_d0altlke",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$RelativeMainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$export$6bb2a69551ff8f5b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ogy _vchhusvi _kqswh2mm _2rko1sit _bfhkhp5a",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$CardContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$CardSummaryWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4utpp _1e0c1txw _1tkezwfg",
            __cmplp.className
        ])
    });
});
const $0da123ed4df02977$var$HighlightContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingAllowed: isDraggingAllowed, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _v56417iv",
            __cmplp.isDraggingAllowed ? "_80om1kw7" : "_80om13gf",
            __cmplp.isHighlighted && "_bfhk1cey _v564glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aZGbv", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $8521b6b2ec32c74c$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $8521b6b2ec32c74c$export$91bc13dfc76fa8fa);
$parcel$export(module.exports, "BADGE_INNER_POSITION", () => $18eb89570dd03c8c$export$86bcdda8e7a22b9d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $8521b6b2ec32c74c$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $8521b6b2ec32c74c$var$BADGE_TEXT_COLOR = 'white';
const $8521b6b2ec32c74c$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $9t7rW.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _16qs1zte _2rko1sit",
            __cmplp.className
        ])
    });
});
const $8521b6b2ec32c74c$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _1yt4otz2 _11q71cj8 _vchhusvi _11c8qk37 _syazu67f",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});
const $18eb89570dd03c8c$export$86bcdda8e7a22b9d = 'inner';
const $18eb89570dd03c8c$export$a3a66eb204e551b3 = 'outer';


parcelRegister("j8Htg", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $3314031ff4af418d$export$a29603f2eb9b6da6);
const $3314031ff4af418d$export$a29603f2eb9b6da6 = (param)=>{
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("kgzZq", function(module, exports) {

$parcel$export(module.exports, "CardSummary", () => $56a5f1bee0255f5b$export$f2e6e773bb9ca12a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $ggLw8 = parcelRequire("ggLw8");

var $f5DAf = parcelRequire("f5DAf");
const $56a5f1bee0255f5b$export$f2e6e773bb9ca12a = ({ text: text, highlight: highlight, shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate = false })=>{
    const HighlightedText = highlight && (0, $f5DAf.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5DAf.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const summary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($56a5f1bee0255f5b$var$Summary, {
        shouldMenuRender: shouldMenuRender || false,
        shouldTruncate: shouldTruncate,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ggLw8.summary
    }, HighlightedText);
    if (!shouldTruncate) return summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: text,
        position: "bottom"
    }, summary);
};
$56a5f1bee0255f5b$export$f2e6e773bb9ca12a.defaultProps = {
    shouldMenuRender: false,
    highlight: []
};
var $56a5f1bee0255f5b$export$2e2bcd8739ae039 = $56a5f1bee0255f5b$export$f2e6e773bb9ca12a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56a5f1bee0255f5b$var$Summary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.shouldMenuRender ? "_u5f3xy5q" : "_u5f3ze3t",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ggLw8", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $bd82ffe601216fab$export$4ea799498ef4a755, (v) => $bd82ffe601216fab$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "card-content-container", () => $bd82ffe601216fab$export$b097e1489ce64e3a, (v) => $bd82ffe601216fab$export$b097e1489ce64e3a = v);
$parcel$export(module.exports, "cardColorInner", () => $bd82ffe601216fab$export$e2907b219480f02f, (v) => $bd82ffe601216fab$export$e2907b219480f02f = v);
$parcel$export(module.exports, "cmpAvatar", () => $bd82ffe601216fab$export$114c94adbfe142fc, (v) => $bd82ffe601216fab$export$114c94adbfe142fc = v);
$parcel$export(module.exports, "content", () => $bd82ffe601216fab$export$a7db06668cad9adb, (v) => $bd82ffe601216fab$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "customCardFieldList", () => $bd82ffe601216fab$export$8b6db2f2076ae2a6, (v) => $bd82ffe601216fab$export$8b6db2f2076ae2a6 = v);
$parcel$export(module.exports, "footer", () => $bd82ffe601216fab$export$adb608be33961c98, (v) => $bd82ffe601216fab$export$adb608be33961c98 = v);
$parcel$export(module.exports, "footerChildSection", () => $bd82ffe601216fab$export$1907b6af328e1b13, (v) => $bd82ffe601216fab$export$1907b6af328e1b13 = v);
$parcel$export(module.exports, "iconsPlaceHolder", () => $bd82ffe601216fab$export$3f4216a049dd4cce, (v) => $bd82ffe601216fab$export$3f4216a049dd4cce = v);
$parcel$export(module.exports, "primary", () => $bd82ffe601216fab$export$9ad721cf3b3debe0, (v) => $bd82ffe601216fab$export$9ad721cf3b3debe0 = v);
$parcel$export(module.exports, "secondary", () => $bd82ffe601216fab$export$745c6f71a1e0e6f7, (v) => $bd82ffe601216fab$export$745c6f71a1e0e6f7 = v);
$parcel$export(module.exports, "summary", () => $bd82ffe601216fab$export$9a2dbef7a17e2e58, (v) => $bd82ffe601216fab$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "tertiary", () => $bd82ffe601216fab$export$5668677bb0c0ed27, (v) => $bd82ffe601216fab$export$5668677bb0c0ed27 = v);
var $bd82ffe601216fab$export$4ea799498ef4a755;
var $bd82ffe601216fab$export$b097e1489ce64e3a;
var $bd82ffe601216fab$export$e2907b219480f02f;
var $bd82ffe601216fab$export$114c94adbfe142fc;
var $bd82ffe601216fab$export$a7db06668cad9adb;
var $bd82ffe601216fab$export$8b6db2f2076ae2a6;
var $bd82ffe601216fab$export$adb608be33961c98;
var $bd82ffe601216fab$export$1907b6af328e1b13;
var $bd82ffe601216fab$export$3f4216a049dd4cce;
var $bd82ffe601216fab$export$9ad721cf3b3debe0;
var $bd82ffe601216fab$export$745c6f71a1e0e6f7;
var $bd82ffe601216fab$export$9a2dbef7a17e2e58;
var $bd82ffe601216fab$export$5668677bb0c0ed27;
$bd82ffe601216fab$export$4ea799498ef4a755 = `yse7za_avatarContainer`;
$bd82ffe601216fab$export$b097e1489ce64e3a = `yse7za_card-content-container`;
$bd82ffe601216fab$export$e2907b219480f02f = `yse7za_cardColorInner`;
$bd82ffe601216fab$export$114c94adbfe142fc = `yse7za_cmpAvatar`;
$bd82ffe601216fab$export$a7db06668cad9adb = `yse7za_content`;
$bd82ffe601216fab$export$8b6db2f2076ae2a6 = `yse7za_customCardFieldList`;
$bd82ffe601216fab$export$adb608be33961c98 = `yse7za_footer`;
$bd82ffe601216fab$export$1907b6af328e1b13 = `yse7za_footerChildSection`;
$bd82ffe601216fab$export$3f4216a049dd4cce = `yse7za_iconsPlaceHolder`;
$bd82ffe601216fab$export$9ad721cf3b3debe0 = `yse7za_primary`;
$bd82ffe601216fab$export$745c6f71a1e0e6f7 = `yse7za_secondary`;
$bd82ffe601216fab$export$9a2dbef7a17e2e58 = `yse7za_summary`;
$bd82ffe601216fab$export$5668677bb0c0ed27 = `yse7za_tertiary`;

});

parcelRegister("f5DAf", function(module, exports) {

$parcel$export(module.exports, "shouldHighlightText", () => $b0abd9ab06e06245$export$dceb4ab0bd0273b3);
$parcel$export(module.exports, "HighlightText", () => $b0abd9ab06e06245$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");

var $7PAQj = parcelRequire("7PAQj");
var $gttjd = parcelRequire("gttjd");
const $b0abd9ab06e06245$export$dceb4ab0bd0273b3 = (text = '', keywords = [])=>text && text.length > 0 && keywords.filter((keyword)=>keyword !== '').length > 0 && keywords.some((keyword)=>(0, $gttjd.removeAccents)(text).toLowerCase().includes(keyword.toLowerCase()) || text.toLowerCase().includes(keyword.toLowerCase()));
const $b0abd9ab06e06245$export$bb02e7bc6e1a7119 = ({ content: content, phrases: phrases })=>{
    if (!phrases || !phrases.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PAQj.default), {
        highlight: phrases,
        text: content
    });
};
var $b0abd9ab06e06245$export$2e2bcd8739ae039 = $b0abd9ab06e06245$export$bb02e7bc6e1a7119;

});
parcelRegister("7PAQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea2f8628dbce2aa$export$2e2bcd8739ae039);

var $gttjd = parcelRequire("gttjd");

var $e63D2 = parcelRequire("e63D2");
var $dea2f8628dbce2aa$export$2e2bcd8739ae039 = (0, $e63D2.default);

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});






parcelRegister("gAOAU", function(module, exports) {

$parcel$export(module.exports, "CardCoverEditingContainer", () => $e93dee3f4ea4ce44$export$13da74796c6022b7);
$parcel$export(module.exports, "useIsCardCoverEditingOpen", () => $e93dee3f4ea4ce44$export$86192d02f3e50475);
$parcel$export(module.exports, "useCardCoverEditingActions", () => $e93dee3f4ea4ce44$export$a20e8ef4d07b82c8);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $e93dee3f4ea4ce44$export$13da74796c6022b7 = (0, $heB5U.createContainer)();
const $e93dee3f4ea4ce44$var$actions = {
    setOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        }
};
const $e93dee3f4ea4ce44$var$store = (0, $a61MH.createStore)({
    name: 'BusinessBoardCardCoverEditingStore',
    initialState: {
        isOpen: false
    },
    actions: $e93dee3f4ea4ce44$var$actions,
    containedBy: $e93dee3f4ea4ce44$export$13da74796c6022b7
});
const $e93dee3f4ea4ce44$export$86192d02f3e50475 = (0, $ggKAj.createStateHook)($e93dee3f4ea4ce44$var$store, {
    selector: (state)=>state.isOpen
});
const $e93dee3f4ea4ce44$export$a20e8ef4d07b82c8 = (0, $ggKAj.createActionsHook)($e93dee3f4ea4ce44$var$store);

});

parcelRegister("74CPP", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $f9ac24ffce4192bf$export$ee9f6369c1b523a9);

var $eUqFw = parcelRequire("eUqFw");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("gvAZT");
var $aoSnO = parcelRequire("aoSnO");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $kQAZu = parcelRequire("kQAZu");

var $d3C6e = parcelRequire("d3C6e");

var $ib4WI = parcelRequire("ib4WI");

var $gWYTK = parcelRequire("gWYTK");

var $gMJE7 = parcelRequire("gMJE7");
const $f9ac24ffce4192bf$export$ee9f6369c1b523a9 = ({ ref: ref, issue: issue, cardIndex: cardIndex, group: group, onCardDragChange: onCardDragChange })=>{
    const project = (0, $kQAZu.useProject)();
    const startCardDrag = (0, $gWYTK.useStartCardDrag)();
    const { canDropAgainstCard: canDropAgainstCard } = (0, $gWYTK.useCanDropCard)(group);
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!ref.current) return;
        const handleDrag = ({ source: source, self: self })=>{
            const sourceData = source.data;
            if (!(0, $gMJE7.isCard)(sourceData)) return;
            if (sourceData.issueId === issue.id) return;
            const destinationData = self.data;
            const closestEdge = (0, $fSMvP.extractClosestEdge)(destinationData);
            const isClosestEdgeAdjacentToSource = (0, $gMJE7.isCard)(destinationData) && sourceData.columnId === destinationData.columnId && closestEdge != null && (0, $gMJE7.isClosestEdgeAdjacentToSource)(sourceData.cardIndex, destinationData.cardIndex, closestEdge);
            onCardDragChange(closestEdge && !isClosestEdgeAdjacentToSource ? {
                cardIndex: cardIndex,
                closestEdge: closestEdge
            } : null);
        };
        return (0, $jFl9L.combine)((0, $eo9PV.draggable)({
            element: ref.current,
            canDrag: ()=>project.permissions.editIssues && !(0, $d3C6e.isOptimisticIssue)(issue.id),
            getInitialData: ()=>({
                    type: (0, $ib4WI.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: group.id
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset: (0, $aoSnO.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                startCardDrag(issue, group);
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            }
        }), (0, $eo9PV.dropTargetForElements)({
            element: ref.current,
            canDrop: ({ source: source })=>(0, $gMJE7.isCard)(source.data) && canDropAgainstCard === 'yes',
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $ib4WI.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: group.id
                };
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ()=>{
                onCardDragChange(null);
            },
            onDrop: ()=>{
                onCardDragChange(null);
            }
        }));
    }, [
        canDropAgainstCard,
        cardIndex,
        group,
        issue,
        onCardDragChange,
        project.permissions.editIssues,
        ref,
        startCardDrag
    ]);
    return {
        dragState: dragState
    };
};

});

parcelRegister("f7G96", function(module, exports) {

$parcel$export(module.exports, "useViewIssue", () => $0b9fbdb737aff2d8$export$f26a5ae87a55d4f8);

var $eUqFw = parcelRequire("eUqFw");

var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $kJlBc = parcelRequire("kJlBc");

var $fa2D3 = parcelRequire("fa2D3");

var $ib4WI = parcelRequire("ib4WI");
const $0b9fbdb737aff2d8$export$f26a5ae87a55d4f8 = ()=>{
    const ufoPressTracing = (0, $fa2D3.default)('jwm.board.issue-view-opened');
    const [, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [, { sendNodeSelected: sendNodeSelected }] = (0, $4TJj0.useCollabStore)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    return (0, $eUqFw.useCallback)((issue, withCmd)=>{
        if (issue.id && issue.fields[0, $ib4WI.ISSUE_KEY_ID].value) {
            const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
            if (withCmd) window.open(`/browse/${issueKey}`, '_blank');
            else {
                ufoPressTracing();
                setSelectedIssueKey(issueKey);
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: String(issue.id)
                });
                sendNodeSelected({
                    nodeId: nodeId
                });
            }
        }
    }, [
        projectId,
        sendNodeSelected,
        setSelectedIssueKey,
        ufoPressTracing
    ]);
};

});

parcelRegister("a8jG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d27abeee15ffba0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $dxopF = parcelRequire("dxopF");

var $3MV1G = parcelRequire("3MV1G");

var $fyk0U = parcelRequire("fyk0U");

var $fyk0U = parcelRequire("fyk0U");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ixSO7 = parcelRequire("ixSO7");

var $9TPjv = parcelRequire("9TPjv");

var $hmsdo = parcelRequire("hmsdo");

var $6MGj1 = parcelRequire("6MGj1");
const $6d27abeee15ffba0$export$ee81106b9e254a08 = '--card-actions-display';
const $6d27abeee15ffba0$var$returnNull = ()=>null;
const $6d27abeee15ffba0$var$CardActions = ({ issue: issue })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const openMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(true), []);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((open)=>!open), []);
    const [isCardCoversNew] = (0, $ixSO7.useIsCardCoversNew)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const openDeleteModal = (0, $eUqFw.useCallback)(()=>setIsDeleteModalOpen(true), []);
    const closeDeleteModal = (0, $eUqFw.useCallback)(()=>setIsDeleteModalOpen(false), []);
    const isCardCoversEditorEnabled = (0, $eI5EY.fg)('card_covers_editor');
    const isCardCoversChangeboardingEnabled = (0, $eI5EY.fg)('jwm_card_covers_changeboarding');
    const [userTraits, { setUserTraits: setUserTraits }] = isCardCoversEditorEnabled && !isCardCoversChangeboardingEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fyk0U.useUserTraits)() : [
        null,
        {
            setUserTraits: ()=>undefined
        }
    ];
    const fetchUserTraits = isCardCoversEditorEnabled && !isCardCoversChangeboardingEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fyk0U.useFetchUserTraitsOld)() : $6d27abeee15ffba0$var$returnNull;
    const setUserTraitsIfNotAvailable = (0, $eUqFw.useCallback)(async ()=>{
        if (!isCardCoversEditorEnabled || isCardCoversChangeboardingEnabled) return false;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        userTraits,
        fetchUserTraits,
        setUserTraits,
        isCardCoversEditorEnabled,
        isCardCoversChangeboardingEnabled
    ]);
    const popupContent = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TPjv.default), {
            issue: issue,
            onContentResize: update,
            onClosePopup: closeMenu,
            onMenuRendered: update,
            onOpenPopup: openMenu,
            onDeleteIssue: openDeleteModal
        }), [
        issue,
        closeMenu,
        openMenu,
        openDeleteModal
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d27abeee15ffba0$var$TriggerButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d27abeee15ffba0$var$StyledButton, {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: formatMessage((0, $6MGj1.default).cardActions)
            }),
            onClick: toggleMenu,
            testId: "work-management-board.ui.board.column.card.card-actions.trigger",
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable,
            isCardCoversNew: isCardCoversNew
        })), [
        formatMessage,
        toggleMenu,
        setUserTraitsIfNotAvailable,
        isCardCoversNew
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        content: popupContent,
        placement: "right-start",
        trigger: trigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hmsdo.default), {
        issue: issue,
        onClose: closeDeleteModal
    })));
};
var $6d27abeee15ffba0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($6d27abeee15ffba0$var$CardActions);
const $6d27abeee15ffba0$var$TriggerButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iu2gc _1xi2u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d27abeee15ffba0$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ch0al _1d5x1txw _1q6e1txw",
            __cmplp.isCardCoversNew ? "_16qs1wx8" : "_16qsglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ixSO7", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $d329192da593e8cf$export$8fa8485fafd17cef);
$parcel$export(module.exports, "useMoveIssue", () => $d329192da593e8cf$export$47e46c713d0f867d);
$parcel$export(module.exports, "useIsCardCoversNew", () => $d329192da593e8cf$export$14c8617559a4dc59);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $fyk0U = parcelRequire("fyk0U");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $c52lf = parcelRequire("c52lf");

var $6kWQc = parcelRequire("6kWQc");

var $akT70 = parcelRequire("akT70");
const $d329192da593e8cf$export$8fa8485fafd17cef = (issue)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    return (0, $eUqFw.useCallback)(async ()=>{
        const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
        try {
            await navigator.clipboard.writeText(`${window.location.origin}/browse/${issueKey}`);
            showFlag({
                type: 'success',
                title: (0, $akT70.default).copyLinkSuccessTitle,
                description: (0, $akT70.default).copyLinkSuccessDescription
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubjectId: issue.id
            }), 'issue linkCopied', {
                throughActionCard: true,
                issueId: issue.id
            });
        } catch (e) {
        // do nothing
        }
    }, [
        createAnalyticsEvent,
        issue,
        showFlag
    ]);
};
const $d329192da593e8cf$export$47e46c713d0f867d = (issue)=>{
    const { issues: issues } = (0, $c52lf.useIssueGroup)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const updateIssue = (0, $6kWQc.useUpdateIssue)();
    const firstIssueId = issues[0]?.id;
    const canMoveToTop = firstIssueId !== issue.id;
    const lastIssueId = issues[issues.length - 1]?.id;
    const canMoveToBottom = lastIssueId !== issue.id;
    const moveToTop = (0, $eUqFw.useCallback)(async ()=>{
        try {
            await updateIssue({
                issue: issue,
                rank: {
                    relativeIssueId: firstIssueId,
                    position: 'before'
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubjectId: issue.id
            }), 'issue movedToTop', {
                throughActionCard: true,
                issueId: issue.id
            });
        } catch (error) {
        // errors handled in updateIssue controller
        }
    }, [
        createAnalyticsEvent,
        firstIssueId,
        issue,
        updateIssue
    ]);
    const moveToBottom = (0, $eUqFw.useCallback)(async ()=>{
        try {
            await updateIssue({
                issue: issue,
                rank: {
                    relativeIssueId: lastIssueId,
                    position: 'after'
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubjectId: issue.id
            }), 'issue movedToBottom', {
                throughActionCard: true,
                issueId: issue.id
            });
        } catch (error) {
        // errors handled in updateIssue controller
        }
    }, [
        createAnalyticsEvent,
        issue,
        lastIssueId,
        updateIssue
    ]);
    return {
        canMoveToTop: canMoveToTop,
        canMoveToBottom: canMoveToBottom,
        moveToTop: moveToTop,
        moveToBottom: moveToBottom
    };
};
const $d329192da593e8cf$var$isCardCoversNew = (0, $bj4JM.createSelector)((state)=>state.attributes, (attributes)=>{
    if (!attributes) return false;
    const cardCoversReleaseDate = new Date('2024-06-17');
    const hasOpenedCardCoversEditor = attributes?.find((trait)=>trait?.name === 'jira-core_ui_cardcovereditor_clicked_first_time');
    const accountCreationDate = attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
    let accountCreatedAfterCardCoversRelease = true;
    if (accountCreationDate && typeof accountCreationDate === 'string') accountCreatedAfterCardCoversRelease = new Date(accountCreationDate) > cardCoversReleaseDate;
    return !hasOpenedCardCoversEditor && !accountCreatedAfterCardCoversRelease;
});
const $d329192da593e8cf$export$14c8617559a4dc59 = (0, $ggKAj.createHook)((0, $fyk0U.UserTraitsStore), {
    selector: $d329192da593e8cf$var$isCardCoversNew
});

});
parcelRegister("akT70", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae210323ad2e755$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ae210323ad2e755$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copyLinkSuccessTitle: {
        "id": "work-management-board.controllers.card-actions.copy-link-success-title",
        "defaultMessage": "Link copied"
    },
    copyLinkSuccessDescription: {
        "id": "work-management-board.controllers.card-actions.copy-link-success-description",
        "defaultMessage": "Item successfully copied to your clipboard."
    }
});

});


parcelRegister("9TPjv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ce8ccfd7481579$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d4ce8ccfd7481579$var$LazyCardActionsMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("ezsGH")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board/column/card/card-actions/card-actions-menu/main.tsx"
});
const $d4ce8ccfd7481579$var$AsyncCardActionsMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "card-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4ce8ccfd7481579$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "medium"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4ce8ccfd7481579$var$LazyCardActionsMenu, props));
var $d4ce8ccfd7481579$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d4ce8ccfd7481579$var$AsyncCardActionsMenu;
const $d4ce8ccfd7481579$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1wdt _1yt41nde",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezsGH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('85Pd3')
        ]);
        const value = parcelRequire('8q5sQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("85Pd3")
    ]).then(()=>parcelRequire('8q5sQ'));
}

});


parcelRegister("hmsdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6247269e8e15ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $1Yimi = parcelRequire("1Yimi");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $fq8Vz = parcelRequire("fq8Vz");

var $cka0x = parcelRequire("cka0x");
const $8b6247269e8e15ce$var$IssueDeleteModal = ({ issue: issue, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const itemKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
    const deleteIssue = (0, $fq8Vz.useDeleteIssue)();
    const [isDeleting, setIsDeleting] = (0, $eUqFw.useState)(false);
    const handleDelete = (0, $eUqFw.useCallback)(async ()=>{
        setIsDeleting(true);
        try {
            await deleteIssue(issue);
        } catch (error) {
            setIsDeleting(false);
        } finally{
            onClose();
        }
    }, [
        deleteIssue,
        issue,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, formatMessage((0, $cka0x.default).title, {
        itemKey: itemKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $cka0x.default).warning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $cka0x.default).recommendation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose,
        isDisabled: isDeleting
    }, formatMessage((0, $cka0x.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "danger",
        onClick: handleDelete,
        isLoading: isDeleting
    }, formatMessage((0, $cka0x.default).delete)))));
};
var $8b6247269e8e15ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8b6247269e8e15ce$var$IssueDeleteModal);

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("fq8Vz", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $8b6a737f8c9520f3$export$43383fdc9fe04fe6);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $1s3ZV = parcelRequire("1s3ZV");

var $dtXTv = parcelRequire("dtXTv");

var $cmw5U = parcelRequire("cmw5U");
const $8b6a737f8c9520f3$export$43383fdc9fe04fe6 = ()=>{
    const deleteIssue = (0, $1s3ZV.useDeleteIssue)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    const abortExperience = (0, $4G5xU.useExperienceAbort)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    return (0, $eUqFw.useCallback)(async (issue)=>{
        const issueId = issue.id;
        const issueKey = issue.fields[0, $ib4WI.ISSUE_KEY_ID].value;
        startExperience();
        let isIssueDeleted = false;
        try {
            await deleteIssue({
                issueKey: issueKey
            });
            isIssueDeleted = true;
            markExperienceSuccess();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubjectId: issueId
            }), 'issue deleted', {
                throughActionCard: true,
                issueId: issueId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // issue not found is not handled as an error as the issue is already gone
            if (error instanceof (0, $1s3ZV.IssueNotFound)) {
                isIssueDeleted = true;
                markExperienceSuccess();
            } else if (error instanceof (0, $1s3ZV.PermissionDenied)) {
                showFlag({
                    type: 'error',
                    title: (0, $cmw5U.default).deletePermissionDefinedErrorTitle,
                    description: (0, $cmw5U.default).deletePermissionDefinedErrorDescription
                });
                abortExperience('handled validation error');
                throw error;
            } else {
                showFlag({
                    type: 'error',
                    title: (0, $cmw5U.default).deleteErrorTitle,
                    description: (0, $cmw5U.default).deleteErrorDescription
                });
                markExperienceFailed('delete issue failed', error);
                throw error;
            }
        }
        if (isIssueDeleted) {
            removeIssues([
                issueId
            ]);
            showFlag({
                type: 'success',
                title: (0, $cmw5U.default).deleteSuccessTitle,
                description: (0, $cmw5U.default).deleteSuccessDescription
            });
        }
    }, [
        abortExperience,
        createAnalyticsEvent,
        deleteIssue,
        markExperienceFailed,
        markExperienceSuccess,
        removeIssues,
        showFlag,
        startExperience
    ]);
};

});
parcelRegister("1s3ZV", function(module, exports) {

$parcel$export(module.exports, "IssueNotFound", () => $115fd91021e70cac$export$94ec83117e97f12a);
$parcel$export(module.exports, "PermissionDenied", () => $115fd91021e70cac$export$1132e67c7dd43dcb);
$parcel$export(module.exports, "useDeleteIssue", () => $115fd91021e70cac$export$43383fdc9fe04fe6);
/* eslint-disable max-classes-per-file */ 
var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $115fd91021e70cac$var$getDeletionUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?deleteSubtasks=true`;
class $115fd91021e70cac$export$94ec83117e97f12a extends Error {
}
class $115fd91021e70cac$export$1132e67c7dd43dcb extends Error {
}
const $115fd91021e70cac$export$43383fdc9fe04fe6 = ()=>(0, $eUqFw.useCallback)(({ issueKey: issueKey })=>(0, $lRmyA.performDeleteRequest)($115fd91021e70cac$var$getDeletionUrl(issueKey), {
            method: 'DELETE'
        }).catch((error)=>{
            if (error.statusCode === 404) throw new $115fd91021e70cac$export$94ec83117e97f12a();
            if (error.statusCode === 403) throw new $115fd91021e70cac$export$1132e67c7dd43dcb();
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmBoardIssueDelete',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to delete issue in JWM board'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }), []);

});

parcelRegister("cmw5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $953f07650825ed3e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $953f07650825ed3e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteSuccessTitle: {
        "id": "work-management-board.controllers.delete-issue.delete-success-title",
        "defaultMessage": "Deleted item"
    },
    deleteSuccessDescription: {
        "id": "work-management-board.controllers.delete-issue.delete-success-description",
        "defaultMessage": "Item deleted successfully"
    },
    deleteErrorTitle: {
        "id": "work-management-board.controllers.delete-issue.delete-error-title",
        "defaultMessage": "Failed to delete item"
    },
    deleteErrorDescription: {
        "id": "work-management-board.controllers.delete-issue.delete-error-description",
        "defaultMessage": "Something went wrong while deleting the item. Please try again or contact your administrator if the problem persists."
    },
    deletePermissionDefinedErrorTitle: {
        "id": "work-management-board.controllers.delete-issue.delete-permission-defined-error-title",
        "defaultMessage": "Permission denied"
    },
    deletePermissionDefinedErrorDescription: {
        "id": "work-management-board.controllers.delete-issue.delete-permission-defined-error-description",
        "defaultMessage": "You do not have permission to delete this item."
    }
});

});


parcelRegister("cka0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $10c2e8df33a7b62f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $10c2e8df33a7b62f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "work-management-board.board.column.card.card-actions.delete-issue-modal.title",
        "defaultMessage": "Delete {itemKey}?"
    },
    warning: {
        "id": "work-management-board.board.column.card.card-actions.delete-issue-modal.warning",
        "defaultMessage": "You're about to permanently delete this item and its comments, attachments, and all of its data."
    },
    recommendation: {
        "id": "work-management-board.board.column.card.card-actions.delete-issue-modal.recommendation",
        "defaultMessage": "If you don't want to delete it, you can resolve or close it instead."
    },
    delete: {
        "id": "work-management-board.board.column.card.card-actions.delete-issue-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "work-management-board.board.column.card.card-actions.delete-issue-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("6MGj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ab5db2d1a11b80$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $35ab5db2d1a11b80$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cardActions: {
        "id": "work-management-board.board.column.card.card-actions.card-actions",
        "defaultMessage": "Card actions"
    }
});

});


parcelRegister("cnz22", function(module, exports) {

$parcel$export(module.exports, "CardBadge", () => $9e1c2949054e4e70$export$bc1a48e1b7ed7af);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $aZGbv = parcelRequire("aZGbv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jNk4i = parcelRequire("jNk4i");
const $9e1c2949054e4e70$export$bc1a48e1b7ed7af = ({ selections: selections, children: children, position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!selections) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const cardSelection = selections[0];
    const tooltipContent = selections.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: user.name
        }, user.name))) : null;
    const otherSelectionsContent = selections.length > 1 ? formatMessage((0, $jNk4i.default).moreSelections, {
        count: selections.length - 1
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.NodeSelectionWrapper), {
        color: cardSelection.color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.ParticipantBadge), {
        color: cardSelection.color,
        position: position
    }, cardSelection.user.name, otherSelectionsContent), children));
};

});
parcelRegister("jNk4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8136b50b09a1700$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8136b50b09a1700$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreSelections: {
        "id": "work-management-board.board.column.card.card-badge.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});


parcelRegister("10ATT", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $ace89df80f5c593a$export$64ef9b8c11710c47);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gjzML = parcelRequire("gjzML");

var $jGcn0 = parcelRequire("jGcn0");

var $d3C6e = parcelRequire("d3C6e");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $daiHs = parcelRequire("daiHs");
var $4wx7G = parcelRequire("4wx7G");
var $huZle = parcelRequire("huZle");
var $byrHc = parcelRequire("byrHc");
var $2kYPS = parcelRequire("2kYPS");
var $dq5k9 = parcelRequire("dq5k9");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");

var $iXHUp = parcelRequire("iXHUp");

var $5lzG5 = parcelRequire("5lzG5");

var $ffOJV = parcelRequire("ffOJV");

var $c9bRS = parcelRequire("c9bRS");
const $ace89df80f5c593a$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $eUqFw.memo)(({ highlight: highlight, issue: issue, onIssueKeyClick: onIssueKeyClick })=>{
    const groupBy = (0, $iXHUp.useGroupByField)();
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const isNewOptimisticIssue = (0, $d3C6e.isOptimisticIssue)(issue.id);
    const labels = issue.fields[0, $ib4WI.LABEL_ID]?.value ?? undefined;
    const isDone = issue.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
    const isStandardIssue = issue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.hierarchyLevel === 0;
    const renderedLabels = (0, $eUqFw.useMemo)(()=>labels && selectedFields.labels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huZle.CardLabels), {
            labels: labels,
            highlight: highlight
        })) : null, [
        selectedFields.labels,
        labels,
        highlight
    ]);
    const renderedDueDate = (0, $eUqFw.useMemo)(()=>issue.fields[0, $ib4WI.DUE_DATE_ID] != null && selectedFields.duedate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daiHs.CardDueDate), {
            dueDate: issue.fields[0, $ib4WI.DUE_DATE_ID].value,
            isCompleted: isDone
        })) : null, [
        issue.fields,
        isDone,
        selectedFields.duedate
    ]);
    const renderedIssueType = (0, $eUqFw.useMemo)(()=>selectedFields.issuetype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffOJV.default), {
            issueType: issue.fields[0, $ib4WI.ISSUE_TYPE_ID]
        }) : null, [
        issue.fields,
        selectedFields.issuetype
    ]);
    const renderedPriority = (0, $eUqFw.useMemo)(()=>{
        const priority = issue.fields[0, $ib4WI.PRIORITY_ID];
        return priority && selectedFields.priority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byrHc.CardPriority), {
            uri: priority.priority.iconUrl,
            name: priority.priority.name
        }) : null;
    }, [
        selectedFields.priority,
        issue.fields
    ]);
    const renderedAssignee = (0, $eUqFw.useMemo)(()=>{
        const assignee = issue.fields[0, $ib4WI.ASSIGNEE_ID];
        if (assignee?.user && selectedFields.assignee) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            highlight: highlight,
            avatarUrl: assignee.user.avatarURL ?? undefined,
            name: assignee.user.name
        });
        return null;
    }, [
        highlight,
        issue.fields,
        selectedFields.assignee
    ]);
    const renderedKey = (0, $eUqFw.useMemo)(()=>selectedFields.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$IssueKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wx7G.CardKey), {
            highlight: highlight,
            onClick: onIssueKeyClick,
            text: issue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        })), [
        highlight,
        issue.fields,
        onIssueKeyClick,
        selectedFields.key
    ]);
    const renderedStatus = (0, $eUqFw.useMemo)(()=>{
        const { status: status } = issue.fields[0, $ib4WI.STATUS_ID];
        return groupBy !== (0, $jGcn0.GROUP_BY_STATUS) && status.statusCategoryId && status.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
            name: status.name,
            category: (0, $8Qd0L.statusCategoryForId)(status.statusCategoryId)
        }));
    }, [
        groupBy,
        issue.fields
    ]);
    const showMultiFieldRow = renderedIssueType || renderedKey || isDone || renderedPriority || renderedAssignee;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$ContentWrapper, null, renderedStatus, renderedLabels, renderedDueDate, showMultiFieldRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$MultiFieldRow, null, renderedIssueType, renderedKey, isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dq5k9.CardTick), null), renderedPriority, renderedAssignee), selectedFields.subtasks && isStandardIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9bRS.default), {
        issue: issue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lzG5.default), {
        issue: issue
    })), isNewOptimisticIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace89df80f5c593a$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2kYPS.CardSpinner), null)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace89df80f5c593a$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _zulpu2gc _1yt4ia9t _fiawglyw",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ipxbi _1xi2pxbi",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$MultiFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _1tkegktf",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$IssueKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $ace89df80f5c593a$var$SingleFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gjzML", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $1d0a2d9cba4728c5$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d0a2d9cba4728c5$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d0a2d9cba4728c5$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $9t7rW.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _2rko1ssb _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _80om1kw7 _18s8v77o",
            __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $1d0a2d9cba4728c5$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $1d0a2d9cba4728c5$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eUqFw.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($1d0a2d9cba4728c5$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0a2d9cba4728c5$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("3ySoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ca0a8de67cc8ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
class $84ca0a8de67cc8ac$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("daiHs", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $486a10674c0d478f$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $d2wNG = parcelRequire("d2wNG");
var $7n7Dc = parcelRequire("7n7Dc");
var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");

var $ffiyv = parcelRequire("ffiyv");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i0Rm4 = parcelRequire("i0Rm4");

var $9CYrO = parcelRequire("9CYrO");
const $486a10674c0d478f$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat } = props;
    const dueDateEndOfDay = (0, $7n7Dc.default)((0, $3xcI8.default)(dueDate));
    const currentDate = (0, $3jYzf.default)(new Date());
    const diffInDays = (0, $d2wNG.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $EN9B6.default)(dueDateEndOfDay, dateFormat) : (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $9CYrO.messages).text, {
        date: (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $486a10674c0d478f$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($486a10674c0d478f$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
/* eslint-enable jira/react/no-style-attribute */ };
$486a10674c0d478f$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $486a10674c0d478f$export$2e2bcd8739ae039 = $486a10674c0d478f$export$9e242219cf1cc36c;
const $486a10674c0d478f$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: `var(--ds-text-accent-red, ${(0, $PdmhA).R400})`,
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA).R50})`
    } : {
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})`
    };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $486a10674c0d478f$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i0Rm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7d80576fbad589$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $8jchp = parcelRequire("8jchp");

const $7b7d80576fbad589$var$renderIcon = (type)=>{
    switch(type){
        case 0, $db933f3263da36b1$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.ChildIssuesGlyph), null);
        case 0, $db933f3263da36b1$export$aac403da0d127706:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.FlagGlyph), null);
        case 0, $db933f3263da36b1$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.CheckGlyph), null);
        case 0, $db933f3263da36b1$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.UploadGlyph), null);
        case 0, $db933f3263da36b1$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketBranchesGlyph), null);
        case 0, $db933f3263da36b1$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketCommitsGlyph), null);
        case 0, $db933f3263da36b1$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketPullrequestsGlyph), null);
        case 0, $db933f3263da36b1$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.EmojiFrequentGlyph), null);
        case 0, $db933f3263da36b1$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.MoreGlyph), null);
        case 0, $db933f3263da36b1$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.PersonGlyph), null);
        case 0, $db933f3263da36b1$export$d4ee7b46933c494f:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $7b7d80576fbad589$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b7d80576fbad589$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $7b7d80576fbad589$var$renderIcon(type));
};
var $7b7d80576fbad589$export$2e2bcd8739ae039 // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $7b7d80576fbad589$var$CardIcon;
const $7b7d80576fbad589$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1tuyf7k-0"
})((props)=>({
        display: 'inline-block',
        flexShrink: 0,
        lineHeight: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            verticalAlign: 'bottom',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.primaryColor || undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b7d80576fbad589$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $9t7rW.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});
const $7b7d80576fbad589$var$Container = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7b7d80576fbad589$var$ContainerExperiment, $7b7d80576fbad589$var$ContainerControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("8jchp", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $82b158e6c49496ac$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $82b158e6c49496ac$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $82b158e6c49496ac$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $82b158e6c49496ac$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $82b158e6c49496ac$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $82b158e6c49496ac$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $82b158e6c49496ac$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $82b158e6c49496ac$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $82b158e6c49496ac$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $82b158e6c49496ac$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $82b158e6c49496ac$export$45e4820251213456);

var $eUqFw = parcelRequire("eUqFw");
const $82b158e6c49496ac$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $82b158e6c49496ac$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $82b158e6c49496ac$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $82b158e6c49496ac$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $82b158e6c49496ac$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $db933f3263da36b1$export$3b43f1ca008dad23 = 'child-issues';
const $db933f3263da36b1$export$aac403da0d127706 = 'flag';
const $db933f3263da36b1$export$540a31b23d6b9abd = 'tick';
const $db933f3263da36b1$export$352da558a3a09227 = 'upload';
const $db933f3263da36b1$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $db933f3263da36b1$export$a153e0417183b79 = 'bitbucket-commits';
const $db933f3263da36b1$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $db933f3263da36b1$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $db933f3263da36b1$export$423cd243bf1888bc = 'more';
const $db933f3263da36b1$export$30a9be92cbb6f382 = 'person';
const $db933f3263da36b1$export$d4ee7b46933c494f = 'due-date';


parcelRegister("9CYrO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57887752e833b9f2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $57887752e833b9f2$export$593a022a1631ee1e = 'Due Date: ';
const $57887752e833b9f2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});


parcelRegister("4wx7G", function(module, exports) {

$parcel$export(module.exports, "CardKey", () => $a6fd5b79568ec04a$export$5bcc49a1014b751b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f5DAf = parcelRequire("f5DAf");

var $4S26w = parcelRequire("4S26w");
const $a6fd5b79568ec04a$export$5bcc49a1014b751b = ({ text: text, highlight: highlight, onClick: onClick, isDone: isDone = false, stopEventPropagation: stopEventPropagation = true, openInNewTab: openInNewTab = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const highlightedText = highlight && (0, $f5DAf.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5DAf.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const onClickKey = (event)=>{
        const isModifierClick = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;
        stopEventPropagation && event.stopPropagation();
        if (!isModifierClick && !openInNewTab) {
            event.preventDefault();
            onClick?.(event);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$42a852a2b6b56249, {
        "data-testid": "platform-card.common.ui.key.key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$9048d548939551ee, {
        isLineThrough: Boolean(isDone),
        href: `/browse/${text}`,
        target: "_blank" // prevent the context menu and Bento from opening
        ,
        onContextMenu: (event)=>event.stopPropagation(),
        onClick: onClickKey,
        ...Boolean(isDone) && {
            'aria-label': formatMessage((0, $4S26w.default).label, {
                issueKey: text
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6fd5b79568ec04a$export$cd0f44441c3b7719, null, highlightedText))));
};
$a6fd5b79568ec04a$export$5bcc49a1014b751b.defaultProps = {
    highlight: []
};
var $a6fd5b79568ec04a$export$2e2bcd8739ae039 // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $a6fd5b79568ec04a$export$5bcc49a1014b751b;
const $a6fd5b79568ec04a$var$StyledLinkControl = /*#__PURE__*/ (0, $kwce8.default).a.withConfig({
    componentId: "buhim-0"
})((props)=>({
        userSelect: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N100})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        textDecoration: props.isLineThrough ? 'line-through' : 'none',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textDecoration: props.isLineThrough ? 'line-through' : 'none'
        }
    }));
const $a6fd5b79568ec04a$var$StyledLinkExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLineThrough: isLineThrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uizt1wug _syaz1o15",
            __cmplp.isLineThrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isLineThrough ? "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _4fpr1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$9048d548939551ee = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $a6fd5b79568ec04a$var$StyledLinkExperiment, $a6fd5b79568ec04a$var$StyledLinkControl); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1eim1xrj _o5721q9c _1reo15vq _18m915vq _1e38mo4m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a6fd5b79568ec04a$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1reo15vq _18m915vq _1bto1l2s _1wyb1crf _k48pni7l _syaz1o15",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4S26w", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9870012944b968$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d9870012944b968$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label",
        "defaultMessage": "{issueKey} is resolved"
    }
});

});


parcelRegister("huZle", function(module, exports) {

$parcel$export(module.exports, "CardLabels", () => $ab3523b8c4a6d48b$export$ece436c5ee6469bd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $8cU5f = parcelRequire("8cU5f");

var $fdpby = parcelRequire("fdpby");
const $ab3523b8c4a6d48b$var$CmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Overflow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: labels.join(', '),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Gradient, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$CmpContainer, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdpby.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        })))))) : null;
const $ab3523b8c4a6d48b$var$TmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$Container, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdpby.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : null;
const $ab3523b8c4a6d48b$export$ece436c5ee6469bd = ({ labels: labels, isCMPBoard: isCMPBoard = false, highlight: highlight = [] })=>isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$CmpCardLabels, {
        labels: labels,
        highlight: highlight
    }) // now renders within custom fields
     : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab3523b8c4a6d48b$var$TmpCardLabels, {
        labels: labels,
        highlight: highlight
    });
var $ab3523b8c4a6d48b$export$2e2bcd8739ae039 = $ab3523b8c4a6d48b$export$ece436c5ee6469bd;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab3523b8c4a6d48b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _18s8r5cr",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$CmpContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c116y _18s8r5cr _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$Gradient = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _kqswh2mm _1reo15vq _18m915vq _aetrb3bt _15l2idpf _19doidpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _qc5omo3v _16r23cth _e9q69hw4",
            __cmplp.className
        ])
    });
});
const $ab3523b8c4a6d48b$var$Overflow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fdpby", function(module, exports) {

$parcel$export(module.exports, "CardLabel", () => $ace01197462babc7$export$e13aaac4037b0914);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
const $ace01197462babc7$export$e13aaac4037b0914 = (props)=>{
    const { text: text, highlight: highlight } = props;
    const isSelected = !!highlight && highlight.includes(text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace01197462babc7$export$42a852a2b6b56249, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ace01197462babc7$var$Content, null, text));
};
$ace01197462babc7$export$e13aaac4037b0914.defaultProps = {
    highlight: []
};
var $ace01197462babc7$export$2e2bcd8739ae039 // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $ace01197462babc7$export$e13aaac4037b0914;
const $ace01197462babc7$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "xwxtfj-0"
})((props)=>({
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 2.5}px`,
        margin: "var(--ds-space-050, 4px)",
        padding: 0,
        position: 'relative',
        cursor: 'default',
        lineHeight: 1,
        overflow: 'hidden',
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isSelected ? "var(--ds-background-accent-blue-subtler, #B3D4FF)" : "var(--ds-background-neutral, #F4F5F7)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isSelected ? "var(--ds-text-accent-blue, #0747A6)" : "var(--ds-text, #172B4D)"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace01197462babc7$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4t3igktf _18s81b66 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _80om73ad _vwz4kb7n _1reo15vq _18m915vq _2rko1l7b",
            __cmplp.isSelected ? "_bfhkynhg" : "_bfhk1s4m",
            __cmplp.isSelected ? "_syazia9z" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $ace01197462babc7$export$42a852a2b6b56249 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $ace01197462babc7$var$ContainerExperiment, $ace01197462babc7$var$ContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ace01197462babc7$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fmgvx _1yt4u49m _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});


parcelRegister("byrHc", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $46a41bceb74ea678$export$92d93d4ee23c212c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i5SoD = parcelRequire("i5SoD");
const $46a41bceb74ea678$export$92d93d4ee23c212c = (props)=>{
    const { name: name, uri: uri } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const priorityLevel = (0, $1ybV0.ff)('sea-2835-improve-accessibility-of-priority-field-in-board-card_mrdww') ? formatMessage((0, $i5SoD.default).priorityTooltip, {
        name: name
    }) : name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46a41bceb74ea678$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: priorityLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46a41bceb74ea678$export$3e431a229df88919, {
        alt: priorityLevel,
        src: uri
    })));
};
var $46a41bceb74ea678$export$2e2bcd8739ae039 = $46a41bceb74ea678$export$92d93d4ee23c212c;
const $46a41bceb74ea678$var$iconSize = (0, $c9TLT.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46a41bceb74ea678$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $46a41bceb74ea678$var$ImageControl = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-18gtlq4-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$46a41bceb74ea678$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$46a41bceb74ea678$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46a41bceb74ea678$var$ImageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $46a41bceb74ea678$export$3e431a229df88919 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $46a41bceb74ea678$var$ImageExperiment, $46a41bceb74ea678$var$ImageControl);

});
parcelRegister("i5SoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b5977dca0a308e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81b5977dca0a308e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    priorityTooltip: {
        "id": "platform-ui-card.common.priority.priority-tooltip",
        "defaultMessage": "Priority: {name}"
    }
});

});


parcelRegister("2kYPS", function(module, exports) {

$parcel$export(module.exports, "CardSpinner", () => $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO6Wr = parcelRequire("lO6Wr");
const $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage((0, $lO6Wr.default).loading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbc873aa655fa8e6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        label: message,
        size: "small"
    })));
};
var $cbc873aa655fa8e6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cbc873aa655fa8e6$export$cbd2bb5b02f5fd3a;
const $cbc873aa655fa8e6$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lO6Wr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35efc65ef144f45$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d35efc65ef144f45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "card.common.spinner.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("dq5k9", function(module, exports) {

$parcel$export(module.exports, "CardTick", () => $5fbf8d3f00f65718$export$711ec40e911e6898);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i0Rm4 = parcelRequire("i0Rm4");

var $j58hq = parcelRequire("j58hq");
const $5fbf8d3f00f65718$export$711ec40e911e6898 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage((0, $j58hq.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fbf8d3f00f65718$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$540a31b23d6b9abd),
        label: message,
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G400})`
    })));
};
var $5fbf8d3f00f65718$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5fbf8d3f00f65718$export$711ec40e911e6898;
const $5fbf8d3f00f65718$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j58hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6db7fbf464b2de9b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6db7fbf464b2de9b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    done: {
        "id": "card.common.tick.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("5lzG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5178e356fbbfe64$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $4XQdE = parcelRequire("4XQdE");

var $9nkwJ = parcelRequire("9nkwJ");

var $ffiyv = parcelRequire("ffiyv");

var $9jNAz = parcelRequire("9jNAz");

var $MxsGB = parcelRequire("MxsGB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4iC3C = parcelRequire("4iC3C");

var $huZle = parcelRequire("huZle");

var $lO4Or = parcelRequire("lO4Or");

var $6BYzZ = parcelRequire("6BYzZ");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");
const $c5178e356fbbfe64$var$DATE_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};
const $c5178e356fbbfe64$var$TimeStampCss = {
    whenDisplaySettingSwitchable: null
};
const $c5178e356fbbfe64$var$categoryFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_CATEGORY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        noIndent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, {
        indent: true
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$CategoryTagContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
        categoryName: field.category.name,
        categoryColor: field.category.color
    })));
const $c5178e356fbbfe64$var$componentFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_COMPONENTS) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        noIndent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, {
        indent: true
    }, field.name), field.value.map((component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
            key: component,
            text: component
        })));
const $c5178e356fbbfe64$var$dateRenderer = ({ field: field, formatDate: formatDate })=>field.type === (0, $ib4WI.BOARD_FIELD_DATE) && field.value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatDate((0, $6BYzZ.DateOnly).fromISODateString(field.value)))));
const $c5178e356fbbfe64$var$textAndNumberRenderer = ({ field: field, formatNumber: formatNumber })=>(field.type === (0, $ib4WI.BOARD_FIELD_TEXT) || field.type === (0, $ib4WI.BOARD_FIELD_FLOAT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.type === (0, $ib4WI.BOARD_FIELD_FLOAT) ? formatNumber(field.value) : field.value));
const $c5178e356fbbfe64$var$dateTimeRenderer = ({ field: field, TimeStampComponent: TimeStampComponent })=>field.type === (0, $ib4WI.BOARD_FIELD_DATE_TIME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$TimeStampContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimeStampComponent, {
        value: field.value,
        extraStyles: $c5178e356fbbfe64$var$TimeStampCss
    })));
const $c5178e356fbbfe64$var$userRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_USER) && field.user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        name: field.user.name,
        src: field.user.avatarURL ?? undefined,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.user.name));
const $c5178e356fbbfe64$var$multiUserRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_MULTI_USER) && field.users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        appearance: "stack",
        data: field.users.map((user)=>({
                name: user.name,
                src: user.avatarURL ?? undefined,
                enableTooltip: true
            })),
        maxCount: 10,
        size: "small"
    }), field.users.length === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.users[0].name));
const $c5178e356fbbfe64$var$selectFieldRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_SELECT) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$FieldLabel, null, field.name), field.value.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huZle.CardLabels), {
        labels: field.value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$SubtlestText, null, field.value[0]));
const $c5178e356fbbfe64$var$timeOriginalEstimateRenderer = ({ field: field })=>field.type === (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$DetailRow, {
        key: field.fieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$InlineLabel, null, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c5178e356fbbfe64$var$InlineContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, field.value)));
const $c5178e356fbbfe64$var$FIELD_RENDERERS = {
    [(0, $ib4WI.BOARD_FIELD_CATEGORY)]: $c5178e356fbbfe64$var$categoryFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_COMPONENTS)]: $c5178e356fbbfe64$var$componentFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_DATE)]: $c5178e356fbbfe64$var$dateRenderer,
    [(0, $ib4WI.BOARD_FIELD_TEXT)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_USER)]: $c5178e356fbbfe64$var$userRenderer,
    [(0, $ib4WI.BOARD_FIELD_MULTI_USER)]: $c5178e356fbbfe64$var$multiUserRenderer,
    [(0, $ib4WI.BOARD_FIELD_SELECT)]: $c5178e356fbbfe64$var$selectFieldRenderer,
    [(0, $ib4WI.BOARD_FIELD_FLOAT)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_STORY_POINTS)]: $c5178e356fbbfe64$var$textAndNumberRenderer,
    [(0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE)]: $c5178e356fbbfe64$var$timeOriginalEstimateRenderer,
    [(0, $ib4WI.BOARD_FIELD_DATE_TIME)]: $c5178e356fbbfe64$var$dateTimeRenderer
};
const $c5178e356fbbfe64$var$FIELD_TYPE_ORDER = Object.keys($c5178e356fbbfe64$var$FIELD_RENDERERS);
const $c5178e356fbbfe64$var$EXCLUDED_SYSTEM_FIELDS = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
]);
const $c5178e356fbbfe64$var$CardDetailFields = ({ issue: issue })=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const { formatDate: formatDateIntl, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const formatDate = (0, $eUqFw.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $c5178e356fbbfe64$var$DATE_FORMAT_OPTIONS) : '', [
        formatDateIntl
    ]);
    const fields = Object.values(issue.fields)?.filter((field)=>{
        /**
     * Filter out field based off the following criteria:
     * * If the field is not selected via customized card configuration
     * * If the field type is not in the FIELD_TYPE_ORDER (i.e. no renderer for field type available)
     * * If the field is in the EXCLUDED_SYSTEM_FIELDS
     */ if (!selectedFields[field.fieldId] || !$c5178e356fbbfe64$var$FIELD_TYPE_ORDER.includes(field.type) || $c5178e356fbbfe64$var$EXCLUDED_SYSTEM_FIELDS.has(field.fieldId)) return false;
        return true;
    }).sort((field1, field2)=>$c5178e356fbbfe64$var$FIELD_TYPE_ORDER.indexOf(field1.type) - $c5178e356fbbfe64$var$FIELD_TYPE_ORDER.indexOf(field2.type)).map((field)=>$c5178e356fbbfe64$var$FIELD_RENDERERS[field.type]?.({
            field: field,
            formatDate: formatDate,
            formatNumber: formatNumber,
            TimeStampComponent: (0, $4iC3C.default)
        }) ?? null);
    return fields;
};
var $c5178e356fbbfe64$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($c5178e356fbbfe64$var$CardDetailFields);
const $c5178e356fbbfe64$var$DetailRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noIndent: noIndent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq",
            __cmplp.noIndent ? "_18u0r5cr" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$FieldLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _1bsb1osq _1bto1l2s _1reo15vq _18m915vq _o5721q9c _11c81vlj _k48p1wq8",
            __cmplp.indent ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$InlineLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1aqp _1bto1l2s _1reo15vq _18m915vq _o5721q9c _11c81vlj _k48p1wq8",
            __cmplp.indent ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$InlineContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$SubtlestText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1be1 _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$TimeStampContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _11c8qk37 _30l3jjyb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5178e356fbbfe64$var$CategoryTagContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66 _19bv1b66 _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.component-visual-refresh_t8zbo')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTag);

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            $98c5a9f7a5ded4f8$var$baseStyles,
            (isRemovable || isLink) && $98c5a9f7a5ded4f8$var$focusRingStyles,
            isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            isInteractive && $98c5a9f7a5ded4f8$var$interactiveStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $70eddb948b5989f5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $70eddb948b5989f5$var$beforeElementStyles
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $154b7edc63fec879$var$baseStyles,
            $154b7edc63fec879$var$linkStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $154b7edc63fec879$var$baseStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("MxsGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c3f5934e57f5b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $k7FjW = parcelRequire("k7FjW");
const $575c3f5934e57f5b$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: backgroundColor } = (0, $k7FjW.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$StyledTag, {
        color: backgroundColor
    }, categoryName));
};
var $575c3f5934e57f5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($575c3f5934e57f5b$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $575c3f5934e57f5b$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $9t7rW.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bah1e5h _4cvr1h6o _v564188d _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoiti9 _bfhk1cj8 _1yt41b66 _1wybdlk8 _k48p1nn1 _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k7FjW", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $0ce9d8c1415fa16c$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $0ce9d8c1415fa16c$export$49fce7fdcf55f26d);

var $fwFhq = parcelRequire("fwFhq");
const $0ce9d8c1415fa16c$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $fwFhq.CATEGORY_THEMES).length);
    return (0, $fwFhq.CATEGORY_THEMES)[randomIndex].name;
};
const $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c = (colorName)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $0ce9d8c1415fa16c$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $fwFhq.GREY_LIGHTEST_META;
    return (0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $fwFhq.GREY_LIGHTEST_META);
};
const $0ce9d8c1415fa16c$export$4ef6b7574883e63d = ()=>(0, $fwFhq.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("fwFhq", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $592872c1ad972acf$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $592872c1ad972acf$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $592872c1ad972acf$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $592872c1ad972acf$export$845e69f3af4133a6);

var $PdmhA = parcelRequire("PdmhA");

var $jwyl8 = parcelRequire("jwyl8");

var $kzlGv = parcelRequire("kzlGv");
const $592872c1ad972acf$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$jwyl8.N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).greyLightest
};
const $592872c1ad972acf$export$7c3ad8ed1eaec359 = {
    name: 'GREY_LIGHTER',
    backgroundColor: `var(--ds-background-neutral-hovered, ${$jwyl8.N200})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).greyLighter
};
const $592872c1ad972acf$export$11b75436f568ab00 = {
    name: 'GREY',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$jwyl8.N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).grey
};
const $592872c1ad972acf$export$680a025ac49fcedd = {
    name: 'GREY_DARKER',
    backgroundColor: `var(--ds-background-neutral-bold, ${$jwyl8.N400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarker
};
const $592872c1ad972acf$export$c63acd769779da32 = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$jwyl8.N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarkest
};
const $592872c1ad972acf$export$d6bc0064d6a00b4b = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-purple-subtlest, ${$jwyl8.P100})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLightest
};
const $592872c1ad972acf$export$7a53a04457b57cc7 = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-purple-subtler, ${$jwyl8.P200})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLighter
};
const $592872c1ad972acf$export$d6f3928d12bf329c = {
    name: 'PURPLE',
    backgroundColor: `var(--ds-background-accent-purple-subtle, ${$jwyl8.P300})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purple
};
const $592872c1ad972acf$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: `var(--ds-text-accent-purple, ${$jwyl8.P400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarker
};
const $592872c1ad972acf$export$5e3ecd219265b1d5 = {
    name: 'PURPLE_DARKEST',
    backgroundColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarkest
};
const $592872c1ad972acf$export$4b98b31eae42f719 = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-blue-subtlest, ${$jwyl8.B100})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLightest
};
const $592872c1ad972acf$export$e92a5b8219b97745 = {
    name: 'BLUE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-blue-subtler, ${$jwyl8.B200})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLighter
};
const $592872c1ad972acf$export$b761714c24fd7f1c = {
    name: 'BLUE',
    backgroundColor: `var(--ds-background-accent-blue-subtle, ${$jwyl8.B300})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blue
};
const $592872c1ad972acf$export$50b37b24459ab9d9 = {
    name: 'BLUE_DARKER',
    backgroundColor: `var(--ds-text-accent-blue, ${$jwyl8.B400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarker
};
const $592872c1ad972acf$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarkest
};
const $592872c1ad972acf$export$1fe5b156c0ba3acb = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-teal-subtlest, ${$jwyl8.T100})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLightest
};
const $592872c1ad972acf$export$fb40f4c2f659b9bb = {
    name: 'TEAL_LIGHTER',
    backgroundColor: `var(--ds-background-accent-teal-subtler, ${$jwyl8.T200})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLighter
};
const $592872c1ad972acf$export$d177e878b5837287 = {
    name: 'TEAL',
    backgroundColor: `var(--ds-background-accent-teal-subtle, ${$jwyl8.T300})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).teal
};
const $592872c1ad972acf$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: `var(--ds-text-accent-teal, ${$jwyl8.T400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarker
};
const $592872c1ad972acf$export$fc1c501cf599d75a = {
    name: 'TEAL_DARKEST',
    backgroundColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarkest
};
const $592872c1ad972acf$export$d977521f30fbcdeb = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-green-subtlest, ${$jwyl8.G100})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLightest
};
const $592872c1ad972acf$export$911ea8fce963369 = {
    name: 'GREEN_LIGHTER',
    backgroundColor: `var(--ds-background-accent-green-subtler, ${$jwyl8.G200})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLighter
};
const $592872c1ad972acf$export$814f677491d6ea0d = {
    name: 'GREEN',
    backgroundColor: `var(--ds-background-accent-green-subtle, ${$jwyl8.G300})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).green
};
const $592872c1ad972acf$export$376a849da12d546d = {
    name: 'GREEN_DARKER',
    backgroundColor: `var(--ds-background-accent-green-bolder, ${$jwyl8.G400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarker
};
const $592872c1ad972acf$export$808ba7d394e8f2c4 = {
    name: 'GREEN_DARKEST',
    backgroundColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarkest
};
const $592872c1ad972acf$export$46ad9119b0fbf094 = {
    name: 'LIME_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-lime-subtlest, ${$jwyl8.L100})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLightest
};
const $592872c1ad972acf$export$e5e5e485aa3ce630 = {
    name: 'LIME_LIGHTER',
    backgroundColor: `var(--ds-background-accent-lime-subtler, ${$jwyl8.L200})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLighter
};
const $592872c1ad972acf$export$166a57cda148857c = {
    name: 'LIME',
    backgroundColor: `var(--ds-background-accent-lime-subtle, ${$jwyl8.L300})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).lime
};
const $592872c1ad972acf$export$40663533c0b649cc = {
    name: 'LIME_DARKER',
    backgroundColor: `var(--ds-text-accent-lime, ${$jwyl8.L400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarker
};
const $592872c1ad972acf$export$78557ba4a4ffc502 = {
    name: 'LIME_DARKEST',
    backgroundColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarkest
};
const $592872c1ad972acf$export$12021cfc394e311e = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${$jwyl8.Y100})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLightest
};
const $592872c1ad972acf$export$eab7ec7309efe3db = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$jwyl8.Y200})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLighter
};
const $592872c1ad972acf$export$8d5b340327da7fa3 = {
    name: 'YELLOW',
    backgroundColor: `var(--ds-background-accent-yellow-subtle, ${$jwyl8.Y300})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellow
};
const $592872c1ad972acf$export$b0a7a0813708318e = {
    name: 'YELLOW_DARKER',
    backgroundColor: `var(--ds-text-accent-yellow, ${$jwyl8.Y400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarker
};
const $592872c1ad972acf$export$dde9759b2d3b0e02 = {
    name: 'YELLOW_DARKEST',
    backgroundColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarkest
};
const $592872c1ad972acf$export$4718b8cf3799954b = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-orange-subtlest, ${$jwyl8.O100})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLightest
};
const $592872c1ad972acf$export$8fac1fdda0aa4e41 = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-orange-subtler, ${$jwyl8.O200})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLighter
};
const $592872c1ad972acf$export$2efe350451bcec02 = {
    name: 'ORANGE',
    backgroundColor: `var(--ds-background-accent-orange-subtle, ${$jwyl8.O300})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orange
};
const $592872c1ad972acf$export$5ba9bd795da8d7d5 = {
    name: 'ORANGE_DARKER',
    backgroundColor: `var(--ds-background-accent-orange-bolder, ${$jwyl8.O400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarker
};
const $592872c1ad972acf$export$93a7b89503a97d81 = {
    name: 'ORANGE_DARKEST',
    backgroundColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarkest
};
const $592872c1ad972acf$export$56873b0b30501dbe = {
    name: 'RED_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-red-subtlest, ${$jwyl8.R100})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLightest
};
const $592872c1ad972acf$export$344aa49a80760380 = {
    name: 'RED_LIGHTER',
    backgroundColor: `var(--ds-background-accent-red-subtler, ${$jwyl8.R200})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLighter
};
const $592872c1ad972acf$export$c760bedaf9085f90 = {
    name: 'RED',
    backgroundColor: `var(--ds-background-accent-red-subtle, ${$jwyl8.R300})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).red
};
const $592872c1ad972acf$export$38493b731be63d77 = {
    name: 'RED_DARKER',
    backgroundColor: `var(--ds-background-accent-red-bolder, ${$jwyl8.R400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).redDarker
};
const $592872c1ad972acf$export$dda419d8311f8d4a = {
    name: 'RED_DARKEST',
    backgroundColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).redDarkest
};
const $592872c1ad972acf$export$e0957dc0d569e65f = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-magenta-subtlest, ${$jwyl8.M100})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLightest
};
const $592872c1ad972acf$export$299af16a857bf4ca = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: `var(--ds-background-accent-magenta-subtler, ${$jwyl8.M200})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLighter
};
const $592872c1ad972acf$export$d7208e47aa15bafe = {
    name: 'MAGENTA',
    backgroundColor: `var(--ds-background-accent-magenta-subtle-hovered, ${$jwyl8.M300})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magenta
};
const $592872c1ad972acf$export$b3aea5a31105d4e3 = {
    name: 'MAGENTA_DARKER',
    backgroundColor: `var(--ds-text-accent-magenta, ${$jwyl8.M400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarker
};
const $592872c1ad972acf$export$faf43e54615bce6b = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.M500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarkest
};
const $592872c1ad972acf$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $PdmhA).N0})`;
const $592872c1ad972acf$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $PdmhA).N500})`;
const $592872c1ad972acf$export$845e69f3af4133a6 = [
    $592872c1ad972acf$export$cb19a604bb399a88,
    $592872c1ad972acf$export$d6bc0064d6a00b4b,
    $592872c1ad972acf$export$4b98b31eae42f719,
    $592872c1ad972acf$export$1fe5b156c0ba3acb,
    $592872c1ad972acf$export$d977521f30fbcdeb,
    $592872c1ad972acf$export$46ad9119b0fbf094,
    $592872c1ad972acf$export$12021cfc394e311e,
    $592872c1ad972acf$export$4718b8cf3799954b,
    $592872c1ad972acf$export$56873b0b30501dbe,
    $592872c1ad972acf$export$e0957dc0d569e65f,
    $592872c1ad972acf$export$7c3ad8ed1eaec359,
    $592872c1ad972acf$export$7a53a04457b57cc7,
    $592872c1ad972acf$export$e92a5b8219b97745,
    $592872c1ad972acf$export$fb40f4c2f659b9bb,
    $592872c1ad972acf$export$911ea8fce963369,
    $592872c1ad972acf$export$e5e5e485aa3ce630,
    $592872c1ad972acf$export$eab7ec7309efe3db,
    $592872c1ad972acf$export$8fac1fdda0aa4e41,
    $592872c1ad972acf$export$344aa49a80760380,
    $592872c1ad972acf$export$299af16a857bf4ca,
    $592872c1ad972acf$export$11b75436f568ab00,
    $592872c1ad972acf$export$d6f3928d12bf329c,
    $592872c1ad972acf$export$b761714c24fd7f1c,
    $592872c1ad972acf$export$d177e878b5837287,
    $592872c1ad972acf$export$814f677491d6ea0d,
    $592872c1ad972acf$export$166a57cda148857c,
    $592872c1ad972acf$export$8d5b340327da7fa3,
    $592872c1ad972acf$export$2efe350451bcec02,
    $592872c1ad972acf$export$c760bedaf9085f90,
    $592872c1ad972acf$export$d7208e47aa15bafe,
    $592872c1ad972acf$export$680a025ac49fcedd,
    $592872c1ad972acf$export$7c314e2461a7241b,
    $592872c1ad972acf$export$50b37b24459ab9d9,
    $592872c1ad972acf$export$6daaa1cc3f46f41,
    $592872c1ad972acf$export$376a849da12d546d,
    $592872c1ad972acf$export$40663533c0b649cc,
    $592872c1ad972acf$export$b0a7a0813708318e,
    $592872c1ad972acf$export$5ba9bd795da8d7d5,
    $592872c1ad972acf$export$38493b731be63d77,
    $592872c1ad972acf$export$b3aea5a31105d4e3,
    $592872c1ad972acf$export$c63acd769779da32,
    $592872c1ad972acf$export$5e3ecd219265b1d5,
    $592872c1ad972acf$export$69c4eac71b813fba,
    $592872c1ad972acf$export$fc1c501cf599d75a,
    $592872c1ad972acf$export$808ba7d394e8f2c4,
    $592872c1ad972acf$export$78557ba4a4ffc502,
    $592872c1ad972acf$export$dde9759b2d3b0e02,
    $592872c1ad972acf$export$93a7b89503a97d81,
    $592872c1ad972acf$export$dda419d8311f8d4a,
    $592872c1ad972acf$export$faf43e54615bce6b
];

});
parcelRegister("jwyl8", function(module, exports) {

$parcel$export(module.exports, "N100", () => $cccad9dbca818926$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $cccad9dbca818926$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $cccad9dbca818926$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $cccad9dbca818926$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $cccad9dbca818926$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "P100", () => $cccad9dbca818926$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $cccad9dbca818926$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $cccad9dbca818926$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $cccad9dbca818926$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $cccad9dbca818926$export$147899de772240ec);
$parcel$export(module.exports, "B100", () => $cccad9dbca818926$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $cccad9dbca818926$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $cccad9dbca818926$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $cccad9dbca818926$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $cccad9dbca818926$export$a6ee3d71bc067634);
$parcel$export(module.exports, "T100", () => $cccad9dbca818926$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $cccad9dbca818926$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $cccad9dbca818926$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $cccad9dbca818926$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $cccad9dbca818926$export$6036577f95c3877e);
$parcel$export(module.exports, "G100", () => $cccad9dbca818926$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $cccad9dbca818926$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $cccad9dbca818926$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $cccad9dbca818926$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $cccad9dbca818926$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "L100", () => $cccad9dbca818926$export$fbb30b762ae4fcda);
$parcel$export(module.exports, "L200", () => $cccad9dbca818926$export$f72948ef771f6f15);
$parcel$export(module.exports, "L300", () => $cccad9dbca818926$export$59d89537e7d73aa4);
$parcel$export(module.exports, "L400", () => $cccad9dbca818926$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L500", () => $cccad9dbca818926$export$58808b1c527bd1b0);
$parcel$export(module.exports, "Y100", () => $cccad9dbca818926$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $cccad9dbca818926$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $cccad9dbca818926$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $cccad9dbca818926$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $cccad9dbca818926$export$874739ea9e379ab6);
$parcel$export(module.exports, "O100", () => $cccad9dbca818926$export$4d0048026652f54a);
$parcel$export(module.exports, "O200", () => $cccad9dbca818926$export$51716a84e62e022c);
$parcel$export(module.exports, "O300", () => $cccad9dbca818926$export$59e5b1f9a23fd718);
$parcel$export(module.exports, "O400", () => $cccad9dbca818926$export$e30ed75d70748b1);
$parcel$export(module.exports, "O500", () => $cccad9dbca818926$export$d93a44e5c84e8256);
$parcel$export(module.exports, "R100", () => $cccad9dbca818926$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $cccad9dbca818926$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $cccad9dbca818926$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $cccad9dbca818926$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $cccad9dbca818926$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "M100", () => $cccad9dbca818926$export$6755153cd35f90b1);
$parcel$export(module.exports, "M200", () => $cccad9dbca818926$export$a19f0c33186f7767);
$parcel$export(module.exports, "M300", () => $cccad9dbca818926$export$a46884cf0037b203);
$parcel$export(module.exports, "M400", () => $cccad9dbca818926$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M500", () => $cccad9dbca818926$export$16814b01d9742bf7);

var $PdmhA = parcelRequire("PdmhA");
const $cccad9dbca818926$export$d6447c357493214f = '#F0F1F4';
const $cccad9dbca818926$export$f563ee71e9ee74cd = 'rgba(9, 30, 66, 0.14)';
const $cccad9dbca818926$export$e2ef2124cf4024b1 = (0, $PdmhA).N60A;
const $cccad9dbca818926$export$eece5f492e429f08 = '#44546F';
const $cccad9dbca818926$export$c39c0fe0f26207ae = (0, $PdmhA).N800;
const $cccad9dbca818926$export$6011520a64d9a187 = '#F3F0FF';
const $cccad9dbca818926$export$a7175d4e9206bc80 = '#DFD8FD';
const $cccad9dbca818926$export$b48405b95304b5a1 = '#9F8FEF';
const $cccad9dbca818926$export$c71e4279dd54a18d = '#5E4DB2';
const $cccad9dbca818926$export$147899de772240ec = '#352C63';
const $cccad9dbca818926$export$ecfc1dff386a3e7a = '#E9F2FF';
const $cccad9dbca818926$export$215b7063051591f1 = '#CCE0FF';
const $cccad9dbca818926$export$e62e8919cca44969 = '#579DFF';
const $cccad9dbca818926$export$b3de0ae08da2ce64 = '#0055CC';
const $cccad9dbca818926$export$a6ee3d71bc067634 = '#09326C';
const $cccad9dbca818926$export$776c9c497ef08533 = '#E3FAFC';
const $cccad9dbca818926$export$69cb3ca10c1e330e = '#C1F0F5';
const $cccad9dbca818926$export$9dc1ef0f3f48059b = '#60C6D2';
const $cccad9dbca818926$export$7c835c78b6fcdef8 = '#206B74';
const $cccad9dbca818926$export$6036577f95c3877e = '#1D474C';
const $cccad9dbca818926$export$afbce1382ec95f73 = '#DFFCF0';
const $cccad9dbca818926$export$747d86715d4175de = '#BAF3DB';
const $cccad9dbca818926$export$940e1f69e873f202 = '#4BCE97';
const $cccad9dbca818926$export$a49394138f7b8e85 = '#216E4E';
const $cccad9dbca818926$export$6fa04827ac68a4fb = '#164B35';
const $cccad9dbca818926$export$fbb30b762ae4fcda = '#EEFBDA';
const $cccad9dbca818926$export$f72948ef771f6f15 = '#D3F1A7';
const $cccad9dbca818926$export$59d89537e7d73aa4 = '#94C748';
const $cccad9dbca818926$export$4b0a7cabffffd4f5 = '#4C6B1F';
const $cccad9dbca818926$export$58808b1c527bd1b0 = '#37471F';
const $cccad9dbca818926$export$1cc05bbbf340e559 = '#FFF7D6';
const $cccad9dbca818926$export$5aae31392d72caaa = (0, $PdmhA).Y75;
const $cccad9dbca818926$export$c6930421db9fa514 = '#E2B203';
const $cccad9dbca818926$export$59619663aa6500fb = '#7F5F01';
const $cccad9dbca818926$export$874739ea9e379ab6 = '#533F04';
const $cccad9dbca818926$export$4d0048026652f54a = '#FFF4E5';
const $cccad9dbca818926$export$51716a84e62e022c = '#FFE2BD';
const $cccad9dbca818926$export$59e5b1f9a23fd718 = '#FAA53D';
const $cccad9dbca818926$export$e30ed75d70748b1 = '#974F0C';
const $cccad9dbca818926$export$d93a44e5c84e8256 = '#5F3811';
const $cccad9dbca818926$export$be802dd0d8b57f35 = '#FFEDEB';
const $cccad9dbca818926$export$60847d42f9da92a6 = '#FFD2CC';
const $cccad9dbca818926$export$4a7404f376229999 = '#F87462';
const $cccad9dbca818926$export$2010d0fb4295b346 = '#AE2A19';
const $cccad9dbca818926$export$2837b5a1a71d5c02 = '#601E16';
const $cccad9dbca818926$export$6755153cd35f90b1 = '#FFECF8';
const $cccad9dbca818926$export$a19f0c33186f7767 = '#FDD0EC';
const $cccad9dbca818926$export$a46884cf0037b203 = '#F797D2';
const $cccad9dbca818926$export$a1d4686c17e1cdef = '#943D73';
const $cccad9dbca818926$export$16814b01d9742bf7 = '#50253F';

});

parcelRegister("kzlGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c77e6e90b19c039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c77e6e90b19c039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("4iC3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a1c7a2e73b38d4$export$2e2bcd8739ae039);

var $5TykG = parcelRequire("5TykG");

var $c1a1c7a2e73b38d4$export$2e2bcd8739ae039 = (0, $5TykG.default);

});
parcelRegister("5TykG", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6a9dc8604f8c0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $8cU5f = parcelRequire("8cU5f");

var $gUUjF = parcelRequire("gUUjF");

var $1IqwQ = parcelRequire("1IqwQ");
var $4ksts = parcelRequire("4ksts");

var $kPvBW = parcelRequire("kPvBW");

var $i9pAn = parcelRequire("i9pAn");

var $6aKs0 = parcelRequire("6aKs0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lGLse = parcelRequire("lGLse");

var $jsScF = parcelRequire("jsScF");

var $hAlQB = parcelRequire("hAlQB");
const $da6a9dc8604f8c0a$var$TimestampView = (props)=>{
    const { value: value, extraStyles: extraStyles = {}, tooltipPosition: tooltipPosition = 'top' } = props;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const loggedInUserTimeZone = loggedInUser ? loggedInUser.timeZone : undefined;
    const userTimeZone = loggedInUserTimeZone || (0, $6aKs0.getBrowserTimeZone)();
    const isADGTimestampDisplaySettingRelative = (0, $hAlQB.getADGTimestampDisplaySetting)(value) === (0, $jsScF.RELATIVE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatDate: formatDate } = (0, $4ksts.useIntlV2)();
    const [userDisplaySetting, { setValue: setTimestampDisplaySetting }] = (0, $i9pAn.useUserPreferencesValue)((0, $kPvBW.TIMESTAMP_DISPLAY_SETTING));
    // Use relative display setting if user hasn't set anything
    const displaySetting = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(userDisplaySetting) || userDisplaySetting === '' ? (0, $jsScF.RELATIVE) : userDisplaySetting;
    const formattedAbsoluteTimestamp = (0, $eUqFw.useMemo)(()=>formatDate(value, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: userTimeZone
        }), [
        formatDate,
        userTimeZone,
        value
    ]);
    const onAbsoluteClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'absoluteTimeButton');
        setTimestampDisplaySetting((0, $jsScF.RELATIVE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to RELATIVE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const onRelativeClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'relativeTimeButton');
        setTimestampDisplaySetting((0, $jsScF.ABSOLUTE)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to ABSOLUTE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const renderAbsolute = (0, $eUqFw.useCallback)((canSwitchDisplaySetting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: canSwitchDisplaySetting,
            onKeyDown: (e)=>{
                if ((e.key === 'Enter' || e.key === 'Space') && canSwitchDisplaySetting) onAbsoluteClick();
            },
            role: "presentation",
            onClick: canSwitchDisplaySetting ? onAbsoluteClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            extraStyles: extraStyles
        }, formattedAbsoluteTimestamp), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onAbsoluteClick
    ]);
    const renderRelative = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da6a9dc8604f8c0a$var$TimestampWrapper, {
            canSwitchDisplaySetting: true,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onRelativeClick(),
            role: "presentation",
            onClick: onRelativeClick,
            extraStyles: extraStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            tag: "span",
            content: formattedAbsoluteTimestamp,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "issue-timestamp.relative-time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IqwQ.FormattedRelativeV2), {
            value: value
        })))), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onRelativeClick,
        tooltipPosition,
        value
    ]);
    // BENTO-2569: Users have requested the ability to switch to absolute timestamps when the timestamp is to be displayed as relative.
    // When the timestamp is to be displayed as absolute then we cannot allow them to switch (to comply with ADG)
    return isADGTimestampDisplaySettingRelative && displaySetting === (0, $jsScF.RELATIVE) ? renderRelative() : renderAbsolute(isADGTimestampDisplaySettingRelative);
};
$da6a9dc8604f8c0a$var$TimestampView.displayName = 'TimestampView';
var $da6a9dc8604f8c0a$export$2e2bcd8739ae039 = $da6a9dc8604f8c0a$var$TimestampView;
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da6a9dc8604f8c0a$var$TimestampWrapper = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "erd76u-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.canSwitchDisplaySetting ? 'pointer' : 'default'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ extraStyles: extraStyles })=>extraStyles.always, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ canSwitchDisplaySetting: canSwitchDisplaySetting, extraStyles: { whenDisplaySettingSwitchable: extraStylesWhenSwitchable } })=>canSwitchDisplaySetting ? extraStylesWhenSwitchable : '');
$da6a9dc8604f8c0a$var$TimestampWrapper.displayName = 'TimestampWrapper';

});
parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery'
};

});

parcelRegister("i9pAn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $0735c0eb8f9298bc$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $0735c0eb8f9298bc$export$eefe4b2985e8203e);

var $eUqFw = parcelRequire("eUqFw");

var $lNFDn = parcelRequire("lNFDn");

var $duUIT = parcelRequire("duUIT");
const $0735c0eb8f9298bc$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $lNFDn.useUserPreferencesStoreValue)(userPreferenceKey);
    const setValue = (0, $eUqFw.useCallback)((newValue)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        return (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eUqFw.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eUqFw.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $0735c0eb8f9298bc$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $lNFDn.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eUqFw.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $duUIT.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $duUIT.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("lNFDn", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $c14aa03e7fb8e4ad$export$4d156074562bac9a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $fB99X = parcelRequire("fB99X");
const $c14aa03e7fb8e4ad$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $fB99X.actions
});
const $c14aa03e7fb8e4ad$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $c14aa03e7fb8e4ad$export$46e7eeb2fc34fab8 = (0, $ggKAj.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: $c14aa03e7fb8e4ad$var$getUserPreference
});
const $c14aa03e7fb8e4ad$export$4d156074562bac9a = (0, $ggKAj.createHook)($c14aa03e7fb8e4ad$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("fB99X", function(module, exports) {

$parcel$export(module.exports, "actions", () => $15d29e400e18f42d$export$e324594224ef24da);
const $15d29e400e18f42d$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $15d29e400e18f42d$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $15d29e400e18f42d$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $15d29e400e18f42d$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $15d29e400e18f42d$export$e324594224ef24da = {
    setUserPreferenceValue: $15d29e400e18f42d$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $15d29e400e18f42d$var$deleteUserPreferenceValue,
    setUserPreferences: $15d29e400e18f42d$var$setUserPreferences,
    getUserPreferenceValue: $15d29e400e18f42d$export$df0a4f67b9888111
};

});


parcelRegister("duUIT", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $15d896639d90b0d5$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $15d896639d90b0d5$export$a60a810760d07867);

var $lRmyA = parcelRequire("lRmyA");
const $15d896639d90b0d5$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $15d896639d90b0d5$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $lRmyA.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


parcelRegister("6aKs0", function(module, exports) {

$parcel$export(module.exports, "SYDNEY_TIMEZONE", () => $c7bf7e7164aeb193$export$1a022a080ce6c5bb);
$parcel$export(module.exports, "getBrowserTimeZone", () => $c7bf7e7164aeb193$export$efc596861aea1477);
const $c7bf7e7164aeb193$export$1a022a080ce6c5bb = 'Australia/Sydney';
const $c7bf7e7164aeb193$export$efc596861aea1477 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone || $c7bf7e7164aeb193$export$1a022a080ce6c5bb;

});

parcelRegister("jsScF", function(module, exports) {

$parcel$export(module.exports, "RELATIVE", () => $ad8b3ae3c84be75e$export$91389b1eb9882ae7);
$parcel$export(module.exports, "ABSOLUTE", () => $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644);
const $ad8b3ae3c84be75e$export$91389b1eb9882ae7 = 'RELATIVE';
const $ad8b3ae3c84be75e$export$8cd2c3eb7eeb9644 = 'ABSOLUTE';

});

parcelRegister("hAlQB", function(module, exports) {

$parcel$export(module.exports, "getADGTimestampDisplaySetting", () => $86e37847e2293e72$export$e89759fbd7b8f45a);

var $jsScF = parcelRequire("jsScF");
// @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
const $86e37847e2293e72$var$getDaysElapsed = (date)=>(Date.now() - new Date(date)) / 86400000;
const $86e37847e2293e72$export$e89759fbd7b8f45a = (date)=>$86e37847e2293e72$var$getDaysElapsed(date) < 8 ? (0, $jsScF.RELATIVE) : (0, $jsScF.ABSOLUTE);

});



parcelRegister("6BYzZ", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $5d1ef987232e205a$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $5d1ef987232e205a$export$b0961ad8aee63b8b);
const $5d1ef987232e205a$export$9cda9b56d134780f = 'Invalid date or date format';
const $5d1ef987232e205a$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $5d1ef987232e205a$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $5d1ef987232e205a$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $5d1ef987232e205a$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $5d1ef987232e205a$var$isLeapYear(year) ? 29 : $5d1ef987232e205a$var$daysInMonth[month - 1])) return false;
    return true;
};
const $5d1ef987232e205a$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $5d1ef987232e205a$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $5d1ef987232e205a$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $5d1ef987232e205a$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $5d1ef987232e205a$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$5d1ef987232e205a$var$isDateValid(year, month, day)) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $5d1ef987232e205a$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $5d1ef987232e205a$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $5d1ef987232e205a$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});


parcelRegister("ffOJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e29972ec623d172$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");
const $2e29972ec623d172$export$200b8444ace4b1d3 = ({ issueType: issueType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2e29972ec623d172$var$iconStyles
    }, issueType?.issueType.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: issueType.issueType.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e29972ec623d172$var$Image, {
        alt: issueType.issueType.name,
        src: issueType.issueType.iconUrl
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e29972ec623d172$var$ImagePlaceholder, null));
var $2e29972ec623d172$export$2e2bcd8739ae039 = $2e29972ec623d172$export$200b8444ace4b1d3;
const $2e29972ec623d172$var$iconStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e29972ec623d172$var$ImagePlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _bfhkn82g _2rkoglpi",
            __cmplp.className
        ])
    });
});
const $2e29972ec623d172$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c9bRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b847888d666dc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $14luy = parcelRequire("14luy");

var $jl4eq = parcelRequire("jl4eq");

var $6naHj = parcelRequire("6naHj");

var $lIQsu = parcelRequire("lIQsu");
const $25b847888d666dc4$var$Subtasks = ({ issue: issue })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isExpanded: isExpanded, toggleSubtasks: toggleSubtasks } = (0, $14luy.useExpandCollapseSubtasks)(issue.id);
    const { loading: loading, fetch: fetch } = (0, $jl4eq.useIssueSubtasks)(issue);
    const hasSubtasks = Boolean(issue.subtaskMetadata?.total);
    (0, $eUqFw.useEffect)(()=>{
        if (isExpanded && hasSubtasks) fetch();
    // empty dependencies as we only want to run this effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleToggleClick = (0, $eUqFw.useCallback)(()=>{
        if (!isExpanded) fetch();
        toggleSubtasks();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardCardSubtaskTrigger', {
            isExpanded: isExpanded
        });
    }, [
        createAnalyticsEvent,
        fetch,
        isExpanded,
        toggleSubtasks
    ]);
    const preventEventBubbling = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
    }, []);
    // Do not display any subtask UI if there are no subtasks
    if (!issue.subtaskMetadata?.total) return null;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onClick: preventEventBubbling
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIQsu.default), {
        isExpanded: isExpanded,
        isLoading: loading,
        onToggle: handleToggleClick,
        subtaskMetadata: issue.subtaskMetadata
    }), isExpanded && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6naHj.default), {
        parent: issue
    })));
};
var $25b847888d666dc4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($25b847888d666dc4$var$Subtasks);

});
parcelRegister("14luy", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseSubtasks", () => $73eb2d10ea848123$export$a152b29991d4fa38);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");
const $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT = 20;
const $73eb2d10ea848123$export$a152b29991d4fa38 = (issueId)=>{
    const [expandedIssues, setExpandedIssues] = (0, $7c3W1.useViewPreference)((0, $ji3xf.EXPANDED_ISSUES_PREFERENCE));
    const isExpanded = Boolean(expandedIssues?.includes(issueId));
    const collapseSubtasks = (0, $eUqFw.useCallback)(()=>{
        const newExpandedIssues = expandedIssues?.filter((id)=>issueId !== id);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const expandSubtasks = (0, $eUqFw.useCallback)(()=>{
        const newExpandedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
            ...expandedIssues || [],
            issueId
        ]);
        // Trim to the last 20 items as we don't want to store too many expanded issues
        if (newExpandedIssues.length > $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT) newExpandedIssues.splice(0, newExpandedIssues.length - $73eb2d10ea848123$var$EXPANDED_ISSUES_LIMIT);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const toggleSubtasks = (0, $eUqFw.useCallback)(()=>{
        isExpanded ? collapseSubtasks() : expandSubtasks();
    }, [
        isExpanded,
        collapseSubtasks,
        expandSubtasks
    ]);
    return {
        isExpanded: isExpanded,
        toggleSubtasks: toggleSubtasks
    };
};

});

parcelRegister("jl4eq", function(module, exports) {

$parcel$export(module.exports, "useIssueSubtasks", () => $1535a736efad0e2e$export$5b5aeea73b6178e9);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $k8Qyf = parcelRequire("k8Qyf");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $c7RGv = parcelRequire("c7RGv");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $ecqJr = parcelRequire("ecqJr");
const $1535a736efad0e2e$export$b46cc40fdf28878c = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.ISSUE_KEY_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.SUMMARY_TYPE)
];
const $1535a736efad0e2e$export$5b5aeea73b6178e9 = (issue)=>{
    const { setIssues: setIssues } = (0, $dtXTv.useIssueStoreActions)();
    const fetchIssues = (0, $c7RGv.useFetchBoardIssues)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        startExperience();
        setLoading(true);
        try {
            const results = await fetchIssues({
                fieldIds: $1535a736efad0e2e$export$b46cc40fdf28878c,
                jql: `parent = ${issue.id}`
            });
            const boardIssues = transformToIssues(results);
            setIssues(boardIssues);
            markExperienceSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                description: (0, $ecqJr.default).errorMessage,
                title: (0, $ecqJr.default).errorTitle,
                type: 'error'
            });
            markExperienceFailed('Failed to load issue subtasks', error);
        } finally{
            setLoading(false);
        }
    }, [
        issue,
        fetchIssues,
        transformToIssues,
        setIssues,
        showFlag,
        startExperience,
        markExperienceSuccess,
        markExperienceFailed
    ]);
    return {
        loading: loading,
        fetch: fetch
    };
};

});
parcelRegister("ecqJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d38812fa55c7a44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d38812fa55c7a44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-subtasks.error-title",
        "defaultMessage": "Failed to load subtasks"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-subtasks.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("6naHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0cd29bc92a7ef92$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");

var $gjzML = parcelRequire("gjzML");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $4wx7G = parcelRequire("4wx7G");
var $kgzZq = parcelRequire("kgzZq");
var $jkZ7i = parcelRequire("jkZ7i");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $d1mZL = parcelRequire("d1mZL");

var $2b5eO = parcelRequire("2b5eO");

var $f7G96 = parcelRequire("f7G96");

var $l4y71 = parcelRequire("l4y71");
const $a0cd29bc92a7ef92$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $a0cd29bc92a7ef92$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL = 3;
const $a0cd29bc92a7ef92$var$SubtaskClickWrapper = ({ onClick: onClick, subtask: subtask, children: children })=>{
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        onClick(event, subtask);
    }, [
        onClick,
        subtask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskWrapper, {
        "data-testid": "work-management-board.ui.board.column.card.card-content.subtasks.subtask-list",
        onClick: handleClick
    }, children);
};
const $a0cd29bc92a7ef92$var$SubtaskList = ({ parent: parent })=>{
    const subtasks = (0, $d1mZL.useSubtasksByParentId)({
        parentId: parent.id
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $2b5eO.useJWMBoardFeatures)();
    const shouldOpenInNewTab = issueViewInteraction === 'openNewTab';
    const onIssueClick = (0, $f7G96.useViewIssue)();
    const handleSubtaskClick = (0, $eUqFw.useCallback)((event, subtaskIssue)=>{
        const withCmd = event.ctrlKey || event.metaKey;
        event.stopPropagation();
        shouldOpenInNewTab ? (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        }) : onIssueClick(subtaskIssue, withCmd);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'subtask clicked');
    }, [
        createAnalyticsEvent,
        onIssueClick,
        shouldOpenInNewTab
    ]);
    const handleIssueKeyClick = (0, $eUqFw.useCallback)((subtaskIssue)=>{
        shouldOpenInNewTab ? (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        }) : onIssueClick(subtaskIssue, false);
    }, [
        onIssueClick,
        shouldOpenInNewTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4y71.default), {
        subtasks: subtasks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskScrollContainer, null, subtasks.map((subtaskIssue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskClickWrapper, {
            key: subtaskIssue.id,
            onClick: handleSubtaskClick,
            subtask: subtaskIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskSummary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgzZq.CardSummary), {
            text: subtaskIssue.fields[0, $ib4WI.SUMMARY_ID].value
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRowCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskIssueTypeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkZ7i.CardType), {
            uri: subtaskIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.iconUrl,
            text: subtaskIssue.fields[0, $ib4WI.ISSUE_TYPE_ID].issueType.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wx7G.CardKey), {
            onClick: ()=>handleIssueKeyClick(subtaskIssue),
            text: subtaskIssue.fields[0, $ib4WI.ISSUE_KEY_ID].value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskRowCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtaskLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: $a0cd29bc92a7ef92$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(subtaskIssue.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId)]
        }, subtaskIssue.fields[0, $ib4WI.STATUS_ID].status.name)), !subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID]?.user.avatarURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "circle",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            avatarUrl: subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID].user.avatarURL,
            name: subtaskIssue.fields[0, $ib4WI.ASSIGNEE_ID].user.name
        })))))), subtasks.length > $a0cd29bc92a7ef92$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a0cd29bc92a7ef92$var$SubtasksDivider, null));
};
var $a0cd29bc92a7ef92$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a0cd29bc92a7ef92$var$SubtaskList);
const $a0cd29bc92a7ef92$var$maxCardWidthWithoutPadding = 236;
const $a0cd29bc92a7ef92$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0cd29bc92a7ef92$var$SubtaskScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71leoa3 _18m9uk5w _18u0xmi2 _2hwxxmi2 _ca0qidpf _n3tdidpf _19bvutpp _u5f3utpp",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0xmi2 _2hwxxmi2 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _80omtlke _irr3k6hx",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1n261g80",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskRowCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskIssueTypeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskSummary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbl3i9 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtasksDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTop: isTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3iidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3dowsm2",
            __cmplp.isTop ? "_19pk12x7" : "_19pkze3t",
            __cmplp.className
        ])
    });
});
const $a0cd29bc92a7ef92$var$SubtaskLozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jkZ7i", function(module, exports) {

$parcel$export(module.exports, "CardType", () => $fc8540d3cdf1aee5$export$f1a79bffad3377cd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $bKxX9 = parcelRequire("bKxX9");
const $fc8540d3cdf1aee5$export$f1a79bffad3377cd = (props)=>{
    const { text: text, uri: uri } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8540d3cdf1aee5$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8540d3cdf1aee5$export$3e431a229df88919, {
        alt: text,
        src: uri
    })));
};
var $fc8540d3cdf1aee5$export$2e2bcd8739ae039 = $fc8540d3cdf1aee5$export$f1a79bffad3377cd;
const $fc8540d3cdf1aee5$var$iconSize = (0, $c9TLT.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc8540d3cdf1aee5$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $fc8540d3cdf1aee5$var$ImageControl = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1oveq8w-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$fc8540d3cdf1aee5$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$fc8540d3cdf1aee5$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc8540d3cdf1aee5$var$ImageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $fc8540d3cdf1aee5$export$3e431a229df88919 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $bKxX9.ff)('compiled.migration.jsw.tanuki'), $fc8540d3cdf1aee5$var$ImageExperiment, $fc8540d3cdf1aee5$var$ImageControl);

});

parcelRegister("l4y71", function(module, exports) {

$parcel$export(module.exports, "default", () => $823dd0a699faa758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8cU5f = parcelRequire("8cU5f");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $6oOl6 = parcelRequire("6oOl6");
const $823dd0a699faa758$var$SubtaskProgressBar = ({ subtasks: subtasks })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderBarSection = (0, $eUqFw.useCallback)((statusCategoryId, BarSectionComponent, message)=>{
        if (!subtasks) return null;
        const count = subtasks.filter((subtask)=>subtask.fields[0, $ib4WI.STATUS_ID].status.statusCategoryId === statusCategoryId).length;
        const label = formatMessage(message, {
            itemCount: count,
            totalCount: subtasks.length
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($823dd0a699faa758$var$BarSectionContainer, {
            barWidthPct: count / subtasks.length * 100,
            role: "progressbar",
            "aria-valuemax": subtasks.length,
            "aria-valuenow": count,
            "aria-label": label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BarSectionComponent, null)));
    }, [
        subtasks,
        formatMessage
    ]);
    if (!subtasks || subtasks.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($823dd0a699faa758$var$SubtaskProgressBarContainer, null, renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE], $823dd0a699faa758$var$DoneBarSection, (0, $6oOl6.default).doneItems), renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).INDETERMINATE], $823dd0a699faa758$var$InProgressBarSection, (0, $6oOl6.default).inProgressItems), renderBarSection((0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).NEW], $823dd0a699faa758$var$TodoBarSection, (0, $6oOl6.default).todoItems));
};
var $823dd0a699faa758$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($823dd0a699faa758$var$SubtaskProgressBar);
const $823dd0a699faa758$var$SubtaskProgressBarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhloo _1bsb1osq _2rko1y44 _1reo15vq _18m915vq _19pk12x7 _otyru2gc _1e0c1txw _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$BarSectionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { barWidthPct: barWidthPct, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mkz0ru": (0, $9t7rW.default)(`${__cmplp.barWidthPct}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i0dlrmxw _11fs1y44 _1ih21y44 _k8kw1y44 _px611y44 _1jqf15vq _8dku15vq _uar715vq _1st315vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$BarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ii2wt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$DoneBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhku8mo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$InProgressBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk9cbf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $823dd0a699faa758$var$TodoBarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $823dd0a699faa758$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhloo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6oOl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c532475580592c48$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c532475580592c48$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.done-items",
        "defaultMessage": "{itemCount} of {totalCount} done"
    },
    inProgressItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.in-progress-items",
        "defaultMessage": "{itemCount} of {totalCount} in progress"
    },
    todoItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.todo-items",
        "defaultMessage": "{itemCount} of {totalCount} to do"
    }
});

});



parcelRegister("lIQsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbf557d053c3af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7opLA = parcelRequire("7opLA");

var $dtaN9 = parcelRequire("dtaN9");

var $eyI8O = parcelRequire("eyI8O");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $il7oX = parcelRequire("il7oX");
const $84dbf557d053c3af$var$SubtasksExpandCollapse = ({ isExpanded: isExpanded, isLoading: isLoading, onToggle: onToggle, subtaskMetadata: subtaskMetadata })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tooltipContent = formatMessage(isExpanded ? (0, $il7oX.default).hideSubtasksTooltip : (0, $il7oX.default).showSubtasksTooltip);
    const ariaLabelContent = formatMessage(isExpanded ? (0, $il7oX.default).hideSubtasksAriaLabel : (0, $il7oX.default).showSubtasksAriaLabel, {
        done: subtaskMetadata.done,
        total: subtaskMetadata.total
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        isLoading: isLoading,
        onClick: onToggle,
        "aria-label": ariaLabelContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84dbf557d053c3af$var$SubtaskContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, subtaskMetadata.done, "/", subtaskMetadata.total), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84dbf557d053c3af$var$SubtaskExpandCollapse, {
        expanded: isExpanded,
        "data-testid": "work-management-board.ui.board.column.card.card-content.subtasks.subtasks-expand-collapse.subtask-expand-collapse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    })))));
};
var $84dbf557d053c3af$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($84dbf557d053c3af$var$SubtasksExpandCollapse);
const $84dbf557d053c3af$var$SubtaskContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84dbf557d053c3af$var$SubtaskExpandCollapse = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { expanded: expanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _v5644a6k",
            __cmplp.expanded ? "_t9ec14w8" : "_t9ec160w",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eyI8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9967b301fa2e1c2$var$_react = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a9967b301fa2e1c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a9967b301fa2e1c2$var$SubtaskIcon = (props)=>/*#__PURE__*/ $a9967b301fa2e1c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0118.994 21H9.006A2.005 2.005 0 017 19h11c.555 0 1-.448 1-1V7zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0114.994 17H5.006A2.005 2.005 0 013 14.994V5.006zM5 5v10h10V5H5z"/><path d="M7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L9 10.586 7.707 9.293z"/></g></svg>`
    }, props));
$a9967b301fa2e1c2$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $a9967b301fa2e1c2$var$_default = $a9967b301fa2e1c2$var$SubtaskIcon;
module.exports.default = $a9967b301fa2e1c2$var$_default;

});

parcelRegister("il7oX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40260260d0c0b03$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b40260260d0c0b03$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.show-subtasks-tooltip",
        "defaultMessage": "Show subtasks"
    },
    hideSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.hide-subtasks-tooltip",
        "defaultMessage": "Hide subtasks"
    },
    showSubtasksAriaLabel: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.show-subtasks-aria-label",
        "defaultMessage": "Show subtasks ({done} of {total, plural, one {# subtask} other {# subtasks}} complete)"
    },
    hideSubtasksAriaLabel: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.hide-subtasks-aria-label",
        "defaultMessage": "Hide subtasks ({done} of {total, plural, one {# subtask} other {# subtasks}} complete)"
    }
});

});




parcelRegister("5Glvh", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $5fd51a3656f7badc$export$1a2d6d8c98d2c941);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2iOYf = parcelRequire("2iOYf");

var $ifH0n = parcelRequire("ifH0n");

var $bOA3Q = parcelRequire("bOA3Q");

var $eI5EY = parcelRequire("eI5EY");

var $aeIT6 = parcelRequire("aeIT6");

var $ib4WI = parcelRequire("ib4WI");

var $gAOAU = parcelRequire("gAOAU");
const $5fd51a3656f7badc$var$CARD_COVER_COLOR_HEIGHT = 24;
const $5fd51a3656f7badc$var$CARD_COVER_IMAGE_HEIGHT = 140;
const $5fd51a3656f7badc$export$1a2d6d8c98d2c941 = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    const isOpen = (0, $gAOAU.useIsCardCoverEditingOpen)();
    const { ref: ref } = (0, $2iOYf.useResizingHeight)();
    if ((0, $eI5EY.fg)('card_covers_animation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: isOpen ? ref : null
    }, coverMedia !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardCoverInner, {
        coverMedia: coverMedia
    }));
    return coverMedia !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardCoverInner, {
        coverMedia: coverMedia
    });
});
const $5fd51a3656f7badc$var$CardCoverInner = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    if (coverMedia.type === 'color') {
        const theme = (0, $bOA3Q.themeManager).getColor(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardColorCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-color",
            backgroundColor: theme.light['color.elevation.surface']
        });
    }
    if (coverMedia.type === 'gradient') {
        const theme = (0, $bOA3Q.themeManager).getGradient(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardGradientCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-gradient",
            background: theme.light['elevation.surface']
        });
    }
    if (coverMedia.type === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$CardImageCover, {
        coverMedia: coverMedia
    });
    return null;
});
const $5fd51a3656f7badc$var$CardImageCover = ({ coverMedia: coverMedia })=>{
    const media = (0, $aeIT6.useMediaConfiguration)();
    const imageRef = (0, $eUqFw.useRef)(null);
    const imgUrl = (0, $eUqFw.useMemo)(()=>{
        if (!media?.clientId || !media?.externalEndpointUrl) return null;
        return (0, $bOA3Q.generateMediaImageUrl)({
            mediaApiFileId: coverMedia.mediaApiFileId,
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            token: coverMedia.mediaReadToken,
            mediaEndpoint: 'image',
            // A card is really 260px wide, but we want to load the image at a higher resolution
            // and then scale it down to avoid blurry images. If you use 260px, there will be a gap
            // between the image and the card border.
            width: (0, $ib4WI.COLUMN_FIXED_WIDTH),
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        coverMedia,
        media
    ]);
    /**
   * Give attribution to the unsplash api for qualified images.
   * This is needed for legal reasons to comply with their API terms of service.
   */ (0, $eUqFw.useEffect)(()=>{
        if (!imgUrl) return;
        if (coverMedia.unsplashId != null && imageRef.current) {
            const unsubscribe = (0, $ifH0n.unsplashTracker).trackWhileInViewport(imageRef.current, coverMedia.unsplashId);
            return unsubscribe;
        }
    }, [
        coverMedia.unsplashId,
        imgUrl
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5fd51a3656f7badc$var$MemoizedCardImageCover, {
        ref: imageRef,
        "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-image",
        src: imgUrl,
        title: coverMedia.fileName
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd51a3656f7badc$var$CardImageCoverImg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $9t7rW.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk2pcs _bfhkvdii _1lrw1dfr _12vemgnk _ouxl1ssb _4t3i11ux _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $5fd51a3656f7badc$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
};
/**
 * Since the board items are refetched after any board changes, we receive a new token
 * every time. As a result, the image is refetched and causes a flicker. We don't need
 * to rerender the image in that case. The cases we need to are when the image is removed
 * or added, in which case we will retrieve a token separately and rerender.
 */ const $5fd51a3656f7badc$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $eUqFw.memo)($5fd51a3656f7badc$var$CardImageCoverImg, (prevProps, nextProps)=>$5fd51a3656f7badc$var$urlWithoutToken(prevProps.src) === $5fd51a3656f7badc$var$urlWithoutToken(nextProps.src));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fd51a3656f7badc$var$CardGradientCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $9t7rW.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71i36 _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $5fd51a3656f7badc$var$CardColorCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2iOYf", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $cc0c08651aba5237$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $cc0c08651aba5237$export$204d7b6d1491a2d3);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");


var $5LHuc = parcelRequire("5LHuc");

var $5bTtn = parcelRequire("5bTtn");

var $hcijx = parcelRequire("hcijx");

var $3WV8S = parcelRequire("3WV8S");

var $fMc9h = parcelRequire("fMc9h");
const $cc0c08651aba5237$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $5LHuc.mediumDurationMs), timingFunction: calcTimingFunction = ()=>(0, $d58b680a02f4d6a4$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $eUqFw.useRef)();
    const [element, setElementRef] = (0, $hcijx.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $5bTtn.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $5bTtn.useRequestAnimationFrame)();
    (0, $fMc9h.useSnapshotBeforeUpdate)(()=>{
        if ((0, $8YJjX.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $3WV8S.useLayoutEffect)(()=>{
        if ((0, $8YJjX.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $cc0c08651aba5237$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $cc0c08651aba5237$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children(resizing));
};
var /**
 * This exists only to be able to extract opts.
 */ $cc0c08651aba5237$export$2e2bcd8739ae039 = (_opts)=>{};

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("hcijx", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $81c15b5f9718dda0$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $81c15b5f9718dda0$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("fMc9h", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $357e6c5475356d12$export$9e95200239cd148b);

var $eUqFw = parcelRequire("eUqFw");

var $3WV8S = parcelRequire("3WV8S");
const $357e6c5475356d12$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $eUqFw.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $3WV8S.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});



parcelRegister("b5A1R", function(module, exports) {

$parcel$export(module.exports, "useCardFooter", () => $958a389f1314c9e6$export$59dd39d875a11145);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $bZapc = parcelRequire("bZapc");

var $1CcjM = parcelRequire("1CcjM");

var $3XjFp = parcelRequire("3XjFp");
const $958a389f1314c9e6$var$CardFooterContent = /*#__PURE__*/ (0, $eUqFw.memo)(({ issue: issue, hasConfluencePages: hasConfluencePages, hasIssueLinks: hasIssueLinks })=>{
    const confluencePages = hasConfluencePages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CcjM.default), {
        issue: issue
    }) : null;
    const issueLinks = hasIssueLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XjFp.IssueLinks), {
        issueId: issue.id,
        issueKey: issue.fields[0, $ib4WI.ISSUE_KEY_ID].value,
        issueSummary: issue.fields[0, $ib4WI.SUMMARY_ID].value,
        issueLinksCount: issue.fields[0, $lO4Or.ISSUE_LINKS_TYPE]?.value ?? 0,
        issueTypeField: issue.fields[0, $ib4WI.ISSUE_TYPE_ID]
    }) : null;
    if (confluencePages || issueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$Footer, null, confluencePages, issueLinks);
    return null;
});
const $958a389f1314c9e6$export$59dd39d875a11145 = (issue)=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const pageCount = issue.fields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE]?.value ?? 0;
    const hasConfluencePages = selectedFields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE] && pageCount > 0;
    let hasIssueLinks = false;
    if ((0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation')) {
        const issueLinksCount = issue.fields[0, $lO4Or.ISSUE_LINKS_TYPE]?.value ?? 0;
        hasIssueLinks = selectedFields[0, $lO4Or.ISSUE_LINKS_TYPE] && issueLinksCount > 0;
    }
    const hasFooter = hasConfluencePages || hasIssueLinks;
    let footerContent = null;
    let footerPlaceholder = null;
    if (hasFooter) {
        footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$CardFooterContent, {
            issue: issue,
            hasConfluencePages: hasConfluencePages,
            hasIssueLinks: hasIssueLinks
        });
        footerPlaceholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($958a389f1314c9e6$var$FooterPlaceholder, null);
    }
    return {
        footerContent: footerContent,
        footerPlaceholder: footerPlaceholder
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $958a389f1314c9e6$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5idpf _1e0c1txw _zulp1b66 _1yt41bs6",
            __cmplp.className
        ])
    });
});
const $958a389f1314c9e6$var$FooterPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1jfw _x3do13y8 _18s8s8vo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1CcjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e0390aa5e8d6ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a6e0390aa5e8d6ff$var$LazyCardDetailConfluencePages = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eTHjv")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board/column/card/card-footer/confluence-pages/main.tsx"
});
const $a6e0390aa5e8d6ff$var$AsyncCardDetailConfluencePages = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.card-detail-confluence-pages",
        packageName: "jira-business.board.card-detail-confluence-pages",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-board-card-detail-confluence-pages",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6e0390aa5e8d6ff$var$Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6e0390aa5e8d6ff$var$LazyCardDetailConfluencePages, props)));
var $a6e0390aa5e8d6ff$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a6e0390aa5e8d6ff$var$AsyncCardDetailConfluencePages;
const $a6e0390aa5e8d6ff$var$Skeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkn82g _2rkoglpi _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eTHjv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bDEk0')
        ]);
        const value = parcelRequire('6DxGu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bDEk0")
    ]).then(()=>parcelRequire('6DxGu'));
}

});


parcelRegister("3XjFp", function(module, exports) {

$parcel$export(module.exports, "IssueLinks", () => $4193899be4feee51$export$a8a190e7e67ab4f5);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $7ZZxN = parcelRequire("7ZZxN");

var $gSSYZ = parcelRequire("gSSYZ");

var $5FsEp = parcelRequire("5FsEp");
const $4193899be4feee51$var$IssueLinksNotMemo = ({ issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueLinksCount: issueLinksCount, issueTypeField: issueTypeField })=>{
    const { permissions: { linkIssues: linkIssues } } = (0, $kQAZu.useProject)();
    const refetchIssues = (0, $5FsEp.useRefetchIssues)();
    const onIssueUnlink = (0, $eUqFw.useCallback)((issueIds)=>{
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    const onIssueLink = (0, $eUqFw.useCallback)((originalIssueId, updateIssueIds)=>{
        const issueIds = [
            originalIssueId,
            ...updateIssueIds
        ];
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSSYZ.IssueLinksStats), {
        testId: "work-management-board.ui.board.column.card.card-footer.issue-links",
        issueLinksCount: issueLinksCount,
        issueKey: issueKey,
        issueId: String(issueId),
        issueSummary: issueSummary,
        issueType: issueTypeField?.issueType,
        feedbackCollectorPrefix: "business-board",
        isLinkingEnabled: linkIssues,
        sourceProductType: (0, $7ZZxN.CORE_PROJECT),
        onIssueUnlink: onIssueUnlink,
        onIssueLink: onIssueLink,
        maxIssueLinksStatsCount: 9
    });
};
const $4193899be4feee51$export$a8a190e7e67ab4f5 = /*#__PURE__*/ (0, $eUqFw.memo)($4193899be4feee51$var$IssueLinksNotMemo);

});
parcelRegister("gSSYZ", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $7c3797fc27cf4728$export$471e3cf08f140899);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $04VQy = parcelRequire("04VQy");
const $7c3797fc27cf4728$export$471e3cf08f140899 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-links-stats-business",
        packageName: "jiraIssueLinksStatsBusiness",
        teamName: "a4t-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $04VQy.IssueLinksStats), props));

});
parcelRegister("04VQy", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $07e882c6cc812654$export$471e3cf08f140899);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $6nIG2 = parcelRequire("6nIG2");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $lNfG4 = parcelRequire("lNfG4");

var $c9TLT = parcelRequire("c9TLT");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $heNuy = parcelRequire("heNuy");

var $1i7ym = parcelRequire("1i7ym");

var $b03HR = parcelRequire("b03HR");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eIp1n = parcelRequire("eIp1n");

var $dWLk9 = parcelRequire("dWLk9");

var $dAMh4 = parcelRequire("dAMh4");

var $bT56S = parcelRequire("bT56S");

var $gYrUv = parcelRequire("gYrUv");
const $07e882c6cc812654$export$901087bc7dae0943 = (target)=>{
    if (target instanceof HTMLElement) {
        if (!document.querySelector('#jira-frontend')?.contains(target)) return true;
    }
    return false;
};
const $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT = 50;
const $07e882c6cc812654$var$asyncIssueLinksDetailsLoad = (0, $lNfG4.metrics).interaction({
    key: 'issue-links-details-content-load'
});
const $07e882c6cc812654$var$asyncIssueLinkPopupLoad = (0, $lNfG4.metrics).interaction({
    key: 'issue-link-popup-load'
});
const $07e882c6cc812654$export$471e3cf08f140899 = ({ issueLinksCount: issueLinksCount, maxIssueLinksStatsCount: maxIssueLinksStatsCount, testId: testId, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, feedbackCollectorPrefix: feedbackCollectorPrefix, isLinkingEnabled: isLinkingEnabled, onIssueUnlink: onIssueUnlinkProp, onIssueLink: onIssueLinkProp, sourceProductType: sourceProductType, stopPropagationOnClick: stopPropagationOnClick = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isLinkPopupOpen, setIsLinkPopupOpen] = (0, $eUqFw.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $heNuy.issueLinksDetailsContentEntryPoint), {
        cloudId: cloudId,
        issueKey: issueKey,
        // Fetch 1 more than required so that we show view all linked issues button
        issueCount: $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT + 1,
        withDueDate: true,
        fields: [
            'issuetype',
            'summary',
            'status',
            'duedate'
        ]
    }, $07e882c6cc812654$var$asyncIssueLinksDetailsLoad);
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const { entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject, entryPointActions: linkIssuePopupEntryPointActions, stopMetric: linkIssuePopupStopMetric } = (0, $6j4bv.useEntryPoint)((0, $b03HR.linkIssuePopupEntryPoint), {
        cloudId: cloudId
    }, $07e882c6cc812654$var$asyncIssueLinkPopupLoad);
    const onTriggerButtonClick = (event, analyticsEvent)=>{
        if (isOpen) onPopupClose();
        else setIsOpen(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueLinksStats', {
            isToOpenPopup: !isOpen
        });
    };
    const onPopupClose = (0, $eUqFw.useCallback)((event)=>{
        if (stopPropagationOnClick && event?.target && $07e882c6cc812654$export$901087bc7dae0943(event.target)) return;
        if (isLinkPopupOpen) {
            if (event instanceof KeyboardEvent && (event.key === 'Escape' || event.key === 'Esc')) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'escapeKey'
            });
            if (event instanceof MouseEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'clickOutsidePopup'
            });
        }
        setIsOpen(false);
        setIsLinkPopupOpen(false);
    }, [
        createAnalyticsEvent,
        isLinkPopupOpen,
        stopPropagationOnClick
    ]);
    const onIssueUnlink = (0, $eUqFw.useCallback)((issueIds)=>{
        onIssueUnlinkProp(issueIds);
        setIsOpen(false);
    }, [
        onIssueUnlinkProp
    ]);
    const onIssueLink = (0, $eUqFw.useCallback)((id, updateIssueIds)=>{
        onIssueLinkProp(id, updateIssueIds);
        onPopupClose();
    }, [
        onIssueLinkProp,
        onPopupClose
    ]);
    const onIssueLinkButtonClick = (0, $eUqFw.useCallback)(()=>{
        setIsLinkPopupOpen(true);
        linkIssuePopupEntryPointActions.load();
    }, [
        linkIssuePopupEntryPointActions
    ]);
    const onIssueLinkPopupClose = ()=>{
        setIsLinkPopupOpen(false);
    };
    const tooltipContent = issueLinksCount > maxIssueLinksStatsCount ? formatMessage((0, $gYrUv.messages).genericMaxIssueLinksStatsTooltipLabel, {
        maxIssueLinksStatsCount: maxIssueLinksStatsCount
    }) : formatMessage((0, $gYrUv.messages).issueLinksTooltipLabel, {
        issueLinksCount: issueLinksCount
    });
    const renderTriggerButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipContent,
            testId: "issue-links-stats-business.ui.linked-issue-stats-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            testId: `issue-links-stats-business.ui.issue-links-stats-button.custom-theme-button-${issueKey}`,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            },
            isSelected: isOpen,
            onClick: onTriggerButtonClick,
            "aria-label": tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $07e882c6cc812654$var$iconButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            size: "small",
            primaryColor: isOpen ? `var(--ds-icon-accent-blue, ${(0, $PdmhA).B500})` : `var(--ds-icon, ${(0, $PdmhA).N500})`,
            label: ""
        }), issueLinksCount > maxIssueLinksStatsCount ? `${maxIssueLinksStatsCount}+` : issueLinksCount)));
    const popupRuntimeProps = (0, $eUqFw.useMemo)(()=>({
            issueId: issueId,
            issueKey: issueKey,
            onSuccessfulIssueLink: onIssueLink,
            onClose: onIssueLinkPopupClose,
            trackOriginSource: 'JWM',
            onReady: linkIssuePopupStopMetric
        }), [
        issueId,
        issueKey,
        linkIssuePopupStopMetric,
        onIssueLink
    ]);
    const contentRuntimeProps = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            issueSummary: issueSummary,
            issueId: issueId,
            issueType: issueType,
            canUserLinkIssue: isLinkingEnabled,
            onIssueUnlink: onIssueUnlink,
            onPopupClose: onPopupClose,
            maxIssuesToDisplay: $07e882c6cc812654$var$MAX_ISSUE_LINKS_COUNT,
            feedbackCollectorPrefix: feedbackCollectorPrefix,
            onReady: stopMetric,
            sourceProductType: sourceProductType,
            onIssueLinkButtonClick: onIssueLinkButtonClick,
            openIssueInNewTabOnExceedLimitClick: true
        }), [
        cloudId,
        feedbackCollectorPrefix,
        isLinkingEnabled,
        issueId,
        issueKey,
        issueSummary,
        issueType,
        onIssueLinkButtonClick,
        onIssueUnlink,
        onPopupClose,
        sourceProductType,
        stopMetric
    ]);
    const renderContent = ()=>{
        if (isLinkPopupOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "businessLinkIssuePopupEntryPoint",
            packageName: "@atlassian/jira-link-issue-popup",
            teamName: "a4t-werewolves",
            entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject,
            runtimeProps: popupRuntimeProps,
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1i7ym.IssueLinksPopupFallback), null)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            padding: "space.200",
            xcss: $07e882c6cc812654$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-issue-links-details-content",
            runtimeProps: contentRuntimeProps,
            packageName: "@atlassian/jira-issue-links-details-content",
            teamName: "A4t-Werewolves",
            errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAMh4.IssueLinksDetailsErrorFallback), {
                    callback: onPopupClose,
                    error: error,
                    testId: "issue-links-stats-business.ui.issue-links-details-popup-entrypoint-container"
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT56S.IssueLinksDetailsPopupSkeleton), {
                noPadding: true,
                smallerWidth: true,
                testId: "issue-links-stats-business.ui.skeleton-loader"
            })
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueLinksStats",
        attributes: {
            application: sourceProductType && (0, $eIp1n.getApplicationForProject)(sourceProductType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        onClick: (event)=>stopPropagationOnClick && event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        testId: "issue-links-stats-business.ui.popup",
        trigger: renderTriggerButton,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: stopPropagationOnClick,
        label: formatMessage((0, $gYrUv.messages).issueLinksPopup)
    })));
};
const $07e882c6cc812654$var$iconButtonStyles = (0, $1ZAYh.xcss)({
    padding: 'space.050',
    lineHeight: '16px'
});
const $07e882c6cc812654$var$ContainerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $c9TLT.gridSize) * 50}px`
});

});
parcelRegister("6zOB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8bd316b08fe19e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $4ZL0y = parcelRequire("4ZL0y");

var $3Ucf8 = parcelRequire("3Ucf8");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $4a8bd316b08fe19e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...rest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }, baseProps.children);
}));
$4a8bd316b08fe19e$var$Button.displayName = 'Button';
var $4a8bd316b08fe19e$export$2e2bcd8739ae039 = $4a8bd316b08fe19e$var$Button;

});

parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("heNuy", function(module, exports) {

$parcel$export(module.exports, "issueLinksDetailsContentEntryPoint", () => $83a4c3a36fc9aef2$export$ed55e17b62c0c3b0);

var $i4Bk1 = parcelRequire("i4Bk1");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $83a4c3a36fc9aef2$export$ed55e17b62c0c3b0 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("botF4")), {
        moduleId: "56ed134e"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueKey: issueKey, issueCount: issueCount, withDueDate: withDueDate, fields: fields })=>({
            queries: {
                issueLinksDetailsPopup: {
                    // policy can be updated to store-or-network once we have issue linking mutation through relay
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $i4Bk1.default,
                    variables: {
                        cloudId: cloudId,
                        issueKey: issueKey,
                        issueCount: issueCount,
                        withDueDate: withDueDate,
                        fields: fields
                    }
                }
            }
        })
});

});
parcelRegister("i4Bk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8186daeaa448c1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3911672bf59cd9c5cbbd5af9f5777951>>
 * @relayHash a08180161ec6ab9c7e11d8f628199d37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41
const $cc8186daeaa448c1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41",
        "metadata": {},
        "name": "srcAsyncIssueLinksDetailsContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $cc8186daeaa448c1$export$2e2bcd8739ae039 = $cc8186daeaa448c1$var$node;

});

parcelRegister("botF4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5xtrL');
        const value = parcelRequire('ebyPr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5xtrL").then(()=>parcelRequire('ebyPr'));
}

});


parcelRegister("1i7ym", function(module, exports) {

$parcel$export(module.exports, "IssueLinksPopupFallback", () => $1d3e922d60bd0af6$export$623aae6a1e4b8f7d);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $1d3e922d60bd0af6$export$623aae6a1e4b8f7d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $1d3e922d60bd0af6$var$linkIssuePopupFallbackStyles,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
const $1d3e922d60bd0af6$var$linkIssuePopupFallbackStyles = (0, $1ZAYh.xcss)({
    width: '360px',
    height: '342px'
});

});

parcelRegister("b03HR", function(module, exports) {

$parcel$export(module.exports, "linkIssuePopupEntryPoint", () => $f8b812f447343c01$export$537a4e334f2de676);

var $6TuD4 = parcelRequire("6TuD4");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $f8b812f447343c01$export$537a4e334f2de676 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lirnM")), {
        moduleId: "e0e327f9"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                issueLinksTypes: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $6TuD4.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("6TuD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0170b90948732f90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f031d559b6b4aa1484052708468df2c>>
 * @relayHash ef080d6ba522722031ef94e4887d4972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b
const $0170b90948732f90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v4 = {
        "kind": "ScalarField",
        "name": "outwards"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b",
            "metadata": {},
            "name": "mainAsyncIssueLinksTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0170b90948732f90$var$node.hash = "ad0bf63495377e340f30a9f1531b3f3c";
var $0170b90948732f90$export$2e2bcd8739ae039 = $0170b90948732f90$var$node;

});

parcelRegister("lirnM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dvdGb');
        const value = parcelRequire('1ZW56');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dvdGb").then(()=>parcelRequire('1ZW56'));
}

});


parcelRegister("dAMh4", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsErrorFallback", () => $3ad3f86af2cdb875$export$5489cdf86d4767fd);

var $eUqFw = parcelRequire("eUqFw");

var $JRB5w = parcelRequire("JRB5w");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxw0i = parcelRequire("dxw0i");
const $3ad3f86af2cdb875$export$5489cdf86d4767fd = ({ callback: callback, testId: testId, error: error })=>{
    callback && callback();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    showFlag({
        id: 'async-issue-links-details-entrypoint-flag',
        type: 'error',
        testId: testId,
        title: formatMessage((0, $dxw0i.messages).issueLinksDetailsErrorFlagTitle),
        description: formatMessage((0, $dxw0i.messages).issueLinksDetailsErrorFlagDescription),
        isAutoDismiss: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
        task: 'viewIssueLinksDetailsPopup',
        isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
    });
    // need to return an empty fragment as entrypoint fallback prop only accept ((props: { error: Error }) => ReactElement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});
parcelRegister("dxw0i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $707ffb590fb8f909$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $707ffb590fb8f909$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueLinksDetailsErrorFlagTitle: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-title",
        "defaultMessage": "We couldn't load your data"
    },
    issueLinksDetailsErrorFlagDescription: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-description",
        "defaultMessage": "Refresh the page and try again, or contact your admin."
    }
});

});


parcelRegister("bT56S", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupSkeleton", () => $3edef41f2835460f$export$c2d4e4e846447365);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3edef41f2835460f$export$c2d4e4e846447365 = ({ testId: testId, smallerWidth: smallerWidth, noPadding: noPadding = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        xcss: smallerWidth ? $3edef41f2835460f$var$smallerWidthStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        inline: noPadding ? 'space.200' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        width: "100%",
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        width: "100%",
        hasIcon: true
    })));
const $3edef41f2835460f$var$smallerWidthStyles = (0, $1ZAYh.xcss)({
    width: '80%'
});

});

parcelRegister("gYrUv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $58c9180c0c47af76$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $58c9180c0c47af76$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueLinksTooltipLabel: {
        "id": "issue-links-stats-business.issue-links-tooltip-label",
        "defaultMessage": "{issueLinksCount} linked {issueLinksCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabel: {
        "id": "issue-links-stats-business.generic-max-issue-links-stats-tooltip-label",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksPopup: {
        "id": "issue-links-stats-business.issue-links-popup",
        "defaultMessage": "Linked issues pop up"
    }
});

});





parcelRegister("3wfag", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cba0860f611197b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hsCsM = parcelRequire("hsCsM");

var $gIx2f = parcelRequire("gIx2f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2vRZq = parcelRequire("2vRZq");

var $kySwt = parcelRequire("kySwt");
const $9cba0860f611197b$var$INLINE_CREATE_TRIGGER_OFFSET = 12;
const $9cba0860f611197b$var$InlineSiblingCreate = ({ group: group, isTopMost: isTopMost, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const inlineCreateProps = (0, $2vRZq.useInlineCreateProps)({
        group: group,
        rankBeforeIssue: issue
    });
    // prevents onBlur from being called before the click event is finished
    const handleTriggerMouseDown = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const openSiblingCreate = (0, $eUqFw.useCallback)(()=>toggleSiblingCreateForm(issue.id), [
        issue.id,
        toggleSiblingCreateForm
    ]);
    const closeSiblingCreate = (0, $eUqFw.useCallback)(()=>toggleSiblingCreateForm(null), [
        toggleSiblingCreateForm
    ]);
    return isSiblingCreateFormOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9cba0860f611197b$var$inlineFormWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        ...inlineCreateProps,
        location: "boardSibling",
        onBlur: closeSiblingCreate
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hsCsM.default), {
        direction: "row",
        onClick: openSiblingCreate,
        onMouseDown: handleTriggerMouseDown,
        label: formatMessage((0, $kySwt.default).createSiblingIssue),
        offset: $9cba0860f611197b$var$INLINE_CREATE_TRIGGER_OFFSET,
        position: isTopMost ? 1 : -2
    });
};
var $9cba0860f611197b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9cba0860f611197b$var$InlineSiblingCreate);
const $9cba0860f611197b$var$inlineFormWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("hsCsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80ad28b2aa0af0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bkIGg = parcelRequire("bkIGg");

var $8cU5f = parcelRequire("8cU5f");
const $b80ad28b2aa0af0b$var$BUTTON_SIZE = 24;
const $b80ad28b2aa0af0b$var$DIVIDER_SIZE = 2;
const $b80ad28b2aa0af0b$var$ROW = 'row';
const $b80ad28b2aa0af0b$var$COLUMN = 'column';
const $b80ad28b2aa0af0b$var$InlineCreateTrigger = ({ direction: direction, label: label, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onMouseUp: onMouseUp, forceVisibility: forceVisibility = false, parentSize: parentSize = '100%', position: position = 0, offset: offset = 0 })=>{
    const [isButtonHovered, setIsButtonHovered] = (0, $eUqFw.useState)(false);
    const handleMouseEnterButton = (0, $eUqFw.useCallback)((event)=>{
        onMouseEnter && onMouseEnter(event);
        setIsButtonHovered(true);
    }, [
        onMouseEnter
    ]);
    const handleMouseLeaveButton = (0, $eUqFw.useCallback)((event)=>{
        onMouseLeave && onMouseLeave(event);
        setIsButtonHovered(false);
    }, [
        onMouseLeave
    ]);
    const Container = (0, $eUqFw.useMemo)(()=>direction === $b80ad28b2aa0af0b$var$ROW ? $b80ad28b2aa0af0b$var$RowContainer : $b80ad28b2aa0af0b$var$ColumnContainer, [
        direction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
        isButtonHovered: isButtonHovered,
        forceVisibility: forceVisibility,
        parentSize: typeof parentSize === 'number' ? `${parentSize}px` : parentSize,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b80ad28b2aa0af0b$var$TriggerButton, {
        "data-testid": "business-inline-create-trigger.ui.trigger-button",
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseEnter: handleMouseEnterButton,
        onMouseLeave: handleMouseLeaveButton,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: label,
        size: "medium"
    }))));
};
var $b80ad28b2aa0af0b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b80ad28b2aa0af0b$var$InlineCreateTrigger);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b80ad28b2aa0af0b$var$RowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $9t7rW.default)(__cmplp.parentSize),
            "--_1htntus": (0, $9t7rW.default)(__cmplp.offset, "px"),
            "--_1gjsdub": (0, $9t7rW.default)(`${__cmplp.position - $b80ad28b2aa0af0b$var$BUTTON_SIZE * 0.5}px`),
            "--_s3bx6z": (0, $9t7rW.default)(`-${__cmplp.offset}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1kze _1e0c1txw _4cvr1h6o _4t3i1tcg _kqswstnw _154i1wab _1ltvd2z4 _v5641w7c _aetrb3bt _1hfkc6ar _1qdgyh40 _qc5o11zv _z0ai1osq _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_1bsbzgxw" : "_1bsb1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $b80ad28b2aa0af0b$var$ColumnContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $9t7rW.default)(__cmplp.parentSize),
            "--_1htntus": (0, $9t7rW.default)(__cmplp.offset, "px"),
            "--_s3bx6z": (0, $9t7rW.default)(`-${__cmplp.offset}px`),
            "--_1gjsdub": (0, $9t7rW.default)(`${__cmplp.position - $b80ad28b2aa0af0b$var$BUTTON_SIZE * 0.5}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1kze _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1tcg _kqswstnw _154id2z4 _1ltv1wab _v5641w7c _aetrb3bt _1hfkc6ar _1qdg1osq _qc5o11zv _z0aiyh40 _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_4t3izgxw" : "_4t3i1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $b80ad28b2aa0af0b$var$TriggerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1ehn _19ith6cr _11q71bhr _80omtlke _2rko1sit _n7dw1ghs _1lwi1ghs _jomr12yw _irr312yw _nt751r31 _1dit1r31 _49pcglyw _ksodglyw _1hvw1o36 _4hz81o36",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gIx2f", function(module, exports) {

$parcel$export(module.exports, "CARD_APPEARANCE", () => $4f781e23a9165d0b$export$2e234a0f40160716);
$parcel$export(module.exports, "ROW_APPEARANCE", () => $4f781e23a9165d0b$export$e99c52f52501386d);
$parcel$export(module.exports, "default", () => $4f781e23a9165d0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $hw2eW = parcelRequire("hw2eW");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $5JgJ2 = parcelRequire("5JgJ2");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $l4rzg = parcelRequire("l4rzg");

var $auegK = parcelRequire("auegK");

var $d3C6e = parcelRequire("d3C6e");

var $kTIhq = parcelRequire("kTIhq");

var $fkT5k = parcelRequire("fkT5k");
const $4f781e23a9165d0b$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $4f781e23a9165d0b$export$2e234a0f40160716 = 'CARD';
const $4f781e23a9165d0b$export$e99c52f52501386d = 'ROW';
const $4f781e23a9165d0b$var$LINK = 'link';
const $4f781e23a9165d0b$var$ISSUE_TYPE = 'issueType';
const $4f781e23a9165d0b$var$useExperience = (location)=>(0, $eUqFw.useMemo)(()=>{
        let experienceId;
        switch(location){
            case 'listFooter':
            case 'listSibling':
            case 'listGroup':
            case 'listHierarchy':
                experienceId = 'list';
                break;
            case 'boardFooter':
            case 'boardSibling':
                experienceId = 'board';
                break;
            case 'calendarDate':
                experienceId = 'calendar';
                break;
            case 'timelineFooter':
            case 'timelineSibling':
            case 'timelineHierarchy':
                experienceId = 'timeline';
                break;
            default:
                throw new Error(`Unknown location ${location}`);
        }
        return {
            ...(0, $l4rzg.CREATE_ISSUE_EXPERIENCE),
            experienceId: experienceId
        };
    }, [
        location
    ]);
const $4f781e23a9165d0b$var$Option = ({ children: children, ...props })=>{
    if (props.data.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionWrapper, {
        "data-testid": "business-issue-create.ui.inline-create-form.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$OptionTypeIcon, {
        src: props.data.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL,
        alt: ""
    }), children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ExtraLinksGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledLink, {
        href: props.data.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, children)));
};
const $4f781e23a9165d0b$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $4f781e23a9165d0b$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $4f781e23a9165d0b$var$InlineCreateForm = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const project = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [filter] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const [sorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    const [preferredIssueTypeId, savePreferredIssueTypeId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.CREATE_TYPE_ID_PREFERENCE));
    const showSuccessFlag = filter != null || sorting != null;
    const experience = $4f781e23a9165d0b$var$useExperience(location);
    const startExperience = (0, $4G5xU.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)(experience);
    const markExperienceFail = (0, $4G5xU.useExperienceFail)(experience);
    const abortExperience = (0, $4G5xU.useExperienceAbort)(experience);
    const issueTypeOptions = (0, $eUqFw.useMemo)(()=>{
        const validIssueTypes = issueTypes.filter((issueType)=>{
            const isAllowed = allowedIssueTypeIds?.includes(issueType.id) ?? true;
            return isAllowed && issueType.hierarchyLevel >= minHierarchyLevel && issueType.hierarchyLevel <= maxHierarchyLevel;
        });
        const typeOptions = validIssueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                issueType: issueType,
                optionType: $4f781e23a9165d0b$var$ISSUE_TYPE
            }));
        typeOptions.sort(// sort by decreasing hierarchy level
        (a, b)=>b.issueType.hierarchyLevel - a.issueType.hierarchyLevel);
        return typeOptions;
    }, [
        allowedIssueTypeIds,
        issueTypes,
        maxHierarchyLevel,
        minHierarchyLevel
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        const canManageTypes = project.permissions.administerProject;
        const manageIssueTypesLink = (0, $hw2eW.getIssueTypesSettingsUrl)(project.key, project.isSimplified);
        let manageTypesOption = null;
        if (canManageTypes) {
            manageTypesOption = {
                label: formatMessage((0, $kTIhq.default).manageIssueTypes),
                value: manageIssueTypesLink,
                url: manageIssueTypesLink,
                optionType: $4f781e23a9165d0b$var$LINK
            };
            return [
                ...issueTypeOptions,
                manageTypesOption
            ];
        }
        return [
            ...issueTypeOptions
        ];
    }, [
        formatMessage,
        issueTypeOptions,
        project
    ]);
    const { summaryRef: summaryRef, submit: submit, blur: blur } = (0, $d3C6e.useCreateIssue)(onSubmit, onBlur);
    const [selectedType, setSelectedType] = (0, $eUqFw.useState)(()=>{
        if (preferredIssueTypeId) {
            const defaultIssueType = issueTypeOptions.find((issueType)=>issueType.value === preferredIssueTypeId);
            if (defaultIssueType) return defaultIssueType;
        } // Returns the first issue type with hierarchy level of zero if there is no last used issue type
        if (minHierarchyLevel === 0) return issueTypeOptions.find((option)=>option.issueType.hierarchyLevel === 0) ?? options[0];
        return options[0];
    });
    const [textContent, setTextContent] = (0, $eUqFw.useState)(summaryRef.current);
    summaryRef.current = textContent;
    const formRef = (0, $eUqFw.useRef)(null);
    const popperRef = (0, $eUqFw.useRef)(null);
    const isEmptyRef = (0, $eUqFw.useRef)(true);
    const textAreaRef = (0, $eUqFw.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0;
    const handleCreateIssue = ()=>{
        if (!isEmptyRef.current && selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
            const issueType = issueTypes.find((type)=>type.id === selectedType.value);
            startExperience();
            const result = submit({
                input: {
                    summary: textContent.trim(),
                    projectId: String(project.id),
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueType: issueType,
                    ...onPrepareIssueContext?.()
                },
                fieldIdsToReturn: fieldIdsToReturn,
                location: location,
                showSuccessFlag: showSuccessFlag
            });
            setTextContent('');
            result.promise.then(()=>markExperienceSuccess()).catch((error)=>{
                if (error instanceof (0, $auegK.CancelledError)) abortExperience('User cancelled');
                else markExperienceFail('Failed to create issue', error);
            });
        }
    };
    const handleCreateIssueRef = (0, $eUqFw.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue; // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $4f781e23a9165d0b$export$35cad9398ceaeef0();
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inPopper = popperRef.current?.contains(event.target) ?? false;
        if (!inForm && !inPopper) {
            handleCreateIssueRef.current();
            blur();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                location: location,
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        isReadyRef,
        blur,
        createAnalyticsEvent,
        location
    ]); // PopupSelectTriggerProps is not exported from @atlaskit/select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueTypeButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledButton, {
            ...triggerProps,
            "aria-label": formatMessage((0, $kTIhq.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , {
                src: selectedType.issueType.avatarUrl ?? undefined,
                alt: "",
                height: 16,
                width: 16
            }),
            iconAfter: isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$ChevronDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            }),
            spacing: "compact",
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger"
        }, !isCompact && selectedType.label);
    (0, $eUqFw.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('click', handleBlur, true);
        return ()=>{
            document.removeEventListener('click', handleBlur, true);
        };
    }, [
        handleBlur
    ]); // this is not a scenario we expect to happen but we know it does happen when a project is just created
    // the issue types and fields have a retry mechanism to avoid this but we want to handle it here as well
    // to avoid runtime errors
    if (issueTypes.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$FullContent, {
        appearance: appearance,
        borderRadius: borderRadius,
        indent: indent,
        minHeight: minHeight,
        onKeyDown: (event)=>{
            event.stopPropagation();
            if (event.key === 'Escape' && !$4f781e23a9165d0b$var$isComposing(event)) {
                blur();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    location: location,
                    formEmpty: isEmptyRef.current,
                    escapeKeyPressed: true
                });
            }
        },
        onSubmit: (event)=>{
            event.preventDefault();
            handleCreateIssue();
        },
        ref: formRef
    }, appearance === $4f781e23a9165d0b$export$e99c52f52501386d && !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$IssueTypeIcon, {
        alt: "" // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ,
        src: selectedType.issueType.avatarUrl ?? $4f781e23a9165d0b$var$GENERIC_ICON_URL
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledTextArea, {
        appearance: appearance,
        autoFocus: true,
        "data-testid": "business-issue-create.ui.inline-create-form.textarea",
        maxLength: (0, $3b526ddeb90a4d89$export$193356664cd84c83),
        onChange: (event)=>{
            const content = event.target.value.replace(/[\n\r]+/g, ' ');
            setTextContent(content);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' && !$4f781e23a9165d0b$var$isComposing(event)) {
                event.preventDefault();
                handleCreateIssue();
            }
        },
        placeholder: formatMessage((0, $kTIhq.default).placeholderText),
        value: textContent,
        ref: textAreaRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$Footer, {
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        onMenuOpen: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'select opened', 'inlineCreateIssueTypes', {
                location: location
            });
        },
        components: {
            Option: $4f781e23a9165d0b$var$Option
        },
        searchThreshold: 10,
        options: options,
        onChange: (option)=>{
            if (option?.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE) {
                setSelectedType(option);
                savePreferredIssueTypeId(option.value);
            }
        },
        popperProps: {
            strategy: popperStrategy,
            innerRef: popperRef
        },
        value: selectedType,
        target: ({ isOpen: isOpen, ...triggerProps })=>isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: selectedType.label
            }, issueTypeButton(triggerProps)) : issueTypeButton(triggerProps)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fkT5k.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $4f781e23a9165d0b$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        }
    }, formatMessage((0, $kTIhq.default).createButton))));
};
const $4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary = (props)=>{
    const experience = $4f781e23a9165d0b$var$useExperience(props.location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: experience,
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f781e23a9165d0b$var$InlineCreateForm, props));
};
const $4f781e23a9165d0b$var$genericMemo = (0, $eUqFw.memo);
var $4f781e23a9165d0b$export$2e2bcd8739ae039 = $4f781e23a9165d0b$var$genericMemo($4f781e23a9165d0b$var$InlineCreateFormWithErrorBoundary);
const $4f781e23a9165d0b$var$lineHeight = 20; // margin: '0px' is needed to override the default margin of the form element
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$FullContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, appearance: appearance, indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_a70prk": (0, $9t7rW.default)(__cmplp.borderRadius ?? "var(--ds-border-radius, 3px)"),
            "--_jfgeee": (0, $9t7rW.default)(__cmplp.minHeight ?? '40px'),
            "--_10qudx8": (0, $9t7rW.default)(__cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && 'center'),
            "--_gg0ene": (0, $9t7rW.default)(__cmplp.indent)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _bfhkvuon _v56416gf _16qshqll _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _2rko7ebt _1tkej4pn _4cvrnb98 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d ? "_4t3i1ylp" : "_4t3i53f4",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 && "_ca0qu2gc _n3tdu2gc",
            __cmplp.indent && "_19bv2uct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41b66 _14zgglyw _bfhkvuon _syaz1fxt _ect41wi2 _1wybdlk8 _vwz4gktf _1idr1wmz _1wfakb7n",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_4t3i1ylp" : "_4t3igktf",
            __cmplp.appearance === $4f781e23a9165d0b$export$e99c52f52501386d && "_o572qvpr _1fjgglyw _1cicglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _4cvr1h6o",
            __cmplp.appearance === $4f781e23a9165d0b$export$2e234a0f40160716 ? "_1bah1yb4" : "_1bahh9n0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$OptionTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ExtraLinksGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$IssueTypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsbpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f781e23a9165d0b$var$ChevronDownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s83jz8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $7ldaw = parcelRequire("7ldaw");

var $bKJfr = parcelRequire("bKJfr");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.openMenu('first') : this.selectRef.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $5wCDk.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, {
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    onMenuClose: ()=>{
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        props.onMenuClose?.();
                    },
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = undefined;
const $eb73e877c5661200$var$packageVersion = undefined;
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "1sujbl1",
    styles: "margin-inline-end:var(--ds-space-025, 2px);text-align:center;width:32px"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});



parcelRegister("hw2eW", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesSettingsUrl", () => $4a7674a4409ee541$export$b9500524016e18f0);
const $4a7674a4409ee541$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

const $3b526ddeb90a4d89$export$3789e4b2a10baa2b = 'full';
const $3b526ddeb90a4d89$export$db1cdb8627b81f84 = 'compact';
const $3b526ddeb90a4d89$export$aca095bc476d426f = 'simple';
const $3b526ddeb90a4d89$export$1aad44a7533f8ad8 = 'table_row';
const $3b526ddeb90a4d89$export$d2f7b3f0efb6e208 = 'hidden';
const $3b526ddeb90a4d89$export$dda6912361cddac9 = 'visible';
const $3b526ddeb90a4d89$export$565566e3df4dad53 = 'blur';
const $3b526ddeb90a4d89$export$806b905ec7df742f = 'enter';
const $3b526ddeb90a4d89$export$2bb790b9008907b4 = 'escape';
const $3b526ddeb90a4d89$export$ba9f60edfdf2e66 = 'create_button';
const $3b526ddeb90a4d89$export$3dd832bb5d8861ec = 'multi_dialog_single_create_button';
const $3b526ddeb90a4d89$export$b5288579893d806 = 'multi_dialog_multi_create_button';
const $3b526ddeb90a4d89$export$193356664cd84c83 = 255;
const $3b526ddeb90a4d89$export$f9e3e7ede9ba929d = 500;
const $3b526ddeb90a4d89$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("l4rzg", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_EXPERIENCE", () => $004447294a5330e0$export$ed625f60643a6c30);
const $004447294a5330e0$export$ed625f60643a6c30 = {
    experience: 'createIssue',
    packageName: 'jiraBusinessIssueCreate',
    teamName: 'wanjel'
};

});

parcelRegister("kTIhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef962d80dcbffe5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ef962d80dcbffe5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholderText: {
        "id": "business-issue-create.inline-create-form.placeholder-text",
        "defaultMessage": "What needs to be done?"
    },
    createButton: {
        "id": "business-issue-create.inline-create-form.create-button",
        "defaultMessage": "Create"
    },
    selectIssueTypeButton: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button",
        "defaultMessage": "Select issue type. {issueType} currently selected."
    },
    manageIssueTypes: {
        "id": "business-issue-create.inline-create-form.manage-issue-types",
        "defaultMessage": "Manage types"
    }
});

});

parcelRegister("fkT5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c337a03315092ec3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $c337a03315092ec3$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $c337a03315092ec3$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $c337a03315092ec3$var$ReturnGlyph,
        label: ""
    });
var $c337a03315092ec3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c337a03315092ec3$var$ReturnIcon);

});


parcelRegister("2vRZq", function(module, exports) {

$parcel$export(module.exports, "useInlineCreateProps", () => $4b2c7a84b9102d07$export$ecb6499077e81078);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $gIx2f = parcelRequire("gIx2f");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $1j5vW = parcelRequire("1j5vW");

var $dtXTv = parcelRequire("dtXTv");

var $lgmYa = parcelRequire("lgmYa");

var $iq40z = parcelRequire("iq40z");
const $4b2c7a84b9102d07$export$ecb6499077e81078 = ({ group: group, onAddOptimisticIssue: onAddOptimisticIssue, rankBeforeIssue: rankBeforeIssue })=>{
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const categoryFieldId = categoryField?.id;
    const { setIssues: setIssues, removeIssues: removeIssues } = (0, $dtXTv.useIssueStoreActions)();
    const fieldIdsToReturn = (0, $lgmYa.useFieldIds)();
    const transformToIssues = (0, $1j5vW.useTransformIssues)();
    const { issueTypes: issueTypes } = (0, $iq40z.useWorkflowStoreState)();
    const allowedIssueTypeIds = (0, $eUqFw.useMemo)(()=>issueTypes.map((issueType)=>issueType.id), [
        issueTypes
    ]);
    const prepareIssueContext = (0, $eUqFw.useCallback)(()=>{
        const issueContext = {};
        if (rankBeforeIssue) issueContext.rankBefore = {
            issueId: String(rankBeforeIssue.id),
            rank: rankBeforeIssue.fields[0, $ib4WI.RANK_ID].value
        };
        if (group.id === (0, $ib4WI.NULL_GROUP_KEY)) return issueContext;
        switch(group.type){
            case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                issueContext.assignee = {
                    accountId: group.id,
                    avatarUrl: group.imageUrl ?? '',
                    displayName: group.name
                };
                break;
            case 0, $jGcn0.GROUP_BY_PRIORITY:
                issueContext.priority = {
                    iconUrl: group.imageUrl ?? '',
                    name: group.name,
                    priorityId: group.id
                };
                break;
            case 0, $jGcn0.GROUP_BY_CATEGORY:
                issueContext.category = {
                    color: group.color || '',
                    optionId: group.id,
                    value: group.name
                };
                break;
            case 0, $jGcn0.GROUP_BY_STATUS:
                issueContext.status = {
                    name: group.name,
                    statusCategoryId: group.statusCategoryId,
                    statusId: group.id
                };
                break;
            default:
                break;
        }
        return issueContext;
    }, [
        group,
        rankBeforeIssue
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        const optimisticIssue = {
            id: optimisticIssuePayload.issueId,
            coverMedia: null,
            fields: {
                [(0, $ib4WI.ISSUE_TYPE_ID)]: {
                    id: optimisticIssuePayload.issueType.id,
                    fieldId: (0, $lO4Or.ISSUE_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
                    issueType: {
                        id: optimisticIssuePayload.issueType.id,
                        name: optimisticIssuePayload.issueType.name,
                        iconUrl: optimisticIssuePayload.issueType.avatarUrl ?? '',
                        hierarchyLevel: optimisticIssuePayload.issueType.hierarchyLevel
                    }
                },
                [(0, $ib4WI.ISSUE_KEY_ID)]: {
                    fieldId: (0, $lO4Or.ISSUE_KEY_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: ''
                },
                [(0, $ib4WI.STATUS_ID)]: {
                    fieldId: (0, $lO4Or.STATUS_TYPE),
                    status: {
                        id: optimisticIssuePayload.status?.statusId ?? '',
                        name: optimisticIssuePayload.status?.name ?? '',
                        statusCategoryId: optimisticIssuePayload.status?.statusCategoryId ?? 2
                    },
                    type: (0, $ib4WI.BOARD_FIELD_STATUS),
                    value: optimisticIssuePayload.status?.statusId ?? '0'
                },
                [(0, $ib4WI.SUMMARY_ID)]: {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.summary
                },
                [(0, $ib4WI.RANK_ID)]: {
                    fieldId: '',
                    type: (0, $ib4WI.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.rank ?? 'z'
                }
            },
            subtaskMetadata: {
                done: 0,
                total: 0
            }
        };
        if (optimisticIssuePayload.assignee) optimisticIssue.fields[0, $ib4WI.ASSIGNEE_ID] = {
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            type: (0, $ib4WI.BOARD_FIELD_USER),
            value: optimisticIssuePayload.assignee.accountId,
            user: {
                accountId: optimisticIssuePayload.assignee.accountId,
                avatarURL: optimisticIssuePayload.assignee.avatarUrl,
                name: optimisticIssuePayload.assignee.displayName
            }
        };
        if (optimisticIssuePayload.priority) optimisticIssue.fields[0, $ib4WI.PRIORITY_ID] = {
            fieldId: (0, $lO4Or.PRIORITY_TYPE),
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            value: optimisticIssuePayload.priority.priorityId,
            priority: {
                id: optimisticIssuePayload.priority.priorityId,
                iconUrl: optimisticIssuePayload.priority.iconUrl,
                name: optimisticIssuePayload.priority.name
            }
        };
        if (optimisticIssuePayload.category && categoryFieldId) optimisticIssue.fields[0, $ib4WI.CATEGORY_ID] = {
            fieldId: categoryFieldId,
            type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
            value: optimisticIssuePayload.category.optionId,
            category: {
                color: optimisticIssuePayload.category.color,
                name: group.name
            }
        };
        setIssues([
            optimisticIssue
        ]);
        onAddOptimisticIssue?.();
        let createdBoardItem;
        try {
            createdBoardItem = await promise;
        } catch (e) {
        // swallow error
        }
        if (createdBoardItem) {
            const issues = transformToIssues([
                createdBoardItem
            ]);
            setIssues(issues);
        }
        removeIssues([
            optimisticIssue.id
        ]);
    }, [
        categoryFieldId,
        setIssues,
        onAddOptimisticIssue,
        removeIssues,
        group.name,
        transformToIssues
    ]);
    return {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: (0, $gIx2f.CARD_APPEARANCE),
        fieldIdsToReturn: fieldIdsToReturn,
        onPrepareIssueContext: prepareIssueContext,
        onSubmit: handleSubmit
    };
};

});

parcelRegister("kySwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5050b008cfd6144a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5050b008cfd6144a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSiblingIssue: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("1kaEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb14cd82ffd46db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $cSu9v = parcelRequire("cSu9v");

var $9drmE = parcelRequire("9drmE");

var $1zSxm = parcelRequire("1zSxm");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $41WOo = parcelRequire("41WOo");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4W8Fw = parcelRequire("4W8Fw");
var $3hjaO = parcelRequire("3hjaO");
var $fkLhx = parcelRequire("fkLhx");

var $ib4WI = parcelRequire("ib4WI");

var $lUpP3 = parcelRequire("lUpP3");

var $gWYTK = parcelRequire("gWYTK");

var $lnmSR = parcelRequire("lnmSR");

var $cgK6s = parcelRequire("cgK6s");

var $iq40z = parcelRequire("iq40z");

var $9PJYX = parcelRequire("9PJYX");

var $bVeLr = parcelRequire("bVeLr");

var $1VNWp = parcelRequire("1VNWp");

var $lELme = parcelRequire("lELme");
const $beb14cd82ffd46db$var$renderTransitionInfoOverlay = (sourceGroup, targetGroup)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$TransitionInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: (0, $8Qd0L.statusCategoryForId)(sourceGroup.statusCategoryId),
        name: sourceGroup.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: (0, $8Qd0L.statusCategoryForId)(targetGroup.statusCategoryId),
        name: targetGroup.name
    }));
const $beb14cd82ffd46db$var$ColumnHeader = ({ dragHandleRef: dragHandleRef, group: group, isCardOverColumn: isCardOverColumn, isDragPreview: isDragPreview, isDropDisabled: isDropDisabled, issueCount: issueCount })=>{
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const workflowOperationStatusId = (0, $cgK6s.useWorkflowOperationStatusId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sourceGroup: sourceGroup, dropTarget: { transition: transition } } = (0, $gWYTK.useCardDragDrop)();
    const { isCollapsed: isCollapsed, toggleCollapse: toggleCollapse } = (0, $lnmSR.useExpandCollapse)(group.id);
    const [isEditMode, setEditMode] = (0, $eUqFw.useState)(false);
    const project = (0, $kQAZu.useProject)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)();
    const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
    const hasMultipleWorkflows = workflows.length > 1;
    const hasExceededMaxIssueTypes = issueTypes.length > (0, $ib4WI.MAX_ISSUE_TYPES_COUNT);
    const isTeamManaged = project.isSimplified;
    const isProjectAdmin = project.permissions.administerProject;
    const { shouldRenderExperiment: automationDiscoveryEnabled } = (0, $41WOo.isAutomationDiscoveryOnBoardColumnsExperimentEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fkLhx.useJwmAutomationDiscoveryOnBoardColumnsExperiment)() : {
        shouldRenderExperiment: false
    };
    const { isAutomationDiscoveryModalOpen: isAutomationDiscoveryModalOpen, setIsAutomationDiscoveryModalOpen: setIsAutomationDiscoveryModalOpen, isTargetColumn: isTargetColumn } = automationDiscoveryEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3hjaO.useAutomationDiscoveryContext)() : {
        isTargetColumn: ()=>false,
        isAutomationDiscoveryModalOpen: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setIsAutomationDiscoveryModalOpen: ()=>{}
    };
    const shouldShowTransitionInfoOverlay = transition != null && sourceGroup?.type === (0, $jGcn0.GROUP_BY_STATUS) && group.type === (0, $jGcn0.GROUP_BY_STATUS) && isCardOverColumn && !isCollapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$Container, {
        "data-testid": "work-management-board.ui.board.column.column-header.container",
        isColumnCollapsed: isCollapsed
    }, (0, $41WOo.isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort)() && isTargetColumn(Number(group.id)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4W8Fw.AutomationDiscoveryModal), {
        isOpen: isAutomationDiscoveryModalOpen,
        setIsOpen: setIsAutomationDiscoveryModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$HeaderTitleWrapper, {
        "data-testid": "work-management-board.ui.board.column.column-header.header-title-wrapper",
        isColumnCollapsed: isCollapsed
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUpP3.default), null) : isProjectAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        "aria-hidden": true,
        xcss: $beb14cd82ffd46db$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), shouldShowTransitionInfoOverlay ? $beb14cd82ffd46db$var$renderTransitionInfoOverlay(sourceGroup, group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bVeLr.default), {
        group: group,
        isCollapsed: isCollapsed,
        issueCount: issueCount,
        isEditMode: isEditMode,
        setEditMode: setEditMode,
        hasMultipleWorkflows: hasMultipleWorkflows,
        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
    }), isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$ExpandCollapseButtonWrapper, {
        "data-component-selector": "work-management-board.ui.board.column.column-header.expand-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1zSxm))), {
            label: formatMessage((0, $lELme.default).expandButton),
            size: "medium"
        }),
        onClick: toggleCollapse,
        spacing: "none"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beb14cd82ffd46db$var$ExpandCollapseButtonWrapper, {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9drmE))), {
            label: formatMessage((0, $lELme.default).collapseButton),
            size: "medium"
        }),
        onClick: toggleCollapse
    })), isTeamManaged && group.type === (0, $jGcn0.GROUP_BY_STATUS) && !isDragPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VNWp.default), {
        isLoading: workflowOperationStatusId === group.id && isWorkflowOperationInProgress,
        hasMultipleWorkflows: hasMultipleWorkflows,
        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes,
        onRenameClick: ()=>{
            setEditMode(true);
        },
        ...(0, $41WOo.isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort)() ? {
            onOpenAutomationClick: ()=>setIsAutomationDiscoveryModalOpen(true)
        } : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PJYX.default), {
        group: group
    }))));
};
const $beb14cd82ffd46db$var$HeaderTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _vchhusvi _syaz1tgx _1e0c1txw _zulp1b66 _1bah1yb4 _1bsb1osq",
            __cmplp.isColumnCollapsed ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isColumnCollapsed ? "_1yt417pv" : "_1yt4zayo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$ExpandCollapseButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i17is _tzy411de _1bsbeudw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
            __cmplp.isColumnCollapsed ? "_4t3i1wug _1tkeidpf _1o9zkb7n _1pbycs5v" : "_4t3ickbl _1o9zidpf _1pbyegat",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$TransitionInfoContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c11p5 _wij21bp4 _1bah1e5h _17kn15vq _1hrp15vq _x3fa1l2s _10ca1q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb14cd82ffd46db$var$MenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $beb14cd82ffd46db$var$dragHandleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
var $beb14cd82ffd46db$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($beb14cd82ffd46db$var$ColumnHeader);

});
parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.793 5.793a.999.999 0 000 1.414L15.586 11H6a1 1 0 000 2h9.586l-3.793 3.793a.999.999 0 000 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 00.293-.679v-.057a.996.996 0 00-.293-.678l-5.499-5.5a1 1 0 00-1.415 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = $9601eacac1d33448$var$ArrowRightIcon;
module.exports.default = $9601eacac1d33448$var$_default;

});

parcelRegister("9drmE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b5a8df78b2a6e40$var$_react = $6b5a8df78b2a6e40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6b5a8df78b2a6e40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6b5a8df78b2a6e40$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $6b5a8df78b2a6e40$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.062 11L6.5 9.914A1 1 0 017.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 116.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0117.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 01-1.414 1.414l-2.616-2.616z" fill="currentColor"/></svg>`
    }, props));
$6b5a8df78b2a6e40$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $6b5a8df78b2a6e40$var$_default = $6b5a8df78b2a6e40$var$EditorCollapseIcon;
module.exports.default = $6b5a8df78b2a6e40$var$_default;

});

parcelRegister("1zSxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12635d47fd0b2d1a$var$_react = $12635d47fd0b2d1a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $12635d47fd0b2d1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $12635d47fd0b2d1a$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $12635d47fd0b2d1a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M18.062 11L16.5 9.914A1 1 0 1117.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 01-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 017.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 016.086 15.5L3.47 12.884z" fill="currentColor"/></svg>`
    }, props));
$12635d47fd0b2d1a$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $12635d47fd0b2d1a$var$_default = $12635d47fd0b2d1a$var$EditorExpandIcon;
module.exports.default = $12635d47fd0b2d1a$var$_default;

});

parcelRegister("4W8Fw", function(module, exports) {

$parcel$export(module.exports, "AutomationDiscoveryModal", () => $7839f74b1171ed0f$export$8a5d1f98e475d5d0);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $hQ8rq = parcelRequire("hQ8rq");
const $7839f74b1171ed0f$export$8a5d1f98e475d5d0 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $hQ8rq.AutomationDiscoveryModalEntryPoint), props);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessColumnAutomationDiscoveryExperiment",
        packageName: "jiraBusinessColumnAutomationDiscoveryExperiment",
        teamName: "program-moon",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        errorFallback: "unmount"
    });
};

});
parcelRegister("hQ8rq", function(module, exports) {

$parcel$export(module.exports, "AutomationDiscoveryModalEntryPoint", () => $8e1df120e51e08e5$export$96eae101cee6b66f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $8e1df120e51e08e5$export$96eae101cee6b66f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6xxc6")).then((module)=>module.AutomationDiscoveryModalContainer), {
        moduleId: "91de62d2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6xxc6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9IPeX')
        ]);
        const value = parcelRequire('KetJx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9IPeX")
    ]).then(()=>parcelRequire('KetJx'));
}

});



parcelRegister("lUpP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7b767a502772fc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a7b767a502772fc$var$RestrictedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7b767a502772fc$var$Graphic, {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.82452 2.57897C11.7787 2.57897 13.6529 3.35529 15.0348 4.73713C16.4166 6.11898 17.1929 7.99317 17.1929 9.94739C17.1929 11.9016 16.4166 13.7758 15.0348 15.1577C13.6529 16.5395 11.7787 17.3158 9.82452 17.3158C7.8703 17.3158 5.99611 16.5395 4.61426 15.1577C3.23241 13.7758 2.4561 11.9016 2.4561 9.94739C2.4561 7.99317 3.23241 6.11898 4.61426 4.73713C5.99611 3.35529 7.8703 2.57897 9.82452 2.57897ZM9.82452 0.473709C8.57209 0.460507 7.32946 0.695786 6.16855 1.16594C5.00763 1.63609 3.95146 2.33177 3.06115 3.21275C2.17084 4.09372 1.46406 5.1425 0.981702 6.29839C0.499342 7.45429 0.250977 8.69436 0.250977 9.94687C0.250977 11.1994 0.499342 12.4394 0.981702 13.5953C1.46406 14.7512 2.17084 15.8 3.06115 16.681C3.95146 17.562 5.00763 18.2576 6.16855 18.7278C7.32946 19.1979 8.57209 19.4332 9.82452 19.42C12.3371 19.42 14.7468 18.4219 16.5234 16.6452C18.3001 14.8686 19.2982 12.4589 19.2982 9.94634C19.2982 7.43376 18.3001 5.02409 16.5234 3.24743C14.7468 1.47077 12.3371 0.472656 9.82452 0.472656V0.473709Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3.68457 5.09375L15.0656 16.4695L16.9856 14.7474L5.40352 3.15796C5.43299 3.18954 3.68457 5.09375 3.68457 5.09375Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4a7b767a502772fc$var$Graphic = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
var $4a7b767a502772fc$export$2e2bcd8739ae039 = $4a7b767a502772fc$var$RestrictedIcon;

});

parcelRegister("9PJYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1561e8a8664387$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iLiDV = parcelRequire("iLiDV");

var $116rm = parcelRequire("116rm");
const $4b1561e8a8664387$var$isStatusGroup = (group)=>group.type === (0, $jGcn0.GROUP_BY_STATUS);
const $4b1561e8a8664387$var$entryPointParams = {};
const $4b1561e8a8664387$var$ColumnConfettiAsync = ({ group: group })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $116rm.boardConfettiEntrypoint), $4b1561e8a8664387$var$entryPointParams);
    const [animating, setAnimating] = (0, $eUqFw.useState)(false);
    const { confettiColumns: confettiColumns, removeConfettiColumn: removeConfettiColumn } = (0, $iLiDV.useConfettiColumns)();
    const showConfetti = (0, $iLiDV.matchConfettiColumn)(group.name) || $4b1561e8a8664387$var$isStatusGroup(group) && group.statusCategoryId === (0, $8Qd0L.StatusCategoryIds).done;
    (0, $eUqFw.useEffect)(()=>{
        if (confettiColumns.has(group.id)) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'boardConfetti created', {
                columnType: (0, $iLiDV.matchConfettiColumn)(group.name) ? 'emoji' : 'done',
                columnId: group.id
            });
            setAnimating(true);
            removeConfettiColumn(group.id);
        }
    }, [
        confettiColumns,
        createAnalyticsEvent,
        group.id,
        group.name,
        removeConfettiColumn
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (animating) entryPointActions.load();
    }, [
        animating,
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onConfettiComplete: ()=>setAnimating(false)
        }), [
        setAnimating
    ]);
    if (!showConfetti || !animating) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jwm-board-confetti",
        packageName: "jiraWorkManagementBoard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: runtimeProps
    });
};
var $4b1561e8a8664387$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4b1561e8a8664387$var$ColumnConfettiAsync);

});
parcelRegister("116rm", function(module, exports) {

$parcel$export(module.exports, "boardConfettiEntrypoint", () => $12c7cffc509e28bb$export$1495ab1cfa22b397);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $12c7cffc509e28bb$export$1495ab1cfa22b397 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8z4XG")), {
        moduleId: "58031bc6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8z4XG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eVlda');
        const value = parcelRequire('72WXl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eVlda").then(()=>parcelRequire('72WXl'));
}

});



parcelRegister("bVeLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f9ca4ed94e88e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $gjzML = parcelRequire("gjzML");

var $MxsGB = parcelRequire("MxsGB");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $cgK6s = parcelRequire("cgK6s");

var $4i4ee = parcelRequire("4i4ee");

var $lN7up = parcelRequire("lN7up");

var $3cUPp = parcelRequire("3cUPp");
const $81f9ca4ed94e88e9$var$HeaderContent = ({ group: group, isCollapsed: isCollapsed, issueCount: issueCount, isEditMode: isEditMode, setEditMode: setEditMode, hasMultipleWorkflows: hasMultipleWorkflows, hasExceededMaxIssueTypes: hasExceededMaxIssueTypes })=>{
    const project = (0, $kQAZu.useProject)();
    const [headerName, setHeaderName] = (0, $eUqFw.useState)(null);
    const { renameColumn: renameColumn, validateRename: validateRename } = (0, $4i4ee.useRenameColumn)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const isTeamManaged = project.isSimplified;
    const isProjectAdmin = project.permissions.administerProject;
    (0, $eUqFw.useEffect)(()=>{
        setHeaderName(group.name);
    }, [
        group.name
    ]);
    const getColumnName = (0, $eUqFw.useCallback)((message)=>group.id === (0, $ib4WI.NULL_GROUP_KEY) ? formatMessage(message) : group.name, [
        formatMessage,
        group.id,
        group.name
    ]);
    const headerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, {
        [(0, $jGcn0.GROUP_BY_STATUS)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$WritingModeWrapper, {
            isVerticalWritingMode: isCollapsed
        }, group.type === (0, $jGcn0.GROUP_BY_STATUS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
            name: headerName ?? group.name,
            category: (0, $8Qd0L.statusCategoryForId)(group.statusCategoryId)
        })),
        [(0, $jGcn0.GROUP_BY_PRIORITY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.type === (0, $jGcn0.GROUP_BY_PRIORITY) && group.imageUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$Image, {
            alt: "",
            draggable: false,
            src: group.imageUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$ColumnName, {
            isVerticalWritingMode: isCollapsed
        }, getColumnName((0, $3cUPp.default).noPriority))),
        [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.id === (0, $ib4WI.NULL_GROUP_KEY) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "circle",
            src: "",
            size: "small"
        }) : group.type === (0, $jGcn0.GROUP_BY_ASSIGNEE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            avatarUrl: group.imageUrl ?? '',
            name: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$ColumnName, {
            isVerticalWritingMode: isCollapsed
        }, getColumnName((0, $3cUPp.default).noAssignee))),
        [(0, $jGcn0.GROUP_BY_CATEGORY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, group.type === (0, $jGcn0.GROUP_BY_CATEGORY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$WritingModeWrapper, {
            isVerticalWritingMode: isCollapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
            categoryName: getColumnName((0, $3cUPp.default).noCategory),
            categoryColor: group.color
        })))
    }[group.type], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$IssueCount, {
        isVerticalWritingMode: isCollapsed
    }, issueCount));
    const shouldRenderReadOnly = !isTeamManaged || !isProjectAdmin || hasMultipleWorkflows || group.type !== (0, $jGcn0.GROUP_BY_STATUS) || isWorkflowOperationInProgress || hasExceededMaxIssueTypes;
    return shouldRenderReadOnly || isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$HeaderContentWrapper, {
        isColumnCollapsed: isCollapsed
    }, headerContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$EditableColumnHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lN7up.default), {
        defaultValue: group.name,
        isEditing: isEditMode,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81f9ca4ed94e88e9$var$HeaderContentWrapper, null, headerContent),
        onCancel: ()=>setEditMode(false),
        onConfirm: async (newName)=>{
            setEditMode(false);
            setHeaderName(newName);
            await renameColumn({
                oldName: group.name,
                newName: newName,
                statusId: Number(group.id)
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnRenameInlineEdit confirmed', 'jwmBoardColumnRename');
        },
        onEdit: ()=>{
            setEditMode(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnHeader clicked', 'jwmBoardColumnRenameFromTitle', {
                isProjectAdmin: isProjectAdmin,
                hasMultipleWorkflows: hasMultipleWorkflows,
                hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
            });
        },
        onValidate: (newName)=>validateRename({
                oldName: group.name,
                newName: newName
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$WritingModeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9idpf _1tkeidpf",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$HeaderContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showDisabledCursor: showDisabledCursor, isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _zulpu2gc _1ul9idpf _1tkeidpf",
            __cmplp.showDisabledCursor ? "_80om13gf" : "_80om1kw7",
            __cmplp.isColumnCollapsed ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isColumnCollapsed ? "_1yt41530" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$EditableColumnHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _1ul9idpf _2iu91osq _d8r5idpf _104v1r31 _1m7fglyw _o6xs1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _s7n41ndm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$ColumnName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1ul9idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $81f9ca4ed94e88e9$var$IssueCount = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
});
var $81f9ca4ed94e88e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($81f9ca4ed94e88e9$var$HeaderContent);

});
parcelRegister("4i4ee", function(module, exports) {

$parcel$export(module.exports, "useRenameColumn", () => $bee1df1b0c862743$export$9c7aed67d23909ba);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $46lXM = parcelRequire("46lXM");

var $fPXdd = parcelRequire("fPXdd");
var $46y1c = parcelRequire("46y1c");

var $bFk6h = parcelRequire("bFk6h");

var $iq40z = parcelRequire("iq40z");

var $cgK6s = parcelRequire("cgK6s");

var $iONAM = parcelRequire("iONAM");

var $9dl5u = parcelRequire("9dl5u");
const $bee1df1b0c862743$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
const $bee1df1b0c862743$export$9c7aed67d23909ba = ()=>{
    const { columns: columns } = (0, $iq40z.useWorkflowStoreState)();
    const startRenameOperation = (0, $cgK6s.useStartRenameOperation)();
    const stopWorkflowOperationInProgress = (0, $cgK6s.useStopWorkflowOperationInProgress)();
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $46y1c.useWorkflowsV2)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const project = (0, $kQAZu.useProject)();
    const { refetch: refetchBoardData } = (0, $bFk6h.useBoardData)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    /**
   * @returns undefined if it is valid, otherwise return string that will be used as error message
   * this is a pattern used by atlaskit form field validation or inline edit
   */ const validateRename = (0, $eUqFw.useCallback)(({ oldName: oldName, newName: newName })=>{
        const cleanNewName = $bee1df1b0c862743$var$getCleanColumnName(newName);
        const convertedNewName = (0, $46lXM.convertStatusNameForComparison)(cleanNewName);
        if (convertedNewName === (0, $46lXM.convertStatusNameForComparison)(oldName)) return undefined;
        if (!cleanNewName.length) return formatMessage((0, $9dl5u.default).emptyColumnNameError);
        if (columns.some((column)=>(0, $46lXM.convertStatusNameForComparison)(column.name) === convertedNewName)) return formatMessage((0, $9dl5u.default).statusAlreadyExists, {
            statusName: cleanNewName
        });
    }, [
        columns,
        formatMessage
    ]);
    const renameColumn = (0, $eUqFw.useCallback)(async ({ oldName: oldName, statusId: statusId, newName: newName })=>{
        const cleanNewName = $bee1df1b0c862743$var$getCleanColumnName(newName);
        const convertedNewName = (0, $46lXM.convertStatusNameForComparison)(cleanNewName);
        if (!cleanNewName.length || convertedNewName === (0, $46lXM.convertStatusNameForComparison)(oldName)) return;
        startRenameOperation(String(statusId));
        startExperience();
        try {
            // fetch workflow data from workflow API
            const workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: issueTypes.map((it)=>({
                        projectId: String(project.id),
                        issueTypeId: it.id
                    }))
            });
            if (workflowsData) {
                const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.hierarchyLevel === -1)?.id;
                // remove subtask workflow
                const filteredWorkflowsData = (0, $iONAM.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
                // rename the column in place
                const toRenameStatus = filteredWorkflowsData.statuses.find((s)=>s.id === statusId.toString());
                if (toRenameStatus) {
                    toRenameStatus.name = cleanNewName;
                    await validateAndUpdateWorkflowsV2({
                        cloudId: cloudId,
                        payload: {
                            payload: {
                                statuses: (0, $fPXdd.mapStatusesToStatusUpdateObjects)(workflowsData.statuses),
                                workflows: [
                                    (0, $fPXdd.mapWorkflowToWorkflowUpdateObject)(workflowsData.workflows[0])
                                ]
                            },
                            validationOptions: {
                                levels: [
                                    'ERROR'
                                ]
                            }
                        }
                    });
                    markExperienceSuccess();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const issueTypeIdNotSubtask = issueTypes.find((issueType)=>issueType.hierarchyLevel === 0)?.id;
            showFlag((0, $iONAM.getColumnActionFailedFlag)({
                messageTitle: (0, $9dl5u.default).errorFlagTitleRenameColumn,
                action: 'rename',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: project.key
            }));
            (0, $iONAM.fireColumnExperienceTracking)({
                markExperienceSuccess: markExperienceSuccess,
                markExperienceFailed: markExperienceFailed,
                error: error,
                errorMessage: 'Failed to validate and update workflow'
            });
            throw error;
        } finally{
            stopWorkflowOperationInProgress();
            refetchBoardData();
        }
    }, [
        issueTypes,
        project,
        cloudId,
        startRenameOperation,
        startExperience,
        fetchWorkflowsV2,
        validateAndUpdateWorkflowsV2,
        showFlag,
        markExperienceSuccess,
        markExperienceFailed,
        stopWorkflowOperationInProgress,
        refetchBoardData
    ]);
    return {
        renameColumn: renameColumn,
        validateRename: validateRename
    };
};

});
parcelRegister("46lXM", function(module, exports) {

$parcel$export(module.exports, "convertStatusNameForComparison", () => $ecb0dc8f975954a4$export$7e224e03b415abf8);
$parcel$export(module.exports, "validateColumnName", () => $ecb0dc8f975954a4$export$d12aef3c6fc7d2cb);

var $9F98y = parcelRequire("9F98y");
const $ecb0dc8f975954a4$export$7e224e03b415abf8 = (statusName)=>statusName.toUpperCase();
const $ecb0dc8f975954a4$export$d12aef3c6fc7d2cb = (columns, name)=>{
    if (columns.some((col)=>// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        $ecb0dc8f975954a4$export$7e224e03b415abf8(col.name) === $ecb0dc8f975954a4$export$7e224e03b415abf8(name))) return {
        isValid: false,
        message: {
            title: (0, $9F98y.default).nameIsTakenTitle,
            description: (0, $9F98y.default).nameIsTakenDescription
        }
    };
    return {
        isValid: true,
        message: null
    };
};

});
parcelRegister("9F98y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa9d69d61890527$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aaa9d69d61890527$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nameIsTakenTitle: {
        "id": "work-management-board.common.utils.validate-column-name.name-is-taken-title",
        "defaultMessage": "''{name}'' is already a status name in this project"
    },
    nameIsTakenDescription: {
        "id": "work-management-board.common.utils.validate-column-name.name-is-taken-description",
        "defaultMessage": "Give your column\u2019s status a different name."
    }
});

});


parcelRegister("fPXdd", function(module, exports) {

$parcel$export(module.exports, "mapStatusesToStatusUpdateObjects", () => $71c6bdd2142e6827$export$6ce728204936b996);
$parcel$export(module.exports, "mapWorkflowToWorkflowUpdateObject", () => $71c6bdd2142e6827$export$aab038e50114d198);
const $71c6bdd2142e6827$export$6ce728204936b996 = (statuses)=>statuses.map((s)=>({
            id: s.id,
            name: s.name,
            description: s.description,
            statusReference: s.statusReference,
            statusCategory: s.statusCategory
        }));
const $71c6bdd2142e6827$export$aab038e50114d198 = (workflow)=>({
        id: workflow.id,
        version: workflow.version,
        description: workflow.description,
        statuses: workflow.statuses.map(({ deprecated: deprecated, ...status })=>status),
        transitions: workflow.transitions,
        startPointLayout: workflow.startPointLayout,
        statusMappings: workflow.statusMappings || []
    });

});

parcelRegister("46y1c", function(module, exports) {

$parcel$export(module.exports, "useWorkflowsV2", () => $67ed7bcfbfaa5754$export$32b6f4c35d4611ee);
$parcel$export(module.exports, "StatusNameIsNotUniqueError", () => (parcelRequire("2UUg7")).StatusNameIsNotUniqueError);
$parcel$export(module.exports, "StatusHasNoIncomingTransitionError", () => (parcelRequire("2UUg7")).StatusHasNoIncomingTransitionError);
$parcel$export(module.exports, "WorkflowVersionConflictError", () => (parcelRequire("2UUg7")).WorkflowVersionConflictError);
// The Workflow V2 API is defined here: https://developer.atlassian.com/cloud/jira-workflow/rest/api-group-workflow-v-/

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $2UUg7 = parcelRequire("2UUg7");

var $fPXdd = parcelRequire("fPXdd");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $67ed7bcfbfaa5754$var$noop = ()=>{};
const $67ed7bcfbfaa5754$export$32b6f4c35d4611ee = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetchWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ cloudId: cloudId, projectAndIssueTypes: projectAndIssueTypes })=>{
        try {
            const response = await (0, $2OdyW.default)(`/gateway/api/jira/project-configuration/query/${cloudId}/2/workflow`, {
                method: 'POST',
                body: JSON.stringify({
                    projectAndIssueTypes: projectAndIssueTypes
                })
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($67ed7bcfbfaa5754$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Fetch workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchBoardWorkflowsV2',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchBoardWorkflowsV2',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Update a single workflow only
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const updateWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        try {
            const response = await (0, $2OdyW.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($67ed7bcfbfaa5754$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Update workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'updateBoardWorkflowsV2',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'updateBoardWorkflowsV2',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to update board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Validates the update payload and calls update workflow if there are no validation errors
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const validateAndUpdateWorkflowsV2 = (0, $eUqFw.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        // validate payload
        let validationResponse;
        try {
            validationResponse = await (0, $2OdyW.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update/validation`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($67ed7bcfbfaa5754$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Validate workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $7byHA.default)(error.statusCode, errorMessage, error.traceId);
                (0, $guiFP.default)({
                    meta: {
                        id: 'validateUpdateBoardWorkflowsV2',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $guiFP.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to validate payload for update workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        if (validationResponse.errors.length > 0) {
            validationResponse.errors.forEach((e)=>{
                if (e.code === (0, $4492296d973902cb$export$fca543997a327d4c)) {
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $2UUg7.StatusNameIsNotUniqueError)();
                }
                if (e.code === (0, $4492296d973902cb$export$cc9aaebfeb8efe99)) {
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $2UUg7.StatusHasNoIncomingTransitionError)();
                }
                if (e.code === (0, $4492296d973902cb$export$3bf8ed0d6cdbf43d)) throw new (0, $2UUg7.WorkflowVersionConflictError)();
            });
            const errorMsgs = validationResponse.errors.map((e)=>e.message).join(', ');
            const errorCodes = validationResponse.errors.map((e)=>e.code).join(', ');
            const errorMessage = `Validation error(s) in update workflows payload - ${errorMsgs}`;
            const error = Error(errorMessage);
            (0, $guiFP.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: errorMessage,
                    totalErrors: validationResponse.errors.length,
                    code: errorCodes
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        // update workflow
        return updateWorkflowsV2({
            payload: payload.payload,
            cloudId: cloudId
        });
    }, [
        updateWorkflowsV2,
        createAnalyticsEvent
    ]);
    return {
        fetchWorkflowsV2: fetchWorkflowsV2,
        updateWorkflowsV2: updateWorkflowsV2,
        validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2
    };
};

});
const $4492296d973902cb$export$cc9aaebfeb8efe99 = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
const $4492296d973902cb$export$fca543997a327d4c = 'NON_UNIQUE_STATUS_NAME';
const $4492296d973902cb$export$3bf8ed0d6cdbf43d = 'VERSION_CONFLICT';

parcelRegister("2UUg7", function(module, exports) {

$parcel$export(module.exports, "StatusNameIsNotUniqueError", () => $cc55e3be2b00295f$export$364f122a770d50d5);
$parcel$export(module.exports, "StatusHasNoIncomingTransitionError", () => $cc55e3be2b00295f$export$f19cc85abf8e1b56);
$parcel$export(module.exports, "WorkflowVersionConflictError", () => $cc55e3be2b00295f$export$3bcae14a5d1b7831);
/* eslint-disable max-classes-per-file */ class $cc55e3be2b00295f$export$364f122a770d50d5 extends Error {
    constructor(){
        super('status name is not unique');
        this.name = 'StatusNameIsNotUniqueError';
    }
}
class $cc55e3be2b00295f$export$f19cc85abf8e1b56 extends Error {
    constructor(){
        super('status has no incoming transition error');
        this.name = 'StatusHasNoIncomingTransitionError';
    }
}
class $cc55e3be2b00295f$export$3bcae14a5d1b7831 extends Error {
    constructor(){
        super('Workflow version and version token must match');
        this.name = 'WorkflowVersionConflictError';
    }
}

});


parcelRegister("iONAM", function(module, exports) {

$parcel$export(module.exports, "getColumnActionFailedFlag", () => $4e9bfe43c468071f$export$df77096ef246183b);
$parcel$export(module.exports, "fireColumnExperienceTracking", () => $4e9bfe43c468071f$export$a7d2bc2831e48c39);
$parcel$export(module.exports, "removeWorkflowAssociatedWithSubtaskOnly", () => $4e9bfe43c468071f$export$404cd34180e60200);

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $eo17r = parcelRequire("eo17r");
parcelRequire("46y1c");
var $2UUg7 = parcelRequire("2UUg7");

var $9elEn = parcelRequire("9elEn");
const $4e9bfe43c468071f$var$GENERIC_SAVING_ERROR = 'There was an error saving the workflows';
const $4e9bfe43c468071f$var$excludedStatusCodes = new Set([
    401,
    403,
    404,
    409
]);
const $4e9bfe43c468071f$var$isFilteredNetworkError = (error)=>Boolean('statusCode' in error && error.statusCode != null && $4e9bfe43c468071f$var$excludedStatusCodes.has(error.statusCode) || error.message?.includes($4e9bfe43c468071f$var$GENERIC_SAVING_ERROR));
const $4e9bfe43c468071f$export$df77096ef246183b = ({ messageTitle: messageTitle, action: action, error: error, projectKey: projectKey, issueTypeIdNotSubtask: issueTypeIdNotSubtask, statusCode: statusCode })=>{
    const workflowEditorHref = issueTypeIdNotSubtask != null && issueTypeIdNotSubtask !== '' ? `/jira/core/projects/${projectKey}/settings/issuetypes/${issueTypeIdNotSubtask}/workflow` : `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const openWorkflowEditorAction = {
        content: (0, $9elEn.default).openWorkflowEditorAction,
        href: workflowEditorHref,
        target: '_blank'
    };
    if (error instanceof (0, $2UUg7.StatusNameIsNotUniqueError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).statusNameIsNotUniqueDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-name-is-not-unique.flag`)
    };
    if (error instanceof (0, $2UUg7.StatusHasNoIncomingTransitionError)) return {
        type: 'error',
        title: (0, $9elEn.default).statusHasNoIncomingTransitionTitle,
        description: (0, $9elEn.default).statusHasNoIncomingTransitionDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-has-no-incoming-transition.flag`)
    };
    if (error instanceof (0, $2UUg7.WorkflowVersionConflictError) || statusCode === 409) return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).workflowVersionConflictDescription,
        actions: [
            {
                content: (0, $9elEn.default).viewWorkflowEditorAction,
                href: workflowEditorHref,
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-workflow-version-conflict.flag`)
    };
    if (action === 'delete-polling') return {
        type: 'warning',
        title: messageTitle,
        description: (0, $9elEn.default).deletePollingTimeoutDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-timeout.flag`)
    };
    return {
        type: 'error',
        title: messageTitle,
        description: (0, $9elEn.default).errorFlagDescription,
        actions: [
            {
                content: (0, $9elEn.default).errorFlagActionsRetry,
                onClick: ()=>{
                    window.location.reload();
                },
                target: '_blank'
            },
            {
                content: (0, $9elEn.default).errorFlagActionsCheckStatus,
                href: 'https://jira-work-management.status.atlassian.com/',
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-column.flag`)
    };
};
const $4e9bfe43c468071f$export$a7d2bc2831e48c39 = ({ markExperienceSuccess: markExperienceSuccess, markExperienceFailed: markExperienceFailed, error: error, errorMessage: errorMessage })=>{
    if (error instanceof (0, $2UUg7.StatusNameIsNotUniqueError) || error instanceof (0, $2UUg7.StatusHasNoIncomingTransitionError) || error instanceof (0, $2UUg7.WorkflowVersionConflictError) || (0, $JRB5w.isClientFetchError)(error) || (0, $7byHA.isValidationError)(error) || $4e9bfe43c468071f$var$isFilteredNetworkError(error)) {
        // Only marking these errors as a success, as they are handled by the flags above
        markExperienceSuccess();
        return;
    }
    markExperienceFailed(errorMessage, error);
};
const $4e9bfe43c468071f$export$404cd34180e60200 = (workflowV2Response, subtaskIssueTypeId)=>{
    if (subtaskIssueTypeId == null) return workflowV2Response;
    const filteredWorkflows = workflowV2Response.workflows.filter((wf)=>// It checks if all workflow associations have only one issue type, and if that issue type is 'subtask'.
        // If this condition is met, it filters out the workflow.
        !wf.associatedWith.every((association)=>association.issueTypes.length === 1 && association.issueTypes[0] === subtaskIssueTypeId));
    // if no workflow specific for subtask, return original response
    if (filteredWorkflows.length === workflowV2Response.workflows.length) return workflowV2Response;
    return {
        ...workflowV2Response,
        workflows: filteredWorkflows
    };
};

});
parcelRegister("9elEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb440c5d59115477$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb440c5d59115477$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitleAddColumn: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-title-add-column",
        "defaultMessage": "Unable to create column"
    },
    errorFlagTitleDeleteColumn: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-title-delete-column",
        "defaultMessage": "Unable to delete column"
    },
    errorFlagDescription: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-description",
        "defaultMessage": "We\u2019ve run into some connection difficulties."
    },
    errorFlagActionsRetry: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-actions-retry",
        "defaultMessage": "Try again"
    },
    errorFlagActionsCheckStatus: {
        "id": "work-management-board.controllers.workflow-actions.error-flag-actions-check-status",
        "defaultMessage": "Check status page"
    },
    statusNameIsNotUniqueDescription: {
        "id": "work-management-board.controllers.workflow-actions.status-name-is-not-unique-description",
        "defaultMessage": "This status name has been used before. To use it again, open the workflow editor and create a status with the same name."
    },
    statusHasNoIncomingTransitionTitle: {
        "id": "work-management-board.controllers.workflow-actions.status-has-no-incoming-transition-title",
        "defaultMessage": "Action needed to delete column"
    },
    statusHasNoIncomingTransitionDescription: {
        "id": "work-management-board.controllers.workflow-actions.status-has-no-incoming-transition-description",
        "defaultMessage": "You need to remove the transitions linked to this status before you can delete it."
    },
    workflowVersionConflictDescription: {
        "id": "work-management-board.controllers.workflow-actions.workflow-version-conflict-description",
        "defaultMessage": "Other workflow updates are in progress. Check the workflow editor and make sure they are complete before making any changes."
    },
    openWorkflowEditorAction: {
        "id": "work-management-board.controllers.workflow-actions.open-workflow-editor-action",
        "defaultMessage": "Open workflow editor"
    },
    viewWorkflowEditorAction: {
        "id": "work-management-board.controllers.workflow-actions.view-workflow-editor-action",
        "defaultMessage": "View workflow editor"
    },
    deletePollingTimeoutTitle: {
        "id": "work-management-board.controllers.workflow-actions.delete-polling-timeout-title",
        "defaultMessage": "Your column is being deleted"
    },
    deletePollingTimeoutDescription: {
        "id": "work-management-board.controllers.workflow-actions.delete-polling-timeout-description",
        "defaultMessage": "Before you make other changes, check the workflow editor to make sure your column has been deleted."
    }
});

});


parcelRegister("9dl5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c373d0d171ab748$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c373d0d171ab748$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusAlreadyExists: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.status-already-exists",
        "defaultMessage": "''{statusName}'' is already a status name in this project"
    },
    emptyColumnNameError: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.empty-column-name-error",
        "defaultMessage": "Status name cannot be empty"
    },
    errorFlagTitleRenameColumn: {
        "id": "work-management-board.controllers.workflow-actions.rename-column.error-flag-title-rename-column",
        "defaultMessage": "Unable to rename column"
    }
});

});


parcelRegister("lN7up", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db95f6962fb66d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $29yDk = parcelRequire("29yDk");

var $2yRWX = parcelRequire("2yRWX");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $duBGk = parcelRequire("duBGk");
const $0db95f6962fb66d1$var$columnNameMaxLength = 30;
const $0db95f6962fb66d1$var$ERROR_MESSAGE_ID = 'column-name-error-dialog';
const $0db95f6962fb66d1$var$EditableColumnHeader = ({ defaultValue: defaultValue, isEditing: isEditing, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onValidate: onValidate, readView: readView })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isReadyRef = (0, $eUqFw.useRef)(false);
    const renameTextFieldRef = (0, $eUqFw.useRef)(null);
    // sets component to be ready after 10 ms and
    // focus on Textfield when editing
    (0, $eUqFw.useEffect)(()=>{
        if (isEditing) setTimeout(()=>{
            isReadyRef.current = true;
            renameTextFieldRef.current?.focus();
        }, 10);
        else isReadyRef.current = false;
    }, [
        isEditing
    ]);
    const handleConfirm = (0, $eUqFw.useCallback)((value)=>{
        if (isReadyRef.current) onConfirm(value);
    }, [
        onConfirm
    ]);
    const columnNameButtonLabel = formatMessage((0, $duBGk.default).columnNameButtonLabel, {
        statusName: defaultValue
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0db95f6962fb66d1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
        readViewFitContainerWidth: true,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: readView,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                isOpen: fieldProps.isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    id: $0db95f6962fb66d1$var$ERROR_MESSAGE_ID,
                    role: "alert",
                    "aria-live": "assertive"
                }, errorMessage),
                placement: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...fieldProps,
                ref: renameTextFieldRef,
                elemAfterInput: fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    label: "error",
                    primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
                }),
                onBlur: ()=>{
                    if (fieldProps.isInvalid) onCancel();
                },
                maxLength: $0db95f6962fb66d1$var$columnNameMaxLength,
                autoComplete: "off",
                "aria-errormessage": $0db95f6962fb66d1$var$ERROR_MESSAGE_ID,
                "aria-label": columnNameButtonLabel
            })),
        onEdit: onEdit,
        onCancel: onCancel,
        onConfirm: handleConfirm,
        validate: onValidate,
        editButtonLabel: columnNameButtonLabel
    }));
};
const $0db95f6962fb66d1$var$EditableColumnHeaderWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.editable-column-header",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0db95f6962fb66d1$var$EditableColumnHeader, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0db95f6962fb66d1$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _18u01i6y _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $0db95f6962fb66d1$export$2e2bcd8739ae039 = $0db95f6962fb66d1$var$EditableColumnHeaderWithErrorBoundary;

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = undefined;
const $99fb58582e83d080$var$packageVersion = undefined;
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $99fb58582e83d080$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $99fb58582e83d080$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("2yRWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0664d820ae0097f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $5wwB6 = parcelRequire("5wwB6");

var $kNcDT = parcelRequire("kNcDT");

var $8hUcM = parcelRequire("8hUcM");
function $0664d820ae0097f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0664d820ae0097f9$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $0664d820ae0097f9$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: undefined,
    packageVersion: undefined
};
const $0664d820ae0097f9$var$noop = ()=>{};
const $0664d820ae0097f9$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel = $0664d820ae0097f9$var$noop, onEdit: providedOnEdit = $0664d820ae0097f9$var$noop, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $kNcDT.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$0664d820ae0097f9$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8hUcM.default), {
            editButtonLabel: editButtonLabel,
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') onCancel();
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $0664d820ae0097f9$var$fieldStyles,
                onBlur: ()=>{
                    onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wwB6.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /** Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, "Submit")))) : /** Field is used here only for the label and spacing */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $0664d820ae0097f9$var$InlineEdit = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($0664d820ae0097f9$var$InnerInlineEdit, props);
};
var $0664d820ae0097f9$export$2e2bcd8739ae039 = $0664d820ae0097f9$var$InlineEdit;

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("5wwB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d378d9c54c5a6cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");

var $PdmhA = parcelRequire("PdmhA");

var $8tdcZ = parcelRequire("8tdcZ");
function $6d378d9c54c5a6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d378d9c54c5a6cc$var$buttonsContainerStyles = {
    name: "w3jtt6",
    styles: "display:flex;margin-block-start:var(--ds-space-075, 6px);position:absolute;inset-block-start:100%;inset-inline-end:0;flex-shrink:0"
};
const $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $8tdcZ.fontSize),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    // These buttons are floating, so they need an override to overlay interaction states
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N20A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N30A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $PdmhA.B400)})`
    }
});
const $6d378d9c54c5a6cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        type: "submit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))),
        UNSAFE_size: "small",
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        UNSAFE_size: "small",
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $6d378d9c54c5a6cc$export$2e2bcd8739ae039 = $6d378d9c54c5a6cc$var$Buttons;

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z" fill="currentColor"/></svg>`
    }, props));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = $6d3cc6c41555bcf7$var$CheckIcon;
module.exports.default = $6d3cc6c41555bcf7$var$_default;

});

parcelRegister("8tdcZ", function(module, exports) {

$parcel$export(module.exports, "fontSize", () => $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "borderRadius", () => $0b3df1ecc0dc12b2$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93 = 14;
const $0b3df1ecc0dc12b2$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();

});


parcelRegister("kNcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc2637f9691157f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $acc2637f9691157f$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $acc2637f9691157f$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $acc2637f9691157f$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $acc2637f9691157f$export$2e2bcd8739ae039 = $acc2637f9691157f$var$useButtonFocusHook;

});

parcelRegister("8hUcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e4844bc5b892d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8tdcZ = parcelRequire("8tdcZ");
function $f1e4844bc5b892d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1e4844bc5b892d8$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $f1e4844bc5b892d8$var$editButtonStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $f1e4844bc5b892d8$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $8tdcZ.borderRadius),
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`
    }
});
const $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $f1e4844bc5b892d8$var$DRAG_THRESHOLD = 5;
const $f1e4844bc5b892d8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f1e4844bc5b892d8$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $f1e4844bc5b892d8$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f1e4844bc5b892d8$var$readViewWrapperStyles,
            readViewFitContainerWidth && $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $f1e4844bc5b892d8$export$2e2bcd8739ae039 = $f1e4844bc5b892d8$var$ReadView;

});


parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ecaf8c9a10cf48c9$var$TextfieldComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
$ecaf8c9a10cf48c9$var$TextfieldComponent.displayName = 'Textfield';
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.memo)($ecaf8c9a10cf48c9$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("duBGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a46d3d6a0ddafd8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a46d3d6a0ddafd8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnNameButtonLabel: {
        "id": "work-management-board.board.column.column-header.header-content.editable-column-header.column-name-button-label",
        "defaultMessage": "Edit {statusName} status column"
    }
});

});


parcelRegister("3cUPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c566e2e6d8db04e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c566e2e6d8db04e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noAssignee: {
        "id": "work-management-board.board.column.column-header.header-content.no-assignee",
        "defaultMessage": "Unassigned"
    },
    noPriority: {
        "id": "work-management-board.board.column.column-header.header-content.no-priority",
        "defaultMessage": "Unprioritized"
    },
    noCategory: {
        "id": "work-management-board.board.column.column-header.header-content.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("1VNWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f158fdcc9bc00806$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7opLA = parcelRequire("7opLA");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $f4oGi = parcelRequire("f4oGi");

var $jG1wZ = parcelRequire("jG1wZ");

var $fEMj1 = parcelRequire("fEMj1");

var $dxopF = parcelRequire("dxopF");

var $8cU5f = parcelRequire("8cU5f");

var $7eqzD = parcelRequire("7eqzD");

var $kQAZu = parcelRequire("kQAZu");

var $41WOo = parcelRequire("41WOo");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hOd9O = parcelRequire("hOd9O");
var $fkLhx = parcelRequire("fkLhx");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4VjPN = parcelRequire("4VjPN");

var $eUIOu = parcelRequire("eUIOu");

var $4Z5qC = parcelRequire("4Z5qC");

var $gKXju = parcelRequire("gKXju");

var $c52lf = parcelRequire("c52lf");

var $cgK6s = parcelRequire("cgK6s");

var $cdPA8 = parcelRequire("cdPA8");

var $77aEt = parcelRequire("77aEt");
const $f158fdcc9bc00806$var$HeaderDropdown = ({ hasExceededMaxIssueTypes: hasExceededMaxIssueTypes, hasMultipleWorkflows: hasMultipleWorkflows, isLoading: isLoading, onRenameClick: onRenameClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $eUqFw.useState)(false);
    const isWorkflowOperationInProgress = (0, $cgK6s.useIsWorkflowOperationInProgress)();
    const { shouldRenderExperiment: automationDiscoveryEnabled } = (0, $41WOo.isAutomationDiscoveryOnBoardColumnsExperimentEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fkLhx.useJwmAutomationDiscoveryOnBoardColumnsExperiment)() : {
        shouldRenderExperiment: false
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { group: group } = automationDiscoveryEnabled ? (0, $c52lf.useIssueGroup)() : {
        group: null
    };
    const project = (0, $kQAZu.useProject)();
    const canAdministerProject = project.permissions.administerProject;
    const actionsDisabled = !canAdministerProject || hasMultipleWorkflows === true || hasExceededMaxIssueTypes === true || isWorkflowOperationInProgress;
    const groups = (0, $gKXju.useGroups)();
    const onlyOneColumnLeft = groups.length <= 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "work-management-board.ui.board.column.column-header.header-dropdown.header-dropdown-menu",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$StyledButton, {
                ...props,
                isLoading: isLoading,
                appearance: "subtle",
                testId: "work-management-board.ui.board.column.column-header.header-dropdown.more-button",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $77aEt.default).columnActionsMenu)
                }),
                ref: triggerRef
            }),
        onOpenChange: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardColumnMoreButton', {
                columnMoreActionsDisabled: actionsDisabled
            });
        },
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $77aEt.default).dropdownHeaderTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
            size: "small",
            label: ""
        }),
        onClick: ()=>{
            onRenameClick();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'jwmBoardColumnRenameDropdownItem');
        },
        isDisabled: actionsDisabled
    }, formatMessage((0, $77aEt.default).rename)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: onlyOneColumnLeft,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: formatMessage((0, $77aEt.default).deleteDisabledTooltip)
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: "work-management-board.ui.board.column.column-header.header-dropdown.delete-dropdown",
        isDisabled: onlyOneColumnLeft || actionsDisabled,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
            size: "small",
            label: ""
        }),
        onClick: ()=>{
            setIsDeleteModalOpen(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'jwmBoardColumnDeleteDropdownItem');
        }
    }, formatMessage((0, $77aEt.default).delete)), automationDiscoveryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hOd9O.ColumnActionsMenuAutomationItems), {
        actionsDisabled: actionsDisabled,
        statusName: group?.name ?? ''
    })), hasExceededMaxIssueTypes === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUIOu.OpenProjectSettingsExceededIssueTypes), null)), hasMultipleWorkflows === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Z5qC.OpenProjectSettingsMultipleWorkflows), null)), !canAdministerProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$DropdownMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VjPN.ContactAdminToModifyBoardMessage), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdPA8.default), {
        onClose: ()=>setIsDeleteModalOpen(false)
    })));
};
const $f158fdcc9bc00806$var$HeaderDropdownWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-business.board.header-dropdown",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f158fdcc9bc00806$var$HeaderDropdown, props));
var $f158fdcc9bc00806$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f158fdcc9bc00806$var$HeaderDropdownWithErrorBoundary;
const $f158fdcc9bc00806$var$DropdownMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41bs6 _p12fuuw1 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f158fdcc9bc00806$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $af8a5fe38412111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5.836 6.95l-3.825 9.97a.5.5 0 00.467.68h1.208a.5.5 0 00.47-.33l.683-1.877a.5.5 0 01.47-.33H9.12a.5.5 0 01.47.33l.683 1.878a.5.5 0 00.47.329h1.272a.5.5 0 00.468-.678L8.685 6.95a.7.7 0 00-.655-.45H6.49a.7.7 0 00-.654.45zm1.566 2.457l1.25 3.414a.2.2 0 01-.188.269H5.966a.2.2 0 01-.188-.269l1.249-3.414a.2.2 0 01.375 0zm10.148 6.465c1.222 0 2.142-1.01 2.142-2.603 0-1.594-.902-2.532-2.142-2.532-1.256 0-2.178.938-2.178 2.532 0 1.575.904 2.603 2.178 2.603zm2.161.602c-.372.833-1.276 1.433-2.445 1.433-2.567 0-4.266-2-4.266-4.638 0-2.551 1.664-4.569 4.195-4.569 1.56 0 2.284.833 2.497 1.329v-.34c0-.247.007-.392.213-.576.137-.122.344-.177.62-.165h.764a.581.581 0 01.496.165c.213.203.192.421.192.577v6.394c0 .227.008.526.023.899 0 .191-.041.336-.124.434a.628.628 0 01-.508.242h-.93c-.193 0-.45-.084-.533-.184-.083-.1-.165-.23-.183-.532a6.342 6.342 0 01-.01-.364v-.105z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = $af8a5fe38412111b$var$EmojiKeyboardIcon;
module.exports.default = $af8a5fe38412111b$var$_default;

});

parcelRegister("fEMj1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6600ff3072270d9$var$_react = $b6600ff3072270d9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b6600ff3072270d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b6600ff3072270d9$var$TrashIcon = (props)=>/*#__PURE__*/ $b6600ff3072270d9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5 5a1 1 0 00-1 1v1h16V6a1 1 0 00-1-1H5zm11.15 15H7.845a1 1 0 01-.986-.835L5 8h14l-1.864 11.166a.999.999 0 01-.986.834M9 4.5a.5.5 0 01.491-.5h5.018a.5.5 0 01.491.5V5H9v-.5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b6600ff3072270d9$var$TrashIcon.displayName = 'TrashIcon';
var $b6600ff3072270d9$var$_default = $b6600ff3072270d9$var$TrashIcon;
module.exports.default = $b6600ff3072270d9$var$_default;

});

parcelRegister("7eqzD", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $b3ad0a6f810bebd6$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $b3ad0a6f810bebd6$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("hOd9O", function(module, exports) {

$parcel$export(module.exports, "ColumnActionsMenuAutomationItems", () => $8d0701016be001bc$export$1da1b2f67de108ff);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $dH3Qh = parcelRequire("dH3Qh");
const $8d0701016be001bc$export$1da1b2f67de108ff = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $dH3Qh.ColumnActionsMenuAutomationItemsEntryPoint), props);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessColumnAutomationDiscoveryExperiment",
        packageName: "jiraBusinessColumnAutomationDiscoveryExperiment",
        teamName: "program-moon",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        errorFallback: "unmount"
    });
};

});
parcelRegister("dH3Qh", function(module, exports) {

$parcel$export(module.exports, "ColumnActionsMenuAutomationItemsEntryPoint", () => $56c2cb46e4bee7f3$export$69a939273a5b5451);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $56c2cb46e4bee7f3$export$69a939273a5b5451 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("1AXob")).then((module)=>module.ColumnActionsMenuAutomationItemsContainer), {
        moduleId: "f60fb5ad"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1AXob", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4SO7K');
        const value = parcelRequire('jzuX3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4SO7K").then(()=>parcelRequire('jzuX3'));
}

});



parcelRegister("4VjPN", function(module, exports) {

$parcel$export(module.exports, "ContactAdminToModifyBoardMessage", () => $b523582b682a07b1$export$a89755471361f3c1);

var $eUqFw = parcelRequire("eUqFw");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gQp5G = parcelRequire("gQp5G");
const $b523582b682a07b1$var$ContactAdmin = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "/secure/ContactAdministrators!default.jspa",
        target: "_blank"
    }, children);
const $b523582b682a07b1$export$a89755471361f3c1 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $b523582b682a07b1$var$ContactAdmin
        },
        message: formatMessage((0, $gQp5G.default).noPermissionToModify, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("gQp5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a680a926e4fd6ffc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a680a926e4fd6ffc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermissionToModify: {
        "id": "work-management-board.common.contact-admin-to-modify-board.no-permission-to-modify",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to make changes to the board"
    }
});

});


parcelRegister("eUIOu", function(module, exports) {

$parcel$export(module.exports, "OpenProjectSettingsExceededIssueTypes", () => $0f807102606ed069$export$b7268968213268c2);

var $eUqFw = parcelRequire("eUqFw");

var $23NQ5 = parcelRequire("23NQ5");

var $kQAZu = parcelRequire("kQAZu");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fAbsD = parcelRequire("fAbsD");
const $0f807102606ed069$var$OpenProjectSettings = ({ children: children })=>{
    const project = (0, $kQAZu.useProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `/jira/core/projects/${project.key}/settings/issuetypes`,
        target: "_blank"
    }, children, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    }));
};
const $0f807102606ed069$export$b7268968213268c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $0f807102606ed069$var$OpenProjectSettings
        },
        message: formatMessage((0, $fAbsD.default).exceededIssueTypesBoardActionsDisabled, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("fAbsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d683adbd1d9b32$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81d683adbd1d9b32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    exceededIssueTypesBoardActionsDisabled: {
        "id": "work-management-board.common.open-project-settings-exceeded-issue-types.exceeded-issue-types-board-actions-disabled",
        "defaultMessage": "Looks like you've got too many issue types. You can {linkStart}add, delete, or rename columns in project settings{linkEnd}."
    }
});

});


parcelRegister("4Z5qC", function(module, exports) {

$parcel$export(module.exports, "OpenProjectSettingsMultipleWorkflows", () => $24ada43abdc0be4e$export$34713a2d1d1029c);

var $eUqFw = parcelRequire("eUqFw");

var $23NQ5 = parcelRequire("23NQ5");

var $kQAZu = parcelRequire("kQAZu");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gy5Ed = parcelRequire("gy5Ed");
const $24ada43abdc0be4e$var$OpenProjectSettings = ({ children: children })=>{
    const project = (0, $kQAZu.useProject)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `/jira/core/projects/${project.key}/settings/issuetypes`,
        target: "_blank"
    }, children, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    }));
};
const $24ada43abdc0be4e$export$34713a2d1d1029c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $24ada43abdc0be4e$var$OpenProjectSettings
        },
        message: formatMessage((0, $gy5Ed.default).multipleWorkflowsBoardActionsDisabled, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("gy5Ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac332460506c549$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aac332460506c549$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    multipleWorkflowsBoardActionsDisabled: {
        "id": "work-management-board.common.open-project-settings-multiple-workflows.multiple-workflows-board-actions-disabled",
        "defaultMessage": "You can't add, delete, or rename columns when a board has multiple workflows. You can {linkStart}change your workflows in project settings{linkEnd}."
    }
});

});


parcelRegister("cdPA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e23821f171c1c31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $1e23821f171c1c31$var$ColumnDeleteModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kJMQT")), {
    moduleId: "./src/packages/business/board/view/src/ui/board/column/column-header/header-dropdown/column-delete-modal/main.tsx"
});
const $1e23821f171c1c31$var$AsyncColumnDeleteModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.column-delete-modal",
        packageName: "async.jira-business.board.column-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "column-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1e23821f171c1c31$var$ColumnDeleteModal, props)));
var $1e23821f171c1c31$export$2e2bcd8739ae039 = $1e23821f171c1c31$var$AsyncColumnDeleteModal;

});
parcelRegister("kJMQT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('50DLA');
        const value = parcelRequire('hiC39');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("50DLA").then(()=>parcelRequire('hiC39'));
}

});


parcelRegister("77aEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $00276efd509970a9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00276efd509970a9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dropdownHeaderTitle: {
        "id": "work-management-board.board.column.column-header.header-dropdown.dropdown-header-title",
        "defaultMessage": "Actions"
    },
    rename: {
        "id": "work-management-board.board.column.column-header.header-dropdown.rename",
        "defaultMessage": "Rename"
    },
    delete: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete",
        "defaultMessage": "Delete"
    },
    deleteDisabledTooltip: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete-disabled-tooltip",
        "defaultMessage": "The board must contain at least one column"
    },
    columnActionsMenu: {
        "id": "work-management-board.board.column.column-header.header-dropdown.column-actions-menu",
        "defaultMessage": "Column actions"
    }
});

});


parcelRegister("lELme", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4ad9f8207289bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c4ad9f8207289bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    collapseButton: {
        "id": "work-management-board.board.column.column-header.collapse-button",
        "defaultMessage": "Collapse"
    },
    expandButton: {
        "id": "work-management-board.board.column.column-header.expand-button",
        "defaultMessage": "Expand"
    }
});

});


parcelRegister("jduWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5740eb86f24e4e08$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gCss4 = parcelRequire("gCss4");

var $2vRZq = parcelRequire("2vRZq");
const $5740eb86f24e4e08$var$inlineCreateStyles = {
    borderRadius: "var(--ds-border-radius, 3px)"
};
const $5740eb86f24e4e08$var$InlineCreate = ({ group: group, scrollToLastElement: scrollToLastElement })=>{
    const onAddOptimisticIssue = (0, $eUqFw.useCallback)(()=>{
        // Only attempt to scroll to the last element after the optimistic issue is created
        requestAnimationFrame(scrollToLastElement);
    }, [
        scrollToLastElement
    ]);
    const inlineCreateProps = (0, $2vRZq.useInlineCreateProps)({
        group: group,
        onAddOptimisticIssue: onAddOptimisticIssue
    });
    const handleToggleForm = (0, $eUqFw.useCallback)((isFormVisible)=>{
        if (isFormVisible) scrollToLastElement();
    }, [
        scrollToLastElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5740eb86f24e4e08$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCss4.default), {
        ...inlineCreateProps,
        location: "boardFooter",
        inlineCreateStyles: $5740eb86f24e4e08$var$inlineCreateStyles,
        onToggleForm: handleToggleForm
    }));
};
const $5740eb86f24e4e08$var$wrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050'
});
var $5740eb86f24e4e08$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5740eb86f24e4e08$var$InlineCreate);

});
parcelRegister("gCss4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d57348ffad7a3f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gIx2f = parcelRequire("gIx2f");

var $73dL5 = parcelRequire("73dL5");
const $8d57348ffad7a3f9$var$InlineCreate = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, fieldIdsToReturn: fieldIdsToReturn, inlineCreateStyles: inlineCreateStyles, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel, minHierarchyLevel: minHierarchyLevel, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, onToggleForm: onToggleForm, popperStrategy: popperStrategy })=>{
    const [isFormVisible, setIsFormVisible] = (0, $eUqFw.useState)(false);
    const showForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(true);
        onToggleForm?.(true);
    }, [
        onToggleForm
    ]);
    const hideForm = (0, $eUqFw.useCallback)(()=>{
        setIsFormVisible(false);
        onToggleForm?.(false);
    }, [
        onToggleForm
    ]);
    const handleBlur = (0, $eUqFw.useCallback)(()=>{
        hideForm();
        onBlur?.();
    }, [
        hideForm,
        onBlur
    ]);
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: appearance,
        fieldIdsToReturn: fieldIdsToReturn,
        isCompact: isCompact,
        location: location,
        maxHierarchyLevel: maxHierarchyLevel,
        minHierarchyLevel: minHierarchyLevel,
        onBlur: handleBlur,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        popperStrategy: popperStrategy,
        ...inlineCreateStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73dL5.default), {
        onClick: showForm,
        ...inlineCreateStyles
    });
};
const $8d57348ffad7a3f9$var$genericMemo = (0, $eUqFw.memo);
var $8d57348ffad7a3f9$export$2e2bcd8739ae039 = $8d57348ffad7a3f9$var$genericMemo($8d57348ffad7a3f9$var$InlineCreate);

});
parcelRegister("73dL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $526fef1529e77253$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gO9Xw = parcelRequire("gO9Xw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9W2dp = parcelRequire("9W2dp");
const $526fef1529e77253$var$InlineCreateTrigger = ({ onClick: onClick, minHeight: minHeight, borderRadius: borderRadius, horizontalPadding: horizontalPadding })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Trigger, {
        borderRadius: borderRadius,
        "data-testid": "business-issue-create.ui.inline-create-trigger",
        horizontalPadding: horizontalPadding,
        minHeight: minHeight,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($526fef1529e77253$var$Label, null, formatMessage((0, $9W2dp.default).createLabel)));
};
var $526fef1529e77253$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($526fef1529e77253$var$InlineCreateTrigger);
const $526fef1529e77253$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, horizontalPadding: horizontalPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ri98hz": (0, $9t7rW.default)(__cmplp.borderRadius ?? 0),
            "--_19b8a3e": (0, $9t7rW.default)(__cmplp.minHeight ?? '32px'),
            "--_1w524p6": (0, $9t7rW.default)(`0 ${__cmplp.horizontalPadding ?? "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke _syaz1thw _bfhk18uv _19itglyw _1wybdlk8 _k48pbfng _2rko16jm _1tke1um9 _1yt414jf _zulph9hh _1bsb1osq _1jhm1q09 _y2mv1q09 _1ygb1q09 _13ro1n1a _1bg41n1a _1ah31n1a _irr3166n _1di61dty",
            __cmplp.className
        ])
    });
});
const $526fef1529e77253$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9W2dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a764120c338951$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37a764120c338951$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createLabel: {
        "id": "business-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});




parcelRegister("gQQ5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f7a84de394113a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lUpP3 = parcelRequire("lUpP3");

var $c52lf = parcelRequire("c52lf");

var $j9aY9 = parcelRequire("j9aY9");
const $02f7a84de394113a$var$InvalidDropTargetMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { group: group } = (0, $c52lf.useIssueGroup)();
    let message;
    const groupType = group.type;
    switch(groupType){
        case 0, $jGcn0.GROUP_BY_ASSIGNEE:
            message = (0, $j9aY9.default).unableToUpdateAssigneeMessage;
            break;
        case 0, $jGcn0.GROUP_BY_CATEGORY:
            message = (0, $j9aY9.default).unableToUpdateCategoryMessage;
            break;
        case 0, $jGcn0.GROUP_BY_PRIORITY:
            message = (0, $j9aY9.default).unableToUpdatePriorityMessage;
            break;
        case 0, $jGcn0.GROUP_BY_STATUS:
            message = (0, $j9aY9.default).transitionNotAvailableMessage;
            break;
        default:
            {
                const exhaustiveCheck = groupType;
                throw new Error(`Unexpected group type: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$Wrapper, {
        "data-testid": "work-management-board.ui.board.column.invalid-drop-target-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUpP3.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02f7a84de394113a$var$Message, null, formatMessage(message))));
};
var $02f7a84de394113a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($02f7a84de394113a$var$InvalidDropTargetMessage);
const $02f7a84de394113a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1gly _2rko3ree _1r04idpf _kqswstnw _154ickbl",
            __cmplp.className
        ])
    });
});
const $02f7a84de394113a$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _zulpu2gc _1yt4wd81 _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $02f7a84de394113a$var$Message = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j9aY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65e47925e32115c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e65e47925e32115c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unableToUpdateAssigneeMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-assignee-message",
        "defaultMessage": "You can't move this issue to this column because the assignee field is not associated with this issue type."
    },
    unableToUpdateCategoryMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-category-message",
        "defaultMessage": "You can't move this issue to this column because the category field is not associated with this issue type."
    },
    unableToUpdatePriorityMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-priority-message",
        "defaultMessage": "You can't move this issue to this column because the priority field is not associated with this issue type."
    },
    transitionNotAvailableMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    }
});

});


parcelRegister("9sGu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f91d7e9311d0a1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $i0ak4 = parcelRequire("i0ak4");

var $gWYTK = parcelRequire("gWYTK");

var $ay4XV = parcelRequire("ay4XV");

var $aL9gA = parcelRequire("aL9gA");
const $f0f91d7e9311d0a1$var$getTransitionById = (transitions, transitionId)=>transitions.find((transition)=>transition.transitionId === transitionId);
const $f0f91d7e9311d0a1$var$TransitionZones = ({ group: group })=>{
    const { transitions: transitions } = (0, $ay4XV.useIssueTransitions)();
    const updateDropTarget = (0, $gWYTK.useUpdateDropTarget)();
    const { sourceGroup: sourceGroup, dropTarget: dropTarget } = (0, $gWYTK.useCardDragDrop)();
    const handleCardDragOver = (0, $eUqFw.useCallback)((transitionId)=>{
        updateDropTarget({
            groupId: group.id,
            transition: $f0f91d7e9311d0a1$var$getTransitionById(transitions, transitionId)
        });
    }, [
        group,
        transitions,
        updateDropTarget
    ]);
    const handleTransitionSelected = (0, $eUqFw.useCallback)((transitionId)=>{
        updateDropTarget({
            transition: $f0f91d7e9311d0a1$var$getTransitionById(transitions, transitionId)
        });
    }, [
        transitions,
        updateDropTarget
    ]);
    const sourceStatus = (0, $eUqFw.useMemo)(()=>sourceGroup ? {
            id: Number(sourceGroup.id),
            name: sourceGroup.name
        } : undefined, [
        sourceGroup
    ]);
    const statusCategoryId = group.type === (0, $jGcn0.GROUP_BY_STATUS) ? group.statusCategoryId : 0;
    const transitionZonesData = (0, $eUqFw.useMemo)(()=>transitions.filter((transition)=>String(transition.toStatusId) === group.id).map((transition)=>({
                transitionId: transition.transitionId,
                transitionName: transition.name,
                targetStatusId: transition.toStatusId,
                targetStatusName: group.name,
                targetStatusCategory: (0, $8Qd0L.statusCategoryForId)(statusCategoryId),
                isAvailable: true,
                isGlobal: transition.isGlobal
            })), [
        transitions,
        group.id,
        group.name,
        statusCategoryId
    ]);
    if (!sourceGroup) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0f91d7e9311d0a1$var$TransitionZoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0ak4.default), {
        hasSwimlanes: false,
        columnId: group.id,
        sourceColumnId: sourceGroup.id,
        sourceStatus: sourceStatus,
        transitions: transitionZonesData,
        hoverIntent: false,
        columnDraggingOver: dropTarget.groupId,
        notAvailableMessage: (0, $aL9gA.default).notAvailableMessage,
        onCardDragOver: handleCardDragOver,
        onTransitionSelected: handleTransitionSelected
    }));
};
var $f0f91d7e9311d0a1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f0f91d7e9311d0a1$var$TransitionZones);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0f91d7e9311d0a1$var$TransitionZoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wtet4lq _vw7oglyw _1f5il1r9 _pslqidpf _1hvostnw _17hj14y2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i0ak4", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a4e6df736323f5$export$2e2bcd8739ae039);

var $983OU = parcelRequire("983OU");
var $13a4e6df736323f5$export$2e2bcd8739ae039 = (0, $983OU.ColumnTransitionZonesContainer);

});
parcelRegister("983OU", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $d8405c1b96d6c598$export$169a50ebb52c9a6);
$parcel$export(module.exports, "InnerContainer", () => $d8405c1b96d6c598$export$819ff6ae0287a04);
$parcel$export(module.exports, "OuterContainer", () => $d8405c1b96d6c598$export$fb3bf400d073b5dd);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $eo9PV = parcelRequire("eo9PV");

var $hKj4G = parcelRequire("hKj4G");

var $iIzf3 = parcelRequire("iIzf3");

var $fIrnI = parcelRequire("fIrnI");

var $cZAdR = parcelRequire("cZAdR");

var $2QY77 = parcelRequire("2QY77");

var $IWUIx = parcelRequire("IWUIx");

const $d8405c1b96d6c598$export$169a50ebb52c9a6 = ({ columnId: columnId, swimlaneId: swimlaneId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent, onTransitionSelected: onTransitionSelected, hasSwimlanes: hasSwimlanes, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, transitions: allTransitions, sourceColumnId: sourceColumnId, showAllTransitionZones: showAllTransitionZones })=>{
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [allowSelfColumnTransitions, setAllowSelfColumnTransitions] = (0, $eUqFw.useState)(false);
    const containerRef = (0, $eUqFw.useRef)(null);
    const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
    const debouncedOnDragOverTransition = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((transitionId, hoverIntentOnZone)=>{
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
        }, (0, $9f45f53a8ada9764$export$c28377001f14d9d)), [
        hoverIntentOnThisColumn,
        onCardDragOver
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            debouncedOnDragOverTransition.cancel();
        }, [
        debouncedOnDragOverTransition
    ]);
    const onHoverOverTransitionToZone = (0, $eUqFw.useCallback)(()=>{
        setAllowSelfColumnTransitions(true);
    }, []);
    const renderTransitions = (transitions)=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIrnI.LoadingContainer), null);
        if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZAdR.NoTransitionContainer), {
            noTransitionMessage: noTransitionMessage
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
            const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
            const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IWUIx.default), {
                key: transitionId,
                isHidden: hoverIntent,
                transitionId: transitionId,
                transitionName: filteredTransitionName,
                targetStatusName: targetStatusName,
                onDragOver: debouncedOnDragOverTransition,
                targetStatusCategory: targetStatusCategory,
                isTransitionAvailable: isAvailable,
                isTransitionGlobal: isGlobal,
                notAvailableMessage: notAvailableMessage,
                sourceStatus: filteredSourceStatus,
                onTransitionSelection: onTransitionSelected,
                hideSourceStatusInLabel: hideSourceStatusInLabel,
                columnId: columnId,
                swimlaneId: swimlaneId
            });
        }));
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!containerRef.current || isLoading || allTransitions.length === 0) return undefined;
        return (0, $eo9PV.dropTargetForElements)({
            element: containerRef.current,
            onDragLeave: ()=>{
                autobatch(()=>setAllowSelfColumnTransitions(false));
            }
        });
    }, [
        isLoading,
        allTransitions.length,
        allowSelfColumnTransitions,
        onCardDragOver,
        autobatch
    ]);
    let transitions = allTransitions;
    if (!showAllTransitionZones && columnId === sourceColumnId) {
        transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
        if (transitions.length === 0) return null;
    }
    if (!showAllTransitionZones && columnId === sourceColumnId && !allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2QY77.default), {
        onHover: onHoverOverTransitionToZone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d8405c1b96d6c598$export$fb3bf400d073b5dd, {
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.outer-container",
        isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
        hasSwimlanes: hasSwimlanes,
        shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
        innerRef: containerRef
    }, renderTransitions(transitions));
};
const $d8405c1b96d6c598$export$819ff6ae0287a04 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1064em4-0"
})`--full-column-height:calc( var(--board-scroll-element-height) * 1px - ${(0, $iIzf3.columnHeaderHeight) + 8}px );position:sticky;width:100%;display:flex;flex-direction:column;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? (0, $iIzf3.columnHeaderHeight) * 2 : (0, $iIzf3.columnHeaderHeight)}px;transition:opacity 0.2s;background-color:${({ theme: theme })=>theme.background};height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : '100%'};max-height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, zoneCount: zoneCount })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : `${zoneCount * (0, $iIzf3.columnHeaderHeight) * 2}px`};`;
const $d8405c1b96d6c598$export$fb3bf400d073b5dd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1064em4-1"
})`position:absolute;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? 0 : (0, $iIzf3.columnHeaderHeight)}px;height:100%;width:100%;z-index:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? (0, $iIzf3.zIndex).fullColumnHeightTransitionZones : (0, $iIzf3.zIndex).transitionZones};background-color:${({ theme: theme })=>theme.background};border-radius:${(0, $iIzf3.layout).cardListRadius}px;${({ isHidden: isHidden })=>isHidden && 'display: none;'};`;

});
parcelRegister("hKj4G", function(module, exports) {

$parcel$export(module.exports, "useAutobatch", () => $8e906032bc4f59a5$export$5b8ae94abd7adcf);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1ybV0 = parcelRequire("1ybV0");
const $8e906032bc4f59a5$var$queue = new Set();
let $8e906032bc4f59a5$var$hasQueuedFlush = false;
function $8e906032bc4f59a5$var$flush() {
    const tasks = Array.from($8e906032bc4f59a5$var$queue);
    $8e906032bc4f59a5$var$queue.clear();
    (0, $lEfVV.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $8e906032bc4f59a5$export$46f5568dd7916109(task) {
    $8e906032bc4f59a5$var$queue.add(task);
    if (!$8e906032bc4f59a5$var$hasQueuedFlush) {
        $8e906032bc4f59a5$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $8e906032bc4f59a5$var$hasQueuedFlush = false;
            $8e906032bc4f59a5$var$flush();
        });
    }
    return ()=>{
        $8e906032bc4f59a5$var$queue.delete(task);
    };
}
function $8e906032bc4f59a5$export$5b8ae94abd7adcf() {
    if (!(0, $1ybV0.ff)('jsw.perf.pragmatic-dnd-auto-batch')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eUqFw.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $eUqFw.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $eUqFw.useCallback)((task)=>{
        const cancel = $8e906032bc4f59a5$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("iIzf3", function(module, exports) {

$parcel$export(module.exports, "layout", () => $773cc0e2395d35af$export$b3219800bda33a1f);
$parcel$export(module.exports, "colors", () => $773cc0e2395d35af$export$8f45430ccf837300);
$parcel$export(module.exports, "zIndex", () => $773cc0e2395d35af$export$56446adcecbeec34);
$parcel$export(module.exports, "columnHeaderHeight", () => $773cc0e2395d35af$export$b10d8d0737c2bc95);
$parcel$export(module.exports, "columnFixedWidth", () => $773cc0e2395d35af$export$fa05dc858c5009bb);
$parcel$export(module.exports, "columnMinWidth", () => $773cc0e2395d35af$export$dc572e5846332cb1);
$parcel$export(module.exports, "columnWithMarginWidth", () => $773cc0e2395d35af$export$28e72c3a8a93ac77);
$parcel$export(module.exports, "columnMinWithMarginWidth", () => $773cc0e2395d35af$export$f47ba5aa0a13b432);
$parcel$export(module.exports, "columnHeaderFontSize", () => $773cc0e2395d35af$export$bc68d684b3f68e0);
$parcel$export(module.exports, "swimlaneHeaderHeight", () => $773cc0e2395d35af$export$b12ee424ee8005de);
$parcel$export(module.exports, "minCardHeight", () => $773cc0e2395d35af$export$9c20cef8efa8ff1c);
$parcel$export(module.exports, "miniMapMapHeight", () => $773cc0e2395d35af$export$73febd7a1d3f7041);
$parcel$export(module.exports, "collapsedColumnFixedWidth", () => $773cc0e2395d35af$export$7709c197eb61e438);
$parcel$export(module.exports, "collapsedColumnWithMarginWidth", () => $773cc0e2395d35af$export$a18d33b11d25b5c7);
$parcel$export(module.exports, "scrollbarWidth", () => $773cc0e2395d35af$export$14c8a45ff6da16d);
$parcel$export(module.exports, "unscheduledColumnWidth", () => $773cc0e2395d35af$export$e635defc4ff8e744);
$parcel$export(module.exports, "unscheduledColumnHeaderHeight", () => $773cc0e2395d35af$export$1f19522691bf7df6);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $773cc0e2395d35af$export$b3219800bda33a1f = {
    gutter: 10,
    smallGutter: 5,
    cardRadius: 3,
    cardListRadius: 6,
    adg3smallGutter: 8,
    columnMargin: 6,
    boardBorderWidth: (0, $c9TLT.contentHorizontalSpacing)
};
const $773cc0e2395d35af$export$8f45430ccf837300 = {
    shadow: "var(--ds-border, rgba(0, 0, 0, 0.2))"
};
const $773cc0e2395d35af$export$56446adcecbeec34 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    transitionZoneIndicator: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    fullColumnHeightTransitionZones: 3
};
const $773cc0e2395d35af$export$b10d8d0737c2bc95 = 32 + 2 * $773cc0e2395d35af$export$b3219800bda33a1f.adg3smallGutter;
const $773cc0e2395d35af$export$fa05dc858c5009bb = 270;
const $773cc0e2395d35af$export$dc572e5846332cb1 = 150;
const $773cc0e2395d35af$export$28e72c3a8a93ac77 = $773cc0e2395d35af$export$fa05dc858c5009bb + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$f47ba5aa0a13b432 = $773cc0e2395d35af$export$dc572e5846332cb1 + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$bc68d684b3f68e0 = 12;
const $773cc0e2395d35af$export$b12ee424ee8005de = 24 + 2 * $773cc0e2395d35af$export$b3219800bda33a1f.adg3smallGutter;
const $773cc0e2395d35af$export$9c20cef8efa8ff1c = (0, $c9TLT.gridSize) * 10;
const $773cc0e2395d35af$export$73febd7a1d3f7041 = 36;
const $773cc0e2395d35af$export$7709c197eb61e438 = 40;
const $773cc0e2395d35af$export$a18d33b11d25b5c7 = $773cc0e2395d35af$export$7709c197eb61e438 + $773cc0e2395d35af$export$b3219800bda33a1f.columnMargin * 2;
const $773cc0e2395d35af$export$14c8a45ff6da16d = '10px';
const $773cc0e2395d35af$export$e635defc4ff8e744 = '270px';
const $773cc0e2395d35af$var$unscheduledColumnTitleHeight = 20;
const $773cc0e2395d35af$export$1f19522691bf7df6 = $773cc0e2395d35af$export$b12ee424ee8005de + $773cc0e2395d35af$var$unscheduledColumnTitleHeight;

});

parcelRegister("fIrnI", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $31048388176c5f92$export$5e3f251c730829);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $31048388176c5f92$export$5e3f251c730829() {
    const [showSpinner, setShowSpinner] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const timeoutId = setTimeout(()=>setShowSpinner(true), 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31048388176c5f92$var$Wrapper, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }) : null);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31048388176c5f92$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _4t3i16xz _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cZAdR", function(module, exports) {

$parcel$export(module.exports, "NoTransitionContainer", () => $fd21cec7fc235f09$export$35d96e22ed839fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aaVrx = parcelRequire("aaVrx");
function $fd21cec7fc235f09$export$35d96e22ed839fc({ noTransitionMessage: noTransitionMessage }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const message = formatMessage(noTransitionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd21cec7fc235f09$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd21cec7fc235f09$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aaVrx))),
        role: "presentation",
        alt: message
    }), message);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd21cec7fc235f09$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _1wyb1skh _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $fd21cec7fc235f09$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aaVrx", function(module, exports) {
module.exports = new URL("restricted.65d4317c.svg", import.meta.url).toString();

});


parcelRegister("2QY77", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9e3819b520b47c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $eo9PV = parcelRequire("eo9PV");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hKj4G = parcelRequire("hKj4G");

var $iIzf3 = parcelRequire("iIzf3");
const $9d9e3819b520b47c$var$hoverIntentDelayMs = 100;
const $9d9e3819b520b47c$var$messages = (0, $90IgZ.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
const $9d9e3819b520b47c$var$ColumnTransitionToZone = ({ onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [isDraggingOver, setIsDraggingOver] = (0, $eUqFw.useState)(false);
    const batchSetIsDraggingOver = (0, $eUqFw.useCallback)((draggingOver)=>{
        autobatch(()=>setIsDraggingOver(draggingOver));
    }, [
        autobatch
    ]);
    const containerRef = (0, $eUqFw.useRef)(null);
    const previousInputPosition = (0, $eUqFw.useRef)(null);
    const debouncedHoverIntent = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onHover, $9d9e3819b520b47c$var$hoverIntentDelayMs), [
        onHover
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        return (0, $eo9PV.dropTargetForElements)({
            element: containerRef.current,
            onDragEnter: ()=>{
                batchSetIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    debouncedHoverIntent();
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                debouncedHoverIntent.cancel();
                batchSetIsDraggingOver(false);
            }
        });
    }, [
        batchSetIsDraggingOver,
        debouncedHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9d9e3819b520b47c$var$TransitionToZone, {
        isDraggingOver: isDraggingOver,
        innerRef: containerRef,
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone"
    }, formatMessage($9d9e3819b520b47c$var$messages.transitionTo));
};
var $9d9e3819b520b47c$export$2e2bcd8739ae039 = $9d9e3819b520b47c$var$ColumnTransitionToZone;
const $9d9e3819b520b47c$var$ttZoneHeight = (0, $iIzf3.minCardHeight) * 0.5 - 5;
const $9d9e3819b520b47c$var$ttZoneMargin = (0, $iIzf3.layout).adg3smallGutter * 0.5;
const $9d9e3819b520b47c$var$ttZoneMarginTop = -($9d9e3819b520b47c$var$ttZoneHeight + (0, $iIzf3.layout).adg3smallGutter); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9d9e3819b520b47c$var$TransitionToZoneControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-5ashvn-0"
})`position:sticky;text-align:center;pointer-events:all !important;top:0;margin:${$9d9e3819b520b47c$var$ttZoneMarginTop}px ${$9d9e3819b520b47c$var$ttZoneMargin}px ${$9d9e3819b520b47c$var$ttZoneMargin}px;border:2px solid ${(props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $PdmhA).B300})` : `var(--ds-border-brand, ${(0, $PdmhA).B100})`};background-color:${(props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).B75})` : `var(--ds-background-selected, ${(0, $PdmhA).B50})`};height:${$9d9e3819b520b47c$var$ttZoneHeight}px;line-height:${$9d9e3819b520b47c$var$ttZoneHeight}px;width:calc(100% - ${(0, $iIzf3.layout).adg3smallGutter * 1.5}px);z-index:10;border-radius:${(0, $iIzf3.layout).cardListRadius}px;`;
const $9d9e3819b520b47c$var$TransitionToZoneExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u _2rkoi2wt",
            __cmplp.isDraggingOver ? "_19itoh42" : "_19itoh42",
            __cmplp.isDraggingOver ? "_bfhkwtfv" : "_bfhk29zg",
            __cmplp.className
        ])
    });
});
const $9d9e3819b520b47c$var$TransitionToZone = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $9d9e3819b520b47c$var$TransitionToZoneExperiment, $9d9e3819b520b47c$var$TransitionToZoneControl);

});

parcelRegister("IWUIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d15b443c6722a1$export$2e2bcd8739ae039);

var $4iQEO = parcelRequire("4iQEO");
var $e8d15b443c6722a1$export$2e2bcd8739ae039 = (0, $4iQEO.ColumnTransitionZone);

});
parcelRegister("4iQEO", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZone", () => $e29b7c5ae96b7ec1$export$627a5fcef77c9034);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eo9PV = parcelRequire("eo9PV");

var $PdmhA = parcelRequire("PdmhA");

var $hKj4G = parcelRequire("hKj4G");

var $dkPd7 = parcelRequire("dkPd7");


var $iIzf3 = parcelRequire("iIzf3");

var $jYyfN = parcelRequire("jYyfN");
const $e29b7c5ae96b7ec1$export$627a5fcef77c9034 = ({ onDragOver: onDragOverProp, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden, LabelComponent: LabelComponent = (0, $jYyfN.default), targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, hideSourceStatusInLabel: hideSourceStatusInLabel, onTransitionSelection: onTransitionSelection, columnId: columnId, swimlaneId: swimlaneId })=>{
    const zoneRef = (0, $eUqFw.useRef)(null);
    const previousInputPosition = (0, $eUqFw.useRef)(null);
    const autobatch = (0, $hKj4G.useAutobatch)();
    const onDragOver = (0, $dkPd7.useEvent)(onDragOverProp);
    const [isDraggingOver, setIsDraggingOver] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!zoneRef.current) return undefined;
        return (0, $eo9PV.dropTargetForElements)({
            element: zoneRef.current,
            getData: ()=>({
                    type: (0, $df03f3fe1f111432$export$2927f4d423091b16),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    transitionId: transitionId
                }),
            onDragEnter: ()=>{
                onDragOver(transitionId, false);
                setIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    onDragOver(transitionId, true);
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                onDragOver(null, false);
                setIsDraggingOver(false);
            },
            onDrop: ()=>{
                if (isHidden || !isTransitionAvailable) return;
                autobatch(()=>onTransitionSelection(transitionId));
            }
        });
    }, [
        autobatch,
        columnId,
        isHidden,
        isTransitionAvailable,
        onTransitionSelection,
        swimlaneId,
        transitionId,
        onDragOver
    ]);
    const labelEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LabelComponent, {
        source: hideSourceStatusInLabel ? null : transitionName,
        sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
        target: targetStatusName,
        targetStatusCategory: targetStatusCategory,
        isTransitionAvailable: isTransitionAvailable,
        isTransitionGlobal: isTransitionGlobal,
        showMessage: false,
        notAvailableMessage: notAvailableMessage
    });
    const commonProps = {
        isDraggingOver: isDraggingOver,
        isTransitionAvailable: isTransitionAvailable
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29b7c5ae96b7ec1$export$2de257552dc02bf, {
        ref: zoneRef,
        ...commonProps,
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container",
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
    }, labelEl);
};
const $e29b7c5ae96b7ec1$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e29b7c5ae96b7ec1$var$borderRadius = `${(0, $iIzf3.layout).cardListRadius}px`;
const $e29b7c5ae96b7ec1$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $PdmhA).B300})` : `var(--ds-border-focused, ${(0, $PdmhA).B200})`;
const $e29b7c5ae96b7ec1$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).B75})` : `var(--ds-background-selected, ${(0, $PdmhA).B50})`;
const $e29b7c5ae96b7ec1$var$getBorder = (props)=>({
        border: `${$e29b7c5ae96b7ec1$var$borderWidth}px solid ${!props.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})` : $e29b7c5ae96b7ec1$var$getAvailableBorderColour(props)}`
    });
const $e29b7c5ae96b7ec1$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? `var(--ds-background-danger, ${(0, $PdmhA).R50})` : $e29b7c5ae96b7ec1$var$getDraggingBackgroundColour(props)}`
    });
const $e29b7c5ae96b7ec1$export$2de257552dc02bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rkfzum": (0, $9t7rW.default)(`${$e29b7c5ae96b7ec1$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})` : $e29b7c5ae96b7ec1$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $9t7rW.default)($e29b7c5ae96b7ec1$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $9t7rW.default)($e29b7c5ae96b7ec1$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19it31oo _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhktaeo" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});
const $e29b7c5ae96b7ec1$export$7ed12d2a5241e393 = {
    getBackgroundColor: $e29b7c5ae96b7ec1$var$getBackgroundColor,
    getBorder: $e29b7c5ae96b7ec1$var$getBorder
};

});
parcelRegister("dkPd7", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $e657ee26e376985d$export$90fc3a17d93f704c);

var $eUqFw = parcelRequire("eUqFw");
const $e657ee26e376985d$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $eUqFw.useRef)(callback);
    (0, $eUqFw.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $eUqFw.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("jYyfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb30df01bb48e09$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cSu9v = parcelRequire("cSu9v");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $3ySoA = parcelRequire("3ySoA");

var $giAhk = parcelRequire("giAhk");

var $2mx1l = parcelRequire("2mx1l");
const $3cb30df01bb48e09$var$ColumnTransitionLabel = /*#__PURE__*/ (0, $eUqFw.memo)(({ source: source, target: target, targetStatusCategory: targetStatusCategory, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, showMessage: showMessage, sourceStatus: sourceStatus, intl: { formatMessage: formatMessage } })=>{
    const shouldRenderSource = source || sourceStatus; /**
                                                      * check null against the source and the sourceStatus.
                                                      * if they are all null. Do not display the source and arrow
                                                      * e.g.
                                                      * label with source: TO DO -> IN PROGRESS
                                                      * label without source: IN PROGRESS
                                                      */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelPositioningWrapper, {
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.label.label-positioning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$TransitionRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineWrapper, null, shouldRenderSource && isTransitionGlobal && sourceStatus?.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, source)), shouldRenderSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: "arrow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$InlineFlex, null, !isTransitionAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2mx1l))),
        role: "presentation",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: formatMessage(notAvailableMessage),
        primaryColor: `var(--ds-text-danger, ${(0, $PdmhA).R500})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: targetStatusCategory,
        name: target,
        isFullWidth: !shouldRenderSource
    }))), !isTransitionAvailable && showMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cb30df01bb48e09$var$LabelMessage, null, formatMessage(notAvailableMessage))));
});
var $3cb30df01bb48e09$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($3cb30df01bb48e09$var$ColumnTransitionLabel);
const $3cb30df01bb48e09$var$LabelRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _p12f1osq _1bto1l2s _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$LabelPositioningWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _p12f1osq _1bto1l2s _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$InlineWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _p12fn7od _o572n7od _1bto1l2s _s7n4nkob",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$TransitionRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$InlineFlex = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o572n7od _1bto1l2s _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cb30df01bb48e09$var$LabelMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _y3gn1h6o _1wyb1skh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2mx1l", function(module, exports) {
module.exports = new URL("rule.b492f5a7.svg", import.meta.url).toString();

});




const $9f45f53a8ada9764$export$c28377001f14d9d = 350;
const $9f45f53a8ada9764$export$b2112118f902d683 = 45;



parcelRegister("aL9gA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f37f08c0e21152a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2f37f08c0e21152a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notAvailableMessage: {
        "id": "work-management-board.board.column.transition-zones.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    }
});

});



parcelRegister("93B7g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3b550c20ac3c2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $7b3b550c20ac3c2a$var$AsyncColumnCreate = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gI97K")), {
    moduleId: "./src/packages/business/board/view/src/ui/board/column-create/main.tsx"
});
const $7b3b550c20ac3c2a$var$ColumnCreate = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.column-create",
        packageName: "async.jira-business.board.column-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "column-create",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3b550c20ac3c2a$var$AsyncColumnCreate, null)));
var $7b3b550c20ac3c2a$export$2e2bcd8739ae039 = $7b3b550c20ac3c2a$var$ColumnCreate;

});
parcelRegister("gI97K", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2bqwA');
        const value = parcelRequire('cDtxQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2bqwA").then(()=>parcelRequire('cDtxQ'));
}

});


parcelRegister("1trHT", function(module, exports) {

$parcel$export(module.exports, "EmptyBoardComponent", () => $49d4432f08b2a361$export$7f64d91ed0b9fc41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $liMZ5 = parcelRequire("liMZ5");

var $1p0YA = parcelRequire("1p0YA");
const $49d4432f08b2a361$export$7f64d91ed0b9fc41 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const emptyBoardTitle = formatMessage((0, $1p0YA.default).emptyBoardTitle);
    const emptyBoardDescription = formatMessage((0, $1p0YA.default).emptyBoardDescription);
    const buttonTitle = formatMessage((0, $1p0YA.default).emptyBoardCreateItem);
    const [, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const handleItemCreateClick = (0, $eUqFw.useCallback)((_e)=>{
        setInlineCreateParam('true');
    }, [
        setInlineCreateParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$EmptyBoardImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $liMZ5.Illustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $49d4432f08b2a361$var$emptyBoardTextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49d4432f08b2a361$var$Header, null, emptyBoardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, emptyBoardDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        testId: "work-management-board.ui.board.empty-state.today",
        onClick: handleItemCreateClick
    }, buttonTitle));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1kdj _vchhusvi _y3gn1h6o _1yt41ejb _11q71xtf _2rkopd34",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$EmptyBoardImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $49d4432f08b2a361$var$emptyBoardTextContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300',
    marginTop: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49d4432f08b2a361$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("liMZ5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $c9ea171949fd4dce$export$d43c2e2ca9b2c105);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $c9ea171949fd4dce$var$LazyIllustration = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gzQni")), {
    moduleId: "./src/packages/business/board/view/src/ui/board/empty-state/illustration/main.tsx"
});
const $c9ea171949fd4dce$export$d43c2e2ca9b2c105 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "illustration",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9ea171949fd4dce$var$LazyIllustration, null));

});
parcelRegister("gzQni", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eKTkT');
        const value = parcelRequire('h9qIC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eKTkT").then(()=>parcelRequire('h9qIC'));
}

});


parcelRegister("1p0YA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c065432f6984cb03$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c065432f6984cb03$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyBoardTitle: {
        "id": "work-management-board.board.empty-state.empty-board-title",
        "defaultMessage": "Visualize your work with a board"
    },
    emptyBoardDescription: {
        "id": "work-management-board.board.empty-state.empty-board-description",
        "defaultMessage": "Track, organize and prioritize your team\u2019s work. Get started by creating an item for your team. "
    },
    emptyBoardCreateItem: {
        "id": "work-management-board.board.empty-state.empty-board-create-item",
        "defaultMessage": "Create an item"
    }
});

});


parcelRegister("2TjqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c54a0bc054f9270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $9pngN = parcelRequire("9pngN");

var $kAck0 = parcelRequire("kAck0");

var $jK1pm = parcelRequire("jK1pm");

var $gKXju = parcelRequire("gKXju");
const $6c54a0bc054f9270$var$MINIMAP_MAP_HEIGHT = 36;
const $6c54a0bc054f9270$var$MIN_SCALING_FACTOR = 14;
const $6c54a0bc054f9270$var$MAX_MAP_WIDTH = 100;
const $6c54a0bc054f9270$var$SHOW_MAP_RATIO = 1.1;
const $6c54a0bc054f9270$var$getScalingFactor = (updatedScrollWidth)=>{
    const maxSizeScalingFactor = updatedScrollWidth / $6c54a0bc054f9270$var$MAX_MAP_WIDTH;
    return Math.max($6c54a0bc054f9270$var$MIN_SCALING_FACTOR, maxSizeScalingFactor);
};
const $6c54a0bc054f9270$var$Minimap = ({ boardContentElement: boardContentElement, scrollElement: scrollElement })=>{
    const [scrollLeft, setScrollLeft] = (0, $eUqFw.useState)(0);
    const [scrollWrapperWidth, setScrollWrapperWidth] = (0, $eUqFw.useState)(scrollElement?.clientWidth ?? 0);
    const [contentWrapperWidth, setContentWrapperWidth] = (0, $eUqFw.useState)(boardContentElement?.clientWidth ?? 0);
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const [mouseStart, setMouseStart] = (0, $eUqFw.useState)(null);
    const [initialOffset, setInitialOffset] = (0, $eUqFw.useState)(0);
    const innerViewRef = (0, $eUqFw.useRef)(null);
    const groups = (0, $gKXju.useGroups)();
    const scalingFactor = $6c54a0bc054f9270$var$getScalingFactor(contentWrapperWidth);
    const outerWidth = contentWrapperWidth / scalingFactor;
    const innerWidth = scrollWrapperWidth / scalingFactor;
    const innerOffset = scrollLeft / scalingFactor;
    const onMouseDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.button === 0) {
            setIsDragging(true);
            setMouseStart(e.clientX);
            setInitialOffset(innerOffset);
        }
    }, [
        innerOffset
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        if (isDragging) setIsDragging(false);
    }, [
        isDragging
    ]);
    const setHorizontalScroll = (0, $eUqFw.useCallback)((newOffset)=>{
        scrollElement?.scrollTo(newOffset, scrollElement?.scrollTop);
    }, [
        scrollElement
    ]);
    const onScroll = (0, $eUqFw.useCallback)((newOffset)=>{
        const newScalingFactor = $6c54a0bc054f9270$var$getScalingFactor(contentWrapperWidth);
        setHorizontalScroll(newOffset * newScalingFactor);
    }, [
        contentWrapperWidth,
        setHorizontalScroll
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((e)=>{
        if (isDragging && mouseStart !== null) {
            const mouseCurrent = e.clientX;
            onScroll(initialOffset + mouseCurrent - mouseStart);
        }
    }, [
        initialOffset,
        isDragging,
        mouseStart,
        onScroll
    ]);
    const cleanupListeners = (0, $eUqFw.useCallback)(()=>{
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp
    ]);
    const updateInnerViewPosition = (0, $eUqFw.useCallback)(()=>{
        if (innerViewRef.current) innerViewRef.current.style.marginLeft = `${innerOffset}px`;
    }, [
        innerOffset
    ]);
    const handleMinimapRef = (0, $eUqFw.useCallback)((ref)=>{
        innerViewRef.current = ref;
        updateInnerViewPosition();
    }, [
        updateInnerViewPosition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleScroll = ()=>{
            setScrollLeft(scrollElement?.scrollLeft ?? 0);
        };
        const scrollElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setScrollWrapperWidth(entry.contentRect.width);
        });
        if (scrollElement) scrollElementResizeObserver.observe(scrollElement);
        const boardContentElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setContentWrapperWidth(entry.contentRect.width);
        });
        if (boardContentElement) boardContentElementResizeObserver.observe(boardContentElement);
        scrollElement?.addEventListener('scroll', handleScroll);
        return ()=>{
            scrollElement?.removeEventListener('scroll', handleScroll);
            scrollElementResizeObserver.disconnect();
            boardContentElementResizeObserver.disconnect();
        };
    }, [
        scrollElement,
        boardContentElement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isDragging) {
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        } else cleanupListeners();
        return ()=>{
            cleanupListeners();
        };
    }, [
        cleanupListeners,
        isDragging,
        onMouseMove,
        onMouseUp
    ]);
    if (!(contentWrapperWidth / scrollWrapperWidth > $6c54a0bc054f9270$var$SHOW_MAP_RATIO)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$MinimapWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6c54a0bc054f9270$var$RelativePositionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$InnerViewStyle, {
        innerWidth: innerWidth,
        isDragging: isDragging,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        ref: handleMinimapRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c54a0bc054f9270$var$OuterViewStyle, {
        outerWidth: outerWidth
    }, groups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAck0.default), {
            key: group.id
        }))))));
};
const $6c54a0bc054f9270$var$RelativePositionStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c54a0bc054f9270$var$MinimapWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rkogqwt _16qsacve _1e0c116y _1yt412x7",
            __cmplp.className
        ])
    });
});
const $6c54a0bc054f9270$var$OuterViewStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerWidth: outerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qlyx8j": (0, $9t7rW.default)(`${__cmplp.outerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it1dk9 _2rko1l7b _1e0c1txw _4t3i14no _1bsbrmio",
            __cmplp.className
        ])
    });
});
const $6c54a0bc054f9270$var$InnerViewStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, innerWidth: innerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1u36uo4": (0, $9t7rW.default)(`${__cmplp.innerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itypf5 _2rko1l7b _80om15ng _4t3i14no _1ltv1n1a _kqswstnw _154i1n1a _1bsb1545",
            __cmplp.isDragging ? "_1h6d194a" : "_1h6d1gvp",
            __cmplp.className
        ])
    });
});
var $6c54a0bc054f9270$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6c54a0bc054f9270$var$Minimap);

});
parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kAck0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e202a8c3d4fe742$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
// eslint-disable-next-line jira/compiled/styled-components-usages, @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e202a8c3d4fe742$var$SC1Control = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wm91pe-0"
})({
    borderRadius: '3px',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-neutral, ${(0, $PdmhA).N30})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + div': {
        marginLeft: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e202a8c3d4fe742$var$SC1Experiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _11q71yrq _1s87v77o",
            __cmplp.className
        ])
    });
});
const $7e202a8c3d4fe742$var$SC1 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7e202a8c3d4fe742$var$SC1Experiment, $7e202a8c3d4fe742$var$SC1Control);
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$7e202a8c3d4fe742$export$2e2bcd8739ae039 = $7e202a8c3d4fe742$var$SC1;

});



parcelRegister("6MNdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58184efd11c4a3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7rh0R = parcelRequire("7rh0R");

var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $gCyQH = parcelRequire("gCyQH");

var $4G5xU = parcelRequire("4G5xU");

var $41WOo = parcelRequire("41WOo");

var $kiBzn = parcelRequire("kiBzn");
var $96etS = parcelRequire("96etS");

var $kHnEs = parcelRequire("kHnEs");
var $9u6Jh = parcelRequire("9u6Jh");
var $fibAs = parcelRequire("fibAs");

var $5I9Im = parcelRequire("5I9Im");

var $8o3tu = parcelRequire("8o3tu");

var $bcWyL = parcelRequire("bcWyL");
var $6HWvN = parcelRequire("6HWvN");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $eeJbA = parcelRequire("eeJbA");

var $eRpjy = parcelRequire("eRpjy");

var $90G8g = parcelRequire("90G8g");


var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $hJ992 = parcelRequire("hJ992");

var $3hjaO = parcelRequire("3hjaO");
var $fkLhx = parcelRequire("fkLhx");

var $gGtKh = parcelRequire("gGtKh");


var $2hsXd = parcelRequire("2hsXd");
var $hmyz0 = parcelRequire("hmyz0");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $84CBi = parcelRequire("84CBi");

var $fa2D3 = parcelRequire("fa2D3");

var $ib4WI = parcelRequire("ib4WI");

var $46lXM = parcelRequire("46lXM");

var $jRisP = parcelRequire("jRisP");

var $b8XnM = parcelRequire("b8XnM");

var $jFt8B = parcelRequire("jFt8B");

var $l6iPu = parcelRequire("l6iPu");

var $kOAHo = parcelRequire("kOAHo");

var $d4amQ = parcelRequire("d4amQ");

var $23ARm = parcelRequire("23ARm");

var $9tAOR = parcelRequire("9tAOR");

var $4Z3mK = parcelRequire("4Z3mK");

var $3jaqr = parcelRequire("3jaqr");

var $4Cd42 = parcelRequire("4Cd42");

var $a6Eha = parcelRequire("a6Eha");

var $2b5eO = parcelRequire("2b5eO");

var $iXHUp = parcelRequire("iXHUp");

var $fs90m = parcelRequire("fs90m");

var $ECWEt = parcelRequire("ECWEt");

var $dnPUB = parcelRequire("dnPUB");

var $lqN6D = parcelRequire("lqN6D");

var $damhm = parcelRequire("damhm");

var $5jiln = parcelRequire("5jiln");

var $iJHpR = parcelRequire("iJHpR");

var $ebQXE = parcelRequire("ebQXE");

var $jOkkZ = parcelRequire("jOkkZ");

var $b5yGB = parcelRequire("b5yGB");

var $fdj8N = parcelRequire("fdj8N");

var $gOfjZ = parcelRequire("gOfjZ");
const $a58184efd11c4a3c$export$957605bae9e497ab = ()=>{
    const [columnsHeight, setColumnsHeight] = (0, $eUqFw.useState)();
    return [
        columnsHeight,
        setColumnsHeight
    ];
};
const $a58184efd11c4a3c$export$6c00e99731ab8283 = ()=>(0, $eUqFw.useRef)(null);
const $a58184efd11c4a3c$export$e5fb3e4929c41494 = ()=>(0, $eUqFw.useRef)(null); // extracted method for testing
const $a58184efd11c4a3c$export$467ee56386e96a1d = (snapshot, columns)=>{
    const columnId = snapshot?.draggingFromThisWith?.split('COLUMN::')[1];
    return columns.findIndex((col)=>columnId != null && (col.id === columnId || col.id === Number(columnId)));
};

const $a58184efd11c4a3c$export$e5994d62cb6062b6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cgQqU")), {
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-create/index.tsx"
}); // eslint-disable-next-line complexity
const $a58184efd11c4a3c$var$JWMBoard = ()=>{
    const [issueToDelete, setIssueToDelete] = (0, $eUqFw.useState)(null);
    const resetIssueToDelete = (0, $eUqFw.useCallback)(()=>setIssueToDelete(null), []);
    const { featureView: featureView, isOnboardingEnabled: isOnboardingEnabled } = (0, $2b5eO.useJWMBoardFeatures)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const isTeamManaged = projectData.isSimplified;
    const deleteIssueAllowed = projectData.permissions.deleteIssues;
    const [, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $4TJj0.useCollabStore)();
    (0, $d4amQ.useBoardSubtasks)();
    const { isFiltering: isFiltering, isLoading: isLoadingFilters } = (0, $dnPUB.useBoardFilters)();
    const [{ columnToDelete: columnToDelete }, { setColumnToDelete: setColumnToDelete, updateIssue: updateIssue }] = (0, $lqN6D.useBoardStore)();
    const [filtersPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const { addConfettiColumn: addConfettiColumn } = (0, $3jaqr.useConfettiColumnActions)();
    const { shouldRenderExperiment: automationDiscoveryEnabled } = (0, $41WOo.isAutomationDiscoveryOnBoardColumnsExperimentEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fkLhx.useJwmAutomationDiscoveryOnBoardColumnsExperiment)(true) : {
        shouldRenderExperiment: false
    }; // Making sure Filter values query doesn't block page rendering when filter is not applied
    const isLoadingFiltersState = Boolean(filtersPreference) && isLoadingFilters;
    const { columns: columns, issues: issues, onRemoveIssue: onRemoveIssue } = (0, $jFt8B.useBoardController)();
    const { loading: loading, error: error } = (0, $l6iPu.useInitializeBoard)();
    const [initialPageLoading, setInitialpageLoading] = (0, $eUqFw.useState)(loading || isLoadingFiltersState);
    (0, $eUqFw.useEffect)(()=>{
        if (initialPageLoading && !loading && !isLoadingFiltersState) setInitialpageLoading(false);
    }, [
        initialPageLoading,
        isLoadingFiltersState,
        loading
    ]);
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const ufoPressTracing = (0, $fa2D3.default)('jwm.board.issue-view-opened');
    const [columnsHeight, setColumnsHeight] = $a58184efd11c4a3c$export$957605bae9e497ab();
    const { onDragStart: onDragStart, onDragEnd: onDragEnd, onCardsMove: onCardsMove, onDragUpdate: onDragUpdate } = (0, $4Z3mK.useCardTransitionsOld)();
    const [areAnyColumnsUpdating] = (0, $lqN6D.useAreAnyColumnsUpdating)();
    const { onColumnMove: onColumnMove } = (0, $a6Eha.useColumnMoveHandlerOld)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const [inlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    const [{ openInSidebar: openInSidebar }] = (0, $fibAs.useIssueAppSwitcher)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const viewMode = (0, $1ybV0.ff)('refactor-bento-view-mode-logic') ? (0, $hJ992.useViewMode)() : null;
    const isViewModeSideBar = (0, $1ybV0.ff)('refactor-bento-view-mode-logic') ? viewMode === (0, $935e771f19f8ea28$export$705305d6da432040) : openInSidebar;
    const shouldShowEmbedOnboarding = !isFiltering && inlineCreateParam == null && selectedIssueKey == null && isOnboardingEnabled && issues.length >= 3;
    const onIssueClick = (0, $eUqFw.useCallback)((issue, withCmd)=>{
        if (issue.id && issue.key) {
            if (withCmd) window.open(`/browse/${issue.key}`, '_blank');
            else {
                ufoPressTracing();
                setSelectedIssueKey(issue.key);
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: `${issue.id}`
                });
                sendNodeSelected({
                    nodeId: nodeId
                });
            }
        }
    }, [
        projectId,
        sendNodeSelected,
        setSelectedIssueKey,
        ufoPressTracing
    ]);
    const [, forceUpdate] = (0, $eUqFw.useReducer)((x)=>x + 1, 0);
    const optimisticColumnMove = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    (...args)=>{
        // Something is causing react to bail out immediately after column move updates states.
        // This is temporary until we revisit this again on JET-2387.
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        onColumnMove(...args);
        forceUpdate();
    }, [
        onColumnMove
    ]);
    const optimisticCardMove = (0, $eUqFw.useCallback)((cardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex)=>{
        onCardsMove(cardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex).then(()=>{
            const eligibleConfettiDoneColumns = columns.filter((column)=>column.isDone && !column.isCollapsed);
            const eligibleConfettiEmojiColumns = columns.filter((column)=>(0, $4Cd42.matchConfettiEmoji)(column.name) && !column.isCollapsed);
            const isMovedToDone = eligibleConfettiDoneColumns.some((column)=>column.id === destinationColumnId);
            const wasPreviouslyDone = eligibleConfettiDoneColumns.some((column)=>column.id === sourceColumnId);
            const isMovedToEmojiColumn = eligibleConfettiEmojiColumns.some((column)=>column.id === destinationColumnId);
            const isNewlyDoneIssue = isMovedToDone && !wasPreviouslyDone;
            if (isNewlyDoneIssue || isMovedToEmojiColumn) {
                addConfettiColumn(Number(destinationColumnId));
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'boardConfetti created', {
                    columnType: isNewlyDoneIssue ? 'done' : 'emoji',
                    columnId: destinationColumnId
                });
            }
        }).catch((e)=>{
            // do not show an error for an invalid move, it has not sent a request to the backend
            // or if the error is undefined, it means that the move was canceled
            if (!e || e instanceof (0, $ib4WI.InvalidMove)) return;
            const errorMessage = e instanceof (0, $7byHA.ValidationError) ? e.message : null;
            showFlag({
                type: 'error',
                title: (0, $damhm.default).itemMoveErrorTitle,
                description: errorMessage ?? (0, $damhm.default).itemMoveErrorMessage
            });
        });
        forceUpdate();
    }, [
        onCardsMove,
        showFlag,
        columns,
        addConfettiColumn,
        createAnalyticsEvent
    ]);
    const columnHasNoIssues = columns.filter((column)=>column.issues.length > 0).length === 0;
    const isBoardEmptyAfterFilter = columnHasNoIssues && (isFiltering || isSearching) && !initialPageLoading;
    const isBoardEmpty = columnHasNoIssues && !isFiltering && !initialPageLoading;
    const onIssueModalClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // when issueKey param is removed from URL we need to clear node selection
        if (selectedIssueKey === undefined && prevSelectedIssueKey != null) {
            const issue = issues.find((item)=>item.key === prevSelectedIssueKey);
            if (issue) {
                const nodeId = (0, $i0nxo.getPresenceNodeId)({
                    projectId: projectId,
                    viewId: 'board',
                    nodeId: `${issue.id}`
                });
                sendClearNodeSelection({
                    nodeId: nodeId
                });
            }
        }
    }, [
        issues,
        prevSelectedIssueKey,
        projectId,
        selectedIssueKey,
        sendClearNodeSelection,
        sendNodeSelected
    ]);
    const onDeleteSuccess = (0, $eUqFw.useCallback)(({ issueId: issueId })=>onRemoveIssue(Number(issueId)), [
        onRemoveIssue
    ]);
    const onBentoChange = (0, $eUqFw.useCallback)((event)=>updateIssue(Number(event.issueId), {
            needsExtendedFieldsUpdate: true
        }), [
        updateIssue
    ]); // Memoised to prevent flicker on JIRT updates
    const issueModal = (0, $eUqFw.useMemo)(()=>selectedIssueKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onIssueModalClose,
            analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e),
            onDeleteSuccess: onDeleteSuccess,
            onChange: onBentoChange
        }), [
        selectedIssueKey,
        onIssueModalClose,
        onDeleteSuccess,
        onBentoChange
    ]);
    const scrollRef = $a58184efd11c4a3c$export$e5fb3e4929c41494();
    const columnsRef = $a58184efd11c4a3c$export$6c00e99731ab8283();
    const [, { setScrollElement: setScrollElement }] = (0, $ECWEt.useScrollElementStore)();
    const issueActions = (0, $eUqFw.useMemo)(()=>({
            onIssueClick: onIssueClick,
            onIssueDelete: setIssueToDelete,
            isDeleteIssueAllowed: deleteIssueAllowed
        }), [
        deleteIssueAllowed,
        onIssueClick
    ]);
    const columnRenderer = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'column' implicitly has an 'any' type. | TS7031 - Binding element 'columnIndex' implicitly has an 'any' type. | TS7031 - Binding element 'boardSize' implicitly has an 'any' type. | TS7031 - Binding element 'isVirtualized' implicitly has an 'any' type.
    ({ column: column, columnIndex: columnIndex, boardSize: boardSize, isVirtualized: isVirtualized })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHpR.default), {
            key: column.name,
            column: column,
            columnIndex: columnIndex,
            scrollRef: scrollRef,
            isVirtualized: isVirtualized,
            boardSize: boardSize
        }), [
        scrollRef
    ]);
    const renderDraggableColumn = (0, $eUqFw.useCallback)((provided, snapshot, rubric)=>{
        const column = columns[rubric.source.index];
        if (!column || !scrollRef.current) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdj8N.DraggingColumn), {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHpR.default), {
            isClone: true,
            key: column.name,
            column: column,
            columnIndex: rubric.source.index,
            scrollRef: scrollRef,
            isDragging: snapshot.isDragging
        }));
    }, [
        columns,
        scrollRef
    ]);
    const getDraggingColumnIndex = (0, $eUqFw.useCallback)((snapshot)=>$a58184efd11c4a3c$export$467ee56386e96a1d(snapshot, columns), [
        columns
    ]);
    const onDragEndFn = (0, $eUqFw.useCallback)((dragStop)=>{
        onDragEnd(dragStop);
        setColumnsHeight(undefined);
    }, [
        onDragEnd,
        setColumnsHeight
    ]);
    const onBeforeCaptureFn = (0, $eUqFw.useCallback)((beforeCapture)=>{
        if (beforeCapture?.draggableId.startsWith((0, $df03f3fe1f111432$export$57d0ef745f304b91)) && columnsRef.current != null) {
            setColumnsHeight(columnsRef.current.offsetHeight);
            if (scrollRef.current) scrollRef.current.scrollTop = 0;
        }
    }, [
        columnsRef,
        scrollRef,
        setColumnsHeight
    ]);
    const onColumnCreateValidate = (0, $eUqFw.useCallback)((_, name)=>(0, $46lXM.validateColumnName)(columns, name), [
        columns
    ]);
    const { addNewColumn: addNewColumn } = (0, $b8XnM.useAddColumn)();
    const onColumnCreateSubmit = (0, $eUqFw.useCallback)((_, columnName)=>{
        addNewColumn({
            columnName: columnName
        });
    }, [
        addNewColumn
    ]);
    const handleScrollRef = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ref' implicitly has an 'any' type.
    (ref)=>{
        scrollRef.current = ref;
        setScrollElement(ref);
    }, [
        scrollRef,
        setScrollElement
    ]);
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCyQH.ErrorPage), {
        error: error
    }));
    const BoardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hsXd.default), {
        dropZoneMode: "virtual",
        noBottomPadding: true,
        offsetLeftPaddingByWidth: true,
        offsetRightPaddingByWidth: true // @ts-expect-error - TS2769 - No overload matches this call.
        ,
        renderClone: renderDraggableColumn,
        scrollRef: handleScrollRef
    }, (placeHolder, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fs90m.default).Provider, {
            value: issueActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gOfjZ.default), {
            scrollRef: scrollRef,
            columns: columns,
            columnRenderer: columnRenderer,
            draggingColumnIndex: getDraggingColumnIndex(snapshot),
            columnsHeight: columnsHeight,
            columnsRef: columnsRef
        }), isTeamManaged && (!groupBy || groupBy === (0, $jGcn0.GROUP_BY_STATUS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "async.jira-business.board.column-create",
            packageName: "async.jira-business.board.column-create"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "column-create",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a58184efd11c4a3c$export$e5994d62cb6062b6, {
            isDisabled: areAnyColumnsUpdating,
            validate: onColumnCreateValidate,
            onSubmit: onColumnCreateSubmit
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a58184efd11c4a3c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, initialPageLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "board-container-initial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdj8N.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-content-old"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a58184efd11c4a3c$var$BoardContainer, {
        isBoardEmpty: isBoardEmpty || isBoardEmptyAfterFilter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hmyz0.default), {
        onColumnMove: optimisticColumnMove,
        onCardsMove: optimisticCardMove,
        onDragStart: onDragStart,
        onDragEnd: onDragEndFn,
        onDragUpdate: onDragUpdate,
        onBeforeCapture: onBeforeCaptureFn,
        sensors: [
            (0, $9tAOR.useCardAnimationSensor)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a58184efd11c4a3c$var$BoardWrapper, {
        featureView: featureView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRisP.ActionsMenuPopupProvider), null, automationDiscoveryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hjaO.AutomationDiscoveryProvider), {
        columns: columns
    }, BoardContent) : BoardContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5yGB.Minimap), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null))), isBoardEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOkkZ.EmptyBoardComponent), null) : null, isBoardEmptyAfterFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiBzn.ThemedFilterEmptyState), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23ARm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kOAHo.BoardIssueDetailsOld), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebQXE.default), {
        issue: issueToDelete,
        onClose: resetIssueToDelete
    }), columnToDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jiln.default), {
        column: columnToDelete,
        onColumnDeleteModalClose: ()=>setColumnToDelete(null),
        columns: columns
    }), isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        onChange: onBentoChange,
        issueKey: selectedIssueKey,
        onClose: onIssueModalClose,
        analyticsSource: (0, $0100842672acae20$export$b2c0462ff17aa26e),
        onIssueDeleteSuccess: onDeleteSuccess
    }) : issueModal, shouldShowEmbedOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8o3tu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcWyL.PerformanceAnalytics), {
        view: featureView,
        loading: initialPageLoading,
        itemsCount: issues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeJbA.SignupInviteModal), null), (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null)));
};
var $a58184efd11c4a3c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a58184efd11c4a3c$var$JWMBoard;
const $a58184efd11c4a3c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a58184efd11c4a3c$var$BoardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isBoardEmpty: isBoardEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4t3i1osq",
            __cmplp.isBoardEmpty ? "_c71l9rak" : "_c71lglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a58184efd11c4a3c$var$BoardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { featureView: featureView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kc5rmu": (0, $9t7rW.default)(`min(
                  100%,
${''}
                  calc(100vh - ${(0, $ib4WI.BOARD_VIEW_COLUMNS_OFFSET)[__cmplp.featureView] - 4}px)
              ) `)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1ul9idpf _kqswh2mm _syaz1fxt _18u0196n _7ta815vq _m76i15vq _vw7ojg8v _1jn0jg8v _1863t4lq _17hj1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8o3tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ec24cb8e2df5ada$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5ec24cb8e2df5ada$var$BoardEmbedOnboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8P3wY")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/onboarding/board-embed/src/ui/main.tsx"
});
const $5ec24cb8e2df5ada$var$BoardEmbedOnboardingAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.onboarding.board-embed",
        packageName: "jira-business.onboarding.board-embed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "board-embed-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ec24cb8e2df5ada$var$BoardEmbedOnboarding, null)));
var $5ec24cb8e2df5ada$export$2e2bcd8739ae039 = $5ec24cb8e2df5ada$var$BoardEmbedOnboardingAsync;

});
parcelRegister("8P3wY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('6QBhb')
        ]);
        const value = parcelRequire('1qy6H');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("6QBhb")
    ]).then(()=>parcelRequire('1qy6H'));
}

});


parcelRegister("2hsXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6002d5717ffcd90$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $3232H = parcelRequire("3232H");
var $iIzf3 = parcelRequire("iIzf3");
var $3ZLl3 = parcelRequire("3ZLl3");
var $lxMAR = parcelRequire("lxMAR");

var $3u9tq = parcelRequire("3u9tq");
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6002d5717ffcd90$var$BoardContainerControl = /*#__PURE__*/ (0, $kwce8.default).section.withConfig({
    componentId: "wheh1n-0"
})`display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch;user-select:none;padding:${(props)=>{
    if (props.flexibleColumns) return (0, $1ybV0.ff)('jsw.perf.cmp-column-spacing') ? `0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth - (0, $iIzf3.layout).columnMargin}px` : `0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px`;
    return `0 0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth - (0, $iIzf3.layout).cardListRadius}px`;
}};${(props)=>props.noBottomPadding ? 'padding-bottom: 0' : ''};min-width:fit-content;gap:${(props)=>props.flexibleColumns && !(0, $1ybV0.ff)('jsw.perf.cmp-column-spacing') ? `${(0, $iIzf3.layout).columnMargin * 2}px ` : 0};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6002d5717ffcd90$var$BoardContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19f1qv1": (0, $9t7rW.default)((()=>{
                if (__cmplp.flexibleColumns) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return (0, $1ybV0.ff)('jsw.perf.cmp-column-spacing') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth - (0, $iIzf3.layout).columnMargin}px` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth}px`;
                 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return `0 0 ${(0, $iIzf3.layout).boardBorderWidth}px ${(0, $iIzf3.layout).boardBorderWidth - (0, $iIzf3.layout).cardListRadius}px`;
            })())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _1bah1y6m _4cvr1fhb _uiztglyw _1yt4pws9 _1ul91ns9",
            __cmplp.noBottomPadding && "_n3tdidpf",
            __cmplp.flexibleColumns && !(0, $1ybV0.ff)('jsw.perf.cmp-column-spacing') ? "_zulp1crf" : "_zulpidpf",
            __cmplp.className
        ])
    });
});
const $e6002d5717ffcd90$var$BoardContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $e6002d5717ffcd90$var$BoardContainerExperiment, $e6002d5717ffcd90$var$BoardContainerControl);
class $e6002d5717ffcd90$export$dc537a3a3893548e extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            offsetRightPaddingByWidth: false,
            offsetLeftPaddingByWidth: false,
            noBottomPadding: false,
            onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onBoardView: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            flexibleColumns: false,
            isDropDisabled: false
        };
    }
    render() {
        const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, isDropDisabled: isDropDisabled } = this.props;
        const leftBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZLl3.LeftBorder), {
            offsetLeftPaddingByWidth: this.props.offsetLeftPaddingByWidth
        });
        const rightBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZLl3.RightBorder), {
            offsetRightPaddingByWidth: this.props.offsetRightPaddingByWidth
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3232H.default), {
            innerRef: this.props.scrollRef,
            onScroll: this.onScroll,
            onInit: this.onScrollInit,
            flexibleColumns: flexibleColumns
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3u9tq.ColumnsDroppable), {
            dropZoneMode: this.props.dropZoneMode,
            renderClone: this.props.renderClone,
            isDropDisabled: isDropDisabled
        }, ({ placeholder: placeholder, ...rest }, snapshot)=>{
            const boardInnerContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6002d5717ffcd90$var$BoardContainer, {
                ...rest,
                "data-testid": "platform-board-kit-legacy-dnd.ui.board.board-container",
                flexibleColumns: flexibleColumns,
                noBottomPadding: noBottomPadding
            }, leftBorder, this.props.children && this.props.children(placeholder, snapshot), rightBorder);
            if (flexibleColumns) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxMAR.TransitionZoneIndicatorContainerProvider), null, boardInnerContainer);
            return boardInnerContainer;
        }));
    }
    constructor(...args){
        super(...args);
        this.topEdge = true;
        this.leftEdge = true;
        this.rightEdge = true;
        this.onScrollInit = ({ hasHorizontalScrollbar: hasHorizontalScrollbar })=>{
            this.props.onBoardView({
                hasHorizontalScrollbar: hasHorizontalScrollbar
            });
        };
        this.onScroll = (scrollInfo)=>{
            const { topEdge: topEdge, leftEdge: leftEdge, rightEdge: rightEdge } = this;
            if (scrollInfo.topEdge !== topEdge) this.topEdge = scrollInfo.topEdge;
            if (scrollInfo.leftEdge !== leftEdge) this.leftEdge = scrollInfo.leftEdge;
            if (scrollInfo.rightEdge !== rightEdge) this.rightEdge = scrollInfo.rightEdge;
            const boardScrollInfo = {
                scrollLeft: scrollInfo.scrollLeft,
                scrollTop: scrollInfo.scrollTop,
                scrollWidth: scrollInfo.scrollWidth,
                clientWidth: scrollInfo.clientWidth,
                reachedLeftEdge: !leftEdge && scrollInfo.leftEdge,
                reachedRightEdge: !rightEdge && scrollInfo.rightEdge
            };
            this.props.onScroll(boardScrollInfo);
        };
    }
}
var $e6002d5717ffcd90$export$2e2bcd8739ae039 = $e6002d5717ffcd90$export$dc537a3a3893548e;

});
parcelRegister("3232H", function(module, exports) {

$parcel$export(module.exports, "default", () => $459db050db99d419$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $aACMj = parcelRequire("aACMj");

var $iIzf3 = parcelRequire("iIzf3");

var $2w3P7 = parcelRequire("2w3P7");
class $459db050db99d419$export$142e061c8a488301 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        // scrollElementHeight is used to calculate the height of transition zone
        // set to minCardHeight by default
        this.state = {
            scrollElementHeight: (0, $iIzf3.minCardHeight),
            scrollElementWidth: 0
        };
        this.scrollElementDimensionFrameId = null;
        this.scrollElementResizeCallback = ()=>{
            this.handleScrollEvent();
            this.setScrollElementDimension();
        };
        this.setScrollElementDimension = ()=>{
            if (!this.props.flexibleColumns) return;
            if (this.scrollElementDimensionFrameId != null) cancelAnimationFrame(this.scrollElementDimensionFrameId);
            this.scrollElementDimensionFrameId = requestAnimationFrame(()=>{
                const scrollElement = this.getScrollElement();
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(scrollElement) && (scrollElement.clientHeight !== this.state.scrollElementHeight || scrollElement.clientWidth !== this.state.scrollElementWidth)) this.setState({
                    scrollElementHeight: scrollElement.clientHeight,
                    scrollElementWidth: scrollElement.clientWidth
                });
            });
        };
        this.resizeObserver = null;
        this.getScrollElement = ()=>(!false ? this.scrollElRef.current : this.scrollEl) ?? window.document.body;
        this.onHorizontalScroll = (scrollLeft)=>{
            requestAnimationFrame(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement())) return;
                this.getScrollElement().scrollLeft = scrollLeft;
            });
        };
        this.setScrollEl = (scrollEl)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(scrollEl)) return;
            if (!false) this.scrollElRef.current = scrollEl;
            else this.scrollEl = scrollEl;
            // Only notify any other listeners if we have any
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.props.innerRef)) return;
            const { innerRef: innerRef } = this.props;
            if (typeof innerRef === 'function') innerRef(this.getScrollElement()); // ref={ref => someRef = ref}
            else // WindowRef passed from BoardContainer -> Board -> This
            innerRef.current = this.getScrollElement();
        };
        this.getBoardScrollPosition = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth
            };
        };
        this.getLegacyBoardScrollInfo = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0,
                leftEdge: true,
                topEdge: true,
                rightEdge: false
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth,
                leftEdge: scrollLeft === 0,
                topEdge: scrollTop === 0,
                rightEdge: scrollLeft === scrollWidth - clientWidth
            };
        };
        this.handleScrollEvent = ()=>{
            if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
            this.scrollMeasureFrameId = requestAnimationFrame(()=>{
                this.props.onBoardScroll(this.getBoardScrollPosition());
                this.props.onScroll(this.getLegacyBoardScrollInfo());
            });
        };
        this.scrollMeasureFrameId = null;
        this.scrollEl = null;
        this.scrollElRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
    componentDidMount() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement())) this.getScrollElement().addEventListener('scroll', this.handleScrollEvent);
        window.addEventListener((0, $aACMj.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        if (this.scrollElRef.current && typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.scrollElementResizeCallback);
            this.resizeObserver.observe(this.scrollElRef.current);
        }
        this.props.onBoardScrollInit(this.getBoardScrollPosition(), this.onHorizontalScroll);
        this.props.onInit({
            hasHorizontalScrollbar: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement()) && this.getScrollElement().scrollWidth > this.getScrollElement().clientWidth
        });
    }
    componentWillUnmount() {
        if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.getScrollElement())) this.getScrollElement().removeEventListener('scroll', this.handleScrollEvent);
        window.removeEventListener((0, $aACMj.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        this.resizeObserver?.disconnect();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($459db050db99d419$var$StyledBoard, {
            ref: this.setScrollEl,
            "data-testid": "platform-board-kit.ui.board.scroll.board-scroll",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                '--board-scroll-element-height': this.state.scrollElementHeight,
                '--board-scroll-element-width': this.state.scrollElementWidth
            }
        }, this.props.children));
    }
}
const $459db050db99d419$var$BoardScrollMain = (props)=>{
    const [, { onBoardScroll: onBoardScroll, onBoardScrollInit: onBoardScrollInit }] = (0, $2w3P7.useBoardScrollApi)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($459db050db99d419$export$142e061c8a488301, {
        ...props,
        onBoardScrollInit: onBoardScrollInit,
        onBoardScroll: onBoardScroll
    });
};
var $459db050db99d419$export$2e2bcd8739ae039 = $459db050db99d419$var$BoardScrollMain;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $459db050db99d419$var$StyledBoard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _c71l1osq _4t3i1osq _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _m6k4brmi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aACMj", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $fecd3763a4a086a2$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $fecd3763a4a086a2$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $fecd3763a4a086a2$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $fecd3763a4a086a2$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $fecd3763a4a086a2$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $fecd3763a4a086a2$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $fecd3763a4a086a2$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $fecd3763a4a086a2$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $fecd3763a4a086a2$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $fecd3763a4a086a2$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $fecd3763a4a086a2$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $fecd3763a4a086a2$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $fecd3763a4a086a2$export$373e09b633948dc);

const $fecd3763a4a086a2$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $fecd3763a4a086a2$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $fecd3763a4a086a2$export$fb374ae0d58ab29b = `[data-component-selector="${$fecd3763a4a086a2$export$7608524551986a84}"]`;
const $fecd3763a4a086a2$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $fecd3763a4a086a2$export$bb13afdd2dbe0316 = `[data-component-selector="${$fecd3763a4a086a2$export$c2a2d9d97661439b}"]`;
const $fecd3763a4a086a2$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $fecd3763a4a086a2$export$1be96bcf0abb2b8e = `[data-component-selector="${$fecd3763a4a086a2$export$675d25966b2d2499}"]`;
const $fecd3763a4a086a2$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $fecd3763a4a086a2$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $fecd3763a4a086a2$export$9d54b3872a1af680 = `[data-component-selector="${$fecd3763a4a086a2$export$4167d13afb6ba84b}"]`;
const $fecd3763a4a086a2$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $fecd3763a4a086a2$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $fecd3763a4a086a2$export$eb11bcee172fa7de = 'data-announced-column-header';
const $fecd3763a4a086a2$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $fecd3763a4a086a2$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});

parcelRegister("2w3P7", function(module, exports) {

$parcel$export(module.exports, "useBoardScroll", () => $efb6ae5a663abfc5$export$e8a9c7f59d1400dd);
$parcel$export(module.exports, "useBoardScrollLeft", () => $efb6ae5a663abfc5$export$42c9508d539e562f);
$parcel$export(module.exports, "useBoardHasScrollLeft", () => $efb6ae5a663abfc5$export$e9583811d4961272);
$parcel$export(module.exports, "useBoardScrollTop", () => $efb6ae5a663abfc5$export$a4a2ab28f4bdd36b);
$parcel$export(module.exports, "useBoardHasScrollTop", () => $efb6ae5a663abfc5$export$20ef285042532517);
$parcel$export(module.exports, "useBoardScrollIsAtRightEdge", () => $efb6ae5a663abfc5$export$cac9ff2d8629bfb2);
$parcel$export(module.exports, "useBoardScrollApi", () => $efb6ae5a663abfc5$export$be9b8d6afde7d0af);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $efb6ae5a663abfc5$var$actions = {
    getBoardScroll: ()=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll, ...state } = getState();
            return state;
        },
    onBoardScroll: (boardScrollPosition)=>({ setState: setState })=>{
            setState(boardScrollPosition);
        },
    onBoardScrollInit: (boardScrollPosition, onHorizontalScroll)=>({ setState: setState })=>{
            setState({
                ...boardScrollPosition,
                onHorizontalScroll: onHorizontalScroll
            });
        },
    onHorizontalScroll: (scrollLeft)=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll } = getState();
            onHorizontalScroll(scrollLeft);
        }
};
const $efb6ae5a663abfc5$var$boardScrollStore = (0, $a61MH.createStore)({
    name: 'board-scroll',
    initialState: {
        scrollLeft: 0,
        scrollTop: 0,
        scrollWidth: 0,
        clientWidth: 0,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onHorizontalScroll: ()=>{}
    },
    actions: $efb6ae5a663abfc5$var$actions
});
const $efb6ae5a663abfc5$export$e8a9c7f59d1400dd = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore);
const $efb6ae5a663abfc5$export$42c9508d539e562f = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>scrollLeft
});
const $efb6ae5a663abfc5$export$e9583811d4961272 = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>!!scrollLeft
});
const $efb6ae5a663abfc5$export$a4a2ab28f4bdd36b = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>scrollTop
});
const $efb6ae5a663abfc5$export$20ef285042532517 = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>!!scrollTop
});
const $efb6ae5a663abfc5$export$cac9ff2d8629bfb2 = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: ({ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth })=>scrollLeft === scrollWidth - clientWidth
});
const $efb6ae5a663abfc5$export$be9b8d6afde7d0af = (0, $ggKAj.createHook)($efb6ae5a663abfc5$var$boardScrollStore, {
    selector: null
});

});


parcelRegister("3ZLl3", function(module, exports) {

$parcel$export(module.exports, "LeftBorder", () => $e4fe0e770864f96e$export$2fa3cb6a784774af);
$parcel$export(module.exports, "RightBorder", () => $e4fe0e770864f96e$export$e6fd94403eb46f0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $iIzf3 = parcelRequire("iIzf3");

var $bWFsx = parcelRequire("bWFsx");

var $2w3P7 = parcelRequire("2w3P7");
const $e4fe0e770864f96e$var$shadowWidth = 7;
const $e4fe0e770864f96e$export$2fa3cb6a784774af = ({ offsetLeftPaddingByWidth: offsetLeftPaddingByWidth })=>{
    const [hasScrollLeft] = (0, $2w3P7.useBoardHasScrollLeft)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4fe0e770864f96e$var$BoardBorderLeftStyle, {
        isShadowVisible: hasScrollLeft,
        offsetLeftPaddingByWidth: offsetLeftPaddingByWidth
    });
};
const $e4fe0e770864f96e$export$e6fd94403eb46f0 = ({ offsetRightPaddingByWidth: offsetRightPaddingByWidth })=>{
    const [isAtRightScrollEdge] = (0, $2w3P7.useBoardScrollIsAtRightEdge)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4fe0e770864f96e$var$BoardBorderRightStyle, {
        isShadowVisible: !isAtRightScrollEdge,
        offsetRightPaddingByWidth: offsetRightPaddingByWidth
    });
}; // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $e4fe0e770864f96e$var$BoardBorderStyleControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18q9p5w-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: !(0, $bWFsx.isStickySupported) ? 'none' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $iIzf3.layout).boardBorderWidth}px`,
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isShadowVisible ? 1 : 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isShadowVisible ? 'auto' : 'none',
        transition: 'opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iIzf3.zIndex).boardBorders
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4fe0e770864f96e$var$BoardBorderLeftStyleControl = /*#__PURE__*/ (0, $kwce8.default)($e4fe0e770864f96e$var$BoardBorderStyleControl).withConfig({
    componentId: "sc-18q9p5w-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        left: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        marginLeft: `${-(0, $iIzf3.layout).boardBorderWidth}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 ${(0, $iIzf3.layout).boardBorderWidth * 2}px 0
            ${"var(--ds-shadow-overflow-spread, #091e4229)"},
        5px -2px ${$e4fe0e770864f96e$var$shadowWidth}px ${"var(--ds-shadow-overflow-perimeter, #091e421f)"}`,
        clipPath: 'inset(0px -12px 0px 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.offsetLeftPaddingByWidth ? `${$e4fe0e770864f96e$var$shadowWidth}px` : ''
    })); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4fe0e770864f96e$var$BoardBorderRightStyleControl = /*#__PURE__*/ (0, $kwce8.default)($e4fe0e770864f96e$var$BoardBorderStyleControl).withConfig({
    componentId: "sc-18q9p5w-2"
})`box-shadow:0 ${(0, $iIzf3.layout).boardBorderWidth * 2}px 0 ${"var(--ds-shadow-overflow-spread, #091e4229)"},-5px -2px ${$e4fe0e770864f96e$var$shadowWidth}px ${"var(--ds-shadow-overflow-perimeter, #091e421f)"};clip-path:inset(0px 0px 0px -12px);${(props)=>props.offsetRightPaddingByWidth ? `width: ${$e4fe0e770864f96e$var$shadowWidth}px; margin-left: ${-$e4fe0e770864f96e$var$shadowWidth}px; right: ${-$e4fe0e770864f96e$var$shadowWidth}px;` : 'right: 0;'};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4fe0e770864f96e$var$BoardBorderStyleExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadowVisible: isShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_x2xsiy": (0, $9t7rW.default)(!(0, $bWFsx.isStickySupported) ? 'none' : '')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ctqga _11q7vuon _1bsb1ylp _kqsw1if8 _v5641p41 _1pby1yp1",
            __cmplp.isShadowVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isShadowVisible ? "_lcxv1wug" : "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4fe0e770864f96e$var$BoardBorderLeftStyleExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e4fe0e770864f96e$var$BoardBorderStyleExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltvidpf _18u010j7 _16qs10uo _mkrzvwc9",
            __cmplp.offsetLeftPaddingByWidth && "_1bsb1v6z",
            __cmplp.className
        ])
    });
});
const $e4fe0e770864f96e$var$BoardBorderLeftStyle = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $e4fe0e770864f96e$var$BoardBorderLeftStyleExperiment, $e4fe0e770864f96e$var$BoardBorderLeftStyleControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4fe0e770864f96e$var$BoardBorderRightStyleExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e4fe0e770864f96e$var$BoardBorderStyleExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qs1ist _mkrz1998",
            __cmplp.offsetRightPaddingByWidth ? "_1bsb1v6z _18u016fl _1xi216fl" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});
const $e4fe0e770864f96e$var$BoardBorderRightStyle = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $e4fe0e770864f96e$var$BoardBorderRightStyleExperiment, $e4fe0e770864f96e$var$BoardBorderRightStyleControl);

});
parcelRegister("bWFsx", function(module, exports) {

$parcel$export(module.exports, "isStickySupported", () => $400388aa28b96562$export$f0b84f0bbcabd5ca);
/**
 * Browsers allowed to run sticky position are:
 * Firefox (any version)
 * Chrome > 58
 * Any other which supports non prefixed version of sticky
 */ let $400388aa28b96562$var$isSupported = false;
const $400388aa28b96562$var$isCSSStickySupported = ()=>typeof window !== 'undefined' && window.CSS && window.CSS.supports && window.CSS.supports('position', 'sticky');
const $400388aa28b96562$var$chromeInfo = typeof navigator !== 'undefined' ? navigator.userAgent.match(/Chrome\/(\d+)/) : null;
if ($400388aa28b96562$var$chromeInfo) // Chrome <= 58 has buggy sticky support
{
    if (Array.isArray($400388aa28b96562$var$chromeInfo) && $400388aa28b96562$var$chromeInfo.length === 2) {
        const chromeVersion = Number($400388aa28b96562$var$chromeInfo[1]);
        const isBrowserBuggy = chromeVersion < 59;
        $400388aa28b96562$var$isSupported = !isBrowserBuggy && $400388aa28b96562$var$isCSSStickySupported();
    }
} else $400388aa28b96562$var$isSupported = $400388aa28b96562$var$isCSSStickySupported();
const $400388aa28b96562$export$f0b84f0bbcabd5ca = $400388aa28b96562$var$isSupported;

});


parcelRegister("lxMAR", function(module, exports) {

$parcel$export(module.exports, "TransitionZoneIndicatorContainerContext", () => $798de536d6ceb959$export$b355823f25623ef7);
$parcel$export(module.exports, "TransitionZoneIndicatorContainerProvider", () => $798de536d6ceb959$export$ebac9eb10481c829);

var $eUqFw = parcelRequire("eUqFw");
const $798de536d6ceb959$export$b355823f25623ef7 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $798de536d6ceb959$export$ebac9eb10481c829 = ({ children: children })=>{
    const contextValue = (0, $eUqFw.useMemo)(()=>{
        const transitionZoneIndicatorRefMap = {};
        return {
            setRef: (id, ref)=>{
                transitionZoneIndicatorRefMap[id] = ref;
            },
            getRef: (id)=>transitionZoneIndicatorRefMap[id],
            removeRef: (id)=>{
                delete transitionZoneIndicatorRefMap[id];
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($798de536d6ceb959$export$b355823f25623ef7.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("3u9tq", function(module, exports) {

$parcel$export(module.exports, "ColumnsDroppable", () => $737ac32fb400a9ae$export$b6532b74655be22d);

var $eUqFw = parcelRequire("eUqFw");

var $966Wa = parcelRequire("966Wa");

const $737ac32fb400a9ae$export$b6532b74655be22d = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { children: children, dropZoneMode: dropZoneMode, renderClone: renderClone, isDropDisabled: isDropDisabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Droppable), {
        droppableId: "board",
        type: (0, $df03f3fe1f111432$export$57d0ef745f304b91),
        direction: "horizontal",
        ignoreContainerClipping: true,
        mode: dropZoneMode,
        renderClone: renderClone,
        isDropDisabled: isDropDisabled
    }, (provided, snapshot)=>children(provided, snapshot));
});

});
parcelRegister("966Wa", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $69fa0e3037063634$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $69fa0e3037063634$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $69fa0e3037063634$export$423ec2075359570a);

var $eUqFw = parcelRequire("eUqFw");

var $fzXll = parcelRequire("fzXll");

var $bqCNv = parcelRequire("bqCNv");

var $34lu7 = parcelRequire("34lu7");

var $4QJdp = parcelRequire("4QJdp");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");
var $b02ud = parcelRequire("b02ud");

var $bn5nT = parcelRequire("bn5nT");

var $dCUwp = parcelRequire("dCUwp");

var $3YjjI = parcelRequire("3YjjI");

var $l1Zd2 = parcelRequire("l1Zd2");

var $gxvYj = parcelRequire("gxvYj");

var $5JNlj = parcelRequire("5JNlj");

var $85I24 = parcelRequire("85I24");

var $lEfVV = parcelRequire("lEfVV");

var $8kUbC = parcelRequire("8kUbC");
var $69fa0e3037063634$var$isProduction = true;
var $69fa0e3037063634$var$spacesAndTabs = /[ \t]{2,}/g;
var $69fa0e3037063634$var$lineStartWithSpaces = /^[ \t]*/gm;
var $69fa0e3037063634$var$clean = function clean(value) {
    return value.replace($69fa0e3037063634$var$spacesAndTabs, ' ').replace($69fa0e3037063634$var$lineStartWithSpaces, '').trim();
};
var $69fa0e3037063634$var$getDevMessage = function getDevMessage(message) {
    return $69fa0e3037063634$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $69fa0e3037063634$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $69fa0e3037063634$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $69fa0e3037063634$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $69fa0e3037063634$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $69fa0e3037063634$var$log(type, message) {
    var _console;
    if ($69fa0e3037063634$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$69fa0e3037063634$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $69fa0e3037063634$var$getFormattedMessage(message));
}
var $69fa0e3037063634$var$warning = $69fa0e3037063634$var$log.bind(null, 'warn');
var $69fa0e3037063634$var$error = $69fa0e3037063634$var$log.bind(null, 'error');
function $69fa0e3037063634$var$noop() {}
function $69fa0e3037063634$var$getOptions(shared, fromBinding) {
    return (0, $34lu7.default)({}, shared, fromBinding);
}
function $69fa0e3037063634$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $69fa0e3037063634$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $69fa0e3037063634$var$isProduction$1 = true;
var $69fa0e3037063634$var$prefix = 'Invariant failed';
function $69fa0e3037063634$var$RbdInvariant(message) {
    this.message = message;
}
$69fa0e3037063634$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $69fa0e3037063634$var$invariant(condition, message) {
    if (condition) return;
    if ($69fa0e3037063634$var$isProduction$1) throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix);
    else throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix + ": " + (message || ''));
}
var $69fa0e3037063634$var$ErrorBoundary = function(_React$Component) {
    (0, $bqCNv.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $69fa0e3037063634$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $69fa0e3037063634$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $69fa0e3037063634$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
var $69fa0e3037063634$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $69fa0e3037063634$var$position = function position(index) {
    return index + 1;
};
var $69fa0e3037063634$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $69fa0e3037063634$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $69fa0e3037063634$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $69fa0e3037063634$var$position(source.index);
    var endPosition = $69fa0e3037063634$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $69fa0e3037063634$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $69fa0e3037063634$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $69fa0e3037063634$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $69fa0e3037063634$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $69fa0e3037063634$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $69fa0e3037063634$var$position(source.index) + "\n";
};
var $69fa0e3037063634$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n  ";
};
var $69fa0e3037063634$var$preset = {
    liftInstruction: $69fa0e3037063634$var$liftInstruction,
    onDragStart: $69fa0e3037063634$var$onDragStart,
    onDragUpdate: $69fa0e3037063634$var$onDragUpdate,
    onDragEnd: $69fa0e3037063634$var$onDragEnd
};
var $69fa0e3037063634$var$origin = {
    x: 0,
    y: 0
};
var $69fa0e3037063634$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $69fa0e3037063634$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $69fa0e3037063634$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $69fa0e3037063634$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $69fa0e3037063634$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $69fa0e3037063634$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $69fa0e3037063634$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $69fa0e3037063634$var$distance(target, point);
    }));
};
var $69fa0e3037063634$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $69fa0e3037063634$var$executeClip = function(frame, subject) {
    var result = (0, $bn5nT.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $69fa0e3037063634$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $69fa0e3037063634$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $69fa0e3037063634$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $69fa0e3037063634$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $69fa0e3037063634$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $34lu7.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $69fa0e3037063634$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $69fa0e3037063634$var$executeClip(frame.pageMarginBox, target);
    return (0, $bn5nT.getRect)(target);
};
var $69fa0e3037063634$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $69fa0e3037063634$var$scroll(page.marginBox, frame);
    var increased = $69fa0e3037063634$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $69fa0e3037063634$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $69fa0e3037063634$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $69fa0e3037063634$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $69fa0e3037063634$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $69fa0e3037063634$var$negate(scrollDiff);
    var frame = (0, $34lu7.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $34lu7.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $69fa0e3037063634$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3YjjI)))(map);
}
function $69fa0e3037063634$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $69fa0e3037063634$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $69fa0e3037063634$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $69fa0e3037063634$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $69fa0e3037063634$var$toDroppableMap = (0, $dCUwp.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDraggableMap = (0, $dCUwp.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDroppableList = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$values(droppables);
});
var $69fa0e3037063634$var$toDraggableList = (0, $dCUwp.default)(function(draggables) {
    return $69fa0e3037063634$var$values(draggables);
});
var $69fa0e3037063634$var$getDraggablesInsideDroppable = (0, $dCUwp.default)(function(droppableId, draggables) {
    var result = $69fa0e3037063634$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $69fa0e3037063634$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $69fa0e3037063634$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $69fa0e3037063634$var$removeDraggableFromList = (0, $dCUwp.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $69fa0e3037063634$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $69fa0e3037063634$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $34lu7.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $69fa0e3037063634$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $69fa0e3037063634$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $69fa0e3037063634$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $69fa0e3037063634$var$noDisplacedBy = {
    point: $69fa0e3037063634$var$origin,
    value: 0
};
var $69fa0e3037063634$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $69fa0e3037063634$var$noImpact = {
    displaced: $69fa0e3037063634$var$emptyGroups,
    displacedBy: $69fa0e3037063634$var$noDisplacedBy,
    at: null
};
var $69fa0e3037063634$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $69fa0e3037063634$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $69fa0e3037063634$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $69fa0e3037063634$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $69fa0e3037063634$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $69fa0e3037063634$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $69fa0e3037063634$var$origin;
    return $69fa0e3037063634$var$offsetByPosition(target, displacement);
};
var $69fa0e3037063634$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $69fa0e3037063634$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $69fa0e3037063634$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $69fa0e3037063634$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $69fa0e3037063634$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $69fa0e3037063634$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $69fa0e3037063634$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isPartiallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisible = function isTotallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $69fa0e3037063634$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $69fa0e3037063634$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $bn5nT.getRect)((0, $bn5nT.expand)(marginBox, expandBy));
}
function $69fa0e3037063634$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $69fa0e3037063634$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $69fa0e3037063634$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $69fa0e3037063634$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $69fa0e3037063634$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $69fa0e3037063634$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $69fa0e3037063634$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $69fa0e3037063634$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $69fa0e3037063634$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    if (index == null) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $69fa0e3037063634$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $69fa0e3037063634$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $69fa0e3037063634$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $69fa0e3037063634$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $69fa0e3037063634$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $69fa0e3037063634$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $69fa0e3037063634$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $69fa0e3037063634$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $69fa0e3037063634$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $69fa0e3037063634$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($69fa0e3037063634$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $69fa0e3037063634$var$origin : $69fa0e3037063634$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $69fa0e3037063634$var$origin;
};
var $69fa0e3037063634$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $69fa0e3037063634$var$tryGetCombine(impact);
    !combine && $69fa0e3037063634$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $69fa0e3037063634$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $69fa0e3037063634$var$add(center, displaceBy);
};
var $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $69fa0e3037063634$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveInto.contentBox[axis.start] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $69fa0e3037063634$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $69fa0e3037063634$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($69fa0e3037063634$var$didStartAfterCritical(closestAfter, afterCritical)) return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $bn5nT.offset)(closest.page, displacedBy.point);
        return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($69fa0e3037063634$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $bn5nT.offset)(last.page, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point));
        return $69fa0e3037063634$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $69fa0e3037063634$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $69fa0e3037063634$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $69fa0e3037063634$var$add(point, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $69fa0e3037063634$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $69fa0e3037063634$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $69fa0e3037063634$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $69fa0e3037063634$var$scrollViewport = function(viewport, newScroll) {
    var diff = $69fa0e3037063634$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $69fa0e3037063634$var$negate(diff);
    var frame = (0, $bn5nT.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $69fa0e3037063634$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $69fa0e3037063634$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $69fa0e3037063634$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $69fa0e3037063634$var$scrollViewport(viewport, $69fa0e3037063634$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $69fa0e3037063634$var$scrollDroppable(destination, $69fa0e3037063634$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $69fa0e3037063634$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $34lu7.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $69fa0e3037063634$var$withViewportDisplacement = function(viewport, point) {
    return $69fa0e3037063634$var$add(viewport.scroll.diff.displacement, point);
};
var $69fa0e3037063634$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $69fa0e3037063634$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $69fa0e3037063634$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $69fa0e3037063634$var$add(draggable.client.borderBox.center, offset);
};
var $69fa0e3037063634$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $69fa0e3037063634$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $69fa0e3037063634$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $69fa0e3037063634$var$isTotallyVisibleOnAxis(args) : $69fa0e3037063634$var$isTotallyVisible(args);
};
var $69fa0e3037063634$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    var impact = $69fa0e3037063634$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $69fa0e3037063634$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $69fa0e3037063634$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $69fa0e3037063634$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $69fa0e3037063634$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $69fa0e3037063634$var$invariant(false);
    return rect;
};
var $69fa0e3037063634$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $69fa0e3037063634$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $69fa0e3037063634$var$isPartiallyVisibleThroughFrame(viewport.frame)($69fa0e3037063634$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $69fa0e3037063634$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $69fa0e3037063634$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $69fa0e3037063634$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $69fa0e3037063634$var$getKnownActive(droppable)[axis.crossAxisStart] === $69fa0e3037063634$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $69fa0e3037063634$var$isWithin($69fa0e3037063634$var$getKnownActive(droppable)[axis.start], $69fa0e3037063634$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(a)));
        var second = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
};
var $69fa0e3037063634$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $69fa0e3037063634$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$offsetByPosition(original, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point)) : original;
};
var $69fa0e3037063634$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $69fa0e3037063634$var$isTotallyVisible({
            target: $69fa0e3037063634$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $69fa0e3037063634$var$getDisplacedBy = (0, $dCUwp.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $69fa0e3037063634$var$patch(axis.line, displacement)
    };
});
var $69fa0e3037063634$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $69fa0e3037063634$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $69fa0e3037063634$var$patch(axis.line, needsToGrowBy);
};
var $69fa0e3037063634$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $34lu7.default)({}, frame, {
        scroll: (0, $34lu7.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $69fa0e3037063634$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$69fa0e3037063634$var$isHomeOf(draggable, droppable) && $69fa0e3037063634$var$invariant(false);
    !!droppable.subject.withPlaceholder && $69fa0e3037063634$var$invariant(false);
    var placeholderSize = $69fa0e3037063634$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $69fa0e3037063634$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $69fa0e3037063634$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, maxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $69fa0e3037063634$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $69fa0e3037063634$var$invariant(false);
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $69fa0e3037063634$var$emptyGroups,
            displacedBy: $69fa0e3037063634$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $69fa0e3037063634$var$isHomeOf(draggable, destination) ? destination : $69fa0e3037063634$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $69fa0e3037063634$var$emptyGroups,
        index: proposedIndex
    });
};
var $69fa0e3037063634$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $69fa0e3037063634$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $69fa0e3037063634$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $69fa0e3037063634$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $69fa0e3037063634$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $69fa0e3037063634$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $69fa0e3037063634$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $69fa0e3037063634$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $69fa0e3037063634$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $69fa0e3037063634$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $69fa0e3037063634$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $69fa0e3037063634$var$isPositionInFrame(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $69fa0e3037063634$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $69fa0e3037063634$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $69fa0e3037063634$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $69fa0e3037063634$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $69fa0e3037063634$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$69fa0e3037063634$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($69fa0e3037063634$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $69fa0e3037063634$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $69fa0e3037063634$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $69fa0e3037063634$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $bn5nT.getRect)($69fa0e3037063634$var$offsetByPosition(rect, point));
};
var $69fa0e3037063634$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $69fa0e3037063634$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $69fa0e3037063634$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $69fa0e3037063634$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $69fa0e3037063634$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $69fa0e3037063634$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $69fa0e3037063634$var$isHomeOf(draggable, destination)
    });
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$combineThresholdDivisor = 4;
var $69fa0e3037063634$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $69fa0e3037063634$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $69fa0e3037063634$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $69fa0e3037063634$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $69fa0e3037063634$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $69fa0e3037063634$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $69fa0e3037063634$var$withDroppableScroll(destination, pageBorderBox);
    return $69fa0e3037063634$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $69fa0e3037063634$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $34lu7.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $69fa0e3037063634$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $69fa0e3037063634$var$whatIsDraggedOver(previousImpact);
    var now = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $69fa0e3037063634$var$removePlaceholder(lastDroppable);
    return $69fa0e3037063634$var$patchDroppableMap(droppables, updated);
};
var $69fa0e3037063634$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $69fa0e3037063634$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($69fa0e3037063634$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $69fa0e3037063634$var$addPlaceholder(droppable, draggable, draggables);
    return $69fa0e3037063634$var$patchDroppableMap(cleaned, patched);
};
var $69fa0e3037063634$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $69fa0e3037063634$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $69fa0e3037063634$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $69fa0e3037063634$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $69fa0e3037063634$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $34lu7.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $69fa0e3037063634$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $69fa0e3037063634$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $34lu7.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $69fa0e3037063634$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $69fa0e3037063634$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $69fa0e3037063634$var$getDraggables$1(last.all, draggables);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $34lu7.default)({}, impact, {
        displaced: displaced
    });
};
var $69fa0e3037063634$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $69fa0e3037063634$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $69fa0e3037063634$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $69fa0e3037063634$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $69fa0e3037063634$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $69fa0e3037063634$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $69fa0e3037063634$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $69fa0e3037063634$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $69fa0e3037063634$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $69fa0e3037063634$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $69fa0e3037063634$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $69fa0e3037063634$var$records = {};
var $69fa0e3037063634$var$isEnabled = false;
var $69fa0e3037063634$var$isTimingsEnabled = function isTimingsEnabled() {
    return $69fa0e3037063634$var$isEnabled;
};
var $69fa0e3037063634$var$start = function start(key) {
    var now;
};
var $69fa0e3037063634$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $69fa0e3037063634$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $bn5nT.offset)(draggable.client, offset$1);
    var page = (0, $bn5nT.withScroll)(client, initialWindowScroll);
    var moved = (0, $34lu7.default)({}, draggable, {
        placeholder: (0, $34lu7.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $69fa0e3037063634$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $69fa0e3037063634$var$invariant(false);
    return frame;
};
var $69fa0e3037063634$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $69fa0e3037063634$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $69fa0e3037063634$var$add(windowScrollChange, droppableScrollChange);
        var moved = $69fa0e3037063634$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $69fa0e3037063634$var$timingsKey = 'Processing dynamic changes';
var $69fa0e3037063634$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $69fa0e3037063634$var$start($69fa0e3037063634$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $69fa0e3037063634$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $34lu7.default)({}, state.dimensions.droppables, $69fa0e3037063634$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $69fa0e3037063634$var$toDraggableMap($69fa0e3037063634$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $34lu7.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $69fa0e3037063634$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingsKey);
    var draggingState = (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $34lu7.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $69fa0e3037063634$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $69fa0e3037063634$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $69fa0e3037063634$var$patchDimensionMap(state.dimensions, updated);
    if (!$69fa0e3037063634$var$isSnapping(state) || isEnabledChanging) return $69fa0e3037063634$var$update({
        state: state,
        dimensions: dimensions
    });
    return $69fa0e3037063634$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $69fa0e3037063634$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $69fa0e3037063634$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $69fa0e3037063634$var$reducer = function(state, action) {
    if (state === void 0) state = $69fa0e3037063634$var$idle;
    if (action.type === 'FLUSH') return (0, $34lu7.default)({}, $69fa0e3037063634$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $69fa0e3037063634$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                offset: $69fa0e3037063634$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $69fa0e3037063634$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result = (0, $34lu7.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($69fa0e3037063634$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $69fa0e3037063634$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $69fa0e3037063634$var$scrollDroppable(target, newScroll);
        return $69fa0e3037063634$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $69fa0e3037063634$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $69fa0e3037063634$var$invariant(false);
        var updated = (0, $34lu7.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $69fa0e3037063634$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        var _updated = (0, $34lu7.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        !state.isWindowScrollAllowed && $69fa0e3037063634$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($69fa0e3037063634$var$isEqual(state.viewport.scroll.current, _newScroll)) return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        var _viewport = $69fa0e3037063634$var$scrollViewport(state.viewport, _newScroll);
        if ($69fa0e3037063634$var$isSnapping(state)) return $69fa0e3037063634$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $69fa0e3037063634$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$69fa0e3037063634$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($69fa0e3037063634$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $34lu7.default)({}, state.viewport, {
            scroll: (0, $34lu7.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $34lu7.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result2 = $69fa0e3037063634$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $69fa0e3037063634$var$invariant(false);
        var newState = (0, $34lu7.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $69fa0e3037063634$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $69fa0e3037063634$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $69fa0e3037063634$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $69fa0e3037063634$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $69fa0e3037063634$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $69fa0e3037063634$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $69fa0e3037063634$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $69fa0e3037063634$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $69fa0e3037063634$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $69fa0e3037063634$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $69fa0e3037063634$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $69fa0e3037063634$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $69fa0e3037063634$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $69fa0e3037063634$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $69fa0e3037063634$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $69fa0e3037063634$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $69fa0e3037063634$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $69fa0e3037063634$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $69fa0e3037063634$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($69fa0e3037063634$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
                dispatch($69fa0e3037063634$var$flush());
                dispatch($69fa0e3037063634$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $69fa0e3037063634$var$validateDimensions(critical, dimensions);
                dispatch($69fa0e3037063634$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $69fa0e3037063634$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $69fa0e3037063634$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $69fa0e3037063634$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $69fa0e3037063634$var$outOfTheWayTiming = $69fa0e3037063634$var$timings.outOfTheWay + "s " + $69fa0e3037063634$var$curves.outOfTheWay;
var $69fa0e3037063634$var$transitions = {
    fluid: "opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    snap: "transform " + $69fa0e3037063634$var$outOfTheWayTiming + ", opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $69fa0e3037063634$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $69fa0e3037063634$var$outOfTheWayTiming,
    placeholder: "height " + $69fa0e3037063634$var$outOfTheWayTiming + ", width " + $69fa0e3037063634$var$outOfTheWayTiming + ", margin " + $69fa0e3037063634$var$outOfTheWayTiming
};
var $69fa0e3037063634$var$moveTo = function moveTo(offset) {
    return $69fa0e3037063634$var$isEqual(offset, $69fa0e3037063634$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $69fa0e3037063634$var$transforms = {
    moveTo: $69fa0e3037063634$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $69fa0e3037063634$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $69fa0e3037063634$var$combine.scale.drop + ")";
    }
};
var $69fa0e3037063634$var$minDropTime = $69fa0e3037063634$var$timings.minDropTime, $69fa0e3037063634$var$maxDropTime = $69fa0e3037063634$var$timings.maxDropTime;
var $69fa0e3037063634$var$dropTimeRange = $69fa0e3037063634$var$maxDropTime - $69fa0e3037063634$var$minDropTime;
var $69fa0e3037063634$var$maxDropTimeAtDistance = 1500;
var $69fa0e3037063634$var$cancelDropModifier = 0.6;
var $69fa0e3037063634$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $69fa0e3037063634$var$distance(current, destination);
    if (distance$1 <= 0) return $69fa0e3037063634$var$minDropTime;
    if (distance$1 >= $69fa0e3037063634$var$maxDropTimeAtDistance) return $69fa0e3037063634$var$maxDropTime;
    var percentage = distance$1 / $69fa0e3037063634$var$maxDropTimeAtDistance;
    var duration = $69fa0e3037063634$var$minDropTime + $69fa0e3037063634$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $69fa0e3037063634$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $69fa0e3037063634$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $69fa0e3037063634$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $69fa0e3037063634$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $69fa0e3037063634$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $34lu7.default)({}, lastImpact, {
        displaced: $69fa0e3037063634$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $69fa0e3037063634$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($69fa0e3037063634$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $69fa0e3037063634$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $69fa0e3037063634$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $69fa0e3037063634$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$69fa0e3037063634$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($69fa0e3037063634$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $69fa0e3037063634$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($69fa0e3037063634$var$animateDrop(args));
        };
    };
};
var $69fa0e3037063634$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $69fa0e3037063634$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $69fa0e3037063634$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($69fa0e3037063634$var$getWindowScroll());
    }
    var scheduled = (0, $gxvYj.default)(updateScroll);
    var binding = $69fa0e3037063634$var$getWindowScrollBinding(scheduled);
    var unbind = $69fa0e3037063634$var$noop;
    function isActive() {
        return unbind !== $69fa0e3037063634$var$noop;
    }
    function start() {
        !!isActive() && $69fa0e3037063634$var$invariant(false);
        unbind = $69fa0e3037063634$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $69fa0e3037063634$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $69fa0e3037063634$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $69fa0e3037063634$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$scrollListener = function(store) {
    var listener = $69fa0e3037063634$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($69fa0e3037063634$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $69fa0e3037063634$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $69fa0e3037063634$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $69fa0e3037063634$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $69fa0e3037063634$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $69fa0e3037063634$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $69fa0e3037063634$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $69fa0e3037063634$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $69fa0e3037063634$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $69fa0e3037063634$var$withTimings = function withTimings(key, fn) {
    $69fa0e3037063634$var$start(key);
    fn();
    $69fa0e3037063634$var$finish(key);
};
var $69fa0e3037063634$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $69fa0e3037063634$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $69fa0e3037063634$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $69fa0e3037063634$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $69fa0e3037063634$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($69fa0e3037063634$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var data = $69fa0e3037063634$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragStart', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragStart, data, announce, $69fa0e3037063634$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $69fa0e3037063634$var$tryGetDestination(impact);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        !dragging && $69fa0e3037063634$var$invariant(false);
        var hasCriticalChanged = !$69fa0e3037063634$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$69fa0e3037063634$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$69fa0e3037063634$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragUpdate', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragUpdate, data, announce, $69fa0e3037063634$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $69fa0e3037063634$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        dragging = null;
        $69fa0e3037063634$var$withTimings('onDragEnd', function() {
            return $69fa0e3037063634$var$execute(getResponders().onDragEnd, result, announce, $69fa0e3037063634$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $69fa0e3037063634$var$responders = function(getResponders, announce) {
    var publisher = $69fa0e3037063634$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $69fa0e3037063634$var$invariant(false);
            store.dispatch($69fa0e3037063634$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($69fa0e3037063634$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $69fa0e3037063634$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $69fa0e3037063634$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $69fa0e3037063634$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($69fa0e3037063634$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $69fa0e3037063634$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($69fa0e3037063634$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $69fa0e3037063634$var$composeEnhancers = (0, $4QJdp.compose);
var $69fa0e3037063634$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $4QJdp.createStore)($69fa0e3037063634$var$reducer, $69fa0e3037063634$var$composeEnhancers((0, $4QJdp.applyMiddleware)($69fa0e3037063634$var$style(styleMarshal), $69fa0e3037063634$var$dimensionMarshalStopper(dimensionMarshal), $69fa0e3037063634$var$lift$1(dimensionMarshal), $69fa0e3037063634$var$drop$1, $69fa0e3037063634$var$dropAnimationFinish, $69fa0e3037063634$var$dropAnimationFlushOnScroll, $69fa0e3037063634$var$pendingDrop, $69fa0e3037063634$var$autoScroll(autoScroller), $69fa0e3037063634$var$scrollListener, $69fa0e3037063634$var$focus(focusMarshal), $69fa0e3037063634$var$responders(getResponders, announce))));
};
var $69fa0e3037063634$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $69fa0e3037063634$var$timingKey = 'Publish collection from DOM';
function $69fa0e3037063634$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $69fa0e3037063634$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $69fa0e3037063634$var$start($69fa0e3037063634$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($69fa0e3037063634$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(removals),
                modified: updated
            };
            staging = $69fa0e3037063634$var$clean$1();
            $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $69fa0e3037063634$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $69fa0e3037063634$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $69fa0e3037063634$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $69fa0e3037063634$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $69fa0e3037063634$var$invariant(false);
    return doc;
};
var $69fa0e3037063634$var$getMaxWindowScroll = function() {
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var maxScroll = $69fa0e3037063634$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $69fa0e3037063634$var$getViewport = function() {
    var scroll = $69fa0e3037063634$var$getWindowScroll();
    var maxScroll = $69fa0e3037063634$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $69fa0e3037063634$var$origin,
                displacement: $69fa0e3037063634$var$origin
            }
        }
    };
    return viewport;
};
var $69fa0e3037063634$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $69fa0e3037063634$var$start(timingKey);
    var viewport = $69fa0e3037063634$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $69fa0e3037063634$var$toDraggableMap(draggables),
        droppables: $69fa0e3037063634$var$toDroppableMap(droppables)
    };
    $69fa0e3037063634$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $69fa0e3037063634$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $69fa0e3037063634$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $69fa0e3037063634$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $69fa0e3037063634$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $69fa0e3037063634$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $69fa0e3037063634$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $69fa0e3037063634$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $69fa0e3037063634$var$getScrollableDroppables = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $69fa0e3037063634$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $69fa0e3037063634$var$find($69fa0e3037063634$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $69fa0e3037063634$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $69fa0e3037063634$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $69fa0e3037063634$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $69fa0e3037063634$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $69fa0e3037063634$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $69fa0e3037063634$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $69fa0e3037063634$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $69fa0e3037063634$var$minScroll = 1;
var $69fa0e3037063634$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $69fa0e3037063634$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $69fa0e3037063634$var$minScroll;
    var percentageFromMaxScrollValueAt = $69fa0e3037063634$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $69fa0e3037063634$var$config.maxPixelScroll * $69fa0e3037063634$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$accelerateAt = $69fa0e3037063634$var$config.durationDampening.accelerateAt;
var $69fa0e3037063634$var$stopAt = $69fa0e3037063634$var$config.durationDampening.stopDampeningAt;
var $69fa0e3037063634$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $69fa0e3037063634$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
    var runTime = now - startOfRange;
    if (runTime >= $69fa0e3037063634$var$stopAt) return proposedScroll;
    if (runTime < $69fa0e3037063634$var$accelerateAt) return $69fa0e3037063634$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $69fa0e3037063634$var$getPercentage({
        startOfRange: $69fa0e3037063634$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $69fa0e3037063634$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($69fa0e3037063634$var$dampenValueByTime(scroll, dragStartTime), $69fa0e3037063634$var$minScroll);
};
var $69fa0e3037063634$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $69fa0e3037063634$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $69fa0e3037063634$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $69fa0e3037063634$var$clean$2 = $69fa0e3037063634$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $69fa0e3037063634$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $69fa0e3037063634$var$clean$2({
        x: x,
        y: y
    });
    if ($69fa0e3037063634$var$isEqual(required, $69fa0e3037063634$var$origin)) return null;
    var limited = $69fa0e3037063634$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $69fa0e3037063634$var$isEqual(limited, $69fa0e3037063634$var$origin) ? null : limited;
};
var $69fa0e3037063634$var$smallestSigned = $69fa0e3037063634$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $69fa0e3037063634$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $69fa0e3037063634$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($69fa0e3037063634$var$isEqual(overlap, $69fa0e3037063634$var$origin)) return null;
        return overlap;
    };
}();
var $69fa0e3037063634$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $69fa0e3037063634$var$smallestSigned(change);
    var overlap = $69fa0e3037063634$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $69fa0e3037063634$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $69fa0e3037063634$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $69fa0e3037063634$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return null;
    return $69fa0e3037063634$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $69fa0e3037063634$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $69fa0e3037063634$var$getBestScrollableDroppable({
        center: center,
        destination: $69fa0e3037063634$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $69fa0e3037063634$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $69fa0e3037063634$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $gxvYj.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $gxvYj.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $69fa0e3037063634$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $69fa0e3037063634$var$start('starting fluid scroller');
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $69fa0e3037063634$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $69fa0e3037063634$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $69fa0e3037063634$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $69fa0e3037063634$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $69fa0e3037063634$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return change;
        var overlap = $69fa0e3037063634$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
        !destination && $69fa0e3037063634$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $69fa0e3037063634$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $69fa0e3037063634$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $69fa0e3037063634$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $69fa0e3037063634$var$prefix$1 = 'data-rbd';
var $69fa0e3037063634$var$dragHandle = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $69fa0e3037063634$var$draggable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$droppable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$scrollContainer = {
    contextId: $69fa0e3037063634$var$prefix$1 + "-scroll-container-context-id"
};
var $69fa0e3037063634$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $69fa0e3037063634$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $69fa0e3037063634$var$noPointerEvents = 'pointer-events: none;';
var $69fa0e3037063634$var$getStyles$1 = function(contextId) {
    var getSelector = $69fa0e3037063634$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $69fa0e3037063634$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $69fa0e3037063634$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($69fa0e3037063634$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $69fa0e3037063634$var$getStyles(rules, 'always'),
        resting: $69fa0e3037063634$var$getStyles(rules, 'resting'),
        dragging: $69fa0e3037063634$var$getStyles(rules, 'dragging'),
        dropAnimating: $69fa0e3037063634$var$getStyles(rules, 'dropAnimating'),
        userCancel: $69fa0e3037063634$var$getStyles(rules, 'userCancel')
    };
};
var $69fa0e3037063634$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);
var $69fa0e3037063634$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $69fa0e3037063634$var$invariant(false);
    return head;
};
var $69fa0e3037063634$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $69fa0e3037063634$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eUqFw.useRef)(null);
    var dynamicRef = (0, $eUqFw.useRef)(null);
    var setDynamicStyle = (0, $fzXll.useCallback)((0, $dCUwp.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $fzXll.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $69fa0e3037063634$var$invariant(false);
        var always = $69fa0e3037063634$var$createStyleEl(nonce);
        var dynamic = $69fa0e3037063634$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($69fa0e3037063634$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($69fa0e3037063634$var$prefix$1 + "-dynamic", contextId);
        $69fa0e3037063634$var$getHead().appendChild(always);
        $69fa0e3037063634$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $69fa0e3037063634$var$invariant(false);
                $69fa0e3037063634$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $fzXll.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $fzXll.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $fzXll.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $69fa0e3037063634$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $69fa0e3037063634$var$isHtmlElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).HTMLElement;
}
function $69fa0e3037063634$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eUqFw.useRef)({});
    var recordRef = (0, $eUqFw.useRef)(null);
    var restoreFocusFrameRef = (0, $eUqFw.useRef)(null);
    var isMountedRef = (0, $eUqFw.useRef)(false);
    var register = (0, $fzXll.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $fzXll.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $69fa0e3037063634$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $fzXll.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $fzXll.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $fzXll.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $69fa0e3037063634$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $69fa0e3037063634$var$useRegistry() {
    var registry = (0, $fzXll.useMemo)($69fa0e3037063634$var$createRegistry, []);
    (0, $eUqFw.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $69fa0e3037063634$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$getBodyElement = function() {
    var body = document.body;
    !body && $69fa0e3037063634$var$invariant(false);
    return body;
};
var $69fa0e3037063634$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $69fa0e3037063634$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $69fa0e3037063634$var$useAnnouncer(contextId) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, $69fa0e3037063634$var$visuallyHidden);
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $69fa0e3037063634$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $fzXll.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $69fa0e3037063634$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $eUqFw.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, {
            display: 'none'
        });
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function unmount() {
            $69fa0e3037063634$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $69fa0e3037063634$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $69fa0e3037063634$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $69fa0e3037063634$var$getVersion = function getVersion(value) {
    var result = $69fa0e3037063634$var$semver.exec(value);
    !(result != null) && $69fa0e3037063634$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $69fa0e3037063634$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $69fa0e3037063634$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $69fa0e3037063634$var$getVersion(peerDepValue);
    var actual = $69fa0e3037063634$var$getVersion(actualValue);
    if ($69fa0e3037063634$var$isSatisfied(peerDep, actual)) return;
};
var $69fa0e3037063634$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $69fa0e3037063634$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $69fa0e3037063634$var$useDev(useHook) {}
function $69fa0e3037063634$var$useDevSetupWarning(fn, inputs) {
    $69fa0e3037063634$var$useDev(function() {
        (0, $eUqFw.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $69fa0e3037063634$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $69fa0e3037063634$var$useStartupValidation() {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$checkReactVersion($69fa0e3037063634$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).version);
        $69fa0e3037063634$var$checkDoctype(document);
    }, []);
}
function $69fa0e3037063634$var$usePrevious(current) {
    var ref = (0, $eUqFw.useRef)(current);
    (0, $eUqFw.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $69fa0e3037063634$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $69fa0e3037063634$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $69fa0e3037063634$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $69fa0e3037063634$var$tab = 9;
var $69fa0e3037063634$var$enter = 13;
var $69fa0e3037063634$var$escape = 27;
var $69fa0e3037063634$var$space = 32;
var $69fa0e3037063634$var$pageUp = 33;
var $69fa0e3037063634$var$pageDown = 34;
var $69fa0e3037063634$var$end = 35;
var $69fa0e3037063634$var$home = 36;
var $69fa0e3037063634$var$arrowLeft = 37;
var $69fa0e3037063634$var$arrowUp = 38;
var $69fa0e3037063634$var$arrowRight = 39;
var $69fa0e3037063634$var$arrowDown = 40;
var $69fa0e3037063634$var$_preventedKeys;
var $69fa0e3037063634$var$preventedKeys = ($69fa0e3037063634$var$_preventedKeys = {}, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$enter] = true, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$tab] = true, $69fa0e3037063634$var$_preventedKeys);
var $69fa0e3037063634$var$preventStandardKeyEvents = function(event) {
    if ($69fa0e3037063634$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $69fa0e3037063634$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $69fa0e3037063634$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $69fa0e3037063634$var$primaryButton = 0;
var $69fa0e3037063634$var$sloppyClickThreshold = 5;
function $69fa0e3037063634$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $69fa0e3037063634$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $69fa0e3037063634$var$sloppyClickThreshold;
}
var $69fa0e3037063634$var$idle$1 = {
    type: 'IDLE'
};
function $69fa0e3037063634$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $69fa0e3037063634$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
                var pending = phase.point;
                if (!$69fa0e3037063634$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$1);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $69fa0e3037063634$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $69fa0e3037063634$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $69fa0e3037063634$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$_scrollJumpKeys;
function $69fa0e3037063634$var$noop$1() {}
var $69fa0e3037063634$var$scrollJumpKeys = ($69fa0e3037063634$var$_scrollJumpKeys = {}, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageDown] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageUp] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$home] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$end] = true, $69fa0e3037063634$var$_scrollJumpKeys);
function $69fa0e3037063634$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($69fa0e3037063634$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop$1);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $69fa0e3037063634$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $69fa0e3037063634$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$idle$2 = {
    type: 'IDLE'
};
var $69fa0e3037063634$var$timeForLongPress = 120;
var $69fa0e3037063634$var$forcePressThreshold = 0.15;
function $69fa0e3037063634$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $69fa0e3037063634$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor$1(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$2);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var getPhase = (0, $fzXll.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $fzXll.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($69fa0e3037063634$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getHandleBindings(args), options);
        var unbindWindow = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $fzXll.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $69fa0e3037063634$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($69fa0e3037063634$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $69fa0e3037063634$var$useValidateSensorHooks(sensorHooks) {
    $69fa0e3037063634$var$useDev(function() {
        var previousRef = $69fa0e3037063634$var$usePrevious(sensorHooks);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $69fa0e3037063634$var$invariant(false);
        });
    });
}
var $69fa0e3037063634$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $69fa0e3037063634$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($69fa0e3037063634$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(parent, current.parentElement);
}
function $69fa0e3037063634$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isHtmlElement(target)) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(draggable, target);
}
var $69fa0e3037063634$var$getBorderBoxCenterPosition = function(el) {
    return (0, $bn5nT.getRect)(el.getBoundingClientRect()).center;
};
function $69fa0e3037063634$var$isElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).Element;
}
var $69fa0e3037063634$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $69fa0e3037063634$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $69fa0e3037063634$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$69fa0e3037063634$var$supportedMatchesName](selector)) return el;
    return $69fa0e3037063634$var$closestPonyfill(el.parentElement, selector);
}
function $69fa0e3037063634$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $69fa0e3037063634$var$closestPonyfill(el, selector);
}
function $69fa0e3037063634$var$getSelector(contextId) {
    return "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isElement(target)) return null;
    var selector = $69fa0e3037063634$var$getSelector(contextId);
    var handle = $69fa0e3037063634$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($69fa0e3037063634$var$dragHandle.draggableId);
}
function $69fa0e3037063634$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $69fa0e3037063634$var$preventDefault(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $69fa0e3037063634$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$69fa0e3037063634$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $69fa0e3037063634$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $69fa0e3037063634$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $69fa0e3037063634$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $69fa0e3037063634$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $69fa0e3037063634$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($69fa0e3037063634$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $69fa0e3037063634$var$invariant(false);
        }
        store.dispatch($69fa0e3037063634$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $69fa0e3037063634$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $69fa0e3037063634$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($69fa0e3037063634$var$drop({
                reason: reason
            }));
        }
        return (0, $34lu7.default)({
            isActive: function isActive() {
                return $69fa0e3037063634$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $gxvYj.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $69fa0e3037063634$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $34lu7.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $69fa0e3037063634$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $69fa0e3037063634$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $69fa0e3037063634$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $69fa0e3037063634$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $69fa0e3037063634$var$defaultSensors = [
    $69fa0e3037063634$var$useMouseSensor,
    $69fa0e3037063634$var$useKeyboardSensor,
    $69fa0e3037063634$var$useMouseSensor$1
];
function $69fa0e3037063634$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $69fa0e3037063634$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eUqFw.useState)(function() {
        return $69fa0e3037063634$var$create();
    })[0];
    var tryAbandonLock = (0, $fzXll.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $fzXll.useCallback)(function(draggableId) {
        return $69fa0e3037063634$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $fzXll.useCallback)(function(draggableId, forceStop, options) {
        return $69fa0e3037063634$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $fzXll.useCallback)(function(event) {
        return $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $fzXll.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $fzXll.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $fzXll.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $fzXll.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $69fa0e3037063634$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $69fa0e3037063634$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $69fa0e3037063634$var$getStore(lazyRef) {
    !lazyRef.current && $69fa0e3037063634$var$invariant(false);
    return lazyRef.current;
}
function $69fa0e3037063634$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $eUqFw.useRef)(null);
    $69fa0e3037063634$var$useStartupValidation();
    var lastPropsRef = $69fa0e3037063634$var$usePrevious(props);
    var getResponders = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $69fa0e3037063634$var$useAnnouncer(contextId);
    var liftInstructionId = $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $69fa0e3037063634$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $fzXll.useCallback)(function(action) {
        $69fa0e3037063634$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $fzXll.useMemo)(function() {
        return (0, $4QJdp.bindActionCreators)({
            publishWhileDragging: $69fa0e3037063634$var$publishWhileDragging,
            updateDroppableScroll: $69fa0e3037063634$var$updateDroppableScroll,
            updateDroppableIsEnabled: $69fa0e3037063634$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $69fa0e3037063634$var$updateDroppableIsCombineEnabled,
            collectionStarting: $69fa0e3037063634$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $69fa0e3037063634$var$useRegistry();
    var dimensionMarshal = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createAutoScroller((0, $34lu7.default)({
            scrollWindow: $69fa0e3037063634$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $4QJdp.bindActionCreators)({
            move: $69fa0e3037063634$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $69fa0e3037063634$var$useFocusMarshal(contextId);
    var store = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $fzXll.useCallback)(function() {
        var current = $69fa0e3037063634$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($69fa0e3037063634$var$flush());
    }, []);
    var isDragging = (0, $fzXll.useCallback)(function() {
        var state = $69fa0e3037063634$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $fzXll.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $fzXll.useCallback)(function(id) {
        return $69fa0e3037063634$var$canStartDrag($69fa0e3037063634$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$isMovementAllowed($69fa0e3037063634$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $fzXll.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $69fa0e3037063634$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eUqFw.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b02ud.default), {
        context: $69fa0e3037063634$var$StoreContext,
        store: store
    }, props.children));
}
var $69fa0e3037063634$var$instanceCount = 0;
function $69fa0e3037063634$export$2bfe52350fc0150d() {
    $69fa0e3037063634$var$instanceCount = 0;
}
function $69fa0e3037063634$export$237bd83162c14364(props) {
    var contextId = (0, $fzXll.useMemo)(function() {
        return "" + $69fa0e3037063634$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $69fa0e3037063634$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $69fa0e3037063634$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $69fa0e3037063634$var$isScroll = $69fa0e3037063634$var$isEqual$1('scroll');
var $69fa0e3037063634$var$isAuto = $69fa0e3037063634$var$isEqual$1('auto');
var $69fa0e3037063634$var$isVisible$1 = $69fa0e3037063634$var$isEqual$1('visible');
var $69fa0e3037063634$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isScroll) || $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isAuto);
};
var $69fa0e3037063634$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $69fa0e3037063634$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $69fa0e3037063634$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$69fa0e3037063634$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $69fa0e3037063634$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $69fa0e3037063634$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $69fa0e3037063634$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $69fa0e3037063634$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $69fa0e3037063634$var$getEnv = function(start) {
    var closestScrollable = $69fa0e3037063634$var$getClosestScrollable(start);
    var isFixedOnPage = $69fa0e3037063634$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $69fa0e3037063634$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $69fa0e3037063634$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $69fa0e3037063634$var$origin,
                    displacement: $69fa0e3037063634$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $69fa0e3037063634$var$vertical : $69fa0e3037063634$var$horizontal;
    var subject = $69fa0e3037063634$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $69fa0e3037063634$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $bn5nT.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $bn5nT.expand)(paddingBox, base.border);
    var client = (0, $bn5nT.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $69fa0e3037063634$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $69fa0e3037063634$var$getClient(ref, closestScrollable);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $bn5nT.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $bn5nT.withScroll)(frameClient, windowScroll),
            scroll: $69fa0e3037063634$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $69fa0e3037063634$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $69fa0e3037063634$var$immediate = {
    passive: false
};
var $69fa0e3037063634$var$delayed = {
    passive: true
};
var $69fa0e3037063634$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $69fa0e3037063634$var$immediate : $69fa0e3037063634$var$delayed;
};
function $69fa0e3037063634$var$useRequiredContext(Context) {
    var result = (0, $eUqFw.useContext)(Context);
    !result && $69fa0e3037063634$var$invariant(false);
    return result;
}
var $69fa0e3037063634$var$count = 0;
function $69fa0e3037063634$var$useUniqueId(prefix) {
    var countRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$count++);
    return prefix + "::" + countRef.current;
}
var $69fa0e3037063634$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $69fa0e3037063634$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eUqFw.useRef)(null);
    var appContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext);
    var uniqueId = $69fa0e3037063634$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $69fa0e3037063634$var$usePrevious(args);
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eUqFw.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $fzXll.useMemo)(function() {
        return (0, $dCUwp.default)(function(x, y) {
            !whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $69fa0e3037063634$var$origin;
        return $69fa0e3037063634$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $fzXll.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $fzXll.useMemo)(function() {
        return (0, $gxvYj.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $fzXll.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $69fa0e3037063634$var$invariant(false);
        var env = $69fa0e3037063634$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $69fa0e3037063634$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($69fa0e3037063634$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($69fa0e3037063634$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $fzXll.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !closest && $69fa0e3037063634$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $fzXll.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $69fa0e3037063634$var$noop$2() {}
var $69fa0e3037063634$var$empty = {
    width: 0,
    height: 0,
    margin: $69fa0e3037063634$var$noSpacing
};
var $69fa0e3037063634$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $69fa0e3037063634$var$empty;
    if (animate === 'close') return $69fa0e3037063634$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $69fa0e3037063634$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $69fa0e3037063634$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $69fa0e3037063634$var$transitions.placeholder : null
    };
};
function $69fa0e3037063634$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eUqFw.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $fzXll.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eUqFw.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eUqFw.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $69fa0e3037063634$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $69fa0e3037063634$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $69fa0e3037063634$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $fzXll.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $69fa0e3037063634$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $69fa0e3037063634$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($69fa0e3037063634$var$Placeholder);
var $69fa0e3037063634$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $69fa0e3037063634$var$checkIsValidInnerRef(el) {
    !(el && $69fa0e3037063634$var$isHtmlElement(el)) && $69fa0e3037063634$var$invariant(false);
}
function $69fa0e3037063634$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $69fa0e3037063634$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $69fa0e3037063634$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $69fa0e3037063634$var$invariant(false);
        !(typeof props.droppableId === 'string') && $69fa0e3037063634$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$69fa0e3037063634$var$isBoolean(props.isDropDisabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.ignoreContainerClipping) && $69fa0e3037063634$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $69fa0e3037063634$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $69fa0e3037063634$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $69fa0e3037063634$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $69fa0e3037063634$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $69fa0e3037063634$var$invariant(false);
    }
];
function $69fa0e3037063634$var$useValidation(args) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$shared);
        if (args.props.mode === 'standard') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$standard);
        if (args.props.mode === 'virtual') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$virtual);
    });
}
var $69fa0e3037063634$var$AnimateInOut = function(_React$PureComponent) {
    (0, $bqCNv.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
var $69fa0e3037063634$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $69fa0e3037063634$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $69fa0e3037063634$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $69fa0e3037063634$var$transitions.snap;
    return $69fa0e3037063634$var$transitions.fluid;
};
var $69fa0e3037063634$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $69fa0e3037063634$var$combine.opacity.drop : $69fa0e3037063634$var$combine.opacity.combining;
};
var $69fa0e3037063634$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $69fa0e3037063634$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $69fa0e3037063634$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $69fa0e3037063634$var$transforms.drop(offset, isCombining) : $69fa0e3037063634$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $69fa0e3037063634$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $69fa0e3037063634$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $69fa0e3037063634$var$zIndexOptions.dropAnimating : $69fa0e3037063634$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $69fa0e3037063634$var$getSecondaryStyle(secondary) {
    return {
        transform: $69fa0e3037063634$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $69fa0e3037063634$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $69fa0e3037063634$var$getDraggingStyle(mapped) : $69fa0e3037063634$var$getSecondaryStyle(mapped);
}
function $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $69fa0e3037063634$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $bn5nT.calculateBox)(borderBox, computedStyles);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $69fa0e3037063634$var$useDraggablePublisher(args) {
    var uniqueId = $69fa0e3037063634$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $fzXll.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $fzXll.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eUqFw.useRef)(entry);
    var isFirstPublishRef = (0, $eUqFw.useRef)(true);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $69fa0e3037063634$var$useValidation$1(props, contextId, getRef) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $69fa0e3037063634$var$invariant(false);
        !(typeof id === 'string') && $69fa0e3037063634$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8kUbC)))(props.index) && $69fa0e3037063634$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $69fa0e3037063634$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$69fa0e3037063634$var$findDragHandle(contextId, id) && $69fa0e3037063634$var$invariant(false);
    });
}
function $69fa0e3037063634$var$useClonePropValidation(isClone) {
    $69fa0e3037063634$var$useDev(function() {
        var initialRef = (0, $eUqFw.useRef)(isClone);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $69fa0e3037063634$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $69fa0e3037063634$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$Draggable(props) {
    var ref = (0, $eUqFw.useRef)(null);
    var setRef = (0, $fzXll.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $fzXll.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $69fa0e3037063634$var$useValidation$1(props, contextId, getRef);
    $69fa0e3037063634$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $fzXll.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $69fa0e3037063634$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $fzXll.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $69fa0e3037063634$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $fzXll.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $fzXll.useMemo)(function() {
        var style = $69fa0e3037063634$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $fzXll.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $69fa0e3037063634$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $69fa0e3037063634$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $69fa0e3037063634$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $69fa0e3037063634$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $69fa0e3037063634$var$getDraggableSelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
            var combineWith = $69fa0e3037063634$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $69fa0e3037063634$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $69fa0e3037063634$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $69fa0e3037063634$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $69fa0e3037063634$var$combine.opacity.drop : null,
                scale: _combineWith ? $69fa0e3037063634$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $69fa0e3037063634$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $69fa0e3037063634$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $69fa0e3037063634$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $69fa0e3037063634$var$getSecondarySnapshot(null)
    }
};
function $69fa0e3037063634$var$getSecondarySelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)($69fa0e3037063634$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($69fa0e3037063634$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $69fa0e3037063634$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $69fa0e3037063634$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $69fa0e3037063634$var$getDraggableSelector();
    var secondarySelector = $69fa0e3037063634$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $69fa0e3037063634$var$atRest;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps = {
    dropAnimationFinished: $69fa0e3037063634$var$dropAnimationFinished
};
var $69fa0e3037063634$var$ConnectedDraggable = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps, $69fa0e3037063634$var$mapDispatchToProps, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Draggable);
function $69fa0e3037063634$var$PrivateDraggable(props) {
    var droppableContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ConnectedDraggable, props);
}
function $69fa0e3037063634$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, (0, $34lu7.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $69fa0e3037063634$var$Droppable(props) {
    var appContext = (0, $eUqFw.useContext)($69fa0e3037063634$var$AppContext);
    !appContext && $69fa0e3037063634$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eUqFw.useRef)(null);
    var placeholderRef = (0, $eUqFw.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $fzXll.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $fzXll.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $fzXll.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $fzXll.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $69fa0e3037063634$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $fzXll.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $69fa0e3037063634$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $69fa0e3037063634$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $fzXll.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $fzXll.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $69fa0e3037063634$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $69fa0e3037063634$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $69fa0e3037063634$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $34lu7.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $dCUwp.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $dCUwp.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$69fa0e3037063634$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $69fa0e3037063634$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $69fa0e3037063634$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $69fa0e3037063634$var$whatIsDraggedOverFromResult(completed.result) === id, $69fa0e3037063634$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $69fa0e3037063634$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $69fa0e3037063634$var$updateViewportMaxScroll
};
function $69fa0e3037063634$var$getBody() {
    !document.body && $69fa0e3037063634$var$invariant(false);
    return document.body;
}
var $69fa0e3037063634$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $69fa0e3037063634$var$getBody
};
var $69fa0e3037063634$export$423ec2075359570a = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps$1, $69fa0e3037063634$var$mapDispatchToProps$1, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Droppable);
$69fa0e3037063634$export$423ec2075359570a.defaultProps = $69fa0e3037063634$var$defaultProps;

});
parcelRegister("bqCNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $852037c688a362ca$export$2e2bcd8739ae039);

var $aqlSy = parcelRequire("aqlSy");

var $hhPJ7 = parcelRequire("hhPJ7");
function $852037c688a362ca$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($aqlSy)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hhPJ7.default)(subClass, superClass);
}

});
parcelRegister("aqlSy", function(module, exports) {

module.exports = (parcelRequire("fKlYj"));

});
parcelRegister("fKlYj", function(module, exports) {
parcelRequire("3w0kn");

var $dhx8H = parcelRequire("dhx8H");
var $b76c3205a8a74d63$require$$Object = $dhx8H.Object;
module.exports = function create(P, D) {
    return $b76c3205a8a74d63$require$$Object.create(P, D);
};

});
parcelRegister("3w0kn", function(module, exports) {

var $5wEa2 = parcelRequire("5wEa2");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$5wEa2($5wEa2.S, 'Object', {
    create: (parcelRequire("cZpQU"))
});

});
parcelRegister("5wEa2", function(module, exports) {

var $63L5I = parcelRequire("63L5I");

var $dhx8H = parcelRequire("dhx8H");

var $8fJLB = parcelRequire("8fJLB");

var $8akT7 = parcelRequire("8akT7");

var $8uIdh = parcelRequire("8uIdh");
var $405f18044f314da9$var$PROTOTYPE = 'prototype';
var $405f18044f314da9$var$$export = function(type, name, source) {
    var IS_FORCED = type & $405f18044f314da9$var$$export.F;
    var IS_GLOBAL = type & $405f18044f314da9$var$$export.G;
    var IS_STATIC = type & $405f18044f314da9$var$$export.S;
    var IS_PROTO = type & $405f18044f314da9$var$$export.P;
    var IS_BIND = type & $405f18044f314da9$var$$export.B;
    var IS_WRAP = type & $405f18044f314da9$var$$export.W;
    var exports = IS_GLOBAL ? $dhx8H : $dhx8H[name] || ($dhx8H[name] = {});
    var expProto = exports[$405f18044f314da9$var$PROTOTYPE];
    var target = IS_GLOBAL ? $63L5I : IS_STATIC ? $63L5I[name] : ($63L5I[name] || {})[$405f18044f314da9$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8uIdh(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $8fJLB(out, $63L5I) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$405f18044f314da9$var$PROTOTYPE] = C[$405f18044f314da9$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $8fJLB(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $405f18044f314da9$var$$export.R && expProto && !expProto[key]) $8akT7(expProto, key, out);
        }
    }
};
// type bitmap
$405f18044f314da9$var$$export.F = 1; // forced
$405f18044f314da9$var$$export.G = 2; // global
$405f18044f314da9$var$$export.S = 4; // static
$405f18044f314da9$var$$export.P = 8; // proto
$405f18044f314da9$var$$export.B = 16; // bind
$405f18044f314da9$var$$export.W = 32; // wrap
$405f18044f314da9$var$$export.U = 64; // safe
$405f18044f314da9$var$$export.R = 128; // real proto method for `library`
module.exports = $405f18044f314da9$var$$export;

});
parcelRegister("63L5I", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $46978d3810f5c50a$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $46978d3810f5c50a$var$global; // eslint-disable-line no-undef

});

parcelRegister("dhx8H", function(module, exports) {
var $9ab691a5895850dc$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9ab691a5895850dc$var$core; // eslint-disable-line no-undef

});

parcelRegister("8fJLB", function(module, exports) {
// optional / simple context binding

var $2vhgy = parcelRequire("2vhgy");
module.exports = function(fn, that, length) {
    $2vhgy(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2vhgy", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("8akT7", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $dhKmr = parcelRequire("dhKmr");

module.exports = (parcelRequire("kD5IQ")) ? function(object, key, value) {
    return $9jrHv.f(object, key, $dhKmr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("9jrHv", function(module, exports) {

$parcel$export(module.exports, "f", () => $6c7b6032f547fb4c$export$2d1720544b23b823, (v) => $6c7b6032f547fb4c$export$2d1720544b23b823 = v);
var $6c7b6032f547fb4c$export$2d1720544b23b823;

var $aIdHH = parcelRequire("aIdHH");

var $3Ksbk = parcelRequire("3Ksbk");

var $1zpu5 = parcelRequire("1zpu5");
var $6c7b6032f547fb4c$var$dP = Object.defineProperty;

$6c7b6032f547fb4c$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $aIdHH(O);
    P = $1zpu5(P, true);
    $aIdHH(Attributes);
    if ($3Ksbk) try {
        return $6c7b6032f547fb4c$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("aIdHH", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");
module.exports = function(it) {
    if (!$8T9YM(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("8T9YM", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3Ksbk", function(module, exports) {



module.exports = !(parcelRequire("kD5IQ")) && !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty((parcelRequire("2fnkQ"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("kD5IQ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cbAAd", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("2fnkQ", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");

var $63L5I = parcelRequire("63L5I");
var $1a2f155b99584f9f$require$document = $63L5I.document;
// typeof document.createElement is 'object' in old IE
var $1a2f155b99584f9f$var$is = $8T9YM($1a2f155b99584f9f$require$document) && $8T9YM($1a2f155b99584f9f$require$document.createElement);
module.exports = function(it) {
    return $1a2f155b99584f9f$var$is ? $1a2f155b99584f9f$require$document.createElement(it) : {};
};

});


parcelRegister("1zpu5", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $8T9YM = parcelRequire("8T9YM");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$8T9YM(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("dhKmr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8uIdh", function(module, exports) {
var $62f36be98ddb54f8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $62f36be98ddb54f8$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cZpQU", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $aIdHH = parcelRequire("aIdHH");

var $1o8G4 = parcelRequire("1o8G4");

var $c3pDW = parcelRequire("c3pDW");

var $974f3c4319e9c96a$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
var $974f3c4319e9c96a$var$Empty = function() {};
var $974f3c4319e9c96a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $974f3c4319e9c96a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("2fnkQ"))('iframe');
    var i = $c3pDW.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("5JYrt")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $974f3c4319e9c96a$var$createDict = iframeDocument.F;
    while(i--)delete $974f3c4319e9c96a$var$createDict[$974f3c4319e9c96a$var$PROTOTYPE][$c3pDW[i]];
    return $974f3c4319e9c96a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = $aIdHH(O);
        result = new $974f3c4319e9c96a$var$Empty();
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$974f3c4319e9c96a$var$IE_PROTO] = O;
    } else result = $974f3c4319e9c96a$var$createDict();
    return Properties === undefined ? result : $1o8G4(result, Properties);
};

});
parcelRegister("1o8G4", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $aIdHH = parcelRequire("aIdHH");

var $kJc9M = parcelRequire("kJc9M");

module.exports = (parcelRequire("kD5IQ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $aIdHH(O);
    var keys = $kJc9M(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$9jrHv.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("kJc9M", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $58JMR = parcelRequire("58JMR");

var $c3pDW = parcelRequire("c3pDW");
module.exports = Object.keys || function keys(O) {
    return $58JMR(O, $c3pDW);
};

});
parcelRegister("58JMR", function(module, exports) {

var $8uIdh = parcelRequire("8uIdh");

var $6WitF = parcelRequire("6WitF");

var $3be1377c0765345e$var$arrayIndexOf = (parcelRequire("hZ5wn"))(false);

var $3be1377c0765345e$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $6WitF(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3be1377c0765345e$var$IE_PROTO) $8uIdh(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8uIdh(O, key = names[i++])) ~$3be1377c0765345e$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("6WitF", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $jRK2B = parcelRequire("jRK2B");

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return $jRK2B($5XrWm(it));
};

});
parcelRegister("jRK2B", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $9A6tO = parcelRequire("9A6tO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $9A6tO(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("9A6tO", function(module, exports) {
var $6f9c80961703262c$var$toString = {}.toString;
module.exports = function(it) {
    return $6f9c80961703262c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("5XrWm", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hZ5wn", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $6WitF = parcelRequire("6WitF");

var $9sYrG = parcelRequire("9sYrG");

var $dmeMq = parcelRequire("dmeMq");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6WitF($this);
        var length = $9sYrG(O.length);
        var index = $dmeMq(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("9sYrG", function(module, exports) {
// 7.1.15 ToLength

var $cIXGZ = parcelRequire("cIXGZ");
var $6e459dd0a2f7e0ab$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $6e459dd0a2f7e0ab$var$min($cIXGZ(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("cIXGZ", function(module, exports) {
// 7.1.4 ToInteger
var $9437e5c320839147$var$ceil = Math.ceil;
var $9437e5c320839147$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $9437e5c320839147$var$floor : $9437e5c320839147$var$ceil)(it);
};

});


parcelRegister("dmeMq", function(module, exports) {

var $cIXGZ = parcelRequire("cIXGZ");
var $9b98cb76c764326c$var$max = Math.max;
var $9b98cb76c764326c$var$min = Math.min;
module.exports = function(index, length) {
    index = $cIXGZ(index);
    return index < 0 ? $9b98cb76c764326c$var$max(index + length, 0) : $9b98cb76c764326c$var$min(index, length);
};

});


parcelRegister("5PKej", function(module, exports) {

var $43f59377ae23d08e$var$shared = (parcelRequire("jmDxJ"))('keys');

var $c3eWa = parcelRequire("c3eWa");
module.exports = function(key) {
    return $43f59377ae23d08e$var$shared[key] || ($43f59377ae23d08e$var$shared[key] = $c3eWa(key));
};

});
parcelRegister("jmDxJ", function(module, exports) {

var $dhx8H = parcelRequire("dhx8H");

var $63L5I = parcelRequire("63L5I");
var $e18ebed786cb5a63$var$SHARED = '__core-js_shared__';
var $e18ebed786cb5a63$var$store = $63L5I[$e18ebed786cb5a63$var$SHARED] || ($63L5I[$e18ebed786cb5a63$var$SHARED] = {});

(module.exports = function(key, value) {
    return $e18ebed786cb5a63$var$store[key] || ($e18ebed786cb5a63$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dhx8H.version,
    mode: (parcelRequire("ijzx7")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ijzx7", function(module, exports) {
module.exports = true;

});


parcelRegister("c3eWa", function(module, exports) {
var $8c615a0c227a0f34$var$id = 0;
var $8c615a0c227a0f34$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8c615a0c227a0f34$var$id + $8c615a0c227a0f34$var$px).toString(36));
};

});



parcelRegister("c3pDW", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("5JYrt", function(module, exports) {

var $63L5I = parcelRequire("63L5I");
var $42e00a46ad7a4675$require$document = $63L5I.document;
module.exports = $42e00a46ad7a4675$require$document && $42e00a46ad7a4675$require$document.documentElement;

});





parcelRegister("hhPJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c260637bde23a$export$2e2bcd8739ae039);

var $5wQ82 = parcelRequire("5wQ82");
function $c95c260637bde23a$export$2e2bcd8739ae039(o, p) {
    $c95c260637bde23a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))) ? (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c95c260637bde23a$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("5wQ82", function(module, exports) {

module.exports = (parcelRequire("1Ra8X"));

});
parcelRegister("1Ra8X", function(module, exports) {
parcelRequire("l16ba");

module.exports = (parcelRequire("dhx8H")).Object.setPrototypeOf;

});
parcelRegister("l16ba", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Object', {
    setPrototypeOf: (parcelRequire("35fJw")).set
});

});
parcelRegister("35fJw", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $8T9YM = parcelRequire("8T9YM");

var $aIdHH = parcelRequire("aIdHH");
var $23ee0b0348ea4da9$var$check = function(O, proto) {
    $aIdHH(O);
    if (!$8T9YM(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("8fJLB"))(Function.call, (parcelRequire("2PKjW")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $23ee0b0348ea4da9$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $23ee0b0348ea4da9$var$check
};

});
parcelRegister("2PKjW", function(module, exports) {

$parcel$export(module.exports, "f", () => $2104467c0339117f$export$2d1720544b23b823, (v) => $2104467c0339117f$export$2d1720544b23b823 = v);
var $2104467c0339117f$export$2d1720544b23b823;

var $4hWyV = parcelRequire("4hWyV");

var $dhKmr = parcelRequire("dhKmr");

var $6WitF = parcelRequire("6WitF");

var $1zpu5 = parcelRequire("1zpu5");

var $8uIdh = parcelRequire("8uIdh");

var $3Ksbk = parcelRequire("3Ksbk");
var $2104467c0339117f$var$gOPD = Object.getOwnPropertyDescriptor;

$2104467c0339117f$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? $2104467c0339117f$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $6WitF(O);
    P = $1zpu5(P, true);
    if ($3Ksbk) try {
        return $2104467c0339117f$var$gOPD(O, P);
    } catch (e) {}
    if ($8uIdh(O, P)) return $dhKmr(!$4hWyV.f.call(O, P), O[P]);
};

});
parcelRegister("4hWyV", function(module, exports) {

$parcel$export(module.exports, "f", () => $31f62d36f059d1f7$export$2d1720544b23b823, (v) => $31f62d36f059d1f7$export$2d1720544b23b823 = v);
var $31f62d36f059d1f7$export$2d1720544b23b823;
$31f62d36f059d1f7$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("34lu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c2693f2e66cfe6$export$2e2bcd8739ae039);

var $85I24 = parcelRequire("85I24");
function $23c2693f2e66cfe6$export$2e2bcd8739ae039() {
    $23c2693f2e66cfe6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($85I24))) ? (0, (/*@__PURE__*/$parcel$interopDefault($85I24))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23c2693f2e66cfe6$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("85I24", function(module, exports) {

module.exports = (parcelRequire("aOK7Q"));

});
parcelRegister("aOK7Q", function(module, exports) {
parcelRequire("8ASim");

module.exports = (parcelRequire("dhx8H")).Object.assign;

});
parcelRegister("8ASim", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S + $5wEa2.F, 'Object', {
    assign: (parcelRequire("jxu2z"))
});

});
parcelRegister("jxu2z", function(module, exports) {
'use strict';

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $cAldW = parcelRequire("cAldW");

var $4hWyV = parcelRequire("4hWyV");

var $1kVaN = parcelRequire("1kVaN");

var $jRK2B = parcelRequire("jRK2B");
var $e39866c849d56a4e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$e39866c849d56a4e$var$$assign || (parcelRequire("cbAAd"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $e39866c849d56a4e$var$$assign({}, A)[S] != 7 || Object.keys($e39866c849d56a4e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1kVaN(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $cAldW.f;
    var isEnum = $4hWyV.f;
    while(aLen > index){
        var S = $jRK2B(arguments[index++]);
        var keys = getSymbols ? $kJc9M(S).concat(getSymbols(S)) : $kJc9M(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$kD5IQ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $e39866c849d56a4e$var$$assign;

});
parcelRegister("cAldW", function(module, exports) {

$parcel$export(module.exports, "f", () => $92994f6ff34f2a23$export$2d1720544b23b823, (v) => $92994f6ff34f2a23$export$2d1720544b23b823 = v);
var $92994f6ff34f2a23$export$2d1720544b23b823;
$92994f6ff34f2a23$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("1kVaN", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return Object($5XrWm(it));
};

});






parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("dCUwp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ebaaafca6cfcfc3$export$2e2bcd8739ae039);
var $9ebaaafca6cfcfc3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9ebaaafca6cfcfc3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9ebaaafca6cfcfc3$var$safeIsNaN(first) && $9ebaaafca6cfcfc3$var$safeIsNaN(second)) return true;
    return false;
}
function $9ebaaafca6cfcfc3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9ebaaafca6cfcfc3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9ebaaafca6cfcfc3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9ebaaafca6cfcfc3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $9ebaaafca6cfcfc3$export$2e2bcd8739ae039 = $9ebaaafca6cfcfc3$var$memoizeOne;

});

parcelRegister("3YjjI", function(module, exports) {

module.exports = (parcelRequire("2NZpQ"));

});
parcelRegister("2NZpQ", function(module, exports) {
parcelRequire("jDAxN");

module.exports = (parcelRequire("dhx8H")).Object.values;

});
parcelRegister("jDAxN", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $5wEa2 = parcelRequire("5wEa2");

var $e4be01bfca6fcf6b$var$$values = (parcelRequire("24HEe"))(false);
$5wEa2($5wEa2.S, 'Object', {
    values: function values(it) {
        return $e4be01bfca6fcf6b$var$$values(it);
    }
});

});
parcelRegister("24HEe", function(module, exports) {

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $6WitF = parcelRequire("6WitF");

var $4hWyV = parcelRequire("4hWyV");
var $182dd014df77b78c$require$isEnum = $4hWyV.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $6WitF(it);
        var keys = $kJc9M(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$kD5IQ || $182dd014df77b78c$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("l1Zd2", function(module, exports) {

module.exports = (parcelRequire("3eZZ2"));

});
parcelRegister("3eZZ2", function(module, exports) {
parcelRequire("cV6iX");

module.exports = (parcelRequire("dhx8H")).Object.keys;

});
parcelRegister("cV6iX", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $1kVaN = parcelRequire("1kVaN");

var $kJc9M = parcelRequire("kJc9M");

(parcelRequire("1u1Xc"))('keys', function() {
    return function keys(it) {
        return $kJc9M($1kVaN(it));
    };
});

});
parcelRegister("1u1Xc", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $5wEa2 = parcelRequire("5wEa2");

var $dhx8H = parcelRequire("dhx8H");

var $cbAAd = parcelRequire("cbAAd");
module.exports = function(KEY, exec) {
    var fn = ($dhx8H.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $5wEa2($5wEa2.S + $5wEa2.F * $cbAAd(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("gxvYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a8875644982a16$export$2e2bcd8739ae039);
var $c0a8875644982a16$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c0a8875644982a16$export$2e2bcd8739ae039 = $c0a8875644982a16$var$rafSchd;

});

parcelRegister("5JNlj", function(module, exports) {

module.exports = (parcelRequire("fpboz"));

});
parcelRegister("fpboz", function(module, exports) {
parcelRequire("1WSQk");

module.exports = (parcelRequire("dhx8H")).Date.now;

});
parcelRegister("1WSQk", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $5wEa2 = parcelRequire("5wEa2");
$5wEa2($5wEa2.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("8kUbC", function(module, exports) {

module.exports = (parcelRequire("jmbPZ"));

});
parcelRegister("jmbPZ", function(module, exports) {
parcelRequire("hSyJ0");

module.exports = (parcelRequire("dhx8H")).Number.isInteger;

});
parcelRegister("hSyJ0", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Number', {
    isInteger: (parcelRequire("cYSpV"))
});

});
parcelRegister("cYSpV", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $8T9YM = parcelRequire("8T9YM");
var $97354cb9c31bad1d$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$8T9YM(it) && isFinite(it) && $97354cb9c31bad1d$var$floor(it) === it;
};

});







parcelRegister("hmyz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a90b20ff2f5cb2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $966Wa = parcelRequire("966Wa");

var $giAhk = parcelRequire("giAhk");

var $hO7ri = parcelRequire("hO7ri");
var $l9U81 = parcelRequire("l9U81");

var $4RHb8 = parcelRequire("4RHb8");
const $1a90b20ff2f5cb2a$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
// Note that react-beautiful-dnd actually handles body styles when dragging
// BUT it doesn't prevent the ICC placeholder from triggering on the board and backlog
// and as a result we need this class here to prevent that behaviour
const $1a90b20ff2f5cb2a$var$StyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                /* disable hover events during drag */
                body.${$1a90b20ff2f5cb2a$var$IS_DRAGGING_CLASS_NAME} * {
                    pointer-events: none;
                }
            `
        }
    });
const $1a90b20ff2f5cb2a$var$defaultCardDndTypes = [
    (0, $df03f3fe1f111432$export$b05303cbde3e8c8c)
];
// eslint-disable-next-line jira/react/no-class-components
class $1a90b20ff2f5cb2a$var$BoardDragDropContext extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            cardDndTypes: $1a90b20ff2f5cb2a$var$defaultCardDndTypes,
            onCardsMove: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onColumnMove: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onBeforeCapture: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onDragUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { children: children, sensors: sensors } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.DragDropContext), {
            onBeforeCapture: this.onBeforeCapture,
            onBeforeDragStart: this.onBeforeDragStart,
            onDragStart: this.onDragStart,
            onDragUpdate: this.onDragUpdate,
            onDragEnd: this.onDragEnd,
            sensors: sensors
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a90b20ff2f5cb2a$var$StyleOverride, null), children);
    }
    constructor(...args){
        super(...args);
        this.initialTotalCards = 0;
        this.onBeforeCapture = (beforeCapture)=>{
            this.props.onBeforeCapture(beforeCapture);
        };
        this.onBeforeDragStart = (dragStart)=>{
            const card = document.querySelector(`[data-rbd-draggable-id="${dragStart.draggableId}"]`);
            if (card && card.classList) this.draggingCardRef = card;
            const { totalCards: totalCards } = (0, $l9U81.getDraggingCardStatus)(dragStart.source.droppableId, this.draggingCardRef);
            this.initialTotalCards = totalCards;
        };
        this.onDragStart = (dragStart, provided)=>{
            this.props.onDragStart(dragStart);
            document.body?.classList.add($1a90b20ff2f5cb2a$var$IS_DRAGGING_CLASS_NAME);
            if (!this.props.intl) return;
            const { intl: intl } = this.props;
            // Clear the unwanted screen reader announce from the dragging item
            document.querySelector(`[data-rbd-draggable-id="${dragStart.draggableId}"]`)?.setAttribute('aria-labelledby', this.draggingCardRef?.getAttribute('aria-labelledby') ?? '');
            const { columnName: columnName, issueKey: issueKey, ignoreDndTypeInMessage: ignoreDndTypeInMessage } = (0, $l9U81.getDraggingCardStatus)(dragStart.source.droppableId, this.draggingCardRef);
            provided.announce(intl.formatMessage((0, $4RHb8.default).grabbed, {
                issueKey: issueKey,
                fromPosition: dragStart.source.index + 1,
                totalCards: this.initialTotalCards,
                columnName: columnName,
                dndType: dragStart.type,
                ignoreDndTypeInMessage: ignoreDndTypeInMessage
            }));
        };
        this.onDragUpdate = (dragUpdate, provided)=>{
            this.props.onDragUpdate(dragUpdate);
            if (!this.props.intl) return;
            const { intl: intl } = this.props;
            const { source: source, destination: destination } = dragUpdate;
            const { cardDndTypes: cardDndTypes } = this.props;
            if (cardDndTypes.includes(dragUpdate.type)) {
                const { columnName: columnName, issueKey: issueKey, ignoreDndTypeInMessage: ignoreDndTypeInMessage } = (0, $l9U81.getDraggingCardStatus)(destination?.droppableId ?? source.droppableId, this.draggingCardRef);
                if (destination?.droppableId === source.droppableId) {
                    if (destination?.index === source.index) provided.announce(intl.formatMessage((0, $4RHb8.default).movedBackPosition, {
                        issueKey: issueKey,
                        columnName: columnName,
                        ignoreDndTypeInMessage: ignoreDndTypeInMessage
                    }));
                    else provided.announce(intl.formatMessage((0, $4RHb8.default).movedNewPosition, {
                        issueKey: issueKey,
                        fromPosition: source.index + 1,
                        toPosition: (destination.index ?? 0) + 1,
                        totalCards: this.initialTotalCards,
                        columnName: columnName,
                        ignoreDndTypeInMessage: ignoreDndTypeInMessage
                    }));
                    return;
                }
                provided.announce(intl.formatMessage((0, $4RHb8.default).movedNewColumn, {
                    issueKey: issueKey,
                    toPosition: (dragUpdate.destination?.index ?? 0) + 1,
                    columnName: columnName,
                    ignoreDndTypeInMessage: ignoreDndTypeInMessage
                }));
            }
        };
        this.onDragEnd = (result, provided)=>{
            this.props.onDragEnd(result);
            document.body?.classList.remove($1a90b20ff2f5cb2a$var$IS_DRAGGING_CLASS_NAME);
            const { destination: destination } = result;
            if (result.reason === 'CANCEL' || !destination) return;
            const { cardDndTypes: cardDndTypes } = this.props;
            if (cardDndTypes.includes(result.type)) {
                const cardId = Number((0, $hO7ri.getDescriptor)(result.draggableId).id);
                const { id: sourceColumnId, swimlaneId: sourceSwimlaneId } = (0, $hO7ri.getDescriptor)(result.source.droppableId);
                const { id: destinationColumnId, swimlaneId: destinationSwimlaneId } = (0, $hO7ri.getDescriptor)(destination.droppableId);
                this.props.onCardsMove([
                    cardId
                ], sourceColumnId, destinationColumnId, result.source.index, destination.index, sourceSwimlaneId, destinationSwimlaneId);
                // Temporarily clear the lift instructions so drop message is announced first
                const labelledby = this.draggingCardRef?.getAttribute('aria-labelledby') || '';
                this.draggingCardRef?.setAttribute('aria-labelledby', '');
                const { columnName: columnName, issueKey: issueKey, totalCards: totalCards, ignoreDndTypeInMessage: ignoreDndTypeInMessage } = (0, $l9U81.getDraggingCardStatus)(destination.droppableId ?? result.source.droppableId, this.draggingCardRef);
                if (this.props.intl) {
                    const sameColumn = sourceColumnId === destinationColumnId;
                    provided.announce(this.props.intl.formatMessage((0, $4RHb8.default).dropped, {
                        issueKey: issueKey,
                        toPosition: (destination.index ?? 0) + 1,
                        totalCards: sameColumn ? this.initialTotalCards : totalCards + 1,
                        columnName: columnName,
                        ignoreDndTypeInMessage: ignoreDndTypeInMessage
                    }));
                }
                this.draggingCardRef?.setAttribute('aria-labelledby', labelledby);
            } else if (result.type === (0, $df03f3fe1f111432$export$57d0ef745f304b91)) {
                const columnId = (0, $hO7ri.getDescriptor)(result.draggableId).id;
                this.props.onColumnMove(columnId, result.source.index, destination.index);
            }
            this.draggingCardRef = undefined;
            this.initialTotalCards = 0;
        };
    }
}
var $1a90b20ff2f5cb2a$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($1a90b20ff2f5cb2a$var$BoardDragDropContext);

});
parcelRegister("hO7ri", function(module, exports) {

$parcel$export(module.exports, "getDescriptor", () => $1789d2f72ab65421$export$dd068f9289a3efeb);
$parcel$export(module.exports, "getColumnDescriptor", () => $1789d2f72ab65421$export$37010f521c16e534);
$parcel$export(module.exports, "getCardDescriptor", () => $1789d2f72ab65421$export$e50ce3233c010197);

const $1789d2f72ab65421$export$dd068f9289a3efeb = (identifier)=>{
    const [type, id, swimlaneId] = identifier.split('::');
    const maybeNumberId = Number(id);
    return {
        type: type,
        id: Number.isNaN(maybeNumberId) ? id : maybeNumberId,
        swimlaneId: swimlaneId || undefined
    };
};
const $1789d2f72ab65421$export$37010f521c16e534 = (columnId, swimlaneId)=>swimlaneId ? `${0, $6b4af2fedea04341$export$7f092194d45e1f0d}::${columnId}::${swimlaneId}` : `${0, $6b4af2fedea04341$export$7f092194d45e1f0d}::${columnId}`;
const $1789d2f72ab65421$export$e50ce3233c010197 = (cardId)=>`${0, $6b4af2fedea04341$export$76a449e52fa0e1e8}::${cardId}`;

});
const $6b4af2fedea04341$export$76a449e52fa0e1e8 = 'ISSUE';
const $6b4af2fedea04341$export$7f092194d45e1f0d = 'COLUMN';


parcelRegister("l9U81", function(module, exports) {

$parcel$export(module.exports, "getDraggingCardStatus", () => $a45d50f198d751ee$export$cb0f697d1bc6ae27);

var $aACMj = parcelRequire("aACMj");
function $a45d50f198d751ee$var$findColumnHeader(el) {
    if (!el) return '';
    const announcedHeader = el.getAttribute((0, $aACMj.DATA_ANNOUNCED_COLUMN_HEADER));
    return announcedHeader || el.querySelector('h2 > *:first-child')?.innerHTML || '';
}
const $a45d50f198d751ee$export$cb0f697d1bc6ae27 = (droppableId, draggingCardRef)=>{
    if (droppableId === 'board') {
        const parent = draggingCardRef?.parentElement;
        const siblings = parent?.querySelectorAll(`:scope > ${(0, $aACMj.DRAGGABLE_COLUMN_SELECTOR)}`);
        const totalCards = siblings?.length || 1;
        return {
            columnName: '',
            issueKey: $a45d50f198d751ee$var$findColumnHeader(draggingCardRef),
            totalCards: totalCards,
            ignoreDndTypeInMessage: false
        };
    }
    const column = document.querySelector(`[data-rbd-draggable-id="${droppableId}"]${(0, $aACMj.DRAGGABLE_COLUMN_SELECTOR)}`) || document.querySelector(`[data-announced-id="${droppableId}"]`);
    const issueId = draggingCardRef?.getAttribute('id') ?? '';
    const header = draggingCardRef?.getAttribute((0, $aACMj.DATA_ANNOUNCED_CARD_HEADER));
    const idKey = issueId !== '' ? (/card-(.+)/.exec(issueId) ?? [
        '',
        ''
    ])[1] : '';
    const issueKey = header || idKey;
    if (!column) return {
        columnName: '',
        issueKey: issueKey,
        totalCards: 1,
        ignoreDndTypeInMessage: false
    };
    const ignoreDndTypeInMessage = column.hasAttribute((0, $aACMj.DATA_ANNOUNCED_IGNORE_DND_TYPE));
    const totalCards = column.querySelectorAll((0, $aACMj.CARD_CONTAINER_SELECTOR)).length;
    const columnName = $a45d50f198d751ee$var$findColumnHeader(column);
    return {
        columnName: columnName,
        issueKey: issueKey,
        totalCards: totalCards,
        ignoreDndTypeInMessage: ignoreDndTypeInMessage
    };
};

});

parcelRegister("4RHb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $929480d4ccc4ff57$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $929480d4ccc4ff57$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    grabbed: {
        "id": "platform-board-kit-legacy-dnd.board-drag-drop-context.grabbed",
        "defaultMessage": "{dndType, select, COLUMN {Column} other {Card}} {issueKey} grabbed. Current Position is {fromPosition} of {totalCards} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}. Use the arrow keys to move, space-bar to drop and escape to cancel."
    },
    movedBackPosition: {
        "id": "platform-board-kit-legacy-dnd.board-drag-drop-context.moved-back-position",
        "defaultMessage": "You've moved {issueKey} back to its original position in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}."
    },
    movedNewPosition: {
        "id": "platform-board-kit-legacy-dnd.board-drag-drop-context.moved-new-position",
        "defaultMessage": "You've moved {issueKey} from position {fromPosition} to position {\n            toPosition\n        } of {totalCards} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {Column}}."
    },
    movedNewColumn: {
        "id": "platform-board-kit-legacy-dnd.board-drag-drop-context.moved-new-column",
        "defaultMessage": "You've moved {issueKey} to position {toPosition} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}."
    },
    dropped: {
        "id": "platform-board-kit-legacy-dnd.board-drag-drop-context.dropped",
        "defaultMessage": "You've dropped {issueKey} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}. Final position is {toPosition} of {totalCards}"
    }
});

});


parcelRegister("jRisP", function(module, exports) {

$parcel$export(module.exports, "ActionsMenuPopupContext", () => $5f49eea02405471f$export$ec998ff9ae917670);
$parcel$export(module.exports, "ActionsMenuPopupProvider", () => $5f49eea02405471f$export$fc27250915227614);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $5f49eea02405471f$export$ec998ff9ae917670 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    openPopupRef: null,
    setOpenPopupRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $5f49eea02405471f$export$fc27250915227614 = ({ children: children })=>{
    const [openPopupRef, setOpenPopupRef] = (0, $eUqFw.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f49eea02405471f$export$ec998ff9ae917670.Provider, {
        value: {
            openPopupRef: openPopupRef,
            setOpenPopupRef: setOpenPopupRef
        }
    }, children);
};

});

parcelRegister("b8XnM", function(module, exports) {

$parcel$export(module.exports, "useRenameColumn", () => $10dd32854b818bdb$export$9c7aed67d23909ba);
$parcel$export(module.exports, "useAddColumn", () => $10dd32854b818bdb$export$3f395c9a4f509e34);

var $dFBS3 = parcelRequire("dFBS3");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $46lXM = parcelRequire("46lXM");

var $lqN6D = parcelRequire("lqN6D");

var $fPXdd = parcelRequire("fPXdd");
var $46y1c = parcelRequire("46y1c");

var $bFk6h = parcelRequire("bFk6h");

var $l6iPu = parcelRequire("l6iPu");

var $j0XTg = parcelRequire("j0XTg");

var $fQmQL = parcelRequire("fQmQL");

var $iPk7h = parcelRequire("iPk7h");

var $4NnjE = parcelRequire("4NnjE");
const $10dd32854b818bdb$var$TEMPORARY_STATUS_ID = 42; // Will be overridden in the backend
const $10dd32854b818bdb$export$9c7aed67d23909ba = ()=>{
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $46y1c.useWorkflowsV2)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ columns: columns }, { modifyColumn: modifyColumn }] = (0, $lqN6D.useBoardStore)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.COLUMN_ACTION_RENAME_EXPERIENCE));
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    let refetchBoardData;
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ refetch: refetchBoardData } = (0, $bFk6h.useBoardData)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    refetchBoardData = (0, $l6iPu.useRefetchBoardData)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.subtask)?.id;
    const issueTypeIdNotSubtask = issueTypes.find((issueType)=>!issueType.subtask)?.id;
    const getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
    /**
   * @returns undefined if it is valid, otherwise return string that will be used as error message
   * this is a pattern used by atlaskit form field validation or inline edit
   */ const validateRename = ({ oldName: oldName, newName: newName })=>{
        const cleanNewName = getCleanColumnName(newName);
        if ((0, $46lXM.convertStatusNameForComparison)(cleanNewName) === (0, $46lXM.convertStatusNameForComparison)(oldName)) return undefined;
        if (cleanNewName === '') return formatMessage((0, $j0XTg.default).emptyColumnNameError);
        if (columns.some((col)=>(0, $46lXM.convertStatusNameForComparison)(col.name) === (0, $46lXM.convertStatusNameForComparison)(cleanNewName))) return formatMessage((0, $j0XTg.default).statusAlreadyExists, {
            statusName: cleanNewName
        });
        return undefined;
    };
    const renameColumn = async ({ oldName: oldName, statusId: statusId, newName: newName })=>{
        const cleanNewName = getCleanColumnName(newName);
        if (cleanNewName === '') return;
        if ((0, $46lXM.convertStatusNameForComparison)(cleanNewName) === (0, $46lXM.convertStatusNameForComparison)(oldName)) return;
        startExperience();
        // set the board column to be loading status
        // optimistic update the name also
        modifyColumn(statusId, {
            loading: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            name: cleanNewName
        });
        const revertOptimisticLoadingState = ()=>{
            modifyColumn(statusId, {
                loading: false,
                name: oldName
            });
        };
        // fetch workflow data from workflow API
        let workflowsData;
        try {
            workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: issueTypes.map((it)=>({
                        projectId: projectId,
                        issueTypeId: it.id
                    }))
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            revertOptimisticLoadingState();
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleRenameColumn,
                action: 'rename',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey
            }));
            if (error && (0, $JRB5w.isClientFetchError)(error) || (0, $fQmQL.isFilteredNetworkError)(error)) markExperienceSuccess();
            else markExperienceFailed('failed to fetch workflow data', error);
            return;
        }
        if (!workflowsData) {
            revertOptimisticLoadingState();
            markExperienceFailed('workflow data is empty', new Error('workflow data is empty'));
            return;
        }
        // remove subtask workflow
        const filteredWorkflowsData = (0, $fQmQL.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
        // rename the column in place
        const toRenameStatus = filteredWorkflowsData.statuses.find((s)=>s.id === statusId.toString());
        if (!toRenameStatus) {
            revertOptimisticLoadingState();
            markExperienceFailed('cannot find status to rename in workflow data', new Error('cannot find status to rename in workflow data'));
            return;
        }
        toRenameStatus.name = cleanNewName;
        const updatePayload = {
            statuses: (0, $fPXdd.mapStatusesToStatusUpdateObjects)(workflowsData.statuses),
            workflows: [
                (0, $fPXdd.mapWorkflowToWorkflowUpdateObject)(workflowsData.workflows[0])
            ]
        };
        // validate the payload and update the worfklow
        try {
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: updatePayload,
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            revertOptimisticLoadingState();
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleRenameColumn,
                action: 'rename',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey
            }));
            (0, $fQmQL.fireColumnExperienceTracking)({
                markExperienceSuccess: markExperienceSuccess,
                markExperienceFailed: markExperienceFailed,
                error: error,
                errorMessage: 'failed to validate and update workflow'
            });
            return;
        }
        markExperienceSuccess();
        // sync the board data after rename
        await refetchBoardData();
        // since fetchBoardData will update the column name, we want to set the `loading` state to be false
        modifyColumn(statusId, {
            loading: false
        });
    };
    return {
        renameColumn: renameColumn,
        validateRename: validateRename
    };
};
const $10dd32854b818bdb$export$3f395c9a4f509e34 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ columns: columns, workflows: workflows }, { addColumn: addColumn, setColumnsAndWorkflows: setColumnsAndWorkflows }] = (0, $lqN6D.useBoardStore)();
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $46y1c.useWorkflowsV2)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.COLUMN_ACTION_ADD_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.COLUMN_ACTION_ADD_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.COLUMN_ACTION_ADD_EXPERIENCE));
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    let refetchBoardData;
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ refetch: refetchBoardData } = (0, $bFk6h.useBoardData)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    refetchBoardData = (0, $l6iPu.useRefetchBoardData)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.subtask)?.id;
    const revertOptimisticUpdate = ()=>{
        setColumnsAndWorkflows(columns, workflows);
    };
    const issueTypeIdNotSubtask = issueTypes.find((issueType)=>!issueType.subtask)?.id;
    const addNewColumn = async ({ columnName: columnName })=>{
        startExperience();
        addColumn({
            name: columnName,
            untranslatedName: columnName,
            statusCategory: (0, $8Qd0L.StatusCategoryTypes).INDETERMINATE,
            statusId: $10dd32854b818bdb$var$TEMPORARY_STATUS_ID,
            canCreateIssues: true,
            hasFilteredIssues: false,
            isCollapsed: false,
            loading: true
        });
        // Fetch workflow data from workflow API
        let workflowsData;
        try {
            workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: issueTypes.map((it)=>({
                        projectId: projectId,
                        issueTypeId: it.id
                    }))
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            revertOptimisticUpdate();
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleAddColumn,
                action: 'add',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey
            }));
            if (error && (0, $JRB5w.isClientFetchError)(error) || (0, $fQmQL.isFilteredNetworkError)(error)) markExperienceSuccess();
            else markExperienceFailed('failed to fetch workflow data', error);
            return;
        }
        if (!workflowsData) {
            revertOptimisticUpdate();
            markExperienceFailed('workflow data is empty', new Error('workflow data is empty'));
            return;
        }
        // remove subtask workflow
        const filteredWorkflowsData = (0, $fQmQL.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
        const { statuses: statuses, workflows: boardWorkflows } = filteredWorkflowsData;
        const workflow = boardWorkflows[0];
        // Create new status and transition
        const getUniqueTransitionId = (transitions)=>{
            const largestId = Math.max(...transitions.map((t)=>parseInt(t.id, 10)));
            return String(largestId + 1);
        };
        const transitionId = getUniqueTransitionId(workflow.transitions);
        // check if existing transition has same name as the new status
        const newTransitionName = workflow.transitions.some((t)=>(0, $46lXM.convertStatusNameForComparison)(t.name) === (0, $46lXM.convertStatusNameForComparison)(columnName)) ? `${columnName} ${transitionId}` : columnName;
        const statusReference = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const newStatus = {
            statusReference: statusReference,
            name: columnName,
            statusCategory: (0, $8Qd0L.IN_PROGRESS),
            description: ''
        };
        const newStatusInWorkflow = {
            statusReference: statusReference,
            properties: {},
            deprecated: false
        };
        const newTransitionInWorkflow = {
            id: transitionId,
            type: 'GLOBAL',
            from: [],
            to: {
                statusReference: statusReference
            },
            name: newTransitionName,
            description: '',
            actions: [],
            validators: [],
            triggers: [],
            properties: {}
        };
        // Append newly created status and transition into workflow data
        workflow.statuses = [
            ...workflow.statuses,
            newStatusInWorkflow
        ];
        workflow.transitions = [
            ...workflow.transitions,
            newTransitionInWorkflow
        ];
        const updatePayload = {
            statuses: [
                ...(0, $fPXdd.mapStatusesToStatusUpdateObjects)(statuses),
                newStatus
            ],
            workflows: [
                (0, $fPXdd.mapWorkflowToWorkflowUpdateObject)(workflow)
            ]
        };
        // validate the payload and update the worfklow
        try {
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: updatePayload,
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            revertOptimisticUpdate();
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleAddColumn,
                action: 'add',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey
            }));
            (0, $fQmQL.fireColumnExperienceTracking)({
                markExperienceSuccess: markExperienceSuccess,
                markExperienceFailed: markExperienceFailed,
                error: error,
                errorMessage: 'failed to validate and update workflow'
            });
            return;
        }
        markExperienceSuccess();
        // sync the board data after adding column
        await refetchBoardData();
    };
    return {
        addNewColumn: addNewColumn
    };
};

});
parcelRegister("l6iPu", function(module, exports) {

$parcel$export(module.exports, "useInitializeBoard", () => $468a28aed4ba76a6$export$5de35efbb4f38e4f);
$parcel$export(module.exports, "useRefetchBoardData", () => $468a28aed4ba76a6$export$5fb6b058ccce71e4);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $499dl = parcelRequire("499dl");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $cOkcY = parcelRequire("cOkcY");

var $lqN6D = parcelRequire("lqN6D");

var $k56ZY = parcelRequire("k56ZY");

var $8ajvJ = parcelRequire("8ajvJ");
const $468a28aed4ba76a6$export$a6053f93069720e7 = (workflow, existingIssues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subtasksMap = new Map();
    existingIssues.forEach((issue)=>{
        // issues don't have a subtask property
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        const subtasks = issue.subtasks;
        if (subtasks) subtasksMap.set(issue.id, subtasks);
    });
    const statusesDictionary = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(workflow.columns, 'statusId');
    return {
        ...workflow,
        issues: workflow.issues.map((issue)=>({
                ...issue,
                untranslatedStatusName: statusesDictionary[issue.statusId]?.untranslatedName,
                subtasks: subtasksMap.get(issue.id)
            }))
    };
};
const $468a28aed4ba76a6$var$getActiveWorkflow = (workflows, activeWorkflowId)=>{
    const activeWorkflow = workflows.find((workflow)=>workflow.workflowId === activeWorkflowId) ?? workflows[0];
    return activeWorkflow;
};
const $468a28aed4ba76a6$export$5de35efbb4f38e4f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $cOkcY.useWorkflowIssues)();
    const hasInitialized = (0, $eUqFw.useRef)(false);
    const { setFetchResponse: setFetchResponse } = (0, $lqN6D.useBoardStoreActions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [activeWorkflowId] = (0, $k56ZY.useActiveWorkflow)();
    (0, $eUqFw.useEffect)(()=>{
        if (!hasInitialized.current) {
            if (data) {
                hasInitialized.current = true;
                const activeWorkflowData = $468a28aed4ba76a6$var$getActiveWorkflow(data.workflows, activeWorkflowId);
                if (!activeWorkflowData) return;
                setFetchResponse({
                    activeWorkflow: $468a28aed4ba76a6$export$a6053f93069720e7(activeWorkflowData, []),
                    workflows: data.workflows,
                    workflowIssuesLastChangedTime: data.lastChangedTime || undefined
                });
            } else if (error) {
                hasInitialized.current = true;
                showFlag({
                    type: 'error',
                    title: (0, $8ajvJ.default).boardInitErrorTitle,
                    description: (0, $8ajvJ.default).boardInitErrorMessage
                });
            }
        }
    }, [
        activeWorkflowId,
        data,
        error,
        setFetchResponse,
        showFlag
    ]);
    return {
        loading: loading,
        error: error
    };
};
const $468a28aed4ba76a6$export$5fb6b058ccce71e4 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const { issues: currentIssues, workflowIssuesLastChangedTime: workflowIssuesLastChangedTime } = (0, $lqN6D.useBoardStoreState)();
    const { setFetchResponse: setFetchResponse } = (0, $lqN6D.useBoardStoreActions)();
    const [activeWorkflowId] = (0, $k56ZY.useActiveWorkflow)();
    return (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $499dl.fetchWorkflowIssues)(project.key, workflowIssuesLastChangedTime);
            const activeWorkflowData = $468a28aed4ba76a6$var$getActiveWorkflow(response.workflows, activeWorkflowId);
            if (!activeWorkflowData) return;
            setFetchResponse({
                activeWorkflow: $468a28aed4ba76a6$export$a6053f93069720e7(activeWorkflowData, currentIssues),
                workflows: response.workflows,
                workflowIssuesLastChangedTime: response.lastChangedTime || undefined
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $499dl.Unchanged)) // do nothing when data has not changed
            return;
            (0, $guiFP.default)({
                meta: {
                    id: 'refetchBoardData',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to refetch workflow issues data'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        activeWorkflowId,
        currentIssues,
        project,
        setFetchResponse,
        workflowIssuesLastChangedTime
    ]);
};

});
parcelRegister("k56ZY", function(module, exports) {

$parcel$export(module.exports, "useActiveWorkflow", () => $1686d350e42b70d1$export$51debb5f83907415);

var $eUqFw = parcelRequire("eUqFw");

var $4ZYEI = parcelRequire("4ZYEI");

var $lEWmB = parcelRequire("lEWmB");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lqN6D = parcelRequire("lqN6D");
const $1686d350e42b70d1$export$51debb5f83907415 = ()=>{
    const { workflows: workflows } = (0, $lqN6D.useBoardStoreState)();
    const { setWorkflowData: setWorkflowData } = (0, $lqN6D.useBoardStoreActions)();
    const [activeWorkflowId, setActiveWorkflowId] = (0, $7c3W1.useViewPreference)((0, $ji3xf.ACTIVE_WORKFLOW_PREFERENCE));
    const { setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const setActiveWorkflow = (0, $eUqFw.useCallback)((newWorkflowId)=>{
        const workflow = workflows.find((wf)=>wf.workflowId === newWorkflowId) ?? workflows[0];
        setActiveWorkflowId(workflow?.workflowId);
        setWorkflowData(workflow);
        // FUN-516: reset filters when switching to a different workflow
        setFilter({});
    }, [
        workflows,
        setActiveWorkflowId,
        setWorkflowData,
        setFilter
    ]);
    const selectedWorkflowId = activeWorkflowId == null || !(0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(activeWorkflowId) ? workflows[0]?.workflowId : activeWorkflowId;
    return [
        selectedWorkflowId,
        setActiveWorkflow
    ];
};

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("8ajvJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $926cf9efe53d4bd5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $926cf9efe53d4bd5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardInitErrorTitle: {
        "id": "work-management-board.controllers.board-data-old.board-init-error-title",
        "defaultMessage": "Failed to load the board"
    },
    boardInitErrorMessage: {
        "id": "work-management-board.controllers.board-data-old.board-init-error-message",
        "defaultMessage": "We couldn't load your board, try refreshing the page or try again later."
    }
});

});


parcelRegister("j0XTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d83bd65db7ba0eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6d83bd65db7ba0eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusAlreadyExists: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.status-already-exists",
        "defaultMessage": "''{statusName}'' is already a status name in this project"
    },
    emptyColumnNameError: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.empty-column-name-error",
        "defaultMessage": "Status name cannot be empty"
    },
    errorFlagTitleAddColumn: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-title-add-column",
        "defaultMessage": "Unable to create column"
    },
    errorFlagTitleRenameColumn: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-title-rename-column",
        "defaultMessage": "Unable to rename column"
    },
    errorFlagTitleDeleteColumn: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-title-delete-column",
        "defaultMessage": "Unable to delete column"
    },
    errorFlagDescription: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-description",
        "defaultMessage": "We\u2019ve run into some connection difficulties."
    },
    errorFlagActionsRetry: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-actions-retry",
        "defaultMessage": "Try again"
    },
    errorFlagActionsCheckStatus: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.error-flag-actions-check-status",
        "defaultMessage": "Check status page"
    },
    statusNameIsNotUniqueDescription: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.status-name-is-not-unique-description",
        "defaultMessage": "This status name has been used before. To use it again, open the workflow editor and create a status with the same name."
    },
    statusHasNoIncomingTransitionTitle: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.status-has-no-incoming-transition-title",
        "defaultMessage": "Action needed to delete column"
    },
    statusHasNoIncomingTransitionDescription: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.status-has-no-incoming-transition-description",
        "defaultMessage": "You need to remove the transitions linked to this status before you can delete it."
    },
    workflowVersionConflictDescription: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.workflow-version-conflict-description",
        "defaultMessage": "Other workflow updates are in progress. Check the workflow editor and make sure they are complete before making any changes."
    },
    openWorkflowEditorAction: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.open-workflow-editor-action",
        "defaultMessage": "Open workflow editor"
    },
    viewWorkflowEditorAction: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.view-workflow-editor-action",
        "defaultMessage": "View workflow editor"
    },
    deletePollingTimeoutTitle: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.delete-polling-timeout-title",
        "defaultMessage": "Your column is being deleted"
    },
    deletePollingTimeoutDescription: {
        "id": "work-management-board.controllers.add-rename-delete-status-old.delete-polling-timeout-description",
        "defaultMessage": "Before you make other changes, check the workflow editor to make sure your column has been deleted."
    }
});

});

parcelRegister("fQmQL", function(module, exports) {

$parcel$export(module.exports, "isFilteredNetworkError", () => $24d89ab52a6a4f35$export$8a106361afb51637);
$parcel$export(module.exports, "getColumnActionFailedFlag", () => $24d89ab52a6a4f35$export$df77096ef246183b);
$parcel$export(module.exports, "fireColumnExperienceTracking", () => $24d89ab52a6a4f35$export$a7d2bc2831e48c39);
$parcel$export(module.exports, "removeWorkflowAssociatedWithSubtaskOnly", () => $24d89ab52a6a4f35$export$404cd34180e60200);

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $eo17r = parcelRequire("eo17r");
parcelRequire("46y1c");
var $2UUg7 = parcelRequire("2UUg7");

var $j0XTg = parcelRequire("j0XTg");
const $24d89ab52a6a4f35$var$GENERIC_SAVING_ERROR = 'There was an error saving the workflows';
const $24d89ab52a6a4f35$var$excludedStatusCodes = new Set([
    401,
    403,
    404,
    409
]);
const $24d89ab52a6a4f35$export$8a106361afb51637 = (error)=>Boolean('statusCode' in error && error.statusCode != null && $24d89ab52a6a4f35$var$excludedStatusCodes.has(error.statusCode) || error.message?.includes($24d89ab52a6a4f35$var$GENERIC_SAVING_ERROR));
const $24d89ab52a6a4f35$export$df77096ef246183b = ({ messageTitle: messageTitle, action: action, error: error, projectKey: projectKey, issueTypeIdNotSubtask: issueTypeIdNotSubtask, statusCode: statusCode })=>{
    const workflowEditorHref = issueTypeIdNotSubtask != null && issueTypeIdNotSubtask !== '' ? `/jira/core/projects/${projectKey}/settings/issuetypes/${issueTypeIdNotSubtask}/workflow` : `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const openWorkflowEditorAction = {
        content: (0, $j0XTg.default).openWorkflowEditorAction,
        href: workflowEditorHref,
        target: '_blank'
    };
    if (error instanceof (0, $2UUg7.StatusNameIsNotUniqueError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $j0XTg.default).statusNameIsNotUniqueDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-name-is-not-unique.flag`)
    };
    if (error instanceof (0, $2UUg7.StatusHasNoIncomingTransitionError)) return {
        type: 'error',
        title: (0, $j0XTg.default).statusHasNoIncomingTransitionTitle,
        description: (0, $j0XTg.default).statusHasNoIncomingTransitionDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-status-has-no-incoming-transition.flag`)
    };
    if (error instanceof (0, $2UUg7.WorkflowVersionConflictError) || statusCode === 409) return {
        type: 'error',
        title: messageTitle,
        description: (0, $j0XTg.default).workflowVersionConflictDescription,
        actions: [
            {
                content: (0, $j0XTg.default).viewWorkflowEditorAction,
                href: workflowEditorHref,
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-workflow-version-conflict.flag`)
    };
    if (action === 'delete-polling') return {
        type: 'warning',
        title: messageTitle,
        description: (0, $j0XTg.default).deletePollingTimeoutDescription,
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-timeout.flag`)
    };
    return {
        type: 'error',
        title: messageTitle,
        description: (0, $j0XTg.default).errorFlagDescription,
        actions: [
            {
                content: (0, $j0XTg.default).errorFlagActionsRetry,
                onClick: ()=>{
                    window.location.reload();
                },
                target: '_blank'
            },
            {
                content: (0, $j0XTg.default).errorFlagActionsCheckStatus,
                href: 'https://jira-work-management.status.atlassian.com/',
                target: '_blank'
            }
        ],
        id: (0, $eo17r.toFlagId)(`jwm-${action}-column.flag`)
    };
};
const $24d89ab52a6a4f35$export$a7d2bc2831e48c39 = ({ markExperienceSuccess: markExperienceSuccess, markExperienceFailed: markExperienceFailed, error: error, errorMessage: errorMessage })=>{
    if (error instanceof (0, $2UUg7.StatusNameIsNotUniqueError) || error instanceof (0, $2UUg7.StatusHasNoIncomingTransitionError) || error instanceof (0, $2UUg7.WorkflowVersionConflictError) || (0, $JRB5w.isClientFetchError)(error) || (0, $7byHA.isValidationError)(error) || $24d89ab52a6a4f35$export$8a106361afb51637(error)) {
        markExperienceSuccess();
        return;
    }
    markExperienceFailed(errorMessage, error);
};
const $24d89ab52a6a4f35$export$404cd34180e60200 = (workflowV2Response, subtaskIssueTypeId)=>{
    if (subtaskIssueTypeId == null) return workflowV2Response;
    const filteredWorkflows = workflowV2Response.workflows.filter((wf)=>// if association issueTypes contain only 1 issue type that is subtask, we want to exclude it from result
        !wf.associatedWith.every((association)=>association.issueTypes.length === 1 && association.issueTypes[0] === subtaskIssueTypeId));
    // if no workflow specific for subtask, return original response
    if (filteredWorkflows.length === workflowV2Response.workflows.length) return workflowV2Response;
    return {
        ...workflowV2Response,
        workflows: filteredWorkflows
    };
};

});

parcelRegister("iPk7h", function(module, exports) {

$parcel$export(module.exports, "useDetectMultipleWorkflows", () => $5552b395f4ae3839$export$42e20d20d2f85d13);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $46y1c = parcelRequire("46y1c");

var $fQmQL = parcelRequire("fQmQL");
const $5552b395f4ae3839$var$getWorkflowsCount = async (param)=>{
    const { subtaskIssueTypeId: subtaskIssueTypeId, fetchWorkflowsV2: fetchWorkflowsV2, ...otherParam } = param;
    const result = await fetchWorkflowsV2(otherParam);
    const filteredResult = (0, $fQmQL.removeWorkflowAssociatedWithSubtaskOnly)(result, subtaskIssueTypeId);
    return filteredResult.workflows.length;
};
const $5552b395f4ae3839$export$e2e5e90dcc14f01b = (0, $5iWql.default)($5552b395f4ae3839$var$getWorkflowsCount, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = // custom equality to check if parameters can be considered the same
    (newParam, prevParam)=>newParam.cloudId === prevParam.cloudId && newParam.projectAndIssueTypes.every((item, index)=>item.projectId === prevParam.projectAndIssueTypes[index].projectId) && newParam.subtaskIssueTypeId === prevParam.subtaskIssueTypeId;
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $5552b395f4ae3839$export$42e20d20d2f85d13 = ({ shouldFetchOnMount: shouldFetchOnMount })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const { fetchWorkflowsV2: fetchWorkflowsV2 } = (0, $46y1c.useWorkflowsV2)();
    const { data: { issueTypes: issueTypes }, loading: loading } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const hasExceededMaxIssueTypes = issueTypes.length > (0, $ib4WI.MAX_ISSUE_TYPES_COUNT);
    const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.subtask)?.id;
    const [state, setState] = (0, $eUqFw.useState)({
        data: undefined,
        loading: shouldFetchOnMount,
        error: undefined
    });
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                // using memoized to prevent unnecessary network requests
                const totalWorkflows = await $5552b395f4ae3839$export$e2e5e90dcc14f01b({
                    cloudId: cloudId,
                    projectAndIssueTypes: issueTypes.map((it)=>({
                            projectId: projectId,
                            issueTypeId: it.id
                        })),
                    subtaskIssueTypeId: subtaskIssueTypeId,
                    fetchWorkflowsV2: fetchWorkflowsV2
                });
                setState({
                    data: {
                        hasMultipleWorkflows: totalWorkflows > 1,
                        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
                    },
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setState({
                    data: undefined,
                    loading: false,
                    error: e
                });
            }
        };
        if (shouldFetchOnMount && !loading) {
            // Do not call fetch since this will return this error: size must be between 0 and 25
            if (hasExceededMaxIssueTypes) setState({
                data: {
                    hasExceededMaxIssueTypes: hasExceededMaxIssueTypes,
                    hasMultipleWorkflows: false
                },
                loading: false,
                error: undefined
            });
            else fetchData();
        }
    }, [
        cloudId,
        issueTypes,
        shouldFetchOnMount,
        projectId,
        subtaskIssueTypeId,
        loading,
        fetchWorkflowsV2,
        hasExceededMaxIssueTypes
    ]);
    return state;
};

});

parcelRegister("4NnjE", function(module, exports) {

$parcel$export(module.exports, "useDeleteColumn", () => $266d4ffe33d5d29f$export$eab38522fc4042c2);

var $8blac = parcelRequire("8blac");

var $gEmpR = parcelRequire("gEmpR");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $fPXdd = parcelRequire("fPXdd");
var $46y1c = parcelRequire("46y1c");

var $fWSay = parcelRequire("fWSay");

var $k56ZY = parcelRequire("k56ZY");

var $bFk6h = parcelRequire("bFk6h");

var $l6iPu = parcelRequire("l6iPu");

var $j0XTg = parcelRequire("j0XTg");

var $fQmQL = parcelRequire("fQmQL");
const $266d4ffe33d5d29f$var$getWorkflowById = (workflowId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
workflows)=>{
    if (workflowId == null) return workflows[0];
    return workflows.find((workflow)=>workflow.workflowId === workflowId) || workflows[0];
};
const $266d4ffe33d5d29f$export$eab38522fc4042c2 = ()=>{
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $46y1c.useWorkflowsV2)();
    const { columns: columns, workflows: workflows } = (0, $lqN6D.useBoardStoreState)();
    const { deleteColumn: deleteColumn, setColumnsAndWorkflows: setColumnsAndWorkflows, setDeleteColumnInProgress: setDeleteColumnInProgress } = (0, $lqN6D.useBoardStoreActions)();
    const revertOptimisticUpdate = ()=>{
        setColumnsAndWorkflows(columns, workflows);
    };
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.COLUMN_ACTION_DELETE_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.COLUMN_ACTION_DELETE_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.COLUMN_ACTION_DELETE_EXPERIENCE));
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    let refetchBoardData;
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ refetch: refetchBoardData } = (0, $bFk6h.useBoardData)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    refetchBoardData = (0, $l6iPu.useRefetchBoardData)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.subtask)?.id;
    const issueTypeIdNotSubtask = issueTypes.find((issueType)=>!issueType.subtask)?.id;
    const [selectedWorkflow] = (0, $k56ZY.useActiveWorkflow)();
    const deleteBoardColumn = async ({ columnToDelete: columnToDelete, toStatus: toStatus })=>{
        startExperience();
        const toColumnData = {
            loading: true
        };
        deleteColumn(columnToDelete, toStatus, toColumnData);
        const columnToDeleteStatusId = columnToDelete.statusId.toString();
        const toStatusId = toStatus.id.toString();
        let updatedWorkflowsResponse;
        const MAX_POLL_COUNT = 5;
        // fetch workflow data from workflow API
        let workflowsData;
        try {
            workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: issueTypes.map((it)=>({
                        projectId: projectId,
                        issueTypeId: it.id
                    }))
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleDeleteColumn,
                action: 'delete',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey
            }));
            revertOptimisticUpdate();
            if (error && (0, $JRB5w.isClientFetchError)(error) || (0, $fQmQL.isFilteredNetworkError)(error)) markExperienceSuccess();
            else markExperienceFailed('failed to fetch workflow data', error);
            return;
        }
        if (!workflowsData) {
            revertOptimisticUpdate();
            markExperienceFailed('workflow data is empty', new Error('workflow data is empty'));
            return;
        }
        // remove subtask workflow
        const filteredWorkflowsData = (0, $fQmQL.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
        const { statuses: statuses, workflows: boardWorkflows } = filteredWorkflowsData;
        const workflow = boardWorkflows[0];
        const wfstatusToDeleteIndex = workflow.statuses.findIndex((status)=>status.statusReference === columnToDeleteStatusId);
        workflow.statuses.splice(wfstatusToDeleteIndex, 1);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        workflow.transitions = workflow.transitions.reduce((acc, next)=>{
            // delete GLOBAL transitions associated with the column being deleted
            if (next.type === 'GLOBAL' && next.to.statusReference === columnToDeleteStatusId) return acc;
            // update the INITIAL transition
            if (next.type === 'INITIAL' && next.to.statusReference === columnToDeleteStatusId) {
                const intialTransition = {
                    ...next
                };
                intialTransition.to.statusReference = toStatusId;
                acc.push(intialTransition);
                return acc;
            }
            // remove any DIRECTED transitions which reference columnToDeleteStatusId
            if (next.type === 'DIRECTED' && (next.to.statusReference === columnToDeleteStatusId || next.from.some((directedFrom)=>directedFrom.statusReference === columnToDeleteStatusId))) return acc;
            acc.push(next);
            return acc;
        }, []);
        const associatedProjectIndex = workflow.associatedWith.findIndex((association)=>association.project.id === projectId);
        if (associatedProjectIndex !== -1) workflow.statusMappings = workflow.associatedWith[associatedProjectIndex]?.issueTypes?.map((type)=>({
                issueTypeId: type,
                projectId: projectId,
                statusMigrations: [
                    {
                        oldStatusReference: columnToDeleteStatusId,
                        newStatusReference: toStatusId
                    }
                ]
            }));
        if (columnToDelete.isDone) {
            // update new status to DONE
            const statusToConvertToDoneIndex = statuses.findIndex((status)=>status.name === toStatus.name);
            if (statusToConvertToDoneIndex !== -1) statuses[statusToConvertToDoneIndex].statusCategory = 'DONE';
        }
        const updatePayload = {
            statuses: (0, $fPXdd.mapStatusesToStatusUpdateObjects)(statuses),
            workflows: [
                (0, $fPXdd.mapWorkflowToWorkflowUpdateObject)(workflow)
            ]
        };
        // validate the payload and update the worfklow
        try {
            const response = await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: updatePayload,
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
            updatedWorkflowsResponse = response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            revertOptimisticUpdate();
            showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                messageTitle: (0, $j0XTg.default).errorFlagTitleDeleteColumn,
                action: 'delete',
                error: error,
                issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                projectKey: projectKey,
                statusCode: error.statusCode
            }));
            (0, $fQmQL.fireColumnExperienceTracking)({
                markExperienceSuccess: markExperienceSuccess,
                markExperienceFailed: markExperienceFailed,
                error: error,
                errorMessage: 'failed to validate and update workflow'
            });
            return;
        }
        const fetchBoardWorkflowsDeleteStatus = async ()=>{
            try {
                const response = await (0, $fWSay.getBoardDataWithMultipleWorkflows)(projectId, false);
                const workflowsResponse = await response.json();
                const boardDataResponse = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(workflowsResponse.data) && $266d4ffe33d5d29f$var$getWorkflowById(selectedWorkflow, workflowsResponse.data) || null;
                return boardDataResponse?.columns?.every((col)=>col.name !== columnToDelete.name);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchBoardData',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch board data and workflows'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                    messageTitle: (0, $j0XTg.default).errorFlagTitleDeleteColumn,
                    action: 'delete',
                    error: error,
                    issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                    projectKey: projectKey
                }));
                markExperienceFailed('Failed to fetch board data and workflows', error);
                // return true to prevent polling below
                return true;
            }
        };
        let timerId;
        let count = 0;
        //  poll boardData to make sure that workflows are correctly updated
        const pollFetchBoardWorkflows = async ()=>{
            if (count === MAX_POLL_COUNT) {
                showFlag((0, $fQmQL.getColumnActionFailedFlag)({
                    messageTitle: (0, $j0XTg.default).deletePollingTimeoutTitle,
                    action: 'delete-polling',
                    issueTypeIdNotSubtask: issueTypeIdNotSubtask,
                    projectKey: projectKey
                }));
                (0, $guiFP.default)({
                    meta: {
                        id: 'pollFetchBoardWorkflows',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Poll fetchBoardWorkflows timed out after delete operation'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                revertOptimisticUpdate();
                markExperienceFailed('Delete column polling reaches the max poll count', new Error('Delete column polling reaches the max poll count'));
                return;
            }
            const isDeletedColumnHasBeenRemovedInWorkflow = await fetchBoardWorkflowsDeleteStatus();
            timerId && clearTimeout(timerId);
            timerId = undefined;
            if (isDeletedColumnHasBeenRemovedInWorkflow === true) {
                await refetchBoardData();
                setDeleteColumnInProgress(false);
                markExperienceSuccess();
                return;
            }
            const ms = 2 ** count * 1000;
            count += 1;
            timerId = setTimeout(pollFetchBoardWorkflows, ms);
        };
        if (updatedWorkflowsResponse && updatedWorkflowsResponse.migrationId != null) await pollFetchBoardWorkflows();
    };
    return {
        deleteBoardColumn: deleteBoardColumn
    };
};

});
parcelRegister("fWSay", function(module, exports) {

$parcel$export(module.exports, "getBoardDataWithMultipleWorkflows", () => $4e74523da079c547$export$11541527ef473794);

var $2vzCR = parcelRequire("2vzCR");

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");
const $4e74523da079c547$var$X_ALAST_CHANGED_TIME_HEADER = 'x-alast-changed-time';
const $4e74523da079c547$var$emptyHeaders = {};
const $4e74523da079c547$var$defaultHeaders = {
    headers: $4e74523da079c547$var$emptyHeaders
};
const $4e74523da079c547$export$11541527ef473794 = async (projectId, shouldUpdateChangedSinceHeader = true)=>{
    try {
        const url = `/rest/board-api/1/board/${projectId}/workflows?excludeLabels=true`;
        let res;
        if ($4e74523da079c547$var$defaultHeaders.headers === $4e74523da079c547$var$emptyHeaders) // Don't fetch with empty headers. It seems to be triggering 304 from previous request
        res = await fetch(url);
        else res = await fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))((0, $fVqUX.default), $4e74523da079c547$var$defaultHeaders));
        if (shouldUpdateChangedSinceHeader && res.ok && res.headers.get($4e74523da079c547$var$X_ALAST_CHANGED_TIME_HEADER)) $4e74523da079c547$var$defaultHeaders.headers = {
            'x-aif-changed-since': res.headers.get($4e74523da079c547$var$X_ALAST_CHANGED_TIME_HEADER)
        };
        return res;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        throw new (0, $7byHA.default)(e);
    }
};
const $4e74523da079c547$export$89ac604d31cc1e73 = ()=>{
    $4e74523da079c547$var$defaultHeaders.headers = $4e74523da079c547$var$emptyHeaders;
};

});



parcelRegister("jFt8B", function(module, exports) {

$parcel$export(module.exports, "useBoardController", () => $e421f4074b75bee5$export$e886093fa929a2dc);

var $eUqFw = parcelRequire("eUqFw");

var $3555e = parcelRequire("3555e");

var $gEmpR = parcelRequire("gEmpR");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $4mhKq = parcelRequire("4mhKq");

var $hX4eH = parcelRequire("hX4eH");
const $e421f4074b75bee5$export$e886093fa929a2dc = ()=>{
    (0, $hX4eH.useFetchWorkflowsDetails)();
    const [{ issues: issues, error: error }, { removeIssue: removeIssue, setIssueFields: setIssueFields, setIssueTypes: setIssueTypes }] = (0, $lqN6D.useBoardStore)();
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const { data: { issueTypes: issueTypes, fields: fields } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const columns = (0, $4mhKq.useColumns)();
    (0, $eUqFw.useEffect)(()=>{
        if (fields != null && issueTypes != null) {
            setIssueFields(fields.concat((0, $ib4WI.getMissingFields)(hasConfluence)));
            setIssueTypes(issueTypes);
        }
    }, [
        fields,
        hasConfluence,
        issueTypes,
        setIssueFields,
        setIssueTypes
    ]);
    return {
        columns: columns,
        issues: issues,
        error: error,
        onRemoveIssue: removeIssue
    };
};

});
parcelRegister("4mhKq", function(module, exports) {

$parcel$export(module.exports, "useColumns", () => $235b58b731621568$export$c97dded465ef56fb);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $dnPUB = parcelRequire("dnPUB");

var $lqN6D = parcelRequire("lqN6D");

var $a0PqO = parcelRequire("a0PqO");

var $fmbIi = parcelRequire("fmbIi");

var $4EaFt = parcelRequire("4EaFt");

var $iXHUp = parcelRequire("iXHUp");
const $235b58b731621568$export$35c527ed4ddcbfd2 = 'Unprioritised';
const $235b58b731621568$export$4cdf66d8e8abc91a = 'Unassigned';
const $235b58b731621568$export$4ec5d4ad1397a493 = 'Uncategorised';
const $235b58b731621568$var$getDoneStatusIds = (columns)=>columns.filter((column)=>column.statusCategory === 'done').map((column)=>column.statusId);
const $235b58b731621568$var$issueToBoardIssue = ({ issue: issue, issueTypes: issueTypes, issuesWithFields: issuesWithFields, people: people, statuses: statuses, doneStatusIds: doneStatusIds, columnId: columnId })=>{
    const issueType = issue.issueTypeId != null && issueTypes != null ? issueTypes[issue.issueTypeId] : undefined;
    const typeName = issueType?.name;
    const statusDetails = statuses && statuses[issue.statusId] ? {
        ...statuses[issue.statusId]
    } : {};
    return {
        ...issue,
        issueDetails: issuesWithFields?.[issue.id],
        columnId: columnId,
        priority: issue.priorityIconUrl != null && issue.priorityName != null ? {
            name: issue.priorityName,
            iconUrl: issue.priorityIconUrl
        } : null,
        numTotalChildren: issue.subtaskMetadata?.total,
        numCompleteChildren: issue.subtaskMetadata?.done,
        assignee: issue.assigneeKey != null && people ? {
            ...people[issue.assigneeKey],
            id: issue.assigneeKey
        } : null,
        isDone: doneStatusIds.includes(issue.statusId),
        typeName: typeName,
        typeUrl: issueType?.avatarUrl ?? '',
        subtasks: issue.subtasks,
        parentId: null,
        ...statusDetails
    };
};
const $235b58b731621568$var$getColumnsByStatus = ({ columns: columns, issues: issues, issuesWithFields: issuesWithFields, people: people, issueTypes: issueTypes, filter: filter, collapsedColumnKeys: collapsedColumnKeys })=>{
    const doneStatusIds = $235b58b731621568$var$getDoneStatusIds(columns);
    return columns.map((column)=>{
        const columnIssues = issues.filter((issue)=>issue.statusId === column.statusId).map((issue)=>$235b58b731621568$var$issueToBoardIssue({
                issue: issue,
                issueTypes: issueTypes,
                issuesWithFields: issuesWithFields,
                people: people,
                doneStatusIds: doneStatusIds,
                columnId: column.statusId
            }));
        return {
            ...column,
            id: column.statusId,
            groupKey: String(column.statusId),
            isDone: column.statusCategory === 'done',
            isInitial: false,
            issues: filter(columnIssues),
            clearedOutCardsUrl: null,
            totalCardsCount: columnIssues.length,
            isCollapsed: collapsedColumnKeys != null && collapsedColumnKeys.includes(String(column.statusId)),
            groupBy: (0, $jGcn0.GROUP_BY_STATUS),
            color: null
        };
    });
};
const $235b58b731621568$var$createGroupColumns = ({ groupConfig: groupConfig, columns: columns, issuesWithFields: issuesWithFields, people: people, issueTypes: issueTypes, filter: filter, collapsedColumnKeys: collapsedColumnKeys })=>{
    const doneStatusIds = $235b58b731621568$var$getDoneStatusIds(columns);
    const groupColumns = new Map();
    const statuses = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(columns.map((column)=>({
            statusId: column.statusId,
            statusName: column.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $8Qd0L.StatusCategoryIds)[column.statusCategory])
        })), (status)=>status.statusId);
    return {
        getColumns: ()=>[
                ...groupColumns.values()
            ].map((column)=>({
                    ...column,
                    issues: filter(column.issues),
                    totalCardsCount: column.issues.length
                })),
        addIssue: (issue)=>{
            const maybeKey = typeof groupConfig.key === 'function' ? groupConfig.key(issue) : issue[groupConfig.key];
            const groupKey = maybeKey != null && maybeKey !== '' ? String(maybeKey) : (0, $ib4WI.NULL_GROUP_KEY);
            let column = groupColumns.get(groupKey);
            if (!column) {
                column = groupConfig.createColumn(groupKey, issue);
                groupColumns.set(groupKey, column);
                column.isCollapsed = collapsedColumnKeys != null && collapsedColumnKeys.includes(groupKey);
            }
            column.issues.push($235b58b731621568$var$issueToBoardIssue({
                issue: issue,
                issueTypes: issueTypes,
                issuesWithFields: issuesWithFields,
                people: people,
                statuses: statuses,
                doneStatusIds: doneStatusIds,
                columnId: groupKey
            }));
        }
    };
};
const $235b58b731621568$var$getColumnsByPriority = ({ columns: columns, issues: issues, issuesWithFields: issuesWithFields, people: people, issueTypes: issueTypes, filter: filter, collapsedColumnKeys: collapsedColumnKeys })=>{
    const groupColumns = $235b58b731621568$var$createGroupColumns({
        groupConfig: {
            key: 'priorityId',
            createColumn (key, issue) {
                return {
                    clearedOutCardsUrl: null,
                    isDone: false,
                    isInitial: false,
                    statusCategory: '',
                    statusId: 0,
                    id: key,
                    name: issue.priorityName ?? $235b58b731621568$export$35c527ed4ddcbfd2,
                    canCreateIssues: true,
                    hasFilteredIssues: false,
                    groupBy: (0, $jGcn0.GROUP_BY_PRIORITY),
                    groupKey: key,
                    imageUrl: issue.priorityIconUrl ?? null,
                    issues: [],
                    totalCardsCount: 0,
                    color: null
                };
            }
        },
        columns: columns,
        issuesWithFields: issuesWithFields,
        people: people,
        issueTypes: issueTypes,
        filter: filter,
        collapsedColumnKeys: collapsedColumnKeys
    });
    issues.forEach((issue)=>groupColumns.addIssue(issue));
    return groupColumns.getColumns();
};
const $235b58b731621568$var$getColumnsByAssignee = ({ columns: columns, issues: issues, issuesWithFields: issuesWithFields, people: people, issueTypes: issueTypes, filter: filter, collapsedColumnKeys: collapsedColumnKeys })=>{
    const groupColumns = $235b58b731621568$var$createGroupColumns({
        groupConfig: {
            key: 'assigneeKey',
            createColumn (key) {
                const assignee = people[key];
                return {
                    clearedOutCardsUrl: null,
                    isDone: false,
                    isInitial: false,
                    statusCategory: '',
                    statusId: 0,
                    id: key,
                    name: assignee?.displayName ?? $235b58b731621568$export$4cdf66d8e8abc91a,
                    canCreateIssues: true,
                    hasFilteredIssues: false,
                    groupBy: (0, $jGcn0.GROUP_BY_ASSIGNEE),
                    groupKey: key,
                    imageUrl: assignee?.avatarUrl ?? null,
                    issues: [],
                    totalCardsCount: 0,
                    color: null
                };
            }
        },
        columns: columns,
        issuesWithFields: issuesWithFields,
        people: people,
        issueTypes: issueTypes,
        filter: filter,
        collapsedColumnKeys: collapsedColumnKeys
    });
    issues.forEach((issue)=>groupColumns.addIssue(issue));
    return groupColumns.getColumns();
};
const $235b58b731621568$var$getColumnsByCategory = ({ columns: columns, issues: issues, issuesWithFields: issuesWithFields, issueFields: issueFields, people: people, issueTypes: issueTypes, filter: filter, collapsedColumnKeys: collapsedColumnKeys })=>{
    const categoryFieldFromAvailableFields = issueFields != null ? Object.values(issueFields).find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) : undefined;
    const categoryFieldId = categoryFieldFromAvailableFields?.id;
    const categoryFieldName = categoryFieldFromAvailableFields?.name;
    const getIssueCategory = (issue)=>issuesWithFields?.[issue.id]?.fieldsByAlias?.category?.value;
    const getIssueCategoryColor = (issue)=>issuesWithFields?.[issue.id]?.fieldsByAlias?.category?.color;
    const getIssueCategoryId = (issue)=>issuesWithFields?.[issue.id]?.fieldsByAlias?.category?.id;
    const groupColumns = $235b58b731621568$var$createGroupColumns({
        groupConfig: {
            key: getIssueCategoryId,
            createColumn (key, issue) {
                const issueCategory = getIssueCategory(issue);
                const getGroupKey = (columnIssue)=>getIssueCategoryId(columnIssue) ?? (0, $ib4WI.NULL_GROUP_KEY);
                return {
                    canCreateIssues: true,
                    clearedOutCardsUrl: null,
                    hasFilteredIssues: false,
                    id: key,
                    isDone: false,
                    isInitial: false,
                    issues: [],
                    name: issueCategory ?? $235b58b731621568$export$4ec5d4ad1397a493,
                    color: getIssueCategoryColor(issue) ?? null,
                    groupFieldKey: categoryFieldId,
                    groupKey: getGroupKey(issue),
                    groupName: categoryFieldName,
                    groupBy: (0, $jGcn0.GROUP_BY_CATEGORY),
                    statusCategory: '',
                    statusId: 0,
                    totalCardsCount: 0
                };
            }
        },
        columns: columns,
        issuesWithFields: issuesWithFields,
        people: people,
        issueTypes: issueTypes,
        filter: filter,
        collapsedColumnKeys: collapsedColumnKeys
    });
    issues.forEach((issue)=>groupColumns.addIssue(issue));
    return groupColumns.getColumns();
};
const $235b58b731621568$export$bb8ec8cb1fd87e3e = {
    [(0, $jGcn0.GROUP_BY_STATUS)]: $235b58b731621568$var$getColumnsByStatus,
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: $235b58b731621568$var$getColumnsByPriority,
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: $235b58b731621568$var$getColumnsByAssignee,
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: $235b58b731621568$var$getColumnsByCategory
};
const $235b58b731621568$export$c97dded465ef56fb = ()=>{
    const { filter: filter } = (0, $dnPUB.useBoardFilters)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const [collapsedColumnKeys] = (0, $fmbIi.useCollapsedColumns)();
    const getColumnsOrder = (0, $4EaFt.useGetColumnsOrder)();
    const [{ issueFields: issueFields, columns: columns, issueTypes: issueTypes, issues: issues, issuesWithFields: issuesWithFields, people: people }] = (0, $lqN6D.useBoardStore)();
    return (0, $eUqFw.useMemo)(()=>{
        const possibleGroupType = groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && (0, $a0PqO.isGroupByFieldAllowedByKey)((0, $lO4Or.PRIORITY_TYPE), issueFields, issueTypes) && (0, $jGcn0.GROUP_BY_PRIORITY) || groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && (0, $a0PqO.isGroupByFieldAllowedByKey)((0, $lO4Or.ASSIGNEE_TYPE), issueFields, issueTypes) && (0, $jGcn0.GROUP_BY_ASSIGNEE) || groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && (0, $a0PqO.isGroupByFieldAllowedByType)((0, $lO4Or.CATEGORY_TYPE), issueFields, issueTypes) && (0, $jGcn0.GROUP_BY_CATEGORY) || (0, $jGcn0.GROUP_BY_STATUS);
        if (possibleGroupType === (0, $jGcn0.GROUP_BY_STATUS)) return $235b58b731621568$var$getColumnsByStatus({
            columns: columns,
            issues: issues,
            issuesWithFields: issuesWithFields,
            issueFields: issueFields,
            people: people,
            issueTypes: issueTypes,
            filter: filter,
            collapsedColumnKeys: collapsedColumnKeys
        });
        return getColumnsOrder($235b58b731621568$export$bb8ec8cb1fd87e3e[possibleGroupType]({
            columns: columns,
            issues: issues,
            issuesWithFields: issuesWithFields,
            issueFields: issueFields,
            people: people,
            issueTypes: issueTypes,
            filter: filter,
            collapsedColumnKeys: collapsedColumnKeys
        }), issueFields);
    }, [
        collapsedColumnKeys,
        columns,
        filter,
        getColumnsOrder,
        groupBy,
        issueFields,
        issueTypes,
        issues,
        issuesWithFields,
        people
    ]);
};

});
parcelRegister("dnPUB", function(module, exports) {

$parcel$export(module.exports, "useBoardFilters", () => $bd438080c6cb7973$export$91982e2d59097163);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $3aUuh = parcelRequire("3aUuh");

var $fvzkg = parcelRequire("fvzkg");
var $lEWmB = parcelRequire("lEWmB");
var $9GlEj = parcelRequire("9GlEj");
var $96etS = parcelRequire("96etS");

var $d3C6e = parcelRequire("d3C6e");

var $gd0Sp = parcelRequire("gd0Sp");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $6SAIj = parcelRequire("6SAIj");
const $bd438080c6cb7973$var$EMPTY_ISSUE_ARRAY = [];
// All filter***2 methods are for filtering by transformed extended fields.
// All will be renamed to filter*** once board field transformation is rolled out, old methods will be removed
const $bd438080c6cb7973$var$filterByExtendedField = (extendedField, filter)=>{
    switch(extendedField.type){
        case 0, $ib4WI.BOARD_FIELD_COMPONENTS:
            return (0, $6SAIj.filterByProjectComponents)(filter, extendedField);
        case 0, $ib4WI.BOARD_FIELD_CATEGORY:
            return (0, $6SAIj.filterByCategory)(filter, extendedField);
        case 0, $ib4WI.BOARD_FIELD_LABEL:
            return (0, $6SAIj.filterByLabels)(filter, extendedField);
        case 0, $ib4WI.BOARD_FIELD_USER:
            return (0, $6SAIj.filterByUser)(filter, extendedField);
        case 0, $ib4WI.BOARD_FIELD_SELECT:
            return (0, $6SAIj.filterBySelect)(filter, extendedField);
        default:
            return false;
    }
};
const $bd438080c6cb7973$var$filterByExtendedFields = (filters, issue, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
categoryFieldId, expandedFilters)=>{
    if (issue.issueDetails == null) return true;
    const issueFieldMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issue.issueDetails.fields, 'fieldId');
    return expandedFilters.every((filter)=>{
        const issueField = issueFieldMap[filter.fieldKey];
        if (issueField == null) return filter.hasEmptyFilter;
        return $bd438080c6cb7973$var$filterByExtendedField(issueField, filter);
    });
};
const $bd438080c6cb7973$var$filterIssues = (filters, issues, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
categoryFieldId, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
issueDetailFields)=>{
    if (issues.length === 0) return $bd438080c6cb7973$var$EMPTY_ISSUE_ARRAY;
    if (filters === null || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters)) return issues;
    // reads filter = {assignee: [{ value: 'aman_account_id' }, { value: 'gorkem_account_id' }]} and converts to
    // [{issueFilterKey: 'assigneeKey', issueFilterValues: ['aman_account_id', 'gorkem_account_id']}]
    const filterValuesMap = Object.entries(filters).reduce((acc, [filterKey, filterValues])=>{
        // @ts-expect-error - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type
        if ((0, $6SAIj.FILTER_MAP)[filterKey] && Array.isArray(filterValues) && filterValues.length > 0) acc.push({
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly assignee: { readonly issueKey: "assigneeKey"; readonly filterValueKey: "value"; }; readonly priority: { readonly issueKey: "priorityName"; readonly filterValueKey: "value"; }; readonly labels: { ...; }; readonly issuetype: { ...; }; }'.
            issueFilterKey: (0, $6SAIj.FILTER_MAP)[filterKey].issueKey,
            issueFilterValues: new Set(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly assignee: { readonly issueKey: "assigneeKey"; readonly filterValueKey: "value"; }; readonly priority: { readonly issueKey: "priorityName"; readonly filterValueKey: "value"; }; readonly labels: { ...; }; readonly issuetype: { ...; }; }'.
            filterValues.map((val)=>val[(0, $6SAIj.FILTER_MAP)[filterKey].filterValueKey]))
        });
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
    const expandedFilters = (0, $6SAIj.getExpandedFilters)(filters, categoryFieldId, issueDetailFields);
    return issues.filter((issue)=>(0, $d3C6e.isOptimisticIssue)(issue.id) || !filterValuesMap.some(({ issueFilterKey: issueFilterKey, issueFilterValues: issueFilterValues })=>{
            const issueField = Array.isArray(issueFilterKey) ? issueFilterKey.reduce((fieldAccumulator, key)=>fieldAccumulator?.[key], issue) : issue[issueFilterKey];
            if (Array.isArray(issueField)) return !issueField.some((value)=>issueFilterValues.has(value));
            return issueFilterValues.has((0, $ib4WI.EMPTY_FILTER_VALUE)) ? issueField && !issueFilterValues.has(issueField) : !issueFilterValues.has(issueField);
        })).filter((issue)=>(0, $d3C6e.isOptimisticIssue)(issue.id) || $bd438080c6cb7973$var$filterByExtendedFields(filters, issue, categoryFieldId, expandedFilters));
};
const $bd438080c6cb7973$var$quickFilterIssues = (quickFilters, issues, atlassianAccountId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(quickFilters).reduce((filteredIssues, [filterKey, filterValue])=>{
        if (filterValue === true) return filterKey === 'ASSIGNED_TO_ME' ? (0, $6SAIj.QUICK_FILTER_MAP)[filterKey](filteredIssues, atlassianAccountId) : (0, $6SAIj.QUICK_FILTER_MAP)[filterKey](filteredIssues);
        return filteredIssues;
    }, issues);
const $bd438080c6cb7973$var$EMPTY_FIELD_IDS = [];
const $bd438080c6cb7973$export$91982e2d59097163 = ()=>{
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const { filters: filters, isLoading: isLoading } = (0, $fvzkg.useDeserialisedFilters)();
    const { jql: filtersJql } = (0, $lEWmB.useFilters)();
    const { quickFiltersJql: quickFiltersJql, quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const [{ categoryFieldId: categoryFieldId, issueDetailFields: issueDetailFields }] = (0, $lqN6D.useBoardStore)();
    const filter = (0, $eUqFw.useCallback)((issues)=>{
        // we always want to filter issues with search text
        const issuesFilteredBySearch = (0, $6SAIj.filterIssuesByText)(issues, simpleSearch);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters)) return $bd438080c6cb7973$var$filterIssues(filters, issuesFilteredBySearch, categoryFieldId, issueDetailFields);
        if (quickFiltersJql !== null && quickFilters) return $bd438080c6cb7973$var$quickFilterIssues(quickFilters, issuesFilteredBySearch, atlassianAccountId);
        return issuesFilteredBySearch;
    }, [
        simpleSearch,
        filters,
        categoryFieldId,
        issueDetailFields,
        quickFiltersJql,
        quickFilters,
        atlassianAccountId
    ]);
    const isFiltering = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters) || quickFiltersJql !== null && quickFiltersJql !== undefined || simpleSearch !== undefined && simpleSearch !== '', [
        filters,
        quickFiltersJql,
        simpleSearch
    ]);
    const combinedFilters = (0, $eUqFw.useMemo)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters)) return filters;
        if (quickFiltersJql !== null && quickFiltersJql !== undefined) return quickFilters;
        return null;
    }, [
        filters,
        quickFilters,
        quickFiltersJql
    ]);
    const filteredFieldIds = (0, $eUqFw.useMemo)(()=>filters != null ? Object.keys(filters).map((fieldKeyFromFilter)=>(0, $6SAIj.filterKeyToIssueFieldKey)(fieldKeyFromFilter, categoryFieldId)) : $bd438080c6cb7973$var$EMPTY_FIELD_IDS, [
        categoryFieldId,
        filters
    ]);
    const isDeserializingFilters = Boolean(!isFiltering && filtersJql);
    return (0, $eUqFw.useMemo)(()=>({
            isFiltering: isFiltering,
            filter: filter,
            combinedFilters: combinedFilters,
            filteredFieldIds: filteredFieldIds,
            isLoading: isLoading || isDeserializingFilters
        }), [
        isFiltering,
        filter,
        combinedFilters,
        filteredFieldIds,
        isLoading,
        isDeserializingFilters
    ]);
};

});
parcelRegister("6SAIj", function(module, exports) {

$parcel$export(module.exports, "FILTER_MAP", () => $7576b001e0974b28$export$b080c57ba7e317eb);
$parcel$export(module.exports, "QUICK_FILTER_MAP", () => $7576b001e0974b28$export$902ef0f0213f4b20);
$parcel$export(module.exports, "filterIssuesByText", () => $7576b001e0974b28$export$c0fbf20bc94589ef);
$parcel$export(module.exports, "filterKeyToIssueFieldKey", () => $7576b001e0974b28$export$84016a5639171c50);
$parcel$export(module.exports, "getExpandedFilters", () => $7576b001e0974b28$export$eb6a39f031848a63);
$parcel$export(module.exports, "filterByProjectComponents", () => $7576b001e0974b28$export$228a944b3f922632);
$parcel$export(module.exports, "filterByCategory", () => $7576b001e0974b28$export$6d1731a321e8bdf4);
$parcel$export(module.exports, "filterByLabels", () => $7576b001e0974b28$export$d226d89b96788bab);
$parcel$export(module.exports, "filterByUser", () => $7576b001e0974b28$export$20a671e3b06cc1b5);
$parcel$export(module.exports, "filterBySelect", () => $7576b001e0974b28$export$d8a8627f7157d954);

var $ellIm = parcelRequire("ellIm");

var $d3C6e = parcelRequire("d3C6e");

var $ib4WI = parcelRequire("ib4WI");
const $7576b001e0974b28$export$e87389f48a5305be = (issues, atlassianAccountId)=>issues.filter(({ id: id, assignee: assignee })=>(0, $d3C6e.isOptimisticIssue)(id) || assignee?.id === atlassianAccountId);
const $7576b001e0974b28$export$ff3ea4cb53c4a28 = (issues)=>issues.filter((issue)=>{
        if ((0, $d3C6e.isOptimisticIssue)(issue.id)) return true;
        if (!issue.dueDate) return false;
        const dueDate = new Date(issue.dueDate);
        const today = new Date();
        return (0, $ellIm.default)(dueDate, today);
    });
const $7576b001e0974b28$export$7caf56b642c4b5aa = (issues)=>issues;
const $7576b001e0974b28$export$b080c57ba7e317eb = {
    assignee: {
        issueKey: [
            'assignee',
            'id'
        ],
        filterValueKey: 'value'
    },
    priority: {
        issueKey: [
            'priority',
            'name'
        ],
        filterValueKey: 'label'
    },
    issuetype: {
        issueKey: 'issueTypeId',
        filterValueKey: 'id'
    },
    type: {
        issueKey: 'issueTypeId',
        filterValueKey: 'id'
    },
    status: {
        issueKey: 'untranslatedStatusName',
        filterValueKey: 'value'
    }
};
const $7576b001e0974b28$export$902ef0f0213f4b20 = {
    ASSIGNED_TO_ME: $7576b001e0974b28$export$e87389f48a5305be,
    DONE: $7576b001e0974b28$export$7caf56b642c4b5aa,
    DUE_THIS_WEEK: $7576b001e0974b28$export$ff3ea4cb53c4a28
};
const $7576b001e0974b28$export$c0fbf20bc94589ef = (issues, searchText)=>{
    if (searchText !== undefined && searchText.trim() !== '') {
        const trimmedSearchTextInLowerCase = searchText.trim().toLowerCase();
        return issues.filter(({ id: id, summary: summary, assignee: assignee, key: key })=>(0, $d3C6e.isOptimisticIssue)(id) || summary.toLowerCase().includes(trimmedSearchTextInLowerCase) || assignee?.displayName?.toLowerCase().includes(trimmedSearchTextInLowerCase) || key.toLowerCase().includes(trimmedSearchTextInLowerCase));
    }
    return issues;
};
const $7576b001e0974b28$export$3f163df70237260e = 'component';
const $7576b001e0974b28$export$68af67b7b7f8e9eb = 'Category[Category]';
const $7576b001e0974b28$export$84016a5639171c50 = (filterKey, categoryFieldId)=>{
    if (filterKey === $7576b001e0974b28$export$3f163df70237260e) return 'components';
    if (categoryFieldId != null && filterKey === $7576b001e0974b28$export$68af67b7b7f8e9eb) return categoryFieldId;
    return filterKey;
};
const $7576b001e0974b28$export$99855e8db1bc4b8d = (filterValueForExtendedField)=>new Set(filterValueForExtendedField.map((filterValue)=>filterValue.value));
const $7576b001e0974b28$var$isSelectOption = (filterValue)=>Array.isArray(filterValue) && filterValue.length > 0 && 'value' in filterValue[0];
const $7576b001e0974b28$export$eb6a39f031848a63 = (filters, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
categoryFieldId, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
issueDetailFields)=>Object.entries(filters).filter(([filterKey])=>!(0, $ib4WI.BASE_FIELDS).includes(filterKey)).filter(([filterKey])=>issueDetailFields != null && issueDetailFields.includes($7576b001e0974b28$export$84016a5639171c50(filterKey, categoryFieldId))).map(([filterKey, filterValue])=>{
        const filterValues = $7576b001e0974b28$var$isSelectOption(filterValue) ? $7576b001e0974b28$export$99855e8db1bc4b8d(filterValue) : new Set();
        return {
            filterKey: filterKey,
            fieldKey: $7576b001e0974b28$export$84016a5639171c50(filterKey, categoryFieldId),
            filterValues: filterValues,
            hasEmptyFilter: filterValues.has((0, $ib4WI.EMPTY_FILTER_VALUE))
        };
    });
const $7576b001e0974b28$export$228a944b3f922632 = (filter, extendedField)=>{
    const components = extendedField.value;
    return Array.isArray(components) && (components.some((component)=>filter.filterValues.has(component)) || filter.hasEmptyFilter && !components.length);
};
const $7576b001e0974b28$export$6d1731a321e8bdf4 = (filter, extendedField)=>{
    const category = extendedField.value;
    return filter.filterValues.has(category ?? '') || filter.hasEmptyFilter && !category;
};
const $7576b001e0974b28$export$d226d89b96788bab = (filter, extendedField)=>{
    const labels = extendedField.value;
    return Array.isArray(labels) && (labels.some((label)=>filter.filterValues.has(label)) || filter.hasEmptyFilter && !labels.length);
};
const $7576b001e0974b28$export$20a671e3b06cc1b5 = (filter, extendedField)=>{
    const users = extendedField.users.map((user)=>user.accountId);
    return Array.isArray(users) && (users.some((user)=>filter.filterValues.has(user)) || filter.hasEmptyFilter && !users.length);
};
const $7576b001e0974b28$export$d8a8627f7157d954 = (filter, extendedField)=>{
    const selectedValues = extendedField.value;
    return Array.isArray(selectedValues) && (selectedValues.some((selectedValue)=>filter.filterValues.has(selectedValue)) || filter.hasEmptyFilter && !selectedValues.length);
};

});


parcelRegister("fmbIi", function(module, exports) {

$parcel$export(module.exports, "useCollapsedColumns", () => $fec94bed5a283e79$export$699eac925f9c8357);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $iXHUp = parcelRequire("iXHUp");
const $fec94bed5a283e79$var$emptyColumnKeys = {
    [(0, $jGcn0.GROUP_BY_STATUS)]: [],
    [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: [],
    [(0, $jGcn0.GROUP_BY_PRIORITY)]: [],
    [(0, $jGcn0.GROUP_BY_CATEGORY)]: []
};
const $fec94bed5a283e79$export$699eac925f9c8357 = ()=>{
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const [collapsedColumnsByGroupBy, updateCollapsedColumns] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLLAPSED_COLUMNS_PREFERENCE));
    const collapsedColumns = (0, $eUqFw.useMemo)(()=>{
        if (collapsedColumnsByGroupBy && typeof collapsedColumnsByGroupBy === 'object') {
            const collapsedKeys = collapsedColumnsByGroupBy[groupBy];
            if (Array.isArray(collapsedKeys)) return collapsedKeys;
        }
        return [];
    }, [
        collapsedColumnsByGroupBy,
        groupBy
    ]);
    const setCollapsedColumns = (0, $eUqFw.useCallback)((newColumnKeys, isCollapsed)=>{
        let newCollapsedKeys = [];
        if (isCollapsed) newCollapsedKeys = [
            ...collapsedColumns,
            ...newColumnKeys
        ];
        else // set expand columns
        newCollapsedKeys = collapsedColumns.filter((collapsedColumnKey)=>!newColumnKeys.includes(collapsedColumnKey));
        updateCollapsedColumns({
            ...collapsedColumnsByGroupBy ?? $fec94bed5a283e79$var$emptyColumnKeys,
            [groupBy]: newCollapsedKeys
        });
    }, [
        collapsedColumns,
        groupBy,
        collapsedColumnsByGroupBy,
        updateCollapsedColumns
    ]);
    return [
        collapsedColumns,
        setCollapsedColumns
    ];
};

});

parcelRegister("4EaFt", function(module, exports) {

$parcel$export(module.exports, "useColumnsOrder", () => $5524504536644d9c$export$c2e15c9fb0e90a6b);
$parcel$export(module.exports, "useGetColumnsOrder", () => $5524504536644d9c$export$89ae84f5982541ee);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $iXHUp = parcelRequire("iXHUp");
const $5524504536644d9c$export$c2e15c9fb0e90a6b = ()=>{
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const [orderedColumnsByGroupBy, setColumnsOrderPreference] = (0, $7c3W1.useViewPreference)((0, $ji3xf.COLUMNS_ORDER_PREFERENCE));
    const setColumnsOrder = (0, $eUqFw.useCallback)((newColumnsOrder)=>{
        const newColumnsOrderKeys = newColumnsOrder.map((column)=>column.groupKey ?? '');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setColumnsOrderPreference({
            ...orderedColumnsByGroupBy,
            [groupBy]: newColumnsOrderKeys
        });
    }, [
        groupBy,
        orderedColumnsByGroupBy,
        setColumnsOrderPreference
    ]);
    const orderedColumns = (0, $eUqFw.useMemo)(()=>{
        if (orderedColumnsByGroupBy && typeof orderedColumnsByGroupBy === 'object') {
            const orderedColumnsKeys = orderedColumnsByGroupBy[groupBy];
            if (Array.isArray(orderedColumnsKeys)) return orderedColumnsKeys;
        }
        return null;
    }, [
        orderedColumnsByGroupBy,
        groupBy
    ]);
    return [
        orderedColumns,
        setColumnsOrder
    ];
};
const $5524504536644d9c$export$89ae84f5982541ee = ()=>{
    const [orderedColumnsKeys] = $5524504536644d9c$export$c2e15c9fb0e90a6b();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    return (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    (columns, issueFields)=>{
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        let orderedPriorityIds;
        if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && issueFields) orderedPriorityIds = issueFields[0, $lO4Or.PRIORITY_TYPE]?.fieldConfig?.options?.map((priorityOption)=>priorityOption.priorityId);
        const indexInOrder = (groupKey, order)=>{
            const index = order.indexOf(groupKey);
            return index >= 0 ? index : columns.length;
        };
        if (orderedColumnsKeys == null) return columns.sort((columnA, columnB)=>{
            if (columnA.groupKey === (0, $ib4WI.NULL_GROUP_KEY)) return -1;
            if (columnB.groupKey === (0, $ib4WI.NULL_GROUP_KEY)) return 1;
            // Sort priorities based on their order
            if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && orderedPriorityIds) return indexInOrder(columnA.groupKey ?? '', orderedPriorityIds) - indexInOrder(columnB.groupKey ?? '', orderedPriorityIds);
            // Others fields alphabetically
            return columnA.name.localeCompare(columnB.name);
        });
        return columns.sort((columnA, columnB)=>indexInOrder(columnA.groupKey ?? '', orderedColumnsKeys) - indexInOrder(columnB.groupKey ?? '', orderedColumnsKeys));
    }, [
        groupBy,
        orderedColumnsKeys
    ]);
};

});


parcelRegister("hX4eH", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflowsDetails", () => $fa04690f3d7f15c7$export$ccfcb2330cb00469);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $c7wtc = parcelRequire("c7wtc");

var $lqN6D = parcelRequire("lqN6D");
const $fa04690f3d7f15c7$export$ccfcb2330cb00469 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    const { setWorkflowsDetails: setWorkflowsDetails } = (0, $lqN6D.useBoardStoreActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(workflows)) setWorkflowsDetails(workflows);
    }, [
        workflows,
        setWorkflowsDetails
    ]);
};

});


parcelRegister("kOAHo", function(module, exports) {

$parcel$export(module.exports, "BoardIssueDetailsOld", () => $1b2f653d4b33ebd9$export$59bffa3d6ea68855);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $lNfG4 = parcelRequire("lNfG4");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $d3C6e = parcelRequire("d3C6e");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $fOY0f = parcelRequire("fOY0f");

var $lqN6D = parcelRequire("lqN6D");

var $57XQa = parcelRequire("57XQa");

var $4edMS = parcelRequire("4edMS");

var $bZapc = parcelRequire("bZapc");
const $1b2f653d4b33ebd9$var$TIME_TO_LOAD_EXTENDED_DATA = 'jwm.jwm-board.load-extended-data';
const $1b2f653d4b33ebd9$var$emptyArray = [];
// Memoised method to only get ids of issues, details of which havent been retrieved before.
// Array is sorted to pass equality check in memoise.
const $1b2f653d4b33ebd9$var$getIssuesIdsToFetchDetailsOf = (issues, issuesWithFields, currentFieldIds, storedFieldIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(()=>{
        // Update all issues if current fields ids has a field id that is not in storedFieldIds
        const moreFieldsRequired = storedFieldIds != null && !currentFieldIds.every((fieldId)=>storedFieldIds.includes(fieldId));
        const toReturn = issues.filter((issue)=>!(0, $d3C6e.isOptimisticIssue)(issue.id)).filter((issue)=>moreFieldsRequired || issuesWithFields == null || issuesWithFields[issue.id] == null || issue.needsExtendedFieldsUpdate === true).map((issue)=>issue.id).sort();
        // if the array is empty return the empty array rather then a new reference for the diff check later in useEffect
        if (toReturn.length === 0) return $1b2f653d4b33ebd9$var$emptyArray;
        return toReturn;
    });
const $1b2f653d4b33ebd9$export$59bffa3d6ea68855 = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const [{ issues: issues, issuesWithFields: issuesWithFields, issueDetailFields: issueDetailFields }, { updateIssuesWithFields: updateIssuesWithFields, clearStoredFieldIds: clearStoredFieldIds }] = (0, $lqN6D.useBoardStore)();
    const fieldIds = (0, $4edMS.useFieldIds)(false);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [hasError, setHasError] = (0, $eUqFw.useState)(false);
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const withConfluenceLinks = hasConfluence ? Boolean(selectedFields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE]) : false;
    const withCoverMedia = Boolean(selectedFields[0, $jGcn0.CARD_COVERS_TYPE]);
    const withIssueLinks = (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation') && Boolean(selectedFields[0, $lO4Or.ISSUE_LINKS_TYPE]);
    const { loadIssuesWithFields: loadIssuesWithFields } = (0, $fOY0f.useBoardIssuesOld)({
        withConfluenceLinks: withConfluenceLinks,
        withIssueLinks: withIssueLinks,
        withCoverMedia: withCoverMedia
    });
    const issueIds = $1b2f653d4b33ebd9$var$getIssuesIdsToFetchDetailsOf(issues, issuesWithFields, fieldIds, issueDetailFields)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_EXTENDED_BOARD_DATA_EXPERIENCE));
    const intl = (0, $5JgJ2.default)();
    // Clear stored field ids on unmount to force reload while keeping the issue details in store
    (0, $eUqFw.useEffect)(()=>clearStoredFieldIds, [
        clearStoredFieldIds
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (fieldIds.length > 0 && issueIds.length > 0 && !loading && !hasError) {
            startExperience();
            const timeToLoadMetric = (0, $lNfG4.metrics).custom({
                key: $1b2f653d4b33ebd9$var$TIME_TO_LOAD_EXTENDED_DATA
            });
            timeToLoadMetric.start();
            setLoading(true);
            loadIssuesWithFields({
                fieldIds: fieldIds,
                issueIds: issueIds,
                onLoad: (issuesWithDetails)=>{
                    const transformedIssues = (0, $57XQa.transformFieldsOld)(issuesWithDetails, intl);
                    updateIssuesWithFields(transformedIssues, fieldIds);
                }
            }).then(()=>{
                markExperienceSuccess();
            }).catch((error)=>{
                // Stop all subsequent loads if there's an error
                setHasError(true);
                (0, $guiFP.default)({
                    meta: {
                        id: 'jwmBoardIssueDetails',
                        packageName: 'jiraWorkManagementBoard',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch extended data for issues'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                markExperienceFailed('Loading extended data failed', error);
            }).finally(()=>{
                timeToLoadMetric.stop({
                    customData: {
                        withCoverMedia: withCoverMedia,
                        withConfluenceLinks: hasConfluence && selectedFields[0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE] === true,
                        issueCount: issueIds.length,
                        fieldCount: fieldIds.length,
                        withIssueLinks: withIssueLinks
                    }
                });
                setLoading(false);
            });
        }
    }, [
        projectId,
        fieldIds,
        issueIds,
        loading,
        hasError,
        loadIssuesWithFields,
        updateIssuesWithFields,
        startExperience,
        markExperienceSuccess,
        markExperienceFailed,
        hasConfluence,
        selectedFields,
        intl,
        withCoverMedia,
        withIssueLinks
    ]);
    return null;
};

});
parcelRegister("fOY0f", function(module, exports) {

$parcel$export(module.exports, "useBoardIssuesOld", () => $8212f71ed1bcb713$export$1a55b02d6e1c99fc);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $jGcn0 = parcelRequire("jGcn0");

var $053h2 = parcelRequire("053h2");

var $79xbN = parcelRequire("79xbN");

var $dWLk9 = parcelRequire("dWLk9");

var $iwwE5 = parcelRequire("iwwE5");
const $8212f71ed1bcb713$export$92b17a4db348dc25 = ()=>(0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
const $8212f71ed1bcb713$var$ITEMS_PER_PAGE = 100;
// delete buildVariablesArray when cleaning up jwm.board-awesome-enhancements
// Build variables for queries in a way that responses won't exceed max item count.
// Exm: Given 350 issues, Query 1 (Issues 1-100), Query 2 (Issues 101-200), Query 3 (Issues 201-300), Query 4 (Issues 301-350)
const $8212f71ed1bcb713$var$buildVariablesArray = ({ fieldIds: fieldIds, issueIds: issueIds, withConfluenceLinks: withConfluenceLinks, withCoverMedia: withCoverMedia, cloudId: cloudId, withIssueLinks: withIssueLinks })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let queryIssueIds = [];
    const variablesArray = [];
    const pushIssueIdsToVariables = ()=>{
        variablesArray.push({
            fieldIds: fieldIds,
            first: $8212f71ed1bcb713$var$ITEMS_PER_PAGE,
            jql: `id in (${queryIssueIds.join(',')})`,
            withConfluenceLinks: withConfluenceLinks,
            withCoverMedia: withCoverMedia,
            cloudId: cloudId,
            withIssueLinks: withIssueLinks,
            withChildrenCount: false,
            withExtendedIssue: false
        });
        queryIssueIds = [];
    };
    issueIds.forEach((issueId)=>{
        queryIssueIds.push(issueId);
        if (queryIssueIds.length === $8212f71ed1bcb713$var$ITEMS_PER_PAGE) pushIssueIdsToVariables();
    });
    if (queryIssueIds.length !== 0) pushIssueIdsToVariables();
    return variablesArray;
};
const $8212f71ed1bcb713$export$1a55b02d6e1c99fc = ({ withConfluenceLinks: withConfluenceLinks, withIssueLinks: withIssueLinks, withCoverMedia: withCoverMedia })=>{
    const client = (0, $iZuDo.useApolloClient)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const loadIssuesWithFields = (0, $eUqFw.useCallback)(async ({ issueIds: issueIds, fieldIds: fieldIds, onLoad: onLoad })=>{
        const variablesArray = $8212f71ed1bcb713$var$buildVariablesArray({
            fieldIds: [
                ...fieldIds.filter((fieldId)=>fieldId !== (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE))// TODO After JIS2 migration completion, remove this mapping JET-4810
                .map((fieldId)=>fieldId === 'timeoriginalestimate' ? 'timetracking' : fieldId)
            ],
            issueIds: issueIds,
            withConfluenceLinks: withConfluenceLinks,
            withCoverMedia: withCoverMedia,
            cloudId: cloudId,
            withIssueLinks: withIssueLinks
        });
        await Promise.all(variablesArray.map(async (variables)=>{
            const response = await client.query({
                query: (0, $iwwE5.JIS2_JWMBoardItemsQuery),
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                variables: variables
            });
            if (!response) return;
            if (response.errors) {
                const apolloError = new (0, $jlBDe.ApolloError)({
                    graphQLErrors: response.errors
                });
                if ((0, $053h2.shouldHandleTheError)(apolloError)) throw apolloError;
            }
            const responseData = response.data.jira?.jwmViewItems;
            if (responseData?.__typename === 'JiraWorkManagementViewItemConnection' && responseData.edges != null) onLoad(responseData.edges.map((edge)=>edge?.node).filter((node)=>node != null));
        }));
    }, [
        client,
        cloudId,
        withConfluenceLinks,
        withCoverMedia,
        withIssueLinks
    ]);
    return {
        loadIssuesWithFields: loadIssuesWithFields
    };
};

});

parcelRegister("57XQa", function(module, exports) {

$parcel$export(module.exports, "transformFieldsOld", () => $6d069ad78a3f4f83$export$43ee9f14497267b6);

var $h9cCP = parcelRequire("h9cCP");

var $8Qd0L = parcelRequire("8Qd0L");

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

var $7v0hO = parcelRequire("7v0hO");

var $ib4WI = parcelRequire("ib4WI");
const $6d069ad78a3f4f83$var$emptyFieldsArray = [];
const $6d069ad78a3f4f83$var$transformers = {
    [(0, $lO4Or.TEXT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.TEXT_GQL_FIELD) || field.text == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TEXT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.text
        };
    },
    [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.COMPONENTS_GQL_FIELD)) return null;
        const value = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_COMPONENTS),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.LABEL_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.LABEL_GQL_FIELD) || field.selectedLabelsConnection == null) return null;
        const value = field.selectedLabelsConnection.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_LABEL),
            fieldId: field.fieldId,
            value: value
        };
    },
    [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD) || field.originalEstimate?.timeInSeconds == null) return null;
        // TODO: FE needs estimateString from JIS2 JET-4805
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.originalEstimate.timeInSeconds
        };
    },
    [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: (field, intl)=>{
        if (field.__typename !== (0, $lO4Or.TIME_TRACKING_GQL_FIELD) || field.originalEstimate?.timeInSeconds == null || field.timeTrackingSettings?.workingHoursPerDay == null || field.timeTrackingSettings?.workingDaysPerWeek == null || field.timeTrackingSettings?.defaultUnit == null || intl == null) return null;
        const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: timeFormat, defaultUnit: defaultUnit } = field.timeTrackingSettings;
        return {
            type: (0, $ib4WI.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            // TODO After JIS2 migration completion, replace string constant with fieldId JET-4810
            fieldId: 'timeoriginalestimate',
            name: field.name,
            value: (0, $7v0hO.timeTrackingFormatter)(field.originalEstimate.timeInSeconds, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                timeFormat: timeFormat || (0, $h9cCP.PRETTY),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_PICKER_GQL_FIELD) || field.date == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.date
        };
    },
    [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) || field.fieldOption?.value == null || field.type === (0, $lO4Or.CATEGORY_TYPE)) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: [
                field.fieldOption.value
            ]
        };
    },
    [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.DATE_TIME_GQL_FIELD) || field.dateTime == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_DATE_TIME),
            fieldId: field.fieldId,
            name: field.name,
            value: field.dateTime
        };
    },
    [(0, $lO4Or.NUMBER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.NUMBER_GQL_FIELD) || field.number == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_FLOAT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.number
        };
    },
    [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.USER_PICKER_GQL_FIELD) || field.user == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: [
                {
                    accountId: field.user.accountId,
                    name: field.user.name,
                    avatarURL: field.user.picture
                }
            ]
        };
    },
    [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.MULTI_SELECT_GQL_FIELD)) return null;
        const value = field.selectedOptions?.edges?.map((edge)=>edge?.node).map((node)=>node?.value).filter(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        (optionValue)=>optionValue != null);
        if (value == null || value.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PEOPLE_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $lO4Or.EPIC_LINK_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.EPIC_LINK_GQL_FIELD) || field.epic == null || field.epic.key == null || field.epic.issueId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PARENT),
            fieldId: field.fieldId,
            name: field.name,
            parent: {
                id: field.epic.issueId,
                key: field.epic.key,
                color: field.epic.color,
                text: field.epic.name
            }
        };
    },
    [(0, $lO4Or.STATUS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.STATUS_GQL_FIELD) || field.status.name == null || field.status.statusCategory?.statusCategoryId == null || field.status.statusId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_STATUS),
            fieldId: field.fieldId,
            name: field.name,
            status: {
                category: (0, $8Qd0L.statusCategoryForId)(field.status.statusCategory.statusCategoryId),
                id: Number(field.status.statusId),
                name: field.status.name
            }
        };
    },
    [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || field.issueType?.issueTypeId == null || field.issueType?.name == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_ISSUE_TYPE),
            fieldId: field.fieldId,
            name: field.name,
            id: field.issueType.issueTypeId,
            issueType: {
                id: field.issueType.issueTypeId,
                name: field.issueType.name,
                iconUrl: field.issueType.avatar?.medium ?? ''
            }
        };
    },
    [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $lO4Or.PRIORITY_GQL_FIELD) || field.priority?.iconUrl == null || field.priority?.name == null || field.priority?.priorityId == null) return null;
        return {
            type: (0, $ib4WI.BOARD_FIELD_PRIORITY),
            fieldId: field.fieldId,
            name: field.name,
            priority: {
                iconUrl: field.priority.iconUrl,
                id: field.priority.priorityId,
                name: field.priority.name
            }
        };
    }
};
const $6d069ad78a3f4f83$var$transformField = (field, intl)=>{
    if (field == null) return null;
    if (field.__typename === (0, $lO4Or.SINGLE_SELECT_GQL_FIELD) && field.type === (0, $lO4Or.CATEGORY_TYPE) && field.fieldOption?.value != null) return {
        fieldId: field.fieldId,
        id: field.fieldOption.optionId,
        name: field.name,
        type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
        value: field.fieldOption.value,
        color: field.fieldOption.color?.colorKey ?? null
    };
    if (field.__typename in $6d069ad78a3f4f83$var$transformers) return $6d069ad78a3f4f83$var$transformers[field.__typename](field, intl);
    return null;
};
const $6d069ad78a3f4f83$export$43ee9f14497267b6 = (issueDetails, intl)=>{
    const toReturn = {};
    issueDetails.forEach((issueDetail)=>{
        const issueFields = [];
        let labelField;
        let categoryField;
        let parentField;
        let confluenceLinksCount;
        issueDetail.fieldsByIdOrAlias?.forEach((field)=>{
            const transformedField = $6d069ad78a3f4f83$var$transformField(field, intl);
            if (transformedField != null) issueFields.push(transformedField);
            if (transformedField?.type === (0, $ib4WI.BOARD_FIELD_CATEGORY)) categoryField = transformedField;
            if (transformedField?.type === (0, $ib4WI.BOARD_FIELD_LABEL)) labelField = transformedField;
            if (transformedField?.type === (0, $ib4WI.BOARD_FIELD_PARENT)) parentField = transformedField;
        });
        if (issueDetail.legacyConfluenceLinks?.linkedConfluencePages?.pageCount != null) confluenceLinksCount = {
            type: (0, $ib4WI.BOARD_FIELD_CONFLUENCE_PAGES_COUNT),
            fieldId: 'remoteIssueLinks',
            value: issueDetail.legacyConfluenceLinks.linkedConfluencePages.pageCount
        };
        if (issueFields.length > 0 || confluenceLinksCount != null) toReturn[issueDetail.issueId] = {
            fields: issueFields,
            fieldsByAlias: {
                label: labelField,
                category: categoryField,
                parent: parentField,
                confluenceLinksCount: confluenceLinksCount
            }
        };
        else toReturn[issueDetail.issueId] = {
            fields: $6d069ad78a3f4f83$var$emptyFieldsArray,
            fieldsByAlias: {}
        };
        if (issueDetail.coverMedia !== undefined) toReturn[issueDetail.issueId].coverMedia = issueDetail.coverMedia;
        if ((0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation')) {
            if (issueDetail.issueLinks?.edges) toReturn[issueDetail.issueId].fieldsByAlias.issueLinksCount = {
                type: (0, $ib4WI.BOARD_FIELD_ISSUE_LINKS_COUNT),
                fieldId: (0, $lO4Or.ISSUE_LINKS_TYPE),
                value: issueDetail.issueLinks.edges.filter(Boolean).length ?? 0
            };
        }
    });
    return toReturn;
};

});

parcelRegister("4edMS", function(module, exports) {

$parcel$export(module.exports, "useFieldIds", () => $604934f65771e021$export$a8f1976671d75184);

var $eUqFw = parcelRequire("eUqFw");

var $ib4WI = parcelRequire("ib4WI");

var $dnPUB = parcelRequire("dnPUB");

var $lqN6D = parcelRequire("lqN6D");

var $bZapc = parcelRequire("bZapc");

var $iXHUp = parcelRequire("iXHUp");
const $604934f65771e021$var$emptyArray = [];
const $604934f65771e021$export$a8f1976671d75184 = (includeBaseFields)=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const [{ issueFields: issueFields }] = (0, $lqN6D.useBoardStore)();
    const groupByField = (0, $iXHUp.useGroupByFieldOld)();
    const { filteredFieldIds: filteredFieldIds } = (0, $dnPUB.useBoardFilters)();
    return (0, $eUqFw.useMemo)(()=>Object.keys(issueFields ?? $604934f65771e021$var$emptyArray).filter((fieldId)=>(selectedFields[fieldId] || filteredFieldIds?.includes(fieldId) || groupByField === fieldId) && (includeBaseFields || !(0, $ib4WI.BASE_FIELDS).includes(fieldId))).map((fieldId)=>{
            // Workaround to get epiclinks working for CMP projects again. Should be removed, revisited once
            // https://team.atlassian.com/project/ATLAS-11451 is complete
            if (issueFields && issueFields[fieldId].type === 'com.pyxis.greenhopper.jira:gh-epic-link') return 'epiclink';
            return fieldId;
        }), [
        filteredFieldIds,
        groupByField,
        includeBaseFields,
        issueFields,
        selectedFields
    ]);
};

});


parcelRegister("d4amQ", function(module, exports) {

$parcel$export(module.exports, "useBoardSubtasks", () => $9914e26a0ab05e70$export$c1d9e68f8c9be556);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $iYgaL = parcelRequire("iYgaL");

var $2lD4a = parcelRequire("2lD4a");

var $bZapc = parcelRequire("bZapc");

var $ghHLE = parcelRequire("ghHLE");
const $9914e26a0ab05e70$export$c1d9e68f8c9be556 = ()=>{
    const [{ issues: issues }, { updateIssue: updateIssue }] = (0, $lqN6D.useBoardStore)();
    const [getIssueById] = (0, $lqN6D.useGetIssueById)();
    const { getSubtasks: getSubtasks } = (0, $iYgaL.useGetSubtasks)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const [initialSubtasksLoaded, setInitialSubtasksLoaded] = (0, $eUqFw.useState)(false);
    const [optimisticUpdate, setOptimisticUpdate] = (0, $eUqFw.useState)([]);
    const [errorIssueIds, setErrorIssueIds] = (0, $eUqFw.useState)([]);
    const batchLoadSubtasks = (0, $eUqFw.useCallback)(async (parentIssueIds)=>{
        const { data: oldSubtasks, error: error } = await getSubtasks({
            parentIssueIds: parentIssueIds
        });
        if (oldSubtasks != null) {
            const issuesToUpdate = {};
            oldSubtasks.forEach((subtask)=>{
                if (subtask.parentId != null) {
                    const parentIssueId = subtask.parentId;
                    if (!issuesToUpdate[parentIssueId]) issuesToUpdate[parentIssueId] = [];
                    issuesToUpdate[parentIssueId].push(subtask);
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Object.entries(issuesToUpdate).forEach(([issueId, issueSubtasks])=>{
                updateIssue(+issueId, {
                    subtasks: issueSubtasks
                });
            });
            return true;
        }
        if (error != null) setErrorIssueIds(parentIssueIds);
        return false;
    }, [
        getSubtasks,
        updateIssue
    ]);
    // initial load of expanded subtasks from local storage
    (0, $eUqFw.useEffect)(()=>{
        if (!initialSubtasksLoaded && issues.length > 0 && selectedFields.subtasks) {
            setInitialSubtasksLoaded(true);
            startExperience();
            const expandedIssueIds = (0, $2lD4a.default).getExpandedTasks(projectId);
            const expandedIssueIdsWithSubtasks = expandedIssueIds.filter((issueId)=>getIssueById(issueId)?.subtaskMetadata?.total > 0);
            // optimistic update to show loading skeleton
            expandedIssueIdsWithSubtasks.forEach((issueId)=>{
                updateIssue(+issueId, {
                    subtasks: []
                });
            });
            setOptimisticUpdate([
                ...expandedIssueIdsWithSubtasks
            ]);
            // we batch so that we get < 100 issues in a response and avoid need for pagination
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const subtaskRequests = [];
            const batches = (0, $ghHLE.batchIssuesForSubtasks)(issues, expandedIssueIdsWithSubtasks);
            batches.forEach((parentIssueIds)=>{
                subtaskRequests.push(batchLoadSubtasks(parentIssueIds));
            });
            Promise.all(subtaskRequests).then((values)=>{
                if (values.filter((v)=>v).length === values.length) {
                    // clean up any old issue ids out of local storage eg. for done tasks no longer on the board
                    const cleanedIssueIds = expandedIssueIds.filter((issueId)=>getIssueById(issueId) != null && expandedIssueIdsWithSubtasks.indexOf(issueId) >= 0);
                    (0, $2lD4a.default).setExpandedTasks(projectId, cleanedIssueIds);
                    markExperienceSuccess();
                    const totalSubtaskCount = issues.reduce((total, issue)=>total + (cleanedIssueIds.indexOf(issue.id) !== -1 ? issue.subtaskMetadata?.total ?? 0 : 0), 0);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmBoardSubtasks loaded', {
                        issues: cleanedIssueIds.length,
                        subtasks: totalSubtaskCount
                    });
                } else markExperienceFailed('Error loading initial subtasks', Error('Error loading initial subtasks'));
            });
        }
    }, [
        issues,
        initialSubtasksLoaded,
        getIssueById,
        batchLoadSubtasks,
        createAnalyticsEvent,
        projectId,
        updateIssue,
        selectedFields,
        startExperience,
        markExperienceSuccess,
        markExperienceFailed
    ]);
    // revert optimistic update when request errors
    (0, $eUqFw.useEffect)(()=>{
        if (errorIssueIds.length > 0) {
            const issuesToRevert = optimisticUpdate.filter((issueId)=>errorIssueIds.indexOf(issueId) >= 0);
            issuesToRevert.forEach((key)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                updateIssue(+key, {
                    subtasks: undefined
                });
            });
            setErrorIssueIds([]);
        }
    }, [
        optimisticUpdate,
        errorIssueIds,
        updateIssue
    ]);
};

});
parcelRegister("iYgaL", function(module, exports) {

$parcel$export(module.exports, "useGetSubtasks", () => $40557fa472e7f9f3$export$7231c3c0c3f05bb0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $dMpBh = parcelRequire("dMpBh");

var $79wfp = parcelRequire("79wfp");

var $igpOa = parcelRequire("igpOa");

var $dz8uv = parcelRequire("dz8uv");
const $40557fa472e7f9f3$export$7231c3c0c3f05bb0 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const client = (0, $iZuDo.useApolloClient)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /** @deprecated */ const getSubtasks = (0, $eUqFw.useCallback)(async ({ parentIssueIds: parentIssueIds = [], issueIds: issueIds = [] })=>{
        try {
            let jql = '';
            if (parentIssueIds.length > 0) {
                jql += `parent in ('${parentIssueIds.join("', '")}')`;
                if (issueIds.length > 0) jql = `(${jql} or id in ('${issueIds.join("', '")}'))`;
            } else if (issueIds.length > 0) jql += `id in ('${issueIds.join("', '")}')`;
            else return {
                data: []
            };
            jql += ' and hierarchyLevel = -1';
            const response = await client.query({
                // no-cache is important as we cannot use a cached response when a JRT update comes through
                // and we reload the subtasks, or the data will be stale
                fetchPolicy: 'no-cache',
                variables: {
                    cloudId: cloudId,
                    jql: jql,
                    fieldIds: (0, $dMpBh.SUBTASK_FIELD_IDS),
                    first: 100
                },
                query: (0, $79wfp.JIS2_BOARD_PARENT_ISSUE_QUERY)
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $dMpBh.QUERY_NAME)} succeeded`);
            const transformedDataOld = response?.data?.subtaskIssues?.jwmViewItems?.edges?.map((edge)=>(0, $dz8uv.transformSubtaskOld)(edge?.node)).filter((subtask)=>!!subtask);
            return {
                data: transformedDataOld,
                subtasks: []
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $igpOa.default).getSubtasksErrorTitle,
                description: (0, $igpOa.default).getSubtasksErrorMessage
            });
            (0, $guiFP.default)({
                meta: {
                    id: (0, $dMpBh.QUERY_NAME),
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                error: error
            };
        }
    }, [
        client,
        cloudId,
        createAnalyticsEvent,
        showFlag
    ]);
    return {
        getSubtasks: getSubtasks
    };
};

});
parcelRegister("dMpBh", function(module, exports) {

$parcel$export(module.exports, "SUBTASK_FIELD_IDS", () => $76b8dcccfe86747c$export$b46cc40fdf28878c);
$parcel$export(module.exports, "QUERY_NAME", () => $76b8dcccfe86747c$export$a93d8cd30a94ee3a);
const $76b8dcccfe86747c$export$b46cc40fdf28878c = [
    'issuekey',
    'summary',
    'issuetype',
    'status',
    'priority',
    'assignee',
    'parent'
];
const $76b8dcccfe86747c$export$a93d8cd30a94ee3a = 'getJiraBoardIssueSubtasks';

});

parcelRegister("79wfp", function(module, exports) {

$parcel$export(module.exports, "JIS2_BOARD_PARENT_ISSUE_QUERY", () => $f981cf6b326228a3$export$b879108a551314d4);

var $9ypom = parcelRequire("9ypom");
const $f981cf6b326228a3$export$d73048fa344fc743 = (0, $9ypom.default)`
    fragment JIS2_BoardParentIssueFieldFragment on JiraWorkManagementViewItem {
        issueId
        fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) {
          ... on JiraParentIssueField {
            fieldId
            parentIssue {
              issueId
            }
          }
          ... on JiraSingleLineTextField {
            fieldId
            text
          }
          ... on JiraSingleSelectUserPickerField {
            fieldId
            user {
              ... on AtlassianAccountUser {
                accountId
                name
                picture
              }
            }
          }
          ... on JiraIssueTypeField {
            fieldId
            id
            name
            issueType {
              issueTypeId
              name
              avatarId
              avatar {
                medium
              }
            }
          }
          ... on JiraStatusField {
            fieldId
            status {
              name
              statusId
              statusCategory {
                statusCategoryId
              }
            }
          }
          ... on JiraPriorityField {
            fieldId
            priority {
              name
              iconUrl
            }
          }
        }
    }
`;
const $f981cf6b326228a3$export$b879108a551314d4 = (0, $9ypom.default)`
    query JIS2_JiraBusinessBoardSubtaskItems ($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int) {
      subtaskIssues: jira {
        jwmViewItems(
          cloudId: $cloudId
          jql: $jql
          first: $first
        ) {
          ... on QueryError {
            message
            extensions {
              statusCode
              errorType
            }
          }
          ... on JiraWorkManagementViewItemConnection {
            edges {
                node {
                    ...JIS2_BoardParentIssueFieldFragment
                }
            }
          }
        }
      }
    }
    ${$f981cf6b326228a3$export$d73048fa344fc743}
`;

});

parcelRegister("igpOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f4a96f52385172$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $16f4a96f52385172$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    getSubtasksErrorTitle: {
        "id": "work-management-board.services.get-subtasks-jis.get-subtasks-error-title",
        "defaultMessage": "Failed to load subtasks"
    },
    getSubtasksErrorMessage: {
        "id": "work-management-board.services.get-subtasks-jis.get-subtasks-error-message",
        "defaultMessage": "Something went wrong while loading subtasks. Please try again or contact your administrator if the problem persists."
    }
});

});

parcelRegister("dz8uv", function(module, exports) {

$parcel$export(module.exports, "transformSubtaskOld", () => $717b0482697c1f54$export$c9d1c4466c4c123f);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");
const $717b0482697c1f54$export$c9d1c4466c4c123f = (subtask)=>{
    if (subtask == null) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const toReturn = {
        id: subtask.issueId,
        url: '',
        columnId: 0,
        dueDate: null,
        numCompleteChildren: 0,
        numTotalChildren: 0
    };
    const processTextFields = (field)=>{
        switch(field.fieldId){
            case 0, $lO4Or.ISSUE_KEY_TYPE:
                toReturn.key = field.text || '';
                break;
            case 0, $lO4Or.SUMMARY_TYPE:
                toReturn.summary = field.text || '';
                break;
            default:
                break;
        }
    };
    const processAssignee = (field)=>{
        if (field.user == null) toReturn.assignee = null;
        toReturn.assignee = {
            id: field.user?.accountId || '',
            displayName: field.user?.name || '',
            avatarUrl: field.user?.picture || ''
        };
    };
    subtask.fieldsByIdOrAlias?.forEach((field)=>{
        switch(field?.__typename){
            case 0, $lO4Or.TEXT_GQL_FIELD:
                processTextFields(field);
                break;
            case 0, $lO4Or.ISSUE_TYPE_GQL_FIELD:
                toReturn.issueTypeId = field.issueType?.issueTypeId || '';
                toReturn.typeName = field.issueType?.name || '';
                toReturn.typeUrl = field.issueType?.avatar?.medium || '';
                break;
            case 0, $lO4Or.STATUS_GQL_FIELD:
                {
                    toReturn.statusId = Number(field.status?.statusId || 0);
                    toReturn.statusName = field.status?.name || '';
                    const statusCategoryId = Number(field.status?.statusCategory?.statusCategoryId || 0);
                    toReturn.statusCategory = statusCategoryId;
                    toReturn.isDone = (0, $8Qd0L.statusCategoryForId)(statusCategoryId) === (0, $8Qd0L.DONE);
                }
                break;
            case 0, $lO4Or.PRIORITY_GQL_FIELD:
                toReturn.priority = {
                    name: field.priority?.name || '',
                    iconUrl: field.priority?.iconUrl || ''
                };
                break;
            case 0, $lO4Or.USER_PICKER_GQL_FIELD:
                processAssignee(field);
                break;
            case 0, $lO4Or.PARENT_GQL_FIELD:
                toReturn.parentId = field.parentIssue?.issueId == null ? null : Number(field.parentIssue?.issueId);
                break;
            default:
                break;
        }
    });
    return toReturn;
};

});


parcelRegister("2lD4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $59584ed54dbd98fa$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
const $59584ed54dbd98fa$var$BoardLocalStorage = (0, $aZaPn.createLocalStorageProvider)('jira_business_jwm-board');
const $59584ed54dbd98fa$var$STORAGE_KEY_EXPANDED_TASKS = 'EXPANDED_TASKS';
const $59584ed54dbd98fa$var$buildExpandedTasksKey = (projectId)=>`${$59584ed54dbd98fa$var$STORAGE_KEY_EXPANDED_TASKS}_${projectId}`;
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $59584ed54dbd98fa$var$LocalStorage = {
    getExpandedTasks: (projectId)=>{
        const data = $59584ed54dbd98fa$var$BoardLocalStorage.get($59584ed54dbd98fa$var$buildExpandedTasksKey(projectId));
        if (Array.isArray(data)) return data;
        return [];
    },
    setExpandedTasks: (projectId, issueIds)=>$59584ed54dbd98fa$var$BoardLocalStorage.set($59584ed54dbd98fa$var$buildExpandedTasksKey(projectId), issueIds)
};
var $59584ed54dbd98fa$export$2e2bcd8739ae039 = $59584ed54dbd98fa$var$LocalStorage;

});

parcelRegister("ghHLE", function(module, exports) {

$parcel$export(module.exports, "batchIssuesForSubtasks", () => $949de59bf4fa5c98$export$5171acceda600e6b);
const $949de59bf4fa5c98$export$5171acceda600e6b = (issues, issueIds)=>{
    const batches = [];
    let batch = [];
    let subtaskCount = 0;
    issueIds.forEach((issueId)=>{
        const issue = issues.find((i)=>i.id === issueId);
        if (issue?.subtaskMetadata) {
            const totalSubtasks = issue.subtaskMetadata.total;
            if (subtaskCount + totalSubtasks > 100) {
                batches.push(batch);
                batch = [
                    issueId
                ];
                subtaskCount = totalSubtasks;
            } else {
                batch.push(issueId);
                subtaskCount += totalSubtasks;
            }
        }
    });
    batches.push(batch);
    return batches;
};

});


parcelRegister("23ARm", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f9d837dde775de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JiQx = parcelRequire("3JiQx");

var $d3C6e = parcelRequire("d3C6e");

var $8BjUT = parcelRequire("8BjUT");


var $lqN6D = parcelRequire("lqN6D");

var $l6iPu = parcelRequire("l6iPu");

var $7sX12 = parcelRequire("7sX12");
/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ const $18f9d837dde775de$var$BoardViewUpdater = ()=>{
    const { removeIssue: removeIssueOld, updateIssue: updateIssue } = (0, $lqN6D.useBoardStoreActions)();
    const [getIssueById] = (0, $lqN6D.useGetIssueById)();
    const { onIssueUpdated: onIssueUpdated, onIssueDeleted: onIssueDeleted } = (0, $7sX12.useCardSubtasks)();
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const refetchBoardData = (0, $l6iPu.useRefetchBoardData)();
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JiQx.BusinessRealtime), {
            appId: "jira-business-board-view",
            onReceive: (event)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (event.payload.issueId != null) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const { issueId: issueId } = event.payload;
                    const isDeleted = event.type === (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99);
                    // Return early when we receive realtime events for an issue that was
                    // recently created via the issue create component in the current window.
                    // This avoid race conditions.
                    if (getIsHighlighted(issueId)) return;
                    const isExistingIssue = getIssueById(issueId) != null;
                    if (isExistingIssue) updateIssue(issueId, {
                        needsExtendedFieldsUpdate: true
                    });
                    if (isExistingIssue && isDeleted) // if issue is not a subtask and has been deleted we can simply remove
                    removeIssueOld(issueId);
                    else {
                        // handle subtask update
                        if (isDeleted) onIssueDeleted(issueId);
                        else onIssueUpdated(issueId);
                        refetchBoardData();
                    }
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BjUT.PageVisibility), {
            onChange: ({ isVisible: isVisible })=>{
                if (isVisible) refetchBoardData();
            }
        })), [
        getIsHighlighted,
        getIssueById,
        onIssueDeleted,
        onIssueUpdated,
        refetchBoardData,
        removeIssueOld,
        updateIssue
    ]);
};
var /** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ $18f9d837dde775de$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($18f9d837dde775de$var$BoardViewUpdater);

});
parcelRegister("7sX12", function(module, exports) {

$parcel$export(module.exports, "useCardSubtasks", () => $13fd974e6ce9b36e$export$e903b9a66019ed9c);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $iYgaL = parcelRequire("iYgaL");

var $2lD4a = parcelRequire("2lD4a");
const $13fd974e6ce9b36e$export$e903b9a66019ed9c = ()=>{
    const [{ subtaskParentMap: subtaskParentMap }, { updateIssue: updateIssue }] = (0, $lqN6D.useBoardStore)();
    const [getIssueById] = (0, $lqN6D.useGetIssueById)();
    const { getSubtasks: getSubtasks } = (0, $iYgaL.useGetSubtasks)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.LOAD_SUBTASKS_EXPERIENCE));
    const isExpanded = (0, $eUqFw.useCallback)((issueId)=>(0, $2lD4a.default).getExpandedTasks(projectId).indexOf(issueId) !== -1, [
        projectId
    ]);
    const loadSubtasks = (0, $eUqFw.useCallback)(async (parentIssueId)=>{
        startExperience();
        // optimistic update to show loading skeleton if we have no current children
        const hasChildren = getIssueById(parentIssueId)?.subtasks != null;
        if (!hasChildren) updateIssue(parentIssueId, {
            subtasks: []
        });
        const { data: oldSubtasks, error: error } = await getSubtasks({
            parentIssueIds: [
                parentIssueId
            ]
        });
        if (oldSubtasks != null) {
            updateIssue(parentIssueId, {
                subtasks: oldSubtasks
            });
            (0, $2lD4a.default).setExpandedTasks(projectId, (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...(0, $2lD4a.default).getExpandedTasks(projectId),
                parentIssueId
            ]));
            markExperienceSuccess();
        } else if (error != null) {
            // revert optimistic update
            updateIssue(parentIssueId, {
                subtasks: undefined
            });
            markExperienceFailed(error.message, error);
        }
    }, [
        startExperience,
        getIssueById,
        getSubtasks,
        updateIssue,
        projectId,
        markExperienceSuccess,
        markExperienceFailed
    ]);
    const hideSubtasks = (0, $eUqFw.useCallback)((parentIssueId)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        updateIssue(parentIssueId, {
            subtasks: undefined
        });
        (0, $2lD4a.default).setExpandedTasks(projectId, (0, $2lD4a.default).getExpandedTasks(projectId).filter((issueId)=>parentIssueId !== issueId));
    }, [
        projectId,
        updateIssue
    ]);
    const toggleSubtasks = (0, $eUqFw.useCallback)((parentIssueId)=>{
        if (isExpanded(parentIssueId)) hideSubtasks(parentIssueId);
        else loadSubtasks(parentIssueId);
    }, [
        hideSubtasks,
        loadSubtasks,
        isExpanded
    ]);
    const onIssueUpdated = (0, $eUqFw.useCallback)((issueId)=>{
        const storedIssue = getIssueById(issueId);
        // Only top-level cards are stored in the board store, subtasks are not
        if (storedIssue) {
            if (isExpanded(issueId)) loadSubtasks(issueId);
        } else // If issue is a subtask we actually want the parent task to refetch subtask details
        getSubtasks({
            issueIds: [
                issueId
            ]
        }).then((response)=>{
            const subtaskIssue = response.data?.[0];
            if (subtaskIssue && subtaskIssue.parentId != null && isExpanded(subtaskIssue.parentId)) loadSubtasks(subtaskIssue.parentId);
        });
    }, [
        getIssueById,
        loadSubtasks,
        getSubtasks,
        isExpanded
    ]);
    const onIssueDeleted = (0, $eUqFw.useCallback)((issueId)=>{
        const parentIssueId = subtaskParentMap[issueId];
        if (parentIssueId != null) {
            const remainingSubtasks = getIssueById(subtaskParentMap[issueId])?.subtasks?.filter((subtask)=>subtask.id !== issueId);
            updateIssue(parentIssueId, {
                // empty array indicates subtasks are loading, need to clear value when no subtasks left
                subtasks: Array.isArray(remainingSubtasks) && remainingSubtasks.length > 0 ? remainingSubtasks : undefined
            });
        }
    }, [
        subtaskParentMap,
        updateIssue,
        getIssueById
    ]);
    return {
        isExpanded: isExpanded,
        loadSubtasks: loadSubtasks,
        hideSubtasks: hideSubtasks,
        toggleSubtasks: toggleSubtasks,
        onIssueUpdated: onIssueUpdated,
        onIssueDeleted: onIssueDeleted
    };
};

});


parcelRegister("9tAOR", function(module, exports) {

$parcel$export(module.exports, "useCardAnimationSensor", () => $f3caa6a9709d828a$export$840be939ee879ec);
$parcel$export(module.exports, "useCardAnimation", () => $f3caa6a9709d828a$export$c99d99bc40e4d963);

var $eUqFw = parcelRequire("eUqFw");

var $4TJj0 = parcelRequire("4TJj0");

var $kQAZu = parcelRequire("kQAZu");

var $hzcvF = parcelRequire("hzcvF");

var $lqN6D = parcelRequire("lqN6D");

var $l6iPu = parcelRequire("l6iPu");

var $ECWEt = parcelRequire("ECWEt");

var $fgS2N = parcelRequire("fgS2N");
var $9zWou = parcelRequire("9zWou");
var $sOKW3 = parcelRequire("sOKW3");
// how many animation points between start and end position
// the higher the number, the slower and smoother the animation
const $f3caa6a9709d828a$var$ANIMATION_SPEED = 50;
const $f3caa6a9709d828a$export$2f2db170c6be15cf = ()=>{
    const [{ dragAnimation: dragAnimation }] = (0, $4TJj0.useCollabStore)();
    const [inProgress, setInProgress] = (0, $eUqFw.useState)(false);
    const wasInProgress = (0, $hzcvF.usePreviousWithInitial)(inProgress);
    const animation = dragAnimation[0];
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const refetchBoardData = (0, $l6iPu.useRefetchBoardData)();
    (0, $eUqFw.useEffect)(()=>{
        const isAnimationProgress = animation != null;
        if (isAnimationProgress !== inProgress) setInProgress(isAnimationProgress);
    }, [
        animation,
        inProgress
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (inProgress === false && wasInProgress === true) refetchBoardData();
    }, [
        inProgress,
        projectId,
        refetchBoardData,
        wasInProgress
    ]);
};
const $f3caa6a9709d828a$export$840be939ee879ec = (api)=>{
    const [{ dragAnimation: dragAnimation }, { stopDragAnimation: stopDragAnimation }] = (0, $4TJj0.useCollabStore)();
    const [{ scrollElement: scrollElement }] = (0, $ECWEt.useScrollElementStore)();
    const [{ columns: columns }] = (0, $lqN6D.useBoardStore)();
    const collapsedColumns = (0, $eUqFw.useMemo)(()=>columns.filter((c)=>!!c.isCollapsed).map((c)=>String(c.statusId)), [
        columns
    ]);
    $f3caa6a9709d828a$export$2f2db170c6be15cf();
    // getting animations one-by-one from the store, until there's nothing to animate
    // we can only animate one card at a time
    // each animation is removed from store once finished
    const animation = dragAnimation[0];
    const sourceNodeId = animation && animation?.sourceNodeId ? `${animation?.sourceNodeId}` : undefined;
    const preDrag = (0, $eUqFw.useMemo)(()=>!api.isLockClaimed() && sourceNodeId != null ? api.tryGetLock(`ISSUE::${sourceNodeId}`) : null, [
        api,
        sourceNodeId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!animation && api.isLockClaimed()) api.tryReleaseLock();
    }, [
        api,
        animation
    ]);
    const position = (0, $eUqFw.useMemo)(()=>(0, $9zWou.getAnimatedCardPosition)({
            animation: animation,
            scrollElement: scrollElement,
            collapsedColumns: collapsedColumns
        }), [
        animation,
        scrollElement,
        collapsedColumns
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (sourceNodeId == null) return;
        if (// couldn't get the lock, possibly because the sournce node is not in the DOM
        // this could happen when remote user updates virtualized card (outside viewport)
        !preDrag || !position) {
            stopDragAnimation({
                sourceNodeId: sourceNodeId
            });
            return;
        }
        const drag = preDrag.fluidLift(position.start);
        const points = (0, $fgS2N.getAnimationPoints)({
            ...position,
            count: $f3caa6a9709d828a$var$ANIMATION_SPEED
        });
        requestAnimationFrame(()=>{
            (0, $fgS2N.animateCard)(drag, points);
        });
    }, [
        api,
        preDrag,
        scrollElement,
        stopDragAnimation,
        sourceNodeId,
        animation,
        position
    ]);
};
const $f3caa6a9709d828a$export$c99d99bc40e4d963 = ()=>{
    const [{ participants: participants, dragAnimation: dragAnimation }, { stopDragAnimation: stopDragAnimation, clearNodeSelection: clearNodeSelection, sendClearNodeSelection: sendClearNodeSelection, sendNodeSelected: sendNodeSelected, setNodeSelection: setNodeSelection }] = (0, $4TJj0.useCollabStore)();
    const onAnimationStart = (0, $eUqFw.useCallback)(({ issueId: issueId, nodeId: nodeId })=>{
        // set telepointer of animated card for current user
        const animation = dragAnimation.find((a)=>Number(a.sourceNodeId) === issueId);
        if (animation) {
            const remoteUser = participants.find((participant)=>participant.clientId === animation.userId);
            if (remoteUser && remoteUser.clientId != null) setNodeSelection({
                nodeId: nodeId,
                sessionId: remoteUser.sessionId,
                user: {
                    userId: remoteUser.clientId,
                    name: remoteUser.name,
                    email: remoteUser.email,
                    avatar: remoteUser.avatar
                }
            });
        } else // set telepointer for remote users
        sendNodeSelected({
            nodeId: nodeId
        });
    }, [
        dragAnimation,
        participants,
        sendNodeSelected,
        setNodeSelection
    ]);
    const onAnimationEnd = (0, $eUqFw.useCallback)(({ issueId: issueId, nodeId: nodeId, dragStop: dragStop, issues: issues })=>{
        // clear telepointer of animated card for current user
        const animation = dragAnimation.find((a)=>Number(a.sourceNodeId) === issueId);
        if (animation) clearNodeSelection({
            nodeId: nodeId
        });
        else // clear telepointer for remote users
        sendClearNodeSelection({
            nodeId: nodeId,
            dropParams: (0, $sOKW3.getDropParams)({
                issueId: issueId,
                issues: issues,
                dragStop: dragStop
            })
        });
        if ((dragStop?.reason === 'CANCEL' || dragStop?.destination == null) && dragStop?.draggableId) stopDragAnimation({
            sourceNodeId: `${issueId}`
        });
    }, [
        clearNodeSelection,
        dragAnimation,
        sendClearNodeSelection,
        stopDragAnimation
    ]);
    return {
        onAnimationStart: onAnimationStart,
        onAnimationEnd: onAnimationEnd
    };
};

});
parcelRegister("ECWEt", function(module, exports) {

$parcel$export(module.exports, "useScrollElementStore", () => $6e5b9f05430cc597$export$64392df048b858a3);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $6e5b9f05430cc597$var$actions = {
    setScrollElement: (scrollElement)=>({ setState: setState })=>setState({
                scrollElement: scrollElement
            })
};
const $6e5b9f05430cc597$var$Store = (0, $a61MH.createStore)({
    initialState: {
        scrollElement: null
    },
    actions: $6e5b9f05430cc597$var$actions,
    name: 'JWMBoardScrollElementStore'
});
const $6e5b9f05430cc597$export$64392df048b858a3 = (0, $ggKAj.createHook)($6e5b9f05430cc597$var$Store);

});

parcelRegister("fgS2N", function(module, exports) {

$parcel$export(module.exports, "getAnimationPoints", () => $025d6f6b2cbde7d0$export$7be4bf80e412c5cf);
$parcel$export(module.exports, "animateCard", () => $025d6f6b2cbde7d0$export$65a869d02d0b8391);
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
// easing function for animation
const $025d6f6b2cbde7d0$var$easeInOutSine = (time, start, end, count)=>{
    const diff = end - start;
    return -diff / 2 * (Math.cos(Math.PI * time / count) - 1) + start;
};
const $025d6f6b2cbde7d0$export$7be4bf80e412c5cf = ({ start: start, end: end, count: count })=>{
    const points = [];
    for(let i = 0; i < count; i += 1)points.push({
        x: $025d6f6b2cbde7d0$var$easeInOutSine(i, start.x, end.x, count),
        y: $025d6f6b2cbde7d0$var$easeInOutSine(i, start.y, end.y, count)
    });
    return points;
};
const $025d6f6b2cbde7d0$export$65a869d02d0b8391 = (drag, points)=>{
    requestAnimationFrame(()=>{
        const nextPosition = points.shift();
        nextPosition && drag.move(nextPosition);
        if (points.length) $025d6f6b2cbde7d0$export$65a869d02d0b8391(drag, points);
        else drag.drop();
    });
};

});

parcelRegister("9zWou", function(module, exports) {

$parcel$export(module.exports, "getAnimatedCardPosition", () => $0967ba67593a9313$export$f4ba78656215d48d);

var $8xzHu = parcelRequire("8xzHu");

var $bYLy3 = parcelRequire("bYLy3");
const $0967ba67593a9313$var$COLUMN_MARGIN = 6;
const $0967ba67593a9313$var$COLUMN_HEADER_SIZE = 60;
const $0967ba67593a9313$export$f4ba78656215d48d = ({ animation: animation, scrollElement: scrollElement, collapsedColumns: collapsedColumns })=>{
    if (animation == null || !scrollElement) return null;
    const { sourceNodeId: sourceNodeId, destinationNodeId: destinationNodeId, destinationRelativeNodeId: destinationRelativeNodeId, destinationColumnId: destinationColumnId } = animation;
    const sourceElement = sourceNodeId != null ? (0, $8xzHu.getDraggableIssueNode)(Number(sourceNodeId)) : null;
    const destinationElement = destinationNodeId != null ? (0, $8xzHu.getDraggableIssueNode)(destinationNodeId) : null;
    const destinationPrevElement = destinationRelativeNodeId != null ? (0, $8xzHu.getDraggableIssueNode)(destinationRelativeNodeId) : null;
    const destinationColumnElement = destinationColumnId != null ? (0, $8xzHu.getDraggableColumnNode)(destinationColumnId) : null;
    if (!sourceElement || !destinationElement && !destinationPrevElement && !destinationColumnElement) return null;
    const sourceElementRect = sourceElement.getBoundingClientRect();
    const scrollElementRect = scrollElement.getBoundingClientRect();
    if (!(0, $bYLy3.isElementInViewport)(sourceElementRect, scrollElementRect)) return null;
    const start = {
        x: sourceElementRect.left,
        y: sourceElementRect.top
    };
    let end = null;
    if (destinationElement) {
        const destinationElementRect = destinationElement.getBoundingClientRect();
        if (!(0, $bYLy3.isElementInViewport)(destinationElementRect, scrollElementRect)) return null;
        end = {
            x: destinationElementRect.left,
            y: destinationElementRect.top
        };
    } else if (destinationPrevElement) {
        const destinationPrevElementRect = destinationPrevElement.getBoundingClientRect();
        if (!(0, $bYLy3.isPrevElementInViewport)(destinationPrevElementRect, sourceElementRect, scrollElementRect)) return null;
        end = {
            x: destinationPrevElementRect.left,
            y: destinationPrevElementRect.top + destinationPrevElementRect.height
        };
    } else if (destinationColumnElement) {
        const destinationColumnElementRect = destinationColumnElement.getBoundingClientRect();
        if (!(0, $bYLy3.isColumnInViewport)(destinationColumnElementRect, scrollElementRect)) return null;
        if (collapsedColumns && collapsedColumns.includes(String(destinationColumnId))) end = {
            x: destinationColumnElementRect.left - $0967ba67593a9313$var$COLUMN_HEADER_SIZE - destinationColumnElementRect.width,
            y: destinationColumnElementRect.top
        };
        else end = {
            x: destinationColumnElementRect.left + $0967ba67593a9313$var$COLUMN_MARGIN,
            y: destinationColumnElementRect.top + $0967ba67593a9313$var$COLUMN_HEADER_SIZE
        };
    }
    if (!end) return null;
    return {
        start: start,
        end: end
    };
};

});
parcelRegister("8xzHu", function(module, exports) {

$parcel$export(module.exports, "getDraggableIssueNode", () => $7a4c509703b24aae$export$1d8915fb19fd9b63);
$parcel$export(module.exports, "getDraggableColumnNode", () => $7a4c509703b24aae$export$44cf4a50de24ccb);
// issue DOM node
const $7a4c509703b24aae$export$1d8915fb19fd9b63 = (id)=>document.querySelector(`[data-rbd-draggable-id="ISSUE::${id}"]`);
const $7a4c509703b24aae$export$44cf4a50de24ccb = (id)=>document.querySelector(`[data-rbd-draggable-id="COLUMN::${id}"]`);

});

parcelRegister("bYLy3", function(module, exports) {

$parcel$export(module.exports, "isElementInViewport", () => $eaa97a9dbcad3b7c$export$7cc0e9dd2435cb30);
$parcel$export(module.exports, "isPrevElementInViewport", () => $eaa97a9dbcad3b7c$export$2f427ae297192452);
$parcel$export(module.exports, "isColumnInViewport", () => $eaa97a9dbcad3b7c$export$4afdf5ed9bfe6499);
const $eaa97a9dbcad3b7c$export$2da27a0506cb31ce = 50;
const $eaa97a9dbcad3b7c$export$7cc0e9dd2435cb30 = (rect, parentRect)=>rect.top - parentRect.top - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0 && parentRect.bottom - rect.bottom - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0 && rect.left - parentRect.left >= 0 && parentRect.right - rect.right - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0;
const $eaa97a9dbcad3b7c$export$2f427ae297192452 = (rect, sourceRect, parentRect)=>rect.top + sourceRect.height - parentRect.top - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0 && parentRect.bottom + sourceRect.height - rect.bottom - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0 && rect.left - parentRect.left >= 0 && parentRect.right - rect.right - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0;
const $eaa97a9dbcad3b7c$export$4afdf5ed9bfe6499 = (rect, parentRect)=>rect.top - parentRect.top >= 0 && rect.left - parentRect.left >= 0 && parentRect.right - rect.right - $eaa97a9dbcad3b7c$export$2da27a0506cb31ce >= 0;

});


parcelRegister("sOKW3", function(module, exports) {

$parcel$export(module.exports, "getDropParams", () => $82aa5fc2aea01204$export$5a67f3ed889a32ac);
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
const $82aa5fc2aea01204$export$5a67f3ed889a32ac = ({ issueId: issueId, issues: issues, dragStop: dragStop })=>{
    const sourceIssue = issues.find((issue)=>issue.id === issueId);
    const destinationIssueIndex = dragStop.destination?.index;
    const destinationStatusId = Number((dragStop.destination?.droppableId || '').split('COLUMN::')[1] || '');
    const destinationColumnIssues = issues.filter((i)=>i.statusId === destinationStatusId);
    const destinationIssue = typeof destinationIssueIndex === 'number' ? destinationColumnIssues[destinationIssueIndex] : undefined;
    const destinationRelativeIssue = !destinationIssue && typeof destinationIssueIndex === 'number' && destinationIssueIndex > 0 ? destinationColumnIssues[destinationIssueIndex - 1] : undefined;
    // issues hasn't been moved anywhere - just a lift and drop on the same place
    if (sourceIssue?.statusId === destinationStatusId && (issueId === destinationIssue?.id || issueId === destinationRelativeIssue?.id)) return undefined;
    return {
        // source issue - dropped card
        sourceNodeId: issueId,
        // that's a card that gets pushed by the dropped card.
        // It is used in calculations of destination coordinates for animation
        destinationNodeId: destinationIssue?.id,
        // relative destination card in case there's no destinationNodeId
        // e.g. when dropped in the end of a column, relative issue would be the last card in that column
        destinationRelativeNodeId: destinationRelativeIssue?.id,
        // column
        destinationColumnId: destinationStatusId
    };
};

});


parcelRegister("4Z3mK", function(module, exports) {

$parcel$export(module.exports, "useCardTransitionsOld", () => $65273c41c5f4ead3$export$61f76798a5d060a4);

var $eUqFw = parcelRequire("eUqFw");

var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $1a3la = parcelRequire("1a3la");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $7UXrG = parcelRequire("7UXrG");

var $dMmlS = parcelRequire("dMmlS");

var $9tAOR = parcelRequire("9tAOR");

var $jEwJw = parcelRequire("jEwJw");

var $4mhKq = parcelRequire("4mhKq");

var $iXHUp = parcelRequire("iXHUp");

var $14qXr = parcelRequire("14qXr");

var $ezHK9 = parcelRequire("ezHK9");
const $65273c41c5f4ead3$var$emptyArray = [];
const $65273c41c5f4ead3$export$61f76798a5d060a4 = (statusId)=>{
    const [{ issues: issues, cardDragState: cardDragState, transitions: allTransitions }, { setIssues: setIssues, setCardDragState: setCardDragState, moveIssues: moveIssues, updateIssue: updateIssue, pushToJobQueue: pushToJobQueue }] = (0, $lqN6D.useBoardStore)();
    const [getIssueById] = (0, $lqN6D.useGetIssueById)();
    const [transitions] = (0, $lqN6D.useTransitionsByStatus)({
        fromStatusId: Number(cardDragState.issue?.statusId ?? 0),
        toStatusId: Number(statusId ?? 0)
    });
    const [transition] = (0, $lqN6D.useTransitionById)({
        transitionId: cardDragState.transitionId
    });
    const [sourceColumn] = (0, $lqN6D.useColumnByStatusId)({
        statusId: Number(cardDragState.issue?.statusId)
    });
    const { loading: issueRankInProgress, rankIssueAfter: rankIssueAfter, rankIssueBefore: rankIssueBefore } = (0, $7UXrG.useRankIssue)();
    const [hasMultipleTransitions] = (0, $lqN6D.useHasMultipleTransitionsBetweenStatuses)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const startTransitionExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.TRANSITION_ISSUE_EXPERIENCE));
    const markTransitionExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.TRANSITION_ISSUE_EXPERIENCE));
    const markTransitionExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.TRANSITION_ISSUE_EXPERIENCE));
    const startRankExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.RANK_ISSUE_EXPERIENCE));
    const markRankExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.RANK_ISSUE_EXPERIENCE));
    const markRankExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.RANK_ISSUE_EXPERIENCE));
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    const hasScheduleIssuesPermission = project.permissions.scheduleIssues;
    const { onAnimationStart: onAnimationStart, onAnimationEnd: onAnimationEnd } = (0, $9tAOR.useCardAnimation)();
    const [{ dragAnimation: dragAnimation }, { stopDragAnimation: stopDragAnimation }] = (0, $4TJj0.useCollabStore)();
    const { transitionAndRank: transitionAndRank } = (0, $dMmlS.useTransitionAndRank)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    const boardColumns = (0, $4mhKq.useColumns)();
    const cardGroupMove = (0, $jEwJw.useCardGroupMove)();
    const targetColumn = (0, $eUqFw.useMemo)(()=>(0, $ezHK9.getColumnById)(cardDragState.columnId, boardColumns), [
        boardColumns,
        cardDragState.columnId
    ]);
    const isTargetColumnCollapsed = (0, $eUqFw.useMemo)(()=>targetColumn != null && !!targetColumn.isCollapsed, [
        targetColumn
    ]);
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const cloudId = (0, $dWLk9.useCloudId)();
    // For the given arguments, executes rank and transition sequentially
    const getTransitionAndRankPromise = (issueId, getRankPromise, defaultTransition, shouldRankAfter, relativeIssueId)=>new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>{
            const processRankPromise = ()=>getRankPromise().then(resolve).catch(reject);
            const transitionToExecute = hasMultipleTransitions ? transition : defaultTransition;
            const { transitionId: transitionId, hasScreen: hasScreen } = transitionToExecute ?? {};
            const analyticsEventData = {
                hasScreen: hasScreen,
                issueId: issueId
            };
            const analyticsSuccess = ()=>{
                markTransitionExperienceSuccess();
                markRankExperienceSuccess();
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $14qXr.transitionAndRankAction)} success`, analyticsEventData);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransitionAndRank success', {
                    triggerPointKey: (0, $14qXr.JWM_BOARD_CARD_ISSUE_TRANSITION),
                    isModalOpen: false
                });
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const analyticsFailure = (err)=>{
                // Exclude client fetch, validation and 4xx errors from experience fail events. Error message for
                // transition and rank is displayed at board level.
                if ((0, $ezHK9.isValidationOrNetworkError)(err)) {
                    markRankExperienceSuccess();
                    markTransitionExperienceSuccess();
                } else {
                    markTransitionExperienceFailed('Issue transition and rank failed.', err);
                    markRankExperienceFailed('Issue transition and rank failed.', err);
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $14qXr.transitionAndRankAction)} failure`, analyticsEventData);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransitionAndRank failed', {
                        triggerPointKey: (0, $14qXr.JWM_BOARD_CARD_ISSUE_TRANSITION),
                        isModalOpen: false
                    });
                }
                throw err;
            };
            if (hasScreen) {
                const handleDialogSuccess = ()=>{
                    processRankPromise();
                    markTransitionExperienceSuccess();
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $14qXr.transitionAction)} success`, analyticsEventData);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition success', {
                        triggerPointKey: (0, $14qXr.JWM_BOARD_CARD_ISSUE_TRANSITION),
                        isModalOpen: true
                    });
                };
                const handleDialogError = ()=>{
                    markTransitionExperienceFailed('Issue transition failed.', new Error('Issue transition with screen failed.'));
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $14qXr.transitionAction)} failure`, analyticsEventData);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition failed', {
                        triggerPointKey: (0, $14qXr.JWM_BOARD_CARD_ISSUE_TRANSITION),
                        isModalOpen: true
                    });
                    reject();
                };
                const handleDialogCancel = ()=>{
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition cancel', {
                        triggerPointKey: (0, $14qXr.JWM_BOARD_CARD_ISSUE_TRANSITION),
                        isModalOpen: true
                    });
                    reject();
                };
                const issueKey = getIssueById(issueId)?.key;
                const formattedIssueId = (0, $6vrw7.toIssueId)(String(issueId));
                const ariIssueId = (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'issue',
                    resourceId: formattedIssueId ?? ''
                });
                startTransitionExperience();
                openIssueTransitionModal?.({
                    payload: {
                        issueId: ariIssueId,
                        issueKey: issueKey,
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        transitionId: String(transitionId)
                    },
                    triggerPointKey: 'issue-transition-board-card-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogCancel: handleDialogCancel,
                    onDialogError: handleDialogError
                });
            } else {
                startTransitionExperience();
                startRankExperience();
                const transitionAndRankInput = {
                    issueIds: [
                        issueId
                    ],
                    transitionId: transitionId != null ? Number(transitionId) : undefined
                };
                if (hasScheduleIssuesPermission) {
                    transitionAndRankInput.afterIssueId = relativeIssueId != null && shouldRankAfter ? relativeIssueId : undefined;
                    transitionAndRankInput.beforeIssueId = relativeIssueId != null && !shouldRankAfter ? relativeIssueId : undefined;
                }
                transitionAndRank(transitionAndRankInput).then(resolve).then(analyticsSuccess).catch(analyticsFailure).catch(reject);
            }
        });
    const onDragStart = (dragStart)=>{
        if (dragStart === undefined) return;
        const { draggableId: draggableId, type: type } = dragStart;
        if (type === (0, $ib4WI.CARD_DND_TYPE)) {
            const issueId = draggableId.split('ISSUE::')[1];
            setCardDragState({
                ...cardDragState,
                issue: getIssueById(Number(issueId))
            });
            const nodeId = (0, $i0nxo.getPresenceNodeId)({
                projectId: projectId,
                viewId: 'board',
                nodeId: issueId
            });
            // set telepointer of animated card for current user
            onAnimationStart({
                issueId: Number(issueId),
                nodeId: nodeId
            });
        }
    };
    const onDragEnd = (dragStop)=>{
        if (!dragStop?.destination && dragStop?.reason === 'DROP') // if the drag destination is null is because the Droppable component is disabled
        // so the user is trying to do an invalid move
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cardTransition invalidMove', {
            isTargetColumnCollapsed: isTargetColumnCollapsed,
            hasMultipleTransitions: hasMultipleTransitions
        });
        setCardDragState({
            ...cardDragState,
            issue: null,
            hoverIntent: false,
            transitionId: null,
            columnId: null
        });
        if (dragStop?.draggableId) {
            const issueId = dragStop.draggableId.split('ISSUE::')[1];
            const nodeId = (0, $i0nxo.getPresenceNodeId)({
                projectId: projectId,
                viewId: 'board',
                nodeId: issueId
            });
            onAnimationEnd({
                issueId: Number(issueId),
                nodeId: nodeId,
                dragStop: dragStop,
                issues: issues
            });
        }
    };
    const onCardDragOver = (0, $eUqFw.useCallback)((columnId)=>(transitionId, hoverIntent)=>{
            setCardDragState({
                ...cardDragState,
                transitionId: transitionId,
                columnId: columnId,
                issue: cardDragState.issue,
                hoverIntent: hoverIntent,
                ...transitionId !== null && {
                    hoverIntent: cardDragState.hoverIntent || hoverIntent && !!transitionId
                }
            });
        }, [
        cardDragState,
        setCardDragState
    ]);
    const onDragUpdate = (0, $eUqFw.useCallback)((dragUpdated)=>{
        if (dragUpdated == null) return;
        const { destination: destination, type: type, draggableId: draggableId } = dragUpdated;
        const issueId = draggableId.split('ISSUE::')[1];
        if (destination && type === (0, $ib4WI.CARD_DND_TYPE)) {
            const columnId = destination.droppableId.split('COLUMN::')[1];
            const maybeNumberColumnID = Number(columnId);
            setCardDragState({
                ...cardDragState,
                issue: getIssueById(Number(issueId)),
                columnId: Number.isNaN(maybeNumberColumnID) ? columnId : maybeNumberColumnID
            });
        }
    }, [
        cardDragState,
        setCardDragState,
        getIssueById
    ]);
    const rollback = ()=>setIssues([
            ...issues
        ]);
    const moveItems = (issueIDs, sourceColumnId, targetColumnId, sourceIndex, destinationIndex)=>{
        if ((0, $ezHK9.isInvalidMove)({
            sourceColumnId: sourceColumnId,
            targetColumnId: targetColumnId,
            sourceIndex: sourceIndex,
            destinationIndex: destinationIndex,
            transition: transition,
            hasMultipleTransitions: hasMultipleTransitions,
            isGroupedByStatus: isGroupedByStatus,
            issueRankInProgress: issueRankInProgress,
            isTargetColumnCollapsed: isTargetColumnCollapsed
        })) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cardTransition invalidMove', {
                isTargetColumnCollapsed: isTargetColumnCollapsed,
                hasMultipleTransitions: hasMultipleTransitions
            });
            return Promise.reject(new (0, $ib4WI.InvalidMove)());
        }
        const targetColumnIssues = targetColumn?.issues ?? $65273c41c5f4ead3$var$emptyArray;
        const { shouldRankAfter: shouldRankAfter, relativeIssueId: relativeIssueId } = (0, $ezHK9.getRankTarget)({
            targetColumn: targetColumn,
            sourceColumnId: sourceColumnId,
            targetColumnId: targetColumnId,
            sourceIndex: sourceIndex,
            destinationIndex: destinationIndex,
            isTargetColumnCollapsed: isTargetColumnCollapsed
        });
        if (targetColumn && targetColumn.groupBy === (0, $jGcn0.GROUP_BY_PRIORITY)) moveIssues(issueIDs, sourceColumnId, targetColumnId, relativeIssueId, shouldRankAfter, (0, $ezHK9.getOptimisticUpdatesForPriority)(targetColumn));
        else if (targetColumn && targetColumn.groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE)) moveIssues(issueIDs, sourceColumnId, targetColumnId, relativeIssueId, shouldRankAfter, (0, $ezHK9.getOptimisticUpdatesForAssignee)(targetColumn));
        else if (targetColumn && targetColumn.groupBy === (0, $jGcn0.GROUP_BY_CATEGORY)) moveIssues(issueIDs, sourceColumnId, targetColumnId, relativeIssueId, shouldRankAfter, (0, $ezHK9.getOptimisticUpdatesForCategory)(targetColumn));
        else if (relativeIssueId !== null || targetColumnId !== sourceColumnId) // Optimistic move issue
        moveIssues(issueIDs, sourceColumnId, targetColumnId, relativeIssueId, shouldRankAfter);
        // we only need to move animated issue optimistically, because it's already been updated on BE by a remote user
        // after the card is droppped, we refetch board data to make sure there's no stale state
        const animatedIssueId = dragAnimation.map((a)=>a.sourceNodeId).find((issueId)=>issueIDs.includes(issueId));
        if (animatedIssueId != null) {
            stopDragAnimation({
                sourceNodeId: `${animatedIssueId}`
            });
            return Promise.resolve();
        }
        const issueIdsToProcess = shouldRankAfter ? [
            ...issueIDs
        ].reverse() : [
            ...issueIDs
        ];
        const rankAnalytics = (action)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), action, {
                issuesInColumnCount: targetColumnIssues.length
            });
        const getRankPromise = (issueId)=>{
            if (!hasScheduleIssuesPermission || relativeIssueId == null || relativeIssueId === issueId) return ()=>Promise.resolve();
            return ()=>{
                startRankExperience();
                const onRankSuccess = ()=>{
                    markRankExperienceSuccess();
                    rankAnalytics(`${(0, $14qXr.rankAction)} success`);
                };
                const onRankFail = (err)=>{
                    if ((0, $ezHK9.isValidationOrNetworkError)(err)) {
                        markRankExperienceSuccess();
                        rankAnalytics(`${(0, $14qXr.rankAction)} success`);
                    } else {
                        markRankExperienceFailed('Issue rank failed.', err);
                        rankAnalytics(`${(0, $14qXr.rankAction)} failure`);
                    }
                    throw err;
                };
                return shouldRankAfter ? rankIssueAfter({
                    issueId: issueId,
                    relativeIssueId: relativeIssueId
                }).then(onRankSuccess).catch(onRankFail) : rankIssueBefore({
                    issueId: issueId,
                    relativeIssueId: relativeIssueId
                }).then(onRankSuccess).catch(onRankFail);
            };
        };
        if (!isGroupedByStatus) return cardGroupMove({
            issueIds: issueIdsToProcess,
            targetColumn: // @ts-expect-error - Type 'null' is not assignable to type 'BoardColumn'
            targetColumn,
            getRankPromise: getRankPromise,
            rollback: rollback
        });
        return pushToJobQueue(()=>issueIdsToProcess.map((issueId)=>()=>getTransitionAndRankPromise(issueId, getRankPromise(issueId), (0, $ezHK9.getDefaultTransition)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    sourceColumnId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    targetColumnId, allTransitions), shouldRankAfter, relativeIssueId)).reduce((previousPromise, currentTransitionAndRankPromise)=>previousPromise.then(currentTransitionAndRankPromise).catch((err)=>{
                    rollback();
                    throw err;
                }), Promise.resolve()).then(()=>{
                issueIdsToProcess.forEach((issueId)=>// TODO JET-1952
                    updateIssue(issueId, {
                        // @ts-expect-error - Type 'string' is not assignable to type 'number'.
                        statusId: targetColumnId
                    }));
                return Promise.resolve();
            }));
    };
    const onCardsMove = (cardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex)=>moveItems(/**
			 * The string cardId type is only used by Advanced Roadmaps increment planning board.
			 * In JWM the cardId should be expected to be a number.
			 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        cardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex);
    return {
        transitions: transitions,
        transition: transition,
        sourceColumn: sourceColumn,
        cardDragState: cardDragState,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onDragUpdate: onDragUpdate,
        onCardDragOver: onCardDragOver,
        onCardsMove: onCardsMove
    };
};

});
parcelRegister("7UXrG", function(module, exports) {

$parcel$export(module.exports, "useRankIssue", () => $b367aa7bbf8715c7$export$dbe3d15eebe7e64c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $b367aa7bbf8715c7$var$REST_API_PATH_AFTER = '/rest/board-api/1/rank/rankAfter';
const $b367aa7bbf8715c7$var$REST_API_PATH_BEFORE = '/rest/board-api/1/rank/rankBefore';
const $b367aa7bbf8715c7$export$dbe3d15eebe7e64c = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const rankIssueBefore = ({ issueId: issueId, relativeIssueId: relativeIssueId, onError: onError })=>{
        setLoading(true);
        return (0, $lRmyA.performPutRequest)(`${$b367aa7bbf8715c7$var$REST_API_PATH_BEFORE}`, {
            body: JSON.stringify({
                issueId: issueId,
                relativeIssueId: relativeIssueId
            })
        }).then(()=>{
            setLoading(false);
        }).catch((error)=>{
            setLoading(false);
            onError && onError(error);
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmBoardRank',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to rank issue before in JWM board'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
    const rankIssueAfter = ({ issueId: issueId, relativeIssueId: relativeIssueId, onError: onError })=>{
        setLoading(true);
        return (0, $lRmyA.performPutRequest)(`${$b367aa7bbf8715c7$var$REST_API_PATH_AFTER}`, {
            body: JSON.stringify({
                issueId: issueId,
                relativeIssueId: relativeIssueId
            })
        }).then(()=>{
            setLoading(false);
        }).catch((error)=>{
            setLoading(false);
            onError && onError(error);
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmBoardRank',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to rank issue after in JWM board'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
    return {
        loading: loading,
        rankIssueBefore: rankIssueBefore,
        rankIssueAfter: rankIssueAfter
    };
};

});

parcelRegister("dMmlS", function(module, exports) {

$parcel$export(module.exports, "useTransitionAndRank", () => $261745716c99c993$export$42fccec90cad410);

var $bnlpg = parcelRequire("bnlpg");

var $iZuDo = parcelRequire("iZuDo");

var $kkYfO = parcelRequire("kkYfO");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kClbt = parcelRequire("kClbt");
const $261745716c99c993$var$QUERY_NAME = 'transitionAndRankBoardView';
const $261745716c99c993$var$isClientSideError = (error)=>{
    const statusCode = error.extensions?.statusCode;
    return statusCode && statusCode >= 400 && statusCode < 500;
};
const $261745716c99c993$export$42fccec90cad410 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const doFireErrorAnalytics = (error)=>{
        (0, $guiFP.default)({
            meta: {
                id: $261745716c99c993$var$QUERY_NAME,
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: Array.isArray(error) && error.length > 0 ? error[0] : error,
            attributes: {
                message: 'Failed to transition and rank'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const [transitionAndRankMutation, { loading: loading }] = (0, $iZuDo.useMutation)((0, $kClbt.TRANSITION_AND_RANK_MUTATION), {
        onCompleted: (onCompletedData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$261745716c99c993$var$QUERY_NAME} succeeded`, {});
            const errors = onCompletedData?.transitionAndRankJwmItems?.errors;
            const areAllErrorsClientSideErrors = errors?.every($261745716c99c993$var$isClientSideError);
            if (errors && errors.length > 0 && !areAllErrorsClientSideErrors) doFireErrorAnalytics(onCompletedData.transitionAndRankJwmItems.errors.map((e)=>new (0, $kkYfO.MutationError)(e)));
        }
    });
    const transitionAndRank = async ({ issueIds: issueIds, transitionId: transitionId, beforeIssueId: beforeIssueId, afterIssueId: afterIssueId })=>{
        const queryInput = {
            issueIds: issueIds
        };
        const rank = beforeIssueId != null && {
            beforeIssueId: beforeIssueId
        } || afterIssueId != null && {
            afterIssueId: afterIssueId
        };
        if (rank) queryInput.rank = rank;
        if (transitionId != null) queryInput.transitionId = transitionId;
        try {
            const result = await transitionAndRankMutation({
                variables: {
                    input: queryInput
                }
            });
            const error = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(result?.data?.transitionAndRankJwmItems?.errors);
            // Converting the mutation error to validation error which is ignored from experience error reporting
            // and displayed to the user properly with ErrorFlag component upstream.
            if (error) throw new (0, $7byHA.ValidationError)(error?.message || '');
        } catch (error) {
            doFireErrorAnalytics(error);
            throw error;
        }
    };
    return {
        transitionAndRank: transitionAndRank,
        loading: loading
    };
};

});
parcelRegister("bnlpg", function(module, exports) {

module.exports = (parcelRequire("jtpa0"));

});
parcelRegister("jtpa0", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e2d43e13ed703ec3$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e2d43e13ed703ec3$var$head;

});


parcelRegister("kClbt", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_AND_RANK_MUTATION", () => $2ef8564fd961d0c3$export$3859a4427e6044ca);

var $9ypom = parcelRequire("9ypom");
const $2ef8564fd961d0c3$export$3859a4427e6044ca = (0, $9ypom.default)`
    mutation TransitionAndRankJWMBoardView ($input: JWMTransitionAndRankItemInput!) {
        transitionAndRankJwmItems(input:$input, fieldIdsToReturn:["issueId"]) {  
            success,
            errors {
              message
              extensions {
                statusCode
              }
            }
        }
    }
`;

});


parcelRegister("jEwJw", function(module, exports) {

$parcel$export(module.exports, "useCardGroupMove", () => $9c85c5e42768ca3e$export$e59a7cfb4ce6dc28);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $4G5xU = parcelRequire("4G5xU");

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $eesws = parcelRequire("eesws");

var $iXHUp = parcelRequire("iXHUp");
const $9c85c5e42768ca3e$var$updateIssueFieldAction = 'jwm.board.issue.field.update';
const $9c85c5e42768ca3e$export$e59a7cfb4ce6dc28 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [getIssueById] = (0, $lqN6D.useGetIssueById)();
    const [{ issuesWithFields: issuesWithFields }, { pushToJobQueue: pushToJobQueue }] = (0, $lqN6D.useBoardStore)();
    const updateIssueField = (0, $eesws.useUpdateIssueField)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.UPDATE_ISSUE_GROUPED_BY_FIELD_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.UPDATE_ISSUE_GROUPED_BY_FIELD_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.UPDATE_ISSUE_GROUPED_BY_FIELD_EXPERIENCE));
    const analyticsSuccess = (0, $eUqFw.useCallback)(()=>{
        markExperienceSuccess();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${$9c85c5e42768ca3e$var$updateIssueFieldAction} success`, {
            groupBy: groupBy
        });
    }, [
        createAnalyticsEvent,
        groupBy,
        markExperienceSuccess
    ]);
    const analyticsFailure = (0, $eUqFw.useCallback)((error)=>{
        // Exclude client fetch, validation and 4xx errors from experience fail events. Error message for
        // transition and rank is displayed at board level.
        const reportedError = error && ((0, $JRB5w.isClientFetchError)(error) || (0, $7byHA.isValidationError)(error) || (0, $JRB5w.isHttpClientErrorResponse)(error));
        if (!reportedError) {
            markExperienceFailed('Issue transition failed.', error);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), `${$9c85c5e42768ca3e$var$updateIssueFieldAction} failure`, {
                groupBy: groupBy
            });
        } else markExperienceSuccess();
    }, [
        createAnalyticsEvent,
        groupBy,
        markExperienceFailed,
        markExperienceSuccess
    ]);
    const getUpdateIssueFieldPromise = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (issueId, targetColumn)=>{
        const issue = getIssueById(issueId);
        switch(groupBy){
            case 0, $jGcn0.GROUP_BY_PRIORITY:
                return ()=>updateIssueField({
                        issueKey: issue.key,
                        fieldKey: 'priority',
                        newValue: {
                            priorityId: targetColumn.groupKey,
                            name: targetColumn.name
                        }
                    });
            case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                return ()=>updateIssueField({
                        issueKey: issue.key,
                        fieldKey: 'assignee',
                        newValue: {
                            accountId: targetColumn.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? undefined : targetColumn.groupKey,
                            displayName: targetColumn.name
                        }
                    });
            case 0, $jGcn0.GROUP_BY_CATEGORY:
                return ()=>updateIssueField({
                        issueKey: issue.key,
                        fieldKey: targetColumn.groupFieldKey ?? '',
                        newValue: targetColumn.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? null : {
                            value: targetColumn.name
                        }
                    });
            default:
                return null;
        }
    }, [
        getIssueById,
        groupBy,
        updateIssueField
    ]);
    const isIssueInCategory = (0, $eUqFw.useCallback)((categoryName, issue)=>{
        const issueDetails = issuesWithFields?.[issue.id];
        const categoryField = issueDetails?.fieldsByAlias.category;
        return categoryField?.value === categoryName || categoryField?.value == null && categoryName === (0, $ib4WI.NULL_GROUP_KEY);
    }, [
        issuesWithFields
    ]);
    const getMoveBetweenGroupsPromise = (0, $eUqFw.useCallback)((issueId, targetColumn, getRankPromise)=>{
        const issue = getIssueById(issueId);
        if (targetColumn == null || issue == null) return Promise.resolve();
        const updateIssueFieldExecutor = getUpdateIssueFieldPromise(issueId, targetColumn);
        // If executor exist is that we can handle this case
        if (updateIssueFieldExecutor) {
            const rankPromiseExecutor = getRankPromise(issueId);
            const isMovingInTheSameColumn = groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && targetColumn.groupKey === issue.priorityId || groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && targetColumn.groupKey === issue.assigneeKey || groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && isIssueInCategory(targetColumn.groupKey, issue);
            if (isMovingInTheSameColumn) return rankPromiseExecutor();
            return new Promise((resolve, reject)=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueGroup updated', {
                    field: groupBy?.toLowerCase()
                });
                startExperience();
                updateIssueFieldExecutor().then(rankPromiseExecutor).then((value)=>{
                    analyticsSuccess();
                    resolve(value);
                }).catch((error)=>{
                    analyticsFailure(error);
                    reject(error);
                });
            });
        }
        return Promise.resolve();
    }, [
        getIssueById,
        getUpdateIssueFieldPromise,
        groupBy,
        isIssueInCategory,
        createAnalyticsEvent,
        startExperience,
        analyticsSuccess,
        analyticsFailure
    ]);
    return (0, $eUqFw.useCallback)(({ issueIds: issueIds, targetColumn: targetColumn, getRankPromise: getRankPromise, rollback: rollback })=>pushToJobQueue(()=>issueIds.map((issueId)=>()=>getMoveBetweenGroupsPromise(issueId, targetColumn, getRankPromise)).reduce((previousPromise, currentTransitionAndRankPromise)=>previousPromise.then(currentTransitionAndRankPromise).catch((err)=>{
                    rollback();
                    throw err;
                }), Promise.resolve()).then(()=>Promise.resolve())), [
        getMoveBetweenGroupsPromise,
        pushToJobQueue
    ]);
};

});
parcelRegister("eesws", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssueField", () => $64925e24b7b4f58a$export$cc74d3329dbba44d);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $fecbI = parcelRequire("fecbI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $64925e24b7b4f58a$var$JWM_BOARD_ISSUE_FIELD_UPDATE = 'jwmBoardIssueFieldUpdate';
const $64925e24b7b4f58a$export$cc74d3329dbba44d = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue })=>(0, $fecbI.defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$64925e24b7b4f58a$var$JWM_BOARD_ISSUE_FIELD_UPDATE} succeeded`, {
                field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
            });
            return response;
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $64925e24b7b4f58a$var$JWM_BOARD_ISSUE_FIELD_UPDATE,
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `${$64925e24b7b4f58a$var$JWM_BOARD_ISSUE_FIELD_UPDATE} failed`,
                    field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }), [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});



parcelRegister("14qXr", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankAction", () => $8254ed4ac6a74ef1$export$61315dc22850a7e8);
$parcel$export(module.exports, "transitionAction", () => $8254ed4ac6a74ef1$export$1048808cdac010a3);
$parcel$export(module.exports, "rankAction", () => $8254ed4ac6a74ef1$export$716d12f112f3b95a);
$parcel$export(module.exports, "JWM_BOARD_CARD_ISSUE_TRANSITION", () => $8254ed4ac6a74ef1$export$c29f63cb300aa044);

const $8254ed4ac6a74ef1$export$9f6f76a546c2b512 = async ()=>{
    const module = await Promise.resolve((parcelRequire("fzLv5")));
    return module.default;
};
const $8254ed4ac6a74ef1$export$61315dc22850a7e8 = 'jwm.board.transition-and-rank';
const $8254ed4ac6a74ef1$export$1048808cdac010a3 = 'jwm.board.transition';
const $8254ed4ac6a74ef1$export$716d12f112f3b95a = 'jwm.board.rank';
const $8254ed4ac6a74ef1$export$c29f63cb300aa044 = 'jwm-board-card-issue-transition';

});

parcelRegister("ezHK9", function(module, exports) {

$parcel$export(module.exports, "isValidationOrNetworkError", () => $36663632637c9aa6$export$e08b42aa0950b820);
$parcel$export(module.exports, "getColumnById", () => $36663632637c9aa6$export$e85f3ae1437b5b1e);
$parcel$export(module.exports, "getDefaultTransition", () => $36663632637c9aa6$export$262124b154b9f1c0);
$parcel$export(module.exports, "isInvalidMove", () => $36663632637c9aa6$export$574df82e893253f3);
$parcel$export(module.exports, "getOptimisticUpdatesForPriority", () => $36663632637c9aa6$export$15f278b27a485ab9);
$parcel$export(module.exports, "getOptimisticUpdatesForAssignee", () => $36663632637c9aa6$export$9930bf2689bad0f2);
$parcel$export(module.exports, "getOptimisticUpdatesForCategory", () => $36663632637c9aa6$export$6e130a81482d8b10);
$parcel$export(module.exports, "getRankTarget", () => $36663632637c9aa6$export$d79471cb0b12d416);

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $ib4WI = parcelRequire("ib4WI");
const $36663632637c9aa6$export$e08b42aa0950b820 = (error)=>// Detects client fetch, validation and 4xx errors
    error != null && ((0, $JRB5w.isClientFetchError)(error) || (0, $7byHA.isValidationError)(error) || (0, $JRB5w.isHttpClientErrorResponse)(error));
const $36663632637c9aa6$export$e85f3ae1437b5b1e = (columnId, boardColumns)=>{
    if (columnId == null) return columnId;
    const columnIdString = String(columnId);
    return boardColumns.find((column)=>columnIdString === String(column.id));
};
const $36663632637c9aa6$export$262124b154b9f1c0 = (sourceStatusId, targetStatusId, allTransitions)=>allTransitions.filter((t)=>Number(targetStatusId) === t.toStatusId && Number(sourceStatusId) === t.fromStatusId || t.isGlobal && Number(targetStatusId) === t.toStatusId && targetStatusId !== sourceStatusId)[0];
const $36663632637c9aa6$export$574df82e893253f3 = ({ sourceColumnId: sourceColumnId, targetColumnId: targetColumnId, sourceIndex: sourceIndex, destinationIndex: destinationIndex, transition: transition, hasMultipleTransitions: hasMultipleTransitions, isGroupedByStatus: isGroupedByStatus, issueRankInProgress: issueRankInProgress, isTargetColumnCollapsed: isTargetColumnCollapsed })=>{
    if (issueRankInProgress) return true;
    if (isTargetColumnCollapsed && hasMultipleTransitions && isGroupedByStatus) return true;
    const isSelfTransition = transition !== undefined && transition.fromStatusId === transition.toStatusId;
    const liftAndDropOnly = sourceIndex === destinationIndex && sourceColumnId === targetColumnId && (transition === undefined || !isSelfTransition);
    if (!isGroupedByStatus) return liftAndDropOnly;
    const transitionNotSelectedButRequired = sourceColumnId !== targetColumnId && transition === undefined && hasMultipleTransitions;
    return liftAndDropOnly || transitionNotSelectedButRequired;
};
const $36663632637c9aa6$export$15f278b27a485ab9 = (targetColumn)=>({
        priorityId: targetColumn.groupKey,
        priorityIconUrl: targetColumn.imageUrl ?? undefined,
        priorityName: targetColumn.name
    });
const $36663632637c9aa6$export$9930bf2689bad0f2 = (targetColumn)=>targetColumn.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? {
        assigneeKey: undefined,
        assigneeName: undefined,
        assignee: undefined
    } : {
        assigneeKey: targetColumn.groupKey,
        assigneeName: targetColumn.name,
        assignee: targetColumn.imageUrl ? {
            avatarUrl: targetColumn.imageUrl,
            displayName: targetColumn.name
        } : undefined
    };
const $36663632637c9aa6$export$6e130a81482d8b10 = (targetColumn)=>targetColumn.groupFieldKey == null ? [] : [
        {
            type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
            name: targetColumn.groupName,
            fieldId: targetColumn.groupFieldKey,
            value: targetColumn.groupKey === (0, $ib4WI.NULL_GROUP_KEY) || targetColumn.groupKey == null ? undefined : targetColumn.groupKey,
            color: targetColumn.color
        }
    ];
const $36663632637c9aa6$var$emptyArray = [];
const $36663632637c9aa6$export$d79471cb0b12d416 = ({ targetColumn: targetColumn, sourceColumnId: sourceColumnId, targetColumnId: targetColumnId, sourceIndex: sourceIndex, destinationIndex: destinationIndex, isTargetColumnCollapsed: isTargetColumnCollapsed })=>{
    const targetColumnIssues = targetColumn?.issues ?? $36663632637c9aa6$var$emptyArray;
    let relativeIssueId = null;
    let shouldRankAfter = false;
    if (sourceColumnId === targetColumnId && targetColumnIssues.length > 1 && destinationIndex !== sourceIndex) {
        // Rank within same column
        shouldRankAfter = destinationIndex > sourceIndex;
        relativeIssueId = targetColumnIssues[destinationIndex]?.id;
    } else if (sourceColumnId !== targetColumnId && targetColumnIssues.length > 0) {
        // Rank within different columns
        if (isTargetColumnCollapsed) {
            // If the column is collapsed we should rank the card to the top
            shouldRankAfter = false;
            relativeIssueId = targetColumnIssues[0].id;
        } else {
            shouldRankAfter = targetColumnIssues[destinationIndex] === undefined;
            relativeIssueId = shouldRankAfter ? targetColumnIssues[destinationIndex - 1]?.id : targetColumnIssues[destinationIndex].id;
        }
    }
    return {
        shouldRankAfter: shouldRankAfter,
        relativeIssueId: relativeIssueId
    };
};

});


parcelRegister("4Cd42", function(module, exports) {

$parcel$export(module.exports, "matchConfettiEmoji", () => $7051014b6c55a488$export$d440163a22e74e79);
const $7051014b6c55a488$var$confettiColumnNames = [
    "\uD83C\uDF8A",
    "\uD83C\uDF89",
    "\uD83C\uDF86",
    "\uD83C\uDF87",
    "\u2728"
];
const $7051014b6c55a488$export$d440163a22e74e79 = (str)=>$7051014b6c55a488$var$confettiColumnNames.some((emoji)=>str.includes(emoji));

});

parcelRegister("a6Eha", function(module, exports) {

$parcel$export(module.exports, "useColumnMoveHandlerOld", () => $4e1ae0fe687b18e4$export$310cfaa6201c4434);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lqN6D = parcelRequire("lqN6D");

var $20OC3 = parcelRequire("20OC3");

var $4mhKq = parcelRequire("4mhKq");

var $4EaFt = parcelRequire("4EaFt");

var $iXHUp = parcelRequire("iXHUp");

var $1Hk8r = parcelRequire("1Hk8r");
const $4e1ae0fe687b18e4$export$3daa7ae3a08bb9e3 = (0, $eo17r.toFlagId)('move-column-error-flag');
const $4e1ae0fe687b18e4$export$310cfaa6201c4434 = ()=>{
    const [{ workflowName: workflowName }, { setColumns: setColumns }] = (0, $lqN6D.useBoardStore)();
    const boardColumns = (0, $4mhKq.useColumns)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const [, setColumnsOrder] = (0, $4EaFt.useColumnsOrder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const project = (0, $kQAZu.useProject)();
    const projectId = String(project.id);
    const onColumnMove = (0, $eUqFw.useCallback)(async (columnId, sourceIndex, destinationIndex)=>{
        if (sourceIndex === destinationIndex) return;
        if (workflowName != null) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'column dragged', 'board');
            const updatedColumns = [
                ...boardColumns
            ];
            const [sourceColumn] = updatedColumns.splice(sourceIndex, 1);
            updatedColumns.splice(destinationIndex, 0, sourceColumn);
            if (groupBy == null || groupBy === (0, $jGcn0.GROUP_BY_STATUS)) {
                // the columns order when grouping by status
                // is stored in the backend so we not persist that in our preferences
                // @ts-expect-error  - TS2345 - Argument of type BoardColumn[] is not assignable to parameter of type Column[] (TODO fix with BAE-23)
                setColumns(updatedColumns);
                try {
                    // @ts-expect-error  - TS2345 - Argument of type BoardColumn[] is not assignable to parameter of type Column[] (TODO fix with BAE-23)
                    await (0, $20OC3.setColumnsOld)(projectId, workflowName, updatedColumns);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // @ts-expect-error  - TS2345 - Argument of type BoardColumn[] is not assignable to parameter of type Column[] (TODO fix with BAE-23)
                    setColumns(boardColumns);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'jwmBoardControllerOnColumnMove',
                            packageName: 'jiraWorkManagementBoard',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to set column order in JWM board'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        id: $4e1ae0fe687b18e4$export$3daa7ae3a08bb9e3,
                        type: 'error',
                        title: (0, $1Hk8r.default).columnMoveErrorTitle,
                        description: (0, $1Hk8r.default).columnMoveErrorMessage
                    });
                }
            } else setColumnsOrder(updatedColumns);
        }
    }, [
        projectId,
        workflowName,
        boardColumns,
        createAnalyticsEvent,
        groupBy,
        setColumns,
        setColumnsOrder,
        showFlag
    ]);
    return {
        onColumnMove: onColumnMove
    };
};

});
parcelRegister("1Hk8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb7f5c2e1d70414f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb7f5c2e1d70414f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnMoveErrorTitle: {
        "id": "work-management-board.controllers.column-move-handler-old.column-move-error-title",
        "defaultMessage": "Failed to move column"
    },
    columnMoveErrorMessage: {
        "id": "work-management-board.controllers.column-move-handler-old.column-move-error-message",
        "defaultMessage": "We couldn't move this column, try refreshing the page or try again later."
    }
});

});


parcelRegister("fs90m", function(module, exports) {

$parcel$export(module.exports, "useIssueActionsContext", () => $89598827822f8df7$export$1da57802c7c55e02);
$parcel$export(module.exports, "default", () => $89598827822f8df7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $89598827822f8df7$var$defaultActionsContext = {
    onIssueClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueDelete: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isDeleteIssueAllowed: false
};
const $89598827822f8df7$var$IssueActionsContext = /*#__PURE__*/ (0, $eUqFw.createContext)($89598827822f8df7$var$defaultActionsContext);
const $89598827822f8df7$export$1da57802c7c55e02 = ()=>(0, $eUqFw.useContext)($89598827822f8df7$var$IssueActionsContext);
var /** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */ $89598827822f8df7$export$2e2bcd8739ae039 = $89598827822f8df7$var$IssueActionsContext;

});

parcelRegister("damhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c43152d41c1ae262$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c43152d41c1ae262$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    itemMoveErrorTitle: {
        "id": "work-management-board.board.item-move-error-title",
        "defaultMessage": "Failed to move item"
    },
    itemMoveErrorMessage: {
        "id": "work-management-board.board.item-move-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    columnMoveErrorTitle: {
        "id": "work-management-board.board.column-move-error-title",
        "defaultMessage": "Failed to move column."
    },
    columnMoveErrorMessage: {
        "id": "work-management-board.board.column-move-error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("5jiln", function(module, exports) {

$parcel$export(module.exports, "default", () => $662deebe62945888$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $662deebe62945888$var$ColumnDeleteModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("ipHsa")), {
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-delete-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$662deebe62945888$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.column-delete-modal",
        packageName: "async.jira-business.board.column-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "column-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($662deebe62945888$var$ColumnDeleteModal, props)));

});
parcelRegister("ipHsa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4NjQt');
        const value = parcelRequire('2co6T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4NjQt").then(()=>parcelRequire('2co6T'));
}

});


parcelRegister("iJHpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1f0692e4caabd1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $96etS = parcelRequire("96etS");

var $ef5z4 = parcelRequire("ef5z4");

var $1ppGa = parcelRequire("1ppGa");

var $ib4WI = parcelRequire("ib4WI");

var $11X9b = parcelRequire("11X9b");

var $iXHUp = parcelRequire("iXHUp");

var $lqN6D = parcelRequire("lqN6D");

var $dz4fU = parcelRequire("dz4fU");

var $9qIRc = parcelRequire("9qIRc");

var $fbIWF = parcelRequire("fbIWF");

var $7zJcC = parcelRequire("7zJcC");

var $kaf8x = parcelRequire("kaf8x");

var $16j6u = parcelRequire("16j6u");

var $eCs6a = parcelRequire("eCs6a");
const $5f1f0692e4caabd1$var$BoardColumn = ({ isVirtualized: isVirtualized, column: column, scrollRef: scrollRef, boardSize: boardSize, columnIndex: columnIndex, isClone: isClone, isDragging: isDragging })=>{
    const isDroppable = (0, $11X9b.useIsColumnDroppableOld)(Number(column.statusId));
    const [simpleSearch] = (0, $96etS.useSimpleSearch)();
    const [{ columnToDelete: columnToDelete, columnToDeleteHover: columnToDeleteHover }] = (0, $lqN6D.useBoardStore)();
    const [hasMultipleTransitions] = (0, $lqN6D.useHasMultipleTransitionsBetweenStatuses)();
    const checkCanCreateIssueInStatus = (0, $ef5z4.useCanCreateIssueInStatus)();
    const [siblingCreateIssueId, setSiblingCreateIssueId] = (0, $eUqFw.useState)(null);
    const [activeWorkflowDetails] = (0, $lqN6D.useActiveWorkflowDetails)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    const project = (0, $kQAZu.useProject)();
    const canAdministerProject = project.permissions.administerProject;
    const isCollapsedColumn = !!column.isCollapsed;
    const isDeletableColumn = (0, $eUqFw.useMemo)(()=>columnToDelete?.statusId === column.statusId || columnToDeleteHover?.statusId === column.statusId, [
        columnToDelete,
        column,
        columnToDeleteHover
    ]);
    const textHighlight = (0, $eUqFw.useMemo)(()=>simpleSearch != null ? [
            simpleSearch
        ] : undefined, [
        simpleSearch
    ]);
    const canCreateIssues = (0, $eUqFw.useMemo)(()=>{
        if (!project.permissions.createIssues) return false;
        if (isGroupedByStatus && !checkCanCreateIssueInStatus(String(column.statusId), activeWorkflowDetails)) return false;
        return true;
    }, [
        activeWorkflowDetails,
        checkCanCreateIssueInStatus,
        column,
        isGroupedByStatus,
        project
    ]);
    const cardRenderer = (0, $eUqFw.useCallback)(({ issue: issue, cardIndex: cardIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qIRc.default), {
            key: issue.id,
            draggableIndex: cardIndex,
            canCreateIssues: canCreateIssues,
            column: column,
            issue: issue,
            cardMenu: ({ onContentResize: onContentResize, onClosePopup: onClosePopup, onOpenPopup: onOpenPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dz4fU.default), {
                    issue: issue,
                    firstIssueId: column.issues[0].id,
                    lastIssueId: column.issues[column.issues.length - 1].id,
                    onContentResize: onContentResize,
                    onClosePopup: onClosePopup,
                    onOpenPopup: onOpenPopup
                }),
            highlight: textHighlight,
            isSiblingCreateFormOpen: siblingCreateIssueId === issue.id,
            toggleSiblingCreateForm: ()=>{
                setSiblingCreateIssueId(siblingCreateIssueId === issue.id ? null : issue.id);
            }
        }), [
        canCreateIssues,
        column,
        textHighlight,
        siblingCreateIssueId
    ]);
    const renderDraggableCard = (0, $eUqFw.useCallback)((provided, snapshot, rubric)=>{
        const issue = column.issues[rubric.source.index];
        if (!issue) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qIRc.default), {
            isDragging: snapshot.isDragging,
            key: issue.id,
            isClone: true,
            draggableIndex: rubric.source.index,
            issue: issue,
            canCreateIssues: canCreateIssues,
            cardMenu: null,
            column: column,
            isSiblingCreateFormOpen: false,
            toggleSiblingCreateForm: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }));
    }, [
        canCreateIssues,
        column
    ]);
    const isDropDisabled = (0, $eUqFw.useMemo)(()=>!isDroppable && column.groupKey !== (0, $ib4WI.NULL_GROUP_KEY) || isCollapsedColumn && hasMultipleTransitions && isGroupedByStatus, [
        column.groupKey,
        hasMultipleTransitions,
        isCollapsedColumn,
        isDroppable,
        isGroupedByStatus
    ]);
    const columnFooter = (0, $eUqFw.useMemo)(()=>canCreateIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zJcC.default), {
            column: column
        }) : null, [
        canCreateIssues,
        column
    ]);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ppGa.default), {
            id: column.id,
            isDraggable: canAdministerProject && !isClone,
            isDragging: isDragging && !isCollapsedColumn,
            isDropDisabled: isDropDisabled,
            isDone: column.isDone,
            isUpdating: column?.loading ?? false,
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbIWF.default), {
                column: column,
                isClone: isClone,
                isDeletableColumn: isDeletableColumn,
                isDropDisabled: !isDroppable
            }),
            draggableIndex: columnIndex,
            TransitionZones: (0, $16j6u.TransitionZones),
            footer: columnFooter,
            dropZoneMode: "virtual",
            // @ts-expect-error - TS2322 - Type '(provided: DraggableProvided, snapshot: DraggableStateSnapshot, rubric: DraggableRubric) => JSX.Element | null' is not assignable to type 'DraggableChildrenFn'.
            renderClone: renderDraggableCard,
            isCollapsed: isCollapsedColumn
        }, (dropProvided, snapshot, columnDroppableProps)=>// This render function will later be an entry point for virtualisation
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaf8x.CardsWrapper), {
                isDeletableColumn: isDeletableColumn,
                ref: dropProvided.innerRef,
                ...dropProvided.droppableProps,
                isDisabled: columnDroppableProps.isDropDisabled,
                isCollapsed: isCollapsedColumn
            }, scrollRef && isVirtualized !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCs6a.default), {
                scrollRef: scrollRef,
                cardRenderer: cardRenderer,
                issues: column.issues,
                boardSize: boardSize,
                footer: columnFooter,
                dndSnapshot: snapshot,
                isClone: isClone,
                isCollapsedColumn: isCollapsedColumn
            }))), [
        canAdministerProject,
        column,
        isClone,
        isDropDisabled,
        isDeletableColumn,
        isDroppable,
        columnIndex,
        columnFooter,
        renderDraggableCard,
        isCollapsedColumn,
        scrollRef,
        isVirtualized,
        cardRenderer,
        boardSize,
        isDragging
    ]);
};
var $5f1f0692e4caabd1$export$2e2bcd8739ae039 = $5f1f0692e4caabd1$var$BoardColumn;

});
parcelRegister("1ppGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $39cb69d0315a58c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kkgbD = parcelRequire("kkgbD");

var $966Wa = parcelRequire("966Wa");

var $cUOHI = parcelRequire("cUOHI");
var $aACMj = parcelRequire("aACMj");
var $hO7ri = parcelRequire("hO7ri");
var $7py1e = parcelRequire("7py1e");
var $2w3P7 = parcelRequire("2w3P7");

var $3L3sQ = parcelRequire("3L3sQ");
// eslint-disable-next-line jira/react/no-class-components
class $39cb69d0315a58c5$var$DraggableColumnOld extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDraggable: false,
            isDropDisabled: false,
            isUpdating: false,
            isCollapsed: false,
            appearance: (0, $cUOHI.ColumnTheme).Default,
            draggableIndex: null,
            footer: null,
            childrenDropZoneType: (0, $df03f3fe1f111432$export$b05303cbde3e8c8c),
            dropZoneMode: 'standard'
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    calculateStyles(styles) {
        const { scrollTop: scrollTop } = this.props.getBoardScroll();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(styles.top) && scrollTop > 0) {
            const top = styles.top + scrollTop;
            return {
                ...styles,
                top: top
            };
        }
        return styles;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderColumn(isDragging, dragHandleProps) {
        const { id: id, isDraggable: isDraggable, isDropDisabled: isDropDisabled, isOutlined: isOutlined, isUpdating: isUpdating, swimlaneId: swimlaneId, childrenDropZoneType: childrenDropZoneType, dropZoneMode: dropZoneMode, TransitionZones: TransitionZones, renderClone: renderClone, isCollapsed: isCollapsed, isFlexible: isFlexible } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3L3sQ.default), {
            id: id,
            swimlaneId: swimlaneId,
            isDraggable: isDraggable,
            isDragging: isDragging,
            isDropDisabled: isDropDisabled,
            isOutlined: isOutlined,
            isUpdating: isUpdating,
            akDragHandleProps: dragHandleProps,
            appearance: this.props.appearance,
            header: this.props.header,
            footer: this.props.footer,
            childrenDropZoneType: childrenDropZoneType,
            TransitionZones: TransitionZones,
            dropZoneMode: dropZoneMode,
            renderClone: renderClone,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible
        }, this.props.children);
    }
    render() {
        const { isDraggable: isDraggable, draggableIndex: draggableIndex, header: header, isCollapsed: isCollapsed, isFlexible: isFlexible, isDragging: isDragging } = this.props;
        if (!isDraggable || !header) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7py1e.StyledWrapper), {
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            "data-component-selector": (0, $aACMj.DRAGGABLE_COLUMN_SELECTOR_NAME),
            "data-testid": "platform-board-kit-legacy-dnd.ui.column.draggable-column.styled-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7py1e.StyledDraggableColumn), {
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            isDragging: isDragging
        }, this.renderColumn(false, {})));
        if (draggableIndex == null) throw new Error('isDraggable=true => draggableIndex prop cannot be empty');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Draggable), {
            draggableId: (0, $hO7ri.getColumnDescriptor)(this.props.id, this.props.swimlaneId),
            index: draggableIndex
        }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7py1e.StyledWrapper), {
                "data-component-selector": (0, $aACMj.DRAGGABLE_COLUMN_SELECTOR_NAME),
                "data-testid": "platform-board-kit-legacy-dnd.ui.column.draggable-column.styled-wrapper",
                innerRef: provided.innerRef,
                ...provided.draggableProps,
                isCollapsed: isCollapsed,
                isFlexible: isFlexible,
                // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: this.calculateStyles(provided.draggableProps.style)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7py1e.StyledDraggableColumn), {
                isDragging: snapshot.isDragging,
                isCollapsed: isCollapsed,
                isFlexible: isFlexible
            }, this.renderColumn(snapshot.isDragging, provided.dragHandleProps))));
    }
}
const $39cb69d0315a58c5$var$DraggableColumnMain = ({ ...props })=>{
    const [, { getBoardScroll: getBoardScroll }] = (0, $2w3P7.useBoardScrollApi)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($39cb69d0315a58c5$var$DraggableColumnOld, {
        getBoardScroll: getBoardScroll,
        ...props
    });
};
var $39cb69d0315a58c5$export$2e2bcd8739ae039 = $39cb69d0315a58c5$var$DraggableColumnMain;

});
parcelRegister("cUOHI", function(module, exports) {

$parcel$export(module.exports, "ColumnTheme", () => $c84748827e21cfa4$export$18d9d841e20106b9);
const $c84748827e21cfa4$export$18d9d841e20106b9 = {
    Default: 'default',
    Warning: 'warning',
    Danger: 'danger'
};

});

parcelRegister("7py1e", function(module, exports) {

$parcel$export(module.exports, "DraggableColumn", () => $8bd2da739696fc12$export$a80792b86712355c);
$parcel$export(module.exports, "StyledWrapper", () => $8bd2da739696fc12$export$1f99da106a398c44);
$parcel$export(module.exports, "StyledDraggableColumn", () => $8bd2da739696fc12$export$96bd54359ad61258);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $aACMj = parcelRequire("aACMj");

var $iIzf3 = parcelRequire("iIzf3");

var $cUOHI = parcelRequire("cUOHI");

var $fyzIg = parcelRequire("fyzIg");

var $1wO7Y = parcelRequire("1wO7Y");

var $1jMDQ = parcelRequire("1jMDQ");
const $8bd2da739696fc12$export$a80792b86712355c = (props)=>{
    const { id: id, isOutlined: isOutlined, swimlaneId: swimlaneId, TransitionZones: TransitionZones, isFlexible: isFlexible, isDraggable: isDraggable = false, isDropDisabled: isDropDisabled = false, isUpdating: isUpdating = false, isCollapsed: isCollapsed = false, header: header, draggableIndex: draggableIndex, appearance: appearance = (0, $cUOHI.ColumnTheme).Default, footer: footer = null, onDragLeave: onDragLeave, isCardDroppable: isCardDroppable, children: children } = props;
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const renderColumn = (isDragging)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jMDQ.default), {
            id: id,
            swimlaneId: swimlaneId,
            isDraggable: isDraggable,
            isDragging: isDragging,
            isDropDisabled: isDropDisabled,
            isOutlined: isOutlined,
            isUpdating: isUpdating,
            akDragHandleProps: {},
            appearance: appearance,
            header: header,
            footer: footer,
            TransitionZones: TransitionZones,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible
        }, children);
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $1wO7Y.useDraggableColumn)({
        isDraggable: isDraggable,
        elementRef: wrapperRef,
        columnId: id,
        swimlaneId: swimlaneId,
        columnIndex: draggableIndex,
        renderPreview: ()=>header,
        onDragLeave: onDragLeave,
        isCardDroppable: isCardDroppable
    });
    const handleOnMouseDown = ()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        window.getSelection()?.removeAllRanges();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bd2da739696fc12$export$1f99da106a398c44, {
        innerRef: wrapperRef,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible,
        "data-component-selector": (0, $aACMj.DRAGGABLE_COLUMN_SELECTOR_NAME),
        onMouseDown: handleOnMouseDown,
        "data-testid": "platform-board-kit.ui.column.draggable-column.styled-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bd2da739696fc12$export$96bd54359ad61258, {
        isCollapsed: isCollapsed,
        isFlexible: isFlexible
    }, renderColumn(false)), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyzIg.ColumnDropIndicator), {
        edge: closestEdge
    }), dragPreview);
};
const $8bd2da739696fc12$var$StyledWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1wug _v564stkc _1ul91t53 _p12f1t53",
            __cmplp.isFlexible ? "_16jlkb7n _1o9zkb7n _i0dlf1ug" : "_16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ex1 _p12f1ex1",
            __cmplp.isFlexible && "_1ul91qnl _p12f1osq",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ex1 _p12f1osq",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $8bd2da739696fc12$var$StyledWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "j176hd-0"
})`position:relative;display:flex;flex-direction:column;align-self:auto;flex:${(props)=>props.isFlexible ? '1 1' : '1 1 auto'};min-width:${(props)=>{
    if (props.isCollapsed) return 0, $iIzf3.collapsedColumnWithMarginWidth;
    if (!props.isFlexible) return `${0, $iIzf3.columnWithMarginWidth}`;
    return 0, $iIzf3.columnMinWithMarginWidth;
}}px;max-width:${(props)=>{
    if (props.isFlexible) return '100%';
    return props.isCollapsed ? `${0, $iIzf3.collapsedColumnWithMarginWidth}px` : `${0, $iIzf3.columnWithMarginWidth}px`;
}};transition:min-width 300ms,max-width 300ms ease-in;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8bd2da739696fc12$export$1f99da106a398c44 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $8bd2da739696fc12$var$StyledWrapperExperiment, $8bd2da739696fc12$var$StyledWrapperControl); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bd2da739696fc12$var$StyledDraggableColumnControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "j176hd-1"
})`border-radius:${(0, $iIzf3.layout).cardListRadius}px;display:flex;flex-direction:column;align-self:auto;contain:'style';flex:1 1 auto;margin-left:${"var(--ds-space-050, 0.25rem)"};margin-right:${"var(--ds-space-050, 0.25rem)"};min-width:${(props)=>{
    if (props.isCollapsed) return `${0, $iIzf3.collapsedColumnFixedWidth}px`;
    return props.isFlexible ? `${0, $iIzf3.columnMinWidth}px` : `${0, $iIzf3.columnFixedWidth}px`;
}};max-width:${(props)=>{
    if (props.isFlexible) return 'none';
    return `${props.isCollapsed ? (0, $iIzf3.collapsedColumnFixedWidth) : (0, $iIzf3.columnFixedWidth)}px`;
}};box-shadow:${(props)=>props.isDragging ? `var(--ds-shadow-overlay, ${`0px 8px 12px ${(0, $PdmhA).N50A}, 0 0 1px ${(0, $PdmhA).N60A}`})` : 'initial'};background-color:${(props)=>props.isCollapsed ? 'transparent' : `var(--ds-background-neutral, ${(0, $PdmhA).N20})`};transition:min-width 300ms,max-width 300ms ease-in;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bd2da739696fc12$var$StyledDraggableColumnExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoi2wt _1e0c1txw _2lx21bp4 _1wpz1wug _njlpl5mv _16jlkb7n _1o9zkb7n _i0dl1wug _18u0pdf9 _2hwxpdf9 _1ul91ogy _p12f1ogy _v564stkc",
            __cmplp.isDragging ? "_16qsuwux" : "_16qsglyw",
            __cmplp.isCollapsed ? "_bfhk18uv" : "_bfhk1s4m",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8bd2da739696fc12$export$96bd54359ad61258 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $8bd2da739696fc12$var$StyledDraggableColumnExperiment, $8bd2da739696fc12$var$StyledDraggableColumnControl);

});
parcelRegister("fyzIg", function(module, exports) {

$parcel$export(module.exports, "ColumnDropIndicator", () => $b98502af7f857ee1$export$265e69d63cbbbb15);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b98502af7f857ee1$export$265e69d63cbbbb15 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iu2gc _1bsbyh40 _1pbyqfx8 _bfhk1r2e _lcxvglyw _t9ecmdz7 _4t3i16ig _1kt9b3bt _1cs8stnw _1auk16fl _qnecj39m _kfgt1y44 _1mp41y44 _rfx31ssb _14h8oh42",
            __cmplp.edge === 'left' ? "_1ltvze3t" : "_1ltv1wug",
            __cmplp.edge === 'right' ? "_1xi2ywd4" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1wO7Y", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $017ae5e87a17df45$export$a2d73877a5476992);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ldoFd = parcelRequire("ldoFd");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $hKj4G = parcelRequire("hKj4G");

var $dkPd7 = parcelRequire("dkPd7");

var $8d4ij = parcelRequire("8d4ij");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $017ae5e87a17df45$var$ColumnDragPreviewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1ogy",
            __cmplp.className
        ])
    });
});
const $017ae5e87a17df45$var$defaultIsCardDroppable = ()=>false;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $017ae5e87a17df45$var$defaultOnDragLeave = ()=>{};
const $017ae5e87a17df45$export$a2d73877a5476992 = ({ isDraggable: isDraggable, elementRef: elementRef, columnId: columnId, swimlaneId: swimlaneId, columnIndex: columnIndex, renderPreview: renderPreview, onDragLeave: onDragLeave = $017ae5e87a17df45$var$defaultOnDragLeave, isCardDroppable: isCardDroppable = $017ae5e87a17df45$var$defaultIsCardDroppable })=>{
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    const batchSetDragState = (0, $eUqFw.useCallback)((state)=>autobatch(()=>setDragState(state)), [
        autobatch
    ]);
    const [closestEdge, setClosestEdge] = (0, $eUqFw.useState)(null);
    const batchSetClosestEdge = (0, $eUqFw.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const onDragLeaveStable = (0, $dkPd7.useEvent)(onDragLeave);
    const isCardDroppableStable = (0, $dkPd7.useEvent)(isCardDroppable);
    const { setIsOverColumn: setIsOverColumn } = (0, $8d4ij.useIsCardOverColumn)();
    (0, $eUqFw.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(columnIndex) || !elementRef.current) return undefined;
        return (0, $jFl9L.combine)(isDraggable ? (0, $eo9PV.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $df03f3fe1f111432$export$57d0ef745f304b91),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }),
            onDrop: ()=>batchSetDragState({
                    type: 'idle'
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset: ()=>({
                            x: 8,
                            y: 8
                        }),
                    render ({ container: container }) {
                        batchSetDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>batchSetDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }) : // eslint-disable-next-line @typescript-eslint/no-empty-function
        ()=>{}, (0, $eo9PV.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>(0, $fSMvP.attachClosestEdge)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: 'COLUMN',
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                }),
            canDrop: ({ source: source })=>{
                const { type: type } = source.data;
                if (type === (0, $df03f3fe1f111432$export$57d0ef745f304b91)) return true;
                if (type === (0, $df03f3fe1f111432$export$b05303cbde3e8c8c)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return isCardDroppableStable(source.data) ?? false;
                return false;
            },
            onDrag: ({ source: { data: data }, self: self, location: location })=>{
                if (data.type === (0, $df03f3fe1f111432$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $fSMvP.extractClosestEdge)(self.data));
                if (data.type === (0, $df03f3fe1f111432$export$b05303cbde3e8c8c) && location.current.dropTargets[0]?.data.type === (0, $df03f3fe1f111432$export$57d0ef745f304b91)) {
                    setIsOverColumn(true);
                    return;
                }
                setIsOverColumn(false);
            },
            onDragEnter: ({ source: { data: data }, self: self })=>{
                if (data.type === (0, $df03f3fe1f111432$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $fSMvP.extractClosestEdge)(self.data));
            },
            onDragLeave: ({ source: { data: data } })=>{
                batchSetClosestEdge(null);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDragLeaveStable(data.type);
                setIsOverColumn(false);
            },
            onDrop: ()=>{
                batchSetClosestEdge(null);
                setIsOverColumn(false);
            }
        }));
    }, [
        batchSetClosestEdge,
        batchSetDragState,
        closestEdge,
        columnId,
        columnIndex,
        elementRef,
        isCardDroppableStable,
        isDraggable,
        onDragLeaveStable,
        swimlaneId,
        setIsOverColumn
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($017ae5e87a17df45$var$ColumnDragPreviewContainer, null, renderPreview()), dragState.container) : null,
        closestEdge: closestEdge
    };
};

});
parcelRegister("8d4ij", function(module, exports) {

$parcel$export(module.exports, "useIsCardOverColumn", () => $6733188fc0bb0d07$export$4fc42d4fdca2b55c);
$parcel$export(module.exports, "ColumnEdgeContextProvider", () => $6733188fc0bb0d07$export$582bb25f0ee3befd);

var $eUqFw = parcelRequire("eUqFw");

var $hKj4G = parcelRequire("hKj4G");
const $6733188fc0bb0d07$var$ColumnEdgeContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isOverColumn: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOverColumn: ()=>{}
});
const $6733188fc0bb0d07$export$4fc42d4fdca2b55c = ()=>(0, $eUqFw.useContext)($6733188fc0bb0d07$var$ColumnEdgeContext);
const $6733188fc0bb0d07$export$582bb25f0ee3befd = ({ children: children })=>{
    const autobatch = (0, $hKj4G.useAutobatch)();
    const [isOverColumn, setIsOverColumn] = (0, $eUqFw.useState)(false);
    const batchSetIsOverColumn = (0, $eUqFw.useCallback)((edge)=>autobatch(()=>setIsOverColumn(edge)), [
        autobatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6733188fc0bb0d07$var$ColumnEdgeContext.Provider, {
        value: {
            isOverColumn: isOverColumn,
            setIsOverColumn: batchSetIsOverColumn
        }
    }, children);
};

});


parcelRegister("1jMDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ce587532c7d251$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CardDroppableTarget", () => $f1ce587532c7d251$export$d969c1f3d7d90ef3);
$parcel$export(module.exports, "Outline", () => $f1ce587532c7d251$export$5beeae30d1389e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lEfVV = parcelRequire("lEfVV");

var $kwce8 = parcelRequire("kwce8");

var $eoCgY = parcelRequire("eoCgY");

var $ldoFd = parcelRequire("ldoFd");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $iIzf3 = parcelRequire("iIzf3");

var $cUOHI = parcelRequire("cUOHI");

var $7Zjtj = parcelRequire("7Zjtj");

var $5MxUC = parcelRequire("5MxUC");

var $lxMAR = parcelRequire("lxMAR");
const $f1ce587532c7d251$var$cardListCssClass = '__board-test-hook__column';
class $f1ce587532c7d251$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDragging: false,
            isDropDisabled: false,
            isUpdating: false,
            isOutlined: false,
            isCollapsed: false,
            appearance: 'default',
            akDragHandleProps: {},
            footer: null
        };
    }
    static{
        this.contextType = (0, $lxMAR.TransitionZoneIndicatorContainerContext);
    }
    renderPortalTransitionZone() {
        const { id: id, swimlaneId: swimlaneId, TransitionZones: TransitionZones } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(TransitionZones)) return null;
        if (this.context) {
            const ref = this.context.getRef(id);
            if (ref && ref.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TransitionZones, {
                columnId: id,
                swimlaneId: swimlaneId
            }), ref.current);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TransitionZones, {
            columnId: id,
            swimlaneId: swimlaneId
        });
    }
    renderAkColumn(theme) {
        const { isDragging: isDragging, isDraggable: isDraggable, isOutlined: isOutlined, isUpdating: isUpdating, header: header, akDragHandleProps: akDragHandleProps, appearance: appearance, TransitionZones: TransitionZones, isCollapsed: isCollapsed, isFlexible: isFlexible } = this.props; // FIXME: This needs to be checked - done as part of typescript upgrade.
        // It can be more than ReactNode and typescript is not happy about this!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const children = this.props.children;
        const renderChildren = ()=>{
            // If you want to use render props this component will give you back the props and some droppable
            // context for the external component to consume
            // Example: src/packages/software/board/board-container/board/columns-container/column/view.js
            if (!false && (0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(this.props.children)) {
                // Our v-list under this column will need visibility over droppableProps
                const renderFunction = this.props.children || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null));
                return renderFunction(this.props);
            } // Fallback to generic non-virtualized implementation
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1ce587532c7d251$export$d969c1f3d7d90ef3 // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: "__board-test-hook__card-list-container"
            }, children, this.props.footer);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1ce587532c7d251$var$StyledColumnWrapper // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $f1ce587532c7d251$var$cardListCssClass,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            appearance: appearance ?? (0, $cUOHI.ColumnTheme).Default
        }, header && /*#__PURE__*/ (0, $eUqFw.cloneElement)(header, {
            isDragging: isDragging,
            isDraggable: isDraggable,
            isUpdating: isUpdating,
            akDragHandleProps: akDragHandleProps,
            appearance: appearance
        }), TransitionZones && this.renderPortalTransitionZone(), renderChildren(), isOutlined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1ce587532c7d251$export$5beeae30d1389e5, {
            withHeader: header
        }), isUpdating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MxUC.Overlay), {
            appearance: appearance ?? (0, $cUOHI.ColumnTheme).Default
        })));
    }
    render() {
        const columnTheme = this.getTheme(this.props.appearance);
        return this.renderAkColumn(columnTheme);
    }
    constructor(...args){
        super(...args);
        this.getTheme = (theme)=>{
            if (theme && (0, $7Zjtj.columnThemes)[theme]) return (0, $7Zjtj.columnThemes)[theme];
            return (0, $7Zjtj.columnThemes).default;
        };
    }
}
const $f1ce587532c7d251$var$outlineWidth = 2; // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1ce587532c7d251$var$OutlineControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ef3ied-0"
})((props)=>({
        position: 'absolute',
        width: `calc(100% - ${$f1ce587532c7d251$var$outlineWidth * 2}px)`,
        height: `calc(
${''}
        100% -${(props.withHeader ? (0, $iIzf3.columnHeaderHeight) : 0) + $f1ce587532c7d251$var$outlineWidth * 2}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iIzf3.zIndex).icc,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `${$f1ce587532c7d251$var$outlineWidth}px solid ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`,
        marginLeft: "var(--ds-space-negative-025, -2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $iIzf3.layout).cardListRadius}px`,
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: `${props.withHeader ? (0, $iIzf3.columnHeaderHeight) : 0}px`,
        left: "var(--ds-space-025, 2px)"
    }));
const $f1ce587532c7d251$var$OutlineExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withHeader: withHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xbj9jl": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${__cmplp.withHeader ? (0, $iIzf3.columnHeaderHeight) : 0}) + ${$f1ce587532c7d251$var$outlineWidth * 2}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbykb7n _19it24b2 _18u01i6y _2rko12x7 _lcxvglyw _1ltvv77o _1bsbmslj _4t3i78vx",
            __cmplp.withHeader ? "_154i1lfg" : "_154iidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f1ce587532c7d251$export$5beeae30d1389e5 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $f1ce587532c7d251$var$OutlineExperiment, $f1ce587532c7d251$var$OutlineControl); // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $f1ce587532c7d251$var$CardDroppableTargetControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ef3ied-1"
})((props)=>({
        flex: '1 0 auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $iIzf3.layout).smallGutter - (0, $c9TLT.gridSize) / 4}px ${(0, $iIzf3.layout).smallGutter}px ${(0, $iIzf3.layout).smallGutter}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${0, $iIzf3.minCardHeight}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isDisabled ? '0.5' : '1'
    }));
const $f1ce587532c7d251$var$CardDroppableTargetExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _ca0q1l7b _u5f314y2 _n3td14y2 _19bv14y2 _1tkeys9h",
            __cmplp.isDisabled ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f1ce587532c7d251$export$d969c1f3d7d90ef3 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $f1ce587532c7d251$var$CardDroppableTargetExperiment, $f1ce587532c7d251$var$CardDroppableTargetControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1ce587532c7d251$var$StyledColumnWrapperControl = /*#__PURE__*/ (0, $kwce8.default)((0, $7Zjtj.ColumnWrapperControl)).withConfig({
    componentId: "sc-1ef3ied-2"
})({
    display: 'flex',
    flexDirection: 'column'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1ce587532c7d251$var$StyledColumnWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7Zjtj.ColumnWrapperExperiment), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $f1ce587532c7d251$var$StyledColumnWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $f1ce587532c7d251$var$StyledColumnWrapperExperiment, $f1ce587532c7d251$var$StyledColumnWrapperControl);

});
parcelRegister("7Zjtj", function(module, exports) {

$parcel$export(module.exports, "columnThemes", () => $4ae01f3f6eeb8a3c$export$18626b6d0fe527f4);
$parcel$export(module.exports, "ColumnWrapperExperiment", () => $4ae01f3f6eeb8a3c$export$8dea97a945e16f7);
$parcel$export(module.exports, "ColumnWrapperControl", () => $4ae01f3f6eeb8a3c$export$9308abaf9d79120);
$parcel$export(module.exports, "ColumnWrapper", () => $4ae01f3f6eeb8a3c$export$b904459935723643);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $iIzf3 = parcelRequire("iIzf3");

var $cUOHI = parcelRequire("cUOHI");
const $4ae01f3f6eeb8a3c$export$18626b6d0fe527f4 = {
    [(0, $cUOHI.ColumnTheme).Default]: {
        background: `var(--ds-surface-sunken, ${(0, $PdmhA).N20})`,
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N40})`,
        btnHover: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N40})`,
        btnActive: `var(--ds-background-neutral-pressed, ${(0, $PdmhA).N50})`,
        btnIconHover: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        titleEditHover: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA).N20})`
    },
    [(0, $cUOHI.ColumnTheme).Warning]: {
        background: "var(--ds-background-accent-yellow-subtlest, #fff7d6)",
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).Y100})`,
        btnHover: `var(--ds-background-warning-hovered, ${(0, $PdmhA).Y75})`,
        btnActive: `var(--ds-background-warning-pressed, ${(0, $PdmhA).Y300})`,
        btnIconHover: `var(--ds-background-neutral-bold, ${(0, $PdmhA).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        titleEditHover: `var(--ds-background-warning-hovered, ${(0, $PdmhA).Y50})`
    },
    [(0, $cUOHI.ColumnTheme).Danger]: {
        background: "var(--ds-background-accent-red-subtlest, #ffedeb)",
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).Y100})`,
        btnHover: `var(--ds-background-warning-hovered, ${(0, $PdmhA).Y75})`,
        btnActive: `var(--ds-background-warning-pressed, ${(0, $PdmhA).Y300})`,
        btnIconHover: `var(--ds-background-neutral-bold, ${(0, $PdmhA).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        titleEditHover: `var(--ds-background-warning-hovered, ${(0, $PdmhA).Y50})`
    }
};
const $4ae01f3f6eeb8a3c$export$8dea97a945e16f7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vk9aov": (0, $9t7rW.default)($4ae01f3f6eeb8a3c$export$18626b6d0fe527f4[(0, $cUOHI.ColumnTheme).Default]?.background ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $4ae01f3f6eeb8a3c$export$18626b6d0fe527f4[(0, $cUOHI.ColumnTheme).Default].background : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-surface-sunken, ${(0, $PdmhA).N20})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkahx4 _2rkoi2wt _kqswh2mm _1wpz1fhb _16jlkb7n _1o9zkb7n _i0dl1wug _v5643711 _1ul91ogy _p12f1ogy",
            __cmplp.isCollapsed && "_bfhk18uv _1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
});
const $4ae01f3f6eeb8a3c$export$9308abaf9d79120 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "pfibim-0"
})`background-color:${(props)=>{
    if (props.isCollapsed) return 'transparent';
    return $4ae01f3f6eeb8a3c$export$18626b6d0fe527f4[(0, $cUOHI.ColumnTheme).Default].background;
}};border-radius:${(0, $iIzf3.layout).cardListRadius}px;position:relative;align-self:stretch;flex:1 1 auto;transition:opacity 0.2s,min-width 300ms,max-width 300ms ease-in;min-width:${(props)=>{
    if (props.isCollapsed) return `${0, $iIzf3.collapsedColumnFixedWidth}px`;
    return props.isFlexible ? `${0, $iIzf3.columnMinWidth}px` : `${0, $iIzf3.columnFixedWidth}px`;
}};max-width:${(props)=>{
    if (props.isFlexible) return 'none';
    return props.isCollapsed ? `${0, $iIzf3.collapsedColumnFixedWidth}px` : `${0, $iIzf3.columnFixedWidth}px`;
}};`;
const $4ae01f3f6eeb8a3c$export$b904459935723643 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $4ae01f3f6eeb8a3c$export$8dea97a945e16f7, $4ae01f3f6eeb8a3c$export$9308abaf9d79120);

});

parcelRegister("5MxUC", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $ce07728d17c0ad38$export$c6fdb837b070b4ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $bKxX9 = parcelRequire("bKxX9");

var $7Zjtj = parcelRequire("7Zjtj");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $ce07728d17c0ad38$var$OverlayControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ehg2v8-0"
})((props)=>({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.theme.background,
        opacity: 0.5
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce07728d17c0ad38$var$OverlayExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12nboa5": (0, $9t7rW.default)((0, $7Zjtj.columnThemes)[__cmplp.appearance].background)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _tzy4105o",
            __cmplp.appearance ? "_bfhkqo2f" : "_bfhk73ad",
            __cmplp.className
        ])
    });
});
const $ce07728d17c0ad38$export$c6fdb837b070b4ff = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $bKxX9.ff)('compiled.migration.jsw.tanuki'), $ce07728d17c0ad38$var$OverlayExperiment, $ce07728d17c0ad38$var$OverlayControl);

});



parcelRegister("3L3sQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86a5bf327eaa879$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kwce8 = parcelRequire("kwce8");

var $eoCgY = parcelRequire("eoCgY");

var $ldoFd = parcelRequire("ldoFd");

var $966Wa = parcelRequire("966Wa");

var $cUOHI = parcelRequire("cUOHI");
var $7Zjtj = parcelRequire("7Zjtj");
var $hO7ri = parcelRequire("hO7ri");
var $lxMAR = parcelRequire("lxMAR");

var $7Zjtj = parcelRequire("7Zjtj");

var $5MxUC = parcelRequire("5MxUC");

var $1jMDQ = parcelRequire("1jMDQ");
const $e86a5bf327eaa879$var$cardListCssClass = '__board-test-hook__column';
class $e86a5bf327eaa879$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDragging: false,
            isDropDisabled: false,
            isUpdating: false,
            isOutlined: false,
            isCollapsed: false,
            appearance: 'default',
            akDragHandleProps: {},
            footer: null,
            childrenDropZoneType: (0, $df03f3fe1f111432$export$b05303cbde3e8c8c),
            dropZoneMode: 'standard',
            renderClone: undefined // Yes, this must be undefined. If we noop/null here, the DnD will break
        };
    }
    static{
        this.contextType = (0, $lxMAR.TransitionZoneIndicatorContainerContext);
    }
    renderPortalTransitionZone() {
        const { id: id, swimlaneId: swimlaneId, TransitionZones: TransitionZones } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(TransitionZones)) return null;
        if (this.context) {
            const ref = this.context.getRef(id);
            if (ref && ref.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TransitionZones, {
                columnId: id,
                swimlaneId: swimlaneId
            }), ref.current);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TransitionZones, {
            columnId: id,
            swimlaneId: swimlaneId
        });
    }
    renderAkColumn(theme) {
        const { id: id, isDragging: isDragging, isDraggable: isDraggable, isDropDisabled: isDropDisabled, isOutlined: isOutlined, isUpdating: isUpdating, header: header, swimlaneId: swimlaneId, akDragHandleProps: akDragHandleProps, appearance: appearance, childrenDropZoneType: childrenDropZoneType, dropZoneMode: dropZoneMode, TransitionZones: TransitionZones, renderClone: renderClone, isCollapsed: isCollapsed, isFlexible: isFlexible } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e86a5bf327eaa879$var$StyledColumnWrapper, {
            // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $e86a5bf327eaa879$var$cardListCssClass,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            appearance: appearance ?? (0, $cUOHI.ColumnTheme).Default
        }, header && /*#__PURE__*/ (0, $eUqFw.cloneElement)(header, {
            isDragging: isDragging,
            isDraggable: isDraggable,
            isUpdating: isUpdating,
            akDragHandleProps: akDragHandleProps,
            appearance: appearance
        }), TransitionZones && this.renderPortalTransitionZone(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Droppable), {
            droppableId: (0, $hO7ri.getColumnDescriptor)(id, swimlaneId),
            type: childrenDropZoneType,
            mode: dropZoneMode,
            isDropDisabled: isDropDisabled,
            renderClone: renderClone
        }, (dropProvided, snapshot)=>{
            // If you want to use render props this component will give you back the props and some droppable
            // context for the external component to consume
            // Example: src/packages/software/board/board-container/board/columns-container/column/view.js
            if (!false && (0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(this.props.children)) {
                // Our v-list under this column will need visibility over droppableProps
                const renderFunction = this.props.children || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null));
                return renderFunction(dropProvided, snapshot, this.props);
            }
            // FIXME: This needs to be checked - done as part of typescript upgrade.
            // It can be more than ReactNode and typescript is not happy about this!
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const children = this.props.children;
            // Fallback to generic non-virtualized implementation
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jMDQ.CardDroppableTarget), {
                innerRef: dropProvided.innerRef,
                ...dropProvided.droppableProps,
                isDisabled: isDropDisabled,
                // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "__board-test-hook__card-list-container"
            }, children, dropProvided.placeholder, this.props.footer);
        }), isOutlined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jMDQ.Outline), {
            withHeader: header
        }), isUpdating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MxUC.Overlay), null)));
    }
    render() {
        const columnTheme = this.getTheme(this.props.appearance);
        return this.renderAkColumn(columnTheme);
    }
    constructor(...args){
        super(...args);
        this.getTheme = (theme)=>{
            if (theme && (0, $7Zjtj.columnThemes)[theme]) return (0, $7Zjtj.columnThemes)[theme];
            return (0, $7Zjtj.columnThemes).default;
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e86a5bf327eaa879$var$StyledColumnWrapper = /*#__PURE__*/ (0, $kwce8.default)((0, $7Zjtj.ColumnWrapper)).withConfig({
    componentId: "t0np7e-0"
})({
    display: 'flex',
    flexDirection: 'column'
});

});


parcelRegister("11X9b", function(module, exports) {

$parcel$export(module.exports, "useIsColumnDroppableOld", () => $18b0460d1c1056d2$export$84bba198598ab783);

var $eUqFw = parcelRequire("eUqFw");

var $lqN6D = parcelRequire("lqN6D");

var $iXHUp = parcelRequire("iXHUp");
const $18b0460d1c1056d2$export$84bba198598ab783 = (statusId)=>{
    const [{ transitions: transitions, cardDragState: cardDragState, issueFields: issueFields }] = (0, $lqN6D.useBoardStore)();
    const { issue: issue } = cardDragState;
    const groupByField = (0, $iXHUp.useGroupByFieldOld)();
    return (0, $eUqFw.useMemo)(()=>{
        // There's no drag in place, hence no need to disable columns
        const isDroppable = issue == null || // The card status and column status is the same, card in drag is in this column
        issue.statusId === statusId || transitions.some((transition)=>// There's a global transition to this column and this column is not the source column
            transition.isGlobal && transition.toStatusId === statusId && transition.fromStatusId !== statusId || // There's a transition from source column to this column
            statusId === transition.toStatusId && issue.statusId === transition.fromStatusId);
        if (issue != null && groupByField != null) {
            const field = issueFields?.[groupByField];
            const { issueTypeId: issueTypeId } = issue;
            if (field == null || issueTypeId == null) return isDroppable;
            return field.issueTypes?.includes(issueTypeId);
        }
        return isDroppable;
    }, [
        groupByField,
        issue,
        issueFields,
        statusId,
        transitions
    ]);
};

});

parcelRegister("dz4fU", function(module, exports) {

$parcel$export(module.exports, "default", () => $de90e016396aaaca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $de90e016396aaaca$var$LazyCardActionsMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("9CL9C")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-old/card-actions/main.tsx"
});
const $de90e016396aaaca$var$AsyncCardActionsMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "card-actions-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de90e016396aaaca$var$LazyCardActionsMenu, props));
var $de90e016396aaaca$export$2e2bcd8739ae039 = $de90e016396aaaca$var$AsyncCardActionsMenu;

});
parcelRegister("9CL9C", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('f1eHA')
        ]);
        const value = parcelRequire('1ViKT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("f1eHA")
    ]).then(()=>parcelRequire('1ViKT'));
}

});


parcelRegister("9qIRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cfec569a12cf9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $966Wa = parcelRequire("966Wa");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $3MV1G = parcelRequire("3MV1G");
parcelRequire("aZGbv");
var $i0nxo = parcelRequire("i0nxo");
var $4TJj0 = parcelRequire("4TJj0");

var $j8Htg = parcelRequire("j8Htg");
var $fyk0U = parcelRequire("fyk0U");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $d3C6e = parcelRequire("d3C6e");

var $hYeSy = parcelRequire("hYeSy");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kgzZq = parcelRequire("kgzZq");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jRisP = parcelRequire("jRisP");

var $2b5eO = parcelRequire("2b5eO");

var $bZapc = parcelRequire("bZapc");

var $fs90m = parcelRequire("fs90m");

var $gsqym = parcelRequire("gsqym");

var $ivgK3 = parcelRequire("ivgK3");

var $cPLNB = parcelRequire("cPLNB");

var $ghGL5 = parcelRequire("ghGL5");

var $2rU1q = parcelRequire("2rU1q");
const $f7cfec569a12cf9a$var$stopPropagation = (event)=>event.stopPropagation();
const $f7cfec569a12cf9a$var$returnNull = ()=>null;
const $f7cfec569a12cf9a$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $eUqFw.memo)(({ cardMenu: cardMenu, column: column, canCreateIssues: canCreateIssues, draggableIndex: draggableIndex, highlight: highlight, isClone: isClone, isDragging: isDragging = false, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm, selections: selections })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { issueViewInteraction: issueViewInteraction } = (0, $2b5eO.useJWMBoardFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isCardCoversEditorEnabled = (0, $eI5EY.fg)('card_covers_editor');
    const [userTraits, { setUserTraits: setUserTraits }] = isCardCoversEditorEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fyk0U.useUserTraits)() : [
        null,
        {
            setUserTraits: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }
    ]; // eslint-disable-next-line react-hooks/rules-of-hooks
    const fetchUserTraits = isCardCoversEditorEnabled ? (0, $fyk0U.useFetchUserTraitsOld)() : $f7cfec569a12cf9a$var$returnNull;
    const shouldUseEmbedIssueClick = issueViewInteraction === 'openNewTab';
    const getIsHighlighted = (0, $d3C6e.useIsHighlighted)();
    const { openPopupRef: openPopupRef, setOpenPopupRef: setOpenPopupRef } = (0, $eUqFw.useContext)((0, $jRisP.ActionsMenuPopupContext)); // Keeps track of current popup
    const popupRef = (0, $eUqFw.useRef)(null);
    const onEmbedIssueOpen = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issue.key
        });
    }, [
        createAnalyticsEvent,
        issue
    ]);
    const { onIssueClick: onIssueClick } = (0, $fs90m.useIssueActionsContext)();
    const clickHandler = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation(); // best practice to use for react-beautiful-dnd (https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-use-dom-events.md)
        if (e.defaultPrevented !== true) {
            const withCmd = e.ctrlKey || e.metaKey;
            onIssueClick(issue, withCmd);
        }
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardIssue');
    }, [
        onIssueClick,
        issue,
        createAnalyticsEvent
    ]);
    const issueKeyClickHandler = (0, $eUqFw.useCallback)(()=>{
        onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue
    ]);
    let prefetchIssue = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)());
     // Reduce rendered elements by only rendering actions menu on hover
    const [shouldRenderMenu, setShouldRenderMenu] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const shouldPersistActionsMenu = isOpen && openPopupRef === popupRef;
    const menuButtonRef = (0, $eUqFw.useRef)(null);
    const hideMenuButton = (0, $eUqFw.useCallback)((e)=>{
        // If the next element to receive focus is the menu button
        // don't hide the button
        if (menuButtonRef.current === e.relatedTarget) return;
        setShouldRenderMenu(false);
    }, [
        setShouldRenderMenu
    ]);
    const showMenuButton = (0, $eUqFw.useCallback)(()=>{
        setShouldRenderMenu(true);
        if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) prefetchIssue(issue.key);
    }, [
        issue.key,
        prefetchIssue
    ]);
    const toggleMenu = (0, $eUqFw.useCallback)((e)=>{
        $f7cfec569a12cf9a$var$stopPropagation(e); // Close the already opened popup if it's not the current one
        if (isOpen && openPopupRef !== popupRef) setIsOpen(false);
         // Update the opened popup ref to the current one if it's not already set
        if (openPopupRef !== popupRef) setOpenPopupRef(popupRef);
        setIsOpen((open)=>!open);
    }, [
        isOpen,
        openPopupRef,
        setOpenPopupRef
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' && event.target === event.currentTarget) shouldUseEmbedIssueClick ? onEmbedIssueOpen() : onIssueClick(issue, false);
    }, [
        onIssueClick,
        issue,
        onEmbedIssueOpen,
        shouldUseEmbedIssueClick
    ]);
    const isNewOptimisticIssue = (0, $eUqFw.useMemo)(()=>issue.key === '' || issue.key == null, [
        issue.key
    ]);
    const shouldRenderMenuOnCard = (0, $eUqFw.useMemo)(()=>!isNewOptimisticIssue && shouldRenderMenu, [
        isNewOptimisticIssue,
        shouldRenderMenu
    ]);
    const onClosePopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const onOpenPopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const popupContent = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$MenuContainer, {
            onClick: toggleMenu
        }, cardMenu && cardMenu({
            onContentResize: update,
            onClosePopup: onClosePopup,
            onOpenPopup: onOpenPopup
        })), [
        cardMenu,
        onClosePopup,
        onOpenPopup,
        toggleMenu
    ]);
    const setUserTraitsIfNotAvailable = (0, $eUqFw.useCallback)(async ()=>{
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        userTraits,
        fetchUserTraits,
        setUserTraits
    ]);
    const draggableContentRenderer = (0, $eUqFw.useCallback)((provided = {})=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$CardContentContainer, {
            ref: popupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$CardSummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgzZq.CardSummary), {
            text: issue.summary,
            shouldMenuRender: true,
            highlight: highlight
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: shouldPersistActionsMenu,
            onClose: ()=>setIsOpen(false),
            content: popupContent,
            placement: "right-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    ...triggerProps,
                    "data-testid": "work-management-board.ui.board-old.column-old.card-old.actions-section" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ,
                    style: $f7cfec569a12cf9a$var$triggerStyle,
                    onMouseOver: setUserTraitsIfNotAvailable,
                    onFocus: setUserTraitsIfNotAvailable
                }, (shouldRenderMenuOnCard || shouldPersistActionsMenu) && (issue.issueDetails?.coverMedia ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$CardMenuButtonWithCover, {
                    ref: menuButtonRef,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                        label: formatMessage((0, $2rU1q.default).cardActions)
                    }),
                    onClick: toggleMenu
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ref: menuButtonRef,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                        label: formatMessage((0, $2rU1q.default).cardActions)
                    }),
                    onClick: toggleMenu
                })))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivgK3.CardContent), {
            highlight: highlight,
            issue: issue,
            onIssueKeyClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : issueKeyClickHandler
        }));
        const contentWithBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsqym.CardBadge), {
            selections: selections,
            position: draggableIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3)
        }, content);
        const isHighlighted = getIsHighlighted(issue.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$CardContainer, {
            isDragging: isDragging,
            ref: (ref)=>{
                // @ts-expect-error - TS2339 - Property 'innerRef' does not exist on type '{}'. | TS2339 - Property 'innerRef'
                provided.innerRef && provided.innerRef(ref);
            },
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler,
            onMouseEnter: showMenuButton,
            onMouseLeave: hideMenuButton,
            onFocus: showMenuButton,
            onBlur: hideMenuButton,
            "data-testid": "work-management-board.ui.board-old.column-old.card-old.container",
            onKeyDown: handleKeyDown
        }, issue.issueDetails?.coverMedia && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$CardCoverWrapper, {
            coverMedia: issue.issueDetails.coverMedia
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$var$HighlightContainer, {
            isDraggingAllowed: !isNewOptimisticIssue,
            isHighlighted: isHighlighted
        }, selections ? contentWithBadge : content));
    }, [
        clickHandler,
        draggableIndex,
        formatMessage,
        getIsHighlighted,
        handleKeyDown,
        hideMenuButton,
        highlight,
        isDragging,
        isNewOptimisticIssue,
        issue,
        issueKeyClickHandler,
        onEmbedIssueOpen,
        popupContent,
        selections,
        shouldPersistActionsMenu,
        shouldRenderMenuOnCard,
        shouldUseEmbedIssueClick,
        showMenuButton,
        toggleMenu,
        setUserTraitsIfNotAvailable
    ]);
    if (isClone === true) return draggableContentRenderer();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Draggable), {
        draggableId: `ISSUE::${issue.id}`,
        index: draggableIndex,
        isDragDisabled: isNewOptimisticIssue
    }, draggableContentRenderer), canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghGL5.default), {
        column: column,
        isSiblingCreateFormOpen: isSiblingCreateFormOpen,
        issueId: issue.id,
        toggleSiblingCreateForm: toggleSiblingCreateForm
    }));
});
const $f7cfec569a12cf9a$var$CardCoverWrapper = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    const selectedFields = (0, $bZapc.useSelectedFields)();
    const showCardCovers = selectedFields[0, $jGcn0.CARD_COVERS_TYPE];
    return showCardCovers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPLNB.CardCover), {
        coverMedia: coverMedia
    });
});
const $f7cfec569a12cf9a$var$CardWithSelection = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const nodeId = (0, $i0nxo.getPresenceNodeId)({
        projectId: projectId,
        viewId: 'board',
        nodeId: `${props.issue.id}`
    });
    const [{ nodeSelection: nodeSelection }] = (0, $4TJj0.useCollabStore)();
    const selections = nodeSelection[nodeId]; // card could have multiple selections from different users
    const cardSelections = Array.isArray(selections) && selections.length ? selections : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7cfec569a12cf9a$export$60332b2344f7fe41, {
        ...props,
        selections: cardSelections
    });
});
var $f7cfec569a12cf9a$export$2e2bcd8739ae039 = $f7cfec569a12cf9a$var$CardWithSelection;
const $f7cfec569a12cf9a$var$MAX_CARD_WIDTH = 270;
const $f7cfec569a12cf9a$var$ACTION_MENU_BUTTON_SIZE = 32;
const $f7cfec569a12cf9a$var$triggerStyle = {
    position: 'absolute',
    top: "var(--ds-space-100, 8px)",
    right: "var(--ds-space-100, 8px)"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$CardMenuButtonWithCover = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk14n2 _1h7hkb7n _jomr1yxr _16l4kb7n _irr31bam",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$MenuContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1f1xx0ol _1pc8x0ol",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1ogy _uiztglyw _vchhusvi _kqswh2mm _2rko1sit _syaz1fxt _irr3k6hx",
            __cmplp.isDragging ? "_80om5szm" : "_80omtlke",
            __cmplp.isDragging ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf" : "_19pk1y44 _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.isDragging ? "_16qsuwux" : "_16qs1os1",
            __cmplp.isDragging ? "_bfhk1bhr" : "_bfhkhp5a",
            __cmplp.isDragging ? "_139ek9zm" : "_139eidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$CardContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4utpp _vchhusvi _1e0c1txw _2lx2vrvc _1n261g80 _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$CardSummaryWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1tkezwfg _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7cfec569a12cf9a$var$HighlightContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHighlighted: isHighlighted, isDraggingAllowed: isDraggingAllowed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_v564d6db",
            __cmplp.isHighlighted ? "_bfhk1cey" : "_bfhk18uv",
            __cmplp.isDraggingAllowed ? "_80om1kw7" : "_80om13gf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gsqym", function(module, exports) {

$parcel$export(module.exports, "CardBadge", () => $5df11082f2caf7d6$export$bc1a48e1b7ed7af);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $aZGbv = parcelRequire("aZGbv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jNk4i = parcelRequire("jNk4i");
const $5df11082f2caf7d6$export$bc1a48e1b7ed7af = ({ selections: selections, children: children, position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!selections) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const cardSelection = selections[0];
    const tooltipContent = selections.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: user.name
        }, user.name))) : null;
    const otherSelectionsContent = selections.length > 1 ? formatMessage((0, $jNk4i.default).moreSelections, {
        count: selections.length - 1
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.NodeSelectionWrapper), {
        color: cardSelection.color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.ParticipantBadge), {
        color: cardSelection.color,
        position: position
    }, cardSelection.user.name, otherSelectionsContent), children));
};

});

parcelRegister("ivgK3", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $896a510262ecdd09$export$64ef9b8c11710c47);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gjzML = parcelRequire("gjzML");

var $jGcn0 = parcelRequire("jGcn0");

var $3ySoA = parcelRequire("3ySoA");

var $daiHs = parcelRequire("daiHs");
var $4wx7G = parcelRequire("4wx7G");
var $huZle = parcelRequire("huZle");
var $byrHc = parcelRequire("byrHc");
var $2kYPS = parcelRequire("2kYPS");
var $dq5k9 = parcelRequire("dq5k9");
var $jkZ7i = parcelRequire("jkZ7i");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7sX12 = parcelRequire("7sX12");

var $bZapc = parcelRequire("bZapc");

var $iXHUp = parcelRequire("iXHUp");

var $b5x4f = parcelRequire("b5x4f");

var $5iwuh = parcelRequire("5iwuh");
const $896a510262ecdd09$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $eUqFw.memo)(({ highlight: highlight, isHovered: isHovered, issue: issue, onIssueKeyClick: onIssueKeyClick })=>{
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const selectedFields = (0, $bZapc.useCardFieldsOld)(issue.issueTypeId);
    const { toggleSubtasks: toggleSubtasks } = (0, $7sX12.useCardSubtasks)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isNewOptimisticIssue = (0, $eUqFw.useMemo)(()=>issue.key === '' || issue.key == null, [
        issue.key
    ]);
    const labels = (0, $eUqFw.useMemo)(()=>{
        if (issue.issueDetails?.fieldsByAlias?.label != null) return issue.issueDetails?.fieldsByAlias?.label.value;
        return undefined;
    }, [
        issue.issueDetails
    ]);
    const renderedLabels = (0, $eUqFw.useMemo)(()=>labels && selectedFields.labels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huZle.CardLabels), {
            labels: labels,
            highlight: highlight
        })) : null, [
        selectedFields.labels,
        labels,
        highlight
    ]);
    const renderedDueDate = (0, $eUqFw.useMemo)(()=>issue.dueDate != null && selectedFields.duedate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daiHs.CardDueDate), {
            dueDate: issue.dueDate,
            isCompleted: issue.isDone
        })) : null, [
        issue.dueDate,
        issue.isDone,
        selectedFields.duedate
    ]);
    const renderedIssueType = (0, $eUqFw.useMemo)(()=>issue.typeUrl != null && issue.typeName != null && selectedFields.issuetype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$IssueTypeIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkZ7i.CardType), {
            uri: issue.typeUrl,
            text: issue.typeName
        })) : null, [
        issue.typeUrl,
        issue.typeName,
        selectedFields.issuetype
    ]);
    const handleSubtaskClick = (0, $eUqFw.useCallback)((event)=>{
        // stop bento from opening
        event.preventDefault();
        event.stopPropagation();
        toggleSubtasks(issue.id);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardCardSubtaskTrigger', {
            isExpanded: issue.subtasks != null
        });
    }, [
        toggleSubtasks,
        createAnalyticsEvent,
        issue.id,
        issue.subtasks
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') toggleSubtasks(issue.id);
    }, [
        issue.id,
        toggleSubtasks
    ]);
    const renderedSubtaskMetadata = (0, $eUqFw.useMemo)(()=>{
        if (issue.subtaskMetadata?.total && selectedFields.subtasks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$SingleFieldRow, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "work-management-board.ui.board.column.card.card-content.subtask-container",
            onClick: handleSubtaskClick,
            tabIndex: 0,
            onKeyPress: handleKeyDown,
            role: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iwuh.CardSubtasks), {
            subtaskMetadata: issue.subtaskMetadata,
            withSubtasks: issue.subtasks != null
        }));
        return null;
    }, [
        issue.subtaskMetadata,
        issue.subtasks,
        selectedFields.subtasks,
        handleSubtaskClick,
        handleKeyDown
    ]);
    const renderedPriority = (0, $eUqFw.useMemo)(()=>issue.priority && selectedFields.priority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byrHc.CardPriority), {
            uri: issue.priority.iconUrl,
            name: issue.priority.name
        }) : null, [
        selectedFields.priority,
        issue.priority
    ]);
    const renderedAssignee = (0, $eUqFw.useMemo)(()=>{
        if (issue.assignee?.id && selectedFields.assignee) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
            highlight: highlight,
            avatarUrl: issue.assignee?.avatarUrl ?? '',
            name: issue.assignee?.displayName ?? ''
        });
        return null;
    }, [
        selectedFields.assignee,
        issue.assignee,
        highlight
    ]);
    const renderedKey = (0, $eUqFw.useMemo)(()=>selectedFields.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wx7G.CardKey), {
            highlight: highlight,
            onClick: onIssueKeyClick,
            text: issue.key
        }), [
        selectedFields.key,
        issue.key,
        highlight,
        onIssueKeyClick
    ]);
    const renderedStatus = (0, $eUqFw.useMemo)(()=>groupBy !== (0, $jGcn0.GROUP_BY_STATUS) && issue.statusCategory && issue.statusName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$SingleFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
            name: issue.statusName,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            category: issue.statusCategory
        })), [
        groupBy,
        issue.statusCategory,
        issue.statusName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderedStatus, renderedLabels, renderedDueDate, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$MultiFieldRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$LeftContentContainer, null, renderedIssueType, renderedKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$FlowContentContainer, null, issue.isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dq5k9.CardTick), null), renderedPriority, renderedAssignee)), renderedSubtaskMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5x4f.default), {
        issue: issue,
        isHovered: isHovered
    }), isNewOptimisticIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($896a510262ecdd09$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2kYPS.CardSpinner), null)));
});
const $896a510262ecdd09$var$maxCardWidth = 270;
const $896a510262ecdd09$var$menuActionButtonSize = 32;
const $896a510262ecdd09$var$flowContentContainerStyles = {
    display: 'flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    '& > div': {
        padding: `0 ${"var(--ds-space-050, 4px)"}`
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $896a510262ecdd09$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ipxbi _1xi2pxbi",
            __cmplp.className
        ])
    });
});
const $896a510262ecdd09$var$MultiFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1ogy _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $896a510262ecdd09$var$LeftContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4swc3 _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1c30otz2",
            __cmplp.className
        ])
    });
});
const $896a510262ecdd09$var$SingleFieldRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9p7wg _ca0q1b66 _n3td1b66 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $896a510262ecdd09$var$FlowContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4swc3 _1c30otz2",
            __cmplp.className
        ])
    });
});
const $896a510262ecdd09$var$IssueTypeIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b5x4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa6d0084c4c53a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aa6d0084c4c53a91$var$LazyCardDetailFields = (0, $7rh0R.lazy)(()=>(parcelRequire("cwYL2")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-old/card-old/card-content/card-detail-fields/main.tsx"
});
const $aa6d0084c4c53a91$var$AsyncCardDetailFields = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "card-detail-fields",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa6d0084c4c53a91$var$LazyCardDetailFields, props));
var $aa6d0084c4c53a91$export$2e2bcd8739ae039 = $aa6d0084c4c53a91$var$AsyncCardDetailFields;

});
parcelRegister("cwYL2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9NxDT');
        const value = parcelRequire('2EFYM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9NxDT").then(()=>parcelRequire('2EFYM'));
}

});


parcelRegister("5iwuh", function(module, exports) {

$parcel$export(module.exports, "CardSubtasks", () => $2e0f759b167cef8e$export$f8f16b567b205e73);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dtaN9 = parcelRequire("dtaN9");

var $eyI8O = parcelRequire("eyI8O");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $il7oX = parcelRequire("il7oX");
const $2e0f759b167cef8e$export$f8f16b567b205e73 = /*#__PURE__*/ (0, $eUqFw.memo)(({ subtaskMetadata: subtaskMetadata, withSubtasks: withSubtasks })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!subtaskMetadata?.total) return null;
    const tooltipContent = formatMessage(withSubtasks ? (0, $il7oX.default).hideSubtasksTooltip : (0, $il7oX.default).showSubtasksTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e0f759b167cef8e$var$SubtaskContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e0f759b167cef8e$var$SubtaskIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
        size: "small",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e0f759b167cef8e$var$SubtaskDoneArea, null, subtaskMetadata.done, "/", subtaskMetadata.total), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e0f759b167cef8e$var$SubtaskExpandCollapse, {
        withSubtasks: !!withSubtasks,
        "data-testid": "work-management-board.ui.board.column.card.card-content.card-subtasks.subtask-expand-collapse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: tooltipContent
    }))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e0f759b167cef8e$var$SubtaskIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $2e0f759b167cef8e$var$SubtaskContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _11q7iw92 _syaz1o15 _1yt418iy _2rko1l7b _80omtlke",
            __cmplp.className
        ])
    });
});
const $2e0f759b167cef8e$var$SubtaskDoneArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $2e0f759b167cef8e$var$SubtaskExpandCollapse = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSubtasks: withSubtasks, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _otyr14id _19pk1i6y _1e0c1o8l _v5644a6k",
            __cmplp.withSubtasks ? "_t9ec14w8" : "_t9ec160w",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cPLNB", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $126af045f9382de5$export$1a2d6d8c98d2c941);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $ifH0n = parcelRequire("ifH0n");

var $bOA3Q = parcelRequire("bOA3Q");

var $aeIT6 = parcelRequire("aeIT6");

var $ib4WI = parcelRequire("ib4WI");

var $57bD3 = parcelRequire("57bD3");
const $126af045f9382de5$var$CARD_COVER_COLOR_HEIGHT = 24;
const $126af045f9382de5$var$CARD_COVER_IMAGE_HEIGHT = 200;
const $126af045f9382de5$export$1a2d6d8c98d2c941 = /*#__PURE__*/ (0, $eUqFw.memo)(({ coverMedia: coverMedia })=>{
    if (!coverMedia) return null;
    if (coverMedia.__typename === 'JiraWorkManagementColorBackground') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const theme = (0, $bOA3Q.themeManager).getColor(coverMedia.colorValue)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126af045f9382de5$var$CardColorCoverContainer, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-color",
            backgroundColor: theme.light['color.elevation.surface']
        });
    }
    if (coverMedia.__typename === 'JiraWorkManagementGradientBackground') {
        const theme = (0, $bOA3Q.themeManager).getGradient(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        coverMedia.gradientValue)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126af045f9382de5$var$CardGradientCoverContainer, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-gradient",
            background: theme.light['elevation.surface']
        });
    }
    if (coverMedia.__typename === 'JiraWorkManagementAttachmentBackground') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126af045f9382de5$var$CardImageCover, {
        coverMedia: coverMedia
    });
    return null;
});
const $126af045f9382de5$var$CardImageCover = ({ coverMedia: coverMedia })=>{
    const media = (0, $aeIT6.useMediaConfiguration)();
    const [height, setHeight] = (0, $eUqFw.useState)($126af045f9382de5$var$CARD_COVER_IMAGE_HEIGHT);
    const imageRef = (0, $eUqFw.useRef)(null);
    const { onBoardCardResize: onBoardCardResize } = (0, $57bD3.useBoardVirtualization)();
    const imgUrl = (0, $eUqFw.useMemo)(()=>{
        if (!media?.clientId || !media?.externalEndpointUrl || !coverMedia?.attachment?.mediaApiFileId || !coverMedia?.attachment?.mediaReadToken) return null;
        return (0, $bOA3Q.generateMediaImageUrl)({
            mediaApiFileId: coverMedia.attachment.mediaApiFileId,
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            token: coverMedia.attachment.mediaReadToken,
            mediaEndpoint: 'image',
            // A card is really 260px wide, but we want to load the image at a higher resolution
            // and then scale it down to avoid blurry images. If you use 260px, there will be a gap
            // between the image and the card border.
            width: (0, $ib4WI.COLUMN_FIXED_WIDTH),
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        coverMedia?.attachment?.mediaApiFileId,
        coverMedia?.attachment?.mediaReadToken,
        media?.clientId,
        media?.externalEndpointUrl
    ]);
    /**
   * Because we don't have the image dimensions until the image is loaded, we need to
   * load the image and get the natural height to set the height of the image container.
   */ (0, $eUqFw.useEffect)(()=>{
        if (!imgUrl) return;
        const img = new Image();
        img.onload = ()=>{
            setHeight(img.naturalHeight);
        };
        img.src = imgUrl;
    }, [
        imgUrl,
        setHeight
    ]);
    const unsplashAttachment = coverMedia.attachment?.__typename === 'JiraPlatformAttachment' ? coverMedia.attachment : null;
    /**
   * Give attribution to the unsplash api for qualified images.
   * This is needed for legal reasons to comply with their API terms of service.
   */ (0, $eUqFw.useEffect)(()=>{
        if (!imgUrl) return;
        if (unsplashAttachment?.sourceType === 'UNSPLASH' && unsplashAttachment?.sourceIdentifier && imageRef.current) {
            const unsubscribe = (0, $ifH0n.unsplashTracker).trackWhileInViewport(imageRef.current, unsplashAttachment?.sourceIdentifier);
            return unsubscribe;
        }
    }, [
        coverMedia.attachment,
        imgUrl,
        unsplashAttachment?.sourceIdentifier,
        unsplashAttachment?.sourceType
    ]);
    /**
   * In order for card positions to appear consistently correct, we need to call
   * onBoardCardResize when the image height changes. This is because the image
   * height is used to calculate the height of the card.
   */ (0, $eUqFw.useLayoutEffect)(()=>{
        if (imageRef.current && height !== imageRef.current.clientHeight) onBoardCardResize();
    }, [
        height,
        onBoardCardResize
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($126af045f9382de5$var$MemoizedCardImageCover, {
        ref: imageRef,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-image",
        src: imgUrl,
        height: height,
        title: coverMedia?.attachment?.fileName ?? undefined
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $126af045f9382de5$var$CardImageCoverImg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $9t7rW.default)(`url(${__cmplp.src})`),
            "--_bwxd0g": (0, $9t7rW.default)(`${__cmplp.height - 5}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q72pcs _bfhkvdii _1lrw1f51 _12vemgnk _ouxl1ssb _c71luuw1 _4t3iwl9h _1bsb1osq _13li1sit _qrwq1sit",
            __cmplp.className
        ])
    });
});
const $126af045f9382de5$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
};
/**
 * Since the board items are refetched after any board changes, we receive a new token
 * every time. As a result, the image is refetched and causes a flicker. We don't need
 * to rerender the image in that case. The cases we need to are when the image is removed
 * or added, in which case we will retrieve a token separately and rerender.
 */ const $126af045f9382de5$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $eUqFw.memo)($126af045f9382de5$var$CardImageCoverImg, (prevProps, nextProps)=>$126af045f9382de5$var$urlWithoutToken(prevProps.src) === $126af045f9382de5$var$urlWithoutToken(nextProps.src) && prevProps.height === nextProps.height);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $126af045f9382de5$var$CardGradientCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $9t7rW.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71i36 _4t3i1tcg _1bsb1osq _13li1sit _qrwq1sit",
            __cmplp.className
        ])
    });
});
const $126af045f9382de5$var$CardColorCoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _4t3i1tcg _1bsb1osq _13li1sit _qrwq1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57bD3", function(module, exports) {

$parcel$export(module.exports, "BoardVirtualizationProvider", () => $b58ac9adc8d7c819$export$1b5d8399d93f6188);
$parcel$export(module.exports, "useBoardVirtualization", () => $b58ac9adc8d7c819$export$d1630c8d096ced71);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $b58ac9adc8d7c819$export$808f4edaf81c6311 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    onBoardCardResize: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $b58ac9adc8d7c819$export$1b5d8399d93f6188 = ({ children: children, onBoardCardResize: onBoardCardResize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b58ac9adc8d7c819$export$808f4edaf81c6311.Provider, {
        value: {
            onBoardCardResize: onBoardCardResize
        }
    }, children);
const $b58ac9adc8d7c819$export$d1630c8d096ced71 = ()=>(0, $eUqFw.useContext)($b58ac9adc8d7c819$export$808f4edaf81c6311);

});


parcelRegister("ghGL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c83d849ecbec0d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hsCsM = parcelRequire("hsCsM");

var $gIx2f = parcelRequire("gIx2f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ib4WI = parcelRequire("ib4WI");

var $kAb4I = parcelRequire("kAb4I");

var $57bD3 = parcelRequire("57bD3");

var $kySwt = parcelRequire("kySwt");
const $5c83d849ecbec0d6$var$INLINE_CREATE_TRIGGER_OFFSET = 12;
const $5c83d849ecbec0d6$var$InlineSiblingCreate = ({ column: column, isSiblingCreateFormOpen: isSiblingCreateFormOpen, issueId: issueId, toggleSiblingCreateForm: toggleSiblingCreateForm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onBoardCardResize: onBoardCardResize } = (0, $57bD3.useBoardVirtualization)();
    const inlineCreateProps = (0, $kAb4I.useInlineCreateProps)({
        column: column,
        rankBeforeIssueId: issueId
    });
    const handleTriggerClick = (0, $eUqFw.useCallback)(()=>{
        toggleSiblingCreateForm();
        onBoardCardResize();
    }, [
        onBoardCardResize,
        toggleSiblingCreateForm
    ]);
    // prevents onBlur from being called before the click event is finished
    const handleTriggerMouseDown = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleFormBlur = (0, $eUqFw.useCallback)(()=>{
        toggleSiblingCreateForm();
        onBoardCardResize();
    }, [
        onBoardCardResize,
        toggleSiblingCreateForm
    ]);
    return isSiblingCreateFormOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5c83d849ecbec0d6$var$inlineFormWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIx2f.default), {
        ...inlineCreateProps,
        location: "boardSibling",
        onBlur: handleFormBlur
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hsCsM.default), {
        direction: "row",
        onClick: handleTriggerClick,
        onMouseDown: handleTriggerMouseDown,
        label: formatMessage((0, $kySwt.default).createSiblingIssue),
        offset: $5c83d849ecbec0d6$var$INLINE_CREATE_TRIGGER_OFFSET,
        position: (0, $ib4WI.GAP_BETWEEN_CARDS) / 2
    });
};
var $5c83d849ecbec0d6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5c83d849ecbec0d6$var$InlineSiblingCreate);
const $5c83d849ecbec0d6$var$inlineFormWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("kAb4I", function(module, exports) {

$parcel$export(module.exports, "useInlineCreateProps", () => $fefaad47f6fb2234$export$ecb6499077e81078);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $gIx2f = parcelRequire("gIx2f");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $57XQa = parcelRequire("57XQa");

var $9Xnty = parcelRequire("9Xnty");
const $fefaad47f6fb2234$export$ecb6499077e81078 = ({ column: column, onAddOptimisticIssue: onAddOptimisticIssue, rankBeforeIssueId: rankBeforeIssueId })=>{
    const [{ categoryFieldId: categoryFieldId, issueFields: issueFields }, { addIssue: addIssue, removeIssue: removeIssue, removeIssueWithFields: removeIssueWithFields, updateIssue: updateIssue }] = (0, $lqN6D.useBoardStore)();
    const statusCategoryId = column.groupBy === (0, $jGcn0.GROUP_BY_STATUS) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8Qd0L.StatusCategoryIds)[column.statusCategory] : undefined;
    const [activeWorkflowDetails] = (0, $lqN6D.useActiveWorkflowDetails)();
    const intl = (0, $5JgJ2.default)();
    const fieldIdsToReturn = (0, $eUqFw.useMemo)(()=>[
            ...Object.keys(issueFields ?? []),
            (0, $lO4Or.ISSUE_KEY_TYPE)
        ], [
        issueFields
    ]);
    const allowedIssueTypeIds = (0, $eUqFw.useMemo)(()=>{
        if (!activeWorkflowDetails) return undefined;
        return activeWorkflowDetails.issueTypes.map((issueType)=>issueType.issueTypeId);
    }, [
        activeWorkflowDetails
    ]);
    const prepareIssueContext = (0, $eUqFw.useCallback)(()=>{
        const issueContext = {};
        if (rankBeforeIssueId) issueContext.rankBefore = {
            issueId: String(rankBeforeIssueId),
            rank: ''
        };
        if (column.groupKey === (0, $ib4WI.NULL_GROUP_KEY)) return issueContext;
        switch(column.groupBy){
            case 0, $jGcn0.GROUP_BY_ASSIGNEE:
                issueContext.assignee = {
                    accountId: column.groupKey ?? '',
                    avatarUrl: column.imageUrl ?? '',
                    displayName: column.name ?? ''
                };
                break;
            case 0, $jGcn0.GROUP_BY_PRIORITY:
                issueContext.priority = {
                    iconUrl: column.imageUrl ?? '',
                    name: column.name ?? '',
                    priorityId: column.groupKey ?? ''
                };
                break;
            case 0, $jGcn0.GROUP_BY_CATEGORY:
                issueContext.category = {
                    color: column.color || '',
                    optionId: column.groupKey ?? '',
                    value: column.name ?? ''
                };
                break;
            case 0, $jGcn0.GROUP_BY_STATUS:
                issueContext.status = {
                    name: column.name ?? '',
                    statusCategoryId: statusCategoryId ?? 0,
                    statusId: column.groupKey ?? ''
                };
                break;
            default:
                break;
        }
        return issueContext;
    }, [
        column,
        rankBeforeIssueId,
        statusCategoryId
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const optimisticIssue = {
            assigneeKey: null,
            assigneeName: null,
            dueDate: null,
            id: optimisticIssuePayload.issueId,
            issueTypeId: optimisticIssuePayload.issueType.id,
            key: '',
            needsExtendedFieldsUpdate: false,
            statusId: 0,
            subtaskMetadata: {
                done: 0,
                total: 0
            },
            summary: optimisticIssuePayload.summary,
            url: ''
        };
        if (optimisticIssuePayload.assignee) {
            optimisticIssue.assignee = {
                avatarUrl: optimisticIssuePayload.assignee.avatarUrl,
                displayName: optimisticIssuePayload.assignee.displayName
            };
            optimisticIssue.assigneeKey = optimisticIssuePayload.assignee.accountId;
            optimisticIssue.assigneeName = optimisticIssuePayload.assignee.displayName;
        }
        if (optimisticIssuePayload.priority) {
            optimisticIssue.priorityIconUrl = optimisticIssuePayload.priority.iconUrl;
            optimisticIssue.priorityId = optimisticIssuePayload.priority.priorityId;
            optimisticIssue.priorityName = optimisticIssuePayload.priority.name;
        }
        if (optimisticIssuePayload.status) {
            optimisticIssue.statusCategory = (0, $8Qd0L.statusCategoryForId)(optimisticIssuePayload.status.statusCategoryId);
            optimisticIssue.statusId = Number(optimisticIssuePayload.status.statusId);
            optimisticIssue.statusName = optimisticIssuePayload.status.name;
            optimisticIssue.untranslatedStatusName = optimisticIssuePayload.status.name;
        }
        let optimisticExtendedFields;
        if (optimisticIssuePayload.category && categoryFieldId) {
            const optimisticCategoryField = {
                fieldId: categoryFieldId,
                id: optimisticIssuePayload.category.optionId,
                name: column.groupName ?? '',
                type: (0, $ib4WI.BOARD_FIELD_CATEGORY),
                value: optimisticIssuePayload.category.value,
                color: optimisticIssuePayload.category.color ?? ''
            };
            optimisticExtendedFields = {
                fields: [
                    optimisticCategoryField
                ],
                fieldsByAlias: {
                    category: optimisticCategoryField
                }
            };
        }
        const optimisticRankBeforeIssueId = optimisticIssuePayload.rankBefore?.issueId ? Number(optimisticIssuePayload.rankBefore?.issueId) : undefined;
        addIssue(optimisticIssue, optimisticExtendedFields, optimisticRankBeforeIssueId);
        onAddOptimisticIssue?.();
        let createdBoardItem;
        try {
            createdBoardItem = await promise;
        } catch (e) {
        // swallow error
        }
        if (createdBoardItem) {
            const extendedFields = (0, $57XQa.transformFieldsOld)([
                createdBoardItem
            ], intl)[createdBoardItem.issueId];
            const issue = (0, $9Xnty.getIssueFromIssueFieldsOld)(createdBoardItem.issueId, extendedFields.fields);
            updateIssue(optimisticIssue.id, issue, extendedFields);
        }
        removeIssue(optimisticIssue.id);
        removeIssueWithFields(optimisticIssue.id);
    }, [
        addIssue,
        categoryFieldId,
        column.groupName,
        intl,
        onAddOptimisticIssue,
        removeIssue,
        removeIssueWithFields,
        updateIssue
    ]);
    return {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: (0, $gIx2f.CARD_APPEARANCE),
        fieldIdsToReturn: fieldIdsToReturn,
        onPrepareIssueContext: prepareIssueContext,
        onSubmit: handleSubmit
    };
};

});
parcelRegister("9Xnty", function(module, exports) {

$parcel$export(module.exports, "getIssueFromIssueFieldsOld", () => $79d54eec15630895$export$19d989ca3b708fcc);

var $lO4Or = parcelRequire("lO4Or");

var $ib4WI = parcelRequire("ib4WI");
const $79d54eec15630895$export$19d989ca3b708fcc = (issueId, issueFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issue = {
        assigneeKey: null,
        assigneeName: null,
        dueDate: null,
        id: issueId,
        key: '',
        needsExtendedFieldsUpdate: false,
        statusId: 0,
        subtaskMetadata: {
            done: 0,
            total: 0
        },
        summary: '',
        url: '',
        issueTypeId: ''
    };
    issueFields.forEach((field)=>{
        switch(field.type){
            case 0, $ib4WI.BOARD_FIELD_DATE:
                if (field.fieldId === (0, $lO4Or.DUE_DATE_TYPE)) issue.dueDate = field.value;
                break;
            case 0, $ib4WI.BOARD_FIELD_LABEL:
                issue.labels = field.value;
                break;
            case 0, $ib4WI.BOARD_FIELD_ISSUE_TYPE:
                issue.issueTypeId = field.id;
                break;
            case 0, $ib4WI.BOARD_FIELD_PRIORITY:
                issue.priorityIconUrl = field.priority.iconUrl;
                issue.priorityId = field.priority.id;
                issue.priorityName = field.priority.name;
                break;
            case 0, $ib4WI.BOARD_FIELD_STATUS:
                issue.statusCategory = field.status.category;
                issue.statusId = field.status.id;
                issue.statusName = field.status.name;
                break;
            case 0, $ib4WI.BOARD_FIELD_TEXT:
                if (field.fieldId === (0, $lO4Or.ISSUE_KEY_TYPE)) issue.key = field.value;
                else if (field.fieldId === (0, $lO4Or.SUMMARY_TYPE)) issue.summary = field.value;
                break;
            case 0, $ib4WI.BOARD_FIELD_USER:
                if (field.fieldId === (0, $lO4Or.ASSIGNEE_TYPE)) {
                    issue.assigneeKey = field.users[0].accountId;
                    issue.assigneeName = field.users[0].name;
                    issue.assignee = {
                        avatarUrl: field.users[0].avatarURL ?? '',
                        displayName: field.users[0].name
                    };
                }
                break;
            default:
                break;
        }
    });
    return issue;
};

});



parcelRegister("2rU1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d7e9849dedc05c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0d7e9849dedc05c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cardActions: {
        "id": "work-management-board.board-old.column-old.card-old.card-actions",
        "defaultMessage": "Card actions"
    }
});

});


parcelRegister("fbIWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5699a96ec9d7030$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $cSu9v = parcelRequire("cSu9v");

var $9drmE = parcelRequire("9drmE");

var $1zSxm = parcelRequire("1zSxm");

var $29yDk = parcelRequire("29yDk");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $gjzML = parcelRequire("gjzML");

var $MxsGB = parcelRequire("MxsGB");

var $7eqzD = parcelRequire("7eqzD");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $41WOo = parcelRequire("41WOo");

var $3ySoA = parcelRequire("3ySoA");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4W8Fw = parcelRequire("4W8Fw");
var $3hjaO = parcelRequire("3hjaO");
var $fkLhx = parcelRequire("fkLhx");

var $2w3P7 = parcelRequire("2w3P7");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $4VjPN = parcelRequire("4VjPN");

var $eUIOu = parcelRequire("eUIOu");

var $4Z5qC = parcelRequire("4Z5qC");

var $iPk7h = parcelRequire("iPk7h");
var $b8XnM = parcelRequire("b8XnM");

var $4Z3mK = parcelRequire("4Z3mK");

var $58VVU = parcelRequire("58VVU");

var $4Cd42 = parcelRequire("4Cd42");

var $iXHUp = parcelRequire("iXHUp");

var $lqN6D = parcelRequire("lqN6D");

var $3cUPp = parcelRequire("3cUPp");

var $lELme = parcelRequire("lELme");

var $1nuKe = parcelRequire("1nuKe");

var $hH7NI = parcelRequire("hH7NI");

var $f1fqt = parcelRequire("f1fqt");

var $kUb08 = parcelRequire("kUb08");
// @ts-expect-error - TS7006 - Parameter 'transition' implicitly has an 'any' type. | TS7006 - Parameter 'sourceColumn' implicitly has an 'any' type. | TS7006 - Parameter 'targetColumn' implicitly has an 'any' type.
const $e5699a96ec9d7030$var$getTransitionInfoOverlay = (transition, sourceColumn, targetColumn)=>{
    const sourceStatus = {
        id: Number(sourceColumn.statusId),
        name: sourceColumn.name,
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<{ undefined: 1; new: 2; done: 3; indeterminate: 4; }>'.
        category: (0, $8Qd0L.statusCategoryForId)((0, $8Qd0L.StatusCategoryIds)[sourceColumn.statusCategory])
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TransitionInfoContainer), null, transition?.isGlobal && sourceStatus && sourceStatus.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        name: sourceColumn.name,
        category: sourceStatus.category
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<{ undefined: 1; new: 2; done: 3; indeterminate: 4; }>'.
        category: (0, $8Qd0L.statusCategoryForId)((0, $8Qd0L.StatusCategoryIds)[targetColumn.statusCategory]),
        name: targetColumn.name
    }));
};
const $e5699a96ec9d7030$var$ColumnHeaderWithPivotSupport = /*#__PURE__*/ (0, $eUqFw.memo)(// eslint-disable-next-line complexity
({ column: column, isClone: isClone, akDragHandleProps: akDragHandleProps, isDeletableColumn: isDeletableColumn, isDropDisabled: isDropDisabled, ...other })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { transition: transition, sourceColumn: sourceColumn } = (0, $4Z3mK.useCardTransitionsOld)();
    const [hasScrollTop] = (0, $2w3P7.useBoardHasScrollTop)();
    const [hasMultipleTransitions] = (0, $lqN6D.useHasMultipleTransitionsBetweenStatuses)();
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    const { cardDragState: cardDragState } = (0, $lqN6D.useBoardStoreState)();
    const { shouldRenderExperiment: automationDiscoveryEnabled } = (0, $41WOo.isAutomationDiscoveryOnBoardColumnsExperimentEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fkLhx.useJwmAutomationDiscoveryOnBoardColumnsExperiment)() : {
        shouldRenderExperiment: false
    };
    const { isAutomationDiscoveryModalOpen: isAutomationDiscoveryModalOpen, setIsAutomationDiscoveryModalOpen: setIsAutomationDiscoveryModalOpen, isTargetColumn: isTargetColumn } = automationDiscoveryEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3hjaO.useAutomationDiscoveryContext)() : {
        isTargetColumn: ()=>false,
        isAutomationDiscoveryModalOpen: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setIsAutomationDiscoveryModalOpen: ()=>{}
    };
    const isDraggingCardOver = (0, $eUqFw.useMemo)(()=>String(cardDragState.columnId) === String(column.id), [
        cardDragState,
        column.id
    ]);
    const oldShouldShowTransitionInfo = column.groupKey == null && transition !== undefined && !!sourceColumn;
    const shouldShowTransitionInfo = oldShouldShowTransitionInfo && isDraggingCardOver && !column.isCollapsed;
    const { collapseColumn: collapseColumn, expandColumn: expandColumn } = (0, $58VVU.useCollapseColumn)({
        groupKey: column.groupKey
    });
    const { renameColumn: renameColumn, validateRename: validateRename } = (0, $b8XnM.useRenameColumn)();
    const [areAnyColumnsUpdating] = (0, $lqN6D.useAreAnyColumnsUpdating)();
    const [isEditMode, setEditMode] = (0, $eUqFw.useState)(false);
    const [isCannotRenameDialogOpen, setIsCannotRenameDialogOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const project = (0, $kQAZu.useProject)();
    const isTeamManaged = project.isSimplified;
    const isProjectAdmin = project.permissions.administerProject;
    const { data: { hasMultipleWorkflows: hasMultipleWorkflows, hasExceededMaxIssueTypes: hasExceededMaxIssueTypes } = {}, loading: multipleWorkflowsLoading = false, error: multipleWorkflowsError } = (0, $iPk7h.useDetectMultipleWorkflows)({
        shouldFetchOnMount: isProjectAdmin && isTeamManaged
    });
    const isColumnDraggable = isProjectAdmin && !isClone;
    const isColumnCollapsed = !!column.isCollapsed;
    const isCollapsedColumnHighlighted = (0, $eUqFw.useMemo)(()=>isColumnCollapsed && !isDropDisabled && isDraggingCardOver && (!hasMultipleTransitions || !isGroupedByStatus), [
        isColumnCollapsed,
        isDropDisabled,
        isDraggingCardOver,
        hasMultipleTransitions,
        isGroupedByStatus
    ]);
    const showConfetti = (0, $eUqFw.useMemo)(()=>(column.isDone || (0, $4Cd42.matchConfettiEmoji)(column.name)) && !column.isCollapsed, [
        column
    ]);
    const displayDialogueMessage = (0, $eUqFw.useCallback)(()=>{
        if (!isProjectAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VjPN.ContactAdminToModifyBoardMessage), null);
        if (hasExceededMaxIssueTypes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUIOu.OpenProjectSettingsExceededIssueTypes), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Z5qC.OpenProjectSettingsMultipleWorkflows), null);
    }, [
        isProjectAdmin,
        hasExceededMaxIssueTypes
    ]);
    // CMP should only show readOnly
    // or there is a failure fetching multiple workflows status or it's still loading
    // or non status pivot mode
    // or any columns updating
    const shouldRenderReadOnly = !isTeamManaged || multipleWorkflowsLoading || multipleWorkflowsError != null || column.groupBy != null && column.groupBy !== (0, $jGcn0.GROUP_BY_STATUS) || areAnyColumnsUpdating;
    const renderHeaderContent = ()=>{
        const headerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, {
            [(0, $jGcn0.GROUP_BY_STATUS)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
                name: column.name,
                category: (0, $8Qd0L.statusCategoryForId)((0, $8Qd0L.StatusCategoryIds)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                column.statusCategory])
            }),
            [(0, $jGcn0.GROUP_BY_PRIORITY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: column.name
            }, column.imageUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.Image), {
                alt: column.name,
                src: column.imageUrl
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TextWrapper), {
                isBold: true,
                isTruncated: true,
                isCapitalised: true
            }, column.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? formatMessage((0, $3cUPp.default).noPriority) : column.name)),
            [(0, $jGcn0.GROUP_BY_ASSIGNEE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, column.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "circle",
                src: "",
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
                avatarUrl: column.imageUrl ?? '',
                name: column.name ?? ''
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TextWrapper), {
                isBold: true,
                isTruncated: true,
                isCapitalised: true
            }, column.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? formatMessage((0, $3cUPp.default).noAssignee) : column.name)),
            [(0, $jGcn0.GROUP_BY_CATEGORY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
                categoryName: column.groupKey === (0, $ib4WI.NULL_GROUP_KEY) ? formatMessage((0, $3cUPp.default).noCategory) : column.name,
                categoryColor: column.color
            }))
        }[column.groupBy ?? (0, $jGcn0.GROUP_BY_STATUS)], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TextWrapper), {
            isBold: false
        }, column.issues.length));
        const readViewHeaderRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TitleReadViewWrapper), {
            isLoading: !!column?.loading,
            isColumnCollapsed: isColumnCollapsed
        }, headerContent);
        // collapsed column should render read only
        if (shouldRenderReadOnly || isColumnCollapsed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TitleReadOnlyWrapper), {
            "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.title-read-view-wrapper"
        }, readViewHeaderRender);
        // for TMP end user that does not have modify permission
        if (!isProjectAdmin || hasMultipleWorkflows || hasExceededMaxIssueTypes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.RenameClickNotAllowedWrapper), null, displayDialogueMessage()),
            isOpen: isCannotRenameDialogOpen,
            onClose: ()=>{
                setIsCannotRenameDialogOpen(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TitleReadViewWrapper), {
            onMouseUp: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnHeader clicked', 'jwmBoardColumnRenameFromTitle', {
                    isProjectAdmin: isProjectAdmin,
                    hasMultipleWorkflows: hasMultipleWorkflows,
                    hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
                });
                setIsCannotRenameDialogOpen(true);
            },
            isLoading: !!column?.loading,
            showDisabledCursor: isCannotRenameDialogOpen,
            "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.title-read-view-wrapper"
        }, headerContent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.EditableColumnHeaderWrapper), {
            "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.editable-column-header-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hH7NI.default), {
            fallback: readViewHeaderRender,
            defaultValue: column.name,
            isEditing: isEditMode,
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.TitleReadViewWrapper), {
                    isLoading: !!column?.loading
                }, headerContent),
            onCancel: ()=>setEditMode(false),
            onConfirm: (newName)=>{
                setEditMode(false);
                renameColumn({
                    oldName: column.name,
                    newName: newName,
                    statusId: column.statusId
                });
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnRenameInlineEdit confirmed', 'jwmBoardColumnRename');
            },
            onEdit: ()=>{
                setEditMode(true);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'columnHeader clicked', 'jwmBoardColumnRenameFromTitle', {
                    isProjectAdmin: isProjectAdmin,
                    hasMultipleWorkflows: hasMultipleWorkflows,
                    hasExceededMaxIssueTypes: hasExceededMaxIssueTypes
                });
            },
            onValidate: (newName)=>validateRename({
                    oldName: column.name,
                    newName: newName
                })
        }));
    };
    const renderMenu = isTeamManaged && !isColumnCollapsed || !column.isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.Container), {
        "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.container",
        isDraggable: true,
        isShadowVisible: hasScrollTop,
        isColumnCollapsed: isColumnCollapsed,
        isCollapsedColumnHighlighted: isCollapsedColumnHighlighted,
        ...other
    }, (0, $41WOo.isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort)() && isTargetColumn(Number(column.id)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4W8Fw.AutomationDiscoveryModal), {
        isOpen: isAutomationDiscoveryModalOpen,
        setIsOpen: setIsAutomationDiscoveryModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.HeaderTitleWrapper), {
        ...akDragHandleProps,
        isDeletableColumn: isDeletableColumn,
        isColumnCollapsed: isColumnCollapsed,
        isCollapsedColumnHighlighted: isCollapsedColumnHighlighted,
        onClick: isColumnCollapsed ? expandColumn : undefined,
        "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.header-title-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isColumnDraggable,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.ColumnWrapper), {
                isColumnCollapsed: isColumnCollapsed
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.HeaderLeftSideWrapper), {
        "data-testid": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.header-left-side-wrapper",
        isColumnCollapsed: isColumnCollapsed
    }, shouldShowTransitionInfo && sourceColumn != null ? $e5699a96ec9d7030$var$getTransitionInfoOverlay(transition, sourceColumn, column) : renderHeaderContent()), isColumnCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.ExpandButtonWrapper), {
        "data-component-selector": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.expand-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.expand-column",
        spacing: "none",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1zSxm))), {
            label: formatMessage((0, $lELme.default).expandButton),
            size: "medium"
        }),
        // @ts-expect-error - TS2322 - Type '(event?: MouseEvent | undefined) => void' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
        onClick: expandColumn
    })), renderMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.MenuWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kUb08.CollapseButtonWrapper), {
        "data-component-selector": "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.collapse-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "work-management-board.ui.board-old.column-old.column-header-with-pivot-support-old.collapse-column",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9drmE))), {
            label: formatMessage((0, $lELme.default).collapseButton),
            size: "medium"
        }),
        onClick: collapseColumn
    })), !shouldRenderReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, column?.loading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1fqt.default), {
        hasMultipleWorkflows: hasMultipleWorkflows,
        hasExceededMaxIssueTypes: hasExceededMaxIssueTypes,
        column: column,
        onRenameClick: ()=>{
            setEditMode(true);
        }
    })))), showConfetti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nuKe.BoardConfettiAsync), {
        columnId: Number(column.id)
    })));
});
var $e5699a96ec9d7030$export$2e2bcd8739ae039 = $e5699a96ec9d7030$var$ColumnHeaderWithPivotSupport;

});
parcelRegister("58VVU", function(module, exports) {

$parcel$export(module.exports, "useCollapseAllColumns", () => $d66d440a0abc7c18$export$e7b2f6b755b628f0);
$parcel$export(module.exports, "useCollapseColumn", () => $d66d440a0abc7c18$export$839c2153f3a0db81);
$parcel$export(module.exports, "useExpandVirtualCards", () => $d66d440a0abc7c18$export$63163f07701a5a6c);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fmbIi = parcelRequire("fmbIi");

var $4mhKq = parcelRequire("4mhKq");

var $iXHUp = parcelRequire("iXHUp");
const $d66d440a0abc7c18$export$e7b2f6b755b628f0 = ()=>{
    const [, setCollapseAllColumns] = (0, $fmbIi.useCollapsedColumns)();
    const groupColumns = (0, $4mhKq.useColumns)();
    const expandAllColumns = (0, $eUqFw.useCallback)(()=>{
        const columnKeys = groupColumns.map((column)=>column.groupKey ?? '');
        setCollapseAllColumns(columnKeys, false);
    }, [
        groupColumns,
        setCollapseAllColumns
    ]);
    const collapseAllColumns = (0, $eUqFw.useCallback)(()=>{
        const columnKeys = groupColumns.map((column)=>column.groupKey ?? '');
        setCollapseAllColumns(columnKeys, true);
    }, [
        groupColumns,
        setCollapseAllColumns
    ]);
    return {
        collapseAllColumns: collapseAllColumns,
        expandAllColumns: expandAllColumns
    };
};
const $d66d440a0abc7c18$export$839c2153f3a0db81 = ({ groupKey: groupKey })=>{
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const [, setCollapsedColumns] = (0, $fmbIi.useCollapsedColumns)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const expandColumn = (0, $eUqFw.useCallback)((event)=>{
        if (event?.stopPropagation) event.stopPropagation();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandColumn', {
            groupKey: groupKey,
            groupBy: groupBy
        });
        groupKey && setCollapsedColumns([
            groupKey
        ], false);
    }, [
        createAnalyticsEvent,
        groupKey,
        groupBy,
        setCollapsedColumns
    ]);
    const collapseColumn = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'collapseColumn', {
            groupKey: groupKey,
            groupBy: groupBy
        });
        groupKey && setCollapsedColumns([
            groupKey
        ], true);
    }, [
        createAnalyticsEvent,
        groupKey,
        groupBy,
        setCollapsedColumns
    ]);
    return {
        collapseColumn: collapseColumn,
        expandColumn: expandColumn
    };
};
const $d66d440a0abc7c18$export$63163f07701a5a6c = (isCollapsedColumn)=>{
    /* HACK - delay virtual cards expanded to avoid the incorrect spacing between cards
    The totalSize is wrong calculated if we don't delay the expansion due to the animation */ const [isCollapsed, setIsCollapsed] = (0, $eUqFw.useState)(isCollapsedColumn);
    (0, $eUqFw.useEffect)(()=>{
        let expandColumnTimer;
        if (!isCollapsedColumn) {
            const oldIsCollapsed = isCollapsedColumn;
            /* Expand collapsed column after 100ms */ expandColumnTimer = setTimeout(()=>{
                if (!oldIsCollapsed && !isCollapsedColumn) setIsCollapsed(false);
            }, 100);
        } else setIsCollapsed(true);
        return ()=>{
            if (expandColumnTimer != null) clearTimeout(expandColumnTimer);
        };
    }, [
        isCollapsedColumn
    ]);
    return {
        isCollapsed: isCollapsed
    };
};

});

parcelRegister("1nuKe", function(module, exports) {

$parcel$export(module.exports, "BoardConfettiAsync", () => $416deb85c1c22b09$export$4f91ba343f675e27);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $3jaqr = parcelRequire("3jaqr");

var $9Ia8c = parcelRequire("9Ia8c");
const $416deb85c1c22b09$var$entryPointParams = {};
const $416deb85c1c22b09$export$4f91ba343f675e27 = ({ columnId: columnId })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $9Ia8c.boardConfettiEntrypoint), $416deb85c1c22b09$var$entryPointParams);
    const [animating, setAnimating] = (0, $eUqFw.useState)(false);
    const [{ confettiColumns: confettiColumns }, { removeConfettiColumn: removeConfettiColumn }] = (0, $3jaqr.useConfettiColumns)();
    (0, $eUqFw.useEffect)(()=>{
        if (confettiColumns.has(columnId)) {
            setAnimating(true);
            removeConfettiColumn(columnId);
        }
    }, [
        confettiColumns,
        removeConfettiColumn,
        columnId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (animating) entryPointActions.load();
    }, [
        animating,
        entryPointActions
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onConfettiComplete: ()=>setAnimating(false)
        }), [
        setAnimating
    ]);
    if (!animating) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jwm-board-confetti",
        packageName: "jiraWorkManagementBoard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("9Ia8c", function(module, exports) {

$parcel$export(module.exports, "boardConfettiEntrypoint", () => $e2549449e390cb45$export$1495ab1cfa22b397);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e2549449e390cb45$export$1495ab1cfa22b397 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("3jGDG")), {
        moduleId: "c1ebfb4b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3jGDG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6eRfj');
        const value = parcelRequire('2TfjR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6eRfj").then(()=>parcelRequire('2TfjR'));
}

});



parcelRegister("hH7NI", function(module, exports) {

$parcel$export(module.exports, "default", () => $81526d9be3389cd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $81526d9be3389cd6$var$EditableColumnHeader = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dNXop")), {
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-old/column-header-with-pivot-support-old/editable-column-header/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81526d9be3389cd6$export$2e2bcd8739ae039 = ({ fallback: fallback, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.editable-column-header",
        packageName: "async.jira-business.board.editable-column-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "editable-column-header",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($81526d9be3389cd6$var$EditableColumnHeader, props)));

});
parcelRegister("dNXop", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('14KDk');
        const value = parcelRequire('b6nxM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("14KDk").then(()=>parcelRequire('b6nxM'));
}

});


parcelRegister("f1fqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0686219032f0e1ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $0686219032f0e1ec$var$HeaderDropdown = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1eU1C")), {
    moduleId: "./src/packages/business/board/view/src/ui/board-old/column-old/column-header-with-pivot-support-old/header-dropdown/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0686219032f0e1ec$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.board.header-dropdown",
        packageName: "async.jira-business.board.header-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "header-dropdown",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0686219032f0e1ec$var$HeaderDropdown, props)));

});
parcelRegister("1eU1C", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('GqkM1');
        const value = parcelRequire('e0hS4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("GqkM1").then(()=>parcelRequire('e0hS4'));
}

});


parcelRegister("kUb08", function(module, exports) {

$parcel$export(module.exports, "TextWrapper", () => $5d3b67dc8b31f16d$export$7c3018f441722857);
$parcel$export(module.exports, "HeaderTitleWrapper", () => $5d3b67dc8b31f16d$export$6add2ed1af1d803b);
$parcel$export(module.exports, "TitleReadOnlyWrapper", () => $5d3b67dc8b31f16d$export$780367a34dc7f5d);
$parcel$export(module.exports, "TitleReadViewWrapper", () => $5d3b67dc8b31f16d$export$d87b3dc835c00dee);
$parcel$export(module.exports, "RenameClickNotAllowedWrapper", () => $5d3b67dc8b31f16d$export$3fa6e253e9bae5c6);
$parcel$export(module.exports, "HeaderLeftSideWrapper", () => $5d3b67dc8b31f16d$export$8f8bde7adeedb305);
$parcel$export(module.exports, "EditableColumnHeaderWrapper", () => $5d3b67dc8b31f16d$export$91e1c5850bdde578);
$parcel$export(module.exports, "CollapseButtonWrapper", () => $5d3b67dc8b31f16d$export$169cc81fcb18756);
$parcel$export(module.exports, "ExpandButtonWrapper", () => $5d3b67dc8b31f16d$export$9c280c1b1f8780dd);
$parcel$export(module.exports, "Container", () => $5d3b67dc8b31f16d$export$42a852a2b6b56249);
$parcel$export(module.exports, "TransitionInfoContainer", () => $5d3b67dc8b31f16d$export$84d99f79e7306841);
$parcel$export(module.exports, "MenuWrapper", () => $5d3b67dc8b31f16d$export$98eff9c5659394e3);
$parcel$export(module.exports, "ColumnWrapper", () => $5d3b67dc8b31f16d$export$b904459935723643);
$parcel$export(module.exports, "Image", () => $5d3b67dc8b31f16d$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $ib4WI = parcelRequire("ib4WI");
const $5d3b67dc8b31f16d$var$DRAGGING_OVER_BORDER_OFFSET = 2;
const $5d3b67dc8b31f16d$var$DRAGGING_TRANSLATION_OFFSET = (0, $ib4WI.COLLAPSED_COLUMN_FIXED_WIDTH) - $5d3b67dc8b31f16d$var$DRAGGING_OVER_BORDER_OFFSET * 2;
const $5d3b67dc8b31f16d$var$COLLAPSED_COLUMN_HEADER_MAX_HEIGHT = (0, $ib4WI.COLLAPSED_COLUMN_FIXED_WIDTH) - $5d3b67dc8b31f16d$var$DRAGGING_OVER_BORDER_OFFSET * 2;
const $5d3b67dc8b31f16d$export$7c3018f441722857 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCapitalised: isCapitalised, isBold: isBold, isTruncated: isTruncated, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66",
            __cmplp.isCapitalised ? "_1p1dx3ek" : "_1p1dangw",
            __cmplp.isBold ? "_k48pni7l" : "_k48p1nn1",
            __cmplp.isTruncated && "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$6add2ed1af1d803b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDeletableColumn: isDeletableColumn, isColumnCollapsed: isColumnCollapsed, isCollapsedColumnHighlighted: isCollapsedColumnHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_q7dy9x": (0, $9t7rW.default)(__cmplp.isCollapsedColumnHighlighted ? $5d3b67dc8b31f16d$var$DRAGGING_TRANSLATION_OFFSET : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ib4WI.COLLAPSED_COLUMN_FIXED_WIDTH), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1tgx _4cvr1h6o _1bah1e5h _1e0c1txw _4t3i1osq _19bvpxbi _u5f3u2gc _13lii2wt _qrwqi2wt",
            __cmplp.isDeletableColumn ? "_bfhktaeo" : "_bfhkhri9",
            __cmplp.isColumnCollapsed && "_1e0c116y _2rkoi2wt _1yt4h8dc _19it9ojs _8hrz5d63 _t9ec1f6s _c71l14no",
            __cmplp.isCollapsedColumnHighlighted && "_19itidpf _bfhkwtfv",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$780367a34dc7f5d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$d87b3dc835c00dee = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showDisabledCursor: showDisabledCursor, isColumnCollapsed: isColumnCollapsed, isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.showDisabledCursor ? "_80om13gf" : "_80om1kw7",
            __cmplp.isColumnCollapsed ? "_1yt41bpf" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.isLoading && "_aetrb3bt _1ywu1ule _18postnw _1qdg1osq _15l2idpf _19doidpf _32rxidpf _16r21myt _19q8i2wt _1450i2wt",
            __cmplp.className
        ])
    });
});
$5d3b67dc8b31f16d$export$d87b3dc835c00dee.displayName = 'TitleReadViewWrapper';
const $5d3b67dc8b31f16d$export$3fa6e253e9bae5c6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb13i4",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$var$BUTTON_SIZE = (0, $c9TLT.gridSize) * 4;
const $5d3b67dc8b31f16d$var$HEADER_PADDING = (0, $c9TLT.gridSize) * 2;
const $5d3b67dc8b31f16d$var$DRAGGED_HANDLER_SIZE = 20;
const $5d3b67dc8b31f16d$export$8f8bde7adeedb305 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isColumnCollapsed ? "_1bsbn7od" : "_1bsb1zx1",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$91e1c5850bdde578 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2iu91osq _d8r5idpf _104v1r31 _1m7fglyw _o6xs1o36",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$169cc81fcb18756 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _tzy411de",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$9c280c1b1f8780dd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec2i46 _tzy411de _1bsb1psw _4t3i1jzl _18u01a1s",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, isDragging: isDragging, isDraggable: isDraggable, isShadowVisible: isShadowVisible, isCollapsedColumnHighlighted: isCollapsedColumnHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_154iidpf _uiztglyw _4t3ickbl _1wybdlk8 _59hlidpf _hilggrho _iyyqgrho _1tsagrho _pdyk427j _1kt9b3bt _1cs8stnw _19wo1i6y _qnecidpf _oounidpf _kfgtyh40 _dsq4glyw _1rus1wws _3bdqt94y _at5wt94y _hrqx1tcg _1bcp1tcg _qdka1tcg _ttss1tcg _1ho1u2gc _pg6ou2gc",
            __cmplp.isColumnCollapsed ? "_1pbycs5v" : "_1pbyegat",
            __cmplp.isDragging ? "_kqswh2mm" : "_kqsw1if8",
            __cmplp.isDraggable ? "_80om1qgj" : "_80om73ad",
            __cmplp.isShadowVisible ? "_154pkb7n" : "_154pidpf",
            __cmplp.isCollapsedColumnHighlighted && "_4t3i1osq _2rkoi2wt _19it5r1b _bfhkwtfv",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$84d99f79e7306841 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1bah1e5h _wij21bp4 _1e0c11p5 _x3fa1l2s _10ca1q9c _17kn15vq _1hrp15vq",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$98eff9c5659394e3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u01wug _1ul91tcg",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$b904459935723643 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumnCollapsed: isColumnCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1kt9mrja _l5lo7vkz _1uak7vkz _is061dl3 _1y8lgktf _kfgtgktf _cfu11txw _19o61h6o _24gj1h6o _wxb0tlke",
            __cmplp.isColumnCollapsed ? "_18u0idpf" : "_18u0xmi2",
            __cmplp.isColumnCollapsed ? "_1bsb1osq" : "_1bsb1rrh",
            __cmplp.className
        ])
    });
});
const $5d3b67dc8b31f16d$export$3e431a229df88919 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _s7n41ndm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7zJcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c6878d851f1895$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gCss4 = parcelRequire("gCss4");

var $kAb4I = parcelRequire("kAb4I");
const $b4c6878d851f1895$var$inlineCreateStyles = {
    borderRadius: "var(--ds-border-radius, 3px)"
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b4c6878d851f1895$var$noop = ()=>{};
const $b4c6878d851f1895$var$InlineCreate = ({ column: column, scrollToLastElement: scrollToLastElement = $b4c6878d851f1895$var$noop })=>{
    const onAddOptimisticIssue = (0, $eUqFw.useCallback)(()=>{
        // Only attempt to scroll to the last element after the optimistic issue is created
        requestAnimationFrame(scrollToLastElement);
    }, [
        scrollToLastElement
    ]);
    const inlineCreateProps = (0, $kAb4I.useInlineCreateProps)({
        column: column,
        onAddOptimisticIssue: onAddOptimisticIssue
    });
    const handleToggleForm = (0, $eUqFw.useCallback)((isFormVisible)=>{
        if (isFormVisible) scrollToLastElement();
    }, [
        scrollToLastElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4c6878d851f1895$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCss4.default), {
        ...inlineCreateProps,
        location: "boardFooter",
        inlineCreateStyles: $b4c6878d851f1895$var$inlineCreateStyles,
        onToggleForm: handleToggleForm
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4c6878d851f1895$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhri9 _2rkohyhq _94n5idpf _19pk1wug _2hwx1lpd _otyr1lpd _18u01lpd _1yt41jus _kqsw1if8 _1pbykb7n",
            __cmplp.className
        ])
    });
});
var $b4c6878d851f1895$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b4c6878d851f1895$var$InlineCreate);

});

parcelRegister("kaf8x", function(module, exports) {

$parcel$export(module.exports, "CardsWrapper", () => $c847829b664e1367$export$594b8b21341e0b1a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c847829b664e1367$export$594b8b21341e0b1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, isDeletableColumn: isDeletableColumn, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _ca0q1l7b _u5f314y2 _n3td14y2 _19bv14y2 _mrkbi2wt _1o0zi2wt",
            __cmplp.isDisabled ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.isDisabled ? "_kdam7g3v" : "_kdamglyw",
            __cmplp.isDeletableColumn ? "_bfhktaeo" : "_bfhk1kw7",
            __cmplp.isCollapsed && "_3um015vq _kqswstnw _154iidpf _94n5idpf _1ltvidpf _1xi2idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("16j6u", function(module, exports) {

$parcel$export(module.exports, "TransitionZones", () => $31c6ffe2dc1acc78$export$937eeb7be994f9fa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gkDS9 = parcelRequire("gkDS9");

var $4Z3mK = parcelRequire("4Z3mK");

var $2b5eO = parcelRequire("2b5eO");

var $iXHUp = parcelRequire("iXHUp");

var $lqN6D = parcelRequire("lqN6D");

var $iWb3Z = parcelRequire("iWb3Z");

var $g6M3O = parcelRequire("g6M3O");
const $31c6ffe2dc1acc78$export$937eeb7be994f9fa = ({ columnId: columnId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sourceColumn: sourceColumn, cardDragState: cardDragState, transitions: transitions, onCardDragOver: onCardDragOver } = (0, $4Z3mK.useCardTransitionsOld)(columnId);
    const [hasMultipleTransitions] = (0, $lqN6D.useHasMultipleTransitionsBetweenStatuses)();
    const sourceId = Number(cardDragState.issue?.statusId);
    const { featureView: featureView } = (0, $2b5eO.useJWMBoardFeatures)();
    const [thisColumn] = (0, $lqN6D.useColumnByStatusId)({
        statusId: Number(columnId)
    });
    const [groupBy] = (0, $iXHUp.useGroupBy)();
    const isGroupedByStatus = groupBy === (0, $jGcn0.GROUP_BY_STATUS);
    return (0, $eUqFw.useMemo)(()=>{
        if (!thisColumn || !sourceColumn || !isGroupedByStatus || !cardDragState.issue || thisColumn.isCollapsed) return null;
        const sourceStatus = {
            id: sourceId,
            name: sourceColumn.name
        };
        const transitionZonesData = transitions.map((transition)=>({
                transitionId: Number(transition.transitionId),
                transitionName: transition.name,
                targetStatusId: Number(transition.toStatusId),
                targetStatusName: thisColumn.name,
                targetStatusCategory: (0, $8Qd0L.statusCategoryForId)(// @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<{ undefined: 1; new: 2; done: 3; indeterminate: 4; }>'.
                (0, $8Qd0L.StatusCategoryIds)[thisColumn.statusCategory]),
                isAvailable: true,
                isGlobal: transition.isGlobal
            }));
        if (hasMultipleTransitions) {
            if (transitionZonesData.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkDS9.ColumnTransitionZonesContainer), {
                hasSwimlanes: false,
                columnId: columnId,
                sourceColumnId: sourceId,
                sourceStatus: sourceStatus,
                transitions: transitionZonesData,
                hoverIntent: cardDragState.hoverIntent,
                columnDraggingOver: cardDragState.columnId,
                notAvailableMessage: (0, $iWb3Z.default).notAvailableMessage,
                onCardDragOver: onCardDragOver(columnId),
                onTransitionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            });
            if (sourceId !== columnId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31c6ffe2dc1acc78$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6M3O.NoTransitionsAvailableMessageContainer), {
                featureView: featureView
            }, formatMessage((0, $iWb3Z.default).transitionUnavailableMessage)));
        }
        return null;
    }, [
        cardDragState.columnId,
        cardDragState.hoverIntent,
        cardDragState.issue,
        columnId,
        featureView,
        formatMessage,
        hasMultipleTransitions,
        isGroupedByStatus,
        onCardDragOver,
        sourceColumn,
        sourceId,
        thisColumn,
        transitions
    ]);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31c6ffe2dc1acc78$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gkDS9", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $da3b39719fc7555e$export$169a50ebb52c9a6);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $fIrnI = parcelRequire("fIrnI");

var $983OU = parcelRequire("983OU");

var $cZAdR = parcelRequire("cZAdR");

var $43lbs = parcelRequire("43lbs");

var $drPpx = parcelRequire("drPpx");
class $da3b39719fc7555e$export$169a50ebb52c9a6 extends (0, $eUqFw.Component) {
    render() {
        const { transitions: allTransitions, hasSwimlanes: hasSwimlanes, hoverIntent: hoverIntent, columnId: columnId, sourceColumnId: sourceColumnId, sourceStatus: sourceStatus, showAllTransitionZones: showAllTransitionZones, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone } = this.props;
        let transitions = allTransitions;
        if (!showAllTransitionZones && columnId === sourceColumnId) {
            transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
            if (transitions.length === 0) return null;
        }
        if (!showAllTransitionZones && columnId === sourceColumnId && !this.state.allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43lbs.default), {
            onHover: this.onHoverOverTransitionToZone
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $983OU.OuterContainer), {
            "data-testid": "platform-board-kit-legacy-dnd.ui.column.column-transition-zones-container.outer-container",
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
            isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
            hasSwimlanes: hasSwimlanes,
            onMouseLeave: this.onMouseLeaveColumn,
            onMouseUp: this.onMouseUpEvent,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone)
        }, this.renderTransitions(transitions));
    }
    constructor(...args){
        super(...args);
        this.state = {
            allowSelfColumnTransitions: false,
            intendToDrop: false,
            intendedTransitionId: null
        };
        this.containerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.onMouseOverTransition = (transitionId, hoverIntentOnZone)=>{
            const { columnId: columnId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent } = this.props;
            const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
            // storing the intended transitionId in state, as the ColumnTransitionZone are hidden
            // once hoverIntent is confirmed, and mouseUp event will not trigger from ColumnTransitionZone
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(transitionId) && hoverIntentOnZone) this.setState({
                intendedTransitionId: transitionId
            });
        };
        this.onMouseLeaveColumn = ()=>{
            // mouseup event confirms that user intend to drop the card over the transition zone
            // using check `intendToDrop`== true, we wont dispatch onCardDragover
            if (!this.state.intendToDrop) this.props.onCardDragOver(null, false);
            this.setState({
                allowSelfColumnTransitions: false,
                intendToDrop: false,
                intendedTransitionId: null
            });
        };
        this.onHoverOverTransitionToZone = ()=>{
            this.setState({
                allowSelfColumnTransitions: true
            });
        };
        // mouseup event is fired when card is dropped over the transition zone div
        this.onTransitionSelection = (transitionId)=>{
            this.props.onTransitionSelected(transitionId);
            this.setState({
                intendToDrop: true,
                intendedTransitionId: null
            });
        };
        // When hoverIntent is confirmed & ColumnTransitionZone is hidden
        // and card is dropped in column, no MouseupEvent triggered from `ColumnTransitionZone`,
        // in that case TransitionId is not available.
        // IntendedTransitionId stored in the state is used as selectedTransitionId
        this.onMouseUpEvent = (e)=>{
            e.stopPropagation();
            if (this.state.intendedTransitionId !== null) this.props.onTransitionSelected(this.state.intendedTransitionId);
            this.setState({
                intendToDrop: true,
                intendedTransitionId: null
            });
        };
        this.renderTransitions = (transitions)=>{
            const { hasSwimlanes: hasSwimlanes, hoverIntent: hoverIntent, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, columnId: columnId, swimlaneId: swimlaneId } = this.props;
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIrnI.LoadingContainer), null);
            if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $983OU.InnerContainer), {
                "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container",
                hasSwimlanes: hasSwimlanes,
                zoneCount: transitions.length,
                shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
                innerRef: this.containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZAdR.NoTransitionContainer), {
                noTransitionMessage: noTransitionMessage
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $983OU.InnerContainer), {
                "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container",
                hasSwimlanes: hasSwimlanes,
                zoneCount: transitions.length,
                shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
                innerRef: this.containerRef
            }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
                const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
                const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $drPpx.default), {
                    key: transitionId,
                    isHidden: hoverIntent,
                    transitionId: transitionId,
                    transitionName: filteredTransitionName,
                    targetStatusName: targetStatusName,
                    onDragOver: this.onMouseOverTransition,
                    targetStatusCategory: targetStatusCategory,
                    isTransitionAvailable: isAvailable,
                    isTransitionGlobal: isGlobal,
                    notAvailableMessage: notAvailableMessage,
                    sourceStatus: filteredSourceStatus,
                    onTransitionSelection: this.onTransitionSelection,
                    hideSourceStatusInLabel: hideSourceStatusInLabel,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                });
            }));
        };
    }
}

});
parcelRegister("43lbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b54dc9ed574c2c0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");

var $iIzf3 = parcelRequire("iIzf3");
const $7b54dc9ed574c2c0$var$hoverIntentDelayMs = 100;
const $7b54dc9ed574c2c0$var$messages = (0, $90IgZ.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit-legacy-dnd.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
class $7b54dc9ed574c2c0$var$ColumnTransitionToZoneOld extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b54dc9ed574c2c0$var$TransitionToZone, {
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
            onMouseEnter: this.onMouseEnter,
            onMouseMove: this.debouncedHoverIntent,
            onMouseLeave: this.onMouseLeave,
            isDraggingOver: this.state.isDraggingOver
        }, this.props.intl.formatMessage($7b54dc9ed574c2c0$var$messages.transitionTo));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isDraggingOver: false
        };
        this.debouncedHoverIntent = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.props.onHover, $7b54dc9ed574c2c0$var$hoverIntentDelayMs);
        this.onMouseEnter = ()=>{
            this.debouncedHoverIntent.cancel();
            this.debouncedHoverIntent();
            this.setState({
                isDraggingOver: true
            });
        };
        this.onMouseLeave = ()=>{
            this.debouncedHoverIntent.cancel();
            this.setState({
                isDraggingOver: false
            });
        };
    }
}
const $7b54dc9ed574c2c0$var$ColumnTransitionToZoneOldWithIntl = (0, $giAhk.injectIntlV2)($7b54dc9ed574c2c0$var$ColumnTransitionToZoneOld);
var $7b54dc9ed574c2c0$export$2e2bcd8739ae039 = $7b54dc9ed574c2c0$var$ColumnTransitionToZoneOldWithIntl;
const $7b54dc9ed574c2c0$var$ttZoneHeight = (0, $iIzf3.minCardHeight) * 0.5 - 5;
const $7b54dc9ed574c2c0$var$ttZoneMargin = (0, $iIzf3.layout).adg3smallGutter * 0.5;
const $7b54dc9ed574c2c0$var$ttZoneMarginTop = -($7b54dc9ed574c2c0$var$ttZoneHeight + (0, $iIzf3.layout).adg3smallGutter); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b54dc9ed574c2c0$var$TransitionToZoneControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-62tuvw-0"
})`position:sticky;text-align:center;pointer-events:all !important;top:0;margin:${$7b54dc9ed574c2c0$var$ttZoneMarginTop}px ${$7b54dc9ed574c2c0$var$ttZoneMargin}px ${$7b54dc9ed574c2c0$var$ttZoneMargin}px;border:2px solid ${(props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $PdmhA).B300})` : `var(--ds-border-brand, ${(0, $PdmhA).B100})`};background-color:${(props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).B75})` : `var(--ds-background-selected, ${(0, $PdmhA).B50})`};height:${$7b54dc9ed574c2c0$var$ttZoneHeight}px;line-height:${$7b54dc9ed574c2c0$var$ttZoneHeight}px;width:calc(100% - ${(0, $iIzf3.layout).adg3smallGutter * 1.5}px);z-index:10;border-radius:${(0, $iIzf3.layout).cardListRadius}px;`;
const $7b54dc9ed574c2c0$var$TransitionToZoneExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u _2rkoi2wt",
            __cmplp.isDraggingOver ? "_19itoh42" : "_19itoh42",
            __cmplp.isDraggingOver ? "_bfhkwtfv" : "_bfhk29zg",
            __cmplp.className
        ])
    });
});
const $7b54dc9ed574c2c0$var$TransitionToZone = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7b54dc9ed574c2c0$var$TransitionToZoneExperiment, $7b54dc9ed574c2c0$var$TransitionToZoneControl);

});

parcelRegister("drPpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $be023a1915ddedf8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $dxIU5 = parcelRequire("dxIU5");

var $PdmhA = parcelRequire("PdmhA");

var $iIzf3 = parcelRequire("iIzf3");


var $jYyfN = parcelRequire("jYyfN");
class $be023a1915ddedf8$export$42263b16cc2f68eb extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            LabelComponent: (0, $jYyfN.default)
        };
    }
    componentWillUnmount() {
        this.debouncedHoverIntent.cancel();
    }
    render() {
        const { targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, LabelComponent: LabelComponent, hideSourceStatusInLabel: hideSourceStatusInLabel } = this.props;
        const { preferredHeight: preferredHeight } = this.state;
        const labelEl = LabelComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LabelComponent, {
            source: hideSourceStatusInLabel ? null : transitionName,
            sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
            target: targetStatusName,
            targetStatusCategory: targetStatusCategory,
            isTransitionAvailable: isTransitionAvailable,
            isTransitionGlobal: isTransitionGlobal,
            showMessage: preferredHeight > (0, $9f45f53a8ada9764$export$b2112118f902d683),
            notAvailableMessage: notAvailableMessage
        }) : null;
        const commonProps = {
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseMove: this.debouncedHoverIntent,
            isTransitionAvailable: isTransitionAvailable,
            onMouseUp: this.handleMouseUpEvent
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be023a1915ddedf8$export$2de257552dc02bf, {
            ref: this.zoneRef,
            ...commonProps,
            "data-testid": "platform-board-kit-legacy-dnd.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
        }, labelEl);
    }
    constructor(...args){
        super(...args);
        this.state = {
            preferredHeight: 0
        };
        this.zoneRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.handleCardDrag = (hoverIntent)=>{
            const { onDragOver: onDragOver, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden } = this.props;
            if (isHidden) return;
            if (isTransitionAvailable) onDragOver(transitionId, hoverIntent);
            else onDragOver(null, false);
        };
        this.handleCardDragHoverIntent = ()=>this.handleCardDrag(true);
        this.handleMouseLeave = ()=>{
            this.debouncedHoverIntent.cancel();
        };
        this.handleMouseEnter = ()=>{
            this.handleCardDrag(false);
        };
        this.debouncedHoverIntent = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.handleCardDragHoverIntent, (0, $9f45f53a8ada9764$export$c28377001f14d9d));
        this.handleMouseUpEvent = (e)=>{
            const { transitionId: transitionId, isHidden: isHidden, isTransitionAvailable: isTransitionAvailable, onTransitionSelection: onTransitionSelection } = this.props;
            if (isHidden || !isTransitionAvailable) return;
             // Stop event bubbling up the parent container as we have prop to handle
            // Also parent container has separate mouseUp Event handler for other scenario
            e.stopPropagation();
            onTransitionSelection(transitionId);
        };
    }
}
var $be023a1915ddedf8$export$2e2bcd8739ae039 = $be023a1915ddedf8$export$42263b16cc2f68eb;
const $be023a1915ddedf8$var$borderWidth = 2; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $be023a1915ddedf8$var$borderRadius = `${(0, $iIzf3.layout).cardListRadius}px`;
const $be023a1915ddedf8$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $PdmhA).B300})` : `var(--ds-border-focused, ${(0, $PdmhA).B200})`;
const $be023a1915ddedf8$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $PdmhA).B75})` : `var(--ds-background-selected, ${(0, $PdmhA).B50})`;
const $be023a1915ddedf8$var$getBorder = (props)=>({
        border: `${$be023a1915ddedf8$var$borderWidth}px solid ${!props.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})` : $be023a1915ddedf8$var$getAvailableBorderColour(props)}`
    });
const $be023a1915ddedf8$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? `var(--ds-background-danger, ${(0, $PdmhA).R50})` : $be023a1915ddedf8$var$getDraggingBackgroundColour(props)}`
    }); // eslint-disable-next-line jira/compiled/styled-components-usages, jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $be023a1915ddedf8$export$202434b85807ad98 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1i7mu1b-0"
})((props)=>({
        flex: '1 1 auto',
        flexDirection: 'column',
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: "var(--ds-space-075, 6px)",
        pointerEvents: 'all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$be023a1915ddedf8$var$getBackgroundColor(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            borderRadius: `${$be023a1915ddedf8$var$borderRadius} ${$be023a1915ddedf8$var$borderRadius} 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:last-child': {
            borderRadius: `0 0 ${$be023a1915ddedf8$var$borderRadius} ${$be023a1915ddedf8$var$borderRadius}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:only-child': {
            borderRadius: $be023a1915ddedf8$var$borderRadius
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:last-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBottom: props.isDraggingOver ? 'auto' : 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.isDraggingOver && {
            '+ div': {
                borderTop: 'none'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$be023a1915ddedf8$var$getBorder(props)
    })); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $be023a1915ddedf8$export$2de257552dc02bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rkfzum": (0, $9t7rW.default)(`${$be023a1915ddedf8$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})` : $be023a1915ddedf8$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $9t7rW.default)($be023a1915ddedf8$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $9t7rW.default)($be023a1915ddedf8$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19it31oo _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhktaeo" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iWb3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a44afdadf68d1af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a44afdadf68d1af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notAvailableMessage: {
        "id": "work-management-board.board-old.column-old.transition-zones.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    transitionNotAvailableMessage: {
        "id": "work-management-board.board-old.column-old.transition-zones.transition-not-available-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    },
    transitionUnavailableMessage: {
        "id": "work-management-board.board-old.column-old.transition-zones.transition-unavailable-message",
        "defaultMessage": "Unable to move this item to this column due to workflow restrictions"
    }
});

});

parcelRegister("g6M3O", function(module, exports) {

$parcel$export(module.exports, "NoTransitionsAvailableMessageContainer", () => $9e1d602a81ed0fb5$export$540b7d6bb641b182);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $ib4WI = parcelRequire("ib4WI");
const $9e1d602a81ed0fb5$export$540b7d6bb641b182 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { featureView: featureView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6mdojg": (0, $9t7rW.default)(`min(
${''}
                  calc(100% - ${(0, $ib4WI.COLUMN_HEADER_HEIGHT) + 4}px),
${''}
                  calc(100vh - ${(0, $ib4WI.BOARD_VIEW_COLUMNS_OFFSET)[__cmplp.featureView]}px)
              )`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _bfhktaeo _2rkoi2wt _kqsw1if8 _154ickbl _4t3i1osq _4cvr1h6o _1bah1h6o _1yt4119w _19it1567 _1pbykb7n _c71l2bqx",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eCs6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $183573ccec30a3e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $ib4WI = parcelRequire("ib4WI");

var $58VVU = parcelRequire("58VVU");

var $bZapc = parcelRequire("bZapc");

var $57bD3 = parcelRequire("57bD3");

var $fc5Rd = parcelRequire("fc5Rd");

var $b3Iom = parcelRequire("b3Iom");

var $ep9aA = parcelRequire("ep9aA");
var $183573ccec30a3e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)(({ scrollRef: scrollRef, boardSize: boardSize, cardRenderer: cardRenderer, issues: issues, footer: footer, dndSnapshot: dndSnapshot, isClone: isClone, isCollapsedColumn: isCollapsedColumn })=>{
    // re-renders VirtualCards to make sure cards height is re-calculated when the column is expanded
    const { isCollapsed: isCollapsed } = (0, $58VVU.useExpandVirtualCards)(isCollapsedColumn);
    (0, $bZapc.useSelectedFields)();
    const useObserver = (0, $eUqFw.useCallback)(()=>boardSize, [
        boardSize
    ]);
    const { virtualItems: virtualItems, totalSize: totalSize, scrollToIndex: scrollToIndex, onBoardCardResize: onBoardCardResize } = (0, $fc5Rd.useVirtualItems)({
        scrollRef: scrollRef,
        size: isCollapsed ? 0 : issues.length,
        overscan: 5,
        // @ts-expect-error undefined is not assignable to `useObserver`
        useObserver: isClone !== true ? useObserver : undefined,
        keyExtractor: (index)=>issues[index].id
    });
    const scrollToLastElement = (0, $eUqFw.useCallback)(()=>{
        scrollToIndex(issues.length, {
            align: 'start'
        });
    }, [
        scrollToIndex,
        issues.length
    ]);
    // Take care when modifying this code. The scrollToLastElement prop must be
    // passed to the footer component as it is expected to be present at all
    // times in the underlying InlineCreate component.
    const scrollableFooter = (0, $eUqFw.useMemo)(()=>footer !== undefined && footer !== null && /*#__PURE__*/ (0, $eUqFw.isValidElement)(footer) ? /*#__PURE__*/ (0, $eUqFw.cloneElement)(footer, {
            scrollToLastElement: scrollToLastElement
        }) : footer, [
        scrollToLastElement,
        footer
    ]);
    const cards = (0, $eUqFw.useMemo)(()=>virtualItems.map((item)=>({
                issue: issues[item.index],
                cardIndex: item.index,
                positionY: item.start,
                onMeasureRef: item.measureRef,
                height: item.size,
                isDraggingCard: (dndSnapshot?.draggingFromThisWith || '').indexOf(String(issues[item.index]?.id)) > -1
            })).filter((item)=>!!item.issue), [
        dndSnapshot?.draggingFromThisWith,
        issues,
        virtualItems
    ]);
    const height = (0, $ep9aA.useReactBeautifulDnDElementHeight)(dndSnapshot);
    if (isCollapsed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $57bD3.BoardVirtualizationProvider), {
        onBoardCardResize: onBoardCardResize
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3Iom.VirtualCardsContainer), {
        "data-testid": "work-management-board.ui.board-old.column-old.virtual-cards-old.virtual-cards-container",
        height: totalSize + height
    }, cards.map((card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3Iom.VirtualCardWrapper), {
            key: card.issue.id,
            "data-testid": "work-management-board.ui.board-old.column-old.virtual-cards-old.virtual-cards-wrapper",
            // can't apply height and measure it at the same time - it leads to infinite renders
            ref: card.isDraggingCard ? undefined : card.onMeasureRef,
            transform: card.positionY
        }, cardRenderer({
            issue: card.issue,
            cardIndex: card.cardIndex
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $ib4WI.VIEW_EXPERIENCE)
    })), isClone !== true && scrollableFooter);
});

});
parcelRegister("fc5Rd", function(module, exports) {

$parcel$export(module.exports, "useVirtualItems", () => $7f5e7d338c4afd75$export$abab86144679540);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gi5DZ = parcelRequire("gi5DZ");

var $2jdHI = parcelRequire("2jdHI");
const $7f5e7d338c4afd75$var$DEFAULT_OVERSCAN = 2;
const $7f5e7d338c4afd75$export$cda75f54a5f66bc0 = ()=>{
    const [layoutReady, setLayoutReady] = (0, $eUqFw.useState)(false);
    // react-virtual re-calculates elements when layout is ready
    // we need to make sure we don't wastefully render columns before that
    (0, $eUqFw.useLayoutEffect)(()=>{
        setLayoutReady(true);
    }, []);
    return layoutReady;
};
const $7f5e7d338c4afd75$var$emptyMeta = {
    virtualItems: [],
    totalSize: 0,
    scrollToIndex: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onBoardCardResize: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $7f5e7d338c4afd75$export$abab86144679540 = ({ scrollRef: scrollRef, size: size, estimateSize: estimateSize, horizontal: horizontal, overscan: overscan = $7f5e7d338c4afd75$var$DEFAULT_OVERSCAN, useObserver: useObserver, rangeExtractor: rangeExtractor, keyExtractor: keyExtractor })=>{
    const layoutReady = $7f5e7d338c4afd75$export$cda75f54a5f66bc0();
    // We want to trigger a re-render to correctly display the updated height of board cards
    const [, setShouldRecalculateVirtualization] = (0, $eUqFw.useState)(0);
    const [onBoardCardResize] = (0, $2jdHI.default)(()=>{
        setShouldRecalculateVirtualization((prevCount)=>prevCount + 1);
    }, 250);
    const meta = (0, $gi5DZ.useVirtual)({
        size: size,
        horizontal: horizontal,
        parentRef: scrollRef,
        estimateSize: estimateSize,
        overscan: overscan,
        useObserver: useObserver,
        rangeExtractor: rangeExtractor,
        keyExtractor: keyExtractor
    });
    return {
        ...layoutReady ? meta : $7f5e7d338c4afd75$var$emptyMeta,
        onBoardCardResize: onBoardCardResize
    };
};

});
parcelRegister("gi5DZ", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $36306a34326f13e7$export$ebc1863da693699a);

var $eUqFw = parcelRequire("eUqFw");
function $36306a34326f13e7$var$_extends() {
    $36306a34326f13e7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36306a34326f13e7$var$_extends.apply(this, arguments);
}
function $36306a34326f13e7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $36306a34326f13e7$var$props = [
    'bottom',
    'height',
    'left',
    'right',
    'top',
    'width'
];
var $36306a34326f13e7$var$rectChanged = function rectChanged(a, b) {
    if (a === void 0) a = {};
    if (b === void 0) b = {};
    return $36306a34326f13e7$var$props.some(function(prop) {
        return a[prop] !== b[prop];
    });
};
var $36306a34326f13e7$var$observedNodes = /*#__PURE__*/ new Map();
var $36306a34326f13e7$var$rafId;
var $36306a34326f13e7$var$run = function run() {
    var changedStates = [];
    $36306a34326f13e7$var$observedNodes.forEach(function(state, node) {
        var newRect = node.getBoundingClientRect();
        if ($36306a34326f13e7$var$rectChanged(newRect, state.rect)) {
            state.rect = newRect;
            changedStates.push(state);
        }
    });
    changedStates.forEach(function(state) {
        state.callbacks.forEach(function(cb) {
            return cb(state.rect);
        });
    });
    $36306a34326f13e7$var$rafId = window.requestAnimationFrame(run);
};
function $36306a34326f13e7$var$observeRect(node, cb) {
    return {
        observe: function observe() {
            var wasEmpty = $36306a34326f13e7$var$observedNodes.size === 0;
            if ($36306a34326f13e7$var$observedNodes.has(node)) $36306a34326f13e7$var$observedNodes.get(node).callbacks.push(cb);
            else $36306a34326f13e7$var$observedNodes.set(node, {
                rect: undefined,
                hasRectChanged: false,
                callbacks: [
                    cb
                ]
            });
            if (wasEmpty) $36306a34326f13e7$var$run();
        },
        unobserve: function unobserve() {
            var state = $36306a34326f13e7$var$observedNodes.get(node);
            if (state) {
                // Remove the callback
                var index = state.callbacks.indexOf(cb);
                if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference
                if (!state.callbacks.length) $36306a34326f13e7$var$observedNodes["delete"](node); // Stop the loop
                if (!$36306a34326f13e7$var$observedNodes.size) cancelAnimationFrame($36306a34326f13e7$var$rafId);
            }
        }
    };
}
var $36306a34326f13e7$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect;
function $36306a34326f13e7$var$useRect(nodeRef) {
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(nodeRef.current), element = _React$useState[0], setElement = _React$useState[1];
    var _React$useReducer = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useReducer($36306a34326f13e7$var$rectReducer, null), rect = _React$useReducer[0], dispatch = _React$useReducer[1];
    var initialRectSet = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    $36306a34326f13e7$var$useIsomorphicLayoutEffect(function() {
        if (nodeRef.current !== element) setElement(nodeRef.current);
    });
    $36306a34326f13e7$var$useIsomorphicLayoutEffect(function() {
        if (element && !initialRectSet.current) {
            initialRectSet.current = true;
            var _rect = element.getBoundingClientRect();
            dispatch({
                rect: _rect
            });
        }
    }, [
        element
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(function() {
        if (!element) return;
        var observer = $36306a34326f13e7$var$observeRect(element, function(rect) {
            dispatch({
                rect: rect
            });
        });
        observer.observe();
        return function() {
            observer.unobserve();
        };
    }, [
        element
    ]);
    return rect;
}
function $36306a34326f13e7$var$rectReducer(state, action) {
    var rect = action.rect;
    if (!state || state.height !== rect.height || state.width !== rect.width) return rect;
    return state;
}
var $36306a34326f13e7$var$defaultEstimateSize = function defaultEstimateSize() {
    return 50;
};
var $36306a34326f13e7$var$defaultKeyExtractor = function defaultKeyExtractor(index) {
    return index;
};
var $36306a34326f13e7$var$defaultMeasureSize = function defaultMeasureSize(el, horizontal) {
    var key = horizontal ? 'offsetWidth' : 'offsetHeight';
    return el[key];
};
var $36306a34326f13e7$export$7eb7cb13fd21e5e1 = function defaultRangeExtractor(range) {
    var start = Math.max(range.start - range.overscan, 0);
    var end = Math.min(range.end + range.overscan, range.size - 1);
    var arr = [];
    for(var i = start; i <= end; i++)arr.push(i);
    return arr;
};
function $36306a34326f13e7$export$ebc1863da693699a(_ref) {
    var _ref3, _measurements;
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 0 : _ref$size, _ref$estimateSize = _ref.estimateSize, estimateSize = _ref$estimateSize === void 0 ? $36306a34326f13e7$var$defaultEstimateSize : _ref$estimateSize, _ref$overscan = _ref.overscan, overscan = _ref$overscan === void 0 ? 1 : _ref$overscan, _ref$paddingStart = _ref.paddingStart, paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart, _ref$paddingEnd = _ref.paddingEnd, paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd, parentRef = _ref.parentRef, horizontal = _ref.horizontal, scrollToFn = _ref.scrollToFn, useObserver = _ref.useObserver, onScrollElement = _ref.onScrollElement, scrollOffsetFn = _ref.scrollOffsetFn, _ref$keyExtractor = _ref.keyExtractor, keyExtractor = _ref$keyExtractor === void 0 ? $36306a34326f13e7$var$defaultKeyExtractor : _ref$keyExtractor, _ref$measureSize = _ref.measureSize, measureSize = _ref$measureSize === void 0 ? $36306a34326f13e7$var$defaultMeasureSize : _ref$measureSize, _ref$rangeExtractor = _ref.rangeExtractor, rangeExtractor = _ref$rangeExtractor === void 0 ? $36306a34326f13e7$export$7eb7cb13fd21e5e1 : _ref$rangeExtractor;
    var sizeKey = horizontal ? 'width' : 'height';
    var scrollKey = horizontal ? 'scrollLeft' : 'scrollTop';
    var latestRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef({
        scrollOffset: 0,
        measurements: []
    });
    var useMeasureParent = useObserver || $36306a34326f13e7$var$useRect;
    var _ref2 = useMeasureParent(parentRef) || (_ref3 = {}, _ref3[sizeKey] = 0, _ref3), outerSize = _ref2[sizeKey];
    latestRef.current.outerSize = outerSize;
    var defaultScrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function(offset) {
        if (parentRef.current) parentRef.current[scrollKey] = offset;
    }, [
        parentRef,
        scrollKey
    ]);
    var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
    scrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function(offset) {
        resolvedScrollToFn(offset, defaultScrollToFn);
    }, [
        defaultScrollToFn,
        resolvedScrollToFn
    ]);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState({}), measuredCache = _React$useState[0], setMeasuredCache = _React$useState[1];
    var measure = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function() {
        return setMeasuredCache({});
    }, []);
    var pendingMeasuredCacheIndexesRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef([]);
    var measurements = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(function() {
        var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
        pendingMeasuredCacheIndexesRef.current = [];
        var measurements = latestRef.current.measurements.slice(0, min);
        for(var i = min; i < size; i++){
            var key = keyExtractor(i);
            var measuredSize = measuredCache[key];
            var start = measurements[i - 1] ? measurements[i - 1].end : paddingStart;
            var _size = typeof measuredSize === 'number' ? measuredSize : estimateSize(i);
            var end = start + _size;
            measurements[i] = {
                index: i,
                start: start,
                size: _size,
                end: end,
                key: key
            };
        }
        return measurements;
    }, [
        estimateSize,
        measuredCache,
        paddingStart,
        size,
        keyExtractor
    ]);
    var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || 0) + paddingEnd;
    latestRef.current.measurements = measurements;
    latestRef.current.totalSize = totalSize;
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState({
        start: 0,
        end: 0
    }), range = _React$useState2[0], setRange = _React$useState2[1];
    var element = onScrollElement ? onScrollElement.current : parentRef.current;
    var scrollOffsetFnRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(scrollOffsetFn);
    scrollOffsetFnRef.current = scrollOffsetFn;
    var rangeTimeoutIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    var cancelAsyncRange = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function() {
        if (rangeTimeoutIdRef.current !== null) {
            clearTimeout(rangeTimeoutIdRef.current);
            rangeTimeoutIdRef.current = null;
        }
    }, []);
    $36306a34326f13e7$var$useIsomorphicLayoutEffect(function() {
        rangeTimeoutIdRef.current = setTimeout(function() {
            setRange(function(prevRange) {
                return $36306a34326f13e7$var$calculateRange(latestRef.current, prevRange);
            });
        });
        return function() {
            return cancelAsyncRange();
        };
    }, [
        measurements,
        outerSize,
        cancelAsyncRange
    ]);
    $36306a34326f13e7$var$useIsomorphicLayoutEffect(function() {
        if (!element) {
            setRange({
                start: 0,
                end: 0
            });
            latestRef.current.scrollOffset = 0;
            return;
        }
        var onScroll = function onScroll(event) {
            var scrollOffset = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
            latestRef.current.scrollOffset = scrollOffset;
            cancelAsyncRange();
            setRange(function(prevRange) {
                return $36306a34326f13e7$var$calculateRange(latestRef.current, prevRange);
            });
        }; // Determine initially visible range
        onScroll();
        element.addEventListener('scroll', onScroll, {
            capture: false,
            passive: true
        });
        return function() {
            element.removeEventListener('scroll', onScroll);
        };
    }, [
        element,
        scrollKey,
        cancelAsyncRange
    ]);
    var measureSizeRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(measureSize);
    measureSizeRef.current = measureSize;
    var virtualItems = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(function() {
        var indexes = rangeExtractor({
            start: range.start,
            end: range.end,
            overscan: overscan,
            size: measurements.length
        });
        var virtualItems = [];
        var _loop = function _loop(k, len) {
            var i = indexes[k];
            var measurement = measurements[i];
            var item = $36306a34326f13e7$var$_extends($36306a34326f13e7$var$_extends({}, measurement), {}, {
                measureRef: function measureRef(el) {
                    if (el) {
                        var measuredSize = measureSizeRef.current(el, horizontal);
                        if (measuredSize !== item.size) {
                            var scrollOffset = latestRef.current.scrollOffset;
                            if (item.start < scrollOffset) defaultScrollToFn(scrollOffset + (measuredSize - item.size));
                            pendingMeasuredCacheIndexesRef.current.push(i);
                            setMeasuredCache(function(old) {
                                var _extends2;
                                return $36306a34326f13e7$var$_extends($36306a34326f13e7$var$_extends({}, old), {}, (_extends2 = {}, _extends2[item.key] = measuredSize, _extends2));
                            });
                        }
                    }
                }
            });
            virtualItems.push(item);
        };
        for(var k = 0, len = indexes.length; k < len; k++)_loop(k);
        return virtualItems;
    }, [
        defaultScrollToFn,
        horizontal,
        measurements,
        overscan,
        range.end,
        range.start,
        rangeExtractor
    ]);
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    $36306a34326f13e7$var$useIsomorphicLayoutEffect(function() {
        if (mountedRef.current) {
            if (estimateSize) setMeasuredCache({});
        }
        mountedRef.current = true;
    }, [
        estimateSize
    ]);
    var scrollToOffset = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function(toOffset, _temp) {
        var _ref4 = _temp === void 0 ? {} : _temp, _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'start' : _ref4$align;
        var _latestRef$current = latestRef.current, scrollOffset = _latestRef$current.scrollOffset, outerSize = _latestRef$current.outerSize;
        if (align === 'auto') {
            if (toOffset <= scrollOffset) align = 'start';
            else if (toOffset >= scrollOffset + outerSize) align = 'end';
            else align = 'start';
        }
        if (align === 'start') scrollToFn(toOffset);
        else if (align === 'end') scrollToFn(toOffset - outerSize);
        else if (align === 'center') scrollToFn(toOffset - outerSize / 2);
    }, [
        scrollToFn
    ]);
    var tryScrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function(index, _temp2) {
        var _ref5 = _temp2 === void 0 ? {} : _temp2, _ref5$align = _ref5.align, align = _ref5$align === void 0 ? 'auto' : _ref5$align, rest = $36306a34326f13e7$var$_objectWithoutPropertiesLoose(_ref5, [
            "align"
        ]);
        var _latestRef$current2 = latestRef.current, measurements = _latestRef$current2.measurements, scrollOffset = _latestRef$current2.scrollOffset, outerSize = _latestRef$current2.outerSize;
        var measurement = measurements[Math.max(0, Math.min(index, size - 1))];
        if (!measurement) return;
        if (align === 'auto') {
            if (measurement.end >= scrollOffset + outerSize) align = 'end';
            else if (measurement.start <= scrollOffset) align = 'start';
            else return;
        }
        var toOffset = align === 'center' ? measurement.start + measurement.size / 2 : align === 'end' ? measurement.end : measurement.start;
        scrollToOffset(toOffset, $36306a34326f13e7$var$_extends({
            align: align
        }, rest));
    }, [
        scrollToOffset,
        size
    ]);
    var scrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // We do a double request here because of
        // dynamic sizes which can cause offset shift
        // and end up in the wrong spot. Unfortunately,
        // we can't know about those dynamic sizes until
        // we try and render them. So double down!
        tryScrollToIndex.apply(void 0, args);
        requestAnimationFrame(function() {
            tryScrollToIndex.apply(void 0, args);
        });
    }, [
        tryScrollToIndex
    ]);
    return {
        virtualItems: virtualItems,
        totalSize: totalSize,
        scrollToOffset: scrollToOffset,
        scrollToIndex: scrollToIndex,
        measure: measure
    };
}
var $36306a34326f13e7$var$findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
    while(low <= high){
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $36306a34326f13e7$var$calculateRange(_ref6, prevRange) {
    var measurements = _ref6.measurements, outerSize = _ref6.outerSize, scrollOffset = _ref6.scrollOffset;
    var size = measurements.length - 1;
    var getOffset = function getOffset(index) {
        return measurements[index].start;
    };
    var start = $36306a34326f13e7$var$findNearestBinarySearch(0, size, getOffset, scrollOffset);
    var end = start;
    while(end < size && measurements[end].end < scrollOffset + outerSize)end++;
    if (prevRange.start !== start || prevRange.end !== end) return {
        start: start,
        end: end
    };
    return prevRange;
}

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});


parcelRegister("b3Iom", function(module, exports) {

$parcel$export(module.exports, "VirtualCardsContainer", () => $30d7ae77f5fe5c66$export$82c6cce01268fc2a);
$parcel$export(module.exports, "VirtualCardWrapper", () => $30d7ae77f5fe5c66$export$1e10594ee60765ff);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $30d7ae77f5fe5c66$export$82c6cce01268fc2a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i2nrh _otyrt94y",
            __cmplp.className
        ])
    });
});
const $30d7ae77f5fe5c66$export$1e10594ee60765ff = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1h5vma4": (0, $9t7rW.default)(`translateY(${__cmplp.transform}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _t9ec1ng1 _1e0c1txw _2lx21sxn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ep9aA", function(module, exports) {

$parcel$export(module.exports, "useReactBeautifulDnDElementHeight", () => $b29e4d9cadd54fb7$export$ab466d1fe45e64ae);

var $eUqFw = parcelRequire("eUqFw");
const $b29e4d9cadd54fb7$export$ab466d1fe45e64ae = (dndSnapshot)=>(0, $eUqFw.useMemo)(()=>{
        if (dndSnapshot.draggingFromThisWith != null) return 0;
        if (dndSnapshot.draggingOverWith == null) return 0;
        const element = document.querySelector(`[data-rbd-draggable-id="${dndSnapshot.draggingOverWith}"]`);
        return element ? element.clientHeight : 0;
    }, [
        dndSnapshot.draggingFromThisWith,
        dndSnapshot.draggingOverWith
    ]);

});



parcelRegister("ebQXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1be0ef1dff6183c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lqZQD = parcelRequire("lqZQD");

var $31StX = parcelRequire("31StX");
const $1be0ef1dff6183c8$var$IssueDeleteModal = /*#__PURE__*/ (0, $eUqFw.memo)(({ issue: issue, onClose: onClose })=>{
    const onDelete = (0, $lqZQD.useDeleteIssueAction)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, issue != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, formatMessage((0, $31StX.default).title, {
        itemKey: issue.key
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $31StX.default).warning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $31StX.default).recommendation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $31StX.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "danger",
        onClick: ()=>{
            onDelete(issue);
            onClose();
        },
        autoFocus: true
    }, formatMessage((0, $31StX.default).delete))))));
});
var $1be0ef1dff6183c8$export$2e2bcd8739ae039 = $1be0ef1dff6183c8$var$IssueDeleteModal;

});
parcelRegister("lqZQD", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssueAction", () => $d2917054cb4f552d$export$cccbeb9fd7c7846f);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ib4WI = parcelRequire("ib4WI");

var $lqN6D = parcelRequire("lqN6D");

var $1s3ZV = parcelRequire("1s3ZV");

var $h3O1d = parcelRequire("h3O1d");
const $d2917054cb4f552d$export$cccbeb9fd7c7846f = ()=>{
    const deleteIssue = (0, $1s3ZV.useDeleteIssue)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [, { pushToJobQueue: pushToJobQueue, removeIssue: removeIssue }] = (0, $lqN6D.useBoardStore)();
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $ib4WI.CARD_ACTION_DELETE_EXPERIENCE));
    return (0, $eUqFw.useCallback)((issue)=>{
        const { id: id, key: key } = issue;
        startExperience();
        pushToJobQueue(()=>deleteIssue({
                issueKey: key
            }).then(()=>{
                removeIssue(id);
                showFlag({
                    type: 'success',
                    title: (0, $h3O1d.default).deleteSuccessTitle,
                    description: (0, $h3O1d.default).deleteSuccessDescription
                });
                markExperienceSuccess();
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                    actionSubjectId: id
                }), 'issue deleted', {
                    throughActionCard: true,
                    issueId: issue.id
                });
            }).catch((err)=>{
                showFlag({
                    type: 'error',
                    title: (0, $h3O1d.default).deleteErrorTitle,
                    description: (0, $h3O1d.default).deleteErrorDescription
                });
                const reportedError = err && ((0, $JRB5w.isClientFetchError)(err) || (0, $7byHA.isValidationError)(err) || (0, $JRB5w.isHttpClientErrorResponse)(err));
                // Exclude client fetch, validation and 4xx errors from experience fail events reporting
                if (!reportedError) markExperienceFailed('delete issue failed', err);
                else markExperienceSuccess();
            }));
    }, [
        startExperience,
        pushToJobQueue,
        deleteIssue,
        removeIssue,
        showFlag,
        markExperienceSuccess,
        createAnalyticsEvent,
        markExperienceFailed
    ]);
};

});
parcelRegister("h3O1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdbefd48a203a25$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2fdbefd48a203a25$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteSuccessTitle: {
        "id": "work-management-board.controllers.delete-issue-old.delete-success-title",
        "defaultMessage": "Deleted item"
    },
    deleteSuccessDescription: {
        "id": "work-management-board.controllers.delete-issue-old.delete-success-description",
        "defaultMessage": "Item deleted successfully"
    },
    deleteErrorTitle: {
        "id": "work-management-board.controllers.delete-issue-old.delete-error-title",
        "defaultMessage": "Failed to delete item"
    },
    deleteErrorDescription: {
        "id": "work-management-board.controllers.delete-issue-old.delete-error-description",
        "defaultMessage": "Something went wrong while deleting the item. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("31StX", function(module, exports) {

$parcel$export(module.exports, "default", () => $949b766b0fb8b30f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $949b766b0fb8b30f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "work-management-board.board-old.delete-issue-modal.title",
        "defaultMessage": "Delete {itemKey}?"
    },
    warning: {
        "id": "work-management-board.board-old.delete-issue-modal.warning",
        "defaultMessage": "You're about to permanently delete this item and its comments, attachments, and all of its data."
    },
    recommendation: {
        "id": "work-management-board.board-old.delete-issue-modal.recommendation",
        "defaultMessage": "If you don't want to delete it, you can resolve or close it instead."
    },
    delete: {
        "id": "work-management-board.board-old.delete-issue-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "work-management-board.board-old.delete-issue-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("jOkkZ", function(module, exports) {

$parcel$export(module.exports, "EmptyBoardComponent", () => $535061722b7dbb85$export$7f64d91ed0b9fc41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $1p0YA = parcelRequire("1p0YA");

var $biIg1 = parcelRequire("biIg1");
const $535061722b7dbb85$export$7f64d91ed0b9fc41 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const emptyBoardTitle = formatMessage((0, $1p0YA.default).emptyBoardTitle);
    const emptyBoardDescription = formatMessage((0, $1p0YA.default).emptyBoardDescription);
    const buttonTitle = formatMessage((0, $1p0YA.default).emptyBoardCreateItem);
    const [, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const handleItemCreateClick = (0, $eUqFw.useCallback)((_e)=>{
        setInlineCreateParam('true');
    }, [
        setInlineCreateParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($535061722b7dbb85$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($535061722b7dbb85$var$EmptyBoardImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biIg1.Illustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $535061722b7dbb85$var$emptyBoardTextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($535061722b7dbb85$var$Header, null, emptyBoardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, emptyBoardDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ,
        testId: "work-management-board.ui.board.empty-state.today",
        onClick: handleItemCreateClick
    }, buttonTitle));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $535061722b7dbb85$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1kdj _19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1h6o _1yt41ejb _11q71xtf _2rkopd34",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $535061722b7dbb85$var$EmptyBoardImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $535061722b7dbb85$var$emptyBoardTextContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300',
    marginTop: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $535061722b7dbb85$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("biIg1", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $1d97b22b328b27ac$export$d43c2e2ca9b2c105);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $1d97b22b328b27ac$var$LazyIllustration = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dwVwQ")), {
    moduleId: "./src/packages/business/board/view/src/ui/board-old/empty-state/illustration/main.tsx"
});
const $1d97b22b328b27ac$export$d43c2e2ca9b2c105 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "illustration",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d97b22b328b27ac$var$LazyIllustration, null));

});
parcelRegister("dwVwQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7jVcX');
        const value = parcelRequire('PINin');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7jVcX").then(()=>parcelRequire('PINin'));
}

});



parcelRegister("b5yGB", function(module, exports) {

$parcel$export(module.exports, "Minimap", () => $a37252af8e99d57c$export$a8b4308ba35ee473);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9pngN = parcelRequire("9pngN");

var $8qP1z = parcelRequire("8qP1z");
var $kAck0 = parcelRequire("kAck0");

var $jK1pm = parcelRequire("jK1pm");

var $4mhKq = parcelRequire("4mhKq");
const $a37252af8e99d57c$export$a8b4308ba35ee473 = ()=>{
    const columns = (0, $4mhKq.useColumns)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-minimap-old"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8qP1z.default), {
        onScrollAttempted: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onShow: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAck0.default), {
            key: column.statusId
        })))));
};

});
parcelRegister("8qP1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea19acf0e14ad7e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2w3P7 = parcelRequire("2w3P7");


var $3QUrs = parcelRequire("3QUrs");
const $9ea19acf0e14ad7e$var$shouldShowMap = ({ scrollWidth: scrollWidth, clientWidth: clientWidth })=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    scrollWidth / clientWidth > (0, $b27bac51511aa71e$export$7acdcdf60f910755);
class $9ea19acf0e14ad7e$export$a8b4308ba35ee473 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            const { isShowing: isShowing } = this.state;
            const shouldShow = $9ea19acf0e14ad7e$var$shouldShowMap(nextProps);
            if (shouldShow !== isShowing) {
                if (shouldShow) this.props.onShow();
                this.setState({
                    isShowing: shouldShow
                });
            }
        };
        this.onScroll = (newOffset)=>{
            const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
            this.props.setHorizontalScroll(newOffset * scalingFactor);
        };
        this.getScalingFactor = (0, $5iWql.default)((scrollWidth)=>{
            const maxSizeScalingFactor = scrollWidth / (0, $b27bac51511aa71e$export$35f810a0d3987157);
            return Math.max((0, $b27bac51511aa71e$export$a5b78b73dbea576), maxSizeScalingFactor);
        });
        const isShowing = $9ea19acf0e14ad7e$var$shouldShowMap(props);
        if (isShowing) this.props.onShow();
        this.state = {
            isShowing: isShowing
        };
    }
    getDimensions() {
        const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
        return {
            outerWidth: this.props.scrollWidth / scalingFactor,
            innerWidth: this.props.clientWidth / scalingFactor,
            innerOffset: this.props.scrollLeft / scalingFactor
        };
    }
    render() {
        if (!this.state.isShowing) return null;
        const { outerWidth: outerWidth, innerWidth: innerWidth, innerOffset: innerOffset } = this.getDimensions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QUrs.default), {
            onScrollAttempted: this.props.onScrollAttempted,
            onScroll: this.onScroll,
            outerWidth: outerWidth,
            innerWidth: innerWidth,
            innerOffset: innerOffset
        }, this.props.children);
    }
}
const $9ea19acf0e14ad7e$var$MinimapMain = (props)=>{
    const [{ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth }, { onHorizontalScroll: onHorizontalScroll }] = (0, $2w3P7.useBoardScroll)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ea19acf0e14ad7e$export$a8b4308ba35ee473, {
        clientWidth: clientWidth,
        scrollLeft: scrollLeft,
        scrollWidth: scrollWidth,
        setHorizontalScroll: onHorizontalScroll,
        ...props
    });
};
var $9ea19acf0e14ad7e$export$2e2bcd8739ae039 = $9ea19acf0e14ad7e$var$MinimapMain;

});
/**
 * The width of the map is determined by the board size / scaling factor.
 * A lower number means a wider minimap.
 * The map will not exceed the maxMapWidth defined below.
 */ const $b27bac51511aa71e$export$a5b78b73dbea576 = 14;
const $b27bac51511aa71e$export$35f810a0d3987157 = 100;
const $b27bac51511aa71e$export$7acdcdf60f910755 = 1.1;

parcelRegister("3QUrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e07d8a241babce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $bAQOb = parcelRequire("bAQOb");

var $iIzf3 = parcelRequire("iIzf3");

var $cNlgf = parcelRequire("cNlgf");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9e07d8a241babce$var$RelativePositionStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $c9e07d8a241babce$var$MinimapStyleOld = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oa7p3z-0"
})({
    display: 'inline-flex',
    padding: "var(--ds-space-075, 6px)",
    background: "var(--ds-surface-overlay, white)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    boxShadow: `var(--ds-shadow-overlay, ${`4px 8px 14px 0 ${(0, $PdmhA).N50A}`})`,
    borderRadius: '3px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9e07d8a241babce$var$MinimapStyleNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1yt412x7 _11q71bhr _16qsacve _2rkoftgi",
            __cmplp.className
        ])
    });
});
const $c9e07d8a241babce$export$60ba57ef3cc9f0b = (0, $bAQOb.componentWithFF)('compiled.migration.jsw.tanuki', $c9e07d8a241babce$var$MinimapStyleNew, $c9e07d8a241babce$var$MinimapStyleOld);
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $c9e07d8a241babce$var$OuterViewStyleOld = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oa7p3z-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${props.outerWidth}px`,
        border: `1px solid ${"var(--ds-surface-overlay, white)"}`,
        borderRadius: '3px',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${0, $iIzf3.miniMapMapHeight}px`
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9e07d8a241babce$var$OuterViewStyleNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerWidth: outerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qlyx8j": (0, $9t7rW.default)(`${__cmplp.outerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbrmio _189et94y _2rko1l7b _1h6d1bhr _1e0c1txw _4t3i14no",
            __cmplp.className
        ])
    });
});
const $c9e07d8a241babce$var$OuterViewStyle = (0, $bAQOb.componentWithFF)('compiled.migration.jsw.tanuki', $c9e07d8a241babce$var$OuterViewStyleNew, $c9e07d8a241babce$var$OuterViewStyleOld);
class $c9e07d8a241babce$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e07d8a241babce$export$60ba57ef3cc9f0b, {
            "data-testid": "platform-board-kit.ui.minimap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e07d8a241babce$var$RelativePositionStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNlgf.default), {
            onScroll: this.props.onScroll,
            onScrollAttempted: this.props.onScrollAttempted,
            innerOffset: this.props.innerOffset,
            innerWidth: this.props.innerWidth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e07d8a241babce$var$OuterViewStyle, {
            outerWidth: this.props.outerWidth
        }, this.props.children));
    }
}

});
parcelRegister("cNlgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $86f46341c21a2d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $iIzf3 = parcelRequire("iIzf3");
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86f46341c21a2d38$var$InnerViewStyleControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "cg5gtg-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        top: "var(--ds-space-negative-025, -2px)",
        left: "var(--ds-space-negative-025, -2px)",
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `2px solid ${`var(--ds-border-brand, ${(0, $PdmhA).B100})`}`,
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${props.innerWidth}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${0, $iIzf3.miniMapMapHeight}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: props.isDragging ? // This looks different in dark mode but the colors used match between none/light/dark
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-border-focused, ${(0, $PdmhA).B200})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-border-brand, ${(0, $PdmhA).B100})`,
        cursor: 'move'
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86f46341c21a2d38$var$InnerViewStyleExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { innerWidth: innerWidth, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ekimo8": (0, $9t7rW.default)(__cmplp.innerWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_154i1i6y _1ltv1i6y _kqswstnw _19itypf5 _2rko1l7b _1bsb1mf3 _4t3i14no _80om15ng",
            __cmplp.isDragging ? "_1h6d194a" : "_1h6d1gvp",
            __cmplp.className
        ])
    });
});
const $86f46341c21a2d38$var$InnerViewStyle = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $86f46341c21a2d38$var$InnerViewStyleExperiment, $86f46341c21a2d38$var$InnerViewStyleControl); // eslint-disable-next-line jira/react/no-class-components
class $86f46341c21a2d38$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onMouseDown = (e)=>{
            if (e.button === 0) this.setState({
                isDragging: true,
                mouseStart: e.clientX,
                initialOffset: this.props.innerOffset
            });
        };
        this.onMouseUp = ()=>{
            // Because we have two mouseup event handlers, this can be fired twice
            // if the mouseup is over the minimap square.
            if (this.state.isDragging) {
                const scrollChanged = this.props.innerOffset !== this.state.initialOffset;
                this.props.onScrollAttempted(scrollChanged);
                this.setState({
                    isDragging: false
                });
            }
        };
        this.onMouseMove = (e)=>{
            if (this.state.isDragging && this.state.mouseStart !== null) {
                const mouseCurrent = e.clientX;
                this.props.onScroll(this.state.initialOffset + mouseCurrent - this.state.mouseStart);
            }
        };
        this.setElement = (element)=>{
            this.element = element;
            this.updateInnerViewPosition();
        };
        this.updateInnerViewPosition = ()=>{
            if (this.element) this.element.style.marginLeft = `${this.props.innerOffset}px`;
        };
        this.element = null;
        this.state = {
            isDragging: false,
            mouseStart: null,
            initialOffset: 0
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isDragging && !prevState.isDragging) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        } else if (!this.state.isDragging && !prevState.isDragging) this.cleanupListeners();
        this.updateInnerViewPosition();
    }
    componentWillUnmount() {
        this.cleanupListeners();
    }
    cleanupListeners() {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86f46341c21a2d38$var$InnerViewStyle, {
            "data-testid": "platform-board-kit.ui.minimap.inner-view",
            innerRef: this.setElement,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseMove: this.onMouseMove,
            isDragging: this.state.isDragging,
            innerWidth: this.props.innerWidth
        });
    }
}

});




parcelRegister("fdj8N", function(module, exports) {

$parcel$export(module.exports, "LoadingWrapper", () => $c1e2572714b35960$export$43a792a870d28db2);
$parcel$export(module.exports, "DraggingColumn", () => $c1e2572714b35960$export$52572d8beb69921b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c1e2572714b35960$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1b1v _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $c1e2572714b35960$export$52572d8beb69921b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_139ek9zm _80om5szm _8hrzn17g _1e0c1txw _cg411fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gOfjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59bdf78109078b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $1T0MC = parcelRequire("1T0MC");

var $iIzf3 = parcelRequire("iIzf3");

var $fc5Rd = parcelRequire("fc5Rd");

var $c2RKx = parcelRequire("c2RKx");
const $e59bdf78109078b8$var$VirtualColumns = ({ scrollRef: scrollRef, scrollElement: scrollElement, columns: columns, columnRenderer: columnRenderer, draggingColumnIndex: draggingColumnIndex, columnsHeight: columnsHeight, columnsRef: columnsRef })=>{
    const getColumnWidth = (0, $eUqFw.useCallback)((columnIndex)=>{
        const isColumnCollapsed = columnIndex != null && !!columns[columnIndex].isCollapsed;
        if (isColumnCollapsed) return 0, $iIzf3.collapsedColumnWithMarginWidth;
        return 0, $iIzf3.columnWithMarginWidth;
    }, [
        columns
    ]);
    const [boardSize, setBoardSize] = (0, $eUqFw.useState)({
        width: scrollElement.offsetWidth,
        height: scrollElement.offsetHeight
    });
    const useObserver = (0, $eUqFw.useCallback)(()=>boardSize, [
        boardSize
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resizeObserverCallback = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
        setBoardSize({
            width: scrollElement.offsetWidth,
            height: scrollElement.offsetHeight
        });
    }, 100), [
        scrollElement
    ]);
    // update board dimensions on browser resize
    (0, $1T0MC.useResizeObserver)(scrollElement, resizeObserverCallback);
    const { virtualItems: virtualItems, totalSize: totalSize } = (0, $fc5Rd.useVirtualItems)({
        horizontal: true,
        scrollRef: scrollRef,
        size: columns.length,
        estimateSize: getColumnWidth,
        useObserver: useObserver
    });
    const virtualItemsIndexes = virtualItems.map((item)=>item.index);
    // We can't dynamically add/remove Droppables during a drag on scroll, see https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/changes-while-dragging.md#rules
    // That's why all columns are rendered all the time no matter the scroll position, but "virtualized" columns have no cards.
    // That way we won't be dynamically adding Droppables, which fixes crads drag-n-drop.
    const virtualColumns = (0, $eUqFw.useMemo)(()=>columns.map((column, columnIndex)=>({
                column: column,
                columnIndex: columnIndex,
                boardSize: boardSize,
                isVirtualized: !virtualItemsIndexes.includes(columnIndex)
            })), [
        columns,
        boardSize,
        virtualItemsIndexes
    ]);
    const renderedColumns = virtualColumns.map((item)=>columnRenderer(item));
    // Adding a placeholder node here needed to insert space for the lifted item when using renderClone.
    // Normaly you'd "position: absolute" all items and wouldn't need placeholder,
    // but in case of columns it is hard to deal with position:absolute as parent height collapses,
    // which forces us to calculate columns height with JS on page load.
    // So instead, this dynamically inserted placeholder doesn't have TTI impact.
    if (draggingColumnIndex != null && draggingColumnIndex > -1) renderedColumns.splice(draggingColumnIndex, 0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2RKx.DraggingPlaceholder), {
        key: columns[draggingColumnIndex].id,
        width: getColumnWidth(draggingColumnIndex),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "work-management-board.ui.board.virtual-columns.dragging-placeholder"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2RKx.VirtualColumnsContainer), {
        ref: columnsRef,
        width: totalSize,
        // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
        height: columnsHeight,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "work-management-board.ui.board.virtual-columns.virtual-columns-container"
    }, renderedColumns);
};
var $e59bdf78109078b8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)(({ scrollRef: scrollRef, ...rest })=>{
    const [scrollElement, setScrollElement] = (0, $eUqFw.useState)(scrollRef.current);
    // make sure to render the columns when scrollRef is set
    (0, $eUqFw.useEffect)(()=>{
        if (scrollRef.current) setScrollElement(scrollRef.current);
    }, [
        scrollElement,
        scrollRef
    ]);
    // react-virtual sometimes renders blank page if we don't have this check
    if (!scrollElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e59bdf78109078b8$var$VirtualColumns, {
        scrollRef: scrollRef,
        scrollElement: scrollElement,
        ...rest
    });
});

});
parcelRegister("1T0MC", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $e148d161081077aa$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
const $e148d161081077aa$export$683480f191c0e3ea = (element, callback)=>{
    (0, $eUqFw.useEffect)(()=>{
        let resizeObserver;
        if (element && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(element);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        element,
        callback
    ]);
    return null;
};

});

parcelRegister("c2RKx", function(module, exports) {

$parcel$export(module.exports, "VirtualColumnsContainer", () => $97d809cb75b25185$export$92b7d5e5faa461a9);
$parcel$export(module.exports, "DraggingPlaceholder", () => $97d809cb75b25185$export$e6e0cf36ad720e4e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $97d809cb75b25185$export$92b7d5e5faa461a9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_10ib6lf": (0, $9t7rW.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _1e0c1txw",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $97d809cb75b25185$export$e6e0cf36ad720e4e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _1e0c1txw _vchhusvi _lcxvglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cgQqU", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("84ijd")),
            load('1gISr')
        ]);
        const value = parcelRequire('9VRnx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("84ijd")),
        load("1gISr")
    ]).then(()=>parcelRequire('9VRnx'));
}

});


parcelRegister("9FDwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1587c654124b8a29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ltfxy = parcelRequire("ltfxy");

var $RZgA1 = parcelRequire("RZgA1");

var $41WOo = parcelRequire("41WOo");

var $8rPxE = parcelRequire("8rPxE");
var $d9gm1 = parcelRequire("d9gm1");

var $bSsl1 = parcelRequire("bSsl1");
var $iSNkS = parcelRequire("iSNkS");
var $eCCst = parcelRequire("eCCst");

var $cRKsH = parcelRequire("cRKsH");

var $3W38d = parcelRequire("3W38d");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $jK1pm = parcelRequire("jK1pm");

var $ib4WI = parcelRequire("ib4WI");

var $2b5eO = parcelRequire("2b5eO");

var $iq40z = parcelRequire("iq40z");

var $lqN6D = parcelRequire("lqN6D");

var $dZHFc = parcelRequire("dZHFc");

var $jhiWm = parcelRequire("jhiWm");

var $aY8Rm = parcelRequire("aY8Rm");

var $72Gha = parcelRequire("72Gha");
const $1587c654124b8a29$var$MORE_MENU_MIN_WIDTH = 260;
const $1587c654124b8a29$var$WORKFLOWS_MENU_WIDTH = 320;
const $1587c654124b8a29$var$HIDDEN_QUICKFILTERS = [
    'DONE',
    'ACTIVE_SPRINTS'
];
const $1587c654124b8a29$var$Header = ()=>{
    const { isShareButtonEnabled: isShareButtonEnabled, inviteButtonInteraction: inviteButtonInteraction, isPresenceEnabled: isPresenceEnabled } = (0, $2b5eO.useJWMBoardFeatures)();
    const [{ nudgeStep: nudgeStep, shouldOpenModal: shouldOpenModal }, { setShouldOpenModal: setShouldOpenModal }] = (0, $3W38d.useNudgeStep)();
    let issues;
    let hasMultipleWorkflows;
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { workflows: workflows } = (0, $iq40z.useWorkflowStoreState)();
        hasMultipleWorkflows = workflows.length > 1;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        [{ issues: issues }] = (0, $lqN6D.useBoardStore)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        hasMultipleWorkflows = (0, $lqN6D.useHasMultipleWorkflows)();
    }
    const allowedFieldTypes = (0, $eUqFw.useMemo)(()=>new Set([
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.ISSUE_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            ...(0, $ib4WI.getSupportedExtendedFilterTypes)(),
            (0, $lO4Or.STATUS_TYPE)
        ]), []);
    const moreMenuContent = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'closeMenu' implicitly has an 'any' type.
    (closeMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72Gha.MoreMenuContent), {
            useCloseMenu: closeMenu ?? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }), []);
    const handleDialogClose = (0, $eUqFw.useCallback)(()=>{
        if (shouldOpenModal) setShouldOpenModal(false);
    }, [
        setShouldOpenModal,
        shouldOpenModal
    ]);
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $aY8Rm.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).BOARD,
        shareContentType: "board",
        isAutoOpenDialog: shouldOpenModal,
        onDialogClose: handleDialogClose
    });
    const showSpotlight = (0, $eUqFw.useMemo)(()=>nudgeStep === (0, $88b44984a9895844$export$61e173eed328e650), [
        nudgeStep
    ]);
    const wrappedShareButton = showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $88b44984a9895844$export$61e173eed328e650)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, shareButton)) : shareButton;
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $aY8Rm.default).searchBoardLabel,
        view: "board"
    });
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSsl1.default), {
        view: "board",
        allowedFieldTypes: allowedFieldTypes,
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab'
    });
    const shareActionButton = isShareButtonEnabled && wrappedShareButton;
    const hasIssues = issues != null && issues.length > 0;
    const moreMenu = (0, $41WOo.isOnboardingForLinkedIssuesEnabledInJwmBoard)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhiWm.IssueLinksNudgeSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: moreMenuContent,
        minWidth: hasMultipleWorkflows ? $1587c654124b8a29$var$WORKFLOWS_MENU_WIDTH : $1587c654124b8a29$var$MORE_MENU_MIN_WIDTH
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: moreMenuContent,
        minWidth: hasMultipleWorkflows ? $1587c654124b8a29$var$WORKFLOWS_MENU_WIDTH : $1587c654124b8a29$var$MORE_MENU_MIN_WIDTH
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-board-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.LeftActionsWrapper), null, searchBar, addPeopleWithPresence), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.RightActionsWrapper), null, shareActionButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rPxE.Filters), {
        view: "board",
        allowedFieldTypes: allowedFieldTypes,
        hiddenQuickFilters: $1587c654124b8a29$var$HIDDEN_QUICKFILTERS,
        allowCustomFields: true
    }), ((0, $1ybV0.ff)('jwm.board-awesome-enhancements') || hasIssues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZHFc.default), null), moreMenu)));
};
var $1587c654124b8a29$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1587c654124b8a29$var$Header);

});
parcelRegister("RZgA1", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2a4eb501d360abec$export$c8223871eecc8f3a);
$parcel$export(module.exports, "LeftActionsWrapper", () => $2a4eb501d360abec$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $2a4eb501d360abec$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hSCS8 = parcelRequire("hSCS8");
const $2a4eb501d360abec$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $hSCS8.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a4eb501d360abec$var$ActionsWrapperStyled, {
        sidebarOpen: !!content,
        "data-testid": testId
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4eb501d360abec$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$var$ActionsWrapperStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10qff79": (0, $9t7rW.default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1ylp _18s8l1uc _1yt46hdp _1n261g80 _bfhk1ml8 _18k9kjed",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$4aa2cd250ec24dcc = $2a4eb501d360abec$var$CenterAlignedWrapper;

});

parcelRegister("8rPxE", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $4a948cec7cd2ee06$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $jpXBE = parcelRequire("jpXBE");

var $fvzkg = parcelRequire("fvzkg");

var $jWIW7 = parcelRequire("jWIW7");

var $9GlEj = parcelRequire("9GlEj");

var $27zPy = parcelRequire("27zPy");

var $6M6Pf = parcelRequire("6M6Pf");
const $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $4a948cec7cd2ee06$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $jWIW7.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const close = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $9GlEj.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $fvzkg.useDeserialiseJqlFilters)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    if ((0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jpXBE.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27zPy.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M6Pf.Trigger), {
                ...triggerProps,
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle
            }),
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }), customFieldsLoader));
});

});
parcelRegister("jpXBE", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $bf0eb06c2610c94c$export$c9b2aef46b42c898);

var $eUqFw = parcelRequire("eUqFw");

var $hLW3I = parcelRequire("hLW3I");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $bf0eb06c2610c94c$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: filterFields } = (0, $hLW3I.useFilterFields)();
    const goalField = (0, $eUqFw.useMemo)(()=>filterFields.find((field)=>field.type === (0, $lO4Or.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});

parcelRegister("27zPy", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d758afbde8c38bbf$export$479f0f2f71193efe);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $cqv89 = parcelRequire("cqv89");

var $hEiVl = parcelRequire("hEiVl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d758afbde8c38bbf$var$LazyMenuContent = (0, $7rh0R.lazy)(()=>(parcelRequire("gk2kI")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $d758afbde8c38bbf$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEiVl.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqv89.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d758afbde8c38bbf$var$LazyMenuContent, props)));

});
parcelRegister("cqv89", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $d72c10a0e4505968$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $d72c10a0e4505968$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d72c10a0e4505968$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d72c10a0e4505968$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hEiVl", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5348b95debef5641$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5348b95debef5641$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5348b95debef5641$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5348b95debef5641$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5348b95debef5641$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5348b95debef5641$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5348b95debef5641$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5348b95debef5641$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5348b95debef5641$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9TEHc = parcelRequire("9TEHc");
const $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5348b95debef5641$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5348b95debef5641$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $9TEHc.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $9TEHc.POPUP_OFFSET_TOP)) + $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
            __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8 _18s81alc",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5348b95debef5641$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdidpf _zulpidpf",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gk2kI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8LeNQ')
        ]);
        const value = parcelRequire('fTzDz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8LeNQ")
    ]).then(()=>parcelRequire('fTzDz'));
}

});


parcelRegister("6M6Pf", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $70b788e25198d514$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4ki2H = parcelRequire("4ki2H");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lwKJI = parcelRequire("lwKJI");
const $70b788e25198d514$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
    label: "",
    size: "small"
});
const $70b788e25198d514$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterMessage = (0, $eUqFw.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const TriggerButton = withThemedButton ? (0, $lGiWG.ThemedButton) : (0, $7u4fN.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $70b788e25198d514$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessage));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70b788e25198d514$var$ButtonContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulp1b66 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwKJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $142e1a2d3eb527a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $142e1a2d3eb527a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("d9gm1", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $2ba7b21880f0a587$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $2ba7b21880f0a587$export$44e8ccf3428dc1d5);

var $dnJL9 = parcelRequire("dnJL9");

var $leRrM = parcelRequire("leRrM");

var $8Duvw = parcelRequire("8Duvw");
const $2ba7b21880f0a587$export$63f96dda4bd4f7dc = (0, $dnJL9.componentWithFG)('jwm_update_simple_search_field', (0, $leRrM.SimpleSearchTextField), (0, $8Duvw.SimpleSearchStatelessField));
const $2ba7b21880f0a587$export$44e8ccf3428dc1d5 = (0, $dnJL9.componentWithFG)('jwm_update_simple_search_field', (0, $leRrM.SimpleSearchField), (0, $8Duvw.SimpleSearchField));
var $2ba7b21880f0a587$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('jwm_update_simple_search_field', (0, $leRrM.SimpleSearchField), (0, $8Duvw.SimpleSearchField));

});
parcelRegister("leRrM", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $5e8b1b065615d445$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $5e8b1b065615d445$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6zOB7 = parcelRequire("6zOB7");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kar7l = parcelRequire("kar7l");

var $c1K7Q = parcelRequire("c1K7Q");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");

var $liWiN = parcelRequire("liWiN");
const $5e8b1b065615d445$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId, isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $eUqFw.useState)(externalValue);
    const handleSearchChange = (0, $eUqFw.useCallback)((newValue)=>{
        let eventAttributes = {};
        if ((0, $1ybV0.ff)('jwm-attachments-m2')) eventAttributes = (0, $9JEYY.getTextFieldAttributes)(newValue);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...eventAttributes
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $2jdHI.default)(handleSearchChange, 500);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $eUqFw.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    const Container = themedField ? $5e8b1b065615d445$var$ThemedContainer : (0, $eUqFw.Fragment);
    (0, $eUqFw.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ref: inputRef,
        ...(0, $c1K7Q.generateDataTestId)('searchfield'),
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? // We used Button with no children instead of IconButton because
        // of different sizing between an icon alone and IconButton
        // Using Button allows us to access to spacing="none" to mimic the
        // same spacing to the icon alone
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    ...iconProps,
                    size: "small",
                    primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "none",
            "aria-label": formatMessage((0, $liWiN.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: "",
            size: "small",
            primaryColor: themedField ? themedIconPrimaryColor : undefined
        }),
        className: (0, $7JEyt.default)([
            "_dzcou2gc"
        ])
    }));
});
const $5e8b1b065615d445$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e8b1b065615d445$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e8b1b065615d445$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: setSimpleSearch,
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $5e8b1b065615d445$var$textFieldStyles = null; /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e8b1b065615d445$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $5e8b1b065615d445$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c1K7Q", function(module, exports) {

$parcel$export(module.exports, "generateDataTestId", () => $9d0a034fe3d4cf2e$export$7de5661ad251801);

var $1ybV0 = parcelRequire("1ybV0");
const $9d0a034fe3d4cf2e$var$DISABLED = 'disabled';
const $9d0a034fe3d4cf2e$var$DUPLICATED = 'duplicated';
const $9d0a034fe3d4cf2e$var$REPLACED = 'replaced';
const $9d0a034fe3d4cf2e$var$DEFAULT_FF = 'replace-data-test-id-with-data-testid-in-bento-m2';
const $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue = (featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $1ybV0.getMultivariateFeatureFlag)(featureFlag, $9d0a034fe3d4cf2e$var$DISABLED, [
        $9d0a034fe3d4cf2e$var$DISABLED,
        $9d0a034fe3d4cf2e$var$DUPLICATED,
        $9d0a034fe3d4cf2e$var$REPLACED
    ]);
const $9d0a034fe3d4cf2e$export$7de5661ad251801 = (testId, featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>{
    const flagValue = $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue(featureFlag);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let testIdProps = {};
    switch(flagValue){
        case 'duplicated':
            testIdProps = {
                'data-test-id': testId,
                'data-testid': testId
            };
            break;
        case 'replaced':
            testIdProps = {
                'data-testid': testId
            };
            break;
        case 'disabled':
        default:
            testIdProps = {
                'data-test-id': testId
            };
            break;
    }
    return testIdProps;
};

});

parcelRegister("9JEYY", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $98a728a18d600acd$export$dfd7972bcd113afb);
const $98a728a18d600acd$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("liWiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2bf85fdbadbe9d8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2bf85fdbadbe9d8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("8Duvw", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchStatelessField", () => $8f736d6f899ffae9$export$7c3ff4c90e7ed9dc);
$parcel$export(module.exports, "SimpleSearchField", () => $8f736d6f899ffae9$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cNGJr = parcelRequire("cNGJr");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kar7l = parcelRequire("kar7l");

var $bKxX9 = parcelRequire("bKxX9");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8Ui86 = parcelRequire("8Ui86");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");
const $8f736d6f899ffae9$export$7c3ff4c90e7ed9dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ autoFocus: autoFocus = false, inputRef: inputRef, placeholder: placeholder, initialValue: initialValue, onChange: onChange, onFocus: onFocus, themedField: themedField = true, shouldFitContainerWidth: shouldFitContainerWidth = false, view: view, isDisabled: isDisabled, testId: testId, label: label, describedbyId: describedbyId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Clean up with fg jwm-a11y-audit-fixes
    const handleChange = (0, $eUqFw.useCallback)((newValue)=>{
        let eventAttributes = {};
        if ((0, $bKxX9.ff)('jwm-attachments-m2')) eventAttributes = (0, $9JEYY.getTextFieldAttributes)(newValue);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...eventAttributes
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [setOnSearchChangeDebounce] = (0, $cNGJr.default)(handleChange, 500);
    const renderCustomSearchField = (0, $eUqFw.useCallback)(({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>{
        const textField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: testId,
            ...textFieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f736d6f899ffae9$export$b547fcf8bdffeeaa, null, searchIcon)
        });
        return themedField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f736d6f899ffae9$export$2a4209ec8a7db359, null, textField) : textField;
    }, [
        testId,
        themedField
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField // @ts-expect-error Type 'Ref<HTMLElement | null> | undefined' is not assignable to type '{ current: HTMLInputElement | null; } | undefined'. Type 'null' is not assignable to type '{ current: HTMLInputElement | null; } | undefined'
    ), {
        inputRef: inputRef,
        autoFocus: autoFocus,
        isCompact: true,
        shouldFitContainerWidth: shouldFitContainerWidth,
        isAlwaysExpanded: true,
        isAutocompleteDisabled: true,
        value: initialValue,
        placeholder: formatMessage(placeholder),
        placeholderAlwaysVisible: true,
        onFocus: onFocus,
        describedById: describedbyId,
        onChange: setOnSearchChangeDebounce,
        renderCustomSearchField: renderCustomSearchField,
        searchIconPrimaryColor: themedField ? themedIconPrimaryColor : undefined,
        isDisabled: isDisabled,
        ...(0, $eI5EY.fg)('jwm_header_filters_a11y_fixes') ? {
            ariaLabelText: label
        } : {}
    });
});
const $8f736d6f899ffae9$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f736d6f899ffae9$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f736d6f899ffae9$export$7c3ff4c90e7ed9dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: setSimpleSearch,
        initialValue: simpleSearch,
        placeholder: placeholder
    }));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f736d6f899ffae9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8f736d6f899ffae9$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8f736d6f899ffae9$export$b547fcf8bdffeeaa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _2hwxv77o",
            __cmplp.className
        ])
    });
});
var $8f736d6f899ffae9$export$2e2bcd8739ae039 = $8f736d6f899ffae9$export$44e8ccf3428dc1d5;

});
parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $babBw = parcelRequire("babBw");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder,
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemAfterInput: searchIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        size: "small",
        label: "",
        primaryColor: primaryColor
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "small",
            label: clearIconLabel,
            primaryColor: primaryColor
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});

});




parcelRegister("bSsl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2ff9f75b0cc835$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $3f7Cz = parcelRequire("3f7Cz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cAOjv")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $cf2ff9f75b0cc835$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf2ff9f75b0cc835$var$AvatarFallback = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $cf2ff9f75b0cc835$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cf2ff9f75b0cc835$var$AddPeopleWithAvatar);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if ((0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj')) {
            if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
            else showFlag((0, $bLjrh.inviteFailFlagConfig));
        } else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || (0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj') && isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kQAZu = parcelRequire("kQAZu");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $7rh0R.lazy)(()=>(parcelRequire("5zF4d")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        if ((0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj')) {
            const userInviteErrorsWithCode = {};
            const oldUserInviteError = [];
            errors.forEach((error)=>{
                // After we cleanup user-invite-include-status-code-on-error_isxoj we shouldn't need
                // this string check as the type will always be UserInviteError
                if (typeof error === 'string') oldUserInviteError.push(error);
                else {
                    // Group all errors by known user invite error codes
                    const errorCode = extractErrorCode(error.message);
                    if (errorCode) {
                        if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                        userInviteErrorsWithCode[errorCode].push(error);
                    }
                }
            });
            // Join messages with the same error code
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
            return;
        }
        const errorMessage = errors?.join(', ') ?? '';
        onInviteError({
            modalType: 'Project',
            errorMessage: errorMessage
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: ""
    })));
});

});
parcelRegister("5zF4d", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6HI0g')
        ]);
        const value = parcelRequire('4urEy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6HI0g")
    ]).then(()=>parcelRequire('4urEy'));
}

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $c7H0g = parcelRequire("c7H0g");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $7rh0R.lazy)(()=>(parcelRequire("9Bx8m")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1iV50")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("1iV50", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('e1vXm')
        ]);
        const value = parcelRequire('bagiu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("e1vXm")
    ]).then(()=>parcelRequire('bagiu'));
}

});


parcelRegister("9Bx8m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('evBHV')
        ]);
        const value = parcelRequire('6SUBw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("evBHV")
    ]).then(()=>parcelRequire('6SUBw'));
}

});




parcelRegister("cAOjv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('j6IJU')
        ]);
        const value = parcelRequire('dNnOv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("j6IJU")
    ]).then(()=>parcelRequire('dNnOv'));
}

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $dFWNP = parcelRequire("dFWNP");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");

var $iSNkS = parcelRequire("iSNkS");
const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        if ((0, $1ybV0.ff)('jwm-a11y-round2_guwbb')) shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");

const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9XSbA")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("9XSbA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('dsiAd'),
            load('h2MrD'),
            load('bYT2S'),
            load('2xQrm')
        ]);
        const value = parcelRequire('iHQJU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("dsiAd"),
        load("h2MrD"),
        load("bYT2S"),
        load("2xQrm")
    ]).then(()=>parcelRequire('iHQJU'));
}

});


parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $8q0kG = parcelRequire("8q0kG");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");
var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation') && (0, $dfBCt.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

var $ljgr5 = parcelRequire("ljgr5");
const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("971uQ")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("971uQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('dPtit')
        ]);
        const value = parcelRequire('dZKRj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("dPtit")
    ]).then(()=>parcelRequire('dZKRj'));
}

});



parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});



parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hB1df")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
parcelRegister("hB1df", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('afZr6');
        const value = parcelRequire('16oN0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("afZr6").then(()=>parcelRequire('16oN0'));
}

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("cRKsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab88bbf4e192a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");


var $fG0qd = parcelRequire("fG0qd");
const $b0ab88bbf4e192a9$var$MoreMenuCore = /*#__PURE__*/ (0, $eUqFw.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f81b038ef83e0f85$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(forceVisibility);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0ab88bbf4e192a9$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG0qd.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }));
});
var $b0ab88bbf4e192a9$export$2e2bcd8739ae039 = $b0ab88bbf4e192a9$var$MoreMenuCore;
const $b0ab88bbf4e192a9$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f81b038ef83e0f85$export$8c68b096b2d5e9f6 = 320;

parcelRegister("fG0qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4453e9a08a331d11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG1wZ = parcelRequire("jG1wZ");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1mhY = parcelRequire("k1mhY");
const $4453e9a08a331d11$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
    label: "",
    size: "small"
});
const $4453e9a08a331d11$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $4453e9a08a331d11$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel)
    }, formatMessage((0, $k1mhY.default).moreButton));
});
var $4453e9a08a331d11$export$2e2bcd8739ae039 = $4453e9a08a331d11$var$Trigger;

});
parcelRegister("k1mhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $255e4847f5c60031$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255e4847f5c60031$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More options"
    }
});

});



const $88b44984a9895844$export$61e173eed328e650 = 'BOARD_EMBED_NUDGE_STEP';

parcelRegister("3W38d", function(module, exports) {

$parcel$export(module.exports, "useNudgeStep", () => $8f55f64483c665ec$export$c5e63e44ad178ae8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $8f55f64483c665ec$var$actions = {
    setNudgeStep: (nudgeStep)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                nudgeStep: nudgeStep
            }),
    setShouldOpenModal: (shouldOpenModal)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                shouldOpenModal: shouldOpenModal
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<...>) => void; }>>'.
const $8f55f64483c665ec$var$Store = (0, $a61MH.createStore)({
    initialState: {
        nudgeStep: (0, $88b44984a9895844$export$61e173eed328e650),
        shouldOpenModal: false
    },
    actions: $8f55f64483c665ec$var$actions,
    name: 'JWMBoardEmbedNudgeStepStore'
});
const $8f55f64483c665ec$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($8f55f64483c665ec$var$Store);

});

parcelRegister("dZHFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $63836c322a52d07c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $9nt1B = parcelRequire("9nt1B");

var $b8123 = parcelRequire("b8123");

var $bULPy = parcelRequire("bULPy");
var $5wpwq = parcelRequire("5wpwq");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $3nkD4 = parcelRequire("3nkD4");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");

var $kBh2b = parcelRequire("kBh2b");

var $lGiWG = parcelRequire("lGiWG");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iXHUp = parcelRequire("iXHUp");

var $lqN6D = parcelRequire("lqN6D");

var $fZC2L = parcelRequire("fZC2L");
const $63836c322a52d07c$var$BoardGroupSelector = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [groupBy, setGroupBy] = (0, $iXHUp.useGroupBy)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const categoryFieldId = categoryField?.id;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    let groupByOptions;
    if ((0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // eslint-disable-next-line react-hooks/rules-of-hooks
    groupByOptions = (0, $iXHUp.useGroupByOptions)();
    else {
        groupByOptions = new Set([
            (0, $jGcn0.GROUP_BY_STATUS)
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isGroupByAssigneeAllowed] = (0, $lqN6D.useIsGroupByFieldAllowed)({
            fieldKey: 'assignee'
        }); // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isGroupByCategoryAllowed] = (0, $lqN6D.useIsGroupByFieldAllowed)({
            fieldType: (0, $lO4Or.CATEGORY_TYPE)
        }); // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isGroupByPriorityAllowed] = (0, $lqN6D.useIsGroupByFieldAllowed)({
            fieldKey: 'priority'
        });
        if (isGroupByAssigneeAllowed) groupByOptions.add((0, $jGcn0.GROUP_BY_ASSIGNEE));
        if (isGroupByCategoryAllowed) groupByOptions.add((0, $jGcn0.GROUP_BY_CATEGORY));
        if (isGroupByPriorityAllowed) groupByOptions.add((0, $jGcn0.GROUP_BY_PRIORITY));
    }
    const fireGroupChangedTracking = (0, $eUqFw.useCallback)((newGroupBy)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupBy', {
            value: newGroupBy
        }), [
        createAnalyticsEvent
    ]);
    const fireGroupMenuOpenedTracking = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmBoardGrouping menuOpened');
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    let groupByLabel;
    let hasDefaultGroupApplied = false;
    if (groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && groupByOptions.has((0, $jGcn0.GROUP_BY_PRIORITY))) groupByLabel = formatMessage((0, $fZC2L.default).groupByPriorityLabel);
    else if (groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && groupByOptions.has((0, $jGcn0.GROUP_BY_ASSIGNEE))) groupByLabel = formatMessage((0, $fZC2L.default).groupByAssigneeLabel);
    else if (groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && groupByOptions.has((0, $jGcn0.GROUP_BY_CATEGORY))) groupByLabel = formatMessage((0, $fZC2L.default).groupByCategoryLabel);
    else {
        hasDefaultGroupApplied = true;
        groupByLabel = formatMessage((0, $fZC2L.default).groupByStatusLabel);
    }
    const groupByStatus = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_STATUS));
        setGroupBy((0, $jGcn0.GROUP_BY_STATUS));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByPriority = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_PRIORITY));
        setGroupBy((0, $jGcn0.GROUP_BY_PRIORITY));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByAssignee = (0, $eUqFw.useCallback)(()=>{
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_ASSIGNEE));
        setGroupBy((0, $jGcn0.GROUP_BY_ASSIGNEE));
        setIsOpen(false);
    }, [
        fireGroupChangedTracking,
        setGroupBy
    ]);
    const groupByCategory = (0, $eUqFw.useCallback)(()=>{
        if (!categoryFieldId) return;
        fireGroupChangedTracking((0, $jGcn0.GROUP_BY_CATEGORY));
        setGroupBy(categoryFieldId);
        setIsOpen(false);
    }, [
        categoryFieldId,
        fireGroupChangedTracking,
        setGroupBy
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const checkIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            size: "medium",
            label: formatMessage((0, $fZC2L.default).groupBySelected),
            primaryColor: `var(--ds-icon-selected, ${(0, $PdmhA.B400)})`
        });
        const HeadingAndClearButtonInContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            justifyContent: "space-between",
            alignItems: "baseline",
            xcss: $63836c322a52d07c$var$headingContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63836c322a52d07c$var$Heading, null, formatMessage((0, $fZC2L.default).groupBySectionTitle)), !hasDefaultGroupApplied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "work-management-board.ui.header.group-selector.clear-button",
            appearance: "subtle-link",
            spacing: "none",
            onClick: groupByStatus,
            "aria-label": formatMessage((0, $fZC2L.default).clearGroupLabel)
        }, formatMessage((0, $fZC2L.default).clearGroup)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, HeadingAndClearButtonInContainer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                    onClick: groupByStatus,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nkD4.StatusIcon), null),
                    iconAfter: hasDefaultGroupApplied && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.status-button"
                }, formatMessage((0, $fZC2L.default).groupByStatusDefaultLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_PRIORITY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                    onClick: groupByPriority,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nkD4.PriorityIcon), null),
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_PRIORITY) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.priority-button"
                }, formatMessage((0, $fZC2L.default).groupByPriorityLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_ASSIGNEE)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                    onClick: groupByAssignee,
                    iconBefore: (0, $kBh2b.getFieldIcons)('medium')[0, $lO4Or.ASSIGNEE_TYPE],
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_ASSIGNEE) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.assignee-button"
                }, formatMessage((0, $fZC2L.default).groupByAssigneeLabel)), groupByOptions.has((0, $jGcn0.GROUP_BY_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                    onClick: groupByCategory,
                    iconBefore: (0, $kBh2b.getFieldIcons)('medium')[0, $lO4Or.CATEGORY_TYPE],
                    iconAfter: groupBy === (0, $jGcn0.GROUP_BY_CATEGORY) && checkIcon,
                    testId: "work-management-board.ui.header.group-selector.category-button"
                }, formatMessage((0, $fZC2L.default).groupByCategoryLabel)))),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
                        label: "",
                        size: "small"
                    }),
                    isSelected: isOpen,
                    onClick: ()=>{
                        setIsOpen((wasOpen)=>!wasOpen);
                        fireGroupMenuOpenedTracking();
                    },
                    appearance: "subtle",
                    testId: "work-management-board.ui.header.group-selector"
                }, formatMessage((0, $fZC2L.default).groupByButtonLabel), groupByLabel),
            shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
            strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
        });
    }, [
        formatMessage,
        hasDefaultGroupApplied,
        groupByStatus,
        isOpen,
        groupByOptions,
        groupByPriority,
        groupBy,
        groupByAssignee,
        groupByCategory,
        groupByLabel,
        fireGroupMenuOpenedTracking
    ]);
};
var $63836c322a52d07c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $63836c322a52d07c$var$BoardGroupSelector;
const $63836c322a52d07c$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5wpwq.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $63836c322a52d07c$var$headingContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`
});

});
parcelRegister("3nkD4", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $2dfc1f6aacfa545f$export$3abf8cb3bcb0225);
$parcel$export(module.exports, "StatusIcon", () => $2dfc1f6aacfa545f$export$b131c49b26d3f427);
$parcel$export(module.exports, "NumberGlyph", () => $2dfc1f6aacfa545f$export$c0f9c6a1407deaef);

var $eUqFw = parcelRequire("eUqFw");
const $2dfc1f6aacfa545f$export$3abf8cb3bcb0225 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$b131c49b26d3f427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$c0f9c6a1407deaef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2dfc1f6aacfa545f$export$ad8f8fc3bcd61b4a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$3dc0fe769dc7dcac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $2dfc1f6aacfa545f$export$4974ca23eb8b9b46 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));

});

parcelRegister("kBh2b", function(module, exports) {

$parcel$export(module.exports, "getFieldIcons", () => $e54f455c6b41e11e$export$df250ca2240f6516);

var $jqvCZ = parcelRequire("jqvCZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $bsrAN = parcelRequire("bsrAN");

var $6g0DE = parcelRequire("6g0DE");

var $975Me = parcelRequire("975Me");

var $4QCVn = parcelRequire("4QCVn");

var $fCSoc = parcelRequire("fCSoc");

var $7nIOX = parcelRequire("7nIOX");

var $is7XO = parcelRequire("is7XO");

var $851U9 = parcelRequire("851U9");

var $cLwpi = parcelRequire("cLwpi");

var $6wPXB = parcelRequire("6wPXB");

var $46tzp = parcelRequire("46tzp");

var $4wZzs = parcelRequire("4wZzs");
const $e54f455c6b41e11e$export$df250ca2240f6516 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((size)=>{
    const legacyFieldIcons = (0, $4wZzs.getLegacyFieldIcons)({
        size: size
    });
    return {
        ...legacyFieldIcons,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            ...(0, $46tzp.getVersionIcons)(size),
            ...(0, $fCSoc.getParentIcon)(size),
            ...(0, $6g0DE.getDevSummaryIcons)(size),
            ...(0, $6wPXB.getTeamIcons)(size),
            ...(0, $975Me.getGoalsIcons)(size)
        } : {},
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $851U9.getResolutionIcons)(size),
            ...(0, $4QCVn.getGroupIcons)(size),
            ...(0, $cLwpi.getStatusCategoryIcons)(size),
            ...(0, $is7XO.getRadioSelectIcon)(size),
            ...(0, $7nIOX.getProjectIcons)(size),
            ...(0, $bsrAN.getCascadingSelectIcons)(size)
        } : {}
    };
});

});
parcelRegister("bsrAN", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectIcons", () => $4ec1409121357127$export$a1c73b689cfdba0d);

var $eUqFw = parcelRequire("eUqFw");

var $7Mesx = parcelRequire("7Mesx");

var $lO4Or = parcelRequire("lO4Or");
const $4ec1409121357127$export$a1c73b689cfdba0d = (size)=>({
        [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mesx))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("7Mesx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a983b68a1ef33a3$var$_react = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5a983b68a1ef33a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5a983b68a1ef33a3$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $5a983b68a1ef33a3$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5a983b68a1ef33a3$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $5a983b68a1ef33a3$var$_default = $5a983b68a1ef33a3$var$EditorBulletListIcon;
module.exports.default = $5a983b68a1ef33a3$var$_default;

});


parcelRegister("6g0DE", function(module, exports) {

$parcel$export(module.exports, "getDevSummaryIcons", () => $c249a2a5b82bb4bc$export$af7756d867a4596f);

var $eUqFw = parcelRequire("eUqFw");

var $gojax = parcelRequire("gojax");

var $lO4Or = parcelRequire("lO4Or");
const $c249a2a5b82bb4bc$export$af7756d867a4596f = (size)=>({
        [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gojax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beedc1cceb482b08$var$_react = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $beedc1cceb482b08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $beedc1cceb482b08$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $beedc1cceb482b08$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$beedc1cceb482b08$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $beedc1cceb482b08$var$_default = $beedc1cceb482b08$var$BitbucketBranchesIcon;
module.exports.default = $beedc1cceb482b08$var$_default;

});


parcelRegister("975Me", function(module, exports) {

$parcel$export(module.exports, "getGoalsIcons", () => $860af03e515ae7da$export$191c71adb6287036);

var $eUqFw = parcelRequire("eUqFw");

var $iY7zv = parcelRequire("iY7zv");

var $lO4Or = parcelRequire("lO4Or");
const $860af03e515ae7da$export$191c71adb6287036 = ()=>({
        [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
            label: "",
            spacing: "spacious"
        })
    });

});
parcelRegister("iY7zv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcf3b42887852980$var$_react = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dcf3b42887852980$var$_UNSAFE_baseNew = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $dcf3b42887852980$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Goal".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcf3b42887852980$var$GoalIcon = (props)=>/*#__PURE__*/ $dcf3b42887852980$var$_react.default.createElement($dcf3b42887852980$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentColor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
    }, props));
$dcf3b42887852980$var$GoalIcon.displayName = 'GoalIcon';
var $dcf3b42887852980$var$_default = module.exports.default = $dcf3b42887852980$var$GoalIcon;

});
parcelRegister("gCIXy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("bxHQy")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bxHQy")).Icon);

var $bxHQy = parcelRequire("bxHQy");

});
parcelRegister("bxHQy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $68e08bf1bc6fdccc$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $68e08bf1bc6fdccc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");
function $68e08bf1bc6fdccc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68e08bf1bc6fdccc$var$commonSVGStyles = {
    name: "10ihzwq",
    styles: "overflow:hidden;pointer-events:none;stop{stop-color:currentColor;}"
};
const $68e08bf1bc6fdccc$var$svgStyles = {
    name: "x6fk93",
    styles: "color:currentColor;vertical-align:bottom"
};
const $68e08bf1bc6fdccc$var$iconStyles = {
    name: "mrp99y",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0;line-height:1;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0)"
};
const $68e08bf1bc6fdccc$var$utilityIconStyles = {
    name: "1j4yvsm",
    styles: "line-height:var(--ds-space-150, 12px)"
};
const $68e08bf1bc6fdccc$var$scaleStyles = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
/**
 * For windows high contrast mode
 */ const $68e08bf1bc6fdccc$var$baseHcmStyles = {
    name: "9vywkz",
    styles: "@media screen and (forced-colors: active){color:CanvasText;filter:grayscale(1);}"
};
const $68e08bf1bc6fdccc$var$sizeMap = {
    scale: {
        name: "1a1gyup",
        styles: "width:inherit;height:inherit"
    },
    utility: {
        name: "1w03az9",
        styles: "width:var(--ds-space-150, 12px);height:var(--ds-space-150, 12px)"
    },
    none: {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    },
    spacious: {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    }
};
const $68e08bf1bc6fdccc$var$baseSizeMap = {
    global: 16,
    utility: 12
};
const $68e08bf1bc6fdccc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.memo)(function Icon(props) {
    const { color: color = "var(--ds-icon, #44546F)", spacing: providedSpacing = 'none', testId: testId, label: label, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, type: // Used to set icon dimensions/behaviour in codegen
    type = 'global', dangerouslySetGlyph: // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $XHGTv.getBooleanFF)('platform.design-system-team.enable-new-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $byn9U.jsx)(FallbackIcon, {
        primaryColor: color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    const spacing = type === 'utility' ? 'none' : providedSpacing;
    const baseSize = $68e08bf1bc6fdccc$var$baseSizeMap[type];
    const size = type === 'utility' ? 'utility' : shouldScale ? 'scale' : spacing;
    const viewBoxPadding = spacing === 'spacious' ? 4 : 0;
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    let iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = `
<filter id="ds-newIconOpacityFilter">
  <feFlood flood-color="var(--ds-icon-disabled)" />
  <feComposite in2="SourceGraphic" operator="in" />
</filter>
<g filter="url(#ds-newIconOpacityFilter)">
  ${dangerouslySetInnerHTML.__html}
</g>`;
        iconColor = "var(--ds-icon, #44546F)";
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $68e08bf1bc6fdccc$var$iconStyles,
            $68e08bf1bc6fdccc$var$baseHcmStyles,
            shouldScale && $68e08bf1bc6fdccc$var$scaleStyles,
            type === 'utility' && $68e08bf1bc6fdccc$var$utilityIconStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        css: [
            $68e08bf1bc6fdccc$var$commonSVGStyles,
            $68e08bf1bc6fdccc$var$svgStyles,
            $68e08bf1bc6fdccc$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $68e08bf1bc6fdccc$export$2e2bcd8739ae039 = $68e08bf1bc6fdccc$export$f04a61298a47a40f;

});




parcelRegister("4QCVn", function(module, exports) {

$parcel$export(module.exports, "getGroupIcons", () => $f5e22dbf818fedac$export$4b39ade85c5051f7);

var $eUqFw = parcelRequire("eUqFw");

var $iwsIy = parcelRequire("iwsIy");

var $lO4Or = parcelRequire("lO4Or");
const $f5e22dbf818fedac$export$4b39ade85c5051f7 = (size)=>({
        [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("fCSoc", function(module, exports) {

$parcel$export(module.exports, "getParentIcon", () => $c4211625266bf1b6$export$744c82990563f55a);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $aa7ce = parcelRequire("aa7ce");
const $c4211625266bf1b6$export$744c82990563f55a = ()=>({
        [(0, $lO4Or.PARENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa7ce.HierarchyIcon), null)
    });

});
parcelRegister("aa7ce", function(module, exports) {

$parcel$export(module.exports, "HierarchyIcon", () => $a7933f94a217c249$export$8c3a8f220bd0db42);

var $eUqFw = parcelRequire("eUqFw");
const $a7933f94a217c249$export$8c3a8f220bd0db42 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }));

});


parcelRegister("7nIOX", function(module, exports) {

$parcel$export(module.exports, "getProjectIcons", () => $288778ae0a7a6d12$export$6db5abb9a6c7aec2);

var $eUqFw = parcelRequire("eUqFw");

var $e5T2d = parcelRequire("e5T2d");

var $lO4Or = parcelRequire("lO4Or");
const $288778ae0a7a6d12$export$6db5abb9a6c7aec2 = (size)=>({
        [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("is7XO", function(module, exports) {

$parcel$export(module.exports, "getRadioSelectIcon", () => $17a174c113288beb$export$c36fadaa74abd39e);

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $lO4Or = parcelRequire("lO4Or");
const $17a174c113288beb$export$c36fadaa74abd39e = (size)=>({
        [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});


parcelRegister("851U9", function(module, exports) {

$parcel$export(module.exports, "getResolutionIcons", () => $b63068b3f418e7aa$export$e9550187a88e57a5);

var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $lO4Or = parcelRequire("lO4Or");
const $b63068b3f418e7aa$export$e9550187a88e57a5 = (size)=>({
        [(0, $lO4Or.RESOLUTION_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});


parcelRegister("cLwpi", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryIcons", () => $77e71eb554926895$export$f263f5d2ca3dcccb);

var $eUqFw = parcelRequire("eUqFw");

var $gniEB = parcelRequire("gniEB");

var $lO4Or = parcelRequire("lO4Or");
const $77e71eb554926895$export$f263f5d2ca3dcccb = (size)=>({
        [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gniEB))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gniEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bebd43992fe8e822$var$_react = $bebd43992fe8e822$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $bebd43992fe8e822$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bebd43992fe8e822$var$StatusIcon = (props)=>/*#__PURE__*/ $bebd43992fe8e822$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5zm3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98l.426 1.343zM6.02 10.423h.07l.7 2.21H5.313l.707-2.21zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.219 1.219 0 001.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636h2.53zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887v-1.434zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812h-1.05zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926 0-1.187.55-1.922 1.437-1.922.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965z" fill="currentColor"/></svg>`
    }, props));
$bebd43992fe8e822$var$StatusIcon.displayName = 'StatusIcon';
var $bebd43992fe8e822$var$_default = $bebd43992fe8e822$var$StatusIcon;
module.exports.default = $bebd43992fe8e822$var$_default;

});


parcelRegister("6wPXB", function(module, exports) {

$parcel$export(module.exports, "getTeamIcons", () => $38769f2763823b24$export$b7d8ffd86073bea);

var $eUqFw = parcelRequire("eUqFw");

var $j76Bh = parcelRequire("j76Bh");

var $lO4Or = parcelRequire("lO4Or");
const $38769f2763823b24$export$b7d8ffd86073bea = (size)=>({
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j76Bh))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("j76Bh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dea3ca78c255f4b6$var$_react = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $dea3ca78c255f4b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dea3ca78c255f4b6$var$TeamsIcon = (props)=>/*#__PURE__*/ $dea3ca78c255f4b6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props));
$dea3ca78c255f4b6$var$TeamsIcon.displayName = 'TeamsIcon';
var $dea3ca78c255f4b6$var$_default = module.exports.default = $dea3ca78c255f4b6$var$TeamsIcon;

});


parcelRegister("46tzp", function(module, exports) {

$parcel$export(module.exports, "getVersionIcons", () => $fc9004aee8bf2947$export$5c5f41529027464e);

var $eUqFw = parcelRequire("eUqFw");

var $14lY4 = parcelRequire("14lY4");

var $lO4Or = parcelRequire("lO4Or");
const $fc9004aee8bf2947$export$5c5f41529027464e = (size)=>({
        [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("4wZzs", function(module, exports) {

$parcel$export(module.exports, "getLegacyFieldIcons", () => $96cd876843d12f51$export$eddca397cc46c15);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $hSJ9G = parcelRequire("hSJ9G");

var $lBXn2 = parcelRequire("lBXn2");

var $d3vNK = parcelRequire("d3vNK");

var $cjQam = parcelRequire("cjQam");

var $awjqo = parcelRequire("awjqo");

var $3fJGp = parcelRequire("3fJGp");

var $dZhDV = parcelRequire("dZhDV");

var $7XRtk = parcelRequire("7XRtk");

var $f4oGi = parcelRequire("f4oGi");

var $6nIG2 = parcelRequire("6nIG2");

var $2OpmI = parcelRequire("2OpmI");

var $dTV7w = parcelRequire("dTV7w");

var $b8123 = parcelRequire("b8123");

var $8CfG4 = parcelRequire("8CfG4");

var $4nce6 = parcelRequire("4nce6");

var $cI9iM = parcelRequire("cI9iM");

var $k6W9R = parcelRequire("k6W9R");

var $gk7tF = parcelRequire("gk7tF");

var $eyI8O = parcelRequire("eyI8O");

var $5KT10 = parcelRequire("5KT10");

var $jGcn0 = parcelRequire("jGcn0");

var $41WOo = parcelRequire("41WOo");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");
const $96cd876843d12f51$var$PriorityIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$StatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
// Custom icon not from Atlaskit
const $96cd876843d12f51$var$NumberGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $96cd876843d12f51$var$TypeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$KeyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$EpicIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$export$eddca397cc46c15 = ({ size: size })=>({
        key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$KeyIcon, null),
        [(0, $lO4Or.ISSUE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$TypeIcon, null),
        [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$StatusIcon, null),
        [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.CREATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.UPDATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.RESOLUTION_DATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$PriorityIcon, null),
        [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.COMPONENTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjQam))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STORY_POINTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SUBTASKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.EPIC_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$EpicIcon, null),
        [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: (0, $41WOo.isLinkedIssuesEnabledInJwmBoardCards)() || (0, $1ybV0.ff)('jwm.board-awesome-enhancements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
            size: size,
            label: ""
        }) : // Need to force small as brand icons are bigger that normal icons.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            size: "small",
            appearance: "brand"
        }),
        [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.CARD_COVERS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dTV7w))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});

parcelRegister("lBXn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbbb1b7540180857$var$_react = $fbbb1b7540180857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbbb1b7540180857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbbb1b7540180857$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $fbbb1b7540180857$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="inherit"/></g></svg>`
    }, props));
$fbbb1b7540180857$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $fbbb1b7540180857$var$_default = $fbbb1b7540180857$var$ChevronDownCircleIcon;
module.exports.default = $fbbb1b7540180857$var$_default;

});

parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});

parcelRegister("cjQam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $025082fde694ac0f$var$_react = $025082fde694ac0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $025082fde694ac0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $025082fde694ac0f$var$ComponentIcon = (props)=>/*#__PURE__*/ $025082fde694ac0f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991zM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 17.991V10.01z"/><path d="M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67z"/></g></svg>`
    }, props));
$025082fde694ac0f$var$ComponentIcon.displayName = 'ComponentIcon';
var $025082fde694ac0f$var$_default = $025082fde694ac0f$var$ComponentIcon;
module.exports.default = $025082fde694ac0f$var$_default;

});

parcelRegister("awjqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a8bf5e62e78ca1b$var$_react = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7a8bf5e62e78ca1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $7a8bf5e62e78ca1b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 7h10a1 1 0 010 2H7a1 1 0 110-2zm0 4h10a1 1 0 010 2H7a1 1 0 010-2zm0 4h5a1 1 0 010 2H7a1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7a8bf5e62e78ca1b$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $7a8bf5e62e78ca1b$var$_default = $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon;
module.exports.default = $7a8bf5e62e78ca1b$var$_default;

});

parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $25e63580bbd9aab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.654 8.764a.858.858 0 01-1.213-1.213l1.214-1.214a3.717 3.717 0 015.257 0 3.714 3.714 0 01.001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 01-5.263.005.858.858 0 011.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a1.998 1.998 0 00-.001-2.831 2 2 0 00-2.83 0l-1.215 1.213zm-.808 6.472a.858.858 0 011.213 1.213l-1.214 1.214a3.717 3.717 0 01-5.257 0 3.714 3.714 0 01-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 015.263-.005.858.858 0 01-1.214 1.214 2.005 2.005 0 00-2.836.005l-.804.803L7.8 13.618a1.998 1.998 0 00.001 2.831 2 2 0 002.83 0l1.215-1.213z" fill="currentColor"/></svg>`
    }, props));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = $25e63580bbd9aab7$var$EditorLinkIcon;
module.exports.default = $25e63580bbd9aab7$var$_default;

});

parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2eea8678fc0743c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.466-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.522 7 7 7 .874 0 1.614-.09 2.26-.279a.751.751 0 00-.42-1.44c-.508.147-1.11.22-1.84.22-2.648 0-5.5-1.722-5.5-5.5 0-3.085 2.417-5.5 5.5-5.5 3.24 0 5.5 1.952 5.5 4.75 0 2.045-1.043 3-1.748 3-.008 0-.752-.11-.752-.75v-4a.75.75 0 10-1.5 0v.187c-.346-.585-1.016-.952-1.795-.952C10.102 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = $a2eea8678fc0743c$var$EditorMentionIcon;
module.exports.default = $a2eea8678fc0743c$var$_default;

});

parcelRegister("7XRtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cc785836207fa6c$var$_react = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5cc785836207fa6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5cc785836207fa6c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $5cc785836207fa6c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5cc785836207fa6c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $5cc785836207fa6c$var$_default = $5cc785836207fa6c$var$EmojiFrequentIcon;
module.exports.default = $5cc785836207fa6c$var$_default;

});

parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20c3ed57b318b9b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.433 5.428l-4.207.6A2 2 0 005.53 7.727l-.6 4.207a1 1 0 00.281.849l6.895 6.894a.999.999 0 001.414 0l5.657-5.657a1 1 0 000-1.414L12.282 5.71a.998.998 0 00-.849-.283m-.647 5.858A1.666 1.666 0 118.43 8.929a1.666 1.666 0 012.357 2.357" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = $20c3ed57b318b9b4$var$LabelIcon;
module.exports.default = $20c3ed57b318b9b4$var$_default;

});

parcelRegister("dTV7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ecb853a8de6aa7$var$_react = $a1ecb853a8de6aa7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a1ecb853a8de6aa7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon = (props)=>/*#__PURE__*/ $a1ecb853a8de6aa7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007zm-2 0A3.006 3.006 0 016.007 3h11.986A3.006 3.006 0 0121 6.007v11.986A3.006 3.006 0 0117.993 21H6.007A3.006 3.006 0 013 17.993V6.007z" fill-rule="nonzero"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.725.725 0 00-.167-.44L14.5 11.85a.238.238 0 00-.344-.006L11 15l-.821-.821a.248.248 0 00-.358 0l-2.465 2.465c-.195.195-.136.356.135.356h3.514z"/><circle cx="9" cy="9" r="2"/></g></svg>`
    }, props));
$a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var $a1ecb853a8de6aa7$var$_default = $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon;
module.exports.default = $a1ecb853a8de6aa7$var$_default;

});

parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="8" height="2" rx="1"/><rect x="8" y="12" width="4" height="2" rx="1"/><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z" fill-rule="nonzero"/></g></svg>`
    }, props));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = $645e088e86b3f594$var$PageIcon;
module.exports.default = $645e088e86b3f594$var$_default;

});

parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M17.717 17.137l-1.436-1.438a1.003 1.003 0 011.418-1.418l3.007 3.01a1.002 1.002 0 010 1.417l-3.007 3.01a1.003 1.003 0 01-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 014 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a7.982 7.982 0 01-.789 3.451l-1.438-1.44a6.11 6.11 0 00.345-2.01A6.121 6.121 0 0012 4.884a6.121 6.121 0 00-6.118 6.125 6.119 6.119 0 005.647 6.102l6.188.025zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005.003.013z" fill="currentColor"/></svg>`
    }, props));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = $be245075b7e5aee7$var$SprintIcon;
module.exports.default = $be245075b7e5aee7$var$_default;

});

parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("fZC2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9157298b7dc778$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af9157298b7dc778$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupBySectionTitle: {
        "id": "work-management-board.header.group-selector.group-by-section-title",
        "defaultMessage": "GROUP BY"
    },
    groupByButtonLabel: {
        "id": "work-management-board.header.group-selector.group-by-button-label",
        "defaultMessage": "Group by: "
    },
    groupByStatusLabel: {
        "id": "work-management-board.header.group-selector.group-by-status-label",
        "defaultMessage": "Status"
    },
    groupByStatusDefaultLabel: {
        "id": "work-management-board.header.group-selector.group-by-status-default-label",
        "defaultMessage": "Status (default)"
    },
    groupByPriorityLabel: {
        "id": "work-management-board.header.group-selector.group-by-priority-label",
        "defaultMessage": "Priority"
    },
    groupByAssigneeLabel: {
        "id": "work-management-board.header.group-selector.group-by-assignee-label",
        "defaultMessage": "Assignee"
    },
    groupByCategoryLabel: {
        "id": "work-management-board.header.group-selector.group-by-category-label",
        "defaultMessage": "Category"
    },
    groupBySelected: {
        "id": "work-management-board.header.group-selector.group-by-selected",
        "defaultMessage": "Selected"
    },
    clearGroup: {
        "id": "work-management-board.header.group-selector.clear-group",
        "defaultMessage": "Clear"
    },
    clearGroupLabel: {
        "id": "work-management-board.header.group-selector.clear-group-label",
        "defaultMessage": "Clear grouping"
    }
});

});


parcelRegister("jhiWm", function(module, exports) {

$parcel$export(module.exports, "IssueLinksNudgeSpotlight", () => $fc3c05f18b0ed6b9$export$4fe4b383c965ae1e);

var $eUqFw = parcelRequire("eUqFw");

var $aBT3I = parcelRequire("aBT3I");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $90ZS3 = parcelRequire("90ZS3");
const $fc3c05f18b0ed6b9$var$ISSUE_LINKS_MORE_MENU_NUDGE_ID = 'issueLinksMoreMenuNudgeId';
const $fc3c05f18b0ed6b9$export$4fe4b383c965ae1e = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [selectedIssue] = (0, $90ZS3.useQueryParam)('selectedIssue');
    (0, $eUqFw.useEffect)(()=>{
        if (!selectedIssue) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'spotlightContext loaded', {
            actionSubjectId: 'issueLinksOnJWMBoardMoreMenuNudge'
        });
    }, [
        createAnalyticsEvent,
        selectedIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $fc3c05f18b0ed6b9$var$ISSUE_LINKS_MORE_MENU_NUDGE_ID
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBT3I.EngagementSpotlight), {
        engagementId: $fc3c05f18b0ed6b9$var$ISSUE_LINKS_MORE_MENU_NUDGE_ID
    }));
};

});
parcelRegister("90ZS3", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $531b22dea21c6f31$export$ae316f0eeb712a36);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $kJlBc = parcelRequire("kJlBc");
const $531b22dea21c6f31$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $kJlBc.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eUqFw.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});


parcelRegister("aY8Rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $557c5b215a8b86ea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $557c5b215a8b86ea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "work-management-board.header.share-title",
        "defaultMessage": "Board"
    },
    searchBoardLabel: {
        "id": "work-management-board.header.search-board-label",
        "defaultMessage": "Search board"
    }
});

});

parcelRegister("72Gha", function(module, exports) {

$parcel$export(module.exports, "MoreMenuContent", () => $3c7a0f9a876272d0$export$293ea00cebb9b442);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $l1jnn = parcelRequire("l1jnn");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c7a0f9a876272d0$var$LazyJWMBoardMoreMenuContent = (0, $7rh0R.lazy)(()=>(parcelRequire("cy9O4")), {
    ssr: false,
    moduleId: "./src/packages/business/board/view/src/ui/header/more-menu-content/main.tsx"
});
const $3c7a0f9a876272d0$export$293ea00cebb9b442 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-board-more-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7a0f9a876272d0$var$LazyJWMBoardMoreMenuContent, props));

});
parcelRegister("l1jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91aceacdc3d4a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $3Y9u8 = parcelRequire("3Y9u8");
const $a91aceacdc3d4a91$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y9u8.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
var $a91aceacdc3d4a91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a91aceacdc3d4a91$var$MenuFallback);

});
parcelRegister("3Y9u8", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $4a1a450a9393c394$export$52b4dfd89a6b3a1b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a1a450a9393c394$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cy9O4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dTjX4')
        ]);
        const value = parcelRequire('al1KN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dTjX4")
    ]).then(()=>parcelRequire('al1KN'));
}

});




parcelRegister("lQ65S", function(module, exports) {

$parcel$export(module.exports, "transformWorkflow", () => $c8e26113839ce7f0$export$bbcfebdec0ab6a21);
const $c8e26113839ce7f0$export$bbcfebdec0ab6a21 = ({ issueTypes: issueTypes, transitions: transitions, workflowId: workflowId, workflowName: workflowName })=>({
        issueTypes: issueTypes.map(({ iconUrl: iconUrl, hierarchyLevel: hierarchyLevel, id: id, name: name })=>({
                avatarUrl: iconUrl,
                hierarchyLevel: hierarchyLevel,
                issueTypeId: id,
                name: name
            })),
        name: workflowName,
        transitions: transitions.map(({ isConditional: isConditional, isGlobal: isGlobal, isInitial: isInitial, name: name, toStatusId: toStatusId, transitionId: transitionId })=>({
                isConditional: isConditional,
                isGlobal: isGlobal,
                isInitial: isInitial,
                name: name,
                to: {
                    statusId: String(toStatusId)
                },
                transitionId: String(transitionId)
            })),
        workflowId: workflowId
    });

});




//# sourceMappingURL=async-business-board.ce29bdab.js.map
